import "./app.429ed9d7.js";


      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8607"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8607"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2NPO8", function(module, exports) {
/* global window */ 
var $kod9A = parcelRequire("kod9A");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $kod9A.default)(root);
var $20a858454bec6c82$export$2e2bcd8739ae039 = result;

});
parcelRegister("kod9A", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed80408d0ab58dd7$export$2e2bcd8739ae039);
function $ed80408d0ab58dd7$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            if (typeof Symbol.for === 'function') // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = Symbol.for('https://github.com/benlesh/symbol-observable');
            else // Symbol.for didn't exist! The best we can do at this point is a totally 
            // unique symbol. Note that the string argument here is a descriptor, not
            // an identifier. This symbol is unique.
            result = Symbol('https://github.com/benlesh/symbol-observable');
            try {
                Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = '@@observable';
    return result;
}

});



var $2M70Q = parcelRequire("2M70Q");

var $b8xcN = parcelRequire("b8xcN");

var $b8xcN = parcelRequire("b8xcN");
var $50023b8a5600e912$var$genericMessage = "Invariant Violation";
var $50023b8a5600e912$var$_a = Object.setPrototypeOf, $50023b8a5600e912$var$setPrototypeOf = $50023b8a5600e912$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $50023b8a5600e912$var$_a;
var $50023b8a5600e912$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $b8xcN.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $50023b8a5600e912$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $50023b8a5600e912$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $50023b8a5600e912$var$genericMessage;
        $50023b8a5600e912$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $50023b8a5600e912$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $50023b8a5600e912$export$cea12affaee22fe8(message);
}
var $50023b8a5600e912$var$verbosityLevels = [
    "debug",
    "log",
    "warn",
    "error",
    "silent"
];
var $50023b8a5600e912$var$verbosityLevel = $50023b8a5600e912$var$verbosityLevels.indexOf("log");
function $50023b8a5600e912$var$wrapConsoleMethod(name) {
    return function() {
        if ($50023b8a5600e912$var$verbosityLevels.indexOf(name) >= $50023b8a5600e912$var$verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function(invariant) {
    invariant.debug = $50023b8a5600e912$var$wrapConsoleMethod("debug");
    invariant.log = $50023b8a5600e912$var$wrapConsoleMethod("log");
    invariant.warn = $50023b8a5600e912$var$wrapConsoleMethod("warn");
    invariant.error = $50023b8a5600e912$var$wrapConsoleMethod("error");
})($50023b8a5600e912$export$f5708dca728d7177 || ($50023b8a5600e912$export$f5708dca728d7177 = {}));
function $50023b8a5600e912$export$a80e09f2cd325fb8(level) {
    var old = $50023b8a5600e912$var$verbosityLevels[$50023b8a5600e912$var$verbosityLevel];
    $50023b8a5600e912$var$verbosityLevel = Math.max(0, $50023b8a5600e912$var$verbosityLevels.indexOf(level));
    return old;
}
var $50023b8a5600e912$export$2e2bcd8739ae039 = $50023b8a5600e912$export$f5708dca728d7177;


var $533b640056a7d99c$export$83d89fbfd8236492 = "3.14.1";


function $9ead41c1c895fb32$export$f8b8b9ce72e9ccbf(thunk) {
    try {
        return thunk();
    } catch (_a) {}
}


var $5b81337c038bdc28$export$2e2bcd8739ae039 = (0, $9ead41c1c895fb32$export$f8b8b9ce72e9ccbf)(function() {
    return globalThis;
}) || (0, $9ead41c1c895fb32$export$f8b8b9ce72e9ccbf)(function() {
    return window;
}) || (0, $9ead41c1c895fb32$export$f8b8b9ce72e9ccbf)(function() {
    return self;
}) || (0, $9ead41c1c895fb32$export$f8b8b9ce72e9ccbf)(function() {
    return $parcel$global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
(0, $9ead41c1c895fb32$export$f8b8b9ce72e9ccbf)(function() {
    return (0, $9ead41c1c895fb32$export$f8b8b9ce72e9ccbf).constructor("return this")();
});


var $b62911f4eb3e0bb3$var$prefixCounts = new Map();
function $b62911f4eb3e0bb3$export$d0c8ec0fe1b18b70(prefix) {
    var count = $b62911f4eb3e0bb3$var$prefixCounts.get(prefix) || 1;
    $b62911f4eb3e0bb3$var$prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}


function $f890162f7853cd70$export$f341b4883239463f(value, space) {
    if (space === void 0) space = 0;
    var undefId = (0, $b62911f4eb3e0bb3$export$d0c8ec0fe1b18b70)("stringifyForDisplay");
    return JSON.stringify(value, function(key, value) {
        return value === void 0 ? undefId : value;
    }, space).split(JSON.stringify(undefId)).join("<undefined>");
}


function $c21c2000775800f2$var$wrap(fn) {
    return function(message) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (typeof message === "number") {
            var arg0 = message;
            message = $c21c2000775800f2$var$getHandledErrorMsg(arg0);
            if (!message) {
                message = $c21c2000775800f2$var$getFallbackErrorMsg(arg0, args);
                args = [];
            }
        }
        fn.apply(void 0, [
            message
        ].concat(args));
    };
}
var $c21c2000775800f2$export$f5708dca728d7177 = Object.assign(function invariant(condition, message) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (!condition) (0, $50023b8a5600e912$export$f5708dca728d7177)(condition, $c21c2000775800f2$var$getHandledErrorMsg(message, args) || $c21c2000775800f2$var$getFallbackErrorMsg(message, args));
}, {
    debug: $c21c2000775800f2$var$wrap((0, $50023b8a5600e912$export$f5708dca728d7177).debug),
    log: $c21c2000775800f2$var$wrap((0, $50023b8a5600e912$export$f5708dca728d7177).log),
    warn: $c21c2000775800f2$var$wrap((0, $50023b8a5600e912$export$f5708dca728d7177).warn),
    error: $c21c2000775800f2$var$wrap((0, $50023b8a5600e912$export$f5708dca728d7177).error)
});
/**
 * Returns an InvariantError.
 *
 * `message` can only be a string, a concatenation of strings, or a ternary statement
 * that results in a string. This will be enforced on build, where the message will
 * be replaced with a message number.
 * String substitutions with %s are supported and will also return
 * pretty-stringified objects.
 * Excess `optionalParams` will be swallowed.
 */ function $c21c2000775800f2$export$3991762405098ea(message) {
    var optionalParams = [];
    for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
    return new (0, $50023b8a5600e912$export$cea12affaee22fe8)($c21c2000775800f2$var$getHandledErrorMsg(message, optionalParams) || $c21c2000775800f2$var$getFallbackErrorMsg(message, optionalParams));
}
var $c21c2000775800f2$export$b8ca975fa04efdf3 = Symbol.for("ApolloErrorMessageHandler_" + (0, $533b640056a7d99c$export$83d89fbfd8236492));
function $c21c2000775800f2$var$stringify(arg) {
    if (typeof arg == "string") return arg;
    try {
        return (0, $f890162f7853cd70$export$f341b4883239463f)(arg, 2).slice(0, 1000);
    } catch (_a) {
        return "<non-serializable>";
    }
}
function $c21c2000775800f2$var$getHandledErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return (0, $5b81337c038bdc28$export$2e2bcd8739ae039)[$c21c2000775800f2$export$b8ca975fa04efdf3] && (0, $5b81337c038bdc28$export$2e2bcd8739ae039)[$c21c2000775800f2$export$b8ca975fa04efdf3](message, messageArgs.map($c21c2000775800f2$var$stringify));
}
function $c21c2000775800f2$var$getFallbackErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
        version: (0, $533b640056a7d99c$export$83d89fbfd8236492),
        message: message,
        args: messageArgs.map($c21c2000775800f2$var$stringify)
    })));
}




var $1a7ebbbf4f751cf9$export$404582bc18fe4d9e = globalThis.__DEV__ !== false;


var $631d82cb14744748$exports = {};
"use strict";
// We don't want bundlers to error when they encounter usage of any of these exports.
// It's up to the package author to ensure that if they access React internals,
// they do so in a safe way that won't break if React changes how they use these internals.
// (e.g. only access them in development, and only in an optional way that won't
// break if internals are not there or do not have the expected structure)
// @ts-ignore
$631d82cb14744748$exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = undefined;
// @ts-ignore
$631d82cb14744748$exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = undefined;
// @ts-ignore
$631d82cb14744748$exports.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = undefined;

// Here we actually pull in the React library and add everything
// it exports to our own `module.exports`.
// If React suddenly were to add one of the above "polyfilled" exports,
// the React version would overwrite our version, so this should be
// future-proof.
Object.assign($631d82cb14744748$exports, (parcelRequire("3OyDL")));




var $138881ab8f31fa6b$var$isReactNative = (0, $9ead41c1c895fb32$export$f8b8b9ce72e9ccbf)(function() {
    return navigator.product;
}) == "ReactNative";
var $138881ab8f31fa6b$export$772fbc04a0ad4ce9 = typeof WeakMap === "function" && !($138881ab8f31fa6b$var$isReactNative && !$parcel$global.HermesInternal);
var $138881ab8f31fa6b$export$7293b8a0b474028d = typeof WeakSet === "function";
var $138881ab8f31fa6b$export$23ba675b4b838b92 = typeof Symbol === "function" && typeof Symbol.for === "function";
var $138881ab8f31fa6b$export$c34f882e9f1c1637 = $138881ab8f31fa6b$export$23ba675b4b838b92 && Symbol.asyncIterator;
var $138881ab8f31fa6b$export$71594e8a50f746f4 = typeof (0, $9ead41c1c895fb32$export$f8b8b9ce72e9ccbf)(function() {
    return window.document.createElement;
}) === "function";
var $138881ab8f31fa6b$var$usingJSDOM = // Following advice found in this comment from @domenic (maintainer of jsdom):
// https://github.com/jsdom/jsdom/issues/1537#issuecomment-229405327
//
// Since we control the version of Jest and jsdom used when running Apollo
// Client tests, and that version is recent enought to include " jsdom/x.y.z"
// at the end of the user agent string, I believe this case is all we need to
// check. Testing for "Node.js" was recommended for backwards compatibility
// with older version of jsdom, but we don't have that problem.
(0, $9ead41c1c895fb32$export$f8b8b9ce72e9ccbf)(function() {
    return navigator.userAgent.indexOf("jsdom") >= 0;
}) || false;
var $138881ab8f31fa6b$export$4001f6cd4a62405b = ($138881ab8f31fa6b$export$71594e8a50f746f4 || $138881ab8f31fa6b$var$isReactNative) && !$138881ab8f31fa6b$var$usingJSDOM;



// To make sure Apollo Client doesn't create more than one React context
// (which can lead to problems like having an Apollo Client instance added
// in one context, then attempting to retrieve it from another different
// context), a single Apollo context is created and tracked in global state.
var $f2219d073890e939$var$contextKey = (0, $138881ab8f31fa6b$export$23ba675b4b838b92) ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function $f2219d073890e939$export$a47505d961ee3a1() {
    (0, $c21c2000775800f2$export$f5708dca728d7177)("createContext" in $631d82cb14744748$exports, 69);
    var context = $631d82cb14744748$exports.createContext[$f2219d073890e939$var$contextKey];
    if (!context) {
        Object.defineProperty($631d82cb14744748$exports.createContext, $f2219d073890e939$var$contextKey, {
            value: context = $631d82cb14744748$exports.createContext({}),
            enumerable: false,
            writable: false,
            configurable: true
        });
        context.displayName = "ApolloContext";
    }
    return context;
}
var $f2219d073890e939$export$c2ee824bcc89ca6a = function() {
    if (globalThis.__DEV__ !== false) globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(70);
    return $f2219d073890e939$export$a47505d961ee3a1();
};


var $4dd79595e79ceb2b$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0, $f2219d073890e939$export$a47505d961ee3a1)();
    var parentContext = $631d82cb14744748$exports.useContext(ApolloContext);
    var context = $631d82cb14744748$exports.useMemo(function() {
        return (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, parentContext), {
            client: client || parentContext.client
        });
    }, [
        parentContext,
        client
    ]);
    (0, $c21c2000775800f2$export$f5708dca728d7177)(context.client, 71);
    return $631d82cb14744748$exports.createElement(ApolloContext.Provider, {
        value: context
    }, children);
};



var $3OyDL = parcelRequire("3OyDL");

var $lApLI = parcelRequire("lApLI");

var $8B9Zg = parcelRequire("8B9Zg");
var $ZNHD9 = parcelRequire("ZNHD9");

var $2M70Q = parcelRequire("2M70Q");
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $8b130464b09d4cb6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10.268 21a2 2 0 0 0 3.464 0",
            key: "vwvbt9"
        }
    ],
    [
        "path",
        {
            d: "M22 8c0-2.3-.8-4.3-2-6",
            key: "5bb3ad"
        }
    ],
    [
        "path",
        {
            d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
            key: "11g9vi"
        }
    ],
    [
        "path",
        {
            d: "M4 2C2.8 3.7 2 5.7 2 8",
            key: "tap9e0"
        }
    ]
];
const $8b130464b09d4cb6$export$2e2bcd8739ae039 = (0, $djixo.default)("bell-ring", $8b130464b09d4cb6$export$3efd853dbb351e94);


var $68l1k = parcelRequire("68l1k");/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $b5346343988c4f3a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 2v2",
            key: "scm5qe"
        }
    ],
    [
        "path",
        {
            d: "M17.915 21a6 6 0 10-12 0",
            key: "13n4mv"
        }
    ],
    [
        "path",
        {
            d: "M8 2v2",
            key: "pbkmx"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "11",
            r: "4",
            key: "1gt34v"
        }
    ],
    [
        "rect",
        {
            x: "3",
            y: "3",
            width: "18",
            height: "18",
            rx: "2",
            key: "h1oib"
        }
    ]
];
const $b5346343988c4f3a$export$2e2bcd8739ae039 = (0, $djixo.default)("contact-round", $b5346343988c4f3a$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $3c721d6b8d7c1a29$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 8h.01",
            key: "1r9ogq"
        }
    ],
    [
        "path",
        {
            d: "M12 12h.01",
            key: "1mp3jc"
        }
    ],
    [
        "path",
        {
            d: "M14 8h.01",
            key: "1primd"
        }
    ],
    [
        "path",
        {
            d: "M16 12h.01",
            key: "1l6xoz"
        }
    ],
    [
        "path",
        {
            d: "M18 8h.01",
            key: "emo2bl"
        }
    ],
    [
        "path",
        {
            d: "M6 8h.01",
            key: "x9i8wu"
        }
    ],
    [
        "path",
        {
            d: "M7 16h10",
            key: "wp8him"
        }
    ],
    [
        "path",
        {
            d: "M8 12h.01",
            key: "czm47f"
        }
    ],
    [
        "rect",
        {
            width: "20",
            height: "16",
            x: "2",
            y: "4",
            rx: "2",
            key: "18n3k1"
        }
    ]
];
const $3c721d6b8d7c1a29$export$2e2bcd8739ae039 = (0, $djixo.default)("keyboard", $3c721d6b8d7c1a29$export$3efd853dbb351e94);


var $gPhVo = parcelRequire("gPhVo");/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $44e0240d7f2d6793$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m4.93 4.93 4.24 4.24",
            key: "1ymg45"
        }
    ],
    [
        "path",
        {
            d: "m14.83 9.17 4.24-4.24",
            key: "1cb5xl"
        }
    ],
    [
        "path",
        {
            d: "m14.83 14.83 4.24 4.24",
            key: "q42g0n"
        }
    ],
    [
        "path",
        {
            d: "m9.17 14.83-4.24 4.24",
            key: "bqpfvv"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "4",
            key: "4exip2"
        }
    ]
];
const $44e0240d7f2d6793$export$2e2bcd8739ae039 = (0, $djixo.default)("life-buoy", $44e0240d7f2d6793$export$3efd853dbb351e94);


var $3wlwv = parcelRequire("3wlwv");
var $7k3Wx = parcelRequire("7k3Wx");
var $dRGZn = parcelRequire("dRGZn");
var $vMEqK = parcelRequire("vMEqK");/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $052f07d1332d4c9e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
            key: "1i5ecw"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const $052f07d1332d4c9e$export$2e2bcd8739ae039 = (0, $djixo.default)("settings", $052f07d1332d4c9e$export$3efd853dbb351e94);


var $8n6ke = parcelRequire("8n6ke");

var $b8xcN = parcelRequire("b8xcN");





var $23e805981e4d0133$var$didWarnUncachedGetSnapshot = false;
// Prevent webpack from complaining about our feature detection of the
// useSyncExternalStore property of the React namespace, which is expected not
// to exist when using React 17 and earlier, and that's fine.
var $23e805981e4d0133$var$uSESKey = "useSyncExternalStore";
var $23e805981e4d0133$var$realHook = $631d82cb14744748$exports[$23e805981e4d0133$var$uSESKey];
var $23e805981e4d0133$export$306c0aa65ff9ec16 = $23e805981e4d0133$var$realHook || function(subscribe, getSnapshot, getServerSnapshot) {
    // Read the current snapshot from the store on every render. Again, this
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    var value = getSnapshot();
    if (// DEVIATION: Using __DEV__
    globalThis.__DEV__ !== false && !$23e805981e4d0133$var$didWarnUncachedGetSnapshot && // DEVIATION: Not using Object.is because we know our snapshots will never
    // be exotic primitive values like NaN, which is !== itself.
    value !== getSnapshot()) {
        $23e805981e4d0133$var$didWarnUncachedGetSnapshot = true;
        // DEVIATION: Using invariant.error instead of console.error directly.
        globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).error(91);
    }
    // Because updates are synchronous, we don't queue them. Instead we force a
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    var _a = $631d82cb14744748$exports.useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _a[0].inst, forceUpdate = _a[1];
    // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    if (0, $138881ab8f31fa6b$export$4001f6cd4a62405b) // DEVIATION: We avoid calling useLayoutEffect when !canUseLayoutEffect,
    // which may seem like a conditional hook, but this code ends up behaving
    // unconditionally (one way or the other) because canUseLayoutEffect is
    // constant.
    $631d82cb14744748$exports.useLayoutEffect(function() {
        Object.assign(inst, {
            value: value,
            getSnapshot: getSnapshot
        });
        // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if ($23e805981e4d0133$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
    // React Hook React.useLayoutEffect has a missing dependency: 'inst'. Either include it or remove the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    else Object.assign(inst, {
        value: value,
        getSnapshot: getSnapshot
    });
    $631d82cb14744748$exports.useEffect(function() {
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if ($23e805981e4d0133$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
        // Subscribe to the store and return a clean-up function.
        return subscribe(function handleStoreChange() {
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if ($23e805981e4d0133$var$checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        });
    // React Hook React.useEffect has a missing dependency: 'inst'. Either include it or remove the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe
    ]);
    return value;
};
function $23e805981e4d0133$var$checkIfSnapshotChanged(_a) {
    var value = _a.value, getSnapshot = _a.getSnapshot;
    try {
        return value !== getSnapshot();
    } catch (_b) {
        return true;
    }
}


const { toString: $b59b67a8b7fe71c2$var$toString, hasOwnProperty: $b59b67a8b7fe71c2$var$hasOwnProperty } = Object.prototype;
const $b59b67a8b7fe71c2$var$fnToStr = Function.prototype.toString;
const $b59b67a8b7fe71c2$var$previousComparisons = new Map();
function $b59b67a8b7fe71c2$export$411ce8e5a71e3069(a, b) {
    try {
        return $b59b67a8b7fe71c2$var$check(a, b);
    } finally{
        $b59b67a8b7fe71c2$var$previousComparisons.clear();
    }
}
var // Allow default imports as well.
$b59b67a8b7fe71c2$export$2e2bcd8739ae039 = $b59b67a8b7fe71c2$export$411ce8e5a71e3069;
function $b59b67a8b7fe71c2$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    const aTag = $b59b67a8b7fe71c2$var$toString.call(a);
    const bTag = $b59b67a8b7fe71c2$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            {
                if ($b59b67a8b7fe71c2$var$previouslyCompared(a, b)) return true;
                const aKeys = $b59b67a8b7fe71c2$var$definedKeys(a);
                const bKeys = $b59b67a8b7fe71c2$var$definedKeys(b);
                // If `a` and `b` have a different number of enumerable keys, they
                // must be different.
                const keyCount = aKeys.length;
                if (keyCount !== bKeys.length) return false;
                // Now make sure they have the same keys.
                for(let k = 0; k < keyCount; ++k){
                    if (!$b59b67a8b7fe71c2$var$hasOwnProperty.call(b, aKeys[k])) return false;
                }
                // Finally, check deep equality of all child properties.
                for(let k = 0; k < keyCount; ++k){
                    const key = aKeys[k];
                    if (!$b59b67a8b7fe71c2$var$check(a[key], b[key])) return false;
                }
                return true;
            }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == `${b}`;
        case '[object Map]':
        case '[object Set]':
            {
                if (a.size !== b.size) return false;
                if ($b59b67a8b7fe71c2$var$previouslyCompared(a, b)) return true;
                const aIterator = a.entries();
                const isMap = aTag === '[object Map]';
                while(true){
                    const info = aIterator.next();
                    if (info.done) break;
                    // If a instanceof Set, aValue === aKey.
                    const [aKey, aValue] = info.value;
                    // So this works the same way for both Set and Map.
                    if (!b.has(aKey)) return false;
                    // However, we care about deep equality of values only when dealing
                    // with Map structures.
                    if (isMap && !$b59b67a8b7fe71c2$var$check(aValue, b.get(aKey))) return false;
                }
                return true;
            }
        case '[object Uint16Array]':
        case '[object Uint8Array]':
        case '[object Uint32Array]':
        case '[object Int32Array]':
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object ArrayBuffer]':
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case '[object DataView]':
            {
                let len = a.byteLength;
                if (len === b.byteLength) {
                    while(len-- && a[len] === b[len]);
                }
                return len === -1;
            }
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]':
            {
                const aCode = $b59b67a8b7fe71c2$var$fnToStr.call(a);
                if (aCode !== $b59b67a8b7fe71c2$var$fnToStr.call(b)) return false;
                // We consider non-native functions equal if they have the same code
                // (native functions require === because their code is censored).
                // Note that this behavior is not entirely sound, since !== function
                // objects with the same code can behave differently depending on
                // their closure scope. However, any function can behave differently
                // depending on the values of its input arguments (including this)
                // and its calling context (including its closure scope), even
                // though the function object is === to itself; and it is entirely
                // possible for functions that are not === to behave exactly the
                // same under all conceivable circumstances. Because none of these
                // factors are statically decidable in JavaScript, JS function
                // equality is not well-defined. This ambiguity allows us to
                // consider the best possible heuristic among various imperfect
                // options, and equating non-native functions that have the same
                // code has enormous practical benefits, such as when comparing
                // functions that are repeatedly passed as fresh function
                // expressions within objects that are otherwise deeply equal. Since
                // any function created from the same syntactic expression (in the
                // same code location) will always stringify to the same code
                // according to fnToStr.call, we can reasonably expect these
                // repeatedly passed function expressions to have the same code, and
                // thus behave "the same" (with all the caveats mentioned above),
                // even though the runtime function objects are !== to one another.
                return !$b59b67a8b7fe71c2$var$endsWith(aCode, $b59b67a8b7fe71c2$var$nativeCodeSuffix);
            }
    }
    // Otherwise the values are not equal.
    return false;
}
function $b59b67a8b7fe71c2$var$definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter($b59b67a8b7fe71c2$var$isDefinedKey, obj);
}
function $b59b67a8b7fe71c2$var$isDefinedKey(key) {
    return this[key] !== void 0;
}
const $b59b67a8b7fe71c2$var$nativeCodeSuffix = "{ [native code] }";
function $b59b67a8b7fe71c2$var$endsWith(full, suffix) {
    const fromIndex = full.length - suffix.length;
    return fromIndex >= 0 && full.indexOf(suffix, fromIndex) === fromIndex;
}
function $b59b67a8b7fe71c2$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    let bSet = $b59b67a8b7fe71c2$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $b59b67a8b7fe71c2$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}


/**
 * Merges the provided objects shallowly and removes
 * all properties with an `undefined` value
 */ function $b37018ac55880203$export$8e16b83750b44988() {
    var objects = [];
    for(var _i = 0; _i < arguments.length; _i++)objects[_i] = arguments[_i];
    var result = Object.create(null);
    objects.forEach(function(obj) {
        if (!obj) return;
        Object.keys(obj).forEach(function(key) {
            var value = obj[key];
            if (value !== void 0) result[key] = value;
        });
    });
    return result;
}

// A version of Array.isArray that works better with readonly arrays.
var $01c8f68cc3e070ef$export$43bee75e5e14138e = Array.isArray;
function $01c8f68cc3e070ef$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}

function $01d0d880754ccbd1$export$417207af72fad9c9(obj) {
    return obj !== null && typeof obj === "object";
}
function $01d0d880754ccbd1$export$53b83ca8eaab0383(obj) {
    return obj !== null && typeof obj === "object" && (Object.getPrototypeOf(obj) === Object.prototype || Object.getPrototypeOf(obj) === null);
}


function $5d04349b74d4efd7$export$7e32b29e1cb162e1(value) {
    var workSet = new Set([
        value
    ]);
    workSet.forEach(function(obj) {
        if ((0, $01d0d880754ccbd1$export$417207af72fad9c9)(obj) && $5d04349b74d4efd7$var$shallowFreeze(obj) === obj) Object.getOwnPropertyNames(obj).forEach(function(name) {
            if ((0, $01d0d880754ccbd1$export$417207af72fad9c9)(obj[name])) workSet.add(obj[name]);
        });
    });
    return value;
}
function $5d04349b74d4efd7$var$shallowFreeze(obj) {
    if (globalThis.__DEV__ !== false && !Object.isFrozen(obj)) try {
        Object.freeze(obj);
    } catch (e) {
        // Some types like Uint8Array and Node.js's Buffer cannot be frozen, but
        // they all throw a TypeError when you try, so we re-throw any exceptions
        // that are not TypeErrors, since that would be unexpected.
        if (e instanceof TypeError) return null;
        throw e;
    }
    return obj;
}
function $5d04349b74d4efd7$export$7f9c177735b71f18(obj) {
    if (globalThis.__DEV__ !== false) $5d04349b74d4efd7$export$7e32b29e1cb162e1(obj);
    return obj;
}


var $b8xcN = parcelRequire("b8xcN");

function $a76f045ea055af6d$export$235b7fc70b9fc359(defaults, options) {
    return (0, $b37018ac55880203$export$8e16b83750b44988)(defaults, options, options.variables && {
        variables: (0, $b37018ac55880203$export$8e16b83750b44988)((0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, defaults && defaults.variables), options.variables))
    });
}


var $b8xcN = parcelRequire("b8xcN");
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const $722ae841a583e691$var$defaultMakeData = ()=>Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach: $722ae841a583e691$var$forEach, slice: $722ae841a583e691$var$slice } = Array.prototype;
const { hasOwnProperty: $722ae841a583e691$var$hasOwnProperty } = Object.prototype;
class $722ae841a583e691$export$73571c50d0f2507e {
    constructor(weakness = true, makeData = $722ae841a583e691$var$defaultMakeData){
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup() {
        return this.lookupArray(arguments);
    }
    lookupArray(array) {
        let node = this;
        $722ae841a583e691$var$forEach.call(array, (key)=>node = node.getChildTrie(key));
        return $722ae841a583e691$var$hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData($722ae841a583e691$var$slice.call(array));
    }
    peek() {
        return this.peekArray(arguments);
    }
    peekArray(array) {
        let node = this;
        for(let i = 0, len = array.length; node && i < len; ++i){
            const map = node.mapFor(array[i], false);
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    remove() {
        return this.removeArray(arguments);
    }
    removeArray(array) {
        let data;
        if (array.length) {
            const head = array[0];
            const map = this.mapFor(head, false);
            const child = map && map.get(head);
            if (child) {
                data = child.removeArray($722ae841a583e691$var$slice.call(array, 1));
                if (!child.data && !child.weak && !(child.strong && child.strong.size)) map.delete(head);
            }
        } else {
            data = this.data;
            delete this.data;
        }
        return data;
    }
    getChildTrie(key) {
        const map = this.mapFor(key, true);
        let child = map.get(key);
        if (!child) map.set(key, child = new $722ae841a583e691$export$73571c50d0f2507e(this.weakness, this.makeData));
        return child;
    }
    mapFor(key, create) {
        return this.weakness && $722ae841a583e691$var$isObjRef(key) ? this.weak || (create ? this.weak = new WeakMap : void 0) : this.strong || (create ? this.strong = new Map : void 0);
    }
}
function $722ae841a583e691$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}


function $aad0ecaed80ca32e$var$defaultDispose() {}
class $aad0ecaed80ca32e$export$d3a0331d2c286dc8 {
    constructor(max = Infinity, dispose = $aad0ecaed80ca32e$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    get size() {
        return this.map.size;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    }
    clean() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            if (node === this.newest) this.newest = node.older;
            if (node === this.oldest) this.oldest = node.newer;
            if (node.newer) node.newer.older = node.older;
            if (node.older) node.older.newer = node.newer;
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    }
}


// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
let $f6d7836b3fbc48f1$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
const $f6d7836b3fbc48f1$var$MISSING_VALUE = {};
let $f6d7836b3fbc48f1$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
const $f6d7836b3fbc48f1$var$makeSlotClass = ()=>class Slot {
        constructor(){
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $f6d7836b3fbc48f1$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        hasValue() {
            for(let context = $f6d7836b3fbc48f1$var$currentContext; context; context = context.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context.slots) {
                const value = context.slots[this.id];
                if (value === $f6d7836b3fbc48f1$var$MISSING_VALUE) break;
                if (context !== $f6d7836b3fbc48f1$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $f6d7836b3fbc48f1$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($f6d7836b3fbc48f1$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $f6d7836b3fbc48f1$var$currentContext.slots[this.id] = $f6d7836b3fbc48f1$var$MISSING_VALUE;
            return false;
        }
        getValue() {
            if (this.hasValue()) return $f6d7836b3fbc48f1$var$currentContext.slots[this.id];
        }
        withValue(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            const slots = {
                __proto__: null,
                [this.id]: value
            };
            const parent = $f6d7836b3fbc48f1$var$currentContext;
            $f6d7836b3fbc48f1$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $f6d7836b3fbc48f1$var$currentContext = parent;
            }
        }
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        static bind(callback) {
            const context = $f6d7836b3fbc48f1$var$currentContext;
            return function() {
                const saved = $f6d7836b3fbc48f1$var$currentContext;
                try {
                    $f6d7836b3fbc48f1$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $f6d7836b3fbc48f1$var$currentContext = saved;
                }
            };
        }
        // Immediately run a callback function without any captured context.
        static noContext(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($f6d7836b3fbc48f1$var$currentContext) {
                const saved = $f6d7836b3fbc48f1$var$currentContext;
                try {
                    $f6d7836b3fbc48f1$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $f6d7836b3fbc48f1$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        }
    };
function $f6d7836b3fbc48f1$var$maybe(fn) {
    try {
        return fn();
    } catch (ignored) {}
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
const $f6d7836b3fbc48f1$var$globalKey = "@wry/context:Slot";
const $f6d7836b3fbc48f1$var$host = // Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
$f6d7836b3fbc48f1$var$maybe(()=>globalThis) || // Fall back to global, which works in Node.js and may be converted by some
// bundlers to the appropriate identifier (window, self, ...) depending on the
// bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
$f6d7836b3fbc48f1$var$maybe(()=>$parcel$global) || // Otherwise, use a dummy host that's local to this module. We used to fall
// back to using the Array constructor as a namespace, but that was flagged in
// https://github.com/benjamn/wryware/issues/347, and can be avoided.
Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
const $f6d7836b3fbc48f1$var$globalHost = $f6d7836b3fbc48f1$var$host;
const $f6d7836b3fbc48f1$export$8c6ed5c666ac1360 = $f6d7836b3fbc48f1$var$globalHost[$f6d7836b3fbc48f1$var$globalKey] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[$f6d7836b3fbc48f1$var$globalKey] || function(Slot) {
    try {
        Object.defineProperty($f6d7836b3fbc48f1$var$globalHost, $f6d7836b3fbc48f1$var$globalKey, {
            value: Slot,
            enumerable: false,
            writable: false,
            // When it was possible for globalHost to be the Array constructor (a
            // legacy Slot dedup strategy), it was important for the property to be
            // configurable:true so it could be deleted. That does not seem to be as
            // important when globalHost is the global object, but I don't want to
            // cause similar problems again, and configurable:true seems safest.
            // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
            configurable: true
        });
    } finally{
        return Slot;
    }
}($f6d7836b3fbc48f1$var$makeSlotClass());


const { bind: $c178253d3b97dada$export$2385a24977818dd0, noContext: $c178253d3b97dada$export$9fa6f2e300a97f8 } = (0, $f6d7836b3fbc48f1$export$8c6ed5c666ac1360);
function $c178253d3b97dada$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($c178253d3b97dada$export$2385a24977818dd0(callback), delay);
}
function $c178253d3b97dada$export$d5d7536e965c82da(genFn) {
    return function() {
        const gen = genFn.apply(this, arguments);
        const boundNext = $c178253d3b97dada$export$2385a24977818dd0(gen.next);
        const boundThrow = $c178253d3b97dada$export$2385a24977818dd0(gen.throw);
        return new Promise((resolve, reject)=>{
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                const next = result.done ? resolve : invokeNext;
                if ($c178253d3b97dada$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            const invokeNext = (value)=>invoke(boundNext, value);
            const invokeThrow = (error)=>invoke(boundThrow, error);
            invokeNext();
        });
    };
}
function $c178253d3b97dada$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
const $c178253d3b97dada$var$wrappedFibers = [];
function $c178253d3b97dada$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($c178253d3b97dada$var$wrappedFibers.indexOf(Fiber) < 0) {
        const wrap = (obj, method)=>{
            const fn = obj[method];
            obj[method] = function() {
                return $c178253d3b97dada$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $c178253d3b97dada$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}


const $db0ce3d3f1dced69$export$11fa9682b6ba79b1 = new (0, $f6d7836b3fbc48f1$export$8c6ed5c666ac1360)();
function $db0ce3d3f1dced69$export$d906efd39458576(fn) {
    return $db0ce3d3f1dced69$export$11fa9682b6ba79b1.withValue(void 0, fn);
}


const { hasOwnProperty: $808c6e5bfc39bb4f$export$5a15a386532a5ea4 } = Object.prototype;
const $808c6e5bfc39bb4f$export$1eb72f2488cedd93 = Array.from || function(set) {
    const array = [];
    set.forEach((item)=>array.push(item));
    return array;
};
function $808c6e5bfc39bb4f$export$50527b97338c0f71(entryOrDep) {
    const { unsubscribe: unsubscribe } = entryOrDep;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}


const $1aebd13bf6a3ddbb$var$emptySetPool = [];
const $1aebd13bf6a3ddbb$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $1aebd13bf6a3ddbb$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $1aebd13bf6a3ddbb$var$valueIs(a, b) {
    const len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $1aebd13bf6a3ddbb$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $1aebd13bf6a3ddbb$var$valueCopy(value) {
    return value.slice(0);
}
class $1aebd13bf6a3ddbb$export$3bb977b3ba9d3b59 {
    constructor(fn){
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++$1aebd13bf6a3ddbb$export$3bb977b3ba9d3b59.count;
    }
    peek() {
        if (this.value.length === 1 && !$1aebd13bf6a3ddbb$var$mightBeDirty(this)) {
            $1aebd13bf6a3ddbb$var$rememberParent(this);
            return this.value[0];
        }
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    recompute(args) {
        $1aebd13bf6a3ddbb$var$assert(!this.recomputing, "already recomputing");
        $1aebd13bf6a3ddbb$var$rememberParent(this);
        return $1aebd13bf6a3ddbb$var$mightBeDirty(this) ? $1aebd13bf6a3ddbb$var$reallyRecompute(this, args) : $1aebd13bf6a3ddbb$var$valueGet(this.value);
    }
    setDirty() {
        if (this.dirty) return;
        this.dirty = true;
        $1aebd13bf6a3ddbb$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        (0, $808c6e5bfc39bb4f$export$50527b97338c0f71)(this);
    }
    dispose() {
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        $1aebd13bf6a3ddbb$var$forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        $1aebd13bf6a3ddbb$var$eachParent(this, (parent, child)=>{
            parent.setDirty();
            $1aebd13bf6a3ddbb$var$forgetChild(parent, this);
        });
    }
    forget() {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    }
    dependOn(dep) {
        dep.add(this);
        if (!this.deps) this.deps = $1aebd13bf6a3ddbb$var$emptySetPool.pop() || new Set();
        this.deps.add(dep);
    }
    forgetDeps() {
        if (this.deps) {
            (0, $808c6e5bfc39bb4f$export$1eb72f2488cedd93)(this.deps).forEach((dep)=>dep.delete(this));
            this.deps.clear();
            $1aebd13bf6a3ddbb$var$emptySetPool.push(this.deps);
            this.deps = null;
        }
    }
}
$1aebd13bf6a3ddbb$export$3bb977b3ba9d3b59.count = 0;
function $1aebd13bf6a3ddbb$var$rememberParent(child) {
    const parent = (0, $db0ce3d3f1dced69$export$11fa9682b6ba79b1).getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($1aebd13bf6a3ddbb$var$mightBeDirty(child)) $1aebd13bf6a3ddbb$var$reportDirtyChild(parent, child);
        else $1aebd13bf6a3ddbb$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $1aebd13bf6a3ddbb$var$reallyRecompute(entry, args) {
    $1aebd13bf6a3ddbb$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    (0, $db0ce3d3f1dced69$export$11fa9682b6ba79b1).withValue(entry, $1aebd13bf6a3ddbb$var$recomputeNewValue, [
        entry,
        args
    ]);
    if ($1aebd13bf6a3ddbb$var$maybeSubscribe(entry, args)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $1aebd13bf6a3ddbb$var$setClean(entry);
    return $1aebd13bf6a3ddbb$var$valueGet(entry.value);
}
function $1aebd13bf6a3ddbb$var$recomputeNewValue(entry, args) {
    entry.recomputing = true;
    const { normalizeResult: normalizeResult } = entry;
    let oldValueCopy;
    if (normalizeResult && entry.value.length === 1) oldValueCopy = $1aebd13bf6a3ddbb$var$valueCopy(entry.value);
    // Make entry.value an empty array, representing an unknown value.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
        // If we have a viable oldValueCopy to compare with the (successfully
        // recomputed) new entry.value, and they are not already === identical, give
        // normalizeResult a chance to pick/choose/reuse parts of oldValueCopy[0]
        // and/or entry.value[0] to determine the final cached entry.value.
        if (normalizeResult && oldValueCopy && !$1aebd13bf6a3ddbb$var$valueIs(oldValueCopy, entry.value)) try {
            entry.value[0] = normalizeResult(entry.value[0], oldValueCopy[0]);
        } catch (_a) {
        // If normalizeResult throws, just use the newer value, rather than
        // saving the exception as entry.value[1].
        }
    } catch (e) {
        // If entry.fn throws, entry.value will hold that exception.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $1aebd13bf6a3ddbb$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $1aebd13bf6a3ddbb$var$setClean(entry) {
    entry.dirty = false;
    if ($1aebd13bf6a3ddbb$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $1aebd13bf6a3ddbb$var$reportClean(entry);
}
function $1aebd13bf6a3ddbb$var$reportDirty(child) {
    $1aebd13bf6a3ddbb$var$eachParent(child, $1aebd13bf6a3ddbb$var$reportDirtyChild);
}
function $1aebd13bf6a3ddbb$var$reportClean(child) {
    $1aebd13bf6a3ddbb$var$eachParent(child, $1aebd13bf6a3ddbb$var$reportCleanChild);
}
function $1aebd13bf6a3ddbb$var$eachParent(child, callback) {
    const parentCount = child.parents.size;
    if (parentCount) {
        const parents = (0, $808c6e5bfc39bb4f$export$1eb72f2488cedd93)(child.parents);
        for(let i = 0; i < parentCount; ++i)callback(parents[i], child);
    }
}
// Let a parent Entry know that one of its children may be dirty.
function $1aebd13bf6a3ddbb$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $1aebd13bf6a3ddbb$var$assert(parent.childValues.has(child));
    $1aebd13bf6a3ddbb$var$assert($1aebd13bf6a3ddbb$var$mightBeDirty(child));
    const parentWasClean = !$1aebd13bf6a3ddbb$var$mightBeDirty(parent);
    if (!parent.dirtyChildren) parent.dirtyChildren = $1aebd13bf6a3ddbb$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) $1aebd13bf6a3ddbb$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $1aebd13bf6a3ddbb$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $1aebd13bf6a3ddbb$var$assert(parent.childValues.has(child));
    $1aebd13bf6a3ddbb$var$assert(!$1aebd13bf6a3ddbb$var$mightBeDirty(child));
    const childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $1aebd13bf6a3ddbb$var$valueCopy(child.value));
    else if (!$1aebd13bf6a3ddbb$var$valueIs(childValue, child.value)) parent.setDirty();
    $1aebd13bf6a3ddbb$var$removeDirtyChild(parent, child);
    if ($1aebd13bf6a3ddbb$var$mightBeDirty(parent)) return;
    $1aebd13bf6a3ddbb$var$reportClean(parent);
}
function $1aebd13bf6a3ddbb$var$removeDirtyChild(parent, child) {
    const dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($1aebd13bf6a3ddbb$var$emptySetPool.length < $1aebd13bf6a3ddbb$var$POOL_TARGET_SIZE) $1aebd13bf6a3ddbb$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function $1aebd13bf6a3ddbb$var$forgetChildren(parent) {
    if (parent.childValues.size > 0) parent.childValues.forEach((_value, child)=>{
        $1aebd13bf6a3ddbb$var$forgetChild(parent, child);
    });
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $1aebd13bf6a3ddbb$var$assert(parent.dirtyChildren === null);
}
function $1aebd13bf6a3ddbb$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $1aebd13bf6a3ddbb$var$removeDirtyChild(parent, child);
}
function $1aebd13bf6a3ddbb$var$maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") try {
        (0, $808c6e5bfc39bb4f$export$50527b97338c0f71)(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}





const $aed695b3db154433$var$EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true
};
function $aed695b3db154433$export$c723b7eff9d8f870(options) {
    const depsByKey = new Map();
    const subscribe = options && options.subscribe;
    function depend(key) {
        const parent = (0, $db0ce3d3f1dced69$export$11fa9682b6ba79b1).getValue();
        if (parent) {
            let dep = depsByKey.get(key);
            if (!dep) depsByKey.set(key, dep = new Set);
            parent.dependOn(dep);
            if (typeof subscribe === "function") {
                (0, $808c6e5bfc39bb4f$export$50527b97338c0f71)(dep);
                dep.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        const dep = depsByKey.get(key);
        if (dep) {
            const m = entryMethodName && (0, $808c6e5bfc39bb4f$export$5a15a386532a5ea4).call($aed695b3db154433$var$EntryMethods, entryMethodName) ? entryMethodName : "setDirty";
            // We have to use arrayFromSet(dep).forEach instead of dep.forEach,
            // because modifying a Set while iterating over it can cause elements in
            // the Set to be removed from the Set before they've been iterated over.
            (0, $808c6e5bfc39bb4f$export$1eb72f2488cedd93)(dep).forEach((entry)=>entry[m]());
            depsByKey.delete(key);
            (0, $808c6e5bfc39bb4f$export$50527b97338c0f71)(dep);
        }
    };
    return depend;
}


// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
let $2a919cc3f1f126e4$var$defaultKeyTrie;
function $2a919cc3f1f126e4$export$cd3144f8dd136006(...args) {
    const trie = $2a919cc3f1f126e4$var$defaultKeyTrie || ($2a919cc3f1f126e4$var$defaultKeyTrie = new (0, $722ae841a583e691$export$73571c50d0f2507e)(typeof WeakMap === "function"));
    return trie.lookupArray(args);
}
const $2a919cc3f1f126e4$var$caches = new Set();
function $2a919cc3f1f126e4$export$4997ffc0176396a6(originalFunction, { max: max = Math.pow(2, 16), keyArgs: keyArgs, makeCacheKey: makeCacheKey = $2a919cc3f1f126e4$export$cd3144f8dd136006, normalizeResult: normalizeResult, subscribe: subscribe, cache: cacheOption = (0, $aad0ecaed80ca32e$export$d3a0331d2c286dc8) } = Object.create(null)) {
    const cache = typeof cacheOption === "function" ? new cacheOption(max, (entry)=>entry.dispose()) : cacheOption;
    const optimistic = function() {
        const key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        let entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new (0, $1aebd13bf6a3ddbb$export$3bb977b3ba9d3b59)(originalFunction));
            entry.normalizeResult = normalizeResult;
            entry.subscribe = subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = ()=>cache.delete(key);
        }
        const value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $2a919cc3f1f126e4$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!(0, $db0ce3d3f1dced69$export$11fa9682b6ba79b1).hasValue()) {
            $2a919cc3f1f126e4$var$caches.forEach((cache)=>cache.clean());
            $2a919cc3f1f126e4$var$caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: ()=>cache.size,
        configurable: false,
        enumerable: false
    });
    Object.freeze(optimistic.options = {
        max: max,
        keyArgs: keyArgs,
        makeCacheKey: makeCacheKey,
        normalizeResult: normalizeResult,
        subscribe: subscribe,
        cache: cache
    });
    function dirtyKey(key) {
        const entry = key && cache.get(key);
        if (entry) entry.setDirty();
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        const entry = key && cache.get(key);
        if (entry) return entry.peek();
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return key ? cache.delete(key) : false;
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}



var $14465ad01ccc354a$var$_a;
var $14465ad01ccc354a$var$muteAllDeprecations = Symbol.for("apollo.deprecations");
var $14465ad01ccc354a$var$deprecationsSlot = Symbol.for("apollo.deprecations.slot");
var $14465ad01ccc354a$var$global = (0, $5b81337c038bdc28$export$2e2bcd8739ae039);
var $14465ad01ccc354a$var$slot = ($14465ad01ccc354a$var$_a = $14465ad01ccc354a$var$global[$14465ad01ccc354a$var$deprecationsSlot]) !== null && $14465ad01ccc354a$var$_a !== void 0 ? $14465ad01ccc354a$var$_a : $14465ad01ccc354a$var$global[$14465ad01ccc354a$var$deprecationsSlot] = new (0, $f6d7836b3fbc48f1$export$8c6ed5c666ac1360)();
function $14465ad01ccc354a$var$isMuted(name) {
    return $14465ad01ccc354a$var$global[$14465ad01ccc354a$var$muteAllDeprecations] || ($14465ad01ccc354a$var$slot.getValue() || []).includes(name);
}
function $14465ad01ccc354a$export$d18d1529326946c4(name) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return $14465ad01ccc354a$var$slot.withValue.apply($14465ad01ccc354a$var$slot, (0, $b8xcN.__spreadArray)([
        Array.isArray(name) ? name : [
            name
        ]
    ], args, false));
}
function $14465ad01ccc354a$export$6d0d09df4c29a84a(options, name, callSite, recommendation) {
    if (recommendation === void 0) recommendation = "Please remove this option.";
    $14465ad01ccc354a$export$606a5c06d13e04b6(name, function() {
        if (name in options) globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(103, callSite, name, recommendation);
    });
}
function $14465ad01ccc354a$export$606a5c06d13e04b6(name, cb) {
    if (!$14465ad01ccc354a$var$isMuted(name)) cb();
}




var $b8xcN = parcelRequire("b8xcN");


var $03c08328939e6317$export$4995664c1b49842e = Symbol();
function $03c08328939e6317$export$345f95cc6b6b9b0b(result) {
    if (result.extensions) return Array.isArray(result.extensions[$03c08328939e6317$export$4995664c1b49842e]);
    return false;
}
function $03c08328939e6317$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty("graphQLErrors");
}
// Sets the error message on this error according to the
// the GraphQL and network errors that are present.
// If the error message has already been set through the
// constructor or otherwise, this function is a nop.
var $03c08328939e6317$var$generateErrorMessage = function(err) {
    var errors = (0, $b8xcN.__spreadArray)((0, $b8xcN.__spreadArray)((0, $b8xcN.__spreadArray)([], err.graphQLErrors, true), err.clientErrors, true), err.protocolErrors, true);
    if (err.networkError) errors.push(err.networkError);
    return errors// The rest of the code sometimes unsafely types non-Error objects as GraphQLErrors
    .map(function(err) {
        return (0, $01d0d880754ccbd1$export$417207af72fad9c9)(err) && err.message || "Error message not found.";
    }).join("\n");
};
var $03c08328939e6317$export$26a337512320b8c6 = /** @class */ function(_super) {
    (0, $b8xcN.__extends)(ApolloError, _super);
    // Constructs an instance of ApolloError given serialized GraphQL errors,
    // client errors, protocol errors or network errors.
    // Note that one of these has to be a valid
    // value or the constructed error will be meaningless.
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, protocolErrors = _a.protocolErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = "ApolloError";
        _this.graphQLErrors = graphQLErrors || [];
        _this.protocolErrors = protocolErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || $03c08328939e6317$var$generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.cause = (0, $b8xcN.__spreadArray)((0, $b8xcN.__spreadArray)((0, $b8xcN.__spreadArray)([
            networkError
        ], graphQLErrors || [], true), protocolErrors || [], true), clientErrors || [], true).find(function(e) {
            return !!e;
        }) || null;
        // We're not using `Object.setPrototypeOf` here as it isn't fully
        // supported on Android (see issue #3236).
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);


/**
 * The current status of a query’s execution in our system.
 */ var $7f070805c91ccc41$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    /**
     * The query has never been run before and the query is now currently running. A query will still
     * have this network status even if a partial data result was returned from the cache, but a
     * query was dispatched anyway.
     */ NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    /**
     * If `setVariables` was called and a query was fired because of that then the network status
     * will be `setVariables` until the result of that query comes back.
     */ NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    /**
     * Indicates that `fetchMore` was called on this query and that the query created is currently in
     * flight.
     */ NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    /**
     * Similar to the `setVariables` network status. It means that `refetch` was called on a query
     * and the refetch request is currently in flight.
     */ NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    /**
     * Indicates that a polling query is currently in flight. So for example if you are polling a
     * query every 10 seconds then the network status will switch to `poll` every 10 seconds whenever
     * a poll request has been sent but not resolved.
     */ NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    /**
     * No request is in flight for this query, and no errors happened. Everything is OK.
     */ NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    /**
     * No request is in flight for this query, but one or more errors were detected.
     */ NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($7f070805c91ccc41$export$bd096ddbd246c79c || ($7f070805c91ccc41$export$bd096ddbd246c79c = {}));
function $7f070805c91ccc41$export$37509604341a3464(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
function $7f070805c91ccc41$export$427e8a52ef0f96e2(networkStatus) {
    return networkStatus === 7 || networkStatus === 8;
}


var $b8xcN = parcelRequire("b8xcN");



var $778668322a5c03d6$var$toString = Object.prototype.toString;
function $778668322a5c03d6$export$629a2bd3f5a49ecc(value) {
    return $778668322a5c03d6$var$cloneDeepHelper(value);
}
function $778668322a5c03d6$var$cloneDeepHelper(val, seen) {
    switch($778668322a5c03d6$var$toString.call(val)){
        case "[object Array]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $778668322a5c03d6$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            // High fidelity polyfills of Object.create and Object.getPrototypeOf are
            // possible in all JS environments, so we will assume they exist/work.
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $778668322a5c03d6$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}

function $2027033ce24a9479$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $2027033ce24a9479$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2027033ce24a9479$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2027033ce24a9479$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2027033ce24a9479$var$_arrayLikeToArray(o, minLen);
}
function $2027033ce24a9479$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2027033ce24a9479$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2027033ce24a9479$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2027033ce24a9479$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2027033ce24a9479$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// === Symbol Support ===
var $2027033ce24a9479$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $2027033ce24a9479$var$hasSymbol = function(name) {
    return $2027033ce24a9479$var$hasSymbols() && Boolean(Symbol[name]);
};
var $2027033ce24a9479$var$getSymbol = function(name) {
    return $2027033ce24a9479$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($2027033ce24a9479$var$hasSymbols() && !$2027033ce24a9479$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $2027033ce24a9479$var$SymbolIterator = $2027033ce24a9479$var$getSymbol('iterator');
var $2027033ce24a9479$var$SymbolObservable = $2027033ce24a9479$var$getSymbol('observable');
var $2027033ce24a9479$var$SymbolSpecies = $2027033ce24a9479$var$getSymbol('species'); // === Abstract Operations ===
function $2027033ce24a9479$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $2027033ce24a9479$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$2027033ce24a9479$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $2027033ce24a9479$export$77cea355fa80b5f4;
}
function $2027033ce24a9479$var$isObservable(x) {
    return x instanceof $2027033ce24a9479$export$77cea355fa80b5f4; // SPEC: Brand check
}
function $2027033ce24a9479$var$hostReportError(e) {
    if ($2027033ce24a9479$var$hostReportError.log) $2027033ce24a9479$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $2027033ce24a9479$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $2027033ce24a9479$var$hostReportError(e);
        }
    });
}
function $2027033ce24a9479$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $2027033ce24a9479$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $2027033ce24a9479$var$hostReportError(e);
    }
}
function $2027033ce24a9479$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $2027033ce24a9479$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $2027033ce24a9479$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $2027033ce24a9479$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $2027033ce24a9479$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $2027033ce24a9479$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $2027033ce24a9479$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $2027033ce24a9479$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $2027033ce24a9479$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $2027033ce24a9479$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $2027033ce24a9479$var$enqueue(function() {
            return $2027033ce24a9479$var$flushSubscription(subscription);
        });
        return;
    }
    $2027033ce24a9479$var$notifySubscription(subscription, type, value);
}
var $2027033ce24a9479$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $2027033ce24a9479$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    var _proto = Subscription.prototype;
    _proto.unsubscribe = function unsubscribe() {
        if (this._state !== 'closed') {
            $2027033ce24a9479$var$closeSubscription(this);
            $2027033ce24a9479$var$cleanupSubscription(this);
        }
    };
    $2027033ce24a9479$var$_createClass(Subscription, [
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $2027033ce24a9479$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        this._subscription = subscription;
    }
    var _proto2 = SubscriptionObserver.prototype;
    _proto2.next = function next(value) {
        $2027033ce24a9479$var$onNotify(this._subscription, 'next', value);
    };
    _proto2.error = function error(value) {
        $2027033ce24a9479$var$onNotify(this._subscription, 'error', value);
    };
    _proto2.complete = function complete() {
        $2027033ce24a9479$var$onNotify(this._subscription, 'complete');
    };
    $2027033ce24a9479$var$_createClass(SubscriptionObserver, [
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $2027033ce24a9479$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    var _proto3 = Observable.prototype;
    _proto3.subscribe = function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) observer = {
            next: observer,
            error: arguments[1],
            complete: arguments[2]
        };
        return new $2027033ce24a9479$var$Subscription(observer, this._subscriber);
    };
    _proto3.forEach = function forEach(fn) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            if (typeof fn !== 'function') {
                reject(new TypeError(fn + ' is not a function'));
                return;
            }
            function done() {
                subscription.unsubscribe();
                resolve();
            }
            var subscription = _this.subscribe({
                next: function(value) {
                    try {
                        fn(value, done);
                    } catch (e) {
                        reject(e);
                        subscription.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    _proto3.map = function map(fn) {
        var _this2 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $2027033ce24a9479$var$getSpecies(this);
        return new C(function(observer) {
            return _this2.subscribe({
                next: function(value) {
                    try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.filter = function filter(fn) {
        var _this3 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $2027033ce24a9479$var$getSpecies(this);
        return new C(function(observer) {
            return _this3.subscribe({
                next: function(value) {
                    try {
                        if (!fn(value)) return;
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.reduce = function reduce(fn) {
        var _this4 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $2027033ce24a9479$var$getSpecies(this);
        var hasSeed = arguments.length > 1;
        var hasValue = false;
        var seed = arguments[1];
        var acc = seed;
        return new C(function(observer) {
            return _this4.subscribe({
                next: function(value) {
                    var first = !hasValue;
                    hasValue = true;
                    if (!first || hasSeed) try {
                        acc = fn(acc, value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    else acc = value;
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                    observer.next(acc);
                    observer.complete();
                }
            });
        });
    };
    _proto3.concat = function concat() {
        var _this5 = this;
        for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
        var C = $2027033ce24a9479$var$getSpecies(this);
        return new C(function(observer) {
            var subscription;
            var index = 0;
            function startNext(next) {
                subscription = next.subscribe({
                    next: function(v) {
                        observer.next(v);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        if (index === sources.length) {
                            subscription = undefined;
                            observer.complete();
                        } else startNext(C.from(sources[index++]));
                    }
                });
            }
            startNext(_this5);
            return function() {
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            };
        });
    };
    _proto3.flatMap = function flatMap(fn) {
        var _this6 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $2027033ce24a9479$var$getSpecies(this);
        return new C(function(observer) {
            var subscriptions = [];
            var outer = _this6.subscribe({
                next: function(value) {
                    if (fn) try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    var inner = C.from(value).subscribe({
                        next: function(value) {
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            var i = subscriptions.indexOf(inner);
                            if (i >= 0) subscriptions.splice(i, 1);
                            completeIfDone();
                        }
                    });
                    subscriptions.push(inner);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    completeIfDone();
                }
            });
            function completeIfDone() {
                if (outer.closed && subscriptions.length === 0) observer.complete();
            }
            return function() {
                subscriptions.forEach(function(s) {
                    return s.unsubscribe();
                });
                outer.unsubscribe();
            };
        });
    };
    _proto3[$2027033ce24a9479$var$SymbolObservable] = function() {
        return this;
    };
    Observable.from = function from(x) {
        var C = typeof this === 'function' ? this : Observable;
        if (x == null) throw new TypeError(x + ' is not an object');
        var method = $2027033ce24a9479$var$getMethod(x, $2027033ce24a9479$var$SymbolObservable);
        if (method) {
            var observable = method.call(x);
            if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
            if ($2027033ce24a9479$var$isObservable(observable) && observable.constructor === C) return observable;
            return new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        if ($2027033ce24a9479$var$hasSymbol('iterator')) {
            method = $2027033ce24a9479$var$getMethod(x, $2027033ce24a9479$var$SymbolIterator);
            if (method) return new C(function(observer) {
                $2027033ce24a9479$var$enqueue(function() {
                    if (observer.closed) return;
                    for(var _iterator = $2027033ce24a9479$var$_createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;){
                        var item = _step.value;
                        observer.next(item);
                        if (observer.closed) return;
                    }
                    observer.complete();
                });
            });
        }
        if (Array.isArray(x)) return new C(function(observer) {
            $2027033ce24a9479$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < x.length; ++i){
                    observer.next(x[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
        throw new TypeError(x + ' is not observable');
    };
    Observable.of = function of() {
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        var C = typeof this === 'function' ? this : Observable;
        return new C(function(observer) {
            $2027033ce24a9479$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < items.length; ++i){
                    observer.next(items[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
    };
    $2027033ce24a9479$var$_createClass(Observable, null, [
        {
            key: $2027033ce24a9479$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
if ($2027033ce24a9479$var$hasSymbols()) Object.defineProperty($2027033ce24a9479$export$77cea355fa80b5f4, Symbol('extensions'), {
    value: {
        symbol: $2027033ce24a9479$var$SymbolObservable,
        hostReportError: $2027033ce24a9479$var$hostReportError
    },
    configurable: true
});


parcelRequire("2NPO8");
// The zen-observable package defines Observable.prototype[Symbol.observable]
// when Symbol is supported, but RxJS interop depends on also setting this fake
// '@@observable' string as a polyfill for Symbol.observable.
var $c52d55f1551242e7$var$prototype = (0, $2027033ce24a9479$export$77cea355fa80b5f4).prototype;
var $c52d55f1551242e7$var$fakeObsSymbol = "@@observable";
if (!$c52d55f1551242e7$var$prototype[$c52d55f1551242e7$var$fakeObsSymbol]) // @ts-expect-error
$c52d55f1551242e7$var$prototype[$c52d55f1551242e7$var$fakeObsSymbol] = function() {
    return this;
};



function $ac8a77922bdd1f1c$export$33c8bd820eece9b2(subclass) {
    function set(key) {
        // Object.defineProperty is necessary because the Symbol.species
        // property is a getter by default in modern JS environments, so we
        // can't assign to it with a normal assignment expression.
        Object.defineProperty(subclass, key, {
            value: (0, $2027033ce24a9479$export$77cea355fa80b5f4)
        });
    }
    if ((0, $138881ab8f31fa6b$export$23ba675b4b838b92) && Symbol.species) set(Symbol.species);
    // The "@@species" string is used as a fake Symbol.species value in some
    // polyfill systems (including the SymbolSpecies variable used by
    // zen-observable), so we should set it as well, to be safe.
    set("@@species");
    return subclass;
}





var $b8xcN = parcelRequire("b8xcN");

/** @category Visiting */ /** @internal */ function $7007d6f1edee536c$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}


const $1518287c7b4a1333$var$MAX_ARRAY_LENGTH = 10;
const $1518287c7b4a1333$var$MAX_RECURSIVE_DEPTH = 2;
function $1518287c7b4a1333$export$9dec5d1b3b6a130d(value) {
    return $1518287c7b4a1333$var$formatValue(value, []);
}
function $1518287c7b4a1333$var$formatValue(value, seenValues) {
    switch(typeof value){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? `[function ${value.name}]` : '[function]';
        case 'object':
            return $1518287c7b4a1333$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $1518287c7b4a1333$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return 'null';
    if (previouslySeenValues.includes(value)) return '[Circular]';
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($1518287c7b4a1333$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === 'string' ? jsonValue : $1518287c7b4a1333$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $1518287c7b4a1333$var$formatArray(value, seenValues);
    return $1518287c7b4a1333$var$formatObject(value, seenValues);
}
function $1518287c7b4a1333$var$isJSONable(value) {
    return typeof value.toJSON === 'function';
}
function $1518287c7b4a1333$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return '{}';
    if (seenValues.length > $1518287c7b4a1333$var$MAX_RECURSIVE_DEPTH) return '[' + $1518287c7b4a1333$var$getObjectTag(object) + ']';
    const properties = entries.map(([key, value])=>key + ': ' + $1518287c7b4a1333$var$formatValue(value, seenValues));
    return '{ ' + properties.join(', ') + ' }';
}
function $1518287c7b4a1333$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $1518287c7b4a1333$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    const len = Math.min($1518287c7b4a1333$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($1518287c7b4a1333$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return '[' + items.join(', ') + ']';
}
function $1518287c7b4a1333$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        const name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}


/** @category AST */ /**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $feac916297e0f6f3$export$18a2be9195644f38 {
    /** The character offset at which this Node begins. */ /** The character offset at which this Node ends. */ /** The Token at which this Node begins. */ /** The Token at which this Node ends. */ /** The Source document the AST represents. */ /**
   * Creates a Location instance.
   * @param startToken - The start token.
   * @param endToken - The end token.
   * @param source - Source document used to derive error locations.
   * @example
   * ```ts
   * import { Location, Source, Token, TokenKind } from 'graphql/language';
   *
   * const source = new Source('{ hello }');
   * const startToken = new Token(TokenKind.BRACE_L, 0, 1, 1, 1);
   * const endToken = new Token(TokenKind.BRACE_R, 8, 9, 1, 9);
   * const location = new Location(startToken, endToken, source);
   *
   * location.start; // => 0
   * location.end; // => 9
   * location.source.body; // => '{ hello }'
   * ```
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    /**
   * Returns the value used by `Object.prototype.toString`.
   * @returns The built-in string tag for this object.
   */ get [Symbol.toStringTag]() {
        return 'Location';
    }
    /**
   * Returns a JSON representation of this location.
   * @returns The JSON-serializable representation.
   * @example
   * ```ts
   * import { parse } from 'graphql/language';
   *
   * const document = parse('{ hello }');
   * const location = document.loc?.toJSON();
   *
   * location; // => { start: 0, end: 9 }
   * ```
   */ toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $feac916297e0f6f3$export$50792b0e93539fde {
    /** The kind of Token. */ /** The character offset at which this Node begins. */ /** The character offset at which this Node ends. */ /** The 1-indexed line number on which this Token appears. */ /** The 1-indexed column number at which this Token begins. */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ /** Next token in the token stream, including ignored tokens. */ /**
   * Creates a Token instance.
   * @param kind - Token kind produced by lexical analysis.
   * @param start - Character offset where this token begins.
   * @param end - Character offset where this token ends.
   * @param line - One-indexed line number where this token begins.
   * @param column - One-indexed column number where this token begins.
   * @param value - Interpreted value for non-punctuation tokens.
   * @example
   * ```ts
   * import { Token, TokenKind } from 'graphql/language';
   *
   * const token = new Token(TokenKind.NAME, 2, 7, 1, 3, 'hello');
   *
   * token.kind; // => TokenKind.NAME
   * token.value; // => 'hello'
   * token.toJSON(); // => { kind: 'Name', value: 'hello', line: 1, column: 3 }
   * ```
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    /**
   * Returns the value used by `Object.prototype.toString`.
   * @returns The built-in string tag for this object.
   */ get [Symbol.toStringTag]() {
        return 'Token';
    }
    /**
   * Returns a JSON representation of this token.
   * @returns The JSON-serializable representation.
   * @example
   * ```ts
   * import { Lexer, Source } from 'graphql/language';
   *
   * const lexer = new Lexer(new Source('{ hello }'));
   * const token = lexer.advance().toJSON();
   *
   * token; // => { kind: '{', value: undefined, line: 1, column: 1 }
   * ```
   */ toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $feac916297e0f6f3$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'description',
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'description',
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'description',
        'name',
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'directives',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    DirectiveExtension: [
        'name',
        'directives'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ],
    TypeCoordinate: [
        'name'
    ],
    MemberCoordinate: [
        'name',
        'memberName'
    ],
    ArgumentCoordinate: [
        'name',
        'fieldName',
        'argumentName'
    ],
    DirectiveCoordinate: [
        'name'
    ],
    DirectiveArgumentCoordinate: [
        'name',
        'argumentName'
    ]
};
const $feac916297e0f6f3$var$kindValues = new Set(Object.keys($feac916297e0f6f3$export$4fcd777a40ccf407));
function $feac916297e0f6f3$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === 'string' && $feac916297e0f6f3$var$kindValues.has(maybeKind);
}
/** An identifier in a GraphQL document. */ /**
 * The operation types supported by GraphQL executable definitions.
 * @category Kinds
 */ var $feac916297e0f6f3$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode['QUERY'] = 'query';
    OperationTypeNode['MUTATION'] = 'mutation';
    OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})($feac916297e0f6f3$export$f58c50edb4aef9d4 || ($feac916297e0f6f3$export$f58c50edb4aef9d4 = {}));
 /** A variable declaration in an operation or legacy fragment definition. */ 

/** @category Kinds */ /** The set of allowed kind values for AST nodes. */ var $c9d7601e69c085e8$export$a84bdc57c5122798;
(function(Kind) {
    Kind['NAME'] = 'Name';
    Kind['DOCUMENT'] = 'Document';
    Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
    Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
    Kind['SELECTION_SET'] = 'SelectionSet';
    Kind['FIELD'] = 'Field';
    Kind['ARGUMENT'] = 'Argument';
    Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
    Kind['INLINE_FRAGMENT'] = 'InlineFragment';
    Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
    Kind['VARIABLE'] = 'Variable';
    Kind['INT'] = 'IntValue';
    Kind['FLOAT'] = 'FloatValue';
    Kind['STRING'] = 'StringValue';
    Kind['BOOLEAN'] = 'BooleanValue';
    Kind['NULL'] = 'NullValue';
    Kind['ENUM'] = 'EnumValue';
    Kind['LIST'] = 'ListValue';
    Kind['OBJECT'] = 'ObjectValue';
    Kind['OBJECT_FIELD'] = 'ObjectField';
    Kind['DIRECTIVE'] = 'Directive';
    Kind['NAMED_TYPE'] = 'NamedType';
    Kind['LIST_TYPE'] = 'ListType';
    Kind['NON_NULL_TYPE'] = 'NonNullType';
    Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
    Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
    Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
    Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
    Kind['FIELD_DEFINITION'] = 'FieldDefinition';
    Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
    Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
    Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
    Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
    Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
    Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
    Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
    Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
    Kind['DIRECTIVE_EXTENSION'] = 'DirectiveExtension';
    Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
    Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
    Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
    Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
    Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
    Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
    Kind['TYPE_COORDINATE'] = 'TypeCoordinate';
    Kind['MEMBER_COORDINATE'] = 'MemberCoordinate';
    Kind['ARGUMENT_COORDINATE'] = 'ArgumentCoordinate';
    Kind['DIRECTIVE_COORDINATE'] = 'DirectiveCoordinate';
    Kind['DIRECTIVE_ARGUMENT_COORDINATE'] = 'DirectiveArgumentCoordinate';
})($c9d7601e69c085e8$export$a84bdc57c5122798 || ($c9d7601e69c085e8$export$a84bdc57c5122798 = {}));
 /**
 * Deprecated legacy alias for the enum type representing the possible kind
 * values of AST nodes. This alias will be removed in v17. In v17, `Kind` is
 * exported as the single public symbol for both the runtime object and the
 * corresponding TypeScript type.
 * @deprecated Will be removed in v17. In v17, use `Kind` as both the runtime
 * value and the type.
 */ 

const $5c27cd6fd658cc32$export$a89c95c098ac2a58 = Object.freeze({});
function $5c27cd6fd658cc32$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $feac916297e0f6f3$export$4fcd777a40ccf407)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $c9d7601e69c085e8$export$a84bdc57c5122798)))enterLeaveMap.set(kind, $5c27cd6fd658cc32$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = {
                        ...node
                    };
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $feac916297e0f6f3$export$8ee0fc9ee280b4ee)(node) || (0, $7007d6f1edee536c$export$b6cb5906f04696c8)(false, `Invalid AST Node: ${(0, $1518287c7b4a1333$export$9dec5d1b3b6a130d)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $5c27cd6fd658cc32$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $feac916297e0f6f3$export$8ee0fc9ee280b4ee)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $5c27cd6fd658cc32$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $c9d7601e69c085e8$export$a84bdc57c5122798))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $5c27cd6fd658cc32$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $5c27cd6fd658cc32$export$a89c95c098ac2a58) skipping[i] = $5c27cd6fd658cc32$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $5c27cd6fd658cc32$export$a89c95c098ac2a58) skipping[i] = $5c27cd6fd658cc32$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $5c27cd6fd658cc32$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === 'object') // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === 'function') // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $5c27cd6fd658cc32$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $5c27cd6fd658cc32$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}


function $070763719c7946cb$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    // Build an array of all our fragment definitions that will be used for
    // validations. We also do some validations on the other definitions in the
    // document while building this list.
    var fragments = [];
    document.definitions.forEach(function(definition) {
        // Throw an error if we encounter an operation definition because we will
        // define our own operation definition later on.
        if (definition.kind === "OperationDefinition") throw (0, $c21c2000775800f2$export$3991762405098ea)(112, definition.operation, definition.name ? " named '".concat(definition.name.value, "'") : "");
        // Add our definition to the fragments array if it is a fragment
        // definition.
        if (definition.kind === "FragmentDefinition") fragments.push(definition);
    });
    // If the user did not give us a fragment name then let us try to get a
    // name from a single fragment in the definition.
    if (typeof actualFragmentName === "undefined") {
        (0, $c21c2000775800f2$export$f5708dca728d7177)(fragments.length === 1, 113, fragments.length);
        actualFragmentName = fragments[0].name.value;
    }
    // Generate a query document with an operation that simply spreads the
    // fragment inside of it.
    var query = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, document), {
        definitions: (0, $b8xcN.__spreadArray)([
            {
                kind: "OperationDefinition",
                // OperationTypeNode is an enum
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions, true)
    });
    return query;
}
function $070763719c7946cb$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $070763719c7946cb$export$f80bdb85f299186(selection, fragmentMap) {
    switch(selection.kind){
        case "InlineFragment":
            return selection;
        case "FragmentSpread":
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") return fragmentMap(fragmentName);
            var fragment = fragmentMap && fragmentMap[fragmentName];
            (0, $c21c2000775800f2$export$f5708dca728d7177)(fragment, 114, fragmentName);
            return fragment || null;
        default:
            return null;
    }
}
function $070763719c7946cb$export$5b84f3d7865d4e49(document) {
    var isUnmasked = true;
    (0, $5c27cd6fd658cc32$export$bf638b60ea8b89b7)(document, {
        FragmentSpread: function(node) {
            isUnmasked = !!node.directives && node.directives.some(function(directive) {
                return directive.name.value === "unmask";
            });
            if (!isUnmasked) return 0, $5c27cd6fd658cc32$export$a89c95c098ac2a58;
        }
    });
    return isUnmasked;
}


function $2e667e6fa29c5a74$var$noop() {}
const $2e667e6fa29c5a74$var$defaultDispose = $2e667e6fa29c5a74$var$noop;
const $2e667e6fa29c5a74$var$_WeakRef = typeof WeakRef !== "undefined" ? WeakRef : function(value) {
    return {
        deref: ()=>value
    };
};
const $2e667e6fa29c5a74$var$_WeakMap = typeof WeakMap !== "undefined" ? WeakMap : Map;
const $2e667e6fa29c5a74$var$_FinalizationRegistry = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : function() {
    return {
        register: $2e667e6fa29c5a74$var$noop,
        unregister: $2e667e6fa29c5a74$var$noop
    };
};
const $2e667e6fa29c5a74$var$finalizationBatchSize = 10024;
class $2e667e6fa29c5a74$export$87b462129af3b7d4 {
    constructor(max = Infinity, dispose = $2e667e6fa29c5a74$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new $2e667e6fa29c5a74$var$_WeakMap();
        this.newest = null;
        this.oldest = null;
        this.unfinalizedNodes = new Set();
        this.finalizationScheduled = false;
        this.size = 0;
        this.finalize = ()=>{
            const iterator = this.unfinalizedNodes.values();
            for(let i = 0; i < $2e667e6fa29c5a74$var$finalizationBatchSize; i++){
                const node = iterator.next().value;
                if (!node) break;
                this.unfinalizedNodes.delete(node);
                const key = node.key;
                delete node.key;
                node.keyRef = new $2e667e6fa29c5a74$var$_WeakRef(key);
                this.registry.register(key, node, node);
            }
            if (this.unfinalizedNodes.size > 0) queueMicrotask(this.finalize);
            else this.finalizationScheduled = false;
        };
        this.registry = new $2e667e6fa29c5a74$var$_FinalizationRegistry(this.deleteNode.bind(this));
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.scheduleFinalization(node);
        this.map.set(key, node);
        this.size++;
        return node.value;
    }
    clean() {
        while(this.oldest && this.size > this.max)this.deleteNode(this.oldest);
    }
    deleteNode(node) {
        if (node === this.newest) this.newest = node.older;
        if (node === this.oldest) this.oldest = node.newer;
        if (node.newer) node.newer.older = node.older;
        if (node.older) node.older.newer = node.newer;
        this.size--;
        const key = node.key || node.keyRef && node.keyRef.deref();
        this.dispose(node.value, key);
        if (!node.keyRef) this.unfinalizedNodes.delete(node);
        else this.registry.unregister(node);
        if (key) this.map.delete(key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            this.deleteNode(node);
            return true;
        }
        return false;
    }
    scheduleFinalization(node) {
        this.unfinalizedNodes.add(node);
        if (!this.finalizationScheduled) {
            this.finalizationScheduled = true;
            queueMicrotask(this.finalize);
        }
    }
}


var $cee967300b629dc7$var$scheduledCleanup = new WeakSet();
function $cee967300b629dc7$var$schedule(cache) {
    if (cache.size <= (cache.max || -1)) return;
    if (!$cee967300b629dc7$var$scheduledCleanup.has(cache)) {
        $cee967300b629dc7$var$scheduledCleanup.add(cache);
        setTimeout(function() {
            cache.clean();
            $cee967300b629dc7$var$scheduledCleanup.delete(cache);
        }, 100);
    }
}
var $cee967300b629dc7$export$8dbad6f439bb2331 = function(max, dispose) {
    /*
    Some builds of `WeakCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $2e667e6fa29c5a74$export$87b462129af3b7d4)(max, dispose);
    cache.set = function(key, value) {
        var ret = (0, $2e667e6fa29c5a74$export$87b462129af3b7d4).prototype.set.call(this, key, value);
        $cee967300b629dc7$var$schedule(this);
        return ret;
    };
    return cache;
};
var $cee967300b629dc7$export$5b4f745137d91413 = function(max, dispose) {
    /*
    Some builds of `StrongCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $aad0ecaed80ca32e$export$d3a0331d2c286dc8)(max, dispose);
    cache.set = function(key, value) {
        var ret = (0, $aad0ecaed80ca32e$export$d3a0331d2c286dc8).prototype.set.call(this, key, value);
        $cee967300b629dc7$var$schedule(this);
        return ret;
    };
    return cache;
};


var $b8xcN = parcelRequire("b8xcN");

var $d301603631c7863b$var$cacheSizeSymbol = Symbol.for("apollo.cacheSize");
var $d301603631c7863b$export$f29926b23b28936b = (0, $b8xcN.__assign)({}, (0, $5b81337c038bdc28$export$2e2bcd8739ae039)[$d301603631c7863b$var$cacheSizeSymbol]);



var $b8xcN = parcelRequire("b8xcN");

var $afbf6f02b98da1f0$var$globalCaches = {};
function $afbf6f02b98da1f0$export$a8fcd406d9e37621(name, getSize) {
    $afbf6f02b98da1f0$var$globalCaches[name] = getSize;
}
var $afbf6f02b98da1f0$export$dfdba94ce46d2ea5 = globalThis.__DEV__ !== false ? $afbf6f02b98da1f0$var$_getApolloClientMemoryInternals : undefined;
var $afbf6f02b98da1f0$export$e95a5a2210e62466 = globalThis.__DEV__ !== false ? $afbf6f02b98da1f0$var$_getInMemoryCacheMemoryInternals : undefined;
var $afbf6f02b98da1f0$export$e7ed438e82606689 = globalThis.__DEV__ !== false ? $afbf6f02b98da1f0$var$_getApolloCacheMemoryInternals : undefined;
function $afbf6f02b98da1f0$var$getCurrentCacheSizes() {
    // `defaultCacheSizes` is a `const enum` that will be inlined during build, so we have to reconstruct it's shape here
    var defaults = {
        parser: 1000 /* defaultCacheSizes["parser"] */ ,
        canonicalStringify: 1000 /* defaultCacheSizes["canonicalStringify"] */ ,
        print: 2000 /* defaultCacheSizes["print"] */ ,
        "documentTransform.cache": 2000 /* defaultCacheSizes["documentTransform.cache"] */ ,
        "queryManager.getDocumentInfo": 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ ,
        "PersistedQueryLink.persistedQueryHashes": 2000 /* defaultCacheSizes["PersistedQueryLink.persistedQueryHashes"] */ ,
        "fragmentRegistry.transform": 2000 /* defaultCacheSizes["fragmentRegistry.transform"] */ ,
        "fragmentRegistry.lookup": 1000 /* defaultCacheSizes["fragmentRegistry.lookup"] */ ,
        "fragmentRegistry.findFragmentSpreads": 4000 /* defaultCacheSizes["fragmentRegistry.findFragmentSpreads"] */ ,
        "cache.fragmentQueryDocuments": 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
        "removeTypenameFromVariables.getVariableDefinitions": 2000 /* defaultCacheSizes["removeTypenameFromVariables.getVariableDefinitions"] */ ,
        "inMemoryCache.maybeBroadcastWatch": 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
        "inMemoryCache.executeSelectionSet": 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
        "inMemoryCache.executeSubSelectedArray": 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ 
    };
    return Object.fromEntries(Object.entries(defaults).map(function(_a) {
        var k = _a[0], v = _a[1];
        return [
            k,
            (0, $d301603631c7863b$export$f29926b23b28936b)[k] || v
        ];
    }));
}
function $afbf6f02b98da1f0$var$_getApolloClientMemoryInternals() {
    var _a, _b, _c, _d, _e;
    if (!(globalThis.__DEV__ !== false)) throw new Error("only supported in development mode");
    return {
        limits: $afbf6f02b98da1f0$var$getCurrentCacheSizes(),
        sizes: (0, $b8xcN.__assign)({
            print: (_a = $afbf6f02b98da1f0$var$globalCaches.print) === null || _a === void 0 ? void 0 : _a.call($afbf6f02b98da1f0$var$globalCaches),
            parser: (_b = $afbf6f02b98da1f0$var$globalCaches.parser) === null || _b === void 0 ? void 0 : _b.call($afbf6f02b98da1f0$var$globalCaches),
            canonicalStringify: (_c = $afbf6f02b98da1f0$var$globalCaches.canonicalStringify) === null || _c === void 0 ? void 0 : _c.call($afbf6f02b98da1f0$var$globalCaches),
            links: $afbf6f02b98da1f0$var$linkInfo(this.link),
            queryManager: {
                getDocumentInfo: this["queryManager"]["transformCache"].size,
                documentTransforms: $afbf6f02b98da1f0$var$transformInfo(this["queryManager"].documentTransform)
            }
        }, (_e = (_d = this.cache).getMemoryInternals) === null || _e === void 0 ? void 0 : _e.call(_d))
    };
}
function $afbf6f02b98da1f0$var$_getApolloCacheMemoryInternals() {
    return {
        cache: {
            fragmentQueryDocuments: $afbf6f02b98da1f0$var$getWrapperInformation(this["getFragmentDoc"])
        }
    };
}
function $afbf6f02b98da1f0$var$_getInMemoryCacheMemoryInternals() {
    var fragments = this.config.fragments;
    return (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, $afbf6f02b98da1f0$var$_getApolloCacheMemoryInternals.apply(this)), {
        addTypenameDocumentTransform: $afbf6f02b98da1f0$var$transformInfo(this["addTypenameTransform"]),
        inMemoryCache: {
            executeSelectionSet: $afbf6f02b98da1f0$var$getWrapperInformation(this["storeReader"]["executeSelectionSet"]),
            executeSubSelectedArray: $afbf6f02b98da1f0$var$getWrapperInformation(this["storeReader"]["executeSubSelectedArray"]),
            maybeBroadcastWatch: $afbf6f02b98da1f0$var$getWrapperInformation(this["maybeBroadcastWatch"])
        },
        fragmentRegistry: {
            findFragmentSpreads: $afbf6f02b98da1f0$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.findFragmentSpreads),
            lookup: $afbf6f02b98da1f0$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.lookup),
            transform: $afbf6f02b98da1f0$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.transform)
        }
    });
}
function $afbf6f02b98da1f0$var$isWrapper(f) {
    return !!f && "dirtyKey" in f;
}
function $afbf6f02b98da1f0$var$getWrapperInformation(f) {
    return $afbf6f02b98da1f0$var$isWrapper(f) ? f.size : undefined;
}
function $afbf6f02b98da1f0$var$isDefined(value) {
    return value != null;
}
function $afbf6f02b98da1f0$var$transformInfo(transform) {
    return $afbf6f02b98da1f0$var$recurseTransformInfo(transform).map(function(cache) {
        return {
            cache: cache
        };
    });
}
function $afbf6f02b98da1f0$var$recurseTransformInfo(transform) {
    return transform ? (0, $b8xcN.__spreadArray)((0, $b8xcN.__spreadArray)([
        $afbf6f02b98da1f0$var$getWrapperInformation(transform === null || transform === void 0 ? void 0 : transform["performWork"])
    ], $afbf6f02b98da1f0$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["left"]), true), $afbf6f02b98da1f0$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["right"]), true).filter($afbf6f02b98da1f0$var$isDefined) : [];
}
function $afbf6f02b98da1f0$var$linkInfo(link) {
    var _a;
    return link ? (0, $b8xcN.__spreadArray)((0, $b8xcN.__spreadArray)([
        (_a = link === null || link === void 0 ? void 0 : link.getMemoryInternals) === null || _a === void 0 ? void 0 : _a.call(link)
    ], $afbf6f02b98da1f0$var$linkInfo(link === null || link === void 0 ? void 0 : link.left), true), $afbf6f02b98da1f0$var$linkInfo(link === null || link === void 0 ? void 0 : link.right), true).filter($afbf6f02b98da1f0$var$isDefined) : [];
}


var $e3e8d305ba8d539e$export$88a0ad9b6f961b51 = Object.assign(function canonicalStringify(value) {
    return JSON.stringify(value, $e3e8d305ba8d539e$var$stableObjectReplacer);
}, {
    reset: function() {
        // Clearing the sortingMap will reclaim all cached memory, without
        // affecting the logical results of canonicalStringify, but potentially
        // sacrificing performance until the cache is refilled.
        $e3e8d305ba8d539e$var$sortingMap = new (0, $cee967300b629dc7$export$5b4f745137d91413)((0, $d301603631c7863b$export$f29926b23b28936b).canonicalStringify || 1000 /* defaultCacheSizes.canonicalStringify */ );
    }
});
if (globalThis.__DEV__ !== false) (0, $afbf6f02b98da1f0$export$a8fcd406d9e37621)("canonicalStringify", function() {
    return $e3e8d305ba8d539e$var$sortingMap.size;
});
// Values are JSON-serialized arrays of object keys (in any order), and values
// are sorted arrays of the same keys.
var $e3e8d305ba8d539e$var$sortingMap;
$e3e8d305ba8d539e$export$88a0ad9b6f961b51.reset();
// The JSON.stringify function takes an optional second argument called a
// replacer function. This function is called for each key-value pair in the
// object being stringified, and its return value is used instead of the
// original value. If the replacer function returns a new value, that value is
// stringified as JSON instead of the original value of the property.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#the_replacer_parameter
function $e3e8d305ba8d539e$var$stableObjectReplacer(key, value) {
    if (value && typeof value === "object") {
        var proto = Object.getPrototypeOf(value);
        // We don't want to mess with objects that are not "plain" objects, which
        // means their prototype is either Object.prototype or null. This check also
        // prevents needlessly rearranging the indices of arrays.
        if (proto === Object.prototype || proto === null) {
            var keys = Object.keys(value);
            // If keys is already sorted, let JSON.stringify serialize the original
            // value instead of creating a new object with keys in the same order.
            if (keys.every($e3e8d305ba8d539e$var$everyKeyInOrder)) return value;
            var unsortedKey = JSON.stringify(keys);
            var sortedKeys = $e3e8d305ba8d539e$var$sortingMap.get(unsortedKey);
            if (!sortedKeys) {
                keys.sort();
                var sortedKey = JSON.stringify(keys);
                // Checking for sortedKey in the sortingMap allows us to share the same
                // sorted array reference for all permutations of the same set of keys.
                sortedKeys = $e3e8d305ba8d539e$var$sortingMap.get(sortedKey) || keys;
                $e3e8d305ba8d539e$var$sortingMap.set(unsortedKey, sortedKeys);
                $e3e8d305ba8d539e$var$sortingMap.set(sortedKey, sortedKeys);
            }
            var sortedObject_1 = Object.create(proto);
            // Reassigning the keys in sorted order will cause JSON.stringify to
            // serialize them in sorted order.
            sortedKeys.forEach(function(key) {
                sortedObject_1[key] = value[key];
            });
            return sortedObject_1;
        }
    }
    return value;
}
// Since everything that happens in stableObjectReplacer benefits from being as
// efficient as possible, we use a static function as the callback for
// keys.every in order to test if the provided keys are already sorted without
// allocating extra memory for a callback.
function $e3e8d305ba8d539e$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}


function $6ee6592fd95fa693$export$634ae0e932e9be99(id) {
    return {
        __ref: String(id)
    };
}
function $6ee6592fd95fa693$export$fa99cac1c0883c47(obj) {
    return Boolean(obj && typeof obj === "object" && typeof obj.__ref === "string");
}
function $6ee6592fd95fa693$export$540432d49fcec6c9(value) {
    return (0, $01d0d880754ccbd1$export$417207af72fad9c9)(value) && value.kind === "Document" && Array.isArray(value.definitions);
}
function $6ee6592fd95fa693$var$isStringValue(value) {
    return value.kind === "StringValue";
}
function $6ee6592fd95fa693$var$isBooleanValue(value) {
    return value.kind === "BooleanValue";
}
function $6ee6592fd95fa693$var$isIntValue(value) {
    return value.kind === "IntValue";
}
function $6ee6592fd95fa693$var$isFloatValue(value) {
    return value.kind === "FloatValue";
}
function $6ee6592fd95fa693$var$isVariable(value) {
    return value.kind === "Variable";
}
function $6ee6592fd95fa693$var$isObjectValue(value) {
    return value.kind === "ObjectValue";
}
function $6ee6592fd95fa693$var$isListValue(value) {
    return value.kind === "ListValue";
}
function $6ee6592fd95fa693$var$isEnumValue(value) {
    return value.kind === "EnumValue";
}
function $6ee6592fd95fa693$var$isNullValue(value) {
    return value.kind === "NullValue";
}
function $6ee6592fd95fa693$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($6ee6592fd95fa693$var$isIntValue(value) || $6ee6592fd95fa693$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($6ee6592fd95fa693$var$isBooleanValue(value) || $6ee6592fd95fa693$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($6ee6592fd95fa693$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $6ee6592fd95fa693$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($6ee6592fd95fa693$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($6ee6592fd95fa693$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $6ee6592fd95fa693$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($6ee6592fd95fa693$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($6ee6592fd95fa693$var$isNullValue(value)) argObj[name.value] = null;
    else throw (0, $c21c2000775800f2$export$3991762405098ea)(123, name.value, value.kind);
}
function $6ee6592fd95fa693$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $6ee6592fd95fa693$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $6ee6592fd95fa693$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $6ee6592fd95fa693$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $6ee6592fd95fa693$var$KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export",
    "nonreactive"
];
// Default stable JSON.stringify implementation used by getStoreKeyName. Can be
// updated/replaced with something better by calling
// getStoreKeyName.setStringify(newStringifyFunction).
var $6ee6592fd95fa693$var$storeKeyNameStringify = (0, $e3e8d305ba8d539e$export$88a0ad9b6f961b51);
var $6ee6592fd95fa693$export$3cdb6c178b88cabe = Object.assign(function(fieldName, args, directives) {
    if (args && directives && directives["connection"] && directives["connection"]["key"]) {
        if (directives["connection"]["filter"] && directives["connection"]["filter"].length > 0) {
            var filterKeys = directives["connection"]["filter"] ? directives["connection"]["filter"] : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives["connection"]["key"], "(").concat($6ee6592fd95fa693$var$storeKeyNameStringify(filteredArgs_1), ")");
        } else return directives["connection"]["key"];
    }
    var completeFieldName = fieldName;
    if (args) {
        // We can't use `JSON.stringify` here since it's non-deterministic,
        // and can lead to different store key names being created even though
        // the `args` object used during creation has the same properties/values.
        var stringifiedArgs = $6ee6592fd95fa693$var$storeKeyNameStringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($6ee6592fd95fa693$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@".concat(key, "(").concat($6ee6592fd95fa693$var$storeKeyNameStringify(directives[key]), ")");
        else completeFieldName += "@".concat(key);
    });
    return completeFieldName;
}, {
    setStringify: function(s) {
        var previous = $6ee6592fd95fa693$var$storeKeyNameStringify;
        $6ee6592fd95fa693$var$storeKeyNameStringify = s;
        return previous;
    }
});
function $6ee6592fd95fa693$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $6ee6592fd95fa693$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $6ee6592fd95fa693$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $6ee6592fd95fa693$export$cf7bf7e4f289cc26(result, selectionSet, fragmentMap) {
    var fragments;
    for(var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++){
        var selection = _a[_i];
        if ($6ee6592fd95fa693$export$fb56ad75dd311c12(selection)) {
            if (selection.name.value === "__typename") return result[$6ee6592fd95fa693$export$7d1ad22471852218(selection)];
        } else if (fragments) fragments.push(selection);
        else fragments = [
            selection
        ];
    }
    if (typeof result.__typename === "string") return result.__typename;
    if (fragments) for(var _b = 0, fragments_1 = fragments; _b < fragments_1.length; _b++){
        var selection = fragments_1[_b];
        var typename = $6ee6592fd95fa693$export$cf7bf7e4f289cc26(result, (0, $070763719c7946cb$export$f80bdb85f299186)(selection, fragmentMap).selectionSet, fragmentMap);
        if (typeof typename === "string") return typename;
    }
}
function $6ee6592fd95fa693$export$fb56ad75dd311c12(selection) {
    return selection.kind === "Field";
}
function $6ee6592fd95fa693$export$22a1cdafaf27bcff(selection) {
    return selection.kind === "InlineFragment";
}


function $6d75937eba8e6f1c$export$a7d0d8111d2386df(doc) {
    (0, $c21c2000775800f2$export$f5708dca728d7177)(doc && doc.kind === "Document", 115);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== "FragmentDefinition";
    }).map(function(definition) {
        if (definition.kind !== "OperationDefinition") throw (0, $c21c2000775800f2$export$3991762405098ea)(116, definition.kind);
        return definition;
    });
    (0, $c21c2000775800f2$export$f5708dca728d7177)(operations.length <= 1, 117, operations.length);
    return doc;
}
function $6d75937eba8e6f1c$export$7a5b1fa979d2c158(doc) {
    $6d75937eba8e6f1c$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition";
    })[0];
}
function $6d75937eba8e6f1c$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition" && !!definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $6d75937eba8e6f1c$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "FragmentDefinition";
    });
}
function $6d75937eba8e6f1c$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $6d75937eba8e6f1c$export$7a5b1fa979d2c158(doc);
    (0, $c21c2000775800f2$export$f5708dca728d7177)(queryDef && queryDef.operation === "query", 118);
    return queryDef;
}
function $6d75937eba8e6f1c$export$772111caef41b3f5(doc) {
    (0, $c21c2000775800f2$export$f5708dca728d7177)(doc.kind === "Document", 119);
    (0, $c21c2000775800f2$export$f5708dca728d7177)(doc.definitions.length <= 1, 120);
    var fragmentDef = doc.definitions[0];
    (0, $c21c2000775800f2$export$f5708dca728d7177)(fragmentDef.kind === "FragmentDefinition", 121);
    return fragmentDef;
}
function $6d75937eba8e6f1c$export$f431198736b7f96d(queryDoc) {
    $6d75937eba8e6f1c$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === "OperationDefinition") {
            var operation = definition.operation;
            if (operation === "query" || operation === "mutation" || operation === "subscription") return definition;
        }
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) // we do this because we want to allow multiple fragment definitions
        // to precede an operation definition.
        fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw (0, $c21c2000775800f2$export$3991762405098ea)(122);
}
function $6d75937eba8e6f1c$export$84c19026e616569e(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) defs.forEach(function(def) {
        if (def.defaultValue) (0, $6ee6592fd95fa693$export$a1dab82d368d6525)(defaultValues, def.variable.name, def.defaultValue);
    });
    return defaultValues;
}

/**
 * @deprecated `iterateObserversSafely` will be removed with Apollo Client 4.0.
 * Please discontinue using this function.
 */ function $16482974f2c55194$export$9f6c99ae166dbeca(observers, method, argument) {
    // In case observers is modified during iteration, we need to commit to the
    // original elements, which also provides an opportunity to filter them down
    // to just the observers with the given method.
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}

function $2227596139f6216d$export$7ff41c6e01127226(promise) {
    promise.catch(function() {});
    return promise;
}




var $b8xcN = parcelRequire("b8xcN");



function $5a6e90bd3aec77b4$export$3dc388a5f013b4a5(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) return true;
    return $5a6e90bd3aec77b4$export$b7bdffb7e6f1ef53(directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === "Variable") {
            evaledValue = variables && variables[ifArgument.value.name.value];
            (0, $c21c2000775800f2$export$f5708dca728d7177)(evaledValue !== void 0, 105, directive.name.value);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === "skip" ? !evaledValue : evaledValue;
    });
}
function $5a6e90bd3aec77b4$export$1b217de6ce18b9a(root) {
    var names = [];
    (0, $5c27cd6fd658cc32$export$bf638b60ea8b89b7)(root, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
var $5a6e90bd3aec77b4$export$528b5e7d8ba07fbf = function(names, root) {
    return $5a6e90bd3aec77b4$export$2dafb573e282fe8d(names, root, false);
};
var $5a6e90bd3aec77b4$export$ad1b63b26c1a9b76 = function(names, root) {
    return $5a6e90bd3aec77b4$export$2dafb573e282fe8d(names, root, true);
};
function $5a6e90bd3aec77b4$export$2dafb573e282fe8d(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    (0, $5c27cd6fd658cc32$export$bf638b60ea8b89b7)(root, {
        Directive: function(node) {
            if (nameSet.delete(node.name.value) && (!all || !nameSet.size)) return 0, $5c27cd6fd658cc32$export$a89c95c098ac2a58;
        }
    });
    // If we found all the names, nameSet will be empty. If we only care about
    // finding some of them, the < condition is sufficient.
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function $5a6e90bd3aec77b4$export$8d1e9e5bbfa5d09a(document) {
    return document && $5a6e90bd3aec77b4$export$2dafb573e282fe8d([
        "client",
        "export"
    ], document, true);
}
function $5a6e90bd3aec77b4$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === "skip" || value === "include";
}
function $5a6e90bd3aec77b4$export$b7bdffb7e6f1ef53(directives) {
    var result = [];
    if (directives && directives.length) directives.forEach(function(directive) {
        if (!$5a6e90bd3aec77b4$var$isInclusionDirective(directive)) return;
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $c21c2000775800f2$export$f5708dca728d7177)(directiveArguments && directiveArguments.length === 1, 106, directiveName);
        var ifArgument = directiveArguments[0];
        (0, $c21c2000775800f2$export$f5708dca728d7177)(ifArgument.name && ifArgument.name.value === "if", 107, directiveName);
        var ifValue = ifArgument.value;
        // means it has to be a variable value if this is a valid @skip or @include directive
        (0, $c21c2000775800f2$export$f5708dca728d7177)(ifValue && (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 108, directiveName);
        result.push({
            directive: directive,
            ifArgument: ifArgument
        });
    });
    return result;
}
function $5a6e90bd3aec77b4$export$d6913ace4214003(fragment) {
    var _a, _b;
    var directive = (_a = fragment.directives) === null || _a === void 0 ? void 0 : _a.find(function(_a) {
        var name = _a.name;
        return name.value === "unmask";
    });
    if (!directive) return "mask";
    var modeArg = (_b = directive.arguments) === null || _b === void 0 ? void 0 : _b.find(function(_a) {
        var name = _a.name;
        return name.value === "mode";
    });
    if (globalThis.__DEV__ !== false) {
        if (modeArg) {
            if (modeArg.value.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).VARIABLE) globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(109);
            else if (modeArg.value.kind !== (0, $c9d7601e69c085e8$export$a84bdc57c5122798).STRING) globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(110);
            else if (modeArg.value.value !== "migrate") globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(111, modeArg.value.value);
        }
    }
    if (modeArg && "value" in modeArg.value && modeArg.value.value === "migrate") return "migrate";
    return "unmask";
}


function $c138ca7e3590aefa$export$5e40714c5ad44445(query, _a, _b, variables) {
    var aData = _a.data, aRest = (0, $b8xcN.__rest)(_a, [
        "data"
    ]);
    var bData = _b.data, bRest = (0, $b8xcN.__rest)(_b, [
        "data"
    ]);
    return (0, $b59b67a8b7fe71c2$export$2e2bcd8739ae039)(aRest, bRest) && $c138ca7e3590aefa$var$equalBySelectionSet((0, $6d75937eba8e6f1c$export$f431198736b7f96d)(query).selectionSet, aData, bData, {
        fragmentMap: (0, $070763719c7946cb$export$193789b4c8246dd4)((0, $6d75937eba8e6f1c$export$5320a7ba9466a3df)(query)),
        variables: variables
    });
}
function $c138ca7e3590aefa$var$equalBySelectionSet(selectionSet, aResult, bResult, context) {
    if (aResult === bResult) return true;
    var seenSelections = new Set();
    // Returning true from this Array.prototype.every callback function skips the
    // current field/subtree. Returning false aborts the entire traversal
    // immediately, causing equalBySelectionSet to return false.
    return selectionSet.selections.every(function(selection) {
        // Avoid re-processing the same selection at the same level of recursion, in
        // case the same field gets included via multiple indirect fragment spreads.
        if (seenSelections.has(selection)) return true;
        seenSelections.add(selection);
        // Ignore @skip(if: true) and @include(if: false) fields.
        if (!(0, $5a6e90bd3aec77b4$export$3dc388a5f013b4a5)(selection, context.variables)) return true;
        // If the field or (named) fragment spread has a @nonreactive directive on
        // it, we don't care if it's different, so we pretend it's the same.
        if ($c138ca7e3590aefa$var$selectionHasNonreactiveDirective(selection)) return true;
        if ((0, $6ee6592fd95fa693$export$fb56ad75dd311c12)(selection)) {
            var resultKey = (0, $6ee6592fd95fa693$export$7d1ad22471852218)(selection);
            var aResultChild = aResult && aResult[resultKey];
            var bResultChild = bResult && bResult[resultKey];
            var childSelectionSet = selection.selectionSet;
            if (!childSelectionSet) // These are scalar values, so we can compare them with deep equal
            // without redoing the main recursive work.
            return (0, $b59b67a8b7fe71c2$export$2e2bcd8739ae039)(aResultChild, bResultChild);
            var aChildIsArray = Array.isArray(aResultChild);
            var bChildIsArray = Array.isArray(bResultChild);
            if (aChildIsArray !== bChildIsArray) return false;
            if (aChildIsArray && bChildIsArray) {
                var length_1 = aResultChild.length;
                if (bResultChild.length !== length_1) return false;
                for(var i = 0; i < length_1; ++i){
                    if (!$c138ca7e3590aefa$var$equalBySelectionSet(childSelectionSet, aResultChild[i], bResultChild[i], context)) return false;
                }
                return true;
            }
            return $c138ca7e3590aefa$var$equalBySelectionSet(childSelectionSet, aResultChild, bResultChild, context);
        } else {
            var fragment = (0, $070763719c7946cb$export$f80bdb85f299186)(selection, context.fragmentMap);
            if (fragment) {
                // The fragment might === selection if it's an inline fragment, but
                // could be !== if it's a named fragment ...spread.
                if ($c138ca7e3590aefa$var$selectionHasNonreactiveDirective(fragment)) return true;
                return $c138ca7e3590aefa$var$equalBySelectionSet(fragment.selectionSet, // Notice that we reuse the same aResult and bResult values here,
                // since the fragment ...spread does not specify a field name, but
                // consists of multiple fields (within the fragment's selection set)
                // that should be applied to the current result value(s).
                aResult, bResult, context);
            }
        }
    });
}
function $c138ca7e3590aefa$var$selectionHasNonreactiveDirective(selection) {
    return !!selection.directives && selection.directives.some($c138ca7e3590aefa$var$directiveIsNonreactive);
}
function $c138ca7e3590aefa$var$directiveIsNonreactive(dir) {
    return dir.name.value === "nonreactive";
}



var $d0d4a90bb058cbe1$var$assign = Object.assign, $d0d4a90bb058cbe1$var$hasOwnProperty = Object.hasOwnProperty;
var $d0d4a90bb058cbe1$export$6c1b56eac59c9584 = /** @class */ function(_super) {
    (0, $b8xcN.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = this;
        var startedInactive = ObservableQuery.inactiveOnCreation.getValue();
        _this = _super.call(this, function(observer) {
            _this._getOrCreateQuery();
            // Zen Observable has its own error function, so in order to log correctly
            // we need to provide a custom error callback.
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) subObserver.error = $d0d4a90bb058cbe1$var$defaultSubscriptionObserverErrorCallback;
            } catch (_a) {}
            var first = !_this.observers.size;
            _this.observers.add(observer);
            // Deliver most recent error or result.
            var last = _this.last;
            if (last && last.error) observer.error && observer.error(last.error);
            else if (last && last.result) observer.next && observer.next(_this.maskResult(last.result));
            // Initiate observation of this query if it hasn't been reported to
            // the QueryManager yet.
            if (first) // Blindly catching here prevents unhandled promise rejections,
            // and is safe because the ObservableQuery handles this error with
            // this.observer.error, so we're not just swallowing the error by
            // ignoring it here.
            _this.reobserve().catch(function() {});
            return function() {
                if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.dirty = false;
        _this._getOrCreateQuery = function() {
            if (startedInactive) {
                queryManager["queries"].set(_this.queryId, queryInfo);
                startedInactive = false;
            }
            return _this.queryManager.getOrCreateQuery(_this.queryId);
        };
        // related classes
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        // active state
        _this.waitForOwnResult = $d0d4a90bb058cbe1$var$skipCacheDataFor(options.fetchPolicy);
        _this.isTornDown = false;
        _this.subscribeToMore = _this.subscribeToMore.bind(_this);
        _this.maskResult = _this.maskResult.bind(_this);
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, // Make sure we don't store "standby" as the initialFetchPolicy.
        _f = options.initialFetchPolicy, // Make sure we don't store "standby" as the initialFetchPolicy.
        initialFetchPolicy = _f === void 0 ? fetchPolicy === "standby" ? defaultFetchPolicy : fetchPolicy : _f;
        _this.options = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, options), {
            // Remember the initial options.fetchPolicy so we can revert back to this
            // policy when variables change. This information can also be specified
            // (or overridden) by providing options.initialFetchPolicy explicitly.
            initialFetchPolicy: initialFetchPolicy,
            // This ensures this.options.fetchPolicy always has a string value, in
            // case options.fetchPolicy was not provided.
            fetchPolicy: fetchPolicy
        });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = (0, $6d75937eba8e6f1c$export$7a5b1fa979d2c158)(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        // The `query` computed property will always reflect the document transformed
        // by the last run query. `this.options.query` will always reflect the raw
        // untransformed query to ensure document transforms with runtime conditionals
        // are run on the original document.
        get: function() {
            return this.lastQuery || this.options.query;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        // Computed shorthand for this.options.variables, preserved for
        // backwards compatibility.
        /**
         * An object containing the variables that were provided for the query.
         */ get: function() {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @deprecated `result` will be removed in Apollo Client 4.0.
     *
     * **Recommended now**
     *
     * If you continue to need this functionality, subscribe to `ObservableQuery`
     * to get the first value emitted from the observable, then immediately unsubscribe.
     *
     * **When upgrading**
     *
     * Use RxJS's [`firstResultFrom`](https://rxjs.dev/api/index/function/firstValueFrom) function to mimic this functionality.
     *
     * ```ts
     * const result = await firstValueFrom(from(observableQuery));
     * ```
     */ ObservableQuery.prototype.result = function() {
        var _this = this;
        if (globalThis.__DEV__ !== false) (0, $14465ad01ccc354a$export$606a5c06d13e04b6)("observableQuery.result", function() {
            globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(23);
        });
        return new Promise(function(resolve, reject) {
            // TODO: this code doesn’t actually make sense insofar as the observer
            // will never exist in this.observers due how zen-observable wraps observables.
            // https://github.com/zenparsing/zen-observable/blob/master/src/Observable.js#L169
            var observer = {
                next: function(result) {
                    resolve(result);
                    // Stop the query within the QueryManager if we can before
                    // this function returns.
                    //
                    // We do this in order to prevent observers piling up within
                    // the QueryManager. Notice that we only fully unsubscribe
                    // from the subscription in a setTimeout(..., 0)  call. This call can
                    // actually be handled by the browser at a much later time. If queries
                    // are fired in the meantime, observers that should have been removed
                    // from the QueryManager will continue to fire, causing an unnecessary
                    // performance hit.
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    /** @internal */ ObservableQuery.prototype.resetDiff = function() {
        this.queryInfo.resetDiff();
    };
    ObservableQuery.prototype.getCurrentFullResult = function(saveAsLastResult) {
        var _this = this;
        if (saveAsLastResult === void 0) saveAsLastResult = true;
        // Use the last result as long as the variables match this.variables.
        var lastResult = (0, $14465ad01ccc354a$export$d18d1529326946c4)("getLastResult", function() {
            return _this.getLastResult(true);
        });
        var networkStatus = this.queryInfo.networkStatus || lastResult && lastResult.networkStatus || (0, $7f070805c91ccc41$export$bd096ddbd246c79c).ready;
        var result = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, lastResult), {
            loading: (0, $7f070805c91ccc41$export$37509604341a3464)(networkStatus),
            networkStatus: networkStatus
        });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (// These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        $d0d4a90bb058cbe1$var$skipCacheDataFor(fetchPolicy) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers) ;
        else if (this.waitForOwnResult) // This would usually be a part of `QueryInfo.getDiff()`.
        // which we skip in the waitForOwnResult case since we are not
        // interested in the diff.
        this.queryInfo["updateWatch"]();
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) result.data = diff.result;
            if ((0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(result.data, {})) result.data = void 0;
            if (diff.complete) {
                // Similar to setting result.partial to false, but taking advantage of the
                // falsiness of missing fields.
                delete result.partial;
                // If the diff is complete, and we're using a FetchPolicy that
                // terminates after a complete cache read, we can assume the next result
                // we receive will have NetworkStatus.ready and !loading.
                if (diff.complete && result.networkStatus === (0, $7f070805c91ccc41$export$bd096ddbd246c79c).loading && (fetchPolicy === "cache-first" || fetchPolicy === "cache-only")) {
                    result.networkStatus = (0, $7f070805c91ccc41$export$bd096ddbd246c79c).ready;
                    result.loading = false;
                }
            } else result.partial = true;
            // We need to check for both both `error` and `errors` field because there
            // are cases where sometimes `error` is set, but not `errors` and
            // vice-versa. This will be updated in the next major version when
            // `errors` is deprecated in favor of `error`.
            if (result.networkStatus === (0, $7f070805c91ccc41$export$bd096ddbd246c79c).ready && (result.error || result.errors)) result.networkStatus = (0, $7f070805c91ccc41$export$bd096ddbd246c79c).error;
            if (globalThis.__DEV__ !== false && !diff.complete && !this.options.partialRefetch && !result.loading && !result.data && !result.error) $d0d4a90bb058cbe1$export$b7e1973aacac3ae7(diff.missing);
        }
        if (saveAsLastResult) this.updateLastResult(result);
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function(saveAsLastResult) {
        if (saveAsLastResult === void 0) saveAsLastResult = true;
        return this.maskResult(this.getCurrentFullResult(saveAsLastResult));
    };
    // Compares newResult to the snapshot we took of this.lastResult when it was
    // first received.
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult, variables) {
        if (!this.last) return true;
        var documentInfo = this.queryManager.getDocumentInfo(this.query);
        var dataMasking = this.queryManager.dataMasking;
        var query = dataMasking ? documentInfo.nonReactiveQuery : this.query;
        var resultIsDifferent = dataMasking || documentInfo.hasNonreactiveDirective ? !(0, $c138ca7e3590aefa$export$5e40714c5ad44445)(query, this.last.result, newResult, this.variables) : !(0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(this.last.result, newResult);
        return resultIsDifferent || variables && !(0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(this.last.variables, variables);
    };
    ObservableQuery.prototype.getLast = function(key, variablesMustMatch) {
        var last = this.last;
        if (last && last[key] && (!variablesMustMatch || (0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(last.variables, this.variables))) return last[key];
    };
    /**
     * @deprecated `getLastResult` will be removed in Apollo Client 4.0. Please
     * discontinue using this method.
     */ ObservableQuery.prototype.getLastResult = function(variablesMustMatch) {
        if (globalThis.__DEV__ !== false) (0, $14465ad01ccc354a$export$606a5c06d13e04b6)("getLastResult", function() {
            globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(24);
        });
        return this.getLast("result", variablesMustMatch);
    };
    /**
     * @deprecated `getLastError` will be removed in Apollo Client 4.0. Please
     * discontinue using this method.
     */ ObservableQuery.prototype.getLastError = function(variablesMustMatch) {
        if (globalThis.__DEV__ !== false) (0, $14465ad01ccc354a$export$606a5c06d13e04b6)("getLastError", function() {
            globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(25);
        });
        return this.getLast("error", variablesMustMatch);
    };
    /**
     * @deprecated `resetLastResults` will be removed in Apollo Client 4.0. Please
     * discontinue using this method.
     */ ObservableQuery.prototype.resetLastResults = function() {
        if (globalThis.__DEV__ !== false) (0, $14465ad01ccc354a$export$606a5c06d13e04b6)("resetLastResults", function() {
            globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(26);
        });
        delete this.last;
        this.isTornDown = false;
    };
    /**
     * @deprecated `resetQueryStoreErrors` will be removed in Apollo Client 4.0.
     * Please discontinue using this method.
     */ ObservableQuery.prototype.resetQueryStoreErrors = function() {
        if (globalThis.__DEV__ !== false) globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(27);
        this.queryManager.resetErrors(this.queryId);
    };
    /**
     * Update the variables of this observable query, and fetch the new results.
     * This method should be preferred over `setVariables` in most use cases.
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ ObservableQuery.prototype.refetch = function(variables) {
        var _a;
        var reobserveOptions = {
            // Always disable polling for refetches.
            pollInterval: 0
        };
        // Unless the provided fetchPolicy always consults the network
        // (no-cache, network-only, or cache-and-network), override it with
        // network-only to force the refetch for this fetchQuery call.
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === "no-cache") reobserveOptions.fetchPolicy = "no-cache";
        else reobserveOptions.fetchPolicy = "network-only";
        if (globalThis.__DEV__ !== false && variables && $d0d4a90bb058cbe1$var$hasOwnProperty.call(variables, "variables")) {
            var queryDef = (0, $6d75937eba8e6f1c$export$d96b2213c1b9d3a9)(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function(v) {
                return v.variable.name.value === "variables";
            })) globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(28, variables, ((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || queryDef);
        }
        if (variables && !(0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(this.options.variables, variables)) // Update the existing options with new variables
        reobserveOptions.variables = this.options.variables = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, this.options.variables), variables);
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, (0, $7f070805c91ccc41$export$bd096ddbd246c79c).refetch);
    };
    /**
     * A function that helps you fetch the next set of results for a [paginated list field](https://www.apollographql.com/docs/react/pagination/core-api/).
     */ ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $b8xcN.__assign)((0, $b8xcN.__assign)((0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, this.options), {
            query: this.options.query
        }), fetchMoreOptions), {
            variables: (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, this.options.variables), fetchMoreOptions.variables)
        })), {
            // The fetchMore request goes immediately to the network and does
            // not automatically write its result to the cache (hence no-cache
            // instead of network-only), because we allow the caller of
            // fetchMore to provide an updateQuery callback that determines how
            // the data gets written to the cache.
            fetchPolicy: "no-cache"
        });
        combinedOptions.query = this.transformDocument(combinedOptions.query);
        var qid = this.queryManager.generateQueryId();
        // If a temporary query is passed to `fetchMore`, we don't want to store
        // it as the last query result since it may be an optimized query for
        // pagination. We will however run the transforms on the original document
        // as well as the document passed in `fetchMoreOptions` to ensure the cache
        // uses the most up-to-date document which may rely on runtime conditionals.
        this.lastQuery = fetchMoreOptions.query ? this.transformDocument(this.options.query) : combinedOptions.query;
        // Simulate a loading result for the original query with
        // result.networkStatus === NetworkStatus.fetchMore.
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = (0, $7f070805c91ccc41$export$bd096ddbd246c79c).fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) this.observe();
        var updatedQuerySet = new Set();
        var updateQuery = fetchMoreOptions === null || fetchMoreOptions === void 0 ? void 0 : fetchMoreOptions.updateQuery;
        var isCached = this.options.fetchPolicy !== "no-cache";
        if (!isCached) (0, $c21c2000775800f2$export$f5708dca728d7177)(updateQuery, 29);
        return this.queryManager.fetchQuery(qid, combinedOptions, (0, $7f070805c91ccc41$export$bd096ddbd246c79c).fetchMore).then(function(fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === (0, $7f070805c91ccc41$export$bd096ddbd246c79c).fetchMore) queryInfo.networkStatus = originalNetworkStatus;
            if (isCached) // Performing this cache update inside a cache.batch transaction ensures
            // any affected cache.watch watchers are notified at most once about any
            // updates. Most watchers will be using the QueryInfo class, which
            // responds to notifications by calling reobserveCacheFirst to deliver
            // fetchMore cache results back to this ObservableQuery.
            _this.queryManager.cache.batch({
                update: function(cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) cache.updateQuery({
                        query: _this.query,
                        variables: _this.variables,
                        returnPartialData: true,
                        optimistic: false
                    }, function(previous) {
                        return updateQuery(previous, {
                            fetchMoreResult: fetchMoreResult.data,
                            variables: combinedOptions.variables
                        });
                    });
                    else // If we're using a field policy instead of updateQuery, the only
                    // thing we need to do is write the new data to the cache using
                    // combinedOptions.variables (instead of this.variables, which is
                    // what this.updateQuery uses, because it works by abusing the
                    // original field value, keyed by the original variables).
                    cache.writeQuery({
                        query: combinedOptions.query,
                        variables: combinedOptions.variables,
                        data: fetchMoreResult.data
                    });
                },
                onWatchUpdated: function(watch) {
                    // Record the DocumentNode associated with any watched query whose
                    // data were updated by the cache writes above.
                    updatedQuerySet.add(watch.query);
                }
            });
            else {
                // There is a possibility `lastResult` may not be set when
                // `fetchMore` is called which would cause this to crash. This should
                // only happen if we haven't previously reported a result. We don't
                // quite know what the right behavior should be here since this block
                // of code runs after the fetch result has executed on the network.
                // We plan to let it crash in the meantime.
                //
                // If we get bug reports due to the `data` property access on
                // undefined, this should give us a real-world scenario that we can
                // use to test against and determine the right behavior. If we do end
                // up changing this behavior, this may require, for example, an
                // adjustment to the types on `updateQuery` since that function
                // expects that the first argument always contains previous result
                // data, but not `undefined`.
                var lastResult = _this.getLast("result");
                var data = updateQuery(lastResult.data, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
                _this.reportResult((0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, lastResult), {
                    networkStatus: originalNetworkStatus,
                    loading: (0, $7f070805c91ccc41$export$37509604341a3464)(originalNetworkStatus),
                    data: data
                }), _this.variables);
            }
            return _this.maskResult(fetchMoreResult);
        }).finally(function() {
            // In case the cache writes above did not generate a broadcast
            // notification (which would have been intercepted by onWatchUpdated),
            // likely because the written data were the same as what was already in
            // the cache, we still want fetchMore to deliver its final loading:false
            // result with the unchanged data.
            if (isCached && !updatedQuerySet.has(_this.query)) _this.reobserveCacheFirst();
        });
    };
    // XXX the subscription variables are separate from the query variables.
    // if you want to update subscription variables, right now you have to do that separately,
    // and you can only do it by stopping the subscription and then subscribing again with new variables.
    /**
     * A function that enables you to execute a [subscription](https://www.apollographql.com/docs/react/data/subscriptions/), usually to subscribe to specific fields that were included in the query.
     *
     * This function returns _another_ function that you can call to terminate the subscription.
     */ ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, updateOptions) {
                    return updateQuery(previous, (0, $b8xcN.__assign)({
                        subscriptionData: subscriptionData
                    }, updateOptions));
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).error(30, err);
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    /**
     * @deprecated `setOptions` will be removed in Apollo Client 4.0. Please use
     * `observableQuery.reobserve(newOptions)` instead.
     */ ObservableQuery.prototype.setOptions = function(newOptions) {
        if (globalThis.__DEV__ !== false) {
            (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(newOptions, "canonizeResults", "setOptions");
            (0, $14465ad01ccc354a$export$606a5c06d13e04b6)("setOptions", function() {
                globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(31);
            });
        }
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.silentSetOptions = function(newOptions) {
        var mergedOptions = (0, $b37018ac55880203$export$8e16b83750b44988)(this.options, newOptions || {});
        $d0d4a90bb058cbe1$var$assign(this.options, mergedOptions);
    };
    /**
     * Update the variables of this observable query, and fetch the new results
     * if they've changed. Most users should prefer `refetch` instead of
     * `setVariables` in order to to be properly notified of results even when
     * they come from the cache.
     *
     * Note: the `next` callback will *not* fire if the variables have not changed
     * or if the result is coming from cache.
     *
     * Note: the promise will return the old results immediately if the variables
     * have not changed.
     *
     * Note: the promise will return null immediately if the query is not active
     * (there are no subscribers).
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ ObservableQuery.prototype.setVariables = function(variables) {
        var _this = this;
        if ((0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(this.variables, variables)) // If we have no observers, then we don't actually want to make a network
        // request. As soon as someone observes the query, the request will kick
        // off. For now, we just store any changes. (See #1077)
        return this.observers.size ? (0, $14465ad01ccc354a$export$d18d1529326946c4)("observableQuery.result", function() {
            return _this.result();
        }) : Promise.resolve();
        this.options.variables = variables;
        // See comment above
        if (!this.observers.size) return Promise.resolve();
        return this.reobserve({
            // Reset options.fetchPolicy to its original value.
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables
        }, (0, $7f070805c91ccc41$export$bd096ddbd246c79c).setVariables);
    };
    /**
     * A function that enables you to update the query's cached result without executing a followup GraphQL operation.
     *
     * See [using updateQuery and updateFragment](https://www.apollographql.com/docs/react/caching/cache-interaction/#using-updatequery-and-updatefragment) for additional information.
     */ ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false
        }), result = _a.result, complete = _a.complete;
        var newResult = mapFn(result, {
            variables: this.variables,
            complete: !!complete,
            previousData: result
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables
            });
            queryManager.broadcastQueries();
        }
    };
    /**
     * A function that instructs the query to begin re-executing at a specified interval (in milliseconds).
     */ ObservableQuery.prototype.startPolling = function(pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    /**
     * A function that instructs the query to stop polling after a previous call to `startPolling`.
     */ ObservableQuery.prototype.stopPolling = function() {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    // Update options.fetchPolicy according to options.nextFetchPolicy.
    ObservableQuery.prototype.applyNextFetchPolicy = function(reason, // It's possible to use this method to apply options.nextFetchPolicy to
    // options.fetchPolicy even if options !== this.options, though that happens
    // most often when the options are temporary, used for only one request and
    // then thrown away, so nextFetchPolicy may not end up mattering.
    options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") ;
            else if (typeof options.nextFetchPolicy === "function") // When someone chooses "cache-and-network" or "network-only" as their
            // initial FetchPolicy, they often do not want future cache updates to
            // trigger unconditional network requests, which is what repeatedly
            // applying the "cache-and-network" or "network-only" policies would
            // seem to imply. Instead, when the cache reports an update after the
            // initial network request, it may be desirable for subsequent network
            // requests to be triggered only if the cache result is incomplete. To
            // that end, the options.nextFetchPolicy option provides an easy way to
            // update options.fetchPolicy after the initial network request, without
            // having to call observableQuery.setOptions.
            options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                reason: reason,
                options: options,
                observable: this,
                initialFetchPolicy: initialFetchPolicy
            });
            else if (reason === "variables-changed") options.fetchPolicy = initialFetchPolicy;
            else options.fetchPolicy = options.nextFetchPolicy;
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function(options, newNetworkStatus, query) {
        // TODO Make sure we update the networkStatus (and infer fetchVariables)
        // before actually committing to the fetch.
        var queryInfo = this._getOrCreateQuery();
        queryInfo.setObservableQuery(this);
        return this.queryManager["fetchConcastWithInfo"](queryInfo, options, newNetworkStatus, query);
    };
    // Turns polling on or off based on this.options.pollInterval.
    ObservableQuery.prototype.updatePolling = function() {
        var _this = this;
        // Avoid polling in SSR mode
        if (this.queryManager.ssrMode) return;
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval || !this.hasObservers()) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo && pollingInfo.interval === pollInterval) return;
        (0, $c21c2000775800f2$export$f5708dca728d7177)(pollInterval, 32);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function() {
            var _a, _b;
            if (_this.pollingInfo) {
                if (!(0, $7f070805c91ccc41$export$37509604341a3464)(_this.queryInfo.networkStatus) && !((_b = (_a = _this.options).skipPollAttempt) === null || _b === void 0 ? void 0 : _b.call(_a))) _this.reobserve({
                    // Most fetchPolicy options don't make sense to use in a polling context, as
                    // users wouldn't want to be polling the cache directly. However, network-only and
                    // no-cache are both useful for when the user wants to control whether or not the
                    // polled results are written to the cache.
                    fetchPolicy: _this.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
                }, (0, $7f070805c91ccc41$export$bd096ddbd246c79c).poll).then(poll, poll);
                else poll();
            }
        };
        var poll = function() {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function(newResult, variables) {
        var _this = this;
        if (variables === void 0) variables = this.variables;
        var error = (0, $14465ad01ccc354a$export$d18d1529326946c4)("getLastError", function() {
            return _this.getLastError();
        });
        // Preserve this.last.error unless the variables have changed.
        if (error && this.last && !(0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(variables, this.last.variables)) error = void 0;
        return this.last = (0, $b8xcN.__assign)({
            result: this.queryManager.assumeImmutableResults ? newResult : (0, $778668322a5c03d6$export$629a2bd3f5a49ecc)(newResult),
            variables: variables
        }, error ? {
            error: error
        } : null);
    };
    ObservableQuery.prototype.reobserveAsConcast = function(newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        newNetworkStatus === (0, $7f070805c91ccc41$export$bd096ddbd246c79c).refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        newNetworkStatus === (0, $7f070805c91ccc41$export$bd096ddbd246c79c).fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        newNetworkStatus === (0, $7f070805c91ccc41$export$bd096ddbd246c79c).poll;
        // Save the old variables, since Object.assign may modify them below.
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = (0, $b37018ac55880203$export$8e16b83750b44988)(this.options, newOptions || {});
        var options = useDisposableConcast ? // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        mergedOptions : $d0d4a90bb058cbe1$var$assign(this.options, mergedOptions);
        // Don't update options.query with the transformed query to avoid
        // overwriting this.options.query when we aren't using a disposable concast.
        // We want to ensure we can re-run the custom document transforms the next
        // time a request is made against the original query.
        var query = this.transformDocument(options.query);
        this.lastQuery = query;
        if (!useDisposableConcast) {
            // We can skip calling updatePolling if we're not changing this.options.
            this.updatePolling();
            // Reset options.fetchPolicy to its original value when variables change,
            // unless a new fetchPolicy was provided by newOptions.
            if (newOptions && newOptions.variables && !(0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(newOptions.variables, oldVariables) && // Don't mess with the fetchPolicy if it's currently "standby".
            options.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
            // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
            (options.fetchPolicy === oldFetchPolicy || // A `nextFetchPolicy` function has even higher priority, though,
            // so in that case `applyNextFetchPolicy` must be called.
            typeof options.nextFetchPolicy === "function")) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) newNetworkStatus = (0, $7f070805c91ccc41$export$bd096ddbd246c79c).setVariables;
            }
        }
        this.waitForOwnResult && (this.waitForOwnResult = $d0d4a90bb058cbe1$var$skipCacheDataFor(options.fetchPolicy));
        var finishWaitingForOwnResult = function() {
            if (_this.concast === concast) _this.waitForOwnResult = false;
        };
        var variables = options.variables && (0, $b8xcN.__assign)({}, options.variables);
        var _a = this.fetch(options, newNetworkStatus, query), concast = _a.concast, fromLink = _a.fromLink;
        var observer = {
            next: function(result) {
                if ((0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(_this.variables, variables)) {
                    finishWaitingForOwnResult();
                    _this.reportResult(result, variables);
                }
            },
            error: function(error) {
                if ((0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(_this.variables, variables)) {
                    // Coming from `getResultsFromLink`, `error` here should always be an `ApolloError`.
                    // However, calling `concast.cancel` can inject another type of error, so we have to
                    // wrap it again here.
                    if (!(0, $03c08328939e6317$export$17f5e6bd290bb15d)(error)) error = new (0, $03c08328939e6317$export$26a337512320b8c6)({
                        networkError: error
                    });
                    finishWaitingForOwnResult();
                    _this.reportError(error, variables);
                }
            }
        };
        if (!useDisposableConcast && (fromLink || !this.concast)) {
            // We use the {add,remove}Observer methods directly to avoid wrapping
            // observer with an unnecessary SubscriptionObserver object.
            if (this.concast && this.observer) this.concast.removeObserver(this.observer);
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast;
    };
    ObservableQuery.prototype.reobserve = function(newOptions, newNetworkStatus) {
        return (0, $2227596139f6216d$export$7ff41c6e01127226)(this.reobserveAsConcast(newOptions, newNetworkStatus).promise.then(this.maskResult));
    };
    ObservableQuery.prototype.resubscribeAfterError = function() {
        var _this = this;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // If `lastError` is set in the current when the subscription is re-created,
        // the subscription will immediately receive the error, which will
        // cause it to terminate again. To avoid this, we first clear
        // the last error/result from the `observableQuery` before re-starting
        // the subscription, and restore the last value afterwards so that the
        // subscription has a chance to stay open.
        var last = this.last;
        (0, $14465ad01ccc354a$export$d18d1529326946c4)("resetLastResults", function() {
            return _this.resetLastResults();
        });
        var subscription = this.subscribe.apply(this, args);
        this.last = last;
        return subscription;
    };
    // (Re)deliver the current result to this.observers without applying fetch
    // policies or making network requests.
    ObservableQuery.prototype.observe = function() {
        this.reportResult(// Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentFullResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function(result, variables) {
        var _this = this;
        var lastError = (0, $14465ad01ccc354a$export$d18d1529326946c4)("getLastError", function() {
            return _this.getLastError();
        });
        var isDifferent = this.isDifferentFromLastResult(result, variables);
        // Update the last result even when isDifferentFromLastResult returns false,
        // because the query may be using the @nonreactive directive, and we want to
        // save the the latest version of any nonreactive subtrees (in case
        // getCurrentResult is called), even though we skip broadcasting changes.
        if (lastError || !result.partial || this.options.returnPartialData) this.updateLastResult(result, variables);
        if (lastError || isDifferent) (0, $16482974f2c55194$export$9f6c99ae166dbeca)(this.observers, "next", this.maskResult(result));
    };
    ObservableQuery.prototype.reportError = function(error, variables) {
        var _this = this;
        // Since we don't get the current result on errors, only the error, we
        // must mirror the updates that occur in QueryStore.markQueryError here
        var errorResult = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, (0, $14465ad01ccc354a$export$d18d1529326946c4)("getLastResult", function() {
            return _this.getLastResult();
        })), {
            error: error,
            errors: error.graphQLErrors,
            networkStatus: (0, $7f070805c91ccc41$export$bd096ddbd246c79c).error,
            loading: false
        });
        this.updateLastResult(errorResult, variables);
        (0, $16482974f2c55194$export$9f6c99ae166dbeca)(this.observers, "error", this.last.error = error);
    };
    ObservableQuery.prototype.hasObservers = function() {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        if (this.isTornDown) return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        // stop all active GraphQL subscriptions
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    ObservableQuery.prototype.transformDocument = function(document) {
        return this.queryManager.transform(document);
    };
    ObservableQuery.prototype.maskResult = function(result) {
        return result && "data" in result ? (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, result), {
            data: this.queryManager.maskOperation({
                document: this.query,
                data: result.data,
                fetchPolicy: this.options.fetchPolicy,
                id: this.queryId
            })
        }) : result;
    };
    /** @internal */ ObservableQuery.prototype.resetNotifications = function() {
        this.cancelNotifyTimeout();
        this.dirty = false;
    };
    ObservableQuery.prototype.cancelNotifyTimeout = function() {
        if (this.notifyTimeout) {
            clearTimeout(this.notifyTimeout);
            this.notifyTimeout = void 0;
        }
    };
    /** @internal */ ObservableQuery.prototype.scheduleNotify = function() {
        var _this = this;
        if (this.dirty) return;
        this.dirty = true;
        if (!this.notifyTimeout) this.notifyTimeout = setTimeout(function() {
            return _this.notify();
        }, 0);
    };
    /** @internal */ ObservableQuery.prototype.notify = function() {
        this.cancelNotifyTimeout();
        if (this.dirty) {
            if (this.options.fetchPolicy == "cache-only" || this.options.fetchPolicy == "cache-and-network" || !(0, $7f070805c91ccc41$export$37509604341a3464)(this.queryInfo.networkStatus)) {
                var diff = this.queryInfo.getDiff();
                if (diff.fromOptimisticTransaction) // If this diff came from an optimistic transaction, deliver the
                // current cache data to the ObservableQuery, but don't perform a
                // reobservation, since oq.reobserveCacheFirst might make a network
                // request, and we never want to trigger network requests in the
                // middle of optimistic updates.
                this.observe();
                else // Otherwise, make the ObservableQuery "reobserve" the latest data
                // using a temporary fetch policy of "cache-first", so complete cache
                // results have a chance to be delivered without triggering additional
                // network requests, even when options.fetchPolicy is "network-only"
                // or "cache-and-network". All other fetch policies are preserved by
                // this method, and are handled by calling oq.reobserve(). If this
                // reobservation is spurious, isDifferentFromLastResult still has a
                // chance to catch it before delivery to ObservableQuery subscribers.
                this.reobserveCacheFirst();
            }
        }
        this.dirty = false;
    };
    // Reobserve with fetchPolicy effectively set to "cache-first", triggering
    // delivery of any new data from the cache, possibly falling back to the network
    // if any cache data are missing. This allows _complete_ cache results to be
    // delivered without also kicking off unnecessary network requests when
    // this.options.fetchPolicy is "cache-and-network" or "network-only". When
    // this.options.fetchPolicy is any other policy ("cache-first", "cache-only",
    // "standby", or "no-cache"), we call this.reobserve() as usual.
    ObservableQuery.prototype.reobserveCacheFirst = function() {
        var _a = this.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
        if (fetchPolicy === "cache-and-network" || fetchPolicy === "network-only") return this.reobserve({
            fetchPolicy: "cache-first",
            // Use a temporary nextFetchPolicy function that replaces itself with the
            // previous nextFetchPolicy value and returns the original fetchPolicy.
            nextFetchPolicy: function(currentFetchPolicy, context) {
                // Replace this nextFetchPolicy function in the options object with the
                // original this.options.nextFetchPolicy value.
                this.nextFetchPolicy = nextFetchPolicy;
                // If the original nextFetchPolicy value was a function, give it a
                // chance to decide what happens here.
                if (typeof this.nextFetchPolicy === "function") return this.nextFetchPolicy(currentFetchPolicy, context);
                // Otherwise go back to the original this.options.fetchPolicy.
                return fetchPolicy;
            }
        });
        return this.reobserve();
    };
    /**
     * @internal
     * A slot used by the `useQuery` hook to indicate that `client.watchQuery`
     * should not register the query immediately, but instead wait for the query to
     * be started registered with the `QueryManager` when `useSyncExternalStore`
     * actively subscribes to it.
     */ ObservableQuery.inactiveOnCreation = new (0, $f6d7836b3fbc48f1$export$8c6ed5c666ac1360)();
    return ObservableQuery;
}((0, $2027033ce24a9479$export$77cea355fa80b5f4));
// Necessary because the ObservableQuery constructor has a different
// signature than the Observable constructor.
(0, $ac8a77922bdd1f1c$export$33c8bd820eece9b2)($d0d4a90bb058cbe1$export$6c1b56eac59c9584);
function $d0d4a90bb058cbe1$var$defaultSubscriptionObserverErrorCallback(error) {
    globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).error(33, error.message, error.stack);
}
function $d0d4a90bb058cbe1$export$b7e1973aacac3ae7(missing) {
    if (globalThis.__DEV__ !== false && missing) globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).debug(34, missing);
}
function $d0d4a90bb058cbe1$var$skipCacheDataFor(fetchPolicy /* `undefined` would mean `"cache-first"` */ ) {
    return fetchPolicy === "network-only" || fetchPolicy === "no-cache" || fetchPolicy === "standby";
}





var $67539dbfe6b21900$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($67539dbfe6b21900$export$d1d99cf900472499 || ($67539dbfe6b21900$export$d1d99cf900472499 = {}));
var $67539dbfe6b21900$var$cache;
function $67539dbfe6b21900$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $67539dbfe6b21900$export$d1d99cf900472499.Query:
            name = "Query";
            break;
        case $67539dbfe6b21900$export$d1d99cf900472499.Mutation:
            name = "Mutation";
            break;
        case $67539dbfe6b21900$export$d1d99cf900472499.Subscription:
            name = "Subscription";
            break;
    }
    return name;
}
function $67539dbfe6b21900$export$8f49e4af10703ce3(document) {
    (0, $14465ad01ccc354a$export$606a5c06d13e04b6)("parser", function() {
        globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(93);
    });
    if (!$67539dbfe6b21900$var$cache) $67539dbfe6b21900$var$cache = new (0, $cee967300b629dc7$export$8dbad6f439bb2331)((0, $d301603631c7863b$export$f29926b23b28936b).parser || 1000 /* defaultCacheSizes.parser */ );
    var cached = $67539dbfe6b21900$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $c21c2000775800f2$export$f5708dca728d7177)(!!document && !!document.kind, 94, document);
    var fragments = [];
    var queries = [];
    var mutations = [];
    var subscriptions = [];
    for(var _i = 0, _a = document.definitions; _i < _a.length; _i++){
        var x = _a[_i];
        if (x.kind === "FragmentDefinition") {
            fragments.push(x);
            continue;
        }
        if (x.kind === "OperationDefinition") switch(x.operation){
            case "query":
                queries.push(x);
                break;
            case "mutation":
                mutations.push(x);
                break;
            case "subscription":
                subscriptions.push(x);
                break;
        }
    }
    (0, $c21c2000775800f2$export$f5708dca728d7177)(!fragments.length || queries.length || mutations.length || subscriptions.length, 95);
    (0, $c21c2000775800f2$export$f5708dca728d7177)(queries.length + mutations.length + subscriptions.length <= 1, 96, document, queries.length, subscriptions.length, mutations.length);
    type = queries.length ? $67539dbfe6b21900$export$d1d99cf900472499.Query : $67539dbfe6b21900$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $67539dbfe6b21900$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $c21c2000775800f2$export$f5708dca728d7177)(definitions.length === 1, 97, document, definitions.length);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === "Name") name = definition.name.value;
    else name = "data"; // fallback to using data if no name
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $67539dbfe6b21900$var$cache.set(document, payload);
    return payload;
}
$67539dbfe6b21900$export$8f49e4af10703ce3.resetCache = function() {
    $67539dbfe6b21900$var$cache = undefined;
};
if (globalThis.__DEV__ !== false) (0, $afbf6f02b98da1f0$export$a8fcd406d9e37621)("parser", function() {
    return $67539dbfe6b21900$var$cache ? $67539dbfe6b21900$var$cache.size : 0;
});
function $67539dbfe6b21900$export$6dfb8732f737404c(document, type) {
    var operation = (0, $14465ad01ccc354a$export$d18d1529326946c4)("parser", $67539dbfe6b21900$export$8f49e4af10703ce3, [
        document
    ]);
    var requiredOperationName = $67539dbfe6b21900$export$5db520940cf00715(type);
    var usedOperationName = $67539dbfe6b21900$export$5db520940cf00715(operation.type);
    (0, $c21c2000775800f2$export$f5708dca728d7177)(operation.type === type, 98, requiredOperationName, requiredOperationName, usedOperationName);
}





function $2b2c5bfb3bce7a5b$export$eb9a56e7a29e494(override) {
    var context = $631d82cb14744748$exports.useContext((0, $f2219d073890e939$export$a47505d961ee3a1)());
    var client = override || context.client;
    (0, $c21c2000775800f2$export$f5708dca728d7177)(!!client, 78);
    return client;
}




function $5371af004b6fa366$export$d5e35053e4aec331(options, name, callSite, recommendation) {
    "use no memo";
    if (recommendation === void 0) recommendation = "Please remove this option.";
    var didWarn = $631d82cb14744748$exports.useRef(false);
    if (globalThis.__DEV__ !== false) {
        if (name in options && !didWarn.current) {
            (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(options, name, callSite, recommendation);
            // eslint-disable-next-line react-compiler/react-compiler
            didWarn.current = true;
        }
    }
}

var $586ac8e427915aad$var$wrapperSymbol = Symbol.for("apollo.hook.wrappers");
function $586ac8e427915aad$export$7f12579c79e39619(hookName, useHook, clientOrObsQuery) {
    var queryManager = clientOrObsQuery["queryManager"];
    var wrappers = queryManager && queryManager[$586ac8e427915aad$var$wrapperSymbol];
    var wrapper = wrappers && wrappers[hookName];
    return wrapper ? wrapper(useHook) : useHook;
}


var $549c36a2a3cf1189$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $549c36a2a3cf1189$var$noop() {}
var $549c36a2a3cf1189$var$lastWatchOptions = Symbol();
function $549c36a2a3cf1189$export$dd0a697e1782aedd(query, options) {
    if (options === void 0) options = Object.create(null);
    return (0, $586ac8e427915aad$export$7f12579c79e39619)("useQuery", $549c36a2a3cf1189$var$useQuery_, (0, $2b2c5bfb3bce7a5b$export$eb9a56e7a29e494)(options && options.client))(query, options);
}
function $549c36a2a3cf1189$var$useQuery_(query, options) {
    if (globalThis.__DEV__ !== false) {
        /* eslint-disable react-hooks/rules-of-hooks, react-compiler/react-compiler */ (0, $5371af004b6fa366$export$d5e35053e4aec331)(options, "canonizeResults", "useQuery");
        (0, $5371af004b6fa366$export$d5e35053e4aec331)(options, "partialRefetch", "useQuery");
        (0, $5371af004b6fa366$export$d5e35053e4aec331)(options, "defaultOptions", "useQuery", "Pass the options directly to the hook instead.");
        (0, $5371af004b6fa366$export$d5e35053e4aec331)(options, "onCompleted", "useQuery", "If your `onCompleted` callback sets local state, switch to use derived state using `data` returned from the hook instead. Use `useEffect` to perform side-effects as a result of updates to `data`.");
        (0, $5371af004b6fa366$export$d5e35053e4aec331)(options, "onError", "useQuery", "If your `onError` callback sets local state, switch to use derived state using `data`, `error` or `errors` returned from the hook instead. Use `useEffect` if you need to perform side-effects as a result of updates to `data`, `error` or `errors`.");
    /* eslint-enable react-hooks/rules-of-hooks, react-compiler/react-compiler */ }
    var _a = $549c36a2a3cf1189$export$5c23c59ff7f655a8(query, options), result = _a.result, obsQueryFields = _a.obsQueryFields;
    return $631d82cb14744748$exports.useMemo(function() {
        return (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, result), obsQueryFields);
    }, [
        result,
        obsQueryFields
    ]);
}
function $549c36a2a3cf1189$var$useInternalState(client, query, options, renderPromises, makeWatchQueryOptions) {
    function createInternalState(previous) {
        var _a;
        (0, $67539dbfe6b21900$export$6dfb8732f737404c)(query, (0, $67539dbfe6b21900$export$d1d99cf900472499).Query);
        var internalState = {
            client: client,
            query: query,
            observable: // See if there is an existing observable that was used to fetch the same
            // data and if so, use it instead since it will contain the proper queryId
            // to fetch the result set. This is used during SSR.
            renderPromises && renderPromises.getSSRObservable(makeWatchQueryOptions()) || (0, $d0d4a90bb058cbe1$export$6c1b56eac59c9584)["inactiveOnCreation"].withValue(!renderPromises, function() {
                return (0, $14465ad01ccc354a$export$d18d1529326946c4)([
                    "canonizeResults",
                    "partialRefetch"
                ], function() {
                    return client.watchQuery($549c36a2a3cf1189$export$2167b7db3cd527f2(void 0, client, options, makeWatchQueryOptions()));
                });
            }),
            resultData: {
                // Reuse previousData from previous InternalState (if any) to provide
                // continuity of previousData even if/when the query or client changes.
                previousData: (_a = previous === null || previous === void 0 ? void 0 : previous.resultData.current) === null || _a === void 0 ? void 0 : _a.data
            }
        };
        return internalState;
    }
    var _a = $631d82cb14744748$exports.useState(createInternalState), internalState = _a[0], updateInternalState = _a[1];
    /**
     * Used by `useLazyQuery` when a new query is executed.
     * We keep this logic here since it needs to update things in unsafe
     * ways and here we at least can keep track of that in a single place.
     */ function onQueryExecuted(watchQueryOptions) {
        var _a;
        var _b;
        // this needs to be set to prevent an immediate `resubscribe` in the
        // next rerender of the `useQuery` internals
        Object.assign(internalState.observable, (_a = {}, _a[$549c36a2a3cf1189$var$lastWatchOptions] = watchQueryOptions, _a));
        var resultData = internalState.resultData;
        updateInternalState((0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, internalState), {
            // might be a different query
            query: watchQueryOptions.query,
            resultData: Object.assign(resultData, {
                // We need to modify the previous `resultData` object as we rely on the
                // object reference in other places
                previousData: ((_b = resultData.current) === null || _b === void 0 ? void 0 : _b.data) || resultData.previousData,
                current: undefined
            })
        }));
    }
    if (client !== internalState.client || query !== internalState.query) {
        // If the client or query have changed, we need to create a new InternalState.
        // This will trigger a re-render with the new state, but it will also continue
        // to run the current render function to completion.
        // Since we sometimes trigger some side-effects in the render function, we
        // re-assign `state` to the new state to ensure that those side-effects are
        // triggered with the new state.
        var newInternalState = createInternalState(internalState);
        updateInternalState(newInternalState);
        return [
            newInternalState,
            onQueryExecuted
        ];
    }
    return [
        internalState,
        onQueryExecuted
    ];
}
function $549c36a2a3cf1189$export$5c23c59ff7f655a8(query, options) {
    var client = (0, $2b2c5bfb3bce7a5b$export$eb9a56e7a29e494)(options.client);
    var renderPromises = $631d82cb14744748$exports.useContext((0, $f2219d073890e939$export$a47505d961ee3a1)()).renderPromises;
    var isSyncSSR = !!renderPromises;
    var disableNetworkFetches = client.disableNetworkFetches;
    var ssrAllowed = options.ssr !== false && !options.skip;
    var partialRefetch = options.partialRefetch;
    var makeWatchQueryOptions = $549c36a2a3cf1189$export$63539d93836ebf9c(client, query, options, isSyncSSR);
    var _a = $549c36a2a3cf1189$var$useInternalState(client, query, options, renderPromises, makeWatchQueryOptions), _b = _a[0], observable = _b.observable, resultData = _b.resultData, onQueryExecuted = _a[1];
    var watchQueryOptions = makeWatchQueryOptions(observable);
    $549c36a2a3cf1189$var$useResubscribeIfNecessary(resultData, observable, client, options, watchQueryOptions);
    var obsQueryFields = $631d82cb14744748$exports.useMemo(function() {
        return $549c36a2a3cf1189$var$bindObservableMethods(observable);
    }, [
        observable
    ]);
    $549c36a2a3cf1189$var$useRegisterSSRObservable(observable, renderPromises, ssrAllowed);
    var result = $549c36a2a3cf1189$var$useObservableSubscriptionResult(resultData, observable, client, options, watchQueryOptions, disableNetworkFetches, partialRefetch, isSyncSSR, {
        onCompleted: options.onCompleted || $549c36a2a3cf1189$var$noop,
        onError: options.onError || $549c36a2a3cf1189$var$noop
    });
    return {
        result: result,
        obsQueryFields: obsQueryFields,
        observable: observable,
        resultData: resultData,
        client: client,
        onQueryExecuted: onQueryExecuted
    };
}
function $549c36a2a3cf1189$var$useObservableSubscriptionResult(resultData, observable, client, options, watchQueryOptions, disableNetworkFetches, partialRefetch, isSyncSSR, callbacks) {
    var callbackRef = $631d82cb14744748$exports.useRef(callbacks);
    $631d82cb14744748$exports.useEffect(function() {
        // Make sure state.onCompleted and state.onError always reflect the latest
        // options.onCompleted and options.onError callbacks provided to useQuery,
        // since those functions are often recreated every time useQuery is called.
        // Like the forceUpdate method, the versions of these methods inherited from
        // InternalState.prototype are empty no-ops, but we can override them on the
        // base state object (without modifying the prototype).
        callbackRef.current = callbacks;
    });
    var resultOverride = (isSyncSSR || disableNetworkFetches) && options.ssr === false && !options.skip ? // If SSR has been explicitly disabled, and this function has been called
    // on the server side, return the default loading state.
    $549c36a2a3cf1189$var$ssrDisabledResult : options.skip || watchQueryOptions.fetchPolicy === "standby" ? // When skipping a query (ie. we're not querying for data but still want to
    // render children), make sure the `data` is cleared out and `loading` is
    // set to `false` (since we aren't loading anything).
    //
    // NOTE: We no longer think this is the correct behavior. Skipping should
    // not automatically set `data` to `undefined`, but instead leave the
    // previous data in place. In other words, skipping should not mandate that
    // previously received data is all of a sudden removed. Unfortunately,
    // changing this is breaking, so we'll have to wait until Apollo Client 4.0
    // to address this.
    $549c36a2a3cf1189$var$skipStandbyResult : void 0;
    var previousData = resultData.previousData;
    var currentResultOverride = $631d82cb14744748$exports.useMemo(function() {
        return resultOverride && $549c36a2a3cf1189$export$de3acc9431f1695e(resultOverride, previousData, observable, client);
    }, [
        client,
        observable,
        resultOverride,
        previousData
    ]);
    return (0, $23e805981e4d0133$export$306c0aa65ff9ec16)($631d82cb14744748$exports.useCallback(function(handleStoreChange) {
        // reference `disableNetworkFetches` here to ensure that the rules of hooks
        // keep it as a dependency of this effect, even though it's not used
        disableNetworkFetches;
        if (isSyncSSR) return function() {};
        var onNext = function() {
            var previousResult = resultData.current;
            // We use `getCurrentResult()` instead of the onNext argument because
            // the values differ slightly. Specifically, loading results will have
            // an empty object for data instead of `undefined` for some reason.
            var result = observable.getCurrentResult();
            // Make sure we're not attempting to re-render similar results
            if (previousResult && previousResult.loading === result.loading && previousResult.networkStatus === result.networkStatus && (0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(previousResult.data, result.data)) return;
            $549c36a2a3cf1189$var$setResult(result, resultData, observable, client, partialRefetch, handleStoreChange, callbackRef.current);
        };
        var onError = function(error) {
            subscription.current.unsubscribe();
            subscription.current = observable.resubscribeAfterError(onNext, onError);
            if (!$549c36a2a3cf1189$var$hasOwnProperty.call(error, "graphQLErrors")) // The error is not a GraphQL error
            throw error;
            var previousResult = resultData.current;
            if (!previousResult || previousResult && previousResult.loading || !(0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(error, previousResult.error)) $549c36a2a3cf1189$var$setResult({
                data: previousResult && previousResult.data,
                error: error,
                loading: false,
                networkStatus: (0, $7f070805c91ccc41$export$bd096ddbd246c79c).error
            }, resultData, observable, client, partialRefetch, handleStoreChange, callbackRef.current);
        };
        // TODO evaluate if we keep this in
        // React Compiler cannot handle scoped `let` access, but a mutable object
        // like this is fine.
        // was:
        // let subscription = observable.subscribe(onNext, onError);
        var subscription = {
            current: observable.subscribe(onNext, onError)
        };
        // Do the "unsubscribe" with a short delay.
        // This way, an existing subscription can be reused without an additional
        // request if "unsubscribe"  and "resubscribe" to the same ObservableQuery
        // happen in very fast succession.
        return function() {
            setTimeout(function() {
                return subscription.current.unsubscribe();
            });
        };
    }, [
        disableNetworkFetches,
        isSyncSSR,
        observable,
        resultData,
        partialRefetch,
        client
    ]), function() {
        return currentResultOverride || $549c36a2a3cf1189$var$getCurrentResult(resultData, observable, callbackRef.current, partialRefetch, client);
    }, function() {
        return currentResultOverride || $549c36a2a3cf1189$var$getCurrentResult(resultData, observable, callbackRef.current, partialRefetch, client);
    });
}
function $549c36a2a3cf1189$var$useRegisterSSRObservable(observable, renderPromises, ssrAllowed) {
    if (renderPromises && ssrAllowed) {
        renderPromises.registerSSRObservable(observable);
        if (observable.getCurrentResult().loading) // TODO: This is a legacy API which could probably be cleaned up
        renderPromises.addObservableQueryPromise(observable);
    }
}
// this hook is not compatible with any rules of React, and there's no good way to rewrite it.
// it should stay a separate hook that will not be optimized by the compiler
function $549c36a2a3cf1189$var$useResubscribeIfNecessary(/** this hook will mutate properties on `resultData` */ resultData, /** this hook will mutate properties on `observable` */ observable, client, options, watchQueryOptions) {
    var _a;
    if (observable[$549c36a2a3cf1189$var$lastWatchOptions] && !(0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(observable[$549c36a2a3cf1189$var$lastWatchOptions], watchQueryOptions)) {
        // Though it might be tempting to postpone this reobserve call to the
        // useEffect block, we need getCurrentResult to return an appropriate
        // loading:true result synchronously (later within the same call to
        // useQuery). Since we already have this.observable here (not true for
        // the very first call to useQuery), we are not initiating any new
        // subscriptions, though it does feel less than ideal that reobserve
        // (potentially) kicks off a network request (for example, when the
        // variables have changed), which is technically a side-effect.
        observable.reobserve($549c36a2a3cf1189$export$2167b7db3cd527f2(observable, client, options, watchQueryOptions));
        // Make sure getCurrentResult returns a fresh ApolloQueryResult<TData>,
        // but save the current data as this.previousData, just like setResult
        // usually does.
        resultData.previousData = ((_a = resultData.current) === null || _a === void 0 ? void 0 : _a.data) || resultData.previousData;
        resultData.current = void 0;
    }
    observable[$549c36a2a3cf1189$var$lastWatchOptions] = watchQueryOptions;
}
function $549c36a2a3cf1189$export$63539d93836ebf9c(client, query, _a, isSyncSSR) {
    if (_a === void 0) _a = {};
    var skip = _a.skip, ssr = _a.ssr, onCompleted = _a.onCompleted, onError = _a.onError, defaultOptions = _a.defaultOptions, // The above options are useQuery-specific, so this ...otherOptions spread
    // makes otherOptions almost a WatchQueryOptions object, except for the
    // query property that we add below.
    otherOptions = (0, $b8xcN.__rest)(_a, [
        "skip",
        "ssr",
        "onCompleted",
        "onError",
        "defaultOptions"
    ]);
    return function(observable) {
        // This Object.assign is safe because otherOptions is a fresh ...rest object
        // that did not exist until just now, so modifications are still allowed.
        var watchQueryOptions = Object.assign(otherOptions, {
            query: query
        });
        if (isSyncSSR && (watchQueryOptions.fetchPolicy === "network-only" || watchQueryOptions.fetchPolicy === "cache-and-network")) // this behavior was added to react-apollo without explanation in this PR
        // https://github.com/apollographql/react-apollo/pull/1579
        watchQueryOptions.fetchPolicy = "cache-first";
        if (!watchQueryOptions.variables) watchQueryOptions.variables = {};
        if (skip) {
            // When skipping, we set watchQueryOptions.fetchPolicy initially to
            // "standby", but we also need/want to preserve the initial non-standby
            // fetchPolicy that would have been used if not skipping.
            watchQueryOptions.initialFetchPolicy = watchQueryOptions.initialFetchPolicy || watchQueryOptions.fetchPolicy || $549c36a2a3cf1189$export$e700754533d2c94f(defaultOptions, client.defaultOptions);
            watchQueryOptions.fetchPolicy = "standby";
        } else if (!watchQueryOptions.fetchPolicy) watchQueryOptions.fetchPolicy = (observable === null || observable === void 0 ? void 0 : observable.options.initialFetchPolicy) || $549c36a2a3cf1189$export$e700754533d2c94f(defaultOptions, client.defaultOptions);
        return watchQueryOptions;
    };
}
function $549c36a2a3cf1189$export$2167b7db3cd527f2(observable, client, queryHookOptions, watchQueryOptions) {
    var toMerge = [];
    var globalDefaults = client.defaultOptions.watchQuery;
    if (globalDefaults) toMerge.push(globalDefaults);
    if (queryHookOptions.defaultOptions) toMerge.push(queryHookOptions.defaultOptions);
    // We use compact rather than mergeOptions for this part of the merge,
    // because we want watchQueryOptions.variables (if defined) to replace
    // this.observable.options.variables whole. This replacement allows
    // removing variables by removing them from the variables input to
    // useQuery. If the variables were always merged together (rather than
    // replaced), there would be no way to remove existing variables.
    // However, the variables from options.defaultOptions and globalDefaults
    // (if provided) should be merged, to ensure individual defaulted
    // variables always have values, if not otherwise defined in
    // observable.options or watchQueryOptions.
    toMerge.push((0, $b37018ac55880203$export$8e16b83750b44988)(observable && observable.options, watchQueryOptions));
    return toMerge.reduce((0, $a76f045ea055af6d$export$235b7fc70b9fc359));
}
function $549c36a2a3cf1189$var$setResult(nextResult, resultData, observable, client, partialRefetch, forceUpdate, callbacks) {
    var previousResult = resultData.current;
    if (previousResult && previousResult.data) resultData.previousData = previousResult.data;
    if (!nextResult.error && (0, $01c8f68cc3e070ef$export$d307f5934e447d0e)(nextResult.errors)) // Until a set naming convention for networkError and graphQLErrors is
    // decided upon, we map errors (graphQLErrors) to the error options.
    // TODO: Is it possible for both result.error and result.errors to be
    // defined here?
    nextResult.error = new (0, $03c08328939e6317$export$26a337512320b8c6)({
        graphQLErrors: nextResult.errors
    });
    resultData.current = $549c36a2a3cf1189$export$de3acc9431f1695e($549c36a2a3cf1189$var$unsafeHandlePartialRefetch(nextResult, observable, partialRefetch), resultData.previousData, observable, client);
    // Calling state.setResult always triggers an update, though some call sites
    // perform additional equality checks before committing to an update.
    forceUpdate();
    $549c36a2a3cf1189$var$handleErrorOrCompleted(nextResult, previousResult === null || previousResult === void 0 ? void 0 : previousResult.networkStatus, callbacks);
}
function $549c36a2a3cf1189$var$handleErrorOrCompleted(result, previousNetworkStatus, callbacks) {
    if (!result.loading) {
        var error_1 = $549c36a2a3cf1189$export$b2c90f1874ba96bf(result);
        // wait a tick in case we are in the middle of rendering a component
        Promise.resolve().then(function() {
            if (error_1) callbacks.onError(error_1);
            else if (result.data && previousNetworkStatus !== result.networkStatus && result.networkStatus === (0, $7f070805c91ccc41$export$bd096ddbd246c79c).ready) callbacks.onCompleted(result.data);
        }).catch(function(error) {
            globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(error);
        });
    }
}
function $549c36a2a3cf1189$var$getCurrentResult(resultData, observable, callbacks, partialRefetch, client) {
    // Using this.result as a cache ensures getCurrentResult continues returning
    // the same (===) result object, unless state.setResult has been called, or
    // we're doing server rendering and therefore override the result below.
    if (!resultData.current) // WARNING: SIDE-EFFECTS IN THE RENDER FUNCTION
    // this could call unsafeHandlePartialRefetch
    $549c36a2a3cf1189$var$setResult(observable.getCurrentResult(), resultData, observable, client, partialRefetch, function() {}, callbacks);
    return resultData.current;
}
function $549c36a2a3cf1189$export$e700754533d2c94f(queryHookDefaultOptions, clientDefaultOptions) {
    var _a;
    return (queryHookDefaultOptions === null || queryHookDefaultOptions === void 0 ? void 0 : queryHookDefaultOptions.fetchPolicy) || ((_a = clientDefaultOptions === null || clientDefaultOptions === void 0 ? void 0 : clientDefaultOptions.watchQuery) === null || _a === void 0 ? void 0 : _a.fetchPolicy) || "cache-first";
}
function $549c36a2a3cf1189$export$b2c90f1874ba96bf(result) {
    return (0, $01c8f68cc3e070ef$export$d307f5934e447d0e)(result.errors) ? new (0, $03c08328939e6317$export$26a337512320b8c6)({
        graphQLErrors: result.errors
    }) : result.error;
}
function $549c36a2a3cf1189$export$de3acc9431f1695e(result, previousData, observable, client) {
    var data = result.data, partial = result.partial, resultWithoutPartial = (0, $b8xcN.__rest)(result, [
        "data",
        "partial"
    ]);
    var queryResult = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({
        data: data
    }, resultWithoutPartial), {
        client: client,
        observable: observable,
        variables: observable.variables,
        called: result !== $549c36a2a3cf1189$var$ssrDisabledResult && result !== $549c36a2a3cf1189$var$skipStandbyResult,
        previousData: previousData
    });
    return queryResult;
}
function $549c36a2a3cf1189$var$unsafeHandlePartialRefetch(result, observable, partialRefetch) {
    // TODO: This code should be removed when the partialRefetch option is
    // removed. I was unable to get this hook to behave reasonably in certain
    // edge cases when this block was put in an effect.
    if (result.partial && partialRefetch && !result.loading && (!result.data || Object.keys(result.data).length === 0) && observable.options.fetchPolicy !== "cache-only") {
        observable.refetch();
        return (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, result), {
            loading: true,
            networkStatus: (0, $7f070805c91ccc41$export$bd096ddbd246c79c).refetch
        });
    }
    return result;
}
var $549c36a2a3cf1189$var$ssrDisabledResult = (0, $5d04349b74d4efd7$export$7f9c177735b71f18)({
    loading: true,
    data: void 0,
    error: void 0,
    networkStatus: (0, $7f070805c91ccc41$export$bd096ddbd246c79c).loading
});
var $549c36a2a3cf1189$var$skipStandbyResult = (0, $5d04349b74d4efd7$export$7f9c177735b71f18)({
    loading: false,
    data: void 0,
    error: void 0,
    networkStatus: (0, $7f070805c91ccc41$export$bd096ddbd246c79c).ready
});
function $549c36a2a3cf1189$var$bindObservableMethods(observable) {
    return {
        refetch: observable.refetch.bind(observable),
        reobserve: function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (globalThis.__DEV__ !== false) globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(83);
            return observable.reobserve.apply(observable, args);
        },
        fetchMore: observable.fetchMore.bind(observable),
        updateQuery: observable.updateQuery.bind(observable),
        startPolling: observable.startPolling.bind(observable),
        stopPolling: observable.stopPolling.bind(observable),
        subscribeToMore: observable.subscribeToMore.bind(observable)
    };
}



var $3OyDL = parcelRequire("3OyDL");

var $8B9Zg = parcelRequire("8B9Zg");
var $ZNHD9 = parcelRequire("ZNHD9");

var $b8xcN = parcelRequire("b8xcN");
/** @category Parsing */ /** @category Errors */ /** @category Errors */ /**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 *
 * @internal
 */ function $0acc3dc02505c627$export$c10d0b04eaa80a43(value) {
    return typeof value == 'object' && value !== null;
}


/** @category Source */ /** @internal */ function $a4bb686bd60165df$export$f5708dca728d7177(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}


const $4e77f77d83958e7f$var$LineRegExp = /\r\n|[\n\r]/g;
function $4e77f77d83958e7f$export$e7fd20fad3cf4b5f(source, position) {
    let lastLineStart = 0;
    let line = 1;
    for (const match of source.body.matchAll($4e77f77d83958e7f$var$LineRegExp)){
        typeof match.index === 'number' || (0, $a4bb686bd60165df$export$f5708dca728d7177)(false);
        if (match.index >= position) break;
        lastLineStart = match.index + match[0].length;
        line += 1;
    }
    return {
        line: line,
        column: position + 1 - lastLineStart
    };
}


/** @category Source */ 
function $8e44834e122ca415$export$96a9681e539deed(location) {
    return $8e44834e122ca415$export$867940333fd9f869(location.source, (0, $4e77f77d83958e7f$export$e7fd20fad3cf4b5f)(location.source, location.start));
}
function $8e44834e122ca415$export$867940333fd9f869(source, sourceLocation) {
    const firstLineColumnOffset = source.locationOffset.column - 1;
    const body = ''.padStart(firstLineColumnOffset) + source.body;
    const lineIndex = sourceLocation.line - 1;
    const lineOffset = source.locationOffset.line - 1;
    const lineNum = sourceLocation.line + lineOffset;
    const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    const columnNum = sourceLocation.column + columnOffset;
    const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
    const lines = body.split(/\r\n|[\n\r]/g);
    const locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        const subLineIndex = Math.floor(columnNum / 80);
        const subLineColumnNum = columnNum % 80;
        const subLines = [];
        for(let i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $8e44834e122ca415$var$printPrefixedLines([
            [
                `${lineNum} |`,
                subLines[0]
            ],
            ...subLines.slice(1, subLineIndex + 1).map((subLine)=>[
                    '|',
                    subLine
                ]),
            [
                '|',
                '^'.padStart(subLineColumnNum)
            ],
            [
                '|',
                subLines[subLineIndex + 1]
            ]
        ]);
    }
    return locationStr + $8e44834e122ca415$var$printPrefixedLines([
        // Lines specified like this: ["prefix", "string"],
        [
            `${lineNum - 1} |`,
            lines[lineIndex - 1]
        ],
        [
            `${lineNum} |`,
            locationLine
        ],
        [
            '|',
            '^'.padStart(columnNum)
        ],
        [
            `${lineNum + 1} |`,
            lines[lineIndex + 1]
        ]
    ]);
}
function $8e44834e122ca415$var$printPrefixedLines(lines) {
    const existingLines = lines.filter(([_, line])=>line !== undefined);
    const padLen = Math.max(...existingLines.map(([prefix])=>prefix.length));
    return existingLines.map(([prefix, line])=>prefix.padStart(padLen) + (line ? ' ' + line : '')).join('\n');
}


function $4b49e183336fd22d$var$toNormalizedOptions(args) {
    const firstArg = args[0];
    if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) return {
        nodes: firstArg,
        source: args[1],
        positions: args[2],
        path: args[3],
        originalError: args[4],
        extensions: args[5]
    };
    return firstArg;
}
class $4b49e183336fd22d$export$92d6ed0888e7cb7f extends Error {
    /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /** An array of GraphQL AST Nodes corresponding to this error. */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /** Original error that caused this GraphQLError, if one exists. */ /** Extension fields to add to the formatted error. */ /**
   * Creates a GraphQLError instance.
   * @param message - Human-readable error message.
   * @param options - Error metadata such as source locations, response path, original error, and extensions.
   * This positional-arguments constructor overload is deprecated. Use the
   * `GraphQLError(message, options)` overload instead.
   * @example
   * ```ts
   * // Create an error from AST nodes and response metadata.
   * import { parse } from 'graphql/language';
   * import { GraphQLError } from 'graphql/error';
   *
   * const document = parse('{ greeting }');
   * const fieldNode = document.definitions[0].selectionSet.selections[0];
   * const error = new GraphQLError('Cannot query this field.', {
   *   nodes: fieldNode,
   *   path: ['greeting'],
   *   extensions: { code: 'FORBIDDEN' },
   * });
   *
   * error.message; // => 'Cannot query this field.'
   * error.locations; // => [{ line: 1, column: 3 }]
   * error.path; // => ['greeting']
   * error.extensions; // => { code: 'FORBIDDEN' }
   * ```
   * @example
   * ```ts
   * // This variant derives locations from source positions and preserves the original error.
   * import { Source } from 'graphql/language';
   * import { GraphQLError } from 'graphql/error';
   *
   * const source = new Source('{ greeting }');
   * const originalError = new Error('Database unavailable.');
   * const error = new GraphQLError('Resolver failed.', {
   *   source,
   *   positions: [2],
   *   path: ['greeting'],
   *   originalError,
   * });
   *
   * error.locations; // => [{ line: 1, column: 3 }]
   * error.path; // => ['greeting']
   * error.originalError; // => originalError
   * ```
   */ /**
   * Creates a GraphQLError instance using the legacy positional constructor.
   * This deprecated overload will be removed in v17. Prefer the
   * `GraphQLErrorOptions` object overload, which keeps optional error metadata
   * in a single options bag.
   * @param message - Human-readable error message.
   * @param nodes - AST node or nodes associated with this error.
   * @param source - Source document used to derive error locations.
   * @param positions - Character offsets in the source document associated with
   * this error.
   * @param path - Response path where this error occurred during execution.
   * @param originalError - Original error that caused this GraphQLError, if one
   * exists.
   * @param extensions - Extension fields to include in the formatted error.
   * @example
   * ```ts
   * import { Source } from 'graphql/language';
   * import { GraphQLError } from 'graphql/error';
   *
   * const source = new Source('{ greeting }');
   * const originalError = new Error('Database unavailable.');
   * const error = new GraphQLError(
   *   'Resolver failed.',
   *   undefined,
   *   source,
   *   [2],
   *   ['greeting'],
   *   originalError,
   *   { code: 'INTERNAL' },
   * );
   *
   * error.locations; // => [{ line: 1, column: 3 }]
   * error.path; // => ['greeting']
   * error.originalError; // => originalError
   * error.extensions; // => { code: 'INTERNAL' }
   * ```
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */ constructor(message, ...rawArgs){
        var _this$nodes, _nodeLocations$, _ref;
        const { nodes: nodes, source: source, positions: positions, path: path, originalError: originalError, extensions: extensions } = $4b49e183336fd22d$var$toNormalizedOptions(rawArgs);
        super(message);
        this.name = 'GraphQLError';
        this.path = path !== null && path !== void 0 ? path : undefined;
        this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        this.nodes = $4b49e183336fd22d$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        const nodeLocations = $4b49e183336fd22d$var$undefinedIfEmpty((_this$nodes = this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map((node)=>node.loc).filter((loc)=>loc != null)); // Compute locations in the source for the given nodes/positions.
        this.source = source !== null && source !== void 0 ? source : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
        this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>loc.start);
        this.locations = positions && source ? positions.map((pos)=>(0, $4e77f77d83958e7f$export$e7fd20fad3cf4b5f)(source, pos)) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>(0, $4e77f77d83958e7f$export$e7fd20fad3cf4b5f)(loc.source, loc.start));
        const originalExtensions = (0, $0acc3dc02505c627$export$c10d0b04eaa80a43)(originalError === null || originalError === void 0 ? void 0 : originalError.extensions) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : undefined;
        this.extensions = (_ref = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref !== void 0 ? _ref : Object.create(null); // Only properties prescribed by the spec should be enumerable.
        // Keep the rest as non-enumerable.
        Object.defineProperties(this, {
            message: {
                writable: true,
                enumerable: true
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        /* c8 ignore start */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
        if (originalError !== null && originalError !== void 0 && originalError.stack) Object.defineProperty(this, 'stack', {
            value: originalError.stack,
            writable: true,
            configurable: true
        });
        else if (Error.captureStackTrace) Error.captureStackTrace(this, $4b49e183336fd22d$export$92d6ed0888e7cb7f);
        else Object.defineProperty(this, 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
    /* c8 ignore stop */ }
    /**
   * Returns the value used by `Object.prototype.toString`.
   * @returns The built-in string tag for this object.
   */ get [Symbol.toStringTag]() {
        return 'GraphQLError';
    }
    /**
   * Returns this error as a human-readable message with source locations.
   * @returns The formatted error string.
   * @example
   * ```ts
   * import { Source } from 'graphql/language';
   * import { GraphQLError } from 'graphql/error';
   *
   * const error = new GraphQLError('Cannot query field "name".', {
   *   source: new Source('{ name }'),
   *   positions: [2],
   * });
   *
   * error.toString(); // => 'Cannot query field "name".\n\nGraphQL request:1:3\n1 | { name }\n  |   ^'
   * ```
   */ toString() {
        let output = this.message;
        if (this.nodes) {
            for (const node of this.nodes)if (node.loc) output += '\n\n' + (0, $8e44834e122ca415$export$96a9681e539deed)(node.loc);
        } else if (this.source && this.locations) for (const location of this.locations)output += '\n\n' + (0, $8e44834e122ca415$export$867940333fd9f869)(this.source, location);
        return output;
    }
    /**
   * Returns the JSON representation used when this object is serialized.
   * @returns The JSON-serializable representation.
   * @example
   * ```ts
   * import { GraphQLError } from 'graphql/error';
   *
   * const error = new GraphQLError('Resolver failed.', {
   *   path: ['viewer', 'name'],
   *   extensions: { code: 'INTERNAL' },
   * });
   *
   * error.toJSON(); // => { message: 'Resolver failed.', path: ['viewer', 'name'], extensions: { code: 'INTERNAL' } }
   * ```
   */ toJSON() {
        const formattedError = {
            message: this.message
        };
        if (this.locations != null) formattedError.locations = this.locations;
        if (this.path != null) formattedError.path = this.path;
        if (this.extensions != null && Object.keys(this.extensions).length > 0) formattedError.extensions = this.extensions;
        return formattedError;
    }
}
function $4b49e183336fd22d$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $4b49e183336fd22d$export$55ee1551a3f962e6(error) {
    return error.toString();
}
function $4b49e183336fd22d$export$7b5b869ee98c16ab(error) {
    return error.toJSON();
}


function $bdedd7f8c04201b5$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $4b49e183336fd22d$export$92d6ed0888e7cb7f)(`Syntax Error: ${description}`, {
        source: source,
        positions: [
            position
        ]
    });
}



/** @category Kinds */ /** The set of allowed directive location values. */ var $bba1598231c55285$export$b45ffd2948484c41;
(function(DirectiveLocation) {
    DirectiveLocation['QUERY'] = 'QUERY';
    DirectiveLocation['MUTATION'] = 'MUTATION';
    DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
    DirectiveLocation['FIELD'] = 'FIELD';
    DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
    DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
    DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
    DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
    DirectiveLocation['SCHEMA'] = 'SCHEMA';
    DirectiveLocation['SCALAR'] = 'SCALAR';
    DirectiveLocation['OBJECT'] = 'OBJECT';
    DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
    DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
    DirectiveLocation['INTERFACE'] = 'INTERFACE';
    DirectiveLocation['UNION'] = 'UNION';
    DirectiveLocation['ENUM'] = 'ENUM';
    DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
    DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
    DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
    DirectiveLocation['DIRECTIVE_DEFINITION'] = 'DIRECTIVE_DEFINITION';
})($bba1598231c55285$export$b45ffd2948484c41 || ($bba1598231c55285$export$b45ffd2948484c41 = {}));
 /**
 * Deprecated legacy alias for the enum type representing directive location
 * values. This alias will be removed in v17. In v17, `DirectiveLocation` is
 * exported as the single public symbol for both the runtime object and the
 * corresponding TypeScript type.
 * @deprecated Will be removed in v17. In v17, use `DirectiveLocation` as both
 * the runtime value and the type.
 */ 


/** @category Lexing */ 

/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $9ac00b3d41263010$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $9ac00b3d41263010$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $9ac00b3d41263010$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $9ac00b3d41263010$export$45a677ea7cb6d5c8(code) {
    return $9ac00b3d41263010$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $9ac00b3d41263010$export$d3f406ff46035894(code) {
    return $9ac00b3d41263010$export$79c5d5217943d6a7(code) || $9ac00b3d41263010$export$727d9dbc4fbb948f(code) || code === 0x005f;
}


function $6afb3cc02f1d0b54$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $6afb3cc02f1d0b54$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $6afb3cc02f1d0b54$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $9ac00b3d41263010$export$3c52dd84024ae72c)(str.charCodeAt(i)))++i;
    return i;
}
function $6afb3cc02f1d0b54$export$40862a63ef85e395(value) {
    if (value === '') return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $6afb3cc02f1d0b54$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $9ac00b3d41263010$export$3c52dd84024ae72c)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith('\\');
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ''; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $9ac00b3d41263010$export$3c52dd84024ae72c)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += '\n';
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += '\n';
    return '"""' + result + '"""';
}



/** @category Lexing */ /**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $f2cb4790d374731f$export$8b9d26ab11394711;
(function(TokenKind) {
    TokenKind['SOF'] = '<SOF>';
    TokenKind['EOF'] = '<EOF>';
    TokenKind['BANG'] = '!';
    TokenKind['DOLLAR'] = '$';
    TokenKind['AMP'] = '&';
    TokenKind['PAREN_L'] = '(';
    TokenKind['PAREN_R'] = ')';
    TokenKind['DOT'] = '.';
    TokenKind['SPREAD'] = '...';
    TokenKind['COLON'] = ':';
    TokenKind['EQUALS'] = '=';
    TokenKind['AT'] = '@';
    TokenKind['BRACKET_L'] = '[';
    TokenKind['BRACKET_R'] = ']';
    TokenKind['BRACE_L'] = '{';
    TokenKind['PIPE'] = '|';
    TokenKind['BRACE_R'] = '}';
    TokenKind['NAME'] = 'Name';
    TokenKind['INT'] = 'Int';
    TokenKind['FLOAT'] = 'Float';
    TokenKind['STRING'] = 'String';
    TokenKind['BLOCK_STRING'] = 'BlockString';
    TokenKind['COMMENT'] = 'Comment';
})($f2cb4790d374731f$export$8b9d26ab11394711 || ($f2cb4790d374731f$export$8b9d26ab11394711 = {}));
 /**
 * Deprecated legacy alias for the enum type representing token kind values.
 * This alias will be removed in v17. In v17, `TokenKind` is exported as the
 * single public symbol for both the runtime object and the corresponding
 * TypeScript type.
 * @deprecated Will be removed in v17. In v17, use `TokenKind` as both the
 * runtime value and the type.
 */ 

class $adffd4d4bf3aee0a$export$6168dc8908a6c652 {
    /** Source document used to derive error locations. */ /** Most recent non-ignored token returned by the lexer. */ /** Current non-ignored token at the lexer cursor. */ /** The (1-indexed) line containing the current token. */ /** Character offset where the current line starts. */ /**
   * Creates a Lexer instance.
   * @param source - Source document used to derive error locations.
   * @example
   * ```ts
   * import { Lexer, Source, TokenKind } from 'graphql/language';
   *
   * const lexer = new Lexer(new Source('{ hello }'));
   *
   * lexer.token.kind; // => TokenKind.SOF
   * lexer.advance().kind; // => TokenKind.BRACE_L
   * lexer.advance().value; // => 'hello'
   * lexer.advance().kind; // => TokenKind.BRACE_R
   * ```
   */ constructor(source){
        const startOfFileToken = new (0, $feac916297e0f6f3$export$50792b0e93539fde)((0, $f2cb4790d374731f$export$8b9d26ab11394711).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Returns the value used by `Object.prototype.toString`.
   * @returns The built-in string tag for this object.
   */ get [Symbol.toStringTag]() {
        return 'Lexer';
    }
    /**
   * Advances the token stream to the next non-ignored token.
   * @returns The next non-ignored token.
   * @example
   * ```ts
   * import { Lexer, Source } from 'graphql/language';
   *
   * const lexer = new Lexer(new Source('{ hello }'));
   * const token = lexer.advance();
   *
   * token.kind; // => '{'
   * lexer.token; // => token
   * ```
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   * @returns The next non-ignored token without advancing the lexer.
   * @example
   * ```ts
   * import { Lexer, Source } from 'graphql/language';
   *
   * const lexer = new Lexer(new Source('{ hello }'));
   * const token = lexer.lookahead();
   *
   * token.kind; // => '{'
   * lexer.token.kind; // => '<SOF>'
   * ```
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $f2cb4790d374731f$export$8b9d26ab11394711).EOF) {
            do if (token.next) token = token.next;
            else {
                // Read the next token and form a link in the token linked-list.
                const nextToken = $adffd4d4bf3aee0a$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
                token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
                nextToken.prev = token;
                token = nextToken;
            }
            while (token.kind === (0, $f2cb4790d374731f$export$8b9d26ab11394711).COMMENT);
        }
        return token;
    }
}
function $adffd4d4bf3aee0a$export$59ac0f4da287406a(kind) {
    return kind === (0, $f2cb4790d374731f$export$8b9d26ab11394711).BANG || kind === (0, $f2cb4790d374731f$export$8b9d26ab11394711).DOLLAR || kind === (0, $f2cb4790d374731f$export$8b9d26ab11394711).AMP || kind === (0, $f2cb4790d374731f$export$8b9d26ab11394711).PAREN_L || kind === (0, $f2cb4790d374731f$export$8b9d26ab11394711).PAREN_R || kind === (0, $f2cb4790d374731f$export$8b9d26ab11394711).DOT || kind === (0, $f2cb4790d374731f$export$8b9d26ab11394711).SPREAD || kind === (0, $f2cb4790d374731f$export$8b9d26ab11394711).COLON || kind === (0, $f2cb4790d374731f$export$8b9d26ab11394711).EQUALS || kind === (0, $f2cb4790d374731f$export$8b9d26ab11394711).AT || kind === (0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACKET_L || kind === (0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACKET_R || kind === (0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACE_L || kind === (0, $f2cb4790d374731f$export$8b9d26ab11394711).PIPE || kind === (0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACE_R;
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 *
 * @internal
 */ function $adffd4d4bf3aee0a$var$isUnicodeScalarValue(code) {
    return code >= 0x0000 && code <= 0xd7ff || code >= 0xe000 && code <= 0x10ffff;
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 *
 * @internal
 */ function $adffd4d4bf3aee0a$var$isSupplementaryCodePoint(body, location) {
    return $adffd4d4bf3aee0a$var$isLeadingSurrogate(body.charCodeAt(location)) && $adffd4d4bf3aee0a$var$isTrailingSurrogate(body.charCodeAt(location + 1));
}
function $adffd4d4bf3aee0a$var$isLeadingSurrogate(code) {
    return code >= 0xd800 && code <= 0xdbff;
}
function $adffd4d4bf3aee0a$var$isTrailingSurrogate(code) {
    return code >= 0xdc00 && code <= 0xdfff;
}
function $adffd4d4bf3aee0a$export$4b99857da92744e4(lexer, location) {
    const code = lexer.source.body.codePointAt(location);
    if (code === undefined) return (0, $f2cb4790d374731f$export$8b9d26ab11394711).EOF;
    else if (code >= 0x0020 && code <= 0x007e) {
        // Printable ASCII
        const char = String.fromCodePoint(code);
        return char === '"' ? "'\"'" : `"${char}"`;
    } // Unicode code point
    return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
function $adffd4d4bf3aee0a$export$c255480b061bd6aa(lexer, kind, start, end, value) {
    const line = lexer.line;
    const col = 1 + start - lexer.lineStart;
    return new (0, $feac916297e0f6f3$export$50792b0e93539fde)(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 *
 * @internal
 */ function $adffd4d4bf3aee0a$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // SourceCharacter
        switch(code){
            // Ignored ::
            //   - UnicodeBOM
            //   - WhiteSpace
            //   - LineTerminator
            //   - Comment
            //   - Comma
            //
            // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
            //
            // WhiteSpace ::
            //   - "Horizontal Tab (U+0009)"
            //   - "Space (U+0020)"
            //
            // Comma :: ,
            case 0xfeff:
            case 0x0009:
            case 0x0020:
            case 0x002c:
                // ,
                ++position;
                continue;
            // LineTerminator ::
            //   - "New Line (U+000A)"
            //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
            //   - "Carriage Return (U+000D)" "New Line (U+000A)"
            case 0x000a:
                // \n
                ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            case 0x000d:
                // \r
                if (body.charCodeAt(position + 1) === 0x000a) position += 2;
                else ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            // Comment
            case 0x0023:
                // #
                return $adffd4d4bf3aee0a$var$readComment(lexer, position);
            // Token ::
            //   - Punctuator
            //   - Name
            //   - IntValue
            //   - FloatValue
            //   - StringValue
            //
            // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
            case 0x0021:
                // !
                return $adffd4d4bf3aee0a$export$c255480b061bd6aa(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).BANG, position, position + 1);
            case 0x0024:
                // $
                return $adffd4d4bf3aee0a$export$c255480b061bd6aa(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).DOLLAR, position, position + 1);
            case 0x0026:
                // &
                return $adffd4d4bf3aee0a$export$c255480b061bd6aa(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).AMP, position, position + 1);
            case 0x0028:
                // (
                return $adffd4d4bf3aee0a$export$c255480b061bd6aa(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return $adffd4d4bf3aee0a$export$c255480b061bd6aa(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).PAREN_R, position, position + 1);
            case 0x002e:
                // .
                if (body.charCodeAt(position + 1) === 0x002e && body.charCodeAt(position + 2) === 0x002e) return $adffd4d4bf3aee0a$export$c255480b061bd6aa(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).SPREAD, position, position + 3);
                break;
            case 0x003a:
                // :
                return $adffd4d4bf3aee0a$export$c255480b061bd6aa(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).COLON, position, position + 1);
            case 0x003d:
                // =
                return $adffd4d4bf3aee0a$export$c255480b061bd6aa(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).EQUALS, position, position + 1);
            case 0x0040:
                // @
                return $adffd4d4bf3aee0a$export$c255480b061bd6aa(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).AT, position, position + 1);
            case 0x005b:
                // [
                return $adffd4d4bf3aee0a$export$c255480b061bd6aa(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACKET_L, position, position + 1);
            case 0x005d:
                // ]
                return $adffd4d4bf3aee0a$export$c255480b061bd6aa(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACKET_R, position, position + 1);
            case 0x007b:
                // {
                return $adffd4d4bf3aee0a$export$c255480b061bd6aa(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACE_L, position, position + 1);
            case 0x007c:
                // |
                return $adffd4d4bf3aee0a$export$c255480b061bd6aa(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).PIPE, position, position + 1);
            case 0x007d:
                // }
                return $adffd4d4bf3aee0a$export$c255480b061bd6aa(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACE_R, position, position + 1);
            // StringValue
            case 0x0022:
                // "
                if (body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) return $adffd4d4bf3aee0a$var$readBlockString(lexer, position);
                return $adffd4d4bf3aee0a$var$readString(lexer, position);
        } // IntValue | FloatValue (Digit | -)
        if ((0, $9ac00b3d41263010$export$727d9dbc4fbb948f)(code) || code === 0x002d) return $adffd4d4bf3aee0a$var$readNumber(lexer, position, code);
         // Name
        if ((0, $9ac00b3d41263010$export$45a677ea7cb6d5c8)(code)) return $adffd4d4bf3aee0a$export$ccff49e992952c96(lexer, position);
        throw (0, $bdedd7f8c04201b5$export$bbee0c6176c019d4)(lexer.source, position, code === 0x0027 ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?' : $adffd4d4bf3aee0a$var$isUnicodeScalarValue(code) || $adffd4d4bf3aee0a$var$isSupplementaryCodePoint(body, position) ? `Unexpected character: ${$adffd4d4bf3aee0a$export$4b99857da92744e4(lexer, position)}.` : `Invalid character: ${$adffd4d4bf3aee0a$export$4b99857da92744e4(lexer, position)}.`);
    }
    return $adffd4d4bf3aee0a$export$c255480b061bd6aa(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 *
 * @internal
 */ function $adffd4d4bf3aee0a$var$readComment(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($adffd4d4bf3aee0a$var$isUnicodeScalarValue(code)) ++position;
        else if ($adffd4d4bf3aee0a$var$isSupplementaryCodePoint(body, position)) position += 2;
        else break;
    }
    return $adffd4d4bf3aee0a$export$c255480b061bd6aa(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).COMMENT, start, position, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 *
 * @internal
 */ function $adffd4d4bf3aee0a$var$readNumber(lexer, start, firstCode) {
    const body = lexer.source.body;
    let position = start;
    let code = firstCode;
    let isFloat = false; // NegativeSign (-)
    if (code === 0x002d) code = body.charCodeAt(++position);
     // Zero (0)
    if (code === 0x0030) {
        code = body.charCodeAt(++position);
        if ((0, $9ac00b3d41263010$export$727d9dbc4fbb948f)(code)) throw (0, $bdedd7f8c04201b5$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, unexpected digit after 0: ${$adffd4d4bf3aee0a$export$4b99857da92744e4(lexer, position)}.`);
    } else {
        position = $adffd4d4bf3aee0a$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Full stop (.)
    if (code === 0x002e) {
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $adffd4d4bf3aee0a$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // E e
    if (code === 0x0045 || code === 0x0065) {
        isFloat = true;
        code = body.charCodeAt(++position); // + -
        if (code === 0x002b || code === 0x002d) code = body.charCodeAt(++position);
        position = $adffd4d4bf3aee0a$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 0x002e || (0, $9ac00b3d41263010$export$45a677ea7cb6d5c8)(code)) throw (0, $bdedd7f8c04201b5$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, expected digit but got: ${$adffd4d4bf3aee0a$export$4b99857da92744e4(lexer, position)}.`);
    return $adffd4d4bf3aee0a$export$c255480b061bd6aa(lexer, isFloat ? (0, $f2cb4790d374731f$export$8b9d26ab11394711).FLOAT : (0, $f2cb4790d374731f$export$8b9d26ab11394711).INT, start, position, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading one or more digits.
 *
 * @internal
 */ function $adffd4d4bf3aee0a$var$readDigits(lexer, start, firstCode) {
    if (!(0, $9ac00b3d41263010$export$727d9dbc4fbb948f)(firstCode)) throw (0, $bdedd7f8c04201b5$export$bbee0c6176c019d4)(lexer.source, start, `Invalid number, expected digit but got: ${$adffd4d4bf3aee0a$export$4b99857da92744e4(lexer, start)}.`);
    const body = lexer.source.body;
    let position = start + 1; // +1 to skip first firstCode
    while((0, $9ac00b3d41263010$export$727d9dbc4fbb948f)(body.charCodeAt(position)))++position;
    return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 *
 * @internal
 */ function $adffd4d4bf3aee0a$var$readString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    let chunkStart = position;
    let value = '';
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Quote (")
        if (code === 0x0022) {
            value += body.slice(chunkStart, position);
            return $adffd4d4bf3aee0a$export$c255480b061bd6aa(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).STRING, start, position + 1, value);
        } // Escape Sequence (\)
        if (code === 0x005c) {
            value += body.slice(chunkStart, position);
            const escape = body.charCodeAt(position + 1) === 0x0075 // u
             ? body.charCodeAt(position + 2) === 0x007b // {
             ? $adffd4d4bf3aee0a$var$readEscapedUnicodeVariableWidth(lexer, position) : $adffd4d4bf3aee0a$var$readEscapedUnicodeFixedWidth(lexer, position) : $adffd4d4bf3aee0a$var$readEscapedCharacter(lexer, position);
            value += escape.value;
            position += escape.size;
            chunkStart = position;
            continue;
        } // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($adffd4d4bf3aee0a$var$isUnicodeScalarValue(code)) ++position;
        else if ($adffd4d4bf3aee0a$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $bdedd7f8c04201b5$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$adffd4d4bf3aee0a$export$4b99857da92744e4(lexer, position)}.`);
    }
    throw (0, $bdedd7f8c04201b5$export$bbee0c6176c019d4)(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.
function $adffd4d4bf3aee0a$var$readEscapedUnicodeVariableWidth(lexer, position) {
    const body = lexer.source.body;
    let point = 0;
    let size = 3; // Cannot be larger than 12 chars (\u{00000000}).
    while(size < 12){
        const code = body.charCodeAt(position + size++); // Closing Brace (})
        if (code === 0x007d) {
            // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
            if (size < 5 || !$adffd4d4bf3aee0a$var$isUnicodeScalarValue(point)) break;
            return {
                value: String.fromCodePoint(point),
                size: size
            };
        } // Append this hex digit to the code point.
        point = point << 4 | $adffd4d4bf3aee0a$var$readHexDigit(code);
        if (point < 0) break;
    }
    throw (0, $bdedd7f8c04201b5$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + size)}".`);
}
function $adffd4d4bf3aee0a$var$readEscapedUnicodeFixedWidth(lexer, position) {
    const body = lexer.source.body;
    const code = $adffd4d4bf3aee0a$var$read16BitHexCode(body, position + 2);
    if ($adffd4d4bf3aee0a$var$isUnicodeScalarValue(code)) return {
        value: String.fromCodePoint(code),
        size: 6
    };
     // GraphQL allows JSON-style surrogate pair escape sequences, but only when
    // a valid pair is formed.
    if ($adffd4d4bf3aee0a$var$isLeadingSurrogate(code)) // \u
    {
        if (body.charCodeAt(position + 6) === 0x005c && body.charCodeAt(position + 7) === 0x0075) {
            const trailingCode = $adffd4d4bf3aee0a$var$read16BitHexCode(body, position + 8);
            if ($adffd4d4bf3aee0a$var$isTrailingSurrogate(trailingCode)) // JavaScript defines strings as a sequence of UTF-16 code units and
            // encodes Unicode code points above U+FFFF using a surrogate pair of
            // code units. Since this is a surrogate pair escape sequence, just
            // include both codes into the JavaScript string value. Had JavaScript
            // not been internally based on UTF-16, then this surrogate pair would
            // be decoded to retrieve the supplementary code point.
            return {
                value: String.fromCodePoint(code, trailingCode),
                size: 12
            };
        }
    }
    throw (0, $bdedd7f8c04201b5$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`);
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 *
 * @internal
 */ function $adffd4d4bf3aee0a$var$read16BitHexCode(body, position) {
    // readHexDigit() returns -1 on error. ORing a negative value with any other
    // value always produces a negative value.
    return $adffd4d4bf3aee0a$var$readHexDigit(body.charCodeAt(position)) << 12 | $adffd4d4bf3aee0a$var$readHexDigit(body.charCodeAt(position + 1)) << 8 | $adffd4d4bf3aee0a$var$readHexDigit(body.charCodeAt(position + 2)) << 4 | $adffd4d4bf3aee0a$var$readHexDigit(body.charCodeAt(position + 3));
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 *
 * @internal
 */ function $adffd4d4bf3aee0a$var$readHexDigit(code) {
    return code >= 0x0030 && code <= 0x0039 // 0-9
     ? code - 0x0030 : code >= 0x0041 && code <= 0x0046 // A-F
     ? code - 0x0037 : code >= 0x0061 && code <= 0x0066 // a-f
     ? code - 0x0057 : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 *
 * @internal
 */ function $adffd4d4bf3aee0a$var$readEscapedCharacter(lexer, position) {
    const body = lexer.source.body;
    const code = body.charCodeAt(position + 1);
    switch(code){
        case 0x0022:
            // "
            return {
                value: '\u0022',
                size: 2
            };
        case 0x005c:
            // \
            return {
                value: '\u005c',
                size: 2
            };
        case 0x002f:
            // /
            return {
                value: '\u002f',
                size: 2
            };
        case 0x0062:
            // b
            return {
                value: '\u0008',
                size: 2
            };
        case 0x0066:
            // f
            return {
                value: '\u000c',
                size: 2
            };
        case 0x006e:
            // n
            return {
                value: '\u000a',
                size: 2
            };
        case 0x0072:
            // r
            return {
                value: '\u000d',
                size: 2
            };
        case 0x0074:
            // t
            return {
                value: '\u0009',
                size: 2
            };
    }
    throw (0, $bdedd7f8c04201b5$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character escape sequence: "${body.slice(position, position + 2)}".`);
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 *
 * @internal
 */ function $adffd4d4bf3aee0a$var$readBlockString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let lineStart = lexer.lineStart;
    let position = start + 3;
    let chunkStart = position;
    let currentLine = '';
    const blockLines = [];
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Triple-Quote (""")
        if (code === 0x0022 && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            const token = $adffd4d4bf3aee0a$export$c255480b061bd6aa(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).BLOCK_STRING, start, position + 3, (0, $6afb3cc02f1d0b54$export$d5ee19b441e8d2ae)(blockLines).join('\n'));
            lexer.line += blockLines.length - 1;
            lexer.lineStart = lineStart;
            return token;
        } // Escaped Triple-Quote (\""")
        if (code === 0x005c && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022 && body.charCodeAt(position + 3) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            chunkStart = position + 1; // skip only slash
            position += 4;
            continue;
        } // LineTerminator
        if (code === 0x000a || code === 0x000d) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) position += 2;
            else ++position;
            currentLine = '';
            chunkStart = position;
            lineStart = position;
            continue;
        } // SourceCharacter
        if ($adffd4d4bf3aee0a$var$isUnicodeScalarValue(code)) ++position;
        else if ($adffd4d4bf3aee0a$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $bdedd7f8c04201b5$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$adffd4d4bf3aee0a$export$4b99857da92744e4(lexer, position)}.`);
    }
    throw (0, $bdedd7f8c04201b5$export$bbee0c6176c019d4)(lexer.source, position, 'Unterminated string.');
}
function $adffd4d4bf3aee0a$export$ccff49e992952c96(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        if ((0, $9ac00b3d41263010$export$d3f406ff46035894)(code)) ++position;
        else break;
    }
    return $adffd4d4bf3aee0a$export$c255480b061bd6aa(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).NAME, start, position, body.slice(start, position));
}







class $5d3292ed71ff61f2$export$1b46278b6a12726b {
    /** The previously focused non-ignored token. */ /** The currently focused non-ignored token. */ /**
   * The (1-indexed) line containing the current token.
   * Since a schema coordinate may not contain newline, this value is always 1.
   */ line = 1;
    /**
   * The character offset at which the current line begins.
   * Since a schema coordinate may not contain newline, this value is always 0.
   */ lineStart = 0;
    constructor(source){
        const startOfFileToken = new (0, $feac916297e0f6f3$export$50792b0e93539fde)((0, $f2cb4790d374731f$export$8b9d26ab11394711).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
    }
    get [Symbol.toStringTag]() {
        return 'SchemaCoordinateLexer';
    }
    /**
   * Advances the token stream to the next non-ignored token.
   *
   * @internal
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the current Lexer token.
   *
   * @internal
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $f2cb4790d374731f$export$8b9d26ab11394711).EOF) {
            // Read the next token and form a link in the token linked-list.
            const nextToken = $5d3292ed71ff61f2$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
            token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
            nextToken.prev = token;
            token = nextToken;
        }
        return token;
    }
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * @internal
 */ function $5d3292ed71ff61f2$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    const position = start;
    if (position < bodyLength) {
        const code = body.charCodeAt(position);
        switch(code){
            case 0x002e:
                // .
                return (0, $adffd4d4bf3aee0a$export$c255480b061bd6aa)(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).DOT, position, position + 1);
            case 0x0028:
                // (
                return (0, $adffd4d4bf3aee0a$export$c255480b061bd6aa)(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return (0, $adffd4d4bf3aee0a$export$c255480b061bd6aa)(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).PAREN_R, position, position + 1);
            case 0x003a:
                // :
                return (0, $adffd4d4bf3aee0a$export$c255480b061bd6aa)(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).COLON, position, position + 1);
            case 0x0040:
                // @
                return (0, $adffd4d4bf3aee0a$export$c255480b061bd6aa)(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).AT, position, position + 1);
        } // Name
        if ((0, $9ac00b3d41263010$export$45a677ea7cb6d5c8)(code)) return (0, $adffd4d4bf3aee0a$export$ccff49e992952c96)(lexer, position);
        throw (0, $bdedd7f8c04201b5$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character: ${(0, $adffd4d4bf3aee0a$export$4b99857da92744e4)(lexer, position)}.`);
    }
    return (0, $adffd4d4bf3aee0a$export$c255480b061bd6aa)(lexer, (0, $f2cb4790d374731f$export$8b9d26ab11394711).EOF, bodyLength, bodyLength);
}


/** @category Source */ 


/* c8 ignore next 3 */ const $dcc2eb4b181ad0e9$var$isProduction = globalThis.process && // eslint-disable-next-line no-undef
true;
const $dcc2eb4b181ad0e9$export$ca03416d6c9e029e = /* c8 ignore next 6 */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
$dcc2eb4b181ad0e9$var$isProduction ? function instanceOf(value, constructor) {
    return value instanceof constructor;
} : function instanceOf(value, constructor) {
    if (value instanceof constructor) return true;
    if (typeof value === 'object' && value !== null) {
        var _value$constructor;
        // Prefer Symbol.toStringTag since it is immune to minification.
        const className = constructor.prototype[Symbol.toStringTag];
        const valueClassName = Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
         ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;
        if (className === valueClassName) {
            const stringifiedValue = (0, $1518287c7b4a1333$export$9dec5d1b3b6a130d)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
    }
    return false;
};


class $5ebdacca28d0ab1f$export$1d2df86270c81ecb {
    /** The GraphQL source text. */ /** Name used in diagnostics for this source, such as a file path or request name. */ /** One-indexed line and column where this source begins. */ /**
   * Creates a Source instance.
   * @param body - The GraphQL source text.
   * @param name - Name used in diagnostics for this source.
   * @param locationOffset - One-indexed line and column where this source begins.
   * @example
   * ```ts
   * import { Source } from 'graphql/language';
   *
   * const source = new Source(
   *   'type Query { greeting: String }',
   *   'schema.graphql',
   *   { line: 10, column: 1 },
   * );
   *
   * source.body; // => 'type Query { greeting: String }'
   * source.name; // => 'schema.graphql'
   * source.locationOffset; // => { line: 10, column: 1 }
   * ```
   */ constructor(body, name = 'GraphQL request', locationOffset = {
        line: 1,
        column: 1
    }){
        typeof body === 'string' || (0, $7007d6f1edee536c$export$b6cb5906f04696c8)(false, `Body must be a string. Received: ${(0, $1518287c7b4a1333$export$9dec5d1b3b6a130d)(body)}.`);
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $7007d6f1edee536c$export$b6cb5906f04696c8)(false, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $7007d6f1edee536c$export$b6cb5906f04696c8)(false, 'column in locationOffset is 1-indexed and must be positive.');
    }
    /**
   * Returns the value used by `Object.prototype.toString`.
   * @returns The built-in string tag for this object.
   */ get [Symbol.toStringTag]() {
        return 'Source';
    }
}
function $5ebdacca28d0ab1f$export$75135ee9ed6e435b(source) {
    return (0, $dcc2eb4b181ad0e9$export$ca03416d6c9e029e)(source, $5ebdacca28d0ab1f$export$1d2df86270c81ecb);
}



function $d023735a9d26c422$export$98e6a39c04603d36(source, options) {
    const parser = new $d023735a9d26c422$export$7acfa6ed01010e37(source, options);
    const document = parser.parseDocument();
    Object.defineProperty(document, 'tokenCount', {
        enumerable: false,
        value: parser.tokenCount
    });
    return document;
}
function $d023735a9d26c422$export$5303528d1070ff6f(source, options) {
    const parser = new $d023735a9d26c422$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).SOF);
    const value = parser.parseValueLiteral(false);
    parser.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).EOF);
    return value;
}
function $d023735a9d26c422$export$e14c466bd0916f7a(source, options) {
    const parser = new $d023735a9d26c422$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).SOF);
    const value = parser.parseConstValueLiteral();
    parser.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).EOF);
    return value;
}
function $d023735a9d26c422$export$28b8f402ccc88182(source, options) {
    const parser = new $d023735a9d26c422$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).SOF);
    const type = parser.parseTypeReference();
    parser.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).EOF);
    return type;
}
function $d023735a9d26c422$export$87ea0c241caf7f8f(source) {
    const sourceObj = (0, $5ebdacca28d0ab1f$export$75135ee9ed6e435b)(source) ? source : new (0, $5ebdacca28d0ab1f$export$1d2df86270c81ecb)(source);
    const lexer = new (0, $5d3292ed71ff61f2$export$1b46278b6a12726b)(sourceObj);
    const parser = new $d023735a9d26c422$export$7acfa6ed01010e37(source, {
        lexer: lexer
    });
    parser.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).SOF);
    const coordinate = parser.parseSchemaCoordinate();
    parser.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).EOF);
    return coordinate;
}
class $d023735a9d26c422$export$7acfa6ed01010e37 {
    constructor(source, options = {}){
        const { lexer: lexer, ..._options } = options;
        if (lexer) this._lexer = lexer;
        else {
            const sourceObj = (0, $5ebdacca28d0ab1f$export$75135ee9ed6e435b)(source) ? source : new (0, $5ebdacca28d0ab1f$export$1d2df86270c81ecb)(source);
            this._lexer = new (0, $adffd4d4bf3aee0a$export$6168dc8908a6c652)(sourceObj);
        }
        this._options = _options;
        this._tokenCounter = 0;
    }
    get tokenCount() {
        return this._tokenCounter;
    }
    /**
   * Converts a name lex token into a name parse node.
   *
   * @internal
   */ parseName() {
        const token = this.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).NAME);
        return this.node(token, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).NAME,
            value: token.value
        });
    }
    /**
   * Document : Definition+
   *
   * @internal
   */ parseDocument() {
        return this.node(this._lexer.token, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).DOCUMENT,
            definitions: this.many((0, $f2cb4790d374731f$export$8b9d26ab11394711).SOF, this.parseDefinition, (0, $f2cb4790d374731f$export$8b9d26ab11394711).EOF)
        });
    }
    /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   *
   * @internal
   */ parseDefinition() {
        if (this.peek((0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACE_L)) return this.parseOperationDefinition();
         // Many definitions begin with a description and require a lookahead.
        const hasDescription = this.peekDescription();
        const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
        if (hasDescription && keywordToken.kind === (0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACE_L) throw (0, $bdedd7f8c04201b5$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, 'Unexpected description, descriptions are not supported on shorthand queries.');
        if (keywordToken.kind === (0, $f2cb4790d374731f$export$8b9d26ab11394711).NAME) {
            switch(keywordToken.value){
                case 'schema':
                    return this.parseSchemaDefinition();
                case 'scalar':
                    return this.parseScalarTypeDefinition();
                case 'type':
                    return this.parseObjectTypeDefinition();
                case 'interface':
                    return this.parseInterfaceTypeDefinition();
                case 'union':
                    return this.parseUnionTypeDefinition();
                case 'enum':
                    return this.parseEnumTypeDefinition();
                case 'input':
                    return this.parseInputObjectTypeDefinition();
                case 'directive':
                    return this.parseDirectiveDefinition();
            }
            switch(keywordToken.value){
                case 'query':
                case 'mutation':
                case 'subscription':
                    return this.parseOperationDefinition();
                case 'fragment':
                    return this.parseFragmentDefinition();
            }
            if (hasDescription) throw (0, $bdedd7f8c04201b5$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, 'Unexpected description, only GraphQL definitions support descriptions.');
            switch(keywordToken.value){
                case 'extend':
                    return this.parseTypeSystemExtension();
            }
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   *
   * @internal
   */ parseOperationDefinition() {
        const start = this._lexer.token;
        if (this.peek((0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACE_L)) return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: (0, $feac916297e0f6f3$export$f58c50edb4aef9d4).QUERY,
            description: undefined,
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet()
        });
        const description = this.parseDescription();
        const operation = this.parseOperationType();
        let name;
        if (this.peek((0, $f2cb4790d374731f$export$8b9d26ab11394711).NAME)) name = this.parseName();
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: operation,
            description: description,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * OperationType : one of query mutation subscription
   *
   * @internal
   */ parseOperationType() {
        const operationToken = this.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).NAME);
        switch(operationToken.value){
            case 'query':
                return (0, $feac916297e0f6f3$export$f58c50edb4aef9d4).QUERY;
            case 'mutation':
                return (0, $feac916297e0f6f3$export$f58c50edb4aef9d4).MUTATION;
            case 'subscription':
                return (0, $feac916297e0f6f3$export$f58c50edb4aef9d4).SUBSCRIPTION;
        }
        throw this.unexpected(operationToken);
    }
    /**
   * VariableDefinitions : ( VariableDefinition+ )
   *
   * @internal
   */ parseVariableDefinitions() {
        return this.optionalMany((0, $f2cb4790d374731f$export$8b9d26ab11394711).PAREN_L, this.parseVariableDefinition, (0, $f2cb4790d374731f$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   *
   * @internal
   */ parseVariableDefinition() {
        return this.node(this._lexer.token, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).VARIABLE_DEFINITION,
            description: this.parseDescription(),
            variable: this.parseVariable(),
            type: (this.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).EQUALS) ? this.parseConstValueLiteral() : undefined,
            directives: this.parseConstDirectives()
        });
    }
    /**
   * Variable : $ Name
   *
   * @internal
   */ parseVariable() {
        const start = this._lexer.token;
        this.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).DOLLAR);
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).VARIABLE,
            name: this.parseName()
        });
    }
    /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   *
   * @internal
   */ parseSelectionSet() {
        return this.node(this._lexer.token, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).SELECTION_SET,
            selections: this.many((0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACE_L, this.parseSelection, (0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   *
   * @internal
   */ parseSelection() {
        return this.peek((0, $f2cb4790d374731f$export$8b9d26ab11394711).SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   *
   * @internal
   */ parseField() {
        const start = this._lexer.token;
        const nameOrAlias = this.parseName();
        let alias;
        let name;
        if (this.expectOptionalToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACE_L) ? this.parseSelectionSet() : undefined
        });
    }
    /**
   * Arguments[Const] : ( Argument[?Const]+ )
   *
   * @internal
   */ parseArguments(isConst) {
        const item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $f2cb4790d374731f$export$8b9d26ab11394711).PAREN_L, item, (0, $f2cb4790d374731f$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * Argument[Const] : Name : Value[?Const]
   *
   * @internal
   */ parseArgument(isConst = false) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    parseConstArgument() {
        return this.parseArgument(true);
    }
    /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   *
   * @internal
   */ parseFragment() {
        const start = this._lexer.token;
        this.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).SPREAD);
        const hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $f2cb4790d374731f$export$8b9d26ab11394711).NAME)) return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false)
        });
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   *
   * @internal
   */ parseFragmentDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.allowLegacyFragmentVariables === true) return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            description: description,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            description: description,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentName : Name but not `on`
   *
   * @internal
   */ parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    }
    /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   *
   * @internal
   */ parseValueLiteral(isConst) {
        const token = this._lexer.token;
        switch(token.kind){
            case (0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACKET_L:
                return this.parseList(isConst);
            case (0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACE_L:
                return this.parseObject(isConst);
            case (0, $f2cb4790d374731f$export$8b9d26ab11394711).INT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).INT,
                    value: token.value
                });
            case (0, $f2cb4790d374731f$export$8b9d26ab11394711).FLOAT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).FLOAT,
                    value: token.value
                });
            case (0, $f2cb4790d374731f$export$8b9d26ab11394711).STRING:
            case (0, $f2cb4790d374731f$export$8b9d26ab11394711).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $f2cb4790d374731f$export$8b9d26ab11394711).NAME:
                this.advanceLexer();
                switch(token.value){
                    case 'true':
                        return this.node(token, {
                            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).BOOLEAN,
                            value: true
                        });
                    case 'false':
                        return this.node(token, {
                            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).BOOLEAN,
                            value: false
                        });
                    case 'null':
                        return this.node(token, {
                            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).NULL
                        });
                    default:
                        return this.node(token, {
                            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).ENUM,
                            value: token.value
                        });
                }
            case (0, $f2cb4790d374731f$export$8b9d26ab11394711).DOLLAR:
                if (isConst) {
                    this.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).DOLLAR);
                    if (this._lexer.token.kind === (0, $f2cb4790d374731f$export$8b9d26ab11394711).NAME) {
                        const varName = this._lexer.token.value;
                        throw (0, $bdedd7f8c04201b5$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected variable "$${varName}" in constant value.`);
                    } else throw this.unexpected(token);
                }
                return this.parseVariable();
            default:
                throw this.unexpected();
        }
    }
    parseConstValueLiteral() {
        return this.parseValueLiteral(true);
    }
    parseStringLiteral() {
        const token = this._lexer.token;
        this.advanceLexer();
        return this.node(token, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).STRING,
            value: token.value,
            block: token.kind === (0, $f2cb4790d374731f$export$8b9d26ab11394711).BLOCK_STRING
        });
    }
    /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   *
   * @internal
   */ parseList(isConst) {
        const item = ()=>this.parseValueLiteral(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).LIST,
            values: this.any((0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACKET_L, item, (0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACKET_R)
        });
    }
    /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   *
   * @internal
   */ parseObject(isConst) {
        const item = ()=>this.parseObjectField(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).OBJECT,
            fields: this.any((0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACE_L, item, (0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * ObjectField[Const] : Name : Value[?Const]
   *
   * @internal
   */ parseObjectField(isConst) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    /**
   * Directives[Const] : Directive[?Const]+
   *
   * @internal
   */ parseDirectives(isConst) {
        const directives = [];
        while(this.peek((0, $f2cb4790d374731f$export$8b9d26ab11394711).AT))directives.push(this.parseDirective(isConst));
        return directives;
    }
    parseConstDirectives() {
        return this.parseDirectives(true);
    }
    /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   *
   * @internal
   */ parseDirective(isConst) {
        const start = this._lexer.token;
        this.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).AT);
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst)
        });
    }
    /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   *
   * @internal
   */ parseTypeReference() {
        const start = this._lexer.token;
        let type;
        if (this.expectOptionalToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACKET_L)) {
            const innerType = this.parseTypeReference();
            this.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACKET_R);
            type = this.node(start, {
                kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).LIST_TYPE,
                type: innerType
            });
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).BANG)) return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).NON_NULL_TYPE,
            type: type
        });
        return type;
    }
    /**
   * NamedType : Name
   *
   * @internal
   */ parseNamedType() {
        return this.node(this._lexer.token, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).NAMED_TYPE,
            name: this.parseName()
        });
    }
    peekDescription() {
        return this.peek((0, $f2cb4790d374731f$export$8b9d26ab11394711).STRING) || this.peek((0, $f2cb4790d374731f$export$8b9d26ab11394711).BLOCK_STRING);
    }
    /**
   * Description : StringValue
   *
   * @internal
   */ parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    }
    /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   *
   * @internal
   */ parseSchemaDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('schema');
        const directives = this.parseConstDirectives();
        const operationTypes = this.many((0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACE_R);
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * OperationTypeDefinition : OperationType : NamedType
   *
   * @internal
   */ parseOperationTypeDefinition() {
        const start = this._lexer.token;
        const operation = this.parseOperationType();
        this.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).COLON);
        const type = this.parseNamedType();
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type
        });
    }
    /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   *
   * @internal
   */ parseScalarTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('scalar');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   *
   * @internal
   */ parseObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('type');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   *
   * @internal
   */ parseImplementsInterfaces() {
        return this.expectOptionalKeyword('implements') ? this.delimitedMany((0, $f2cb4790d374731f$export$8b9d26ab11394711).AMP, this.parseNamedType) : [];
    }
    /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   *
   * @internal
   */ parseFieldsDefinition() {
        return this.optionalMany((0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACE_L, this.parseFieldDefinition, (0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   *
   * @internal
   */ parseFieldDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        this.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives
        });
    }
    /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   *
   * @internal
   */ parseArgumentDefs() {
        return this.optionalMany((0, $f2cb4790d374731f$export$8b9d26ab11394711).PAREN_L, this.parseInputValueDef, (0, $f2cb4790d374731f$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   *
   * @internal
   */ parseInputValueDef() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        this.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        let defaultValue;
        if (this.expectOptionalToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).EQUALS)) defaultValue = this.parseConstValueLiteral();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives
        });
    }
    /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   *
   * @internal
   */ parseInterfaceTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('interface');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   *
   * @internal
   */ parseUnionTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('union');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   *
   * @internal
   */ parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).EQUALS) ? this.delimitedMany((0, $f2cb4790d374731f$export$8b9d26ab11394711).PIPE, this.parseNamedType) : [];
    }
    /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   *
   * @internal
   */ parseEnumTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('enum');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   *
   * @internal
   */ parseEnumValuesDefinition() {
        return this.optionalMany((0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACE_L, this.parseEnumValueDefinition, (0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * @internal
   */ parseEnumValueDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseEnumValueName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * EnumValue : Name but not `true`, `false` or `null`
   *
   * @internal
   */ parseEnumValueName() {
        if (this._lexer.token.value === 'true' || this._lexer.token.value === 'false' || this._lexer.token.value === 'null') throw (0, $bdedd7f8c04201b5$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, `${$d023735a9d26c422$var$getTokenDesc(this._lexer.token)} is reserved and cannot be used for an enum value.`);
        return this.parseName();
    }
    /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   *
   * @internal
   */ parseInputObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('input');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   *
   * @internal
   */ parseInputFieldsDefinition() {
        return this.optionalMany((0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACE_L, this.parseInputValueDef, (0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   *   - DirectiveDefinitionExtension
   *
   * @internal
   */ parseTypeSystemExtension() {
        const keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $f2cb4790d374731f$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
            case 'directive':
                if (this._options.experimentalDirectivesOnDirectiveDefinitions) return this.parseDirectiveDefinitionExtension();
                break;
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   *
   * @internal
   */ parseSchemaExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        const directives = this.parseConstDirectives();
        const operationTypes = this.optionalMany((0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $f2cb4790d374731f$export$8b9d26ab11394711).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   *
   * @internal
   */ parseScalarTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        if (directives.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   *
   * @internal
   */ parseObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   *
   * @internal
   */ parseInterfaceTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   *
   * @internal
   */ parseUnionTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   *
   * @internal
   */ parseEnumTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   *
   * @internal
   */ parseInputObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    parseDirectiveDefinitionExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('directive');
        this.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).AT);
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        if (directives.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).DIRECTIVE_EXTENSION,
            name: name,
            directives: directives
        });
    }
    /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   *
   * @internal
   */ parseDirectiveDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).AT);
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        const directives = this._options.experimentalDirectivesOnDirectiveDefinitions ? this.parseConstDirectives() : [];
        const repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        const locations = this.parseDirectiveLocations();
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            directives: directives,
            repeatable: repeatable,
            locations: locations
        });
    }
    /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   *
   * @internal
   */ parseDirectiveLocations() {
        return this.delimitedMany((0, $f2cb4790d374731f$export$8b9d26ab11394711).PIPE, this.parseDirectiveLocation);
    }
    /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   *   `DIRECTIVE_DEFINITION`
   */ parseDirectiveLocation() {
        const start = this._lexer.token;
        const name = this.parseName();
        if (Object.prototype.hasOwnProperty.call((0, $bba1598231c55285$export$b45ffd2948484c41), name.value)) return name;
        throw this.unexpected(start);
    }
    /**
   * SchemaCoordinate :
   *   - Name
   *   - Name . Name
   *   - Name . Name ( Name : )
   *   - \@ Name
   *   - \@ Name ( Name : )
   * @returns Parsed schema coordinate AST.
   * @example
   * ```ts
   * import { Parser, Source } from 'graphql/language';
   *
   * const typeCoordinate = new Parser(new Source('User.name')).parseSchemaCoordinate();
   * const directiveCoordinate = new Parser(new Source('@include(if:)')).parseSchemaCoordinate();
   *
   * typeCoordinate.name.value; // => 'User'
   * typeCoordinate.memberName?.value; // => 'name'
   * directiveCoordinate.name.value; // => 'deprecated'
   * directiveCoordinate.argumentName?.value; // => 'reason'
   * ```
   */ parseSchemaCoordinate() {
        const start = this._lexer.token;
        const ofDirective = this.expectOptionalToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).AT);
        const name = this.parseName();
        let memberName;
        if (!ofDirective && this.expectOptionalToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).DOT)) memberName = this.parseName();
        let argumentName;
        if ((ofDirective || memberName) && this.expectOptionalToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).PAREN_L)) {
            argumentName = this.parseName();
            this.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).COLON);
            this.expectToken((0, $f2cb4790d374731f$export$8b9d26ab11394711).PAREN_R);
        }
        if (ofDirective) {
            if (argumentName) return this.node(start, {
                kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).DIRECTIVE_ARGUMENT_COORDINATE,
                name: name,
                argumentName: argumentName
            });
            return this.node(start, {
                kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).DIRECTIVE_COORDINATE,
                name: name
            });
        } else if (memberName) {
            if (argumentName) return this.node(start, {
                kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).ARGUMENT_COORDINATE,
                name: name,
                fieldName: memberName,
                argumentName: argumentName
            });
            return this.node(start, {
                kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).MEMBER_COORDINATE,
                name: name,
                memberName: memberName
            });
        }
        return this.node(start, {
            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).TYPE_COORDINATE,
            name: name
        });
    }
    /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   *
   * @internal
   */ node(startToken, node) {
        if (this._options.noLocation !== true) node.loc = new (0, $feac916297e0f6f3$export$18a2be9195644f38)(startToken, this._lexer.lastToken, this._lexer.source);
        return node;
    }
    /**
   * Determines if the next token is of a given kind
   *
   * @internal
   */ peek(kind) {
        return this._lexer.token.kind === kind;
    }
    /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   *
   * @internal
   */ expectToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return token;
        }
        throw (0, $bdedd7f8c04201b5$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected ${$d023735a9d26c422$var$getTokenKindDesc(kind)}, found ${$d023735a9d26c422$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   *
   * @internal
   */ expectOptionalToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   *
   * @internal
   */ expectKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $f2cb4790d374731f$export$8b9d26ab11394711).NAME && token.value === value) this.advanceLexer();
        else throw (0, $bdedd7f8c04201b5$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected "${value}", found ${$d023735a9d26c422$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   *
   * @internal
   */ expectOptionalKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $f2cb4790d374731f$export$8b9d26ab11394711).NAME && token.value === value) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   *
   * @internal
   */ unexpected(atToken) {
        const token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $bdedd7f8c04201b5$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected ${$d023735a9d26c422$var$getTokenDesc(token)}.`);
    }
    /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   *
   * @internal
   */ any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    }
    /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   *
   * @internal
   */ optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            const nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   *
   * @internal
   */ many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   *
   * @internal
   */ delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    }
    advanceLexer() {
        const { maxTokens: maxTokens } = this._options;
        const token = this._lexer.advance();
        if (token.kind !== (0, $f2cb4790d374731f$export$8b9d26ab11394711).EOF) {
            ++this._tokenCounter;
            if (maxTokens !== undefined && this._tokenCounter > maxTokens) throw (0, $bdedd7f8c04201b5$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Document contains more that ${maxTokens} tokens. Parsing aborted.`);
        }
    }
}
/**
 * A helper function to describe a token as a string for debugging.
 *
 * @internal
 */ function $d023735a9d26c422$var$getTokenDesc(token) {
    const value = token.value;
    return $d023735a9d26c422$var$getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 *
 * @internal
 */ function $d023735a9d26c422$var$getTokenKindDesc(kind) {
    return (0, $adffd4d4bf3aee0a$export$59ac0f4da287406a)(kind) ? `"${kind}"` : kind;
}


var $f1082495fae7e77b$var$docCache = new Map();
var $f1082495fae7e77b$var$fragmentSourceMap = new Map();
var $f1082495fae7e77b$var$printFragmentWarnings = true;
var $f1082495fae7e77b$var$experimentalFragmentVariables = false;
function $f1082495fae7e77b$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $f1082495fae7e77b$var$cacheKeyFromLoc(loc) {
    return $f1082495fae7e77b$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $f1082495fae7e77b$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $f1082495fae7e77b$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $f1082495fae7e77b$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($f1082495fae7e77b$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $f1082495fae7e77b$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, ast), {
        definitions: definitions
    });
}
function $f1082495fae7e77b$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $f1082495fae7e77b$var$parseDocument(source) {
    var cacheKey = $f1082495fae7e77b$var$normalize(source);
    if (!$f1082495fae7e77b$var$docCache.has(cacheKey)) {
        var parsed = (0, $d023735a9d26c422$export$98e6a39c04603d36)(source, {
            experimentalFragmentVariables: $f1082495fae7e77b$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $f1082495fae7e77b$var$experimentalFragmentVariables,
            experimentalFragmentArguments: $f1082495fae7e77b$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $f1082495fae7e77b$var$docCache.set(cacheKey, $f1082495fae7e77b$var$stripLoc($f1082495fae7e77b$var$processFragments(parsed)));
    }
    return $f1082495fae7e77b$var$docCache.get(cacheKey);
}
function $f1082495fae7e77b$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $f1082495fae7e77b$var$parseDocument(result);
}
function $f1082495fae7e77b$export$657554ef4dc7ac2d() {
    $f1082495fae7e77b$var$docCache.clear();
    $f1082495fae7e77b$var$fragmentSourceMap.clear();
}
function $f1082495fae7e77b$export$e4294e638636c6ab() {
    $f1082495fae7e77b$var$printFragmentWarnings = false;
}
function $f1082495fae7e77b$export$78cf889af350c840() {
    $f1082495fae7e77b$var$experimentalFragmentVariables = true;
}
function $f1082495fae7e77b$export$5290df9bbbd3cfa() {
    $f1082495fae7e77b$var$experimentalFragmentVariables = false;
}
var $f1082495fae7e77b$var$extras = {
    gql: $f1082495fae7e77b$export$72e4926bf8358653,
    resetCaches: $f1082495fae7e77b$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $f1082495fae7e77b$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $f1082495fae7e77b$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $f1082495fae7e77b$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $f1082495fae7e77b$var$extras.gql, gql_1.resetCaches = $f1082495fae7e77b$var$extras.resetCaches, gql_1.disableFragmentWarnings = $f1082495fae7e77b$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $f1082495fae7e77b$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $f1082495fae7e77b$var$extras.disableExperimentalFragmentVariables;
})($f1082495fae7e77b$export$72e4926bf8358653 || ($f1082495fae7e77b$export$72e4926bf8358653 = {}));
$f1082495fae7e77b$export$72e4926bf8358653["default"] = $f1082495fae7e77b$export$72e4926bf8358653;
var $f1082495fae7e77b$export$2e2bcd8739ae039 = $f1082495fae7e77b$export$72e4926bf8358653;


/**
 * The Step 5 GraphQL documents: search, messaging, issues.
 *
 * A SECOND FILE rather than another 600 lines in queries.js. The split is by
 * step rather than by screen on purpose — `queries.js` is what Steps 1–4
 * shipped and is stable, and a reviewer looking at what Step 5 added should not
 * have to diff a thousand-line file to find it. `queries.js` re-exports
 * everything here, so no screen has to know which file a document lives in.
 */ 
const $047171b3f4119885$export$3b9cdff68986504e = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query SearchContacts(
    $filter: ContactFilterInput
    $page: Int!
    $pageSize: Int!
    $withFacets: Boolean!
  ) {
    searchContacts(
      filter: $filter
      page: $page
      pageSize: $pageSize
      withFacets: $withFacets
    ) {
      totalCount
      page
      pageSize
      facets {
        kind
        key
        count
      }
      items {
        id
        kind
        displayName
        collaborationStatus
        subscriptionType
        photoUrl
        deletedAt
        messagingOptOut
        interactionCount
        lastInteractionAt
        primaryPhoneE164
        # The default avatar is chosen by gender when there is no photo. The
        # field is already on the contact row and already mapped — the list
        # simply never asked for it.
        gender
        # «معرف», resolved in the CRM, which owns both rows.
        referrerName
        specialty {
          id
          labelFa
        }
        fieldOfWork {
          id
          labelFa
        }
        tags {
          id
          name
          colorHex
          # Which column the chip belongs in — «ارزیابی» or «برچسب‌ها».
          isAssessment
        }
        primaryPhone {
          id
          number
        }
      }
    }
  }
`;
const $047171b3f4119885$export$c8f13d3a0b86351b = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query SavedViews {
    savedViews {
      id
      name
      filterJson
      ownerId
      ownerName
      isShared
      isSystem
    }
    bulkLimit
  }
`;
const $047171b3f4119885$export$f38236151411f663 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation CreateSavedView($name: String!, $filter: ContactFilterInput!, $isShared: Boolean) {
    createSavedView(name: $name, filter: $filter, isShared: $isShared) {
      id
      name
      filterJson
      isShared
      isSystem
    }
  }
`;
const $047171b3f4119885$export$44c2f64f2aceaabd = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation UpdateSavedView(
    $id: ID!
    $name: String
    $filter: ContactFilterInput
    $isShared: Boolean
  ) {
    updateSavedView(id: $id, name: $name, filter: $filter, isShared: $isShared) {
      id
      name
      filterJson
      isShared
    }
  }
`;
const $047171b3f4119885$export$c9aa14f48ff4ab57 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation DeleteSavedView($id: ID!) {
    deleteSavedView(id: $id)
  }
`;
const $047171b3f4119885$export$878d5942ff911a0b = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation BulkTag($selector: BulkSelectorInput!, $tagId: ID!) {
    bulkTag(selector: $selector, tagId: $tagId) {
      matched
      affected
    }
  }
`;
const $047171b3f4119885$export$86079382de63686a = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation BulkUntag($selector: BulkSelectorInput!, $tagId: ID!) {
    bulkUntag(selector: $selector, tagId: $tagId) {
      matched
      affected
    }
  }
`;
const $047171b3f4119885$export$ba2e208fd7624519 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation BulkChangeStatus(
    $selector: BulkSelectorInput!
    $toStatus: CollaborationStatus!
    $reason: String
  ) {
    bulkChangeStatus(selector: $selector, toStatus: $toStatus, reason: $reason) {
      matched
      affected
    }
  }
`;
const $047171b3f4119885$export$81043027b6e6a14b = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation SetMessagingOptOut($contactId: ID!, $optedOut: Boolean!) {
    setMessagingOptOut(contactId: $contactId, optedOut: $optedOut) {
      id
      messagingOptOut
    }
  }
`;
const $047171b3f4119885$export$6e5785418e8671b9 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation ReplayProjections {
    replayProjections
  }
`;
/* ---------------- messaging ---------------- */ const $047171b3f4119885$var$MESSAGE_FIELDS = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  fragment MessageFields on Message {
    id
    contactId
    phoneE164
    renderedBody
    channel
    templateId
    status
    suppressionReason
    error
    campaignId
    automationRuleId
    queuedAt
    sendAfter
    sentAt
    deliveredAt
    readAt
    createdAt
    contact {
      id
      displayName
    }
  }
`;
const $047171b3f4119885$export$5378220b4be5edb8 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$047171b3f4119885$var$MESSAGE_FIELDS}
  query Messages(
    $page: Int!
    $pageSize: Int!
    $contactId: ID
    $statuses: [MessageStatus!]
    $campaignId: ID
  ) {
    messages(
      page: $page
      pageSize: $pageSize
      contactId: $contactId
      statuses: $statuses
      campaignId: $campaignId
    ) {
      totalCount
      page
      pageSize
      items {
        ...MessageFields
      }
    }
  }
`;
const $047171b3f4119885$export$a55094a4f4e56a9e = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$047171b3f4119885$var$MESSAGE_FIELDS}
  mutation SendMessage(
    $contactId: ID!
    $templateId: ID
    $freeBody: String
    $force: Boolean
    $accountId: String
    $media: MediaRefInput
    $channel: String
  ) {
    sendMessage(
      contactId: $contactId
      templateId: $templateId
      freeBody: $freeBody
      force: $force
      accountId: $accountId
      # WHATSAPP (the default when absent) or SMS — declared for the same
      # reason media is below.
      channel: $channel
      # DECLARED. A variable a query does not declare is silently dropped, and
      # the send goes out as its caption alone — the same hole that kept the
      # free-text preview blank.
      media: $media
    ) {
      ...MessageFields
    }
  }
`;
const $047171b3f4119885$export$9e01144bce1e85f6 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$047171b3f4119885$var$MESSAGE_FIELDS}
  mutation RetryMessage($id: ID!) {
    retryMessage(id: $id) {
      ...MessageFields
    }
  }
`;
const $047171b3f4119885$export$5fb40de85b536fc0 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query PreviewSend(
    $contactId: ID!
    $templateId: ID
    $freeBody: String
    $force: Boolean
    $accountId: String
    $channel: String
  ) {
    previewSend(
      contactId: $contactId
      templateId: $templateId
      # DECLARED, which it was not: the dialog had been passing this as a
      # variable no query named, so every free-text preview rendered blank
      # while templates rendered correctly.
      freeBody: $freeBody
      force: $force
      accountId: $accountId
      channel: $channel
    ) {
      wouldSend
      reason
      detail
      renderedBody
      phoneE164
      accountId
    }
  }
`;
const $047171b3f4119885$export$14ef471adc6a5e99 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query SmsStatus {
    smsStatus {
      provider
      configured
      detail
    }
  }
`;
const $047171b3f4119885$export$562f31d2c926639d = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query WhatsappStatus {
    whatsappStatus {
      provider
      configured
      paired
      connected
      phoneE164
      pushName
      queueDepth
      sentLastHour
      maxPerHour
      sendDisabled
      lastError
      uptimeSeconds
    }
    projectionStatus {
      recipientCount
      sources {
        source
        lastEvent
        lastEventAt
        lastAppliedAt
        appliedCount
      }
    }
  }
`;
const $047171b3f4119885$export$632d0db57ac2645 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation UnlinkWhatsapp($accountId: String) {
    unlinkWhatsapp(accountId: $accountId)
  }
`;
const $047171b3f4119885$export$983156425e02684 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  fragment WhatsappAccountFields on WhatsappAccount {
    id
    accountId
    label
    isDefault
    isActive
    sortOrder
    linked
    connected
    phoneE164
    pushName
    queueDepth
    sentLastHour
    maxPerHour
    sendDisabled
    lastError
    linkedAt
  }
`;
const $047171b3f4119885$export$f08c69326971bdb2 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query WhatsappAccounts($includeInactive: Boolean) {
    whatsappAccounts(includeInactive: $includeInactive) {
      ...WhatsappAccountFields
    }
  }
  ${$047171b3f4119885$export$983156425e02684}
`;
const $047171b3f4119885$export$d8464ea945544c47 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation CreateWhatsappAccount(
    $label: String!
    $accountId: String
    $isDefault: Boolean
  ) {
    createWhatsappAccount(label: $label, accountId: $accountId, isDefault: $isDefault) {
      ...WhatsappAccountFields
    }
  }
  ${$047171b3f4119885$export$983156425e02684}
`;
const $047171b3f4119885$export$3b41fa584fa4ca4 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation UpdateWhatsappAccount($id: ID!, $label: String) {
    updateWhatsappAccount(id: $id, label: $label) {
      ...WhatsappAccountFields
    }
  }
  ${$047171b3f4119885$export$983156425e02684}
`;
const $047171b3f4119885$export$31ebb277d01c34ae = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation SetWhatsappAccountActive($id: ID!, $isActive: Boolean!) {
    setWhatsappAccountActive(id: $id, isActive: $isActive) {
      ...WhatsappAccountFields
    }
  }
  ${$047171b3f4119885$export$983156425e02684}
`;
const $047171b3f4119885$export$eec6816698e22cca = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation SetDefaultWhatsappAccount($id: ID!) {
    setDefaultWhatsappAccount(id: $id) {
      ...WhatsappAccountFields
    }
  }
  ${$047171b3f4119885$export$983156425e02684}
`;
const $047171b3f4119885$var$CAMPAIGN_FIELDS = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  fragment CampaignFields on Campaign {
    id
    name
    accountId
    channel
    templateId
    freeBody
    recipientSource
    recipientIds
    resolvedCount
    scheduledAt
    state
    queuedCount
    sentCount
    deliveredCount
    readCount
    failedCount
    suppressedCount
    startedAt
    completedAt
    createdAt
  }
`;
const $047171b3f4119885$export$dc9303094dc8d17f = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$047171b3f4119885$var$CAMPAIGN_FIELDS}
  query Campaigns($page: Int!, $pageSize: Int!) {
    campaigns(page: $page, pageSize: $pageSize) {
      totalCount
      page
      pageSize
      items {
        ...CampaignFields
      }
    }
  }
`;
const $047171b3f4119885$export$39821677e7ddca34 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query CampaignPreview($id: ID!, $sample: Int) {
    campaignPreview(id: $id, sample: $sample) {
      displayName
      renderedBody
    }
  }
`;
const $047171b3f4119885$export$5406bbed7d677353 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$047171b3f4119885$var$CAMPAIGN_FIELDS}
  mutation CreateCampaign(
    $name: String!
    $templateId: ID
    $freeBody: String
    $contactIds: [ID!]
    $filter: ContactFilterInput
    $scheduledAt: String
    $accountId: String
    $media: MediaRefInput
    $channel: String
  ) {
    createCampaign(
      name: $name
      templateId: $templateId
      freeBody: $freeBody
      contactIds: $contactIds
      filter: $filter
      scheduledAt: $scheduledAt
      accountId: $accountId
      media: $media
      channel: $channel
    ) {
      ...CampaignFields
    }
  }
`;
const $047171b3f4119885$export$431dc0c2ff5a4e9a = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$047171b3f4119885$var$CAMPAIGN_FIELDS}
  mutation ScheduleCampaign($id: ID!, $scheduledAt: String) {
    scheduleCampaign(id: $id, scheduledAt: $scheduledAt) {
      ...CampaignFields
    }
  }
`;
const $047171b3f4119885$export$15728f4a132922ba = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$047171b3f4119885$var$CAMPAIGN_FIELDS}
  mutation CancelCampaign($id: ID!) {
    cancelCampaign(id: $id) {
      ...CampaignFields
    }
  }
`;
const $047171b3f4119885$export$7a07355bc01f6db9 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query Automation($includeDisabled: Boolean) {
    automationRules(includeDisabled: $includeDisabled) {
      id
      name
      trigger
      triggerConfigJson
      templateId
      sendTimeLocal
      enabled
    }
    occasions(includeInactive: true) {
      id
      code
      labelFa
      jalaliMonth
      jalaliDay
      isActive
      isSystem
    }
  }
`;
const $047171b3f4119885$export$1d3239ed8df5698f = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation CreateAutomationRule(
    $name: String!
    $trigger: AutomationTrigger!
    $templateId: ID!
    $triggerConfigJson: String
    $sendTimeLocal: String
  ) {
    createAutomationRule(
      name: $name
      trigger: $trigger
      templateId: $templateId
      triggerConfigJson: $triggerConfigJson
      sendTimeLocal: $sendTimeLocal
    ) {
      id
      name
      trigger
      enabled
    }
  }
`;
const $047171b3f4119885$export$cd33e63553c99333 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation UpdateAutomationRule($id: ID!, $enabled: Boolean, $name: String) {
    updateAutomationRule(id: $id, enabled: $enabled, name: $name) {
      id
      name
      enabled
    }
  }
`;
const $047171b3f4119885$export$1e93a0f3b2de7317 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation CreateOccasion(
    $code: String!
    $labelFa: String!
    $jalaliMonth: Int!
    $jalaliDay: Int!
  ) {
    createOccasion(
      code: $code
      labelFa: $labelFa
      jalaliMonth: $jalaliMonth
      jalaliDay: $jalaliDay
    ) {
      id
      code
      labelFa
      jalaliMonth
      jalaliDay
    }
  }
`;
const $047171b3f4119885$export$3e464326d9b05f59 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query AutomationDryRun($localDate: String) {
    automationDryRun(localDate: $localDate) {
      ruleId
      ruleName
      contactId
      displayName
      renderedBody
      reason
    }
  }
`;
/* ---------------- issues ---------------- */ const $047171b3f4119885$var$ISSUE_LIST_FIELDS = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  fragment IssueListFields on Issue {
    id
    kind
    priority
    status
    title
    orphaned
    reportedAt
    contactNotifiedAt
    assigneeId
    assigneeName
    type {
      id
      labelFa
    }
    contact {
      id
      displayName
    }
  }
`;
const $047171b3f4119885$export$f1d9713146d025f5 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$047171b3f4119885$var$ISSUE_LIST_FIELDS}
  query Issues(
    $page: Int!
    $pageSize: Int!
    $contactId: ID
    $statuses: [IssueStatus!]
    $kinds: [IssueKind!]
    $priorities: [IssuePriority!]
    $assigneeId: ID
    $search: String
  ) {
    issues(
      page: $page
      pageSize: $pageSize
      contactId: $contactId
      statuses: $statuses
      kinds: $kinds
      priorities: $priorities
      assigneeId: $assigneeId
      search: $search
    ) {
      totalCount
      page
      pageSize
      items {
        ...IssueListFields
      }
    }
  }
`;
const $047171b3f4119885$export$f4f44b136c1e517c = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$047171b3f4119885$var$ISSUE_LIST_FIELDS}
  query Issue($id: ID!) {
    issue(id: $id) {
      ...IssueListFields
      description
      dueAt
      resolution
      resolvedAt
      reportedBy
      reportedByName
      comments {
        id
        authorId
        authorName
        body
        isCustomerVisible
        createdAt
        attachments {
          id
          fileName
          mimeType
          sizeBytes
        }
      }
      statusHistory {
        id
        fromStatus
        toStatus
        changedBy
        changedByName
        changedAt
        reason
      }
      links {
        id
        targetType
        targetId
      }
      attachments {
        id
        fileName
        mimeType
        sizeBytes
      }
    }
    issueTypes {
      id
      labelFa
    }
  }
`;
const $047171b3f4119885$export$f08810cd3a46d5f8 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query IssueTypes($includeInactive: Boolean) {
    issueTypes(includeInactive: $includeInactive) {
      id
      code
      labelFa
      labelEn
      isActive
      isSystem
      sortOrder
    }
  }
`;
const $047171b3f4119885$export$ee884be3a3453f7a = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation CreateIssueType($code: String!, $labelFa: String!, $labelEn: String, $sortOrder: Int) {
    createIssueType(code: $code, labelFa: $labelFa, labelEn: $labelEn, sortOrder: $sortOrder) {
      id
      code
      labelFa
      labelEn
      isActive
      isSystem
    }
  }
`;
const $047171b3f4119885$export$24d168255ea252f0 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation UpdateIssueType($id: ID!, $labelFa: String, $labelEn: String, $sortOrder: Int) {
    updateIssueType(id: $id, labelFa: $labelFa, labelEn: $labelEn, sortOrder: $sortOrder) {
      id
      code
      labelFa
      labelEn
      isActive
      isSystem
    }
  }
`;
const $047171b3f4119885$export$ac53f097aef4b96c = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation SetIssueTypeActive($id: ID!, $isActive: Boolean!) {
    setIssueTypeActive(id: $id, isActive: $isActive) {
      id
      isActive
    }
  }
`;
const $047171b3f4119885$export$a84692caf5a334ea = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$047171b3f4119885$var$ISSUE_LIST_FIELDS}
  mutation CreateIssue(
    $kind: IssueKind!
    $typeId: ID!
    $title: String!
    $description: String
    $contactId: ID
    $priority: IssuePriority
    $linkTargetType: LinkTarget
    $linkTargetId: ID
  ) {
    createIssue(
      kind: $kind
      typeId: $typeId
      title: $title
      description: $description
      contactId: $contactId
      priority: $priority
      linkTargetType: $linkTargetType
      linkTargetId: $linkTargetId
    ) {
      ...IssueListFields
    }
  }
`;
const $047171b3f4119885$export$eb275db119aada7d = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$047171b3f4119885$var$ISSUE_LIST_FIELDS}
  mutation ChangeIssueStatus(
    $id: ID!
    $toStatus: IssueStatus!
    $resolution: String
    $reason: String
  ) {
    changeIssueStatus(id: $id, toStatus: $toStatus, resolution: $resolution, reason: $reason) {
      ...IssueListFields
      resolution
      resolvedAt
    }
  }
`;
const $047171b3f4119885$export$e3e5ec492e10f340 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$047171b3f4119885$var$ISSUE_LIST_FIELDS}
  mutation AssignIssue($id: ID!, $assigneeId: ID) {
    assignIssue(id: $id, assigneeId: $assigneeId) {
      ...IssueListFields
    }
  }
`;
const $047171b3f4119885$export$a0313c9e3952c70c = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation AddIssueComment($issueId: ID!, $body: String!, $isCustomerVisible: Boolean) {
    addIssueComment(issueId: $issueId, body: $body, isCustomerVisible: $isCustomerVisible) {
      id
      comments {
        id
        authorId
        authorName
        body
        isCustomerVisible
        createdAt
      }
    }
  }
`;
const $047171b3f4119885$export$cbfcf33edfce844c = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation NotifyContactAboutIssue($issueId: ID!, $templateId: ID) {
    notifyContactAboutIssue(issueId: $issueId, templateId: $templateId) {
      id
      status
      suppressionReason
      renderedBody
    }
  }
`;
const $047171b3f4119885$export$12fa00367f992389 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query IssueStats(
    $dateFrom: String!
    $dateTo: String!
    $groupBy: StatsGroupBy
    $bucket: StatsBucket
  ) {
    issueStats(dateFrom: $dateFrom, dateTo: $dateTo, groupBy: $groupBy, bucket: $bucket) {
      key
      label
      count
      resolvedCount
      reopenedCount
      medianHoursToResolve
      bucketStart
    }
  }
`;
const $047171b3f4119885$export$ae597b5e85500ea1 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query UrgentIssues {
    issues(
      page: 1
      pageSize: 5
      priorities: [URGENT]
      unassigned: true
      statuses: [OPEN, IN_PROGRESS]
    ) {
      totalCount
      items {
        id
        title
        reportedAt
        contact {
          id
          displayName
        }
      }
    }
  }
`;


/**
 * The Step 6 GraphQL documents: the dashboard, the ops panel, erasure.
 *
 * A third file, by step, for the reason queries.step5.js gives: a reviewer
 * looking at what Step 6 added should not have to diff a two-thousand-line
 * file to find it. `queries.js` re-exports everything.
 */ 
const $c0a10c62685d2613$export$7ec9de067149dc59 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  fragment MetricFields on Metric {
    name
    buckets
    total
    previousTotal
    deltaPct
    denominator
    suppressed
    rows {
      key
      label
      values
      total
      extraJson
    }
    definition {
      name
      titleFa
      titleEn
      section
      formula
      sources
      grain
      caveat
      needsConfirmation
      isScalar
      isRate
      perUser
    }
  }
`;
const $c0a10c62685d2613$export$906dd73ee0044751 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$c0a10c62685d2613$export$7ec9de067149dc59}
  query DashboardMetrics($names: [String!]!, $filter: MetricFilterInput) {
    metrics(names: $names, filter: $filter) {
      metrics {
        ...MetricFields
      }
      # A failing metric does not fail the dashboard: the card renders its
      # message in place of the number.
      errors {
        name
        message
      }
    }
  }
`;
const $c0a10c62685d2613$export$823454d9e232e181 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$c0a10c62685d2613$export$7ec9de067149dc59}
  query DashboardMetric($name: String!, $filter: MetricFilterInput) {
    metric(name: $name, filter: $filter) {
      ...MetricFields
    }
  }
`;
const $c0a10c62685d2613$export$ff9ca03ce8e1567c = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query MetricDefinitions {
    metricDefinitions {
      name
      titleFa
      titleEn
      section
      formula
      sources
      grain
      caveat
      needsConfirmation
      isScalar
      isRate
      perUser
    }
  }
`;
const $c0a10c62685d2613$export$f24c3e189ef0415a = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query MetricDrillDown(
    $metric: String!
    $key: String
    $filter: MetricFilterInput
    $limit: Int
  ) {
    metricDrillDown(metric: $metric, key: $key, filter: $filter, limit: $limit) {
      total
      contacts {
        id
        displayName
        collaborationStatus
        # The SCALAR. primaryPhone is a PhoneNumber object, so selecting it
        # bare made this whole query invalid — the drill-down never ran at all.
        primaryPhoneE164
      }
    }
  }
`;
const $c0a10c62685d2613$export$265bdcff49f3dab7 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query AnalyticsStatus {
    analyticsStatus {
      rebuildRunning
      whatsappSessionState
      rowCountsJson
      exchanges {
        exchange
        lastEventAt
        lagSeconds
        appliedCount
        unknownCount
      }
    }
  }
`;
const $c0a10c62685d2613$export$1db3a9c2cdc0237b = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query SystemHealth {
    systemHealth {
      checkedAt
      services {
        name
        address
        healthy
        detail
        latencyMs
      }
      analytics {
        rebuildRunning
        whatsappSessionState
        rowCountsJson
        exchanges {
          exchange
          lagSeconds
          appliedCount
          unknownCount
        }
      }
      projections {
        recipientCount
        # templateCount, lastEventAt and lagSeconds were selected here and
        # do not exist on ProjectionStatus — which made the whole systemHealth
        # query invalid, so the ops panel never rendered. The lag lives on the
        # per-source rows, which is where the Outbox banner reads it too.
        sources {
          source
          lastEvent
          lastEventAt
          lastAppliedAt
          appliedCount
        }
      }
      whatsapp {
        provider
        connected
        phoneE164
      }
    }
  }
`;
const $c0a10c62685d2613$export$7def131616ad6745 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query AuditLog(
    $page: Int
    $pageSize: Int
    $services: [String!]
    $actorId: ID
    $entityType: String
    $entityId: ID
    $dateFrom: String
    $dateTo: String
  ) {
    auditLog(
      page: $page
      pageSize: $pageSize
      services: $services
      actorId: $actorId
      entityType: $entityType
      entityId: $entityId
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      total
      items {
        id
        service
        actorId
        actorName
        action
        entityType
        entityId
        diffJson
        occurredAt
      }
    }
  }
`;
const $c0a10c62685d2613$export$9988b6e5e67ad43e = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation RebuildAnalytics($exchanges: [String!], $includeDimensions: Boolean) {
    rebuildAnalytics(exchanges: $exchanges, includeDimensions: $includeDimensions) {
      rebuildId
      state
      startedAt
      finishedAt
      replayedJson
      rowsBeforeJson
      rowsAfterJson
      detail
    }
  }
`;
const $c0a10c62685d2613$export$fa44c7e576a03193 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation EraseContact($contactId: ID!, $reason: String) {
    eraseContact(contactId: $contactId, reason: $reason) {
      contactId
      clearedFields
      photoDeleted
      downstreamServices
    }
  }
`;


const $13be303c7211393a$var$PHONE_FIELDS = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  fragment PhoneFields on PhoneNumber {
    id
    number
    label
    isPrimary
    channels {
      id
      code
      labelFa
    }
  }
`;
const $13be303c7211393a$export$9b2e8c059cb38823 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$PHONE_FIELDS}
  query Contacts(
    $page: Int!
    $pageSize: Int!
    $search: String
    $statuses: [CollaborationStatus!]
    $deleted: Boolean
  ) {
    contacts(
      page: $page
      pageSize: $pageSize
      search: $search
      statuses: $statuses
      deleted: $deleted
    ) {
      totalCount
      page
      pageSize
      items {
        id
        kind
        displayName
        collaborationStatus
        subscriptionType
        photoUrl
        deletedAt
        specialty {
          id
          labelFa
        }
        fieldOfWork {
          id
          labelFa
        }
        primaryPhone {
          ...PhoneFields
        }
        tags {
          id
          name
          colorHex
        }
        updatedAt
      }
    }
  }
`;
const $13be303c7211393a$export$424c3e2b2b2e6aa4 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$PHONE_FIELDS}
  fragment ContactFields on Contact {
    id
    kind
    displayName
    firstName
    lastName
    orgName
    birthDate
    gender
    description
    address
    instagramId
    collaborationStatus
    subscriptionType
    photoUrl
    photoAttachmentId
    deletedAt
    messagingOptOut
    fieldOfWork {
      id
      labelFa
    }
    specialty {
      id
      labelFa
    }
    subSpecialty {
      id
      labelFa
    }
    acquisitionSource {
      id
      labelFa
    }
    lifecycleStage {
      id
      labelFa
    }
    salesStage {
      id
      labelFa
    }
    customerHealth {
      id
      labelFa
    }
    engagementStatus {
      id
      labelFa
    }
    city {
      id
      labelFa
    }
    facilityType {
      id
      labelFa
      requiresDetail
    }
    centerName
    professionalCode
    referrerContactId
    referrerName
    isGold
    attachments {
      id
      fileName
      mimeType
      sizeBytes
      createdAt
    }
    phoneNumbers {
      ...PhoneFields
    }
    tags {
      id
      name
      colorHex
      isAssessment
    }
    interests {
      product {
        id
        labelFa
      }
      notes
    }
    customFields {
      id
      name
      labelFa
      type
      options
      isActive
      value
    }
    statusHistory {
      id
      fromStatus
      toStatus
      reason
      changedAt
      changedBy
      changedByName
    }
    affiliations {
      id
      personContactId
      organizationContactId
      personName
      organizationName
      roleTitle
    }
    createdAt
    updatedAt
  }
`;
const $13be303c7211393a$export$40a76660d65736ce = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$export$424c3e2b2b2e6aa4}
  query Contact($id: ID!) {
    contact(id: $id) {
      ...ContactFields
    }
  }
`;
const $13be303c7211393a$export$b16b176cffe7eb2b = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query Interactions(
    $contactId: ID!
    $page: Int!
    $pageSize: Int!
    $typeId: ID
    $dateFrom: String
    $dateTo: String
  ) {
    interactions(
      contactId: $contactId
      page: $page
      pageSize: $pageSize
      typeId: $typeId
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      totalCount
      page
      pageSize
      items {
        id
        occurredAt
        description
        status
        outcome
        createdBy
        createdByName
        followUpActivityId
        type {
          id
          labelFa
          code
        }
        attachments {
          id
          fileName
          mimeType
          sizeBytes
        }
      }
    }
  }
`;
const $13be303c7211393a$export$b21d8737225985c0 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation RecordInteraction($input: RecordInteractionInput!) {
    recordInteraction(input: $input) {
      id
      occurredAt
      description
      status
      outcome
      createdByName
      type {
        id
        labelFa
      }
    }
  }
`;
const $13be303c7211393a$export$fe262e7837b23f20 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation CreateContact($input: CreateContactInput!) {
    createContact(input: $input) {
      id
      displayName
    }
  }
`;
const $13be303c7211393a$export$2882fad028843c4d = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$export$424c3e2b2b2e6aa4}
  mutation UpdateContact($id: ID!, $input: UpdateContactInput!) {
    updateContact(id: $id, input: $input) {
      ...ContactFields
    }
  }
`;
const $13be303c7211393a$export$b75cf570f6a6871c = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$export$424c3e2b2b2e6aa4}
  mutation ChangeStatus($contactId: ID!, $toStatus: CollaborationStatus!, $reason: String) {
    changeCollaborationStatus(contactId: $contactId, toStatus: $toStatus, reason: $reason) {
      ...ContactFields
    }
  }
`;
const $13be303c7211393a$export$7846c1e041428763 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$export$424c3e2b2b2e6aa4}
  mutation AddPhone($contactId: ID!, $phoneNumber: PhoneNumberInput!) {
    addPhoneNumber(contactId: $contactId, phoneNumber: $phoneNumber) {
      ...ContactFields
    }
  }
`;
const $13be303c7211393a$export$f4b9f8e7332ad2b2 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$export$424c3e2b2b2e6aa4}
  mutation UpdatePhone($phoneNumberId: ID!, $numberRaw: String, $label: String, $notes: String) {
    updatePhoneNumber(
      phoneNumberId: $phoneNumberId
      numberRaw: $numberRaw
      label: $label
      notes: $notes
    ) {
      ...ContactFields
    }
  }
`;
const $13be303c7211393a$export$243aac1b21f2c5ae = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$export$424c3e2b2b2e6aa4}
  mutation RemovePhone($phoneNumberId: ID!) {
    removePhoneNumber(phoneNumberId: $phoneNumberId) {
      ...ContactFields
    }
  }
`;
const $13be303c7211393a$export$9199c4a746e9200 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$export$424c3e2b2b2e6aa4}
  mutation SetPrimaryPhone($phoneNumberId: ID!) {
    setPrimaryNumber(phoneNumberId: $phoneNumberId) {
      ...ContactFields
    }
  }
`;
const $13be303c7211393a$export$ad4a4d3fb42d49a6 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$export$424c3e2b2b2e6aa4}
  mutation SetPhoneChannels($phoneNumberId: ID!, $channelCodes: [String!]!) {
    setPhoneNumberChannels(phoneNumberId: $phoneNumberId, channelCodes: $channelCodes) {
      ...ContactFields
    }
  }
`;
const $13be303c7211393a$export$592dd87ffcd0d16a = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$export$424c3e2b2b2e6aa4}
  mutation SetInterests($contactId: ID!, $productIds: [ID!]!) {
    setInterests(contactId: $contactId, productIds: $productIds) {
      ...ContactFields
    }
  }
`;
const $13be303c7211393a$export$d4645122950b3dd3 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$export$424c3e2b2b2e6aa4}
  mutation TagContact($contactId: ID!, $tagId: ID!) {
    tagContact(contactId: $contactId, tagId: $tagId) {
      ...ContactFields
    }
  }
`;
const $13be303c7211393a$export$f5d4460b81cdbdcf = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$export$424c3e2b2b2e6aa4}
  mutation UntagContact($contactId: ID!, $tagId: ID!) {
    untagContact(contactId: $contactId, tagId: $tagId) {
      ...ContactFields
    }
  }
`;
const $13be303c7211393a$export$c0bfd20ca7055609 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$export$424c3e2b2b2e6aa4}
  mutation SetAffiliation(
    $personContactId: ID!
    $organizationContactId: ID!
    $roleTitle: String
  ) {
    setAffiliation(
      personContactId: $personContactId
      organizationContactId: $organizationContactId
      roleTitle: $roleTitle
    ) {
      ...ContactFields
    }
  }
`;
const $13be303c7211393a$export$c1cd75f1a3d9800f = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$export$424c3e2b2b2e6aa4}
  mutation RemoveAffiliation($personContactId: ID!, $organizationContactId: ID!) {
    removeAffiliation(
      personContactId: $personContactId
      organizationContactId: $organizationContactId
    ) {
      ...ContactFields
    }
  }
`;
const $13be303c7211393a$export$a5e8620403de4a6c = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation DeleteContact($id: ID!, $reason: String) {
    deleteContact(id: $id, reason: $reason) {
      id
      deletedAt
    }
  }
`;
const $13be303c7211393a$export$2fcd14942149ca8f = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation UndeleteContact($id: ID!) {
    undeleteContact(id: $id) {
      id
      deletedAt
    }
  }
`;
const $13be303c7211393a$export$4fdec73565eec05f = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query Me {
    me {
      id
      displayName
      role
      bypassed
      # Which halves of the MeshHub app the caller may use: the CRM here, the
      # platform back office at /platform. The BFF enforces both; this only
      # decides what the rail offers.
      access {
        platform
        crm
      }
    }
  }
`;
/* ---------- configuration (settings area) ---------- */ const $13be303c7211393a$var$LOOKUP_FIELDS = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  fragment LookupFields on Lookup {
    id
    kind
    code
    labelFa
    labelEn
    parentId
    isActive
    sortOrder
    isSystem
    requiresDetail
  }
`;
const $13be303c7211393a$export$d2d584f4325fcf08 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$LOOKUP_FIELDS}
  query AdminLookups($kind: String!, $includeInactive: Boolean!) {
    lookups(kind: $kind, includeInactive: $includeInactive) {
      ...LookupFields
    }
  }
`;
const $13be303c7211393a$export$bceff013a27ec1ea = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$LOOKUP_FIELDS}
  mutation CreateLookup($input: CreateLookupInput!) {
    createLookup(input: $input) {
      ...LookupFields
    }
  }
`;
const $13be303c7211393a$export$48b05fe6fa904f4b = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$LOOKUP_FIELDS}
  mutation UpdateLookup($input: UpdateLookupInput!) {
    updateLookup(input: $input) {
      ...LookupFields
    }
  }
`;
const $13be303c7211393a$export$c6cb79e861c7fb42 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$LOOKUP_FIELDS}
  mutation SetLookupActive($id: ID!, $isActive: Boolean!) {
    setLookupActive(id: $id, isActive: $isActive) {
      ...LookupFields
    }
  }
`;
const $13be303c7211393a$export$f444d57829178b1f = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$LOOKUP_FIELDS}
  mutation ReorderLookups($kind: String!, $orderedIds: [ID!]!) {
    reorderLookups(kind: $kind, orderedIds: $orderedIds) {
      ...LookupFields
    }
  }
`;
const $13be303c7211393a$var$TAG_FIELDS = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  fragment TagFields on Tag {
    id
    name
    colorHex
    isActive
    isAssessment
  }
`;
const $13be303c7211393a$export$c064f18f2e294629 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$TAG_FIELDS}
  query AdminTags($includeInactive: Boolean!) {
    tags(includeInactive: $includeInactive) {
      ...TagFields
    }
  }
`;
const $13be303c7211393a$export$14db7933f8d84816 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$TAG_FIELDS}
  mutation CreateTag($name: String!, $colorHex: String!, $isAssessment: Boolean) {
    createTag(name: $name, colorHex: $colorHex, isAssessment: $isAssessment) {
      ...TagFields
    }
  }
`;
const $13be303c7211393a$export$8090d300a1218c8 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$TAG_FIELDS}
  mutation UpdateTag(
    $id: ID!
    $name: String
    $colorHex: String
    $isAssessment: Boolean
  ) {
    updateTag(id: $id, name: $name, colorHex: $colorHex, isAssessment: $isAssessment) {
      ...TagFields
    }
  }
`;
const $13be303c7211393a$export$c189a2effcb3cc82 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$TAG_FIELDS}
  mutation SetTagActive($id: ID!, $isActive: Boolean!) {
    setTagActive(id: $id, isActive: $isActive) {
      ...TagFields
    }
  }
`;
const $13be303c7211393a$var$CUSTOM_FIELD_FIELDS = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  fragment CustomFieldFields on CustomFieldDefinition {
    id
    name
    labelFa
    type
    appliesTo
    options
    isActive
  }
`;
const $13be303c7211393a$export$3c145a0cae51e944 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$CUSTOM_FIELD_FIELDS}
  query CustomFields($includeInactive: Boolean!) {
    customFieldDefinitions(includeInactive: $includeInactive) {
      ...CustomFieldFields
    }
  }
`;
const $13be303c7211393a$export$6588b0f00bceb444 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$CUSTOM_FIELD_FIELDS}
  mutation CreateCustomField($input: CustomFieldDefinitionInput!) {
    createCustomFieldDefinition(input: $input) {
      ...CustomFieldFields
    }
  }
`;
const $13be303c7211393a$export$e970ae7328b2abf9 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$CUSTOM_FIELD_FIELDS}
  mutation UpdateCustomField($id: ID!, $input: CustomFieldDefinitionInput!) {
    updateCustomFieldDefinition(id: $id, input: $input) {
      ...CustomFieldFields
    }
  }
`;
const $13be303c7211393a$export$5062eff1685daf61 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$CUSTOM_FIELD_FIELDS}
  mutation SetCustomFieldActive($id: ID!, $isActive: Boolean!) {
    setCustomFieldDefinitionActive(id: $id, isActive: $isActive) {
      ...CustomFieldFields
    }
  }
`;
const $13be303c7211393a$var$TEMPLATE_FIELDS = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  fragment TemplateFields on MessageTemplate {
    id
    name
    body
    isActive
    channel {
      id
      code
      labelFa
    }
    category {
      id
      code
      labelFa
    }
  }
`;
const $13be303c7211393a$export$53468eed769bf661 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$TEMPLATE_FIELDS}
  query Templates($includeInactive: Boolean!) {
    messageTemplates(includeInactive: $includeInactive) {
      ...TemplateFields
    }
  }
`;
const $13be303c7211393a$export$6b3f4b0350c29d0e = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query ValidatePlaceholders($body: String!) {
    validatePlaceholders(body: $body) {
      valid
      allowed
      used
      errors {
        placeholder
        message
        position
      }
    }
  }
`;
const $13be303c7211393a$export$dcee5dee04648c93 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$TEMPLATE_FIELDS}
  mutation CreateTemplate($input: MessageTemplateInput!) {
    createMessageTemplate(input: $input) {
      ...TemplateFields
    }
  }
`;
const $13be303c7211393a$export$ba33506117bc02e3 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$TEMPLATE_FIELDS}
  mutation UpdateTemplate($id: ID!, $input: MessageTemplateInput!) {
    updateMessageTemplate(id: $id, input: $input) {
      ...TemplateFields
    }
  }
`;
const $13be303c7211393a$export$e44689c3b2734c03 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$TEMPLATE_FIELDS}
  mutation SetTemplateActive($id: ID!, $isActive: Boolean!) {
    setMessageTemplateActive(id: $id, isActive: $isActive) {
      ...TemplateFields
    }
  }
`;
const $13be303c7211393a$export$bba36a65d26d4ad8 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query Users($page: Int!, $pageSize: Int!) {
    users(page: $page, pageSize: $pageSize) {
      totalCount
      page
      pageSize
      items {
        id
        displayName
        role
        isActive
        firstSeenAt
        lastSeenAt
      }
    }
  }
`;
/* ========================================================================
 * Scheduling (Step 4)
 *
 * `Activity.contact` is a nested Contact even though the scheduling service
 * stores only an id — the BFF composes it through a batching loader, which is
 * the one place the two services meet. From here it is just a field.
 * ===================================================================== */ const $13be303c7211393a$var$ACTIVITY_FIELDS = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  fragment ActivityFields on Activity {
    id
    title
    description
    startsAt
    endsAt
    allDay
    status
    resultNote
    resultedAt
    orphaned
    source
    assignedTo
    contactId
    contact {
      id
      displayName
      collaborationStatus
    }
    type {
      id
      code
      labelFa
    }
    reminders {
      id
      remindAt
      channel
      firedAt
    }
    sync {
      googleEventId
      hasConflict
      conflictAt
    }
  }
`;
const $13be303c7211393a$export$7579a9be522a8054 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query ActivityAttachments($id: ID!) {
    activity(id: $id) {
      id
      attachments {
        id
        fileName
        mimeType
        sizeBytes
        createdAt
      }
    }
  }
`;
const $13be303c7211393a$export$30b197584a180028 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$ACTIVITY_FIELDS}
  query Calendar($dateFrom: String!, $dateTo: String!, $users: [ID!]) {
    calendar(dateFrom: $dateFrom, dateTo: $dateTo, users: $users) {
      ...ActivityFields
    }
  }
`;
const $13be303c7211393a$export$169c53b8a8e588c8 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$ACTIVITY_FIELDS}
  query Activities(
    $page: Int
    $pageSize: Int
    $contactId: ID
    $statuses: [ActivityStatus!]
    $dateFrom: String
    $dateTo: String
  ) {
    activities(
      page: $page
      pageSize: $pageSize
      contactId: $contactId
      statuses: $statuses
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      totalCount
      page
      pageSize
      items {
        ...ActivityFields
      }
    }
  }
`;
const $13be303c7211393a$export$aeca63296978d858 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$ACTIVITY_FIELDS}
  query Activity($id: ID!) {
    activity(id: $id) {
      ...ActivityFields
      checklists {
        id
        title
        templateId
        items {
          id
          title
          isDone
          doneAt
          sortOrder
        }
      }
    }
  }
`;
const $13be303c7211393a$export$76905cee0d96ad5e = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query ActivityTypes($includeInactive: Boolean) {
    activityTypes(includeInactive: $includeInactive) {
      id
      code
      labelFa
      labelEn
      isActive
      isSystem
      sortOrder
    }
  }
`;
const $13be303c7211393a$export$39328c7d9faf3888 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation CreateActivityType($input: ActivityTypeInput!) {
    createActivityType(input: $input) {
      id
      code
      labelFa
      labelEn
      isActive
      isSystem
      sortOrder
    }
  }
`;
const $13be303c7211393a$export$b8cf506a23320988 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation UpdateActivityType($id: ID!, $input: UpdateActivityTypeInput!) {
    updateActivityType(id: $id, input: $input) {
      id
      code
      labelFa
      labelEn
      isActive
      isSystem
      sortOrder
    }
  }
`;
const $13be303c7211393a$export$69b3d794de253f20 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation SetActivityTypeActive($id: ID!, $isActive: Boolean!) {
    setActivityTypeActive(id: $id, isActive: $isActive) {
      id
      isActive
    }
  }
`;
const $13be303c7211393a$export$ed4256ea0078549b = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$ACTIVITY_FIELDS}
  mutation CreateActivity($input: ActivityInput!) {
    createActivity(input: $input) {
      ...ActivityFields
    }
  }
`;
const $13be303c7211393a$export$d6c64a6ab1cc0107 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$ACTIVITY_FIELDS}
  mutation UpdateActivity($id: ID!, $input: ActivityInput!) {
    updateActivity(id: $id, input: $input) {
      ...ActivityFields
    }
  }
`;
const $13be303c7211393a$export$3e128542718f832c = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$ACTIVITY_FIELDS}
  mutation ChangeActivityStatus(
    $id: ID!
    $toStatus: ActivityStatus!
    $resultNote: String
    $reason: String
  ) {
    changeActivityStatus(
      id: $id
      toStatus: $toStatus
      resultNote: $resultNote
      reason: $reason
    ) {
      ...ActivityFields
    }
  }
`;
const $13be303c7211393a$export$621d5565408ec3f3 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation DeleteActivity($id: ID!) {
    deleteActivity(id: $id) {
      id
      deletedAt
    }
  }
`;
const $13be303c7211393a$export$123be1de0d50e4e3 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$ACTIVITY_FIELDS}
  mutation SetReminders($activityId: ID!, $reminders: [ReminderInput!]!) {
    setReminders(activityId: $activityId, reminders: $reminders) {
      ...ActivityFields
    }
  }
`;
const $13be303c7211393a$export$67cc7384e85bd2f2 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$ACTIVITY_FIELDS}
  mutation CreateFollowUp($interactionId: ID!, $input: ActivityInput!) {
    createFollowUpFromInteraction(interactionId: $interactionId, input: $input) {
      activity {
        ...ActivityFields
      }
      interaction {
        id
        followUpActivityId
      }
    }
  }
`;
const $13be303c7211393a$export$20635703b116d48d = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query FollowUps($state: SuggestionState) {
    followUpSuggestions(state: $state) {
      id
      reason
      state
      suggestedAt
      contactId
      contact {
        id
        displayName
      }
      activity {
        id
        title
        startsAt
        type {
          id
          labelFa
        }
      }
    }
  }
`;
const $13be303c7211393a$export$a374dbe2b0fba9f6 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation AcceptSuggestion($id: ID!, $input: ActivityInput!) {
    acceptSuggestion(id: $id, input: $input) {
      id
      state
      createdActivityId
    }
  }
`;
const $13be303c7211393a$export$9c1728c7497ad15d = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation DismissSuggestion($id: ID!) {
    dismissSuggestion(id: $id) {
      id
      state
    }
  }
`;
const $13be303c7211393a$export$292885ccfb78e1d8 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query DueReminders($since: String) {
    dueReminders(since: $since) {
      reminder {
        id
        remindAt
        firedAt
      }
      activity {
        id
        title
        startsAt
        contact {
          id
          displayName
        }
      }
    }
  }
`;
const $13be303c7211393a$var$CHECKLIST_FIELDS = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  fragment ChecklistFields on Checklist {
    id
    title
    ownerType
    ownerId
    templateId
    items {
      id
      title
      isDone
      doneAt
      sortOrder
    }
  }
`;
const $13be303c7211393a$export$48bc793f71228ca6 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$CHECKLIST_FIELDS}
  query Checklists($ownerType: ChecklistOwner!, $ownerId: ID!) {
    checklists(ownerType: $ownerType, ownerId: $ownerId) {
      ...ChecklistFields
    }
  }
`;
const $13be303c7211393a$export$68d6e722992ca7ca = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  query ChecklistTemplates($includeInactive: Boolean) {
    checklistTemplates(includeInactive: $includeInactive) {
      id
      title
      description
      isActive
      isSystem
      items {
        id
        title
        sortOrder
      }
    }
  }
`;
const $13be303c7211393a$export$7aa9473f85afc7a = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation CreateChecklistTemplate($input: ChecklistTemplateInput!) {
    createChecklistTemplate(input: $input) {
      id
    }
  }
`;
const $13be303c7211393a$export$1ad4459b0390dadd = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation UpdateChecklistTemplate($id: ID!, $input: ChecklistTemplateInput!) {
    updateChecklistTemplate(id: $id, input: $input) {
      id
    }
  }
`;
const $13be303c7211393a$export$d31b8b684d42dab8 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  mutation SetChecklistTemplateActive($id: ID!, $isActive: Boolean!) {
    setChecklistTemplateActive(id: $id, isActive: $isActive) {
      id
      isActive
    }
  }
`;
const $13be303c7211393a$export$fbd174fc100d5ca5 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$CHECKLIST_FIELDS}
  mutation CreateChecklist(
    $ownerType: ChecklistOwner!
    $ownerId: ID!
    $title: String
    $templateId: ID
  ) {
    createChecklist(
      ownerType: $ownerType
      ownerId: $ownerId
      title: $title
      templateId: $templateId
    ) {
      ...ChecklistFields
    }
  }
`;
const $13be303c7211393a$export$196a6e805067bdb6 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$CHECKLIST_FIELDS}
  mutation ToggleChecklistItem($itemId: ID!, $isDone: Boolean!) {
    toggleChecklistItem(itemId: $itemId, isDone: $isDone) {
      ...ChecklistFields
    }
  }
`;
const $13be303c7211393a$export$1d1a45c6fc413210 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$CHECKLIST_FIELDS}
  mutation AddChecklistItem($checklistId: ID!, $title: String!) {
    addChecklistItem(checklistId: $checklistId, title: $title) {
      ...ChecklistFields
    }
  }
`;
const $13be303c7211393a$var$GOOGLE_CONNECTION_FIELDS = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  fragment GoogleConnectionFields on GoogleConnection {
    configured
    connected
    googleEmail
    calendarId
    connectedAt
    lastSyncAt
    lastError
    connectUrl
    recent {
      direction
      entity
      outcome
      error
      at
    }
  }
`;
const $13be303c7211393a$export$c934b5b4ba3d37d1 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$GOOGLE_CONNECTION_FIELDS}
  query GoogleConnection {
    googleConnection {
      ...GoogleConnectionFields
    }
  }
`;
const $13be303c7211393a$export$a55e62122bd685e = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$GOOGLE_CONNECTION_FIELDS}
  mutation SyncGoogleNow {
    syncGoogleNow {
      pushed
      pulled
      imported
      conflicts
      tasks
      errors
      skippedReason
      connection {
        ...GoogleConnectionFields
      }
    }
  }
`;
const $13be303c7211393a$export$a57372ef6713ed79 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$GOOGLE_CONNECTION_FIELDS}
  mutation DisconnectGoogle {
    disconnectGoogle {
      ...GoogleConnectionFields
    }
  }
`;
const $13be303c7211393a$export$8ef7c2a226fc63e3 = (0, $f1082495fae7e77b$export$72e4926bf8358653)`
  ${$13be303c7211393a$var$GOOGLE_CONNECTION_FIELDS}
  mutation SetGoogleCalendar($calendarId: String!) {
    setGoogleCalendar(calendarId: $calendarId) {
      ...GoogleConnectionFields
    }
  }
`;


/**
 * Localization, handled CENTRALLY — never per component (CLAUDE.md §12).
 *
 * Three rules this module exists to enforce:
 *   1. Storage is UTC; display is Jalali (Shamsi). Conversion happens here.
 *   2. Persian digits are a *presentation* form, applied at format time and
 *      never stored or sent back to the API.
 *   3. Phone numbers and other LTR islands are marked as such by the caller
 *      (dir="ltr"), because an RTL page mangles them otherwise.
 */ /**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $11b80e3ab1e4e153$export$dfd9b671c89acc8e = 7;
const $11b80e3ab1e4e153$export$3913210603d8e9ae = 365.2425;
const $11b80e3ab1e4e153$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $11b80e3ab1e4e153$export$4dec998e48f9c246 = -$11b80e3ab1e4e153$export$81caae6e1cc7a622;
const $11b80e3ab1e4e153$export$4fad13613e88edc8 = 604800000;
const $11b80e3ab1e4e153$export$b76b1809a2898f9a = 86400000;
const $11b80e3ab1e4e153$export$91246f0b9bd9beff = 60000;
const $11b80e3ab1e4e153$export$7f72910d6dfd237a = 3600000;
const $11b80e3ab1e4e153$export$397c2d5776aa9055 = 1000;
const $11b80e3ab1e4e153$export$3633035e63cee86a = 525600;
const $11b80e3ab1e4e153$export$ab7da2ccd1075c38 = 43200;
const $11b80e3ab1e4e153$export$2423174df8cd3cd2 = 1440;
const $11b80e3ab1e4e153$export$f2f5ae5a8e2d8f9f = 60;
const $11b80e3ab1e4e153$export$3c58128db900d44e = 3;
const $11b80e3ab1e4e153$export$80d7e435f744f319 = 12;
const $11b80e3ab1e4e153$export$4db7641526e3241f = 4;
const $11b80e3ab1e4e153$export$698aec755e92c695 = 3600;
const $11b80e3ab1e4e153$export$a77c1a7ebebe2a5a = 60;
const $11b80e3ab1e4e153$export$815a9362476d2fe3 = $11b80e3ab1e4e153$export$698aec755e92c695 * 24;
const $11b80e3ab1e4e153$export$34804a017b31e2fe = $11b80e3ab1e4e153$export$815a9362476d2fe3 * 7;
const $11b80e3ab1e4e153$export$7271e9e3478110d1 = $11b80e3ab1e4e153$export$815a9362476d2fe3 * $11b80e3ab1e4e153$export$3913210603d8e9ae;
const $11b80e3ab1e4e153$export$8e6600bbdee7dabb = $11b80e3ab1e4e153$export$7271e9e3478110d1 / 12;
const $11b80e3ab1e4e153$export$be1dccf2de902d31 = $11b80e3ab1e4e153$export$8e6600bbdee7dabb * 3;
const $11b80e3ab1e4e153$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");


const $08fdb7588d4cb299$var$PERSIAN_EPOCH = 1948320;
const $08fdb7588d4cb299$var$PERSIAN_NUM_DAYS = [
    0,
    31,
    62,
    93,
    124,
    155,
    186,
    216,
    246,
    276,
    306,
    336
];
function $08fdb7588d4cb299$export$b20224aa730f4092(gy, gm, gd) {
    return $08fdb7588d4cb299$export$899c1875413e119a($08fdb7588d4cb299$export$139c1497b1db9ced(gy, gm, gd));
}
function $08fdb7588d4cb299$export$5dd73e2bc1d686cd(jy, jm, jd) {
    return $08fdb7588d4cb299$export$1916ca8559c28572($08fdb7588d4cb299$export$4f8990bb611e0b64(jy, jm, jd));
}
function $08fdb7588d4cb299$export$b404427083bd986a(jy) {
    if (jy === -3) // to be compatible with other calculations
    return false;
    const m = $08fdb7588d4cb299$var$mod(25 * jy + 11, 33);
    return m < 8 && m >= -1 || m <= -27;
}
function $08fdb7588d4cb299$export$18ac9a377c3b5961(gy) {
    return gy % 4 == 0 && !(gy % 100 == 0 && !(gy % 400 == 0));
}
function $08fdb7588d4cb299$export$4f8990bb611e0b64(jy, jm, jd) {
    const [ny, nm] = $08fdb7588d4cb299$export$80b027a317f1af5a(jy, jm);
    jy = ny;
    jm = nm;
    const month = jm - 1;
    const year = jy;
    const day = jd;
    let julianDay = $08fdb7588d4cb299$var$PERSIAN_EPOCH - 1 + 365 * (year - 1) + $08fdb7588d4cb299$var$div(8 * year + 21, 33);
    if (month != 0) julianDay += $08fdb7588d4cb299$var$PERSIAN_NUM_DAYS[month];
    return julianDay + day;
}
function $08fdb7588d4cb299$export$899c1875413e119a(julianDay) {
    if (isNaN(julianDay)) return {
        jy: NaN,
        jm: NaN,
        jd: NaN
    };
    let month, dayOfYear;
    const daysSinceEpoch = julianDay - $08fdb7588d4cb299$var$PERSIAN_EPOCH;
    let year = 1 + $08fdb7588d4cb299$var$div(33 * daysSinceEpoch + 3, 12053);
    dayOfYear = daysSinceEpoch - (365 * (year - 1) + $08fdb7588d4cb299$var$div(8 * year + 21, 33)); // 0-based
    if (dayOfYear < 0) {
        year--;
        dayOfYear = daysSinceEpoch - (365 * (year - 1) + $08fdb7588d4cb299$var$div(8 * year + 21, 33));
    }
    if (dayOfYear < 216) // Compute 0-based month
    month = $08fdb7588d4cb299$var$div(dayOfYear, 31);
    else month = $08fdb7588d4cb299$var$div(dayOfYear - 6, 30);
    const dayOfMonth = dayOfYear - $08fdb7588d4cb299$var$PERSIAN_NUM_DAYS[month] + 1;
    dayOfYear++; // Make it 1-based now
    const jy = year;
    const jm = month + 1;
    const jd = dayOfMonth;
    return {
        jy: jy,
        jm: jm,
        jd: jd
    };
}
function $08fdb7588d4cb299$export$139c1497b1db9ced(gy, gm, gd) {
    const [ny, nm] = $08fdb7588d4cb299$export$80b027a317f1af5a(gy, gm);
    gy = ny;
    gm = nm;
    return $08fdb7588d4cb299$var$div(1461 * (gy + 4800 + $08fdb7588d4cb299$var$div(gm - 14, 12)), 4) + $08fdb7588d4cb299$var$div(367 * (gm - 2 - 12 * $08fdb7588d4cb299$var$div(gm - 14, 12)), 12) - $08fdb7588d4cb299$var$div(3 * $08fdb7588d4cb299$var$div(gy + 4900 + $08fdb7588d4cb299$var$div(gm - 14, 12), 100), 4) + gd - 32075;
}
function $08fdb7588d4cb299$export$1916ca8559c28572(jdn) {
    if (isNaN(jdn)) return {
        gy: NaN,
        gm: NaN,
        gd: NaN
    };
    let L = jdn + 68569;
    const n = $08fdb7588d4cb299$var$div(4 * L, 146097);
    L = L - $08fdb7588d4cb299$var$div(146097 * n + 3, 4);
    const i = $08fdb7588d4cb299$var$div(4000 * (L + 1), 1461001);
    L = L - $08fdb7588d4cb299$var$div(1461 * i, 4) + 31;
    const j = $08fdb7588d4cb299$var$div(80 * L, 2447);
    const gd = L - $08fdb7588d4cb299$var$div(2447 * j, 80);
    L = $08fdb7588d4cb299$var$div(j, 11);
    const gm = j + 2 - 12 * L;
    const gy = 100 * (n - 49) + i + L;
    return {
        gy: gy,
        gm: gm,
        gd: gd
    };
}
function $08fdb7588d4cb299$export$80b027a317f1af5a(year, month) {
    month = month - 1;
    if (month < 0) {
        const old_month = month;
        month = $08fdb7588d4cb299$var$pmod(month, 12);
        year -= $08fdb7588d4cb299$var$div(month - old_month, 12);
    }
    if (month > 11) {
        year += $08fdb7588d4cb299$var$div(month, 12);
        month = $08fdb7588d4cb299$var$mod(month, 12);
    }
    return [
        year,
        month + 1
    ];
}
/*
  Utility helper functions.
*/ function $08fdb7588d4cb299$var$div(a, b) {
    return ~~(a / b);
}
function $08fdb7588d4cb299$var$mod(a, b) {
    return a - ~~(a / b) * b;
}
// mod always return positive number
function $08fdb7588d4cb299$var$pmod(a, b) {
    return $08fdb7588d4cb299$var$mod($08fdb7588d4cb299$var$mod(a, b) + b, b);
}


function $fb07d2974af45058$export$dc59854f87f8c633(...args) {
    if (args.length > 1) {
        const [year, month, day = 1, ...rest] = args;
        const g = (0, $08fdb7588d4cb299$export$5dd73e2bc1d686cd)(year, month + 1, day);
        return new Date(...[
            g.gy,
            g.gm - 1,
            g.gd,
            ...rest
        ]);
    }
    return new Date(...args);
}


function $4558a23d2098dccf$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $11b80e3ab1e4e153$export$2a7b97929c48d47d) in date) return date[0, $11b80e3ab1e4e153$export$2a7b97929c48d47d](value);
    if (date instanceof Date) return new date.constructor(value);
    return (0, $fb07d2974af45058$export$dc59854f87f8c633)(value);
}
var // Fallback for modularized imports:
$4558a23d2098dccf$export$2e2bcd8739ae039 = $4558a23d2098dccf$export$ead8a1812b171991;



function $3031c7cbe07ac8a4$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $4558a23d2098dccf$export$ead8a1812b171991)(context || argument, argument);
}
var // Fallback for modularized imports:
$3031c7cbe07ac8a4$export$2e2bcd8739ae039 = $3031c7cbe07ac8a4$export$e67a095c620b86fe;



function $07a5aee0b2ab35ee$export$6ce1b5acc29cb53b(cleanDate) {
    const gd = cleanDate.getDate();
    const gm = cleanDate.getMonth() + 1;
    const gy = cleanDate.getFullYear();
    return (0, $08fdb7588d4cb299$export$b20224aa730f4092)(gy, gm, gd).jm - 1;
}



function $89b9b0a19d744029$export$63264690f8e36790(cleanDate, ...args) {
    const gd = cleanDate.getDate();
    const gm = cleanDate.getMonth() + 1;
    const gy = cleanDate.getFullYear();
    const j = (0, $08fdb7588d4cb299$export$b20224aa730f4092)(gy, gm, gd);
    const [month, date = j.jd] = args;
    const g = (0, $08fdb7588d4cb299$export$5dd73e2bc1d686cd)(j.jy, month + 1, date);
    return cleanDate.setFullYear(g.gy, g.gm - 1, g.gd);
}



function $1e8f3299fd78be22$export$aa350b96d91cd94(cleanDate) {
    const gd = cleanDate.getDate();
    const gm = cleanDate.getMonth() + 1;
    const gy = cleanDate.getFullYear();
    return (0, $08fdb7588d4cb299$export$b20224aa730f4092)(gy, gm, gd).jd;
}



function $5164498ef15241bd$export$bc715fab9217bc6f(cleanDate) {
    const gd = cleanDate.getDate();
    const gm = cleanDate.getMonth() + 1;
    const gy = cleanDate.getFullYear();
    return (0, $08fdb7588d4cb299$export$b20224aa730f4092)(gy, gm, gd).jy;
}



function $4cbebb0ad625a795$export$2a89662e70105846(cleanDate, ...args) {
    const gd = cleanDate.getDate();
    const gm = cleanDate.getMonth() + 1;
    const gy = cleanDate.getFullYear();
    const j = (0, $08fdb7588d4cb299$export$b20224aa730f4092)(gy, gm, gd);
    const [year, month = j.jm - 1, date = j.jd] = args;
    const g = (0, $08fdb7588d4cb299$export$5dd73e2bc1d686cd)(year, month + 1, date);
    return cleanDate.setFullYear(g.gy, g.gm - 1, g.gd);
}


function $5432326631fed4eb$export$17c93e242b2d3a22(date, amount, options) {
    const _date = (0, $3031c7cbe07ac8a4$export$e67a095c620b86fe)(date, options?.in);
    if (isNaN(amount)) return (0, $4558a23d2098dccf$export$ead8a1812b171991)(options?.in || date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = (0, $1e8f3299fd78be22$export$aa350b96d91cd94)(_date);
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $4558a23d2098dccf$export$ead8a1812b171991)(options?.in || date, _date.getTime());
    (0, $89b9b0a19d744029$export$63264690f8e36790)(endOfDesiredMonth, (0, $07a5aee0b2ab35ee$export$6ce1b5acc29cb53b)(_date) + amount + 1, 0);
    const daysInMonth = (0, $1e8f3299fd78be22$export$aa350b96d91cd94)(endOfDesiredMonth);
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        (0, $4cbebb0ad625a795$export$2a89662e70105846)(_date, (0, $5164498ef15241bd$export$bc715fab9217bc6f)(endOfDesiredMonth), (0, $07a5aee0b2ab35ee$export$6ce1b5acc29cb53b)(endOfDesiredMonth), dayOfMonth);
        return _date;
    }
}
var // Fallback for modularized imports:
$5432326631fed4eb$export$2e2bcd8739ae039 = $5432326631fed4eb$export$17c93e242b2d3a22;

const $a352b2dc2a4b5acc$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062B\u0627\u0646\u06CC\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    xSeconds: {
        one: "1 \u062B\u0627\u0646\u06CC\u0647",
        other: "{{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    halfAMinute: "\u0646\u06CC\u0645 \u062F\u0642\u06CC\u0642\u0647",
    lessThanXMinutes: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062F\u0642\u06CC\u0642\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    xMinutes: {
        one: "1 \u062F\u0642\u06CC\u0642\u0647",
        other: "{{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    aboutXHours: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0639\u062A",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0639\u062A"
    },
    xHours: {
        one: "1 \u0633\u0627\u0639\u062A",
        other: "{{count}} \u0633\u0627\u0639\u062A"
    },
    xDays: {
        one: "1 \u0631\u0648\u0632",
        other: "{{count}} \u0631\u0648\u0632"
    },
    aboutXWeeks: {
        one: "\u062D\u062F\u0648\u062F 1 \u0647\u0641\u062A\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0647\u0641\u062A\u0647"
    },
    xWeeks: {
        one: "1 \u0647\u0641\u062A\u0647",
        other: "{{count}} \u0647\u0641\u062A\u0647"
    },
    aboutXMonths: {
        one: "\u062D\u062F\u0648\u062F 1 \u0645\u0627\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0645\u0627\u0647"
    },
    xMonths: {
        one: "1 \u0645\u0627\u0647",
        other: "{{count}} \u0645\u0627\u0647"
    },
    aboutXYears: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0644",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0644"
    },
    xYears: {
        one: "1 \u0633\u0627\u0644",
        other: "{{count}} \u0633\u0627\u0644"
    },
    overXYears: {
        one: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 1 \u0633\u0627\u0644",
        other: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 {{count}} \u0633\u0627\u0644"
    },
    almostXYears: {
        one: "\u0646\u0632\u062F\u06CC\u06A9 1 \u0633\u0627\u0644",
        other: "\u0646\u0632\u062F\u06CC\u06A9 {{count}} \u0633\u0627\u0644"
    }
};
const $a352b2dc2a4b5acc$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $a352b2dc2a4b5acc$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u062F\u0631 " + result;
        else return result + " \u0642\u0628\u0644";
    }
    return result;
};


function $1a263a0253079032$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $2192aee677d1edaf$var$dateFormats = {
    full: "EEEE do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "yyyy/MM/dd"
};
const $2192aee677d1edaf$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $2192aee677d1edaf$var$dateTimeFormats = {
    full: "{{date}} '\u062F\u0631' {{time}}",
    long: "{{date}} '\u062F\u0631' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $2192aee677d1edaf$export$cbf60ecb96cbb82f = {
    date: (0, $1a263a0253079032$export$38e44e97ce4dbb7d)({
        formats: $2192aee677d1edaf$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $1a263a0253079032$export$38e44e97ce4dbb7d)({
        formats: $2192aee677d1edaf$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $1a263a0253079032$export$38e44e97ce4dbb7d)({
        formats: $2192aee677d1edaf$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $6d30d2ee8c02df5b$var$formatRelativeLocale = {
    lastWeek: "eeee '\u06AF\u0630\u0634\u062A\u0647 \u062F\u0631' p",
    yesterday: "'\u062F\u06CC\u0631\u0648\u0632 \u062F\u0631' p",
    today: "'\u0627\u0645\u0631\u0648\u0632 \u062F\u0631' p",
    tomorrow: "'\u0641\u0631\u062F\u0627 \u062F\u0631' p",
    nextWeek: "eeee '\u062F\u0631' p",
    other: "P"
};
const $6d30d2ee8c02df5b$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$6d30d2ee8c02df5b$var$formatRelativeLocale[token];


/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $9c7f5596ec43e54e$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $a072cc2cb603124f$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0647.",
        "\u0628.\u0647."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0632 \u0647\u062C\u0631\u062A",
        "\u0628\u0639\u062F \u0627\u0632 \u0647\u062C\u0631\u062A"
    ]
};
const $a072cc2cb603124f$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u0633\u200C\u06451",
        "\u0633\u200C\u06452",
        "\u0633\u200C\u06453",
        "\u0633\u200C\u06454"
    ],
    wide: [
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 1",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 2",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 3",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 4"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $a072cc2cb603124f$var$monthValues = {
    narrow: [
        "\u0641\u0631",
        "\u0627\u0631",
        "\u062E\u0631",
        "\u062A\u06CC",
        "\u0645\u0631",
        "\u0634\u0647",
        "\u0645\u0647",
        "\u0622\u0628",
        "\u0622\u0630",
        "\u062F\u06CC",
        "\u0628\u0647",
        "\u0627\u0633"
    ],
    abbreviated: [
        "\u0641\u0631\u0648",
        "\u0627\u0631\u062F",
        "\u062E\u0631\u062F",
        "\u062A\u06CC\u0631",
        "\u0645\u0631\u062F",
        "\u0634\u0647\u0631",
        "\u0645\u0647\u0631",
        "\u0622\u0628\u0627",
        "\u0622\u0630\u0631",
        "\u062F\u06CC",
        "\u0628\u0647\u0645",
        "\u0627\u0633\u0641"
    ],
    wide: [
        "\u0641\u0631\u0648\u0631\u062F\u06CC\u0646",
        "\u0627\u0631\u062F\u06CC\u0628\u0647\u0634\u062A",
        "\u062E\u0631\u062F\u0627\u062F",
        "\u062A\u06CC\u0631",
        "\u0645\u0631\u062F\u0627\u062F",
        "\u0634\u0647\u0631\u06CC\u0648\u0631",
        "\u0645\u0647\u0631",
        "\u0622\u0628\u0627\u0646",
        "\u0622\u0630\u0631",
        "\u062F\u06CC",
        "\u0628\u0647\u0645\u0646",
        "\u0627\u0633\u0641\u0646\u062F"
    ]
};
const $a072cc2cb603124f$var$dayValues = {
    narrow: [
        "\u06CC",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    short: [
        "1\u0634",
        "2\u0634",
        "3\u0634",
        "4\u0634",
        "5\u0634",
        "\u062C",
        "\u0634"
    ],
    abbreviated: [
        "\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ],
    wide: [
        "\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ]
};
const $a072cc2cb603124f$var$dayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
const $a072cc2cb603124f$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
const $a072cc2cb603124f$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + "-\u0627\u0645";
};
const $a072cc2cb603124f$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $a072cc2cb603124f$var$ordinalNumber,
    era: (0, $9c7f5596ec43e54e$export$63596d6ee8878b25)({
        values: $a072cc2cb603124f$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $9c7f5596ec43e54e$export$63596d6ee8878b25)({
        values: $a072cc2cb603124f$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $9c7f5596ec43e54e$export$63596d6ee8878b25)({
        values: $a072cc2cb603124f$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $9c7f5596ec43e54e$export$63596d6ee8878b25)({
        values: $a072cc2cb603124f$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $9c7f5596ec43e54e$export$63596d6ee8878b25)({
        values: $a072cc2cb603124f$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $a072cc2cb603124f$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $964e61d9f05685d8$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $964e61d9f05685d8$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $964e61d9f05685d8$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $964e61d9f05685d8$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $964e61d9f05685d8$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $3121270271a75d4e$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $594fd82cd0cbeb97$var$matchOrdinalNumberPattern = /^(\d+)(-?ام)?/i;
const $594fd82cd0cbeb97$var$parseOrdinalNumberPattern = /\d+/i;
const $594fd82cd0cbeb97$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?ه\.?|ب\.?\s?ه\.?|ه\.?)/i,
    wide: /^(قبل از هجرت|هجری شمسی|بعد از هجرت)/i
};
const $594fd82cd0cbeb97$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
const $594fd82cd0cbeb97$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^(ف|Q|س‌م)[1234]/i,
    wide: /^(فصل|quarter|سه‌ماهه) [1234](-ام|ام)?/i
};
const $594fd82cd0cbeb97$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $594fd82cd0cbeb97$var$matchMonthPatterns = {
    narrow: /^(فر|ار|خر|تی|مر|شه|مه|آب|آذ|دی|به|اس)/i,
    abbreviated: /^(فرو|ارد|خرد|تیر|مرد|شهر|مهر|آبا|آذر|دی|بهم|اسف)/i,
    wide: /^(فروردین|اردیبهشت|خرداد|تیر|مرداد|شهریور|مهر|آبان|آذر|دی|بهمن|اسفند)/i
};
const $594fd82cd0cbeb97$var$parseMonthPatterns = {
    narrow: [
        /^فر/i,
        /^ار/i,
        /^خر/i,
        /^تی/i,
        /^مر/i,
        /^شه/i,
        /^مه/i,
        /^آب/i,
        /^آذ/i,
        /^دی/i,
        /^به/i,
        /^اس/i
    ],
    any: [
        /^فر/i,
        /^ار/i,
        /^خر/i,
        /^تی/i,
        /^مر/i,
        /^شه/i,
        /^مه/i,
        /^آب/i,
        /^آذ/i,
        /^دی/i,
        /^به/i,
        /^اس/i
    ]
};
const $594fd82cd0cbeb97$var$matchDayPatterns = {
    narrow: /^[شیدسچپج]/i,
    short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
    abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
    wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
};
const $594fd82cd0cbeb97$var$parseDayPatterns = {
    narrow: [
        /^ی/i,
        /^دو/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^(ی|1ش|یکشنبه)/i,
        /^(د|2ش|دوشنبه)/i,
        /^(س|3ش|سه‌شنبه)/i,
        /^(چ|4ش|چهارشنبه)/i,
        /^(پ|5ش|پنجشنبه)/i,
        /^(ج|جمعه)/i,
        /^(ش|شنبه)/i
    ]
};
const $594fd82cd0cbeb97$var$matchDayPeriodPatterns = {
    narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
    any: /^(ق.ظ.|ب.ظ.|قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
};
const $594fd82cd0cbeb97$var$parseDayPeriodPatterns = {
    any: {
        am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
        pm: /^(ب|ب.ظ.|بعدازظهر)/i,
        midnight: /^(‌نیمه‌شب|ن)/i,
        noon: /^(ظ|ظهر)/i,
        morning: /^(ص|صبح)/i,
        afternoon: /^(ب|ب.ظ.|بعدازظهر)/i,
        evening: /^(ع|عصر)/i,
        night: /^(ش|شب)/i
    }
};
const $594fd82cd0cbeb97$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $3121270271a75d4e$export$fdaf2fd6d7edde95)({
        matchPattern: $594fd82cd0cbeb97$var$matchOrdinalNumberPattern,
        parsePattern: $594fd82cd0cbeb97$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $964e61d9f05685d8$export$1430a0f35710914d)({
        matchPatterns: $594fd82cd0cbeb97$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $594fd82cd0cbeb97$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $964e61d9f05685d8$export$1430a0f35710914d)({
        matchPatterns: $594fd82cd0cbeb97$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $594fd82cd0cbeb97$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $964e61d9f05685d8$export$1430a0f35710914d)({
        matchPatterns: $594fd82cd0cbeb97$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $594fd82cd0cbeb97$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $964e61d9f05685d8$export$1430a0f35710914d)({
        matchPatterns: $594fd82cd0cbeb97$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $594fd82cd0cbeb97$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $964e61d9f05685d8$export$1430a0f35710914d)({
        matchPatterns: $594fd82cd0cbeb97$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $594fd82cd0cbeb97$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $2ae9407ce37e1a2e$export$355e05e1e35701f3 = {
    code: "fa-IR",
    formatDistance: (0, $a352b2dc2a4b5acc$export$2c14ff85d6318973),
    formatLong: (0, $2192aee677d1edaf$export$cbf60ecb96cbb82f),
    formatRelative: (0, $6d30d2ee8c02df5b$export$8fbbfd65594f46a0),
    localize: (0, $a072cc2cb603124f$export$b3bd0bc58e36cd63),
    match: (0, $594fd82cd0cbeb97$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 6 /* Sat */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$2ae9407ce37e1a2e$export$2e2bcd8739ae039 = $2ae9407ce37e1a2e$export$355e05e1e35701f3;


let $d509f3f8eb02ebdb$var$defaultOptions = {};
function $d509f3f8eb02ebdb$export$430a3269e24b912e() {
    return $d509f3f8eb02ebdb$var$defaultOptions;
}
function $d509f3f8eb02ebdb$export$95365be1b0704abc(newOptions) {
    $d509f3f8eb02ebdb$var$defaultOptions = newOptions;
}



function $a2296a1d3f9eb6ba$export$113002b5eff6e430(date) {
    const _date = (0, $3031c7cbe07ac8a4$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}



function $19971bf034cb86da$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $4558a23d2098dccf$export$ead8a1812b171991).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}




function $133aec35fde1e9b4$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $3031c7cbe07ac8a4$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$133aec35fde1e9b4$export$2e2bcd8739ae039 = $133aec35fde1e9b4$export$63fa379ae8a9ba2;


function $6731760c7cccaf14$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $19971bf034cb86da$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $133aec35fde1e9b4$export$63fa379ae8a9ba2)(laterDate_);
    const earlierStartOfDay = (0, $133aec35fde1e9b4$export$63fa379ae8a9ba2)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $a2296a1d3f9eb6ba$export$113002b5eff6e430)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $a2296a1d3f9eb6ba$export$113002b5eff6e430)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $11b80e3ab1e4e153$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$6731760c7cccaf14$export$2e2bcd8739ae039 = $6731760c7cccaf14$export$4a02e9c37dab4871;





function $0d123e530d359a25$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $3031c7cbe07ac8a4$export$e67a095c620b86fe)(date, options?.in);
    (0, $4cbebb0ad625a795$export$2a89662e70105846)(date_, (0, $5164498ef15241bd$export$bc715fab9217bc6f)(date_), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$0d123e530d359a25$export$2e2bcd8739ae039 = $0d123e530d359a25$export$f91e89d3d0406102;



function $d425bb5959050dc5$export$d3b42cd8452deec(date, options) {
    const _date = (0, $3031c7cbe07ac8a4$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $6731760c7cccaf14$export$4a02e9c37dab4871)(_date, (0, $0d123e530d359a25$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$d425bb5959050dc5$export$2e2bcd8739ae039 = $d425bb5959050dc5$export$d3b42cd8452deec;







function $1e923dfe911bf81a$export$566174fa40823587(cleanDate, ...args) {
    const gd = cleanDate.getDate();
    const gm = cleanDate.getMonth() + 1;
    const gy = cleanDate.getFullYear();
    const j = (0, $08fdb7588d4cb299$export$b20224aa730f4092)(gy, gm, gd);
    const [date] = args;
    const g = (0, $08fdb7588d4cb299$export$5dd73e2bc1d686cd)(j.jy, j.jm, date);
    return cleanDate.setFullYear(g.gy, g.gm - 1, g.gd);
}


function $67e6f49433132d83$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $d509f3f8eb02ebdb$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 6;
    const _date = (0, $3031c7cbe07ac8a4$export$e67a095c620b86fe)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    (0, $1e923dfe911bf81a$export$566174fa40823587)(_date, (0, $1e8f3299fd78be22$export$aa350b96d91cd94)(_date) - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$67e6f49433132d83$export$2e2bcd8739ae039 = $67e6f49433132d83$export$42c81a444fbfb5d4;


function $4a9eb2d03649c763$export$6173213f95a4431e(date, options) {
    return (0, $67e6f49433132d83$export$42c81a444fbfb5d4)(date, {
        ...options,
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$4a9eb2d03649c763$export$2e2bcd8739ae039 = $4a9eb2d03649c763$export$6173213f95a4431e;






function $3dec3c2483570b91$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $3031c7cbe07ac8a4$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $4558a23d2098dccf$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $4a9eb2d03649c763$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $4558a23d2098dccf$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $4a9eb2d03649c763$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$3dec3c2483570b91$export$2e2bcd8739ae039 = $3dec3c2483570b91$export$3dbc52535f6f8fcc;



function $8cdec383fade6b6c$export$236bdfa374eb69a9(date, options) {
    const year = (0, $3dec3c2483570b91$export$3dbc52535f6f8fcc)(date, options);
    const fourthOfJanuary = (0, $4558a23d2098dccf$export$ead8a1812b171991)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $4a9eb2d03649c763$export$6173213f95a4431e)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$8cdec383fade6b6c$export$2e2bcd8739ae039 = $8cdec383fade6b6c$export$236bdfa374eb69a9;



function $93c97d5d93b203f7$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $3031c7cbe07ac8a4$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $4a9eb2d03649c763$export$6173213f95a4431e)(_date) - +(0, $8cdec383fade6b6c$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $11b80e3ab1e4e153$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$93c97d5d93b203f7$export$2e2bcd8739ae039 = $93c97d5d93b203f7$export$7cabdc5698b63e2f;













function $d39173a20500d1e9$export$12d572480ceb6e58(date, options) {
    const _date = (0, $3031c7cbe07ac8a4$export$e67a095c620b86fe)(date, options?.in);
    const year = (0, $5164498ef15241bd$export$bc715fab9217bc6f)(_date);
    const defaultOptions = (0, $d509f3f8eb02ebdb$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $4558a23d2098dccf$export$ead8a1812b171991)(options?.in || date, 0);
    (0, $4cbebb0ad625a795$export$2a89662e70105846)(firstWeekOfNextYear, year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $67e6f49433132d83$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $4558a23d2098dccf$export$ead8a1812b171991)(options?.in || date, 0);
    (0, $4cbebb0ad625a795$export$2a89662e70105846)(firstWeekOfThisYear, year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $67e6f49433132d83$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$d39173a20500d1e9$export$2e2bcd8739ae039 = $d39173a20500d1e9$export$12d572480ceb6e58;




function $7480bf0be571bed4$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $d509f3f8eb02ebdb$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $d39173a20500d1e9$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $4558a23d2098dccf$export$ead8a1812b171991)(options?.in || date, 0);
    (0, $4cbebb0ad625a795$export$2a89662e70105846)(firstWeek, year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $67e6f49433132d83$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$7480bf0be571bed4$export$2e2bcd8739ae039 = $7480bf0be571bed4$export$bb7b45bb8e74da0f;



function $bfbf0f34c257a04c$export$efe19b760242b2fc(date, options) {
    const _date = (0, $3031c7cbe07ac8a4$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $67e6f49433132d83$export$42c81a444fbfb5d4)(_date, options) - +(0, $7480bf0be571bed4$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $11b80e3ab1e4e153$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$bfbf0f34c257a04c$export$2e2bcd8739ae039 = $bfbf0f34c257a04c$export$efe19b760242b2fc;



function $ef14671e17f88e99$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}






const $d55d29dc45547c91$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = (0, $5164498ef15241bd$export$bc715fab9217bc6f)(date);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $ef14671e17f88e99$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = (0, $07a5aee0b2ab35ee$export$6ce1b5acc29cb53b)(date);
        return token === "M" ? String(month + 1) : (0, $ef14671e17f88e99$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $ef14671e17f88e99$export$c8306e720e213c0f)((0, $1e8f3299fd78be22$export$aa350b96d91cd94)(date), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $ef14671e17f88e99$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $ef14671e17f88e99$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $ef14671e17f88e99$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $ef14671e17f88e99$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $ef14671e17f88e99$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};





const $9a4c581cf3ad74f0$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $9a4c581cf3ad74f0$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = (0, $5164498ef15241bd$export$bc715fab9217bc6f)(date) > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = (0, $5164498ef15241bd$export$bc715fab9217bc6f)(date);
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $d55d29dc45547c91$export$b0d4b338e1516f13).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $d39173a20500d1e9$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $ef14671e17f88e99$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $ef14671e17f88e99$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $3dec3c2483570b91$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $ef14671e17f88e99$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = (0, $5164498ef15241bd$export$bc715fab9217bc6f)(date);
        return (0, $ef14671e17f88e99$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil(((0, $07a5aee0b2ab35ee$export$6ce1b5acc29cb53b)(date) + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $ef14671e17f88e99$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil(((0, $07a5aee0b2ab35ee$export$6ce1b5acc29cb53b)(date) + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $ef14671e17f88e99$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = (0, $07a5aee0b2ab35ee$export$6ce1b5acc29cb53b)(date);
        switch(token){
            case "M":
            case "MM":
                return (0, $d55d29dc45547c91$export$b0d4b338e1516f13).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = (0, $07a5aee0b2ab35ee$export$6ce1b5acc29cb53b)(date);
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $ef14671e17f88e99$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $bfbf0f34c257a04c$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $ef14671e17f88e99$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $93c97d5d93b203f7$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $ef14671e17f88e99$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber((0, $1e8f3299fd78be22$export$aa350b96d91cd94)(date), {
            unit: "date"
        });
        return (0, $d55d29dc45547c91$export$b0d4b338e1516f13).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $d425bb5959050dc5$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $ef14671e17f88e99$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $ef14671e17f88e99$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $ef14671e17f88e99$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $ef14671e17f88e99$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $9a4c581cf3ad74f0$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $9a4c581cf3ad74f0$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $9a4c581cf3ad74f0$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $9a4c581cf3ad74f0$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $9a4c581cf3ad74f0$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $9a4c581cf3ad74f0$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $d55d29dc45547c91$export$b0d4b338e1516f13).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $d55d29dc45547c91$export$b0d4b338e1516f13).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $ef14671e17f88e99$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $ef14671e17f88e99$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $d55d29dc45547c91$export$b0d4b338e1516f13).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $d55d29dc45547c91$export$b0d4b338e1516f13).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $d55d29dc45547c91$export$b0d4b338e1516f13).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $9a4c581cf3ad74f0$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $9a4c581cf3ad74f0$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $9a4c581cf3ad74f0$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $9a4c581cf3ad74f0$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $9a4c581cf3ad74f0$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $9a4c581cf3ad74f0$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $9a4c581cf3ad74f0$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $9a4c581cf3ad74f0$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $9a4c581cf3ad74f0$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $9a4c581cf3ad74f0$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $ef14671e17f88e99$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $ef14671e17f88e99$export$c8306e720e213c0f)(+date, token.length);
    }
};
function $9a4c581cf3ad74f0$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $ef14671e17f88e99$export$c8306e720e213c0f)(minutes, 2);
}
function $9a4c581cf3ad74f0$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $ef14671e17f88e99$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $9a4c581cf3ad74f0$var$formatTimezone(offset, delimiter);
}
function $9a4c581cf3ad74f0$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $ef14671e17f88e99$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $ef14671e17f88e99$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


const $600b61225543aa1c$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $600b61225543aa1c$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $600b61225543aa1c$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $600b61225543aa1c$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $600b61225543aa1c$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $600b61225543aa1c$var$timeLongFormatter(timePattern, formatLong));
};
const $600b61225543aa1c$export$70cc8fd02856fd58 = {
    p: $600b61225543aa1c$var$timeLongFormatter,
    P: $600b61225543aa1c$var$dateTimeLongFormatter
};


const $1ebefc5cab0acce0$var$dayOfYearTokenRE = /^D+$/;
const $1ebefc5cab0acce0$var$weekYearTokenRE = /^Y+$/;
const $1ebefc5cab0acce0$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $1ebefc5cab0acce0$export$c6cc36aa33304772(token) {
    return $1ebefc5cab0acce0$var$dayOfYearTokenRE.test(token);
}
function $1ebefc5cab0acce0$export$c6b49d6dceb604a1(token) {
    return $1ebefc5cab0acce0$var$weekYearTokenRE.test(token);
}
function $1ebefc5cab0acce0$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $1ebefc5cab0acce0$var$message(token, format, input);
    console.warn(_message);
    if ($1ebefc5cab0acce0$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $1ebefc5cab0acce0$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $f2d98dc6cda06d7b$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$f2d98dc6cda06d7b$export$2e2bcd8739ae039 = $f2d98dc6cda06d7b$export$871608497c498473;



function $22b984c186047979$export$1ea939691cdc45b8(date) {
    return !(!(0, $f2d98dc6cda06d7b$export$871608497c498473)(date) && typeof date !== "number" || isNaN(+(0, $3031c7cbe07ac8a4$export$e67a095c620b86fe)(date)));
}
var // Fallback for modularized imports:
$22b984c186047979$export$2e2bcd8739ae039 = $22b984c186047979$export$1ea939691cdc45b8;



// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $da1615303898be1d$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $da1615303898be1d$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $da1615303898be1d$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $da1615303898be1d$var$doubleQuoteRegExp = /''/g;
const $da1615303898be1d$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $da1615303898be1d$export$d9468344d3651243(date, formatStr, options) {
    const defaultOptions = (0, $d509f3f8eb02ebdb$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $2ae9407ce37e1a2e$export$355e05e1e35701f3);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 6;
    const originalDate = (0, $3031c7cbe07ac8a4$export$e67a095c620b86fe)(date, options?.in);
    if (!(0, $22b984c186047979$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($da1615303898be1d$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $600b61225543aa1c$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($da1615303898be1d$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $da1615303898be1d$var$cleanEscapedString(substring)
        };
        if ((0, $9a4c581cf3ad74f0$export$fe98a034cfb96d55)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($da1615303898be1d$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $1ebefc5cab0acce0$export$c6b49d6dceb604a1)(token) || !options?.useAdditionalDayOfYearTokens && (0, $1ebefc5cab0acce0$export$c6cc36aa33304772)(token)) (0, $1ebefc5cab0acce0$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = (0, $9a4c581cf3ad74f0$export$fe98a034cfb96d55)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $da1615303898be1d$var$cleanEscapedString(input) {
    const matched = input.match($da1615303898be1d$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($da1615303898be1d$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$da1615303898be1d$export$2e2bcd8739ae039 = $da1615303898be1d$export$d9468344d3651243;




function $2afc42ef31f7b732$export$a18c89cbd24170ff(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $19971bf034cb86da$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return (0, $5164498ef15241bd$export$bc715fab9217bc6f)(laterDate_) === (0, $5164498ef15241bd$export$bc715fab9217bc6f)(earlierDate_) && (0, $07a5aee0b2ab35ee$export$6ce1b5acc29cb53b)(laterDate_) === (0, $07a5aee0b2ab35ee$export$6ce1b5acc29cb53b)(earlierDate_);
}
var // Fallback for modularized imports:
$2afc42ef31f7b732$export$2e2bcd8739ae039 = $2afc42ef31f7b732$export$a18c89cbd24170ff;






function $3a6113699f762a29$export$430a3269e24b912e() {
    return Object.assign({}, (0, $d509f3f8eb02ebdb$export$430a3269e24b912e)());
}
var // Fallback for modularized imports:
$3a6113699f762a29$export$2e2bcd8739ae039 = $3a6113699f762a29$export$430a3269e24b912e;









function $91ba5598b7fd40e9$export$9cb09a71b7d66923(date, constructor) {
    const date_ = $91ba5598b7fd40e9$var$isConstructor(constructor) ? new constructor(0) : (0, $4558a23d2098dccf$export$ead8a1812b171991)(constructor, 0);
    (0, $4cbebb0ad625a795$export$2a89662e70105846)(date_, (0, $5164498ef15241bd$export$bc715fab9217bc6f)(date), (0, $07a5aee0b2ab35ee$export$6ce1b5acc29cb53b)(date), (0, $1e8f3299fd78be22$export$aa350b96d91cd94)(date));
    date_.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    return date_;
}
function $91ba5598b7fd40e9$var$isConstructor(constructor) {
    return typeof constructor === "function" && constructor.prototype?.constructor === constructor;
}
var // Fallback for modularized imports:
$91ba5598b7fd40e9$export$2e2bcd8739ae039 = $91ba5598b7fd40e9$export$9cb09a71b7d66923;


const $aa63955b68c5b25e$var$TIMEZONE_UNIT_PRIORITY = 10;
class $aa63955b68c5b25e$export$81d53e3678089a6 {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
class $aa63955b68c5b25e$export$9a09e32dd4990fd5 extends $aa63955b68c5b25e$export$81d53e3678089a6 {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
class $aa63955b68c5b25e$export$8be15fe85ad72f86 extends $aa63955b68c5b25e$export$81d53e3678089a6 {
    priority = $aa63955b68c5b25e$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    constructor(context, reference){
        super();
        this.context = context || ((date)=>(0, $4558a23d2098dccf$export$ead8a1812b171991)(reference, date));
    }
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $4558a23d2098dccf$export$ead8a1812b171991)(date, (0, $91ba5598b7fd40e9$export$9cb09a71b7d66923)(date, this.context));
    }
}



class $27ad086ad94c147b$export$7acfa6ed01010e37 {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new (0, $aa63955b68c5b25e$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}



class $0325849d5db2c12c$export$8e5a1d3f85a9688 extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        (0, $4cbebb0ad625a795$export$2a89662e70105846)(date, value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}




const $51cba75c2fdedf0c$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $51cba75c2fdedf0c$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};




function $74306f4f5a1f9b21$export$553d7fa8e3805fc0(year) {
    return (0, $08fdb7588d4cb299$export$b404427083bd986a)(year);
}



function $5c567940e6f62f92$export$553d7fa8e3805fc0(date, options) {
    const _date = (0, $3031c7cbe07ac8a4$export$e67a095c620b86fe)(date, options?.in);
    const year = (0, $5164498ef15241bd$export$bc715fab9217bc6f)(_date);
    return (0, $74306f4f5a1f9b21$export$553d7fa8e3805fc0)(year);
}
var // Fallback for modularized imports:
$5c567940e6f62f92$export$2e2bcd8739ae039 = $5c567940e6f62f92$export$553d7fa8e3805fc0;



function $de63ed5c9003800f$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $de63ed5c9003800f$export$cc7cc9e2a3ff9388(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $de63ed5c9003800f$export$6497f4c0ecdfba8e(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $11b80e3ab1e4e153$export$7f72910d6dfd237a) + minutes * (0, $11b80e3ab1e4e153$export$91246f0b9bd9beff) + seconds * (0, $11b80e3ab1e4e153$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $de63ed5c9003800f$export$d931c43c4608a164(dateString) {
    return $de63ed5c9003800f$export$cc7cc9e2a3ff9388((0, $51cba75c2fdedf0c$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $de63ed5c9003800f$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $de63ed5c9003800f$export$cc7cc9e2a3ff9388((0, $51cba75c2fdedf0c$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $de63ed5c9003800f$export$cc7cc9e2a3ff9388((0, $51cba75c2fdedf0c$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $de63ed5c9003800f$export$cc7cc9e2a3ff9388((0, $51cba75c2fdedf0c$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $de63ed5c9003800f$export$cc7cc9e2a3ff9388((0, $51cba75c2fdedf0c$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $de63ed5c9003800f$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $de63ed5c9003800f$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $de63ed5c9003800f$export$cc7cc9e2a3ff9388((0, $51cba75c2fdedf0c$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $de63ed5c9003800f$export$cc7cc9e2a3ff9388((0, $51cba75c2fdedf0c$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $de63ed5c9003800f$export$cc7cc9e2a3ff9388((0, $51cba75c2fdedf0c$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $de63ed5c9003800f$export$cc7cc9e2a3ff9388((0, $51cba75c2fdedf0c$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $de63ed5c9003800f$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $de63ed5c9003800f$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $de63ed5c9003800f$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $de63ed5c9003800f$export$3d50627710b84d75(year) {
    return (0, $5c567940e6f62f92$export$553d7fa8e3805fc0)((0, $fb07d2974af45058$export$dc59854f87f8c633)(year, 0));
}




class $d30636691d58cb7a$export$48d352de7cd4a988 extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $de63ed5c9003800f$export$4f84e3a82c7b538)((0, $de63ed5c9003800f$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "yo":
                return (0, $de63ed5c9003800f$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $de63ed5c9003800f$export$4f84e3a82c7b538)((0, $de63ed5c9003800f$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = (0, $5164498ef15241bd$export$bc715fab9217bc6f)(date);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $de63ed5c9003800f$export$29126f735cbf69f7)(value.year, currentYear);
            (0, $4cbebb0ad625a795$export$2a89662e70105846)(date, normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        (0, $4cbebb0ad625a795$export$2a89662e70105846)(date, year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}







class $db9841805cd9c2ac$export$b8ef38dfcf05d5db extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $de63ed5c9003800f$export$4f84e3a82c7b538)((0, $de63ed5c9003800f$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "Yo":
                return (0, $de63ed5c9003800f$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $de63ed5c9003800f$export$4f84e3a82c7b538)((0, $de63ed5c9003800f$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $d39173a20500d1e9$export$12d572480ceb6e58)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $de63ed5c9003800f$export$29126f735cbf69f7)(value.year, currentYear);
            (0, $4cbebb0ad625a795$export$2a89662e70105846)(date, normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $67e6f49433132d83$export$42c81a444fbfb5d4)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        (0, $4cbebb0ad625a795$export$2a89662e70105846)(date, year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $67e6f49433132d83$export$42c81a444fbfb5d4)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}







class $8c0183ed083c333f$export$951d1df011fde06f extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $de63ed5c9003800f$export$2c9307b2e29c533c)(4, dateString);
        return (0, $de63ed5c9003800f$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $4558a23d2098dccf$export$ead8a1812b171991)(date, 0);
        (0, $4cbebb0ad625a795$export$2a89662e70105846)(firstWeekOfYear, value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $4a9eb2d03649c763$export$6173213f95a4431e)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $ae96c9def7b825b6$export$bad9d2ea38e8f1a extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $de63ed5c9003800f$export$2c9307b2e29c533c)(4, dateString);
        return (0, $de63ed5c9003800f$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        (0, $4cbebb0ad625a795$export$2a89662e70105846)(date, value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $26fab119a9d8d40e$export$5cb0f701186dde1d extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $de63ed5c9003800f$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        (0, $89b9b0a19d744029$export$63264690f8e36790)(date, (value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $ddd7a3694b3c7ee8$export$300c0c2990e20e6d extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $de63ed5c9003800f$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        (0, $89b9b0a19d744029$export$63264690f8e36790)(date, (value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}






class $2be3e4d17646ea4f$export$400dd8b40ef138a3 extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $de63ed5c9003800f$export$4f84e3a82c7b538)((0, $de63ed5c9003800f$export$cc7cc9e2a3ff9388)((0, $51cba75c2fdedf0c$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $de63ed5c9003800f$export$4f84e3a82c7b538)((0, $de63ed5c9003800f$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $de63ed5c9003800f$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        (0, $89b9b0a19d744029$export$63264690f8e36790)(date, value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}






class $c05f646e9bf932de$export$1d7eaa53eaa5deba extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $de63ed5c9003800f$export$4f84e3a82c7b538)((0, $de63ed5c9003800f$export$cc7cc9e2a3ff9388)((0, $51cba75c2fdedf0c$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $de63ed5c9003800f$export$4f84e3a82c7b538)((0, $de63ed5c9003800f$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $de63ed5c9003800f$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        (0, $89b9b0a19d744029$export$63264690f8e36790)(date, value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}






function $73dc88adf8f4a234$export$4b3066ce4afafd88(date, week, options) {
    const date_ = (0, $3031c7cbe07ac8a4$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $bfbf0f34c257a04c$export$efe19b760242b2fc)(date_, options) - week;
    (0, $1e923dfe911bf81a$export$566174fa40823587)(date_, (0, $1e8f3299fd78be22$export$aa350b96d91cd94)(date_) - diff * 7);
    return (0, $3031c7cbe07ac8a4$export$e67a095c620b86fe)(date_, options?.in);
}
var // Fallback for modularized imports:
$73dc88adf8f4a234$export$2e2bcd8739ae039 = $73dc88adf8f4a234$export$4b3066ce4afafd88;






class $5bae7fa76a8f8ffb$export$c4005ffc174e07c0 extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $de63ed5c9003800f$export$cc7cc9e2a3ff9388)((0, $51cba75c2fdedf0c$export$c123ee06d9da8480).week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $de63ed5c9003800f$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $67e6f49433132d83$export$42c81a444fbfb5d4)((0, $73dc88adf8f4a234$export$4b3066ce4afafd88)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}




function $43ec50e07c503366$export$6542bebf6be94082(date, week, options) {
    const _date = (0, $3031c7cbe07ac8a4$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $93c97d5d93b203f7$export$7cabdc5698b63e2f)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}
var // Fallback for modularized imports:
$43ec50e07c503366$export$2e2bcd8739ae039 = $43ec50e07c503366$export$6542bebf6be94082;






class $3172bddd9d7be9b2$export$6fc8dbedd560a6af extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $de63ed5c9003800f$export$cc7cc9e2a3ff9388)((0, $51cba75c2fdedf0c$export$c123ee06d9da8480).week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $de63ed5c9003800f$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $4a9eb2d03649c763$export$6173213f95a4431e)((0, $43ec50e07c503366$export$6542bebf6be94082)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}








const $230f6d0e10c4a1a2$var$DAYS_IN_MONTH = [
    31,
    31,
    31,
    31,
    31,
    31,
    30,
    30,
    30,
    30,
    30,
    29
];
const $230f6d0e10c4a1a2$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    31,
    31,
    31,
    31,
    31,
    30,
    30,
    30,
    30,
    30,
    30
];
class $230f6d0e10c4a1a2$export$e8d4b28a20981dd2 extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $de63ed5c9003800f$export$cc7cc9e2a3ff9388)((0, $51cba75c2fdedf0c$export$c123ee06d9da8480).date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $de63ed5c9003800f$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = (0, $5164498ef15241bd$export$bc715fab9217bc6f)(date);
        const isLeapYear = (0, $de63ed5c9003800f$export$3d50627710b84d75)(year);
        const month = (0, $07a5aee0b2ab35ee$export$6ce1b5acc29cb53b)(date);
        if (isLeapYear) return value >= 1 && value <= $230f6d0e10c4a1a2$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $230f6d0e10c4a1a2$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        (0, $1e923dfe911bf81a$export$566174fa40823587)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}







class $a8f8c1304b2eea36$export$6cfe0d613455f615 extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $de63ed5c9003800f$export$cc7cc9e2a3ff9388)((0, $51cba75c2fdedf0c$export$c123ee06d9da8480).dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $de63ed5c9003800f$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = (0, $5164498ef15241bd$export$bc715fab9217bc6f)(date);
        const isLeapYear = (0, $de63ed5c9003800f$export$3d50627710b84d75)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        (0, $89b9b0a19d744029$export$63264690f8e36790)(date, 0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}







function $d0b57804d4ec991a$export$dd412b56f1e4d8aa(date, amount, options) {
    const _date = (0, $3031c7cbe07ac8a4$export$e67a095c620b86fe)(date, options?.in);
    if (isNaN(amount)) return (0, $4558a23d2098dccf$export$ead8a1812b171991)(options?.in || date, NaN);
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    if (!amount) return _date;
    (0, $1e923dfe911bf81a$export$566174fa40823587)(_date, (0, $1e8f3299fd78be22$export$aa350b96d91cd94)(_date) + amount);
    return _date;
}
var // Fallback for modularized imports:
$d0b57804d4ec991a$export$2e2bcd8739ae039 = $d0b57804d4ec991a$export$dd412b56f1e4d8aa;



function $9d1506e181f4ba51$export$b04fdcda82decc6c(date, day, options) {
    const defaultOptions = (0, $d509f3f8eb02ebdb$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 6;
    const date_ = (0, $3031c7cbe07ac8a4$export$e67a095c620b86fe)(date, options?.in);
    const currentDay = date_.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $d0b57804d4ec991a$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$9d1506e181f4ba51$export$2e2bcd8739ae039 = $9d1506e181f4ba51$export$b04fdcda82decc6c;



class $8ad054e8d5dfc09f$export$1b03c8b76262f7bd extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $9d1506e181f4ba51$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $c650aacee6225d9c$export$44d1c127ab42c480 extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6 /* move sun -> sat */  + 1) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $de63ed5c9003800f$export$4f84e3a82c7b538)((0, $de63ed5c9003800f$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $de63ed5c9003800f$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $9d1506e181f4ba51$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}





class $9b48629be3d3a9cf$export$e447a647caaaec1d extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6 /* move sun -> sat */  + 1) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $de63ed5c9003800f$export$4f84e3a82c7b538)((0, $de63ed5c9003800f$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $de63ed5c9003800f$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $9d1506e181f4ba51$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}




function $df86aee4d9c32264$export$c514f4c1a8ed5e9e(date, options) {
    const day = (0, $3031c7cbe07ac8a4$export$e67a095c620b86fe)(date, options?.in).getDay();
    return day === 0 ? 7 : day;
}
var // Fallback for modularized imports:
$df86aee4d9c32264$export$2e2bcd8739ae039 = $df86aee4d9c32264$export$c514f4c1a8ed5e9e;



function $3f9fed57deed4e48$export$1fd9df65adb0d1aa(date, day, options) {
    const date_ = (0, $3031c7cbe07ac8a4$export$e67a095c620b86fe)(date, options?.in);
    const currentDay = (0, $df86aee4d9c32264$export$c514f4c1a8ed5e9e)(date_, options);
    const diff = day - currentDay;
    return (0, $d0b57804d4ec991a$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$3f9fed57deed4e48$export$2e2bcd8739ae039 = $3f9fed57deed4e48$export$1fd9df65adb0d1aa;




class $a442cfcf6d1a33e2$export$693fb1e525095b2a extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $de63ed5c9003800f$export$513bb01536146ab6)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $de63ed5c9003800f$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $de63ed5c9003800f$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $de63ed5c9003800f$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $de63ed5c9003800f$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $3f9fed57deed4e48$export$1fd9df65adb0d1aa)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $139e7c2470c7eff6$export$8d1e08492351df91 extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $de63ed5c9003800f$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}




class $403bfa9696c0083d$export$73ca2bd0a17d273 extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $de63ed5c9003800f$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}




class $ccbd9be2dd7a145a$export$bb9212adf05373db extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $de63ed5c9003800f$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}





class $50ab46714c107aab$export$8a04050a727a1756 extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $de63ed5c9003800f$export$cc7cc9e2a3ff9388)((0, $51cba75c2fdedf0c$export$c123ee06d9da8480).hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $de63ed5c9003800f$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}





class $8210b93c4c4eed87$export$e56f4dea2c3e56dd extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $de63ed5c9003800f$export$cc7cc9e2a3ff9388)((0, $51cba75c2fdedf0c$export$c123ee06d9da8480).hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $de63ed5c9003800f$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}





class $76a40d317345c1c2$export$cbbe855312f87d77 extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $de63ed5c9003800f$export$cc7cc9e2a3ff9388)((0, $51cba75c2fdedf0c$export$c123ee06d9da8480).hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $de63ed5c9003800f$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}





class $e23f86657fbd0075$export$6008046d2b34b6a5 extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $de63ed5c9003800f$export$cc7cc9e2a3ff9388)((0, $51cba75c2fdedf0c$export$c123ee06d9da8480).hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $de63ed5c9003800f$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}





class $137d9a15b711e0b1$export$2b52670d9e2be53 extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $de63ed5c9003800f$export$cc7cc9e2a3ff9388)((0, $51cba75c2fdedf0c$export$c123ee06d9da8480).minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $de63ed5c9003800f$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}





class $c89afc0b8fd119f8$export$94d46d540cf1366a extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $de63ed5c9003800f$export$cc7cc9e2a3ff9388)((0, $51cba75c2fdedf0c$export$c123ee06d9da8480).second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $de63ed5c9003800f$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}




class $f09ad8196bc28473$export$b8e6f8b2d70893b1 extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $de63ed5c9003800f$export$4f84e3a82c7b538)((0, $de63ed5c9003800f$export$513bb01536146ab6)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}







class $89b2f9cbd5d69c53$export$104d901d49fea29b extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $de63ed5c9003800f$export$6497f4c0ecdfba8e)((0, $51cba75c2fdedf0c$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "XX":
                return (0, $de63ed5c9003800f$export$6497f4c0ecdfba8e)((0, $51cba75c2fdedf0c$export$a7ee192b982af9c1).basic, dateString);
            case "XXXX":
                return (0, $de63ed5c9003800f$export$6497f4c0ecdfba8e)((0, $51cba75c2fdedf0c$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $de63ed5c9003800f$export$6497f4c0ecdfba8e)((0, $51cba75c2fdedf0c$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $de63ed5c9003800f$export$6497f4c0ecdfba8e)((0, $51cba75c2fdedf0c$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $4558a23d2098dccf$export$ead8a1812b171991)(date, date.getTime() - (0, $a2296a1d3f9eb6ba$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}







class $d293ed03b87fccdc$export$12910e5204b52b9 extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $de63ed5c9003800f$export$6497f4c0ecdfba8e)((0, $51cba75c2fdedf0c$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "xx":
                return (0, $de63ed5c9003800f$export$6497f4c0ecdfba8e)((0, $51cba75c2fdedf0c$export$a7ee192b982af9c1).basic, dateString);
            case "xxxx":
                return (0, $de63ed5c9003800f$export$6497f4c0ecdfba8e)((0, $51cba75c2fdedf0c$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $de63ed5c9003800f$export$6497f4c0ecdfba8e)((0, $51cba75c2fdedf0c$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $de63ed5c9003800f$export$6497f4c0ecdfba8e)((0, $51cba75c2fdedf0c$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $4558a23d2098dccf$export$ead8a1812b171991)(date, date.getTime() - (0, $a2296a1d3f9eb6ba$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}





class $3bd9213faa0dbaa8$export$2cd8bf877a05e96 extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 40;
    parse(dateString) {
        return (0, $de63ed5c9003800f$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $4558a23d2098dccf$export$ead8a1812b171991)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}





class $c7b9a39442516ef4$export$6d8f69c6906d6368 extends (0, $27ad086ad94c147b$export$7acfa6ed01010e37) {
    priority = 20;
    parse(dateString) {
        return (0, $de63ed5c9003800f$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $4558a23d2098dccf$export$ead8a1812b171991)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}


const $709cb84effd06d93$export$19131010e7fd8373 = {
    G: new (0, $0325849d5db2c12c$export$8e5a1d3f85a9688)(),
    y: new (0, $d30636691d58cb7a$export$48d352de7cd4a988)(),
    Y: new (0, $db9841805cd9c2ac$export$b8ef38dfcf05d5db)(),
    R: new (0, $8c0183ed083c333f$export$951d1df011fde06f)(),
    u: new (0, $ae96c9def7b825b6$export$bad9d2ea38e8f1a)(),
    Q: new (0, $26fab119a9d8d40e$export$5cb0f701186dde1d)(),
    q: new (0, $ddd7a3694b3c7ee8$export$300c0c2990e20e6d)(),
    M: new (0, $2be3e4d17646ea4f$export$400dd8b40ef138a3)(),
    L: new (0, $c05f646e9bf932de$export$1d7eaa53eaa5deba)(),
    w: new (0, $5bae7fa76a8f8ffb$export$c4005ffc174e07c0)(),
    I: new (0, $3172bddd9d7be9b2$export$6fc8dbedd560a6af)(),
    d: new (0, $230f6d0e10c4a1a2$export$e8d4b28a20981dd2)(),
    D: new (0, $a8f8c1304b2eea36$export$6cfe0d613455f615)(),
    E: new (0, $8ad054e8d5dfc09f$export$1b03c8b76262f7bd)(),
    e: new (0, $c650aacee6225d9c$export$44d1c127ab42c480)(),
    c: new (0, $9b48629be3d3a9cf$export$e447a647caaaec1d)(),
    i: new (0, $a442cfcf6d1a33e2$export$693fb1e525095b2a)(),
    a: new (0, $139e7c2470c7eff6$export$8d1e08492351df91)(),
    b: new (0, $403bfa9696c0083d$export$73ca2bd0a17d273)(),
    B: new (0, $ccbd9be2dd7a145a$export$bb9212adf05373db)(),
    h: new (0, $50ab46714c107aab$export$8a04050a727a1756)(),
    H: new (0, $8210b93c4c4eed87$export$e56f4dea2c3e56dd)(),
    K: new (0, $76a40d317345c1c2$export$cbbe855312f87d77)(),
    k: new (0, $e23f86657fbd0075$export$6008046d2b34b6a5)(),
    m: new (0, $137d9a15b711e0b1$export$2b52670d9e2be53)(),
    s: new (0, $c89afc0b8fd119f8$export$94d46d540cf1366a)(),
    S: new (0, $f09ad8196bc28473$export$b8e6f8b2d70893b1)(),
    X: new (0, $89b2f9cbd5d69c53$export$104d901d49fea29b)(),
    x: new (0, $d293ed03b87fccdc$export$12910e5204b52b9)(),
    t: new (0, $3bd9213faa0dbaa8$export$2cd8bf877a05e96)(),
    T: new (0, $c7b9a39442516ef4$export$6d8f69c6906d6368)()
};


/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $74bf58011bdaa496$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $74bf58011bdaa496$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $74bf58011bdaa496$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $74bf58011bdaa496$var$doubleQuoteRegExp = /''/g;
const $74bf58011bdaa496$var$notWhitespaceRegExp = /\S/;
const $74bf58011bdaa496$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $74bf58011bdaa496$export$98e6a39c04603d36(dateStr, formatStr, referenceDate, options) {
    const invalidDate = ()=>(0, $4558a23d2098dccf$export$ead8a1812b171991)(options?.in || referenceDate, NaN);
    const defaultOptions = (0, $3a6113699f762a29$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $2ae9407ce37e1a2e$export$355e05e1e35701f3);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 6;
    if (!formatStr) return dateStr ? invalidDate() : (0, $3031c7cbe07ac8a4$export$e67a095c620b86fe)(referenceDate, options?.in);
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will try to use the context or
    // the reference date and fallback to the system time zone.
    const setters = [
        new (0, $aa63955b68c5b25e$export$8be15fe85ad72f86)(options?.in, referenceDate)
    ];
    const tokens = formatStr.match($74bf58011bdaa496$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in (0, $600b61225543aa1c$export$70cc8fd02856fd58)) {
            const longFormatter = (0, $600b61225543aa1c$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($74bf58011bdaa496$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $1ebefc5cab0acce0$export$c6b49d6dceb604a1)(token)) (0, $1ebefc5cab0acce0$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $1ebefc5cab0acce0$export$c6cc36aa33304772)(token)) (0, $1ebefc5cab0acce0$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = (0, $709cb84effd06d93$export$19131010e7fd8373)[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return invalidDate();
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($74bf58011bdaa496$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $74bf58011bdaa496$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return invalidDate();
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $74bf58011bdaa496$var$notWhitespaceRegExp.test(dateStr)) return invalidDate();
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $3031c7cbe07ac8a4$export$e67a095c620b86fe)(referenceDate, options?.in);
    if (isNaN(+date)) return invalidDate();
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return invalidDate();
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return date;
}
function $74bf58011bdaa496$var$cleanEscapedString(input) {
    return input.match($74bf58011bdaa496$var$escapedStringRegExp)[1].replace($74bf58011bdaa496$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$74bf58011bdaa496$export$2e2bcd8739ae039 = $74bf58011bdaa496$export$98e6a39c04603d36;



function $af5de0b2582bebff$export$a5a3b454ada2268e(date, options) {
    const _date = (0, $3031c7cbe07ac8a4$export$e67a095c620b86fe)(date, options?.in);
    (0, $1e923dfe911bf81a$export$566174fa40823587)(_date, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$af5de0b2582bebff$export$2e2bcd8739ae039 = $af5de0b2582bebff$export$a5a3b454ada2268e;


const $d4d460d3ffb6daab$var$PERSIAN_DIGITS = [
    "\u06F0",
    "\u06F1",
    "\u06F2",
    "\u06F3",
    "\u06F4",
    "\u06F5",
    "\u06F6",
    "\u06F7",
    "\u06F8",
    "\u06F9"
];
function $d4d460d3ffb6daab$export$e9cf274fc1035ec4(value) {
    if (value === null || value === undefined) return '';
    return String(value).replace(/\d/g, (d)=>$d4d460d3ffb6daab$var$PERSIAN_DIGITS[Number(d)]);
}
function $d4d460d3ffb6daab$export$365a38b4fc2bed91(value) {
    if (value === null || value === undefined) return '';
    return String(value).replace(/[۰-۹٠-٩]/g, (d)=>{
        const code = d.charCodeAt(0);
        const base = code >= 0x0660 && code <= 0x0669 ? 0x0660 : 0x06f0;
        return String(code - base);
    });
}
/** Parse an API timestamp (ISO-8601 UTC). Returns null for missing/invalid. */ function $d4d460d3ffb6daab$var$parse(iso) {
    if (!iso) return null;
    const date = new Date(iso);
    return Number.isNaN(date.getTime()) ? null : date;
}
function $d4d460d3ffb6daab$export$3ae94a2503e890a1(iso) {
    const date = $d4d460d3ffb6daab$var$parse(iso);
    return date ? $d4d460d3ffb6daab$export$e9cf274fc1035ec4((0, $da1615303898be1d$export$d9468344d3651243)(date, 'yyyy/MM/dd')) : "\u2014";
}
function $d4d460d3ffb6daab$export$8b492ed8828f789c(iso) {
    const date = $d4d460d3ffb6daab$var$parse(iso);
    return date ? $d4d460d3ffb6daab$export$e9cf274fc1035ec4((0, $da1615303898be1d$export$d9468344d3651243)(date, 'yyyy/MM/dd HH:mm')) : "\u2014";
}
function $d4d460d3ffb6daab$export$8f66139a5bd54aaa(iso) {
    const date = $d4d460d3ffb6daab$var$parse(iso);
    return date ? $d4d460d3ffb6daab$export$e9cf274fc1035ec4((0, $da1615303898be1d$export$d9468344d3651243)(date, 'd MMMM yyyy')) : "\u2014";
}
function $d4d460d3ffb6daab$export$8fbbfd65594f46a0(iso) {
    const date = $d4d460d3ffb6daab$var$parse(iso);
    if (!date) return "\u2014";
    const days = Math.round((Date.now() - date.getTime()) / 86400000);
    if (days === 0) return "\u0627\u0645\u0631\u0648\u0632";
    if (days === 1) return "\u062F\u06CC\u0631\u0648\u0632";
    if (days > 1 && days < 30) return `${$d4d460d3ffb6daab$export$e9cf274fc1035ec4(days)} \u{631}\u{648}\u{632} \u{67E}\u{6CC}\u{634}`;
    if (days < 0 && days > -30) return `${$d4d460d3ffb6daab$export$e9cf274fc1035ec4(-days)} \u{631}\u{648}\u{632} \u{62F}\u{6CC}\u{6AF}\u{631}`;
    return $d4d460d3ffb6daab$export$3ae94a2503e890a1(iso);
}
function $d4d460d3ffb6daab$export$10c09b2cff9813eb(number) {
    return $d4d460d3ffb6daab$export$e9cf274fc1035ec4(number ?? '');
}
function $d4d460d3ffb6daab$export$104ee80c24270f18(value) {
    return $d4d460d3ffb6daab$export$e9cf274fc1035ec4(value ?? 0);
}
function $d4d460d3ffb6daab$export$e1a3971de07c83b5(bytes) {
    const size = Number(bytes ?? 0);
    if (size >= 1048576) return `${$d4d460d3ffb6daab$export$e9cf274fc1035ec4((size / 1048576).toFixed(1))} \u{645}\u{6AF}\u{627}\u{628}\u{627}\u{6CC}\u{62A}`;
    if (size >= 1024) return `${$d4d460d3ffb6daab$export$e9cf274fc1035ec4(Math.round(size / 1024))} \u{6A9}\u{6CC}\u{644}\u{648}\u{628}\u{627}\u{6CC}\u{62A}`;
    return `${$d4d460d3ffb6daab$export$e9cf274fc1035ec4(size)} \u{628}\u{627}\u{6CC}\u{62A}`;
}
function $d4d460d3ffb6daab$export$b0a6e191e6afdfa(input) {
    const text = $d4d460d3ffb6daab$export$365a38b4fc2bed91(input ?? '').trim().replace(/-/g, '/');
    if (!/^\d{4}\/\d{1,2}\/\d{1,2}$/.test(text)) return null;
    const date = (0, $74bf58011bdaa496$export$98e6a39c04603d36)(text, 'yyyy/M/d', new Date());
    if (Number.isNaN(date.getTime())) return null;
    // Format from the Gregorian side: a plain toISOString() would shift the day
    // for anyone east or west of UTC, which is exactly where the users are.
    const pad = (n)=>String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
function $d4d460d3ffb6daab$export$aae69b02cbc5f8df(iso) {
    if (!iso) return '';
    // Parsed as local midnight, not UTC, for the same reason as above.
    const [y, m, d] = String(iso).slice(0, 10).split('-').map(Number);
    if (!y || !m || !d) return '';
    return $d4d460d3ffb6daab$export$e9cf274fc1035ec4((0, $da1615303898be1d$export$d9468344d3651243)(new Date(y, m - 1, d), 'yyyy/MM/dd'));
}
function $d4d460d3ffb6daab$export$747b60771a8a4ce9(isoDate, timeInput) {
    if (!isoDate) return null;
    const time = $d4d460d3ffb6daab$export$365a38b4fc2bed91(timeInput ?? '').trim() || '00:00';
    if (!/^\d{1,2}:\d{2}$/.test(time)) return null;
    const [hours, minutes] = time.split(':').map(Number);
    if (hours > 23 || minutes > 59) return null;
    const [y, m, d] = String(isoDate).split('-').map(Number);
    // Local time, then toISOString: the user means «۱۴:۳۰ here», not 14:30 UTC.
    return new Date(y, m - 1, d, hours, minutes).toISOString();
}
function $d4d460d3ffb6daab$export$64fd9b596f090699(dateInput, timeInput) {
    return $d4d460d3ffb6daab$export$747b60771a8a4ce9($d4d460d3ffb6daab$export$b0a6e191e6afdfa(dateInput), timeInput);
}
function $d4d460d3ffb6daab$export$a32865ea4a905df9(iso) {
    const date = $d4d460d3ffb6daab$var$parse(iso) ?? new Date();
    const pad = (n)=>String(n).padStart(2, '0');
    return {
        date: `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`,
        time: `${pad(date.getHours())}:${pad(date.getMinutes())}`
    };
}
const $d4d460d3ffb6daab$export$3c3cfc169bd4703d = {
    UNKNOWN: "\u0646\u0627\u0645\u0639\u0644\u0648\u0645",
    INTERESTED: "\u0645\u0634\u062A\u0627\u0642 \u0627\u0634\u062A\u0631\u0627\u06A9",
    CONSULTING: "\u0645\u0634\u0627\u0648\u0631\u0647",
    SUBSCRIBER: "\u0645\u0634\u062A\u0631\u06A9"
};
const $d4d460d3ffb6daab$export$fc6fe25248839a29 = {
    MALE: "\u0645\u0631\u062F",
    FEMALE: "\u0632\u0646",
    OTHER: "\u0633\u0627\u06CC\u0631"
};
const $d4d460d3ffb6daab$export$c2e265752f50ea92 = {
    WHITELABEL: "\u0648\u0627\u06CC\u062A\u200C\u0644\u06CC\u0628\u0644",
    STANDARD: "\u0639\u0627\u062F\u06CC",
    BARTER: "\u062A\u0647\u0627\u062A\u0631"
};
const $d4d460d3ffb6daab$export$a204b71704535ad8 = {
    PLANNED: "\u0628\u0631\u0646\u0627\u0645\u0647\u200C\u0631\u06CC\u0632\u06CC\u200C\u0634\u062F\u0647",
    DONE: "\u0627\u0646\u062C\u0627\u0645\u200C\u0634\u062F\u0647",
    CANCELLED: "\u0644\u063A\u0648\u0634\u062F\u0647"
};
const $d4d460d3ffb6daab$export$dab5d6c7a52ba3f8 = {
    PERSON: "\u0634\u062E\u0635",
    ORGANIZATION: "\u0633\u0627\u0632\u0645\u0627\u0646"
};
const $d4d460d3ffb6daab$export$949ded4877079784 = [
    "\u0634\u0646\u0628\u0647",
    "\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647",
    "\u062F\u0648\u0634\u0646\u0628\u0647",
    "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
    "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
    "\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647",
    "\u062C\u0645\u0639\u0647"
];
const $d4d460d3ffb6daab$export$87b71208d3952cb3 = 6;
const $d4d460d3ffb6daab$export$54a58e9738ad4e5d = $d4d460d3ffb6daab$export$949ded4877079784.map((name)=>name.slice(0, 1));
const $d4d460d3ffb6daab$export$3d5cc8a1339f76b9 = [
    "\u0641\u0631\u0648\u0631\u062F\u06CC\u0646",
    "\u0627\u0631\u062F\u06CC\u0628\u0647\u0634\u062A",
    "\u062E\u0631\u062F\u0627\u062F",
    "\u062A\u06CC\u0631",
    "\u0645\u0631\u062F\u0627\u062F",
    "\u0634\u0647\u0631\u06CC\u0648\u0631",
    "\u0645\u0647\u0631",
    "\u0622\u0628\u0627\u0646",
    "\u0622\u0630\u0631",
    "\u062F\u06CC",
    "\u0628\u0647\u0645\u0646",
    "\u0627\u0633\u0641\u0646\u062F"
];
function $d4d460d3ffb6daab$export$d4a2b3f01177c29b(iso) {
    if (!iso) return '';
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return '';
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-u-ca-persian-nu-latn', {
        year: 'numeric',
        month: 'numeric',
        timeZone: 'UTC'
    }).formatToParts(date).map((part)=>[
            part.type,
            part.value
        ]));
    const month = $d4d460d3ffb6daab$export$3d5cc8a1339f76b9[Number(parts.month) - 1] ?? '';
    return `${month} ${$d4d460d3ffb6daab$export$e9cf274fc1035ec4(parts.year)}`;
}
function $d4d460d3ffb6daab$export$cfc9e8d9ee3dc0f4(date) {
    return (date.getDay() + 1) % 7;
}
function $d4d460d3ffb6daab$export$b08f6004b835d36b(date) {
    const start = new Date(date);
    start.setHours(0, 0, 0, 0);
    start.setDate(start.getDate() - $d4d460d3ffb6daab$export$cfc9e8d9ee3dc0f4(start));
    return start;
}
function $d4d460d3ffb6daab$export$b28d13d660cf3bf3(date) {
    const start = $d4d460d3ffb6daab$export$b08f6004b835d36b(date);
    return Array.from({
        length: 7
    }, (_, index)=>{
        const day = new Date(start);
        day.setDate(start.getDate() + index);
        return day;
    });
}
function $d4d460d3ffb6daab$export$63fa379ae8a9ba2(date) {
    const start = new Date(date);
    start.setHours(0, 0, 0, 0);
    return start;
}
function $d4d460d3ffb6daab$export$dd412b56f1e4d8aa(date, days) {
    const out = new Date(date);
    out.setDate(out.getDate() + days);
    return out;
}
function $d4d460d3ffb6daab$export$905b00761e12531b(date) {
    return $d4d460d3ffb6daab$export$e9cf274fc1035ec4((0, $da1615303898be1d$export$d9468344d3651243)(date, 'd MMMM'));
}
function $d4d460d3ffb6daab$export$18f8ccbe37e54acd(date) {
    return $d4d460d3ffb6daab$export$e9cf274fc1035ec4((0, $da1615303898be1d$export$d9468344d3651243)(date, 'MMMM yyyy'));
}
function $d4d460d3ffb6daab$export$1563a4bbc9fdec3a(date) {
    const days = $d4d460d3ffb6daab$export$b28d13d660cf3bf3(date);
    const first = days[0];
    const last = days[6];
    const sameMonth = (0, $da1615303898be1d$export$d9468344d3651243)(first, 'MM yyyy') === (0, $da1615303898be1d$export$d9468344d3651243)(last, 'MM yyyy');
    if (sameMonth) return $d4d460d3ffb6daab$export$e9cf274fc1035ec4(`${(0, $da1615303898be1d$export$d9468344d3651243)(first, 'd')} \u{2013} ${(0, $da1615303898be1d$export$d9468344d3651243)(last, 'd MMMM yyyy')}`);
    return $d4d460d3ffb6daab$export$e9cf274fc1035ec4(`${(0, $da1615303898be1d$export$d9468344d3651243)(first, 'd MMMM')} \u{2013} ${(0, $da1615303898be1d$export$d9468344d3651243)(last, 'd MMMM yyyy')}`);
}
function $d4d460d3ffb6daab$export$59226c665b47d8a8(date, { withYear: withYear = true } = {}) {
    const value = date instanceof Date ? date : $d4d460d3ffb6daab$var$parse(date);
    if (!value) return '';
    return new Intl.DateTimeFormat('en-GB', {
        day: 'numeric',
        month: 'short',
        ...withYear ? {
            year: 'numeric'
        } : {}
    }).format(value);
}
function $d4d460d3ffb6daab$export$2d14dc66f38a5d5f(iso, n) {
    const base = $d4d460d3ffb6daab$export$2052d237514e69a0(iso) ?? new Date();
    return $d4d460d3ffb6daab$export$ba57117c6378084d((0, $5432326631fed4eb$export$17c93e242b2d3a22)(base, n));
}
function $d4d460d3ffb6daab$export$3d9a2d9d5742b9a(iso) {
    const base = $d4d460d3ffb6daab$export$2052d237514e69a0(iso) ?? new Date();
    return $d4d460d3ffb6daab$export$18f8ccbe37e54acd(base);
}
function $d4d460d3ffb6daab$export$5960e8f7b4114e63(iso, { today: today = new Date() } = {}) {
    const base = $d4d460d3ffb6daab$export$2052d237514e69a0(iso) ?? $d4d460d3ffb6daab$export$63fa379ae8a9ba2(today);
    const first = (0, $af5de0b2582bebff$export$a5a3b454ada2268e)(base);
    const gridStart = $d4d460d3ffb6daab$export$b08f6004b835d36b(first);
    const weeks = [];
    const cursor = new Date(gridStart);
    for(let week = 0; week < 6; week += 1){
        const row = [];
        for(let day = 0; day < 7; day += 1){
            row.push({
                iso: $d4d460d3ffb6daab$export$ba57117c6378084d(cursor),
                label: $d4d460d3ffb6daab$export$e9cf274fc1035ec4((0, $da1615303898be1d$export$d9468344d3651243)(cursor, 'd')),
                inMonth: (0, $2afc42ef31f7b732$export$a18c89cbd24170ff)(cursor, first),
                isToday: $d4d460d3ffb6daab$export$ea39ec197993aef0(cursor, today),
                isWeekend: $d4d460d3ffb6daab$export$cfc9e8d9ee3dc0f4(cursor) === $d4d460d3ffb6daab$export$87b71208d3952cb3
            });
            cursor.setDate(cursor.getDate() + 1);
        }
        weeks.push(row);
    }
    return weeks;
}
function $d4d460d3ffb6daab$export$2052d237514e69a0(iso) {
    if (!iso) return null;
    const [y, m, d] = String(iso).slice(0, 10).split('-').map(Number);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
}
function $d4d460d3ffb6daab$export$ba57117c6378084d(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}
function $d4d460d3ffb6daab$export$42f3f62cb506de78() {
    return $d4d460d3ffb6daab$export$ba57117c6378084d(new Date());
}
function $d4d460d3ffb6daab$export$3203edd9e5edd663(iso) {
    const date = $d4d460d3ffb6daab$var$parse(iso);
    return date ? $d4d460d3ffb6daab$export$e9cf274fc1035ec4((0, $da1615303898be1d$export$d9468344d3651243)(date, 'HH:mm')) : "\u2014";
}
function $d4d460d3ffb6daab$export$ea39ec197993aef0(a, b) {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}
const $d4d460d3ffb6daab$export$b274e447bdddfc87 = {
    SCHEDULED: "\u0628\u0631\u0646\u0627\u0645\u0647\u200C\u0631\u06CC\u0632\u06CC\u200C\u0634\u062F\u0647",
    DONE: "\u0627\u0646\u062C\u0627\u0645\u200C\u0634\u062F\u0647",
    CANCELLED: "\u0644\u063A\u0648\u0634\u062F\u0647",
    MISSED: "\u0627\u0646\u062C\u0627\u0645\u200C\u0646\u0634\u062F\u0647"
};
const $d4d460d3ffb6daab$export$6fb89037e97dc785 = {
    IN_APP: "\u062F\u0631 \u0628\u0631\u0646\u0627\u0645\u0647",
    GOOGLE: "\u06AF\u0648\u06AF\u0644"
};


/**
 * In-app reminders, as a dismissible tray in the shell.
 *
 * A POLL, not a subscription. One query a minute per open tab is cheaper than
 * holding a socket open for each of them, and the tray is not a real-time
 * surface — a reminder that appears within a minute of firing is a reminder
 * that worked. A subscription is roadmap (todo.md), and would be the right
 * answer if this ever needed to be instant.
 *
 * It shows reminders the server has already FIRED, not ones that are merely
 * due. There is one firing path and this reads its output; computing "due" here
 * would be a second, competing one that could disagree with the events on the bus.
 *
 * Dismissal is local and per-tab, deliberately. A reminder is a nudge, not a
 * task: two tabs each dismissing their own copy is fine, and persisting the
 * dismissal would need a mutation, a table and a decision about what "seen"
 * means across devices — all for something the user will act on in the next
 * thirty seconds.
 */ 
var $2M70Q = parcelRequire("2M70Q");


var $6tkl0 = parcelRequire("6tkl0");/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $85349ebe33ede3d6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10.268 21a2 2 0 0 0 3.464 0",
            key: "vwvbt9"
        }
    ],
    [
        "path",
        {
            d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
            key: "11g9vi"
        }
    ]
];
const $85349ebe33ede3d6$export$2e2bcd8739ae039 = (0, $djixo.default)("bell", $85349ebe33ede3d6$export$3efd853dbb351e94);


var $bi4P4 = parcelRequire("bi4P4");

var $3OyDL = parcelRequire("3OyDL");

var $8B9Zg = parcelRequire("8B9Zg");
/**
 * The ONLY place app code may read density values (CLAUDE.md §12).
 *
 * Every value resolves to a design token — this module is a named, greppable
 * indirection, not a second source of truth. A raw pixel literal anywhere else
 * in `src/` is a bug and `npm run lint` fails on it.
 */ const $370d2fd34ead4cb4$export$ea79a652c275fff6 = {
    rowHeight: 'var(--mh-density-row-height)',
    rowPaddingY: 'var(--mh-density-row-padding-y)',
    rowPaddingX: 'var(--mh-density-row-padding-x)',
    headerHeight: 'var(--mh-density-header-height)',
    controlHeight: 'var(--mh-density-control-height)',
    toolbarHeight: 'var(--mh-density-toolbar-height)',
    sidebarWidth: 'var(--mh-density-sidebar-width)',
    overlayWidth: 'var(--mh-density-overlay-width)',
    overlayWidthWide: 'var(--mh-density-overlay-wide)',
    thumb: 'var(--mh-density-thumb)',
    avatar: 'var(--mh-density-avatar)',
    hour: 'var(--mh-density-hour)',
    timeGutter: 'var(--mh-density-time-gutter)',
    drawerWidth: 'var(--mh-density-drawer-width)',
    /* How tall one open filter section may grow before it scrolls inside itself.
     «شهر» has 31 options and would otherwise push half the panel off-screen. */ filterSectionMax: 'var(--mh-density-filter-section-max)'
};
const $370d2fd34ead4cb4$export$8ec3d08588d2eeda = 25;
const $370d2fd34ead4cb4$export$cd99908c73c6130 = 200;
const $370d2fd34ead4cb4$export$6341774785f0a1ff = 15;
const $370d2fd34ead4cb4$export$e907fe684aa8ce6c = 250;
const $370d2fd34ead4cb4$export$ddf7aeb94920d3f5 = 400;
const $370d2fd34ead4cb4$export$fc88ff6ef7948967 = 'px-4 py-2 align-middle';
const $370d2fd34ead4cb4$export$f3ef51d640bae134 = 7;
const $370d2fd34ead4cb4$export$89f380dcb6ef7bfb = 21;
const $370d2fd34ead4cb4$export$a8491cebaea55fc3 = 15;
const $370d2fd34ead4cb4$export$6f5a30ba6fce13da = 60;
const $370d2fd34ead4cb4$export$a66f137be64912c3 = 60000;
const $370d2fd34ead4cb4$export$a1a73e558e01ca3a = 767;
const $370d2fd34ead4cb4$export$dcc4079bc63af6b8 = `(max-width: ${$370d2fd34ead4cb4$export$a1a73e558e01ca3a}px)`;




/**
 * Every user-facing string in one place.
 *
 * Groundwork for real localization: today there is one locale (fa), so this is
 * a flat object rather than an i18n runtime. What it buys now is that no
 * component invents its own wording, and that swapping in a second locale later
 * is a change to this file plus a lookup helper — not a sweep through every
 * screen. Formatting of dates and digits stays in `format.js`.
 */ const $d916753b57975e04$export$25ce5a424b770e84 = {
    app: {
        name: "\u0645\u0634\u200C\u0647\u0627\u0628",
        loading: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC\u2026",
        retry: "\u062A\u0644\u0627\u0634 \u062F\u0648\u0628\u0627\u0631\u0647",
        cancel: "\u0627\u0646\u0635\u0631\u0627\u0641",
        save: "\u0630\u062E\u06CC\u0631\u0647",
        create: "\u0627\u06CC\u062C\u0627\u062F",
        edit: "\u0648\u06CC\u0631\u0627\u06CC\u0634",
        close: "\u0628\u0633\u062A\u0646",
        confirm: "\u062A\u0623\u06CC\u06CC\u062F",
        search: "\u062C\u0633\u062A\u200C\u0648\u062C\u0648",
        none: "\u2014",
        yes: "\u0628\u0644\u0647",
        no: "\u062E\u06CC\u0631",
        active: "\u0641\u0639\u0627\u0644",
        inactive: "\u063A\u06CC\u0631\u0641\u0639\u0627\u0644",
        activate: "\u0641\u0639\u0627\u0644\u200C\u0633\u0627\u0632\u06CC",
        deactivate: "\u063A\u06CC\u0631\u0641\u0639\u0627\u0644\u200C\u0633\u0627\u0632\u06CC",
        system: "\u0633\u06CC\u0633\u062A\u0645\u06CC",
        notFound: "\u0645\u0648\u0631\u062F\u06CC \u06CC\u0627\u0641\u062A \u0646\u0634\u062F",
        unknownError: "\u062E\u0637\u0627\u06CC \u0646\u0627\u0645\u0634\u062E\u0635",
        add: "\u0627\u0641\u0632\u0648\u062F\u0646",
        remove: "\u062D\u0630\u0641",
        delete: "\u062D\u0630\u0641",
        restore: "\u0628\u0627\u0632\u06AF\u0631\u062F\u0627\u0646\u06CC",
        all: "\u0647\u0645\u0647",
        from: "\u0627\u0632",
        to: "\u062A\u0627",
        apply: "\u0627\u0639\u0645\u0627\u0644",
        clear: "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646",
        optional: "\u0627\u062E\u062A\u06CC\u0627\u0631\u06CC",
        saving: "\u062F\u0631 \u062D\u0627\u0644 \u0630\u062E\u06CC\u0631\u0647\u2026",
        saved: "\u0630\u062E\u06CC\u0631\u0647 \u0634\u062F",
        previous: "\u0642\u0628\u0644\u06CC",
        next: "\u0628\u0639\u062F\u06CC",
        pageOf: (page, total)=>`\u{635}\u{641}\u{62D}\u{647} ${page} \u{627}\u{632} ${total}`,
        download: "\u062F\u0631\u06CC\u0627\u0641\u062A",
        // --- the date and time pickers ---
        pickDate: "\u0627\u0646\u062A\u062E\u0627\u0628 \u062A\u0627\u0631\u06CC\u062E",
        pickTime: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0633\u0627\u0639\u062A",
        today: "\u0627\u0645\u0631\u0648\u0632",
        hour: "\u0633\u0627\u0639\u062A",
        minute: "\u062F\u0642\u06CC\u0642\u0647",
        previousMonth: "\u0645\u0627\u0647 \u0642\u0628\u0644",
        nextMonth: "\u0645\u0627\u0647 \u0628\u0639\u062F"
    },
    /**
   * The inline vocabulary creator (`components/VocabularyField.web.jsx`).
   * Deliberately generic: it is used for activity types, interaction types and
   * issue types, and naming any of them here would put a deployment's
   * vocabulary into the client (CLAUDE.md §1).
   */ vocabulary: {
        none: "\u2014 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F \u2014",
        addNew: "\u0627\u0641\u0632\u0648\u062F\u0646 \u06AF\u0632\u06CC\u0646\u0647 \u062A\u0627\u0632\u0647 \u0628\u0647 \u0627\u06CC\u0646 \u0641\u0647\u0631\u0633\u062A",
        addNewShort: "\u06AF\u0632\u06CC\u0646\u0647 \u062A\u0627\u0632\u0647",
        newLabel: "\u0646\u0627\u0645 \u06AF\u0632\u06CC\u0646\u0647 \u062A\u0627\u0632\u0647",
        newHint: "\u0646\u0627\u0645 \u0631\u0627 \u0628\u0646\u0648\u06CC\u0633\u06CC\u062F\u061B \u0647\u0645\u06CC\u0646\u200C\u062C\u0627 \u0627\u0641\u0632\u0648\u062F\u0647 \u0648 \u0627\u0646\u062A\u062E\u0627\u0628 \u0645\u06CC\u200C\u0634\u0648\u062F.",
        codeIs: (code)=>`\u{6A9}\u{62F}: ${code} \u{2014} \u{67E}\u{633} \u{627}\u{632} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{642}\u{627}\u{628}\u{644} \u{62A}\u{63A}\u{6CC}\u{6CC}\u{631} \u{646}\u{6CC}\u{633}\u{62A}.`,
        emptyUser: "\u0647\u0646\u0648\u0632 \u06AF\u0632\u06CC\u0646\u0647\u200C\u0627\u06CC \u062A\u0639\u0631\u06CC\u0641 \u0646\u0634\u062F\u0647 \u0627\u0633\u062A. \u0627\u0632 \u0645\u062F\u06CC\u0631 \u0633\u0627\u0645\u0627\u0646\u0647 \u0628\u062E\u0648\u0627\u0647\u06CC\u062F \u0627\u06CC\u0646 \u0641\u0647\u0631\u0633\u062A \u0631\u0627 \u062A\u06A9\u0645\u06CC\u0644 \u06A9\u0646\u062F."
    },
    auth: {
        signIn: "\u0648\u0631\u0648\u062F \u0628\u0647 \u0645\u0634\u200C\u0647\u0627\u0628",
        signInAction: "\u0648\u0631\u0648\u062F \u0628\u0627 \u062D\u0633\u0627\u0628 \u0633\u0627\u0632\u0645\u0627\u0646\u06CC",
        signInHint: "\u0628\u0631\u0627\u06CC \u0627\u062F\u0627\u0645\u0647 \u0628\u0627 \u062D\u0633\u0627\u0628 \u0633\u0627\u0632\u0645\u0627\u0646\u06CC \u062E\u0648\u062F \u0648\u0627\u0631\u062F \u0634\u0648\u06CC\u062F.",
        signOut: "\u062E\u0631\u0648\u062C",
        signingIn: "\u062F\u0631 \u062D\u0627\u0644 \u0648\u0631\u0648\u062F\u2026",
        sessionExpired: "\u0646\u0634\u0633\u062A \u0634\u0645\u0627 \u0645\u0646\u0642\u0636\u06CC \u0634\u062F\u0647 \u0627\u0633\u062A. \u062F\u0648\u0628\u0627\u0631\u0647 \u0648\u0627\u0631\u062F \u0634\u0648\u06CC\u062F.",
        forbiddenTitle: "\u062F\u0633\u062A\u0631\u0633\u06CC \u0646\u062F\u0627\u0631\u06CC\u062F",
        forbiddenHint: "\u0627\u06CC\u0646 \u0628\u062E\u0634 \u062A\u0646\u0647\u0627 \u0628\u0631\u0627\u06CC \u0645\u062F\u06CC\u0631\u0627\u0646 \u0633\u0627\u0645\u0627\u0646\u0647 \u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0627\u0633\u062A. \u0627\u06AF\u0631 \u0641\u06A9\u0631 \u0645\u06CC\u200C\u06A9\u0646\u06CC\u062F \u0627\u0634\u062A\u0628\u0627\u0647\u06CC \u0631\u062E \u062F\u0627\u062F\u0647\u060C \u0628\u0627 \u0645\u062F\u06CC\u0631 \u0633\u0627\u0645\u0627\u0646\u0647 \u062A\u0645\u0627\u0633 \u0628\u06AF\u06CC\u0631\u06CC\u062F.",
        backToContacts: "\u0628\u0627\u0632\u06AF\u0634\u062A \u0628\u0647 \u0645\u062E\u0627\u0637\u0628\u06CC\u0646",
        roleAdmin: "\u0645\u062F\u06CC\u0631",
        roleUser: "\u06A9\u0627\u0631\u0628\u0631"
    },
    nav: {
        dashboard: "\u062F\u0627\u0634\u0628\u0648\u0631\u062F",
        contacts: "\u0645\u062E\u0627\u0637\u0628\u06CC\u0646",
        settings: "\u062A\u0646\u0638\u06CC\u0645\u0627\u062A",
        shortcuts: "\u0645\u06CC\u0627\u0646\u200C\u0628\u0631\u0647\u0627",
        // The other bundle of the app, at /platform (ex Parsina's admin panel).
        platform: "\u067E\u0646\u0644 \u067E\u0644\u062A\u0641\u0631\u0645",
        // …which is all of it a CRM-only user may open: the demo-request queue.
        demoRequests: "\u062F\u0631\u062E\u0648\u0627\u0633\u062A\u200C\u0647\u0627\u06CC \u062F\u0645\u0648"
    },
    contacts: {
        title: "\u0645\u062E\u0627\u0637\u0628\u06CC\u0646",
        count: (n)=>`${n} \u{645}\u{648}\u{631}\u{62F}`,
        searchPlaceholder: "\u062C\u0633\u062A\u200C\u0648\u062C\u0648\u06CC \u0646\u0627\u0645 \u06CC\u0627 \u0634\u0645\u0627\u0631\u0647\u2026",
        searchLabel: "\u062C\u0633\u062A\u200C\u0648\u062C\u0648\u06CC \u0645\u062E\u0627\u0637\u0628\u06CC\u0646",
        emptyHint: "\u0639\u0628\u0627\u0631\u062A \u062C\u0633\u062A\u200C\u0648\u062C\u0648 \u0631\u0627 \u062A\u063A\u06CC\u06CC\u0631 \u062F\u0647\u06CC\u062F.",
        columns: {
            name: "\u0646\u0627\u0645",
            specialty: "\u062A\u062E\u0635\u0635 / \u062D\u0648\u0632\u0647",
            primaryPhone: "\u0634\u0645\u0627\u0631\u0647 \u0627\u0635\u0644\u06CC",
            channels: "\u06A9\u0627\u0646\u0627\u0644\u200C\u0647\u0627",
            assessment: "\u0627\u0631\u0632\u06CC\u0627\u0628\u06CC",
            referrer: "\u0645\u0639\u0631\u0641",
            tags: "\u0628\u0631\u0686\u0633\u0628\u200C\u0647\u0627",
            updatedAt: "\u0622\u062E\u0631\u06CC\u0646 \u0628\u0631\u0648\u0632\u0631\u0633\u0627\u0646\u06CC"
        },
        columnPhoto: "\u062A\u0635\u0648\u06CC\u0631",
        statusFilterAll: "\u0647\u0645\u0647 \u0648\u0636\u0639\u06CC\u062A\u200C\u0647\u0627",
        showDeleted: "\u062D\u0630\u0641\u200C\u0634\u062F\u0647\u200C\u0647\u0627",
        deletedNotice: "\u0627\u06CC\u0646 \u0645\u062E\u0627\u0637\u0628 \u062D\u0630\u0641 \u0634\u062F\u0647 \u0627\u0633\u062A \u0648 \u062F\u0631 \u0641\u0647\u0631\u0633\u062A\u200C\u0647\u0627 \u062F\u06CC\u062F\u0647 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F.",
        detail: {
            profile: "\u0645\u0634\u062E\u0635\u0627\u062A",
            phones: "\u0634\u0645\u0627\u0631\u0647\u200C\u0647\u0627",
            interests: "\u0645\u062D\u0635\u0648\u0644\u0627\u062A \u0645\u0648\u0631\u062F \u0639\u0644\u0627\u0642\u0647",
            affiliations: "\u0648\u0627\u0628\u0633\u062A\u06AF\u06CC\u200C\u0647\u0627",
            interactions: "\u062A\u0639\u0627\u0645\u0644\u0627\u062A",
            statusHistory: "\u062A\u0627\u0631\u06CC\u062E\u0686\u0647 \u0645\u0631\u062D\u0644\u0647 \u0627\u0634\u062A\u0631\u0627\u06A9",
            customFields: "\u0627\u0637\u0644\u0627\u0639\u0627\u062A \u062A\u06A9\u0645\u06CC\u0644\u06CC",
            noPhones: "\u0634\u0645\u0627\u0631\u0647\u200C\u0627\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
            noInteractions: "\u062A\u0639\u0627\u0645\u0644\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
            noInterests: "\u0645\u062D\u0635\u0648\u0644\u06CC \u0627\u0646\u062A\u062E\u0627\u0628 \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
            noAffiliations: "\u0648\u0627\u0628\u0633\u062A\u06AF\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
            primary: "\u0627\u0635\u0644\u06CC",
            makePrimary: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0628\u0647\u200C\u0639\u0646\u0648\u0627\u0646 \u0627\u0635\u0644\u06CC",
            outcome: "\u0646\u062A\u06CC\u062C\u0647",
            kind: "\u0646\u0648\u0639",
            fieldOfWork: "\u062D\u0648\u0632\u0647 \u0641\u0639\u0627\u0644\u06CC\u062A",
            specialty: "\u062A\u062E\u0635\u0635",
            subSpecialty: "\u0641\u0648\u0642 \u062A\u062E\u0635\u0635",
            subscriptionType: "\u0646\u0648\u0639 \u0627\u0634\u062A\u0631\u0627\u06A9",
            birthDate: "\u062A\u0627\u0631\u06CC\u062E \u062A\u0648\u0644\u062F",
            instagram: "\u0627\u06CC\u0646\u0633\u062A\u0627\u06AF\u0631\u0627\u0645",
            address: "\u0646\u0634\u0627\u0646\u06CC",
            description: "\u062A\u0648\u0636\u06CC\u062D\u0627\u062A",
            notFound: "\u0645\u062E\u0627\u0637\u0628 \u06CC\u0627\u0641\u062A \u0646\u0634\u062F",
            firstName: "\u0646\u0627\u0645",
            lastName: "\u0646\u0627\u0645 \u062E\u0627\u0646\u0648\u0627\u062F\u06AF\u06CC",
            orgName: "\u0646\u0627\u0645 \u0633\u0627\u0632\u0645\u0627\u0646",
            gender: "\u062C\u0646\u0633\u06CC\u062A",
            tags: "\u0628\u0631\u0686\u0633\u0628\u200C\u0647\u0627",
            addTag: "\u0627\u0641\u0632\u0648\u062F\u0646 \u0628\u0631\u0686\u0633\u0628",
            editProfile: "\u0648\u06CC\u0631\u0627\u06CC\u0634 \u0645\u0634\u062E\u0635\u0627\u062A",
            changeStatus: "\u062A\u063A\u06CC\u06CC\u0631 \u0648\u0636\u0639\u06CC\u062A",
            recordInteraction: "\u062B\u0628\u062A \u062A\u0639\u0627\u0645\u0644",
            photo: "\u062A\u0635\u0648\u06CC\u0631 \u0645\u062E\u0627\u0637\u0628",
            // Read out by a screen reader in place of a photo, and shown on hover.
            // The glyph says something about the person, so unlike the initials it
            // is not decorative and needs a name.
            genderAvatar: {
                MALE: "\u0645\u062E\u0627\u0637\u0628 \u0645\u0631\u062F",
                FEMALE: "\u0645\u062E\u0627\u0637\u0628 \u0632\u0646"
            },
            uploadPhoto: "\u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u062A\u0635\u0648\u06CC\u0631",
            replacePhoto: "\u062A\u063A\u06CC\u06CC\u0631 \u062A\u0635\u0648\u06CC\u0631",
            deleteContact: "\u062D\u0630\u0641 \u0645\u062E\u0627\u0637\u0628",
            undeleteContact: "\u0628\u0627\u0632\u06AF\u0631\u062F\u0627\u0646\u06CC \u0645\u062E\u0627\u0637\u0628",
            confirmDelete: (name)=>`\xab${name}\xbb \u{62D}\u{630}\u{641} \u{634}\u{648}\u{62F}\u{61F} \u{627}\u{632} \u{641}\u{647}\u{631}\u{633}\u{62A}\u{200C}\u{647}\u{627} \u{67E}\u{646}\u{647}\u{627}\u{646} \u{645}\u{6CC}\u{200C}\u{634}\u{648}\u{62F} \u{627}\u{645}\u{627} \u{633}\u{648}\u{627}\u{628}\u{642}\u{60C} \u{62A}\u{639}\u{627}\u{645}\u{644}\u{627}\u{62A} \u{648} \u{62A}\u{627}\u{631}\u{6CC}\u{62E}\u{686}\u{647}\u{200C}\u{627}\u{634} \u{62F}\u{633}\u{62A}\u{200C}\u{646}\u{62E}\u{648}\u{631}\u{62F}\u{647} \u{645}\u{6CC}\u{200C}\u{645}\u{627}\u{646}\u{646}\u{62F} \u{648} \u{645}\u{62F}\u{6CC}\u{631} \u{645}\u{6CC}\u{200C}\u{62A}\u{648}\u{627}\u{646}\u{62F} \u{628}\u{627}\u{632}\u{634} \u{6AF}\u{631}\u{62F}\u{627}\u{646}\u{62F}.`,
            confirmUndelete: (name)=>`\xab${name}\xbb \u{628}\u{647} \u{641}\u{647}\u{631}\u{633}\u{62A} \u{645}\u{62E}\u{627}\u{637}\u{628}\u{6CC}\u{646} \u{628}\u{627}\u{632}\u{6AF}\u{631}\u{62F}\u{627}\u{646}\u{62F}\u{647} \u{634}\u{648}\u{62F}\u{61F}`,
            deleteReason: "\u062F\u0644\u06CC\u0644 \u062D\u0630\u0641",
            // A number a live contact already holds. The server names WHO; the
            // wording is here, and the link lets a rep open the one on file instead
            // of typing the doctor in twice.
            duplicatePhone: (number, name)=>`\u{634}\u{645}\u{627}\u{631}\u{647}\u{654} ${number} \u{642}\u{628}\u{644}\u{627}\u{64B} \u{628}\u{631}\u{627}\u{6CC} \xab${name || "\u0645\u062E\u0627\u0637\u0628 \u062F\u06CC\u06AF\u0631\u06CC"}\xbb \u{62B}\u{628}\u{62A} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}\u{61B} \u{645}\u{62E}\u{627}\u{637}\u{628} \u{62A}\u{6A9}\u{631}\u{627}\u{631}\u{6CC} \u{633}\u{627}\u{62E}\u{62A}\u{647} \u{646}\u{634}\u{62F}.`,
            duplicatePhoneSameContact: (number)=>`\u{634}\u{645}\u{627}\u{631}\u{647}\u{654} ${number} \u{642}\u{628}\u{644}\u{627}\u{64B} \u{628}\u{631}\u{627}\u{6CC} \u{647}\u{645}\u{6CC}\u{646} \u{645}\u{62E}\u{627}\u{637}\u{628} \u{62B}\u{628}\u{62A} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}.`,
            openExistingContact: "\u0645\u0634\u0627\u0647\u062F\u0647\u0654 \u0647\u0645\u0627\u0646 \u0645\u062E\u0627\u0637\u0628",
            addPhone: "\u0627\u0641\u0632\u0648\u062F\u0646 \u0634\u0645\u0627\u0631\u0647",
            editPhone: "\u0648\u06CC\u0631\u0627\u06CC\u0634 \u0634\u0645\u0627\u0631\u0647",
            phoneNumber: "\u0634\u0645\u0627\u0631\u0647",
            phoneLabel: "\u0628\u0631\u0686\u0633\u0628 \u0634\u0645\u0627\u0631\u0647",
            phoneNotes: "\u06CC\u0627\u062F\u062F\u0627\u0634\u062A",
            channels: "\u06A9\u0627\u0646\u0627\u0644\u200C\u0647\u0627",
            confirmRemovePhone: (number)=>`\u{634}\u{645}\u{627}\u{631}\u{647} ${number} \u{62D}\u{630}\u{641} \u{634}\u{648}\u{62F}\u{61F} \u{627}\u{6CC}\u{646} \u{62D}\u{630}\u{641} \u{642}\u{637}\u{639}\u{6CC} \u{627}\u{633}\u{62A}.`,
            addAffiliation: "\u0627\u0641\u0632\u0648\u062F\u0646 \u0648\u0627\u0628\u0633\u062A\u06AF\u06CC",
            organization: "\u0633\u0627\u0632\u0645\u0627\u0646",
            person: "\u0634\u062E\u0635",
            roleTitle: "\u0633\u0645\u062A",
            searchOrganization: "\u062C\u0633\u062A\u200C\u0648\u062C\u0648\u06CC \u0633\u0627\u0632\u0645\u0627\u0646\u2026",
            searchPerson: "\u062C\u0633\u062A\u200C\u0648\u062C\u0648\u06CC \u0634\u062E\u0635\u2026",
            confirmRemoveAffiliation: (name)=>`\u{648}\u{627}\u{628}\u{633}\u{62A}\u{6AF}\u{6CC} \u{628}\u{647} \xab${name}\xbb \u{62D}\u{630}\u{641} \u{634}\u{648}\u{62F}\u{61F}`,
            // --- the CRM profile fields. Standard Persian CRM terms rather than
            // literal translations: «سرنخ» is what a sales team says, «رهبری» is
            // what a dictionary says. ---
            sections: {
                basics: "\u0627\u0637\u0644\u0627\u0639\u0627\u062A \u067E\u0627\u06CC\u0647",
                professional: "\u0627\u0637\u0644\u0627\u0639\u0627\u062A \u062D\u0631\u0641\u0647\u200C\u0627\u06CC",
                crm: "\u0627\u0637\u0644\u0627\u0639\u0627\u062A CRM",
                facility: "\u0627\u0637\u0644\u0627\u0639\u0627\u062A \u0645\u0631\u06A9\u0632",
                relations: "\u0627\u0631\u062A\u0628\u0627\u0637\u0627\u062A"
            },
            // The spec's own title, and the one the filter panel uses — so the
            // field and the filter on it read the same.
            lifecycleStage: "\u0648\u0636\u0639\u06CC\u062A \u0686\u0631\u062E\u0647 \u0639\u0645\u0631 \u0645\u0634\u062A\u0631\u06CC",
            salesStage: "\u0645\u0631\u062D\u0644\u0647 \u0641\u0631\u0648\u0634",
            customerHealth: "\u0648\u0636\u0639\u06CC\u062A \u0645\u0634\u062A\u0631\u06CC",
            engagementStatus: "\u0648\u0636\u0639\u06CC\u062A \u0647\u0645\u06A9\u0627\u0631\u06CC",
            // The pre-existing subscription pipeline. Relabelled so it cannot be
            // read as the new «وضعیت همکاری» beside it — same values, same history,
            // a name that says which question it answers.
            collaborationStatus: "\u0645\u0631\u062D\u0644\u0647 \u0627\u0634\u062A\u0631\u0627\u06A9",
            city: "\u0634\u0647\u0631",
            facilityType: "\u0646\u0648\u0639 \u0645\u062E\u0627\u0637\u0628",
            centerName: "\u0646\u0627\u0645 \u0645\u0631\u06A9\u0632",
            centerNameRequired: "\u0628\u0631\u0627\u06CC \u0627\u06CC\u0646 \u0646\u0648\u0639 \u0645\u062E\u0627\u0637\u0628\u060C \u062B\u0628\u062A \u0646\u0627\u0645 \u0645\u0631\u06A9\u0632 \u0627\u0644\u0632\u0627\u0645\u06CC \u0627\u0633\u062A.",
            professionalCode: "\u0646\u0638\u0627\u0645 \u067E\u0632\u0634\u06A9\u06CC / \u06A9\u062F \u062D\u0631\u0641\u0647\u200C\u0627\u06CC",
            acquisitionSource: "\u0646\u062D\u0648\u0647 \u0622\u0634\u0646\u0627\u06CC\u06CC",
            isGold: "\u0645\u0634\u062A\u0631\u06CC \u0648\u06CC\u0698\u0647 (Gold)",
            isGoldOn: "\u0648\u06CC\u0698\u0647",
            referrer: "\u0645\u0639\u0631\u0641",
            addReferrer: "\u0627\u0641\u0632\u0648\u062F\u0646 \u0645\u0639\u0631\u0641",
            changeReferrer: "\u062A\u063A\u06CC\u06CC\u0631 \u0645\u0639\u0631\u0641",
            removeReferrer: "\u062D\u0630\u0641 \u0645\u0639\u0631\u0641",
            searchContact: "\u062C\u0633\u062A\u200C\u0648\u062C\u0648\u06CC \u0645\u062E\u0627\u0637\u0628\u2026",
            moreContacts: (n)=>`${n} \u{645}\u{62E}\u{627}\u{637}\u{628} \u{62F}\u{6CC}\u{6AF}\u{631} \u{647}\u{645} \u{647}\u{633}\u{62A}\u{61B} \u{628}\u{631}\u{627}\u{6CC} \u{6CC}\u{627}\u{641}\u{62A}\u{646} \u{622}\u{646}\u{200C}\u{647}\u{627} \u{62C}\u{633}\u{62A}\u{200C}\u{648}\u{62C}\u{648} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
            noReferrer: "\u0645\u0639\u0631\u0641\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
            referrerSelfError: "\u06CC\u06A9 \u0645\u062E\u0627\u0637\u0628 \u0646\u0645\u06CC\u200C\u062A\u0648\u0627\u0646\u062F \u0645\u0639\u0631\u0641 \u062E\u0648\u062F\u0634 \u0628\u0627\u0634\u062F.",
            files: "\u0641\u0627\u06CC\u0644\u200C\u0647\u0627\u06CC \u067E\u06CC\u0648\u0633\u062A",
            addFile: "\u0627\u0641\u0632\u0648\u062F\u0646 \u0641\u0627\u06CC\u0644",
            noFiles: "\u0641\u0627\u06CC\u0644\u06CC \u067E\u06CC\u0648\u0633\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A."
        }
    },
    quickAdd: {
        title: "\u062B\u0628\u062A \u0633\u0631\u06CC\u0639 \u0645\u062E\u0627\u0637\u0628",
        hint: "\u0641\u0642\u0637 \u0646\u0627\u0645 \u062E\u0627\u0646\u0648\u0627\u062F\u06AF\u06CC \u0644\u0627\u0632\u0645 \u0627\u0633\u062A\u061B \u0628\u0627\u0642\u06CC \u0627\u0637\u0644\u0627\u0639\u0627\u062A \u0631\u0627 \u0628\u0639\u062F\u0627\u064B \u06A9\u0627\u0645\u0644 \u06A9\u0646\u06CC\u062F.",
        open: "\u062B\u0628\u062A \u0633\u0631\u06CC\u0639",
        firstName: "\u0646\u0627\u0645",
        lastName: "\u0646\u0627\u0645 \u062E\u0627\u0646\u0648\u0627\u062F\u06AF\u06CC",
        phone: "\u0634\u0645\u0627\u0631\u0647 \u062A\u0645\u0627\u0633",
        fieldOfWork: "\u062D\u0648\u0632\u0647 \u0641\u0639\u0627\u0644\u06CC\u062A",
        note: "\u06CC\u0627\u062F\u062F\u0627\u0634\u062A \u0627\u0648\u0644\u06CC\u0646 \u062A\u0645\u0627\u0633",
        notePlaceholder: "\u06A9\u062C\u0627 \u0648 \u0686\u0637\u0648\u0631 \u0622\u0634\u0646\u0627 \u0634\u062F\u06CC\u062F\u061F \u0627\u06CC\u0646 \u0645\u062A\u0646 \u0628\u0647\u200C\u0639\u0646\u0648\u0627\u0646 \u0627\u0648\u0644\u06CC\u0646 \u062A\u0639\u0627\u0645\u0644 \u062B\u0628\u062A \u0645\u06CC\u200C\u0634\u0648\u062F.",
        submit: "\u062B\u0628\u062A \u0648 \u0628\u0633\u062A\u0646",
        submitAndAnother: "\u062B\u0628\u062A \u0648 \u0645\u0648\u0631\u062F \u0628\u0639\u062F\u06CC",
        added: (name)=>`\xab${name}\xbb \u{62B}\u{628}\u{62A} \u{634}\u{62F}.`,
        lastNameRequired: "\u0646\u0627\u0645 \u062E\u0627\u0646\u0648\u0627\u062F\u06AF\u06CC \u0644\u0627\u0632\u0645 \u0627\u0633\u062A.",
        // Mobile only: the disclosure that hides the two fields a rep does not
        // type while talking.
        more: "\u0627\u0637\u0644\u0627\u0639\u0627\u062A \u0628\u06CC\u0634\u062A\u0631",
        channels: "\u0631\u0627\u0647\u200C\u0647\u0627\u06CC \u0627\u0631\u062A\u0628\u0627\u0637\u06CC",
        noteBecomesInteraction: "\u06CC\u0627\u062F\u062F\u0627\u0634\u062A \u0628\u0647\u200C\u0639\u0646\u0648\u0627\u0646 \u0627\u0648\u0644\u06CC\u0646 \u062A\u0639\u0627\u0645\u0644 \u062B\u0628\u062A \u0645\u06CC\u200C\u0634\u0648\u062F.",
        // The CRM fields, behind a disclosure that starts CLOSED. Exhibition mode
        // is a surname, a number and thirty seconds; everything below is for the
        // person filling a profile in at a desk.
        crmDetails: "\u0627\u0637\u0644\u0627\u0639\u0627\u062A \u062A\u06A9\u0645\u06CC\u0644\u06CC CRM",
        crmDetailsHint: "\u0627\u062E\u062A\u06CC\u0627\u0631\u06CC \u2014 \u0628\u0639\u062F\u0627\u064B \u0647\u0645 \u0627\u0632 \u0635\u0641\u062D\u0647 \u0645\u062E\u0627\u0637\u0628 \u0642\u0627\u0628\u0644 \u0648\u06CC\u0631\u0627\u06CC\u0634 \u0627\u0633\u062A.",
        product: "\u0645\u062D\u0635\u0648\u0644 \u0645\u0648\u0631\u062F \u0639\u0644\u0627\u0642\u0647",
        sendMessage: "\u0627\u0631\u0633\u0627\u0644 \u067E\u06CC\u0627\u0645 \u0628\u0647 \u0627\u06CC\u0646 \u0645\u062E\u0627\u0637\u0628"
    },
    interaction: {
        title: "\u062B\u0628\u062A \u062A\u0639\u0627\u0645\u0644",
        type: "\u0646\u0648\u0639 \u062A\u0639\u0627\u0645\u0644",
        occurredAt: "\u0632\u0645\u0627\u0646",
        date: "\u062A\u0627\u0631\u06CC\u062E",
        time: "\u0633\u0627\u0639\u062A",
        description: "\u0634\u0631\u062D",
        outcome: "\u0646\u062A\u06CC\u062C\u0647",
        status: "\u0648\u0636\u0639\u06CC\u062A",
        followUpNote: "\u06CC\u0627\u062F\u062F\u0627\u0634\u062A \u067E\u06CC\u06AF\u06CC\u0631\u06CC",
        followUpHint: "\u0641\u0639\u0644\u0627\u064B \u0628\u0647 \u0627\u0646\u062A\u0647\u0627\u06CC \u0634\u0631\u062D \u0627\u0641\u0632\u0648\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F\u061B \u067E\u06CC\u06AF\u06CC\u0631\u06CC \u0628\u0647\u200C\u0639\u0646\u0648\u0627\u0646 \u06CC\u06A9 \u0641\u0639\u0627\u0644\u06CC\u062A \u0645\u0633\u062A\u0642\u0644 \u0628\u0627 \u0633\u0631\u0648\u06CC\u0633 \u0632\u0645\u0627\u0646\u200C\u0628\u0646\u062F\u06CC \u0645\u06CC\u200C\u0622\u06CC\u062F.",
        attachments: "\u067E\u06CC\u0648\u0633\u062A\u200C\u0647\u0627",
        dropzone: "\u0641\u0627\u06CC\u0644 \u0631\u0627 \u0627\u06CC\u0646\u062C\u0627 \u0631\u0647\u0627 \u06A9\u0646\u06CC\u062F \u06CC\u0627 \u0628\u0631\u0627\u06CC \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0644\u06CC\u06A9 \u06A9\u0646\u06CC\u062F",
        uploading: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC\u2026",
        uploadFailed: "\u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0627\u0645\u0648\u0641\u0642 \u0628\u0648\u062F.",
        filterType: "\u0646\u0648\u0639",
        filterFrom: "\u0627\u0632 \u062A\u0627\u0631\u06CC\u062E",
        filterTo: "\u062A\u0627 \u062A\u0627\u0631\u06CC\u062E",
        clearFilters: "\u062D\u0630\u0641 \u0641\u06CC\u0644\u062A\u0631\u0647\u0627",
        loadMore: "\u0646\u0645\u0627\u06CC\u0634 \u0628\u06CC\u0634\u062A\u0631",
        by: "\u062B\u0628\u062A \u062A\u0648\u0633\u0637",
        invalidDate: "\u062A\u0627\u0631\u06CC\u062E \u0645\u0639\u062A\u0628\u0631 \u0646\u06CC\u0633\u062A (\u0645\u062B\u0627\u0644: \u06F1\u06F4\u06F0\u06F5/\u06F0\u06F6/\u06F0\u06F8).",
        typeRequired: "\u0646\u0648\u0639 \u062A\u0639\u0627\u0645\u0644 \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F."
    },
    voice: {
        start: "\u0634\u0631\u0648\u0639 \u06AF\u0648\u06CC\u0634",
        stop: "\u062A\u0648\u0642\u0641 \u06AF\u0648\u06CC\u0634",
        listening: "\u062F\u0631 \u062D\u0627\u0644 \u0634\u0646\u06CC\u062F\u0646\u2026",
        denied: "\u062F\u0633\u062A\u0631\u0633\u06CC \u0628\u0647 \u0645\u06CC\u06A9\u0631\u0648\u0641\u0648\u0646 \u062F\u0627\u062F\u0647 \u0646\u0634\u062F. \u0627\u0632 \u062A\u0646\u0638\u06CC\u0645\u0627\u062A \u0645\u0631\u0648\u0631\u06AF\u0631 \u0627\u062C\u0627\u0632\u0647 \u062F\u0647\u06CC\u062F.",
        failed: "\u062A\u0628\u062F\u06CC\u0644 \u06AF\u0641\u062A\u0627\u0631 \u0628\u0647 \u0645\u062A\u0646 \u0627\u0646\u062C\u0627\u0645 \u0646\u0634\u062F.",
        noSpeech: "\u0635\u062F\u0627\u06CC\u06CC \u0634\u0646\u06CC\u062F\u0647 \u0646\u0634\u062F.",
        privacy: "\u06AF\u0641\u062A\u0627\u0631 \u062F\u0631 \u0645\u0631\u0648\u0631\u06AF\u0631 \u0634\u0645\u0627 \u067E\u0631\u062F\u0627\u0632\u0634 \u0645\u06CC\u200C\u0634\u0648\u062F \u0648 \u0631\u0648\u06CC \u0633\u0631\u0648\u0631\u0647\u0627\u06CC \u0645\u0634\u200C\u0647\u0627\u0628 \u0630\u062E\u06CC\u0631\u0647 \u0646\u0645\u06CC\u200C\u06AF\u0631\u062F\u062F."
    },
    status: {
        title: "\u062A\u063A\u06CC\u06CC\u0631 \u0645\u0631\u062D\u0644\u0647 \u0627\u0634\u062A\u0631\u0627\u06A9",
        current: "\u0648\u0636\u0639\u06CC\u062A \u0641\u0639\u0644\u06CC",
        next: "\u0648\u0636\u0639\u06CC\u062A \u062C\u062F\u06CC\u062F",
        reason: "\u062F\u0644\u06CC\u0644",
        reasonRequiredBackward: "\u0628\u0631\u0627\u06CC \u0628\u0627\u0632\u06AF\u0634\u062A \u0628\u0647 \u0645\u0631\u062D\u0644\u0647 \u0642\u0628\u0644\u060C \u0630\u06A9\u0631 \u062F\u0644\u06CC\u0644 \u0644\u0627\u0632\u0645 \u0627\u0633\u062A \u2014 \u06A9\u0633\u06CC \u06A9\u0647 \u0645\u0627\u0647\u200C\u0647\u0627 \u0628\u0639\u062F \u0627\u06CC\u0646 \u062A\u0627\u0631\u06CC\u062E\u0686\u0647 \u0631\u0627 \u0645\u06CC\u200C\u062E\u0648\u0627\u0646\u062F \u0628\u0627\u06CC\u062F \u0628\u062F\u0627\u0646\u062F \u0686\u0647 \u0634\u062F.",
        reasonOptional: "\u062F\u0644\u06CC\u0644 (\u0627\u062E\u062A\u06CC\u0627\u0631\u06CC)",
        submit: "\u062B\u0628\u062A \u062A\u063A\u06CC\u06CC\u0631",
        history: "\u062A\u0627\u0631\u06CC\u062E\u0686\u0647",
        by: "\u062A\u0648\u0633\u0637"
    },
    imports: {
        title: "\u0648\u0631\u0648\u062F \u0645\u062E\u0627\u0637\u0628\u06CC\u0646 \u0627\u0632 \u0641\u0627\u06CC\u0644 \u0627\u06A9\u0633\u0644",
        intro: "\u0641\u0627\u06CC\u0644 \u0627\u06A9\u0633\u0644 \u0647\u0645\u0627\u06CC\u0634 \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F. \u0627\u0628\u062A\u062F\u0627 \u067E\u06CC\u0634\u200C\u0646\u0645\u0627\u06CC\u0634 \u06AF\u0631\u0641\u062A\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F \u0648 \u0647\u06CC\u0686 \u0686\u06CC\u0632\u06CC \u0630\u062E\u06CC\u0631\u0647 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F\u061B \u067E\u0633 \u0627\u0632 \u062A\u0623\u06CC\u06CC\u062F \u0634\u0645\u0627\u060C \u0647\u0645\u0627\u0646 \u0646\u062A\u06CC\u062C\u0647 \u0627\u0639\u0645\u0627\u0644 \u0645\u06CC\u200C\u06AF\u0631\u062F\u062F.",
        columns: "\u0633\u062A\u0648\u0646\u200C\u0647\u0627\u06CC \u0645\u0648\u0631\u062F \u0627\u0646\u062A\u0638\u0627\u0631: \u0645\u0634\u062E\u0635\u0627\u062A \u067E\u0632\u0634\u06A9\u0627\u0646\u060C \u0647\u0645\u0627\u06CC\u0634/\u06A9\u0646\u06AF\u0631\u0647\u060C \u062A\u0627\u0631\u06CC\u062E \u067E\u0631\u0632\u0646\u062A\u060C \u062A\u0648\u0636\u06CC\u062D\u0627\u062A\u060C \u0634\u0645\u0627\u0631\u0647 \u062A\u0644\u0641\u0646",
        choose: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0641\u0627\u06CC\u0644",
        file: "\u0641\u0627\u06CC\u0644",
        sheet: "\u0628\u0631\u06AF\u0647",
        preview: "\u067E\u06CC\u0634\u200C\u0646\u0645\u0627\u06CC\u0634",
        commit: "\u062A\u0623\u06CC\u06CC\u062F \u0648 \u062B\u0628\u062A \u0627\u0646\u062A\u062E\u0627\u0628\u200C\u0634\u062F\u0647\u200C\u0647\u0627",
        committing: "\u062F\u0631 \u062D\u0627\u0644 \u062B\u0628\u062A\u2026",
        previewing: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0631\u0631\u0633\u06CC\u2026",
        again: "\u0641\u0627\u06CC\u0644 \u062F\u06CC\u06AF\u0631",
        summary: "\u062E\u0644\u0627\u0635\u0647",
        created: "\u0645\u062E\u0627\u0637\u0628 \u062C\u062F\u06CC\u062F",
        matched: "\u0645\u062E\u0627\u0637\u0628 \u0645\u0648\u062C\u0648\u062F",
        skipped: "\u062A\u06A9\u0631\u0627\u0631\u06CC (\u0646\u0627\u062F\u06CC\u062F\u0647)",
        invalid: "\u0646\u0627\u0645\u0639\u062A\u0628\u0631",
        newSources: "\u0647\u0645\u0627\u06CC\u0634\u200C\u0647\u0627\u06CC \u062A\u0627\u0632\u0647 \u06A9\u0647 \u0633\u0627\u062E\u062A\u0647 \u0645\u06CC\u200C\u0634\u0648\u0646\u062F",
        newInteractionType: "\u0646\u0648\u0639 \u062A\u0639\u0627\u0645\u0644 \u062A\u0627\u0632\u0647 \u06A9\u0647 \u0633\u0627\u062E\u062A\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F",
        rowsTitle: "\u0633\u0637\u0631\u0647\u0627",
        row: "\u0633\u0637\u0631",
        outcome: "\u0646\u062A\u06CC\u062C\u0647",
        detail: "\u062A\u0648\u0636\u06CC\u062D",
        warnings: "\u0647\u0634\u062F\u0627\u0631",
        // The operator's own column headings, so the preview can be read against
        // the spreadsheet instead of trusted.
        cols: {
            name: "\u0645\u0634\u062E\u0635\u0627\u062A \u067E\u0632\u0634\u06A9\u0627\u0646",
            congress: "\u0647\u0645\u0627\u06CC\u0634/\u06A9\u0646\u06AF\u0631\u0647",
            date: "\u062A\u0627\u0631\u06CC\u062E \u067E\u0631\u0632\u0646\u062A",
            description: "\u062A\u0648\u0636\u06CC\u062D\u0627\u062A",
            phone: "\u0634\u0645\u0627\u0631\u0647 \u062A\u0644\u0641\u0646"
        },
        readAs: "\u062E\u0648\u0627\u0646\u062F\u0647 \u0634\u062F",
        notRead: "\u062E\u0648\u0627\u0646\u062F\u0647 \u0646\u0634\u062F",
        selectAll: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0647\u0645\u0647",
        selectRow: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0633\u0637\u0631",
        selectedOf: "{n} \u0627\u0632 {total} \u0633\u0637\u0631 \u0627\u0646\u062A\u062E\u0627\u0628 \u0634\u062F\u0647",
        nothingSelected: "\u0647\u06CC\u0686 \u0633\u0637\u0631\u06CC \u0627\u0646\u062A\u062E\u0627\u0628 \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
        notSelectable: "\u0642\u0627\u0628\u0644 \u0648\u0631\u0648\u062F \u0646\u06CC\u0633\u062A",
        selectionNote: "\u0646\u062A\u06CC\u062C\u0647\u0654 \u0647\u0631 \u0633\u0637\u0631 \u0628\u0631\u0627\u06CC \u06A9\u0644 \u0641\u0627\u06CC\u0644 \u0645\u062D\u0627\u0633\u0628\u0647 \u0634\u062F\u0647 \u0627\u0633\u062A\u061B \u0628\u0627 \u062A\u063A\u06CC\u06CC\u0631 \u0627\u0646\u062A\u062E\u0627\u0628\u060C \u0647\u0646\u06AF\u0627\u0645 \u062B\u0628\u062A \u062F\u0648\u0628\u0627\u0631\u0647 \u0645\u062D\u0627\u0633\u0628\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.",
        genders: {
            MALE: "\u0622\u0642\u0627",
            FEMALE: "\u062E\u0627\u0646\u0645"
        },
        outcomes: {
            CREATED: "\u0645\u062E\u0627\u0637\u0628 \u062C\u062F\u06CC\u062F",
            MATCHED: "\u0628\u0647 \u0645\u062E\u0627\u0637\u0628 \u0645\u0648\u062C\u0648\u062F \u0627\u0641\u0632\u0648\u062F\u0647 \u0634\u062F",
            SKIPPED: "\u062A\u06A9\u0631\u0627\u0631\u06CC \u2014 \u0646\u0627\u062F\u06CC\u062F\u0647 \u06AF\u0631\u0641\u062A\u0647 \u0634\u062F",
            INVALID: "\u0646\u0627\u0645\u0639\u062A\u0628\u0631"
        },
        done: "\u062B\u0628\u062A \u0627\u0646\u062C\u0627\u0645 \u0634\u062F",
        previewOnly: "\u0627\u06CC\u0646 \u0641\u0642\u0637 \u067E\u06CC\u0634\u200C\u0646\u0645\u0627\u06CC\u0634 \u0627\u0633\u062A \u2014 \u0647\u0646\u0648\u0632 \u0686\u06CC\u0632\u06CC \u0630\u062E\u06CC\u0631\u0647 \u0646\u0634\u062F\u0647.",
        unmatchable: "\u0628\u062F\u0648\u0646 \u0634\u0645\u0627\u0631\u0647 \u2014 \u062F\u0631 \u0648\u0631\u0648\u062F \u0645\u062C\u062F\u062F \u062A\u06A9\u0631\u0627\u0631 \u0645\u06CC\u200C\u0634\u0648\u062F",
        onlyAdmin: "\u0641\u0642\u0637 \u0645\u062F\u06CC\u0631 \u0645\u06CC\u200C\u062A\u0648\u0627\u0646\u062F \u0627\u0632 \u0641\u0627\u06CC\u0644 \u0648\u0631\u0648\u062F \u0627\u0646\u062C\u0627\u0645 \u062F\u0647\u062F.",
        empty: "\u0633\u0637\u0631\u06CC \u0628\u0631\u0627\u06CC \u0646\u0645\u0627\u06CC\u0634 \u0646\u06CC\u0633\u062A."
    },
    settings: {
        title: "\u062A\u0646\u0638\u06CC\u0645\u0627\u062A",
        subtitle: "\u067E\u06CC\u06A9\u0631\u0628\u0646\u062F\u06CC \u0633\u0627\u0645\u0627\u0646\u0647 \u2014 \u062A\u0646\u0647\u0627 \u0628\u0631\u0627\u06CC \u0645\u062F\u06CC\u0631\u0627\u0646",
        sections: {
            lookups: "\u0641\u0647\u0631\u0633\u062A\u200C\u0647\u0627\u06CC \u067E\u0627\u06CC\u0647",
            specialties: "\u062A\u062E\u0635\u0635\u200C\u0647\u0627",
            tags: "\u0628\u0631\u0686\u0633\u0628\u200C\u0647\u0627",
            customFields: "\u0641\u06CC\u0644\u062F\u0647\u0627\u06CC \u0633\u0641\u0627\u0631\u0634\u06CC",
            templates: "\u0642\u0627\u0644\u0628\u200C\u0647\u0627\u06CC \u067E\u06CC\u0627\u0645",
            activityTypes: "\u0627\u0646\u0648\u0627\u0639 \u0641\u0639\u0627\u0644\u06CC\u062A",
            issueTypes: "\u0627\u0646\u0648\u0627\u0639 \u0645\u0633\u0626\u0644\u0647",
            users: "\u06A9\u0627\u0631\u0628\u0631\u0627\u0646",
            import: "\u0648\u0631\u0648\u062F \u0627\u0632 \u0627\u06A9\u0633\u0644"
        },
        common: {
            code: "\u06A9\u062F",
            labelFa: "\u0628\u0631\u0686\u0633\u0628 \u0641\u0627\u0631\u0633\u06CC",
            labelEn: "\u0628\u0631\u0686\u0633\u0628 \u0627\u0646\u06AF\u0644\u06CC\u0633\u06CC",
            sortOrder: "\u062A\u0631\u062A\u06CC\u0628",
            status: "\u0648\u0636\u0639\u06CC\u062A",
            actions: "\u0639\u0645\u0644\u06CC\u0627\u062A",
            moveUp: "\u0627\u0646\u062A\u0642\u0627\u0644 \u0628\u0647 \u0628\u0627\u0644\u0627",
            moveDown: "\u0627\u0646\u062A\u0642\u0627\u0644 \u0628\u0647 \u067E\u0627\u06CC\u06CC\u0646",
            codeImmutable: "\u06A9\u062F \u067E\u0633 \u0627\u0632 \u0627\u06CC\u062C\u0627\u062F \u0642\u0627\u0628\u0644 \u062A\u063A\u06CC\u06CC\u0631 \u0646\u06CC\u0633\u062A.",
            systemLocked: "\u0631\u062F\u06CC\u0641 \u0633\u06CC\u0633\u062A\u0645\u06CC: \u062A\u0646\u0647\u0627 \u0628\u0631\u0686\u0633\u0628\u200C\u0647\u0627 \u0642\u0627\u0628\u0644 \u0648\u06CC\u0631\u0627\u06CC\u0634\u200C\u0627\u0646\u062F.",
            noDelete: "\u062D\u0630\u0641 \u0648\u062C\u0648\u062F \u0646\u062F\u0627\u0631\u062F\u061B \u0686\u0648\u0646 \u0633\u0648\u0627\u0628\u0642 \u062A\u0627\u0631\u06CC\u062E\u06CC \u0628\u0647 \u0627\u06CC\u0646 \u0645\u0642\u0627\u062F\u06CC\u0631 \u0627\u0631\u062C\u0627\u0639 \u0645\u06CC\u200C\u062F\u0647\u0646\u062F\u060C \u062A\u0646\u0647\u0627 \u063A\u06CC\u0631\u0641\u0639\u0627\u0644\u200C\u0633\u0627\u0632\u06CC \u0645\u0645\u06A9\u0646 \u0627\u0633\u062A.",
            confirmDeactivate: (name)=>`\xab${name}\xbb \u{63A}\u{6CC}\u{631}\u{641}\u{639}\u{627}\u{644} \u{634}\u{648}\u{62F}\u{61F} \u{627}\u{632} \u{641}\u{647}\u{631}\u{633}\u{62A}\u{200C}\u{647}\u{627}\u{6CC} \u{627}\u{646}\u{62A}\u{62E}\u{627}\u{628} \u{62D}\u{630}\u{641} \u{645}\u{6CC}\u{200C}\u{634}\u{648}\u{62F} \u{627}\u{645}\u{627} \u{631}\u{648}\u{6CC} \u{633}\u{648}\u{627}\u{628}\u{642} \u{642}\u{628}\u{644}\u{6CC} \u{628}\u{627}\u{642}\u{6CC} \u{645}\u{6CC}\u{200C}\u{645}\u{627}\u{646}\u{62F}.`,
            confirmActivate: (name)=>`\xab${name}\xbb \u{62F}\u{648}\u{628}\u{627}\u{631}\u{647} \u{641}\u{639}\u{627}\u{644} \u{634}\u{648}\u{62F}\u{61F}`,
            showInactive: "\u0646\u0645\u0627\u06CC\u0634 \u063A\u06CC\u0631\u0641\u0639\u0627\u0644\u200C\u0647\u0627",
            newItem: "\u0645\u0648\u0631\u062F \u062C\u062F\u06CC\u062F"
        },
        lookups: {
            kindLabel: "\u0646\u0648\u0639 \u0641\u0647\u0631\u0633\u062A",
            kinds: {
                FIELD_OF_WORK: "\u062D\u0648\u0632\u0647 \u0641\u0639\u0627\u0644\u06CC\u062A",
                SPECIALTY: "\u062A\u062E\u0635\u0635",
                COMMUNICATION_CHANNEL: "\u06A9\u0627\u0646\u0627\u0644 \u0627\u0631\u062A\u0628\u0627\u0637\u06CC",
                PRODUCT: "\u0645\u062D\u0635\u0648\u0644",
                INTERACTION_TYPE: "\u0646\u0648\u0639 \u062A\u0639\u0627\u0645\u0644",
                TEMPLATE_CATEGORY: "\u062F\u0633\u062A\u0647\u200C\u0628\u0646\u062F\u06CC \u0642\u0627\u0644\u0628 \u067E\u06CC\u0627\u0645",
                ACQUISITION_SOURCE: "\u0646\u062D\u0648\u0647 \u0622\u0634\u0646\u0627\u06CC\u06CC",
                LIFECYCLE_STAGE: "\u0648\u0636\u0639\u06CC\u062A \u0686\u0631\u062E\u0647 \u0639\u0645\u0631 \u0645\u0634\u062A\u0631\u06CC",
                SALES_STAGE: "\u0645\u0631\u062D\u0644\u0647 \u0641\u0631\u0648\u0634",
                CUSTOMER_HEALTH: "\u0648\u0636\u0639\u06CC\u062A \u0645\u0634\u062A\u0631\u06CC",
                ENGAGEMENT_STATUS: "\u0648\u0636\u0639\u06CC\u062A \u0647\u0645\u06A9\u0627\u0631\u06CC",
                CITY: "\u0634\u0647\u0631",
                FACILITY_TYPE: "\u0646\u0648\u0639 \u0645\u062E\u0627\u0637\u0628"
            },
            createTitle: "\u0627\u0641\u0632\u0648\u062F\u0646 \u0645\u0648\u0631\u062F \u062A\u0627\u0632\u0647",
            codeHint: "\u062D\u0631\u0648\u0641 \u0628\u0632\u0631\u06AF \u0627\u0646\u06AF\u0644\u06CC\u0633\u06CC\u060C \u0627\u0639\u062F\u0627\u062F \u0648 \u0632\u06CC\u0631\u062E\u0637 \u2014 \u0645\u062B\u0644\u0627\u064B NEW_PRODUCT",
            requiresDetail: "\u0646\u06CC\u0627\u0632\u0645\u0646\u062F \u0646\u0627\u0645 \u0645\u0631\u06A9\u0632",
            requiresDetailHint: "\u0628\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u0627\u06CC\u0646 \u06AF\u0632\u06CC\u0646\u0647\u060C \u062B\u0628\u062A \u0646\u0627\u0645 \u0645\u0631\u06A9\u0632 \u0628\u0631\u0627\u06CC \u0645\u062E\u0627\u0637\u0628 \u0627\u0644\u0632\u0627\u0645\u06CC \u0645\u06CC\u200C\u0634\u0648\u062F. \u0628\u0631\u0627\u06CC \xab\u0646\u0648\u0639 \u0645\u062E\u0627\u0637\u0628\xbb \u06A9\u0627\u0631\u0628\u0631\u062F \u062F\u0627\u0631\u062F."
        },
        activityTypes: {
            hint: "\u0627\u0646\u0648\u0627\u0639\u06CC \u06A9\u0647 \u062F\u0631 \u062A\u0642\u0648\u06CC\u0645 \u0648 \u0647\u0646\u06AF\u0627\u0645 \u062B\u0628\u062A \u0641\u0639\u0627\u0644\u06CC\u062A \u0627\u0646\u062A\u062E\u0627\u0628 \u0645\u06CC\u200C\u0634\u0648\u0646\u062F.",
            createTitle: "\u0646\u0648\u0639 \u0641\u0639\u0627\u0644\u06CC\u062A \u062A\u0627\u0632\u0647",
            empty: "\u0647\u06CC\u0686 \u0646\u0648\u0639 \u0641\u0639\u0627\u0644\u06CC\u062A\u06CC \u062A\u0639\u0631\u06CC\u0641 \u0646\u0634\u062F\u0647 \u0627\u0633\u062A\u061B \u062A\u0627 \u0632\u0645\u0627\u0646\u06CC \u06A9\u0647 \u06CC\u06A9\u06CC \u0627\u0636\u0627\u0641\u0647 \u0646\u0634\u0648\u062F\u060C \u062B\u0628\u062A \u0641\u0639\u0627\u0644\u06CC\u062A \u062F\u0631 \u062A\u0642\u0648\u06CC\u0645 \u0645\u0645\u06A9\u0646 \u0646\u06CC\u0633\u062A."
        },
        issueTypes: {
            hint: "\u062F\u0633\u062A\u0647\u200C\u0628\u0646\u062F\u06CC \u0645\u0633\u0627\u0626\u0644 \u0648 \u0634\u06A9\u0627\u06CC\u062A\u200C\u0647\u0627\u06CC\u06CC \u06A9\u0647 \u0627\u0632 \u0645\u0634\u062A\u0631\u06CC\u0627\u0646 \u062B\u0628\u062A \u0645\u06CC\u200C\u0634\u0648\u062F.",
            createTitle: "\u0646\u0648\u0639 \u0645\u0633\u0626\u0644\u0647 \u062A\u0627\u0632\u0647",
            empty: "\u0647\u06CC\u0686 \u0646\u0648\u0639 \u0645\u0633\u0626\u0644\u0647\u200C\u0627\u06CC \u062A\u0639\u0631\u06CC\u0641 \u0646\u0634\u062F\u0647 \u0627\u0633\u062A\u061B \u062A\u0627 \u0632\u0645\u0627\u0646\u06CC \u06A9\u0647 \u06CC\u06A9\u06CC \u0627\u0636\u0627\u0641\u0647 \u0646\u0634\u0648\u062F\u060C \u062B\u0628\u062A \u0645\u0633\u0626\u0644\u0647 \u0645\u0645\u06A9\u0646 \u0646\u06CC\u0633\u062A."
        },
        specialties: {
            title: "\u062F\u0631\u062E\u062A \u062A\u062E\u0635\u0635\u200C\u0647\u0627",
            addChild: "\u0627\u0641\u0632\u0648\u062F\u0646 \u0632\u06CC\u0631\u0634\u0627\u062E\u0647",
            moveTo: "\u0627\u0646\u062A\u0642\u0627\u0644 \u0628\u0647",
            makeRoot: "\u0627\u0646\u062A\u0642\u0627\u0644 \u0628\u0647 \u0631\u06CC\u0634\u0647",
            hasActiveChildren: "\u0627\u0628\u062A\u062F\u0627 \u0632\u06CC\u0631\u0634\u0627\u062E\u0647\u200C\u0647\u0627\u06CC \u0641\u0639\u0627\u0644 \u0631\u0627 \u063A\u06CC\u0631\u0641\u0639\u0627\u0644 \u06A9\u0646\u06CC\u062F.",
            cycleRejected: "\u0627\u06CC\u0646 \u062C\u0627\u0628\u0647\u200C\u062C\u0627\u06CC\u06CC \u062D\u0644\u0642\u0647 \u0627\u06CC\u062C\u0627\u062F \u0645\u06CC\u200C\u06A9\u0646\u062F \u0648 \u0645\u062C\u0627\u0632 \u0646\u06CC\u0633\u062A.",
            rootLevel: "\u0633\u0637\u062D \u0631\u06CC\u0634\u0647"
        },
        tags: {
            name: "\u0646\u0627\u0645 \u0628\u0631\u0686\u0633\u0628",
            color: "\u0631\u0646\u06AF",
            preview: "\u067E\u06CC\u0634\u200C\u0646\u0645\u0627\u06CC\u0634",
            createTitle: "\u0628\u0631\u0686\u0633\u0628 \u062A\u0627\u0632\u0647",
            isAssessment: "\u0627\u0631\u0632\u06CC\u0627\u0628\u06CC",
            isAssessmentHint: "\u0628\u0631\u0686\u0633\u0628\u200C\u0647\u0627\u06CC \u0627\u0631\u0632\u06CC\u0627\u0628\u06CC \u0645\u06CC\u0632\u0627\u0646 \u0639\u0644\u0627\u0642\u0647 \u0645\u062E\u0627\u0637\u0628 \u0631\u0627 \u0646\u0634\u0627\u0646 \u0645\u06CC\u200C\u062F\u0647\u0646\u062F (\u0645\u0627\u0646\u0646\u062F \xab\u0645\u0634\u062A\u0627\u0642\xbb \u06CC\u0627 \xab\u0628\u06CC\u200C\u0639\u0644\u0627\u0642\u0647\xbb) \u0648 \u062F\u0631 \u0641\u0647\u0631\u0633\u062A \u0645\u062E\u0627\u0637\u0628\u06CC\u0646 \u0633\u062A\u0648\u0646 \u062C\u062F\u0627\u06AF\u0627\u0646\u0647\u200C\u0627\u06CC \u062F\u0627\u0631\u0646\u062F."
        },
        customFields: {
            name: "\u0634\u0646\u0627\u0633\u0647 \u0641\u0646\u06CC",
            nameHint: "\u062D\u0631\u0648\u0641 \u06A9\u0648\u0686\u06A9 \u0627\u0646\u06AF\u0644\u06CC\u0633\u06CC \u0648 \u0632\u06CC\u0631\u062E\u0637 \u2014 \u0645\u062B\u0644\u0627\u064B congress_source",
            nameImmutable: "\u0634\u0646\u0627\u0633\u0647 \u0641\u0646\u06CC \u0648 \u0646\u0648\u0639 \u0641\u06CC\u0644\u062F \u067E\u0633 \u0627\u0632 \u0627\u06CC\u062C\u0627\u062F \u0642\u0627\u0628\u0644 \u062A\u063A\u06CC\u06CC\u0631 \u0646\u06CC\u0633\u062A\u0646\u062F.",
            label: "\u0628\u0631\u0686\u0633\u0628",
            type: "\u0646\u0648\u0639",
            appliesTo: "\u0642\u0627\u0628\u0644 \u0627\u0633\u062A\u0641\u0627\u062F\u0647 \u0628\u0631\u0627\u06CC",
            options: "\u06AF\u0632\u06CC\u0646\u0647\u200C\u0647\u0627",
            addOption: "\u0627\u0641\u0632\u0648\u062F\u0646 \u06AF\u0632\u06CC\u0646\u0647",
            optionsHint: "\u0628\u0631\u0627\u06CC \u0646\u0648\u0639 \xab\u0627\u0646\u062A\u062E\u0627\u0628\u06CC\xbb \u062D\u062F\u0627\u0642\u0644 \u06CC\u06A9 \u06AF\u0632\u06CC\u0646\u0647 \u0644\u0627\u0632\u0645 \u0627\u0633\u062A.",
            createTitle: "\u0641\u06CC\u0644\u062F \u0633\u0641\u0627\u0631\u0634\u06CC \u062A\u0627\u0632\u0647",
            deactivateHint: "\u063A\u06CC\u0631\u0641\u0639\u0627\u0644\u200C\u0633\u0627\u0632\u06CC \u0641\u06CC\u0644\u062F \u0631\u0627 \u0627\u0632 \u0641\u0631\u0645\u200C\u0647\u0627 \u067E\u0646\u0647\u0627\u0646 \u0645\u06CC\u200C\u06A9\u0646\u062F\u061B \u0645\u0642\u0627\u062F\u06CC\u0631 \u062B\u0628\u062A\u200C\u0634\u062F\u0647 \u062F\u0633\u062A\u200C\u0646\u062E\u0648\u0631\u062F\u0647 \u0645\u06CC\u200C\u0645\u0627\u0646\u0646\u062F.",
            types: {
                TEXT: "\u0645\u062A\u0646",
                NUMBER: "\u0639\u062F\u062F",
                DATE: "\u062A\u0627\u0631\u06CC\u062E",
                BOOLEAN: "\u0628\u0644\u0647/\u062E\u06CC\u0631",
                SELECT: "\u0627\u0646\u062A\u062E\u0627\u0628 \u06CC\u06A9\u06CC",
                MULTISELECT: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0686\u0646\u062F\u062A\u0627\u06CC\u06CC"
            },
            appliesToOptions: {
                PERSON: "\u0627\u0634\u062E\u0627\u0635",
                ORGANIZATION: "\u0633\u0627\u0632\u0645\u0627\u0646\u200C\u0647\u0627",
                BOTH: "\u0647\u0631 \u062F\u0648"
            }
        },
        templates: {
            name: "\u0646\u0627\u0645 \u0642\u0627\u0644\u0628",
            channel: "\u06A9\u0627\u0646\u0627\u0644",
            category: "\u062F\u0633\u062A\u0647\u200C\u0628\u0646\u062F\u06CC",
            body: "\u0645\u062A\u0646 \u067E\u06CC\u0627\u0645",
            preview: "\u067E\u06CC\u0634\u200C\u0646\u0645\u0627\u06CC\u0634",
            createTitle: "\u0642\u0627\u0644\u0628 \u067E\u06CC\u0627\u0645 \u062A\u0627\u0632\u0647",
            allowedPlaceholders: "\u062C\u0627\u06CC\u06AF\u0632\u06CC\u0646\u200C\u0647\u0627\u06CC \u0645\u062C\u0627\u0632",
            placeholderHint: "\u062A\u0646\u0647\u0627 \u0627\u06CC\u0646 \u0633\u0647 \u062C\u0627\u06CC\u06AF\u0632\u06CC\u0646 \u067E\u0630\u06CC\u0631\u0641\u062A\u0647 \u0645\u06CC\u200C\u0634\u0648\u0646\u062F.",
            insertPlaceholder: "\u062F\u0631\u062C",
            sendingElsewhere: "\u0627\u0631\u0633\u0627\u0644 \u067E\u06CC\u0627\u0645 \u062F\u0631 \u0633\u0631\u0648\u06CC\u0633 \u067E\u06CC\u0627\u0645\u200C\u0631\u0633\u0627\u0646\u06CC \u0627\u0646\u062C\u0627\u0645 \u0645\u06CC\u200C\u0634\u0648\u062F\u061B \u0627\u06CC\u0646\u062C\u0627 \u0641\u0642\u0637 \u0645\u062A\u0646 \u0642\u0627\u0644\u0628 \u062A\u0639\u0631\u06CC\u0641 \u0645\u06CC\u200C\u0634\u0648\u062F.",
            valid: "\u0645\u062A\u0646 \u0645\u0639\u062A\u0628\u0631 \u0627\u0633\u062A."
        },
        users: {
            displayName: "\u0646\u0627\u0645",
            role: "\u0646\u0642\u0634",
            lastSeen: "\u0622\u062E\u0631\u06CC\u0646 \u0628\u0627\u0632\u062F\u06CC\u062F",
            firstSeen: "\u0627\u0648\u0644\u06CC\u0646 \u0648\u0631\u0648\u062F",
            readOnlyNotice: "\u06A9\u0627\u0631\u0628\u0631\u0627\u0646 \u0648 \u0646\u0642\u0634\u200C\u0647\u0627 \u062F\u0631 Keycloak \u0645\u062F\u06CC\u0631\u06CC\u062A \u0645\u06CC\u200C\u0634\u0648\u0646\u062F. \u0627\u06CC\u0646 \u0641\u0647\u0631\u0633\u062A \u0641\u0642\u0637 \u062E\u0648\u0627\u0646\u062F\u0646\u06CC \u0627\u0633\u062A \u0648 \u067E\u0633 \u0627\u0632 \u0627\u0648\u0644\u06CC\u0646 \u0648\u0631\u0648\u062F \u0647\u0631 \u06A9\u0627\u0631\u0628\u0631 \u0633\u0627\u062E\u062A\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.",
            openKeycloak: "\u0645\u062F\u06CC\u0631\u06CC\u062A \u062F\u0631 Keycloak"
        }
    },
    shortcuts: {
        title: "\u0645\u06CC\u0627\u0646\u200C\u0628\u0631\u0647\u0627\u06CC \u0635\u0641\u062D\u0647\u200C\u06A9\u0644\u06CC\u062F",
        closeHint: "\u0628\u0631\u0627\u06CC \u0628\u0633\u062A\u0646\u060C \u06A9\u0644\u06CC\u062F Esc \u06CC\u0627 \u062F\u0648\u0628\u0627\u0631\u0647 \u061F \u0631\u0627 \u0628\u0632\u0646\u06CC\u062F.",
        alwaysAvailable: "\u0647\u0645\u06CC\u0634\u0647 \u062F\u0631 \u062F\u0633\u062A\u0631\u0633",
        showHelp: "\u0646\u0645\u0627\u06CC\u0634 \u0647\u0645\u06CC\u0646 \u0631\u0627\u0647\u0646\u0645\u0627",
        groups: {
            general: "\u0639\u0645\u0648\u0645\u06CC",
            contacts: "\u0645\u062E\u0627\u0637\u0628\u06CC\u0646",
            settings: "\u062A\u0646\u0638\u06CC\u0645\u0627\u062A",
            session: "\u0646\u0634\u0633\u062A",
            calendar: "\u062A\u0642\u0648\u06CC\u0645"
        },
        actions: {
            searchContacts: "\u062C\u0633\u062A\u200C\u0648\u062C\u0648 \u062F\u0631 \u0645\u062E\u0627\u0637\u0628\u06CC\u0646",
            backToList: "\u0628\u0627\u0632\u06AF\u0634\u062A \u0628\u0647 \u0641\u0647\u0631\u0633\u062A \u0645\u062E\u0627\u0637\u0628\u06CC\u0646",
            signOut: "\u062E\u0631\u0648\u062C \u0627\u0632 \u062D\u0633\u0627\u0628 \u06A9\u0627\u0631\u0628\u0631\u06CC",
            quickAdd: "\u062B\u0628\u062A \u0633\u0631\u06CC\u0639 \u0645\u062E\u0627\u0637\u0628",
            recordInteraction: "\u062B\u0628\u062A \u062A\u0639\u0627\u0645\u0644 \u0628\u0631\u0627\u06CC \u0627\u06CC\u0646 \u0645\u062E\u0627\u0637\u0628",
            today: "\u0631\u0641\u062A\u0646 \u0628\u0647 \u0627\u0645\u0631\u0648\u0632",
            prevWeek: "\u0647\u0641\u062A\u0647\u0654 \u0642\u0628\u0644",
            nextWeek: "\u0647\u0641\u062A\u0647\u0654 \u0628\u0639\u062F",
            newActivity: "\u0641\u0639\u0627\u0644\u06CC\u062A \u062C\u062F\u06CC\u062F",
            followUps: "\u0635\u0646\u062F\u0648\u0642 \u067E\u06CC\u06AF\u06CC\u0631\u06CC\u200C\u0647\u0627"
        }
    },
    /* ---------- scheduling (Step 4) ---------- */ calendar: {
        title: "\u062A\u0642\u0648\u06CC\u0645",
        today: "\u0627\u0645\u0631\u0648\u0632",
        jumpToDate: "\u0631\u0641\u062A\u0646 \u0628\u0647 \u062A\u0627\u0631\u06CC\u062E \u062F\u0644\u062E\u0648\u0627\u0647",
        week: "\u0647\u0641\u062A\u0647",
        day: "\u0631\u0648\u0632",
        agenda: "\u0641\u0647\u0631\u0633\u062A",
        allDay: "\u062A\u0645\u0627\u0645\u200C\u0631\u0648\u0632",
        noActivities: "\u062F\u0631 \u0627\u06CC\u0646 \u0628\u0627\u0632\u0647 \u0641\u0639\u0627\u0644\u06CC\u062A\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A",
        newActivity: "\u0641\u0639\u0627\u0644\u06CC\u062A \u062C\u062F\u06CC\u062F",
        dragHint: "\u0628\u0631\u0627\u06CC \u0633\u0627\u062E\u062A\u0646 \u0641\u0639\u0627\u0644\u06CC\u062A \u0631\u0648\u06CC \u062A\u0642\u0648\u06CC\u0645 \u0628\u06A9\u0634\u06CC\u062F\u061B \u0628\u0631\u0627\u06CC \u062C\u0627\u0628\u0647\u200C\u062C\u0627\u06CC\u06CC\u060C \u0641\u0639\u0627\u0644\u06CC\u062A \u0631\u0627 \u0628\u06A9\u0634\u06CC\u062F.",
        whose: "\u062A\u0642\u0648\u06CC\u0645",
        mine: "\u062A\u0642\u0648\u06CC\u0645 \u0645\u0646",
        everyone: "\u0647\u0645\u0647\u0654 \u06A9\u0627\u0631\u0628\u0631\u0627\u0646",
        syncedWithGoogle: "\u0647\u0645\u06AF\u0627\u0645 \u0628\u0627 \u06AF\u0648\u06AF\u0644",
        conflict: "\u062A\u0639\u0627\u0631\u0636 \u0647\u0645\u06AF\u0627\u0645\u200C\u0633\u0627\u0632\u06CC",
        conflictHint: "\u0627\u06CC\u0646 \u0641\u0639\u0627\u0644\u06CC\u062A \u0647\u0645 \u0627\u06CC\u0646\u062C\u0627 \u0648 \u0647\u0645 \u062F\u0631 \u06AF\u0648\u06AF\u0644 \u062A\u063A\u06CC\u06CC\u0631 \u06A9\u0631\u062F\u0647 \u0628\u0648\u062F\u061B \u0646\u0633\u062E\u0647\u0654 \u062C\u062F\u06CC\u062F\u062A\u0631 \u0627\u0639\u0645\u0627\u0644 \u0634\u062F.",
        orphaned: "\u0645\u062E\u0627\u0637\u0628 \u062D\u0630\u0641 \u0634\u062F\u0647",
        orphanedHint: "\u0645\u062E\u0627\u0637\u0628 \u0627\u06CC\u0646 \u0641\u0639\u0627\u0644\u06CC\u062A \u062F\u0631 \u0628\u062E\u0634 \u0645\u062E\u0627\u0637\u0628\u06CC\u0646 \u062D\u0630\u0641 \u0634\u062F\u0647 \u0627\u0633\u062A.",
        imported: "\u0648\u0627\u0631\u062F\u0634\u062F\u0647 \u0627\u0632 \u06AF\u0648\u06AF\u0644"
    },
    activity: {
        title: "\u0641\u0639\u0627\u0644\u06CC\u062A",
        create: "\u062B\u0628\u062A \u0641\u0639\u0627\u0644\u06CC\u062A",
        edit: "\u0648\u06CC\u0631\u0627\u06CC\u0634 \u0641\u0639\u0627\u0644\u06CC\u062A",
        type: "\u0646\u0648\u0639 \u0641\u0639\u0627\u0644\u06CC\u062A",
        subject: "\u0639\u0646\u0648\u0627\u0646",
        contact: "\u0645\u062E\u0627\u0637\u0628",
        contactHint: "\u0628\u0631\u0627\u06CC \u06CC\u0627\u062F\u0622\u0648\u0631 \u0634\u062E\u0635\u06CC \u062E\u0627\u0644\u06CC \u0628\u06AF\u0630\u0627\u0631\u06CC\u062F",
        noContact: "\u0628\u062F\u0648\u0646 \u0645\u062E\u0627\u0637\u0628 (\u06CC\u0627\u062F\u0622\u0648\u0631 \u0634\u062E\u0635\u06CC)",
        searchContact: "\u062C\u0633\u062A\u200C\u0648\u062C\u0648\u06CC \u0645\u062E\u0627\u0637\u0628\u2026",
        moreContacts: (n)=>`${n} \u{645}\u{62E}\u{627}\u{637}\u{628} \u{62F}\u{6CC}\u{6AF}\u{631} \u{647}\u{645} \u{647}\u{633}\u{62A}\u{61B} \u{628}\u{631}\u{627}\u{6CC} \u{6CC}\u{627}\u{641}\u{62A}\u{646} \u{622}\u{646}\u{200C}\u{647}\u{627} \u{62C}\u{633}\u{62A}\u{200C}\u{648}\u{62C}\u{648} \u{6A9}\u{646}\u{6CC}\u{62F}.`,
        // «تاریخ» alone sat beside «مخاطب» and «نوع» and could have meant any of
        // them; every field on this form now says which activity it belongs to.
        date: "\u062A\u0627\u0631\u06CC\u062E \u0641\u0639\u0627\u0644\u06CC\u062A",
        time: "\u0633\u0627\u0639\u062A \u0641\u0639\u0627\u0644\u06CC\u062A",
        startTime: "\u0634\u0631\u0648\u0639",
        endTime: "\u067E\u0627\u06CC\u0627\u0646",
        allDay: "\u062A\u0645\u0627\u0645\u200C\u0631\u0648\u0632",
        // «مسئول» was the ambiguity this form was reported for: beside «مخاطب» it
        // read as another word for the same person.
        assignee: "\u0645\u0633\u0626\u0648\u0644 \u0641\u0639\u0627\u0644\u06CC\u062A",
        assigneeHint: "\u06A9\u0627\u0631\u0628\u0631\u06CC \u06A9\u0647 \u0627\u0646\u062C\u0627\u0645 \u0627\u06CC\u0646 \u0641\u0639\u0627\u0644\u06CC\u062A \u0628\u0631 \u0639\u0647\u062F\u0647 \u0627\u0648\u0633\u062A.",
        assigneeSelf: "\u062E\u0648\u062F\u0645",
        searchUser: "\u062C\u0633\u062A\u200C\u0648\u062C\u0648\u06CC \u06A9\u0627\u0631\u0628\u0631\u2026",
        description: "\u062A\u0648\u0636\u06CC\u062D\u0627\u062A",
        reminders: "\u06CC\u0627\u062F\u0622\u0648\u0631\u0647\u0627",
        addReminder: "\u0627\u0641\u0632\u0648\u062F\u0646 \u06CC\u0627\u062F\u0622\u0648\u0631",
        reminderOffset: "\u0632\u0645\u0627\u0646 \u06CC\u0627\u062F\u0622\u0648\u0631\u06CC",
        reminderChannel: "\u06A9\u0627\u0646\u0627\u0644",
        noReminders: "\u06CC\u0627\u062F\u0622\u0648\u0631\u06CC \u062A\u0646\u0638\u06CC\u0645 \u0646\u0634\u062F\u0647 \u0627\u0633\u062A",
        checklists: "\u0686\u06A9\u200C\u0644\u06CC\u0633\u062A\u200C\u0647\u0627",
        addChecklist: "\u0627\u0641\u0632\u0648\u062F\u0646 \u0686\u06A9\u200C\u0644\u06CC\u0633\u062A",
        fromTemplate: "\u0627\u0632 \u0631\u0648\u06CC \u0627\u0644\u06AF\u0648",
        blankChecklist: "\u0686\u06A9\u200C\u0644\u06CC\u0633\u062A \u062E\u0627\u0644\u06CC",
        result: "\u0646\u062A\u06CC\u062C\u0647",
        resultRequired: "\u0628\u0631\u0627\u06CC \u062B\u0628\u062A \u0628\u0647\u200C\u0639\u0646\u0648\u0627\u0646 \u0627\u0646\u062C\u0627\u0645\u200C\u0634\u062F\u0647\u060C \u0646\u0648\u0634\u062A\u0646 \u0646\u062A\u06CC\u062C\u0647 \u0627\u0644\u0632\u0627\u0645\u06CC \u0627\u0633\u062A.",
        markDone: "\u062B\u0628\u062A \u0628\u0647\u200C\u0639\u0646\u0648\u0627\u0646 \u0627\u0646\u062C\u0627\u0645\u200C\u0634\u062F\u0647",
        markCancelled: "\u0644\u063A\u0648 \u0641\u0639\u0627\u0644\u06CC\u062A",
        markMissed: "\u062B\u0628\u062A \u0628\u0647\u200C\u0639\u0646\u0648\u0627\u0646 \u0627\u0646\u062C\u0627\u0645\u200C\u0646\u0634\u062F\u0647",
        reopen: "\u0628\u0627\u0632\u06AF\u0634\u0627\u06CC\u06CC",
        reopenReason: "\u062F\u0644\u06CC\u0644 \u0628\u0627\u0632\u06AF\u0634\u0627\u06CC\u06CC",
        reopenReasonHint: "\u0628\u0627\u0632\u06AF\u0634\u0627\u06CC\u06CC \u06CC\u06A9 \u0641\u0639\u0627\u0644\u06CC\u062A \u0628\u0633\u062A\u0647\u200C\u0634\u062F\u0647 \u0646\u06CC\u0627\u0632 \u0628\u0647 \u062A\u0648\u0636\u06CC\u062D \u062F\u0627\u0631\u062F.",
        delete: "\u062D\u0630\u0641 \u0641\u0639\u0627\u0644\u06CC\u062A",
        deleteConfirm: "\u0627\u06CC\u0646 \u0641\u0639\u0627\u0644\u06CC\u062A \u0627\u0632 \u062A\u0642\u0648\u06CC\u0645 \u062D\u0630\u0641 \u0645\u06CC\u200C\u0634\u0648\u062F.",
        // --- attachments on an activity ---
        attachments: "\u0641\u0627\u06CC\u0644\u200C\u0647\u0627\u06CC \u067E\u06CC\u0648\u0633\u062A",
        addFile: "\u0627\u0641\u0632\u0648\u062F\u0646 \u0641\u0627\u06CC\u0644",
        noFiles: "\u0641\u0627\u06CC\u0644\u06CC \u067E\u06CC\u0648\u0633\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
        filesAfterSave: "\u0641\u0627\u06CC\u0644\u200C\u0647\u0627 \u067E\u0633 \u0627\u0632 \u062B\u0628\u062A \u0641\u0639\u0627\u0644\u06CC\u062A \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0645\u06CC\u200C\u0634\u0648\u0646\u062F.",
        uploadFailed: "\u0641\u0639\u0627\u0644\u06CC\u062A \u062B\u0628\u062A \u0634\u062F\u060C \u0627\u0645\u0627 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0628\u0631\u062E\u06CC \u0641\u0627\u06CC\u0644\u200C\u0647\u0627 \u0646\u0627\u0645\u0648\u0641\u0642 \u0628\u0648\u062F.",
        createdFromInteraction: "\u067E\u06CC\u06AF\u06CC\u0631\u06CC \u0627\u06CC\u0646 \u062A\u0639\u0627\u0645\u0644",
        linkedActivity: "\u067E\u06CC\u06AF\u06CC\u0631\u06CC \u062B\u0628\u062A\u200C\u0634\u062F\u0647",
        viewActivity: "\u0645\u0634\u0627\u0647\u062F\u0647\u0654 \u0641\u0639\u0627\u0644\u06CC\u062A",
        activitiesTab: "\u0641\u0639\u0627\u0644\u06CC\u062A\u200C\u0647\u0627",
        noActivities: "\u0628\u0631\u0627\u06CC \u0627\u06CC\u0646 \u0645\u062E\u0627\u0637\u0628 \u0641\u0639\u0627\u0644\u06CC\u062A\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647 \u0627\u0633\u062A",
        reminderOffsets: {
            '10': "\u06F1\u06F0 \u062F\u0642\u06CC\u0642\u0647 \u0642\u0628\u0644",
            '30': "\u06F3\u06F0 \u062F\u0642\u06CC\u0642\u0647 \u0642\u0628\u0644",
            '60': "\u06F1 \u0633\u0627\u0639\u062A \u0642\u0628\u0644",
            '1440': "\u06F1 \u0631\u0648\u0632 \u0642\u0628\u0644"
        }
    },
    followUps: {
        title: "\u067E\u06CC\u06AF\u06CC\u0631\u06CC\u200C\u0647\u0627",
        empty: "\u067E\u06CC\u06AF\u06CC\u0631\u06CC \u0628\u0627\u0632\u06CC \u0648\u062C\u0648\u062F \u0646\u062F\u0627\u0631\u062F",
        emptyHint: "\u0648\u0642\u062A\u06CC \u0641\u0639\u0627\u0644\u06CC\u062A\u06CC \u0628\u062F\u0648\u0646 \u0646\u062A\u06CC\u062C\u0647 \u0627\u0632 \u0632\u0645\u0627\u0646\u0634 \u0628\u06AF\u0630\u0631\u062F\u060C \u0627\u06CC\u0646\u062C\u0627 \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.",
        accept: "\u0627\u06CC\u062C\u0627\u062F \u067E\u06CC\u06AF\u06CC\u0631\u06CC",
        dismiss: "\u0631\u062F \u06A9\u0631\u062F\u0646",
        dismissed: "\u0631\u062F\u0634\u062F\u0647",
        accepted: "\u067E\u0630\u06CC\u0631\u0641\u062A\u0647\u200C\u0634\u062F\u0647",
        // The composed sentence, assembled where the contact NAME is available.
        sentence: {
            OVERDUE: (name, date)=>`${name} \u{62F}\u{631} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} ${date} \u{627}\u{646}\u{62C}\u{627}\u{645} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}. \u{622}\u{6CC}\u{627} \u{645}\u{6CC}\u{200C}\u{62E}\u{648}\u{627}\u{647}\u{6CC}\u{62F} \u{6CC}\u{6A9} \u{67E}\u{6CC}\u{6AF}\u{6CC}\u{631}\u{6CC} \u{62C}\u{62F}\u{6CC}\u{62F} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}\u{61F}`,
            MISSED: (name, date)=>`${name} \u{62F}\u{631} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} ${date} \u{627}\u{646}\u{62C}\u{627}\u{645}\u{200C}\u{646}\u{634}\u{62F}\u{647} \u{62B}\u{628}\u{62A} \u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}. \u{622}\u{6CC}\u{627} \u{645}\u{6CC}\u{200C}\u{62E}\u{648}\u{627}\u{647}\u{6CC}\u{62F} \u{6CC}\u{6A9} \u{67E}\u{6CC}\u{6AF}\u{6CC}\u{631}\u{6CC} \u{62C}\u{62F}\u{6CC}\u{62F} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}\u{61F}`,
            CANCELLED: (name, date)=>`${name} \u{62F}\u{631} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} ${date} \u{644}\u{63A}\u{648} \u{634}\u{62F} \u{648} \u{67E}\u{633} \u{627}\u{632} \u{622}\u{646} \u{628}\u{631}\u{646}\u{627}\u{645}\u{647}\u{200C}\u{627}\u{6CC} \u{62B}\u{628}\u{62A} \u{646}\u{634}\u{62F}\u{647} \u{627}\u{633}\u{62A}. \u{622}\u{6CC}\u{627} \u{645}\u{6CC}\u{200C}\u{62E}\u{648}\u{627}\u{647}\u{6CC}\u{62F} \u{6CC}\u{6A9} \u{67E}\u{6CC}\u{6AF}\u{6CC}\u{631}\u{6CC} \u{62C}\u{62F}\u{6CC}\u{62F} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}\u{61F}`,
            STALE: (name, date)=>`\u{627}\u{632} \u{622}\u{62E}\u{631}\u{6CC}\u{646} \u{641}\u{639}\u{627}\u{644}\u{6CC}\u{62A} \u{628}\u{627} ${name} \u{62F}\u{631} \u{62A}\u{627}\u{631}\u{6CC}\u{62E} ${date} \u{645}\u{62F}\u{62A}\u{6CC} \u{6AF}\u{630}\u{634}\u{62A}\u{647} \u{627}\u{633}\u{62A}. \u{622}\u{6CC}\u{627} \u{645}\u{6CC}\u{200C}\u{62E}\u{648}\u{627}\u{647}\u{6CC}\u{62F} \u{6CC}\u{6A9} \u{67E}\u{6CC}\u{6AF}\u{6CC}\u{631}\u{6CC} \u{62C}\u{62F}\u{6CC}\u{62F} \u{627}\u{6CC}\u{62C}\u{627}\u{62F} \u{6A9}\u{646}\u{6CC}\u{62F}\u{61F}`
        },
        reasonLabels: {
            OVERDUE: "\u0627\u0632 \u0632\u0645\u0627\u0646\u0634 \u06AF\u0630\u0634\u062A\u0647",
            MISSED: "\u0627\u0646\u062C\u0627\u0645 \u0646\u0634\u062F\u0647",
            CANCELLED: "\u0644\u063A\u0648 \u0634\u062F\u0647",
            STALE: "\u0628\u062F\u0648\u0646 \u067E\u06CC\u06AF\u06CC\u0631\u06CC"
        }
    },
    reminders: {
        title: "\u06CC\u0627\u062F\u0622\u0648\u0631\u0647\u0627",
        dismiss: "\u0628\u0633\u062A\u0646",
        dismissAll: "\u0628\u0633\u062A\u0646 \u0647\u0645\u0647",
        empty: "\u06CC\u0627\u062F\u0622\u0648\u0631\u06CC \u0646\u062F\u0627\u0631\u06CC\u062F"
    },
    integrations: {
        title: "\u06CC\u06A9\u067E\u0627\u0631\u0686\u0647\u200C\u0633\u0627\u0632\u06CC\u200C\u0647\u0627",
        google: "\u062A\u0642\u0648\u06CC\u0645 \u0648 \u0648\u0638\u0627\u06CC\u0641 \u06AF\u0648\u06AF\u0644",
        notConfigured: "\u067E\u06CC\u06A9\u0631\u0628\u0646\u062F\u06CC \u0646\u0634\u062F\u0647",
        notConfiguredHint: "\u0628\u0631\u0627\u06CC \u0641\u0639\u0627\u0644\u200C\u0633\u0627\u0632\u06CC\u060C \u0645\u062F\u06CC\u0631 \u0633\u0627\u0645\u0627\u0646\u0647 \u0628\u0627\u06CC\u062F \u0627\u0637\u0644\u0627\u0639\u0627\u062A OAuth \u06AF\u0648\u06AF\u0644 \u0631\u0627 \u062F\u0631 \u062A\u0646\u0638\u06CC\u0645\u0627\u062A \u0633\u0631\u0648\u06CC\u0633 \u0648\u0627\u0631\u062F \u06A9\u0646\u062F. \u0631\u0627\u0647\u0646\u0645\u0627: docs/google-setup.md",
        connect: "\u0627\u062A\u0635\u0627\u0644 \u0628\u0647 \u06AF\u0648\u06AF\u0644",
        disconnect: "\u0642\u0637\u0639 \u0627\u062A\u0635\u0627\u0644",
        disconnectConfirm: "\u0627\u062A\u0635\u0627\u0644 \u0642\u0637\u0639 \u0645\u06CC\u200C\u0634\u0648\u062F \u0648 \u0647\u0645\u06AF\u0627\u0645\u200C\u0633\u0627\u0632\u06CC \u0645\u062A\u0648\u0642\u0641 \u0645\u06CC\u200C\u06AF\u0631\u062F\u062F. \u0641\u0639\u0627\u0644\u06CC\u062A\u200C\u0647\u0627\u06CC \u062B\u0628\u062A\u200C\u0634\u062F\u0647 \u062D\u0630\u0641 \u0646\u0645\u06CC\u200C\u0634\u0648\u0646\u062F.",
        connectedAs: "\u0645\u062A\u0635\u0644 \u0628\u0627 \u062D\u0633\u0627\u0628",
        lastSync: "\u0622\u062E\u0631\u06CC\u0646 \u0647\u0645\u06AF\u0627\u0645\u200C\u0633\u0627\u0632\u06CC",
        lastError: "\u0622\u062E\u0631\u06CC\u0646 \u062E\u0637\u0627",
        syncNow: "\u0647\u0645\u06AF\u0627\u0645\u200C\u0633\u0627\u0632\u06CC",
        syncing: "\u062F\u0631 \u062D\u0627\u0644 \u0647\u0645\u06AF\u0627\u0645\u200C\u0633\u0627\u0632\u06CC\u2026",
        calendarTarget: "\u062A\u0642\u0648\u06CC\u0645 \u0645\u0642\u0635\u062F",
        never: "\u0647\u0646\u0648\u0632 \u0627\u0646\u062C\u0627\u0645 \u0646\u0634\u062F\u0647",
        reconnect: "\u0627\u062A\u0635\u0627\u0644 \u062F\u0648\u0628\u0627\u0631\u0647",
        recentActivity: "\u0631\u0648\u06CC\u062F\u0627\u062F\u0647\u0627\u06CC \u0627\u062E\u06CC\u0631 \u0647\u0645\u06AF\u0627\u0645\u200C\u0633\u0627\u0632\u06CC",
        whatSyncs: "\u0686\u0647 \u0686\u06CC\u0632\u06CC \u0647\u0645\u06AF\u0627\u0645 \u0645\u06CC\u200C\u0634\u0648\u062F",
        whatSyncsBody: "\u0641\u0639\u0627\u0644\u06CC\u062A\u200C\u0647\u0627\u06CC \u0645\u0634\u200C\u0647\u0627\u0628 \u0628\u0647 \u062A\u0642\u0648\u06CC\u0645 \u06AF\u0648\u06AF\u0644 \u0634\u0645\u0627 \u0627\u0636\u0627\u0641\u0647 \u0645\u06CC\u200C\u0634\u0648\u0646\u062F \u0648 \u062A\u063A\u06CC\u06CC\u0631\u0627\u062A \u062A\u0642\u0648\u06CC\u0645 \u06AF\u0648\u06AF\u0644 \u0628\u0647 \u0645\u0634\u200C\u0647\u0627\u0628 \u0628\u0631\u0645\u06CC\u200C\u06AF\u0631\u062F\u062F. \u0631\u0648\u06CC\u062F\u0627\u062F\u0647\u0627\u06CC\u06CC \u06A9\u0647 \u062F\u0631 \u06AF\u0648\u06AF\u0644 \u0633\u0627\u062E\u062A\u0647\u200C\u0627\u06CC\u062F \u0646\u06CC\u0632 \u0628\u0647\u200C\u0635\u0648\u0631\u062A \u0641\u0639\u0627\u0644\u06CC\u062A \u0648\u0627\u0631\u062F\u0634\u062F\u0647 \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u0646\u062F. \xab\u0646\u062A\u06CC\u062C\u0647\xbb \u0641\u0642\u0637 \u062F\u0631 \u0645\u0634\u200C\u0647\u0627\u0628 \u0646\u06AF\u0647\u062F\u0627\u0631\u06CC \u0645\u06CC\u200C\u0634\u0648\u062F \u0648 \u0647\u0631\u06AF\u0632 \u0627\u0632 \u0633\u0645\u062A \u06AF\u0648\u06AF\u0644 \u067E\u0627\u06A9 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F.",
        connected: "\u0627\u062A\u0635\u0627\u0644 \u0628\u0627 \u0645\u0648\u0641\u0642\u06CC\u062A \u0627\u0646\u062C\u0627\u0645 \u0634\u062F.",
        denied: "\u062F\u0633\u062A\u0631\u0633\u06CC \u062F\u0627\u062F\u0647 \u0646\u0634\u062F.",
        error: "\u0627\u062A\u0635\u0627\u0644 \u0646\u0627\u0645\u0648\u0641\u0642 \u0628\u0648\u062F",
        syncResult: (pushed, pulled, imported)=>`${pushed} \u{627}\u{631}\u{633}\u{627}\u{644}\u{60C} ${pulled} \u{62F}\u{631}\u{6CC}\u{627}\u{641}\u{62A}\u{60C} ${imported} \u{648}\u{627}\u{631}\u{62F}\u{634}\u{62F}\u{647}`
    },
    // ---------------- Step 5 ----------------
    search: {
        title: "\u062C\u0633\u062A\u200C\u0648\u062C\u0648\u06CC \u067E\u06CC\u0634\u0631\u0641\u062A\u0647",
        filters: "\u0641\u06CC\u0644\u062A\u0631\u0647\u0627",
        clearFilters: "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646 \u0641\u06CC\u0644\u062A\u0631\u0647\u0627",
        hideFilters: "\u067E\u0646\u0647\u0627\u0646 \u06A9\u0631\u062F\u0646 \u0641\u06CC\u0644\u062A\u0631\u0647\u0627",
        showFilters: "\u0646\u0645\u0627\u06CC\u0634 \u0641\u06CC\u0644\u062A\u0631\u0647\u0627",
        term: "\u0646\u0627\u0645 \u06CC\u0627 \u0634\u0645\u0627\u0631\u0647",
        termHint: "\u062D\u0631\u0648\u0641 \u0639\u0631\u0628\u06CC \u0648 \u0641\u0627\u0631\u0633\u06CC \u0648 \u0627\u0631\u0642\u0627\u0645 \u0647\u0631 \u0633\u0647 \u06CC\u06A9\u0633\u0627\u0646 \u062F\u0631 \u0646\u0638\u0631 \u06AF\u0631\u0641\u062A\u0647 \u0645\u06CC\u200C\u0634\u0648\u0646\u062F",
        kind: "\u0646\u0648\u0639",
        // --- the CRM profile dimensions. The titles are the ones the contact form
        // uses, so a filter and the field it filters read the same. ---
        lifecycleStage: "\u0648\u0636\u0639\u06CC\u062A \u0686\u0631\u062E\u0647 \u0639\u0645\u0631 \u0645\u0634\u062A\u0631\u06CC",
        salesStage: "\u0645\u0631\u062D\u0644\u0647 \u0641\u0631\u0648\u0634",
        customerHealth: "\u0648\u0636\u0639\u06CC\u062A \u0645\u0634\u062A\u0631\u06CC",
        engagementStatus: "\u0648\u0636\u0639\u06CC\u062A \u0647\u0645\u06A9\u0627\u0631\u06CC",
        assessment: "\u0627\u0631\u0632\u06CC\u0627\u0628\u06CC",
        referrer: "\u0645\u0639\u0631\u0641",
        referrerAny: "\u0647\u0645\u0647",
        facilityType: "\u0646\u0648\u0639 \u0645\u062E\u0627\u0637\u0628",
        city: "\u0634\u0647\u0631",
        gender: "\u062C\u0646\u0633\u06CC\u062A",
        gold: "\u0645\u0634\u062A\u0631\u06CC \u0648\u06CC\u0698\u0647 (Gold)",
        goldAny: "\u0647\u0645\u0647",
        goldOnly: "\u0645\u0634\u062A\u0631\u06CC \u0648\u06CC\u0698\u0647",
        goldRegular: "\u0639\u0627\u062F\u06CC",
        fieldOfWork: "\u062D\u0648\u0632\u0647 \u0641\u0639\u0627\u0644\u06CC\u062A",
        specialty: "\u062A\u062E\u0635\u0635",
        specialtyHint: "\u0627\u0646\u062A\u062E\u0627\u0628 \u06CC\u06A9 \u062A\u062E\u0635\u0635\u060C \u0632\u06CC\u0631\u0634\u0627\u062E\u0647\u200C\u0647\u0627\u06CC\u0634 \u0631\u0627 \u0647\u0645 \u0634\u0627\u0645\u0644 \u0645\u06CC\u200C\u0634\u0648\u062F",
        tags: "\u0628\u0631\u0686\u0633\u0628\u200C\u0647\u0627",
        tagMatchAny: "\u0647\u0631 \u06A9\u062F\u0627\u0645",
        tagMatchAll: "\u0647\u0645\u0647",
        // Singular, matching the label the contact form uses for the same field.
        products: "\u0645\u062D\u0635\u0648\u0644 \u0645\u0648\u0631\u062F \u0639\u0644\u0627\u0642\u0647",
        createdRange: "\u062A\u0627\u0631\u06CC\u062E \u0627\u06CC\u062C\u0627\u062F",
        lastInteractionRange: "\u0622\u062E\u0631\u06CC\u0646 \u062A\u0639\u0627\u0645\u0644",
        noInteractionDays: "\u0628\u062F\u0648\u0646 \u062A\u0639\u0627\u0645\u0644 \u0628\u0647 \u0645\u062F\u062A (\u0631\u0648\u0632)",
        affiliatedOrg: "\u0648\u0627\u0628\u0633\u062A\u0647 \u0628\u0647 \u0633\u0627\u0632\u0645\u0627\u0646",
        includeDeleted: "\u0634\u0627\u0645\u0644 \u062D\u0630\u0641\u200C\u0634\u062F\u0647\u200C\u0647\u0627",
        sort: "\u0645\u0631\u062A\u0628\u200C\u0633\u0627\u0632\u06CC",
        sortName: "\u0646\u0627\u0645",
        sortCreated: "\u062A\u0627\u0631\u06CC\u062E \u0627\u06CC\u062C\u0627\u062F",
        sortLastInteraction: "\u0622\u062E\u0631\u06CC\u0646 \u062A\u0639\u0627\u0645\u0644",
        sortStatus: "\u0648\u0636\u0639\u06CC\u062A",
        results: "\u0646\u062A\u06CC\u062C\u0647",
        savedViews: "\u0646\u0645\u0627\u0647\u0627\u06CC \u0630\u062E\u06CC\u0631\u0647\u200C\u0634\u062F\u0647",
        saveView: "\u0630\u062E\u06CC\u0631\u0647\u0654 \u0627\u06CC\u0646 \u0641\u06CC\u0644\u062A\u0631",
        saveViewName: "\u0646\u0627\u0645 \u0646\u0645\u0627",
        shareView: "\u0627\u0634\u062A\u0631\u0627\u06A9 \u0628\u0627 \u0647\u0645\u0647 (\u0645\u062F\u06CC\u0631)",
        deleteView: "\u062D\u0630\u0641 \u0646\u0645\u0627",
        systemView: "\u0646\u0645\u0627\u06CC \u0633\u06CC\u0633\u062A\u0645\u06CC \u2014 \u0642\u0627\u0628\u0644 \u062D\u0630\u0641 \u0646\u06CC\u0633\u062A",
        selectAllMatching: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0647\u0645\u0647\u0654 {n} \u0645\u0648\u0631\u062F \u0645\u0646\u0637\u0628\u0642",
        selectedCount: "{n} \u0645\u0648\u0631\u062F \u0627\u0646\u062A\u062E\u0627\u0628 \u0634\u062F\u0647",
        clearSelection: "\u0644\u063A\u0648 \u0627\u0646\u062A\u062E\u0627\u0628",
        bulkTag: "\u0627\u0641\u0632\u0648\u062F\u0646 \u0628\u0631\u0686\u0633\u0628",
        bulkUntag: "\u062D\u0630\u0641 \u0628\u0631\u0686\u0633\u0628",
        bulkStatus: "\u062A\u063A\u06CC\u06CC\u0631 \u0648\u0636\u0639\u06CC\u062A",
        bulkMessage: "\u0627\u0631\u0633\u0627\u0644 \u067E\u06CC\u0627\u0645",
        bulkExport: "\u062E\u0631\u0648\u062C\u06CC CSV",
        bulkDone: "{n} \u0645\u062E\u0627\u0637\u0628 \u0628\u0647\u200C\u0631\u0648\u0632\u0631\u0633\u0627\u0646\u06CC \u0634\u062F",
        bulkTooLarge: "\u062A\u0639\u062F\u0627\u062F \u0628\u06CC\u0634 \u0627\u0632 \u0633\u0642\u0641 \u0645\u062C\u0627\u0632 \u0627\u0633\u062A\u061B \u0641\u06CC\u0644\u062A\u0631 \u0631\u0627 \u0645\u062D\u062F\u0648\u062F\u062A\u0631 \u06A9\u0646\u06CC\u062F",
        columns: "\u0633\u062A\u0648\u0646\u200C\u0647\u0627",
        lastInteraction: "\u0622\u062E\u0631\u06CC\u0646 \u062A\u0639\u0627\u0645\u0644",
        interactions: "\u062A\u0639\u0627\u0645\u0644\u0627\u062A",
        never: "\u0647\u0631\u06AF\u0632",
        optedOut: "\u0627\u0646\u0635\u0631\u0627\u0641 \u0627\u0632 \u067E\u06CC\u0627\u0645"
    },
    messaging: {
        title: "\u067E\u06CC\u0627\u0645\u200C\u0647\u0627",
        outbox: "\u0635\u0646\u062F\u0648\u0642 \u062E\u0631\u0648\u062C\u06CC",
        campaigns: "\u06A9\u0645\u067E\u06CC\u0646\u200C\u0647\u0627",
        send: "\u0627\u0631\u0633\u0627\u0644 \u067E\u06CC\u0627\u0645",
        sendTo: "\u0627\u0631\u0633\u0627\u0644 \u0628\u0647 {name}",
        template: "\u0642\u0627\u0644\u0628 \u067E\u06CC\u0627\u0645",
        freeText: "\u0645\u062A\u0646 \u0622\u0632\u0627\u062F",
        preview: "\u067E\u06CC\u0634\u200C\u0646\u0645\u0627\u06CC\u0634",
        force: "\u0627\u0631\u0633\u0627\u0644 \u0628\u0627 \u0648\u062C\u0648\u062F \u0647\u0634\u062F\u0627\u0631",
        forceHint: "\u0641\u0642\u0637 \u0647\u0634\u062F\u0627\u0631 \xab\u062A\u06A9\u0631\u0627\u0631\u06CC\xbb \u0631\u0627 \u0646\u0627\u062F\u06CC\u062F\u0647 \u0645\u06CC\u200C\u06AF\u06CC\u0631\u062F\u061B \u0627\u0646\u0635\u0631\u0627\u0641 \u0645\u062E\u0627\u0637\u0628 \u0647\u0631\u06AF\u0632 \u0646\u0627\u062F\u06CC\u062F\u0647 \u06AF\u0631\u0641\u062A\u0647 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F",
        sandboxBanner: "\u062D\u0627\u0644\u062A \u0622\u0632\u0645\u0627\u06CC\u0634\u06CC \u2014 \u0647\u06CC\u0686 \u067E\u06CC\u0627\u0645\u06CC \u0648\u0627\u0642\u0639\u0627\u064B \u0627\u0631\u0633\u0627\u0644 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F",
        liveBanner: "\u0627\u062A\u0635\u0627\u0644 \u0648\u0627\u0642\u0639\u06CC \u0628\u0647 \u0648\u0627\u062A\u0633\u200C\u0627\u067E \u2014 \u067E\u06CC\u0627\u0645\u200C\u0647\u0627 \u0627\u0631\u0633\u0627\u0644 \u0645\u06CC\u200C\u0634\u0648\u0646\u062F",
        status: "\u0648\u0636\u0639\u06CC\u062A",
        statusQueued: "\u062F\u0631 \u0635\u0641",
        statusSent: "\u0627\u0631\u0633\u0627\u0644 \u0634\u062F",
        statusDelivered: "\u062A\u062D\u0648\u06CC\u0644 \u0634\u062F",
        statusRead: "\u062E\u0648\u0627\u0646\u062F\u0647 \u0634\u062F",
        statusFailed: "\u0646\u0627\u0645\u0648\u0641\u0642",
        statusSuppressed: "\u0627\u0631\u0633\u0627\u0644 \u0646\u0634\u062F",
        reasonOptOut: "\u0627\u0646\u0635\u0631\u0627\u0641 \u0645\u062E\u0627\u0637\u0628",
        // NO_CHANNEL on WhatsApp. Since 2026-09-26 a send falls back to the
        // primary phone, so this no longer means «the واتساپ box was not ticked»:
        // it means no number at all, or the gateway said the number is not on
        // WhatsApp. The old wording sent people to tick a checkbox that was never
        // the problem.
        reasonNoChannel: "\u0634\u0645\u0627\u0631\u0647\u200C\u0627\u06CC \u0646\u062F\u0627\u0631\u062F \u06CC\u0627 \u062F\u0631 \u0648\u0627\u062A\u0633\u200C\u0627\u067E \u062B\u0628\u062A \u0646\u0634\u062F\u0647",
        // NO_CHANNEL on an SMS: the contact has no mobile at all. «شماره واتس‌اپ
        // ندارد» beside a text message would send somebody looking for the wrong
        // number.
        reasonNoMobile: "\u0634\u0645\u0627\u0631\u0647 \u0645\u0648\u0628\u0627\u06CC\u0644 \u0646\u062F\u0627\u0631\u062F",
        reasonDuplicate: "\u062A\u06A9\u0631\u0627\u0631\u06CC",
        reasonCampaignCancelled: "\u06A9\u0645\u067E\u06CC\u0646 \u0644\u063A\u0648 \u0634\u062F",
        reasonQuietHours: "\u062F\u0631 \u0627\u0646\u062A\u0638\u0627\u0631 \u067E\u0627\u06CC\u0627\u0646 \u0633\u0627\u0639\u0627\u062A \u0633\u06A9\u0648\u062A",
        reasonRateLimit: "\u062F\u0631 \u0627\u0646\u062A\u0638\u0627\u0631 \u0645\u062D\u062F\u0648\u062F\u06CC\u062A \u0627\u0631\u0633\u0627\u0644",
        retry: "\u062A\u0644\u0627\u0634 \u062F\u0648\u0628\u0627\u0631\u0647",
        body: "\u0645\u062A\u0646",
        recipient: "\u06AF\u06CC\u0631\u0646\u062F\u0647",
        sentAt: "\u0632\u0645\u0627\u0646 \u0627\u0631\u0633\u0627\u0644",
        campaignName: "\u0646\u0627\u0645 \u06A9\u0645\u067E\u06CC\u0646",
        newCampaign: "\u06A9\u0645\u067E\u06CC\u0646 \u062C\u062F\u06CC\u062F",
        fromView: "\u0627\u0632 \u0646\u0645\u0627\u06CC \u0630\u062E\u06CC\u0631\u0647\u200C\u0634\u062F\u0647",
        recipients: "\u06AF\u06CC\u0631\u0646\u062F\u06AF\u0627\u0646",
        schedule: "\u0632\u0645\u0627\u0646\u200C\u0628\u0646\u062F\u06CC",
        sendNow: "\u0627\u0631\u0633\u0627\u0644 \u0641\u0648\u0631\u06CC",
        cancel: "\u0644\u063A\u0648 \u06A9\u0645\u067E\u06CC\u0646",
        counters: "\u0634\u0645\u0627\u0631\u0646\u062F\u0647\u200C\u0647\u0627",
        projectionLag: "\u0647\u0645\u06AF\u0627\u0645\u200C\u0633\u0627\u0632\u06CC \u067E\u0631\u0648\u062C\u06A9\u0634\u0646",
        projectionRecipients: "{n} \u0645\u062E\u0627\u0637\u0628 \u062F\u0631 \u067E\u0631\u0648\u062C\u06A9\u0634\u0646",
        replayProjections: "\u0628\u0627\u0632\u0633\u0627\u0632\u06CC \u067E\u0631\u0648\u062C\u06A9\u0634\u0646\u200C\u0647\u0627",
        replayDone: "{n} \u0645\u0648\u0631\u062F \u0628\u0627\u0632\u0633\u0627\u0632\u06CC \u0634\u062F",
        replayed: "{n} \u0631\u0648\u06CC\u062F\u0627\u062F \u0628\u0627\u0632\u067E\u062E\u0634 \u0634\u062F",
        noMessages: "\u0647\u0646\u0648\u0632 \u067E\u06CC\u0627\u0645\u06CC \u0627\u0631\u0633\u0627\u0644 \u0646\u0634\u062F\u0647",
        // --- channel picker on the send dialog ---
        channel: "\u0631\u0648\u0634 \u0627\u0631\u0633\u0627\u0644",
        whatsapp: "\u0648\u0627\u062A\u0633\u0627\u067E",
        sms: "\u067E\u06CC\u0627\u0645\u06A9",
        sendViaWhatsapp: "\u0627\u0631\u0633\u0627\u0644 \u0627\u0632 \u0637\u0631\u06CC\u0642 \u0648\u0627\u062A\u0633\u0627\u067E",
        sendSms: "\u0627\u0631\u0633\u0627\u0644 \u067E\u06CC\u0627\u0645\u06A9",
        freeBody: "\u0645\u062A\u0646 \u067E\u06CC\u0627\u0645",
        freeBodyHint: "\u0627\u06AF\u0631 \u0642\u0627\u0644\u0628\u06CC \u0627\u0646\u062A\u062E\u0627\u0628 \u0646\u06A9\u0646\u06CC\u062F\u060C \u0647\u0645\u06CC\u0646 \u0645\u062A\u0646 \u0627\u0631\u0633\u0627\u0644 \u0645\u06CC\u200C\u0634\u0648\u062F. \u062C\u0627\u06CC\u06AF\u0632\u06CC\u0646\u200C\u0647\u0627 \u0628\u0631\u0627\u06CC \u0647\u0631 \u0645\u062E\u0627\u0637\u0628 \u0628\u0627 \u0646\u0627\u0645 \u0627\u0648 \u067E\u0631 \u0645\u06CC\u200C\u0634\u0648\u0646\u062F.",
        freeBodyIgnored: "\u0642\u0627\u0644\u0628 \u0627\u0646\u062A\u062E\u0627\u0628 \u0634\u062F\u0647 \u0627\u0633\u062A\u061B \u0628\u0631\u0627\u06CC \u0646\u0648\u0634\u062A\u0646 \u0645\u062A\u0646 \u0622\u0632\u0627\u062F\u060C \xab\u0628\u062F\u0648\u0646 \u0642\u0627\u0644\u0628\xbb \u0631\u0627 \u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F.",
        // The placeholder chips under the free-text box. The same three the
        // template editor offers; the server substitutes them per recipient, so
        // in a batch every doctor reads their own name.
        placeholders: "\u062C\u0627\u06CC\u06AF\u0632\u06CC\u0646\u200C\u0647\u0627",
        placeholderHint: "\u0631\u0648\u06CC \u0647\u0631 \u062C\u0627\u06CC\u06AF\u0632\u06CC\u0646 \u0628\u0632\u0646\u06CC\u062F \u062A\u0627 \u062F\u0631 \u062C\u0627\u06CC \u0645\u06A9\u0627\u0646\u200C\u0646\u0645\u0627 \u062F\u0631\u062C \u0634\u0648\u062F\u061B \u0647\u0646\u06AF\u0627\u0645 \u0627\u0631\u0633\u0627\u0644\u060C \u0628\u0631\u0627\u06CC \u0647\u0631 \u0645\u062E\u0627\u0637\u0628 \u0628\u0627 \u0646\u0627\u0645 \u0647\u0645\u0627\u0646 \u0634\u062E\u0635 \u062C\u0627\u06CC\u200C\u06AF\u0630\u0627\u0631\u06CC \u0645\u06CC\u200C\u0634\u0648\u062F.",
        // The SERVER decided this token is unknown (`validatePlaceholders`); the
        // client only words it. Said before sending because the renderer blanks
        // an unknown placeholder rather than leaking braces to a doctor.
        placeholderUnknown: "\u062C\u0627\u06CC\u06AF\u0632\u06CC\u0646 \xab{token}\xbb \u0634\u0646\u0627\u062E\u062A\u0647 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F \u0648 \u0647\u0646\u06AF\u0627\u0645 \u0627\u0631\u0633\u0627\u0644 \u062E\u0627\u0644\u06CC \u0645\u06CC\u200C\u0645\u0627\u0646\u062F. \u062C\u0627\u06CC\u06AF\u0632\u06CC\u0646\u200C\u0647\u0627\u06CC \u0645\u062C\u0627\u0632: {allowed}",
        whatsappTemplate: "\u0642\u0627\u0644\u0628 \u067E\u06CC\u0627\u0645 \u0648\u0627\u062A\u0633\u0627\u067E",
        smsTemplate: "\u0642\u0627\u0644\u0628 \u067E\u06CC\u0627\u0645\u06A9",
        // The deployment has no SMS route (SMS_PROVIDER=none, or the caller
        // secret is missing). Said out loud, in the place the decision is made,
        // rather than left as a button that quietly does nothing — «sandbox» and
        // «connected» must never be confusable, and neither must «sent» and «not
        // set up».
        smsNotConfigured: "\u0645\u0633\u06CC\u0631 \u0627\u0631\u0633\u0627\u0644 \u067E\u06CC\u0627\u0645\u06A9 \u0647\u0646\u0648\u0632 \u067E\u06CC\u06A9\u0631\u0628\u0646\u062F\u06CC \u0646\u0634\u062F\u0647 \u0627\u0633\u062A. \u0642\u0627\u0644\u0628 \u0648 \u0645\u062A\u0646 \u0646\u0647\u0627\u06CC\u06CC \u0631\u0627 \u0645\u06CC\u200C\u062A\u0648\u0627\u0646\u06CC\u062F \u0627\u06CC\u0646\u062C\u0627 \u0628\u0628\u06CC\u0646\u06CC\u062F\u061B \u0627\u0631\u0633\u0627\u0644 \u0628\u0627 \u0631\u0627\u0647\u200C\u0627\u0646\u062F\u0627\u0632\u06CC \u0633\u0631\u0648\u06CC\u0633 \u067E\u06CC\u0627\u0645\u06A9 \u0641\u0639\u0627\u0644 \u0645\u06CC\u200C\u0634\u0648\u062F.",
        noTemplateForChannel: "\u0628\u0631\u0627\u06CC \u0627\u06CC\u0646 \u0631\u0648\u0634 \u0627\u0631\u0633\u0627\u0644\u060C \u0642\u0627\u0644\u0628\u06CC \u062A\u0639\u0631\u06CC\u0641 \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
        // Named beside every SMS send, like the WhatsApp banner: the sandbox and
        // a real text must never look alike. The live line also says what the
        // Outbox will NOT show, so a text stuck at «ارسال شد» is not a mystery.
        smsSandbox: "\u062D\u0627\u0644\u062A \u0622\u0632\u0645\u0627\u06CC\u0634\u06CC \u2014 \u067E\u06CC\u0627\u0645\u06A9\u06CC \u0648\u0627\u0642\u0639\u0627\u064B \u0627\u0631\u0633\u0627\u0644 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F.",
        smsLive: "\u067E\u06CC\u0627\u0645\u06A9 \u0627\u0632 \u062E\u0637 \u0633\u0627\u0645\u0627\u0646\u0647 \u067E\u06CC\u0627\u0645\u06A9 \u0627\u0631\u0633\u0627\u0644 \u0645\u06CC\u200C\u0634\u0648\u062F. \u062A\u062D\u0648\u06CC\u0644 \u067E\u06CC\u0627\u0645\u06A9 \u06AF\u0632\u0627\u0631\u0634 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F\u061B \u0648\u0636\u0639\u06CC\u062A \u062F\u0631 \xab\u0627\u0631\u0633\u0627\u0644 \u0634\u062F\xbb \u0645\u06CC\u200C\u0645\u0627\u0646\u062F.",
        smsBadge: "\u067E\u06CC\u0627\u0645\u06A9",
        // --- sending to a selection ---
        sendToMany: "\u0627\u0631\u0633\u0627\u0644 \u067E\u06CC\u0627\u0645 \u0628\u0647 {n} \u0645\u062E\u0627\u0637\u0628",
        sendToManyAction: "\u0633\u0627\u062E\u062A \u0648 \u0627\u0631\u0633\u0627\u0644 \u06A9\u0645\u067E\u06CC\u0646",
        bulkSend: "\u0627\u0631\u0633\u0627\u0644 \u067E\u06CC\u0627\u0645",
        // `campaignName` already exists in this block — reused rather than
        // redeclared, because a duplicate key in one object literal silently keeps
        // the last one and the two drift apart the first time somebody edits the
        // one they can see.
        bulkDefaultName: "\u0627\u0631\u0633\u0627\u0644 \u06AF\u0631\u0648\u0647\u06CC \u2014 {date}",
        bulkNameHint: "\u062F\u0631 \u0641\u0647\u0631\u0633\u062A \u06A9\u0645\u067E\u06CC\u0646\u200C\u0647\u0627 \u0628\u0627 \u0647\u0645\u06CC\u0646 \u0646\u0627\u0645 \u062F\u06CC\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.",
        // A bulk send is a CAMPAIGN: the list is frozen, it can be cancelled while
        // it drains, and the Outbox accounts for it afterwards. Said on the screen
        // because «ارسال» that quietly creates a durable object is a surprise.
        bulkSendHint: "\u0628\u0631\u0627\u06CC \u0627\u0631\u0633\u0627\u0644 \u06AF\u0631\u0648\u0647\u06CC \u06CC\u06A9 \u06A9\u0645\u067E\u06CC\u0646 \u0633\u0627\u062E\u062A\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F: \u0641\u0647\u0631\u0633\u062A \u06AF\u06CC\u0631\u0646\u062F\u06AF\u0627\u0646 \u0647\u0645\u0627\u0646 \u0644\u062D\u0638\u0647 \u062B\u0628\u062A \u0645\u06CC\u200C\u0634\u0648\u062F\u060C \u062A\u0627 \u067E\u06CC\u0634 \u0627\u0632 \u067E\u0627\u06CC\u0627\u0646 \u0627\u0631\u0633\u0627\u0644 \u0642\u0627\u0628\u0644 \u0644\u063A\u0648 \u0627\u0633\u062A\u060C \u0648 \u0646\u062A\u06CC\u062C\u0647\u0654 \u0622\u0646 \u062F\u0631 \xab\u0635\u0646\u062F\u0648\u0642 \u062E\u0631\u0648\u062C\u06CC\xbb \u062F\u06CC\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.",
        previewSample: "\u067E\u06CC\u0634\u200C\u0646\u0645\u0627\u06CC\u0634 \u0628\u0631\u0627\u06CC {name}",
        previewSampleSuppressed: "\u0628\u0631\u0627\u06CC \u0647\u0645\u06CC\u0646 \u0645\u062E\u0627\u0637\u0628 \u0627\u0631\u0633\u0627\u0644 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F\u061B \u0628\u0642\u06CC\u0647\u0654 \u06AF\u06CC\u0631\u0646\u062F\u06AF\u0627\u0646 \u062C\u062F\u0627\u06AF\u0627\u0646\u0647 \u0628\u0631\u0631\u0633\u06CC \u0645\u06CC\u200C\u0634\u0648\u0646\u062F.",
        previewEmpty: "\u0647\u0646\u0648\u0632 \u0645\u062A\u0646\u06CC \u0646\u0648\u0634\u062A\u0647 \u0646\u0634\u062F\u0647 \u0627\u0633\u062A.",
        bulkSendQueued: "\u06A9\u0645\u067E\u06CC\u0646 \u0633\u0627\u062E\u062A\u0647 \u0634\u062F\u061B \u0648\u0636\u0639\u06CC\u062A \u0627\u0631\u0633\u0627\u0644 \u062F\u0631 \xab\u0635\u0646\u062F\u0648\u0642 \u062E\u0631\u0648\u062C\u06CC\xbb \u062F\u06CC\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.",
        // --- a picture or a video ---
        mediaAdd: "\u0627\u0641\u0632\u0648\u062F\u0646 \u0639\u06A9\u0633 \u06CC\u0627 \u0648\u06CC\u062F\u06CC\u0648",
        mediaRemove: "\u062D\u0630\u0641 \u0641\u0627\u06CC\u0644",
        mediaUploading: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC\u2026 {pct}\u066A",
        mediaReady: "\u0622\u0645\u0627\u062F\u0647 \u0627\u0631\u0633\u0627\u0644",
        // Text is the CAPTION, and it is optional — said beside the file, because
        // the form otherwise reads as if a message still needs words.
        mediaCaptionHint: "\u0645\u062A\u0646 \u067E\u06CC\u0627\u0645\u060C \u0632\u06CC\u0631\u0646\u0648\u06CC\u0633 \u0627\u06CC\u0646 \u0641\u0627\u06CC\u0644 \u0645\u06CC\u200C\u0634\u0648\u062F \u0648 \u0627\u062E\u062A\u06CC\u0627\u0631\u06CC \u0627\u0633\u062A.",
        // Named rather than listed as MIME types: a person reads «JPG», not
        // «image/jpeg». HEIC is called out because it is the one an iPhone makes.
        mediaWrongType: "\u0641\u0642\u0637 \u0639\u06A9\u0633 JPG \u06CC\u0627 PNG \u0648 \u0648\u06CC\u062F\u06CC\u0648\u06CC MP4 \u06CC\u0627 3GP \u0642\u0627\u0628\u0644 \u0627\u0631\u0633\u0627\u0644 \u0627\u0633\u062A. \u0639\u06A9\u0633\u200C\u0647\u0627\u06CC HEIC \u0622\u06CC\u0641\u0648\u0646 \u0631\u0627 \u0648\u0627\u062A\u0633\u200C\u0627\u067E \u0646\u0645\u0627\u06CC\u0634 \u0646\u0645\u06CC\u200C\u062F\u0647\u062F\u061B \u0622\u0646 \u0631\u0627 \u0628\u0647 JPG \u062A\u0628\u062F\u06CC\u0644 \u06A9\u0646\u06CC\u062F.",
        mediaTooLarge: "\u062D\u062C\u0645 \u0641\u0627\u06CC\u0644 \u0628\u06CC\u0634 \u0627\u0632 {mb} \u0645\u06AF\u0627\u0628\u0627\u06CC\u062A \u0627\u0633\u062A."
    },
    automation: {
        title: "\u062E\u0648\u062F\u06A9\u0627\u0631\u0633\u0627\u0632\u06CC",
        rules: "\u0642\u0648\u0627\u0646\u06CC\u0646",
        occasions: "\u0645\u0646\u0627\u0633\u0628\u062A\u200C\u0647\u0627",
        newRule: "\u0642\u0627\u0646\u0648\u0646 \u062C\u062F\u06CC\u062F",
        ruleName: "\u0646\u0627\u0645 \u0642\u0627\u0646\u0648\u0646",
        trigger: "\u0631\u0648\u06CC\u062F\u0627\u062F",
        triggerBirthday: "\u062A\u0648\u0644\u062F",
        triggerOccasion: "\u0645\u0646\u0627\u0633\u0628\u062A",
        triggerStatusChanged: "\u062A\u063A\u06CC\u06CC\u0631 \u0645\u0631\u062D\u0644\u0647 \u0627\u0634\u062A\u0631\u0627\u06A9",
        triggerIssueResolved: "\u062D\u0644 \u0634\u062F\u0646 \u0645\u0634\u06A9\u0644",
        sendTime: "\u0633\u0627\u0639\u062A \u0627\u0631\u0633\u0627\u0644",
        enabled: "\u0641\u0639\u0627\u0644",
        dryRun: "\u0634\u0628\u06CC\u0647\u200C\u0633\u0627\u0632\u06CC",
        dryRunDate: "\u062A\u0627\u0631\u06CC\u062E (\u0645\u06CC\u0644\u0627\u062F\u06CC)",
        dryRunHint: "\u0647\u06CC\u0686 \u067E\u06CC\u0627\u0645\u06CC \u0627\u0631\u0633\u0627\u0644 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F \u2014 \u0641\u0642\u0637 \u0646\u0634\u0627\u0646 \u0645\u06CC\u200C\u062F\u0647\u062F \u0686\u0647 \u06A9\u0633\u06CC \u0686\u0647 \u0686\u06CC\u0632\u06CC \u0645\u06CC\u200C\u06AF\u0631\u0641\u062A",
        dryRunEmpty: "\u062F\u0631 \u0627\u06CC\u0646 \u062A\u0627\u0631\u06CC\u062E \u06A9\u0633\u06CC \u067E\u06CC\u0627\u0645\u06CC \u0646\u0645\u06CC\u200C\u06AF\u06CC\u0631\u062F",
        occasionCode: "\u06A9\u062F",
        occasionLabel: "\u0639\u0646\u0648\u0627\u0646",
        jalaliMonth: "\u0645\u0627\u0647 \u0634\u0645\u0633\u06CC",
        jalaliDay: "\u0631\u0648\u0632",
        newOccasion: "\u0645\u0646\u0627\u0633\u0628\u062A \u062C\u062F\u06CC\u062F",
        toStatus: "\u0648\u0636\u0639\u06CC\u062A \u0647\u062F\u0641"
    },
    whatsapp: {
        title: "\u0648\u0627\u062A\u0633\u200C\u0627\u067E",
        connection: "\u0648\u0636\u0639\u06CC\u062A \u0627\u062A\u0635\u0627\u0644",
        provider: "\u0627\u0631\u0627\u0626\u0647\u200C\u062F\u0647\u0646\u062F\u0647",
        paired: "\u062F\u0633\u062A\u06AF\u0627\u0647 \u0645\u062A\u0635\u0644",
        notPaired: "\u062F\u0633\u062A\u06AF\u0627\u0647\u06CC \u0645\u062A\u0635\u0644 \u0646\u06CC\u0633\u062A",
        connected: "\u0622\u0646\u0644\u0627\u06CC\u0646",
        disconnected: "\u0622\u0641\u0644\u0627\u06CC\u0646",
        linkedNumber: "\u0634\u0645\u0627\u0631\u0647\u0654 \u0645\u062A\u0635\u0644",
        pushName: "\u0646\u0627\u0645 \u0646\u0645\u0627\u06CC\u0634\u06CC",
        queueDepth: "\u0635\u0641 \u0627\u0631\u0633\u0627\u0644",
        sentLastHour: "\u0627\u0631\u0633\u0627\u0644 \u062F\u0631 \u06CC\u06A9 \u0633\u0627\u0639\u062A \u06AF\u0630\u0634\u062A\u0647",
        sendDisabled: "\u0627\u0631\u0633\u0627\u0644 \u063A\u06CC\u0631\u0641\u0639\u0627\u0644 \u0627\u0633\u062A (SEND_DISABLED)",
        lastError: "\u0622\u062E\u0631\u06CC\u0646 \u062E\u0637\u0627",
        pair: "\u0627\u062A\u0635\u0627\u0644 \u062F\u0633\u062A\u06AF\u0627\u0647",
        pairing: "\u062F\u0631 \u062D\u0627\u0644 \u062F\u0631\u06CC\u0627\u0641\u062A \u06A9\u062F\u2026",
        scanHint: "\u062F\u0631 \u0648\u0627\u062A\u0633\u200C\u0627\u067E \u06AF\u0648\u0634\u06CC: \u062A\u0646\u0638\u06CC\u0645\u0627\u062A \u2190 \u062F\u0633\u062A\u06AF\u0627\u0647\u200C\u0647\u0627\u06CC \u0645\u062A\u0635\u0644 \u2190 \u0627\u062A\u0635\u0627\u0644 \u062F\u0633\u062A\u06AF\u0627\u0647",
        qrLabel: "\u06A9\u062F QR \u0627\u062A\u0635\u0627\u0644 \u0648\u0627\u062A\u0633\u200C\u0627\u067E",
        qrPayloadToggle: "\u06A9\u062F \u0627\u0633\u06A9\u0646 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F\u061F \u0646\u0645\u0627\u06CC\u0634 \u0645\u062A\u0646 \u06A9\u062F",
        codeAlternative: "\u06CC\u0627 \u0628\u0627 \u06A9\u062F \u0639\u062F\u062F\u06CC \u0645\u062A\u0635\u0644 \u0634\u0648\u06CC\u062F",
        phoneForCode: "\u0634\u0645\u0627\u0631\u0647\u0654 \u062A\u0644\u0641\u0646",
        pairSuccess: "\u062F\u0633\u062A\u06AF\u0627\u0647 \u0628\u0627 \u0645\u0648\u0641\u0642\u06CC\u062A \u0645\u062A\u0635\u0644 \u0634\u062F",
        pairTimeout: "\u0632\u0645\u0627\u0646 \u0628\u0647 \u067E\u0627\u06CC\u0627\u0646 \u0631\u0633\u06CC\u062F\u061B \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F",
        unlink: "\u0642\u0637\u0639 \u0627\u062A\u0635\u0627\u0644",
        unlinkConfirm: "\u0642\u0637\u0639 \u0627\u062A\u0635\u0627\u0644\u060C \u0627\u0631\u0633\u0627\u0644 \u0647\u0631 \u067E\u06CC\u0627\u0645\u06CC \u0631\u0627 \u0645\u062A\u0648\u0642\u0641 \u0645\u06CC\u200C\u06A9\u0646\u062F. \u0645\u0637\u0645\u0626\u0646\u06CC\u062F\u061F",
        pacing: "\u062A\u0646\u0638\u06CC\u0645\u0627\u062A \u0627\u0631\u0633\u0627\u0644",
        riskTitle: "\u0647\u0634\u062F\u0627\u0631 \u0645\u0647\u0645",
        riskBody: "\u0645\u0634\u200C\u0647\u0627\u0628 \u0627\u0632 \u067E\u0631\u0648\u062A\u06A9\u0644 \u063A\u06CC\u0631\u0631\u0633\u0645\u06CC \u0648\u0627\u062A\u0633\u200C\u0627\u067E \u0648\u0628 \u0627\u0633\u062A\u0641\u0627\u062F\u0647 \u0645\u06CC\u200C\u06A9\u0646\u062F. \u0634\u0645\u0627\u0631\u0647\u0654 \u0645\u062A\u0635\u0644 \u0645\u0645\u06A9\u0646 \u0627\u0633\u062A \u0645\u062D\u062F\u0648\u062F \u06CC\u0627 \u0645\u0633\u062F\u0648\u062F \u0634\u0648\u062F. \u0627\u0632 \u06CC\u06A9 \u0634\u0645\u0627\u0631\u0647\u0654 \u0627\u062E\u062A\u0635\u0627\u0635\u06CC \u0627\u0633\u062A\u0641\u0627\u062F\u0647 \u06A9\u0646\u06CC\u062F\u060C \u062D\u062C\u0645 \u0627\u0631\u0633\u0627\u0644 \u0631\u0627 \u062A\u062F\u0631\u06CC\u062C\u06CC \u0628\u0627\u0644\u0627 \u0628\u0628\u0631\u06CC\u062F\u060C \u0648 \u0627\u0646\u0635\u0631\u0627\u0641 \u0645\u062E\u0627\u0637\u0628\u0627\u0646 \u0631\u0627 \u0647\u0645\u06CC\u0634\u0647 \u0645\u062D\u062A\u0631\u0645 \u0628\u0634\u0645\u0627\u0631\u06CC\u062F. \u0631\u0627\u0647\u0646\u0645\u0627\u06CC \u06A9\u0627\u0645\u0644: docs/whatsapp-setup.md",
        // --- several numbers ---
        accounts: "\u0634\u0645\u0627\u0631\u0647\u200C\u0647\u0627\u06CC \u0648\u0627\u062A\u0633\u200C\u0627\u067E",
        accountsEmpty: "\u0647\u0646\u0648\u0632 \u0634\u0645\u0627\u0631\u0647\u200C\u0627\u06CC \u062A\u0639\u0631\u06CC\u0641 \u0646\u0634\u062F\u0647 \u0627\u0633\u062A\u061B \u0627\u0631\u0633\u0627\u0644 \u0627\u0632 \u0634\u0645\u0627\u0631\u0647\u0654 \u067E\u06CC\u0634\u200C\u0641\u0631\u0636 \u0627\u0646\u062C\u0627\u0645 \u0645\u06CC\u200C\u0634\u0648\u062F.",
        addAccount: "\u0627\u0641\u0632\u0648\u062F\u0646 \u0634\u0645\u0627\u0631\u0647",
        accountLabel: "\u0646\u0627\u0645 \u0634\u0645\u0627\u0631\u0647",
        accountLabelHint: "\u0646\u0627\u0645\u06CC \u06A9\u0647 \u06A9\u0627\u0631\u0628\u0631\u0627\u0646 \u0647\u0646\u06AF\u0627\u0645 \u0627\u0631\u0633\u0627\u0644 \u0645\u06CC\u200C\u0628\u06CC\u0646\u0646\u062F \u2014 \u0645\u062B\u0644\u0627\u064B \xab\u0634\u0645\u0627\u0631\u0647\u0654 \u0641\u0631\u0648\u0634\xbb.",
        addAccountHint: "\u0641\u0642\u0637 \u06CC\u06A9 \u0646\u0627\u0645 \u0644\u0627\u0632\u0645 \u0627\u0633\u062A. \u0634\u0646\u0627\u0633\u0647\u0654 \u0641\u0646\u06CC \u0627\u0632 \u0631\u0648\u06CC \u0646\u0627\u0645 \u0633\u0627\u062E\u062A\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F \u0648 \u067E\u0633 \u0627\u0632 \u0627\u0641\u0632\u0648\u062F\u0646 \u0631\u0648\u06CC \u0647\u0645\u0627\u0646 \u0634\u0645\u0627\u0631\u0647 \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F.",
        accountIdToggle: "\u062A\u0639\u06CC\u06CC\u0646 \u062F\u0633\u062A\u06CC \u0634\u0646\u0627\u0633\u0647\u0654 \u0641\u0646\u06CC (\u067E\u06CC\u0634\u0631\u0641\u062A\u0647)",
        accountIdPlaceholder: "\u062E\u0648\u062F\u06A9\u0627\u0631 \u0633\u0627\u062E\u062A\u0647 \u0645\u06CC\u200C\u0634\u0648\u062F",
        accountId: "\u0634\u0646\u0627\u0633\u0647\u0654 \u0641\u0646\u06CC",
        // The id is machinery: immutable, prefixed, and keyed to a linked device.
        // Said plainly here because the one thing a user must not do is change it
        // later expecting a rename.
        accountIdHint: "\u062E\u0627\u0644\u06CC \u0628\u06AF\u0630\u0627\u0631\u06CC\u062F \u062A\u0627 \u062E\u0648\u062F\u06A9\u0627\u0631 \u0633\u0627\u062E\u062A\u0647 \u0634\u0648\u062F. \u0641\u0642\u0637 \u0648\u0642\u062A\u06CC \u0644\u0627\u0632\u0645 \u0627\u0633\u062A \u06A9\u0647 \u0628\u062E\u0648\u0627\u0647\u06CC\u062F \u0634\u0645\u0627\u0631\u0647 \u0631\u0627 \u0628\u0647 \u0646\u0634\u0633\u062A\u06CC \u06A9\u0647 \u0627\u0632 \u0642\u0628\u0644 \u0631\u0648\u06CC \u062F\u0631\u06AF\u0627\u0647 \u0648\u062C\u0648\u062F \u062F\u0627\u0631\u062F \u0648\u0635\u0644 \u06A9\u0646\u06CC\u062F. \u067E\u0633 \u0627\u0632 \u0633\u0627\u062E\u062A \u0642\u0627\u0628\u0644 \u062A\u063A\u06CC\u06CC\u0631 \u0646\u06CC\u0633\u062A\u060C \u0686\u0648\u0646 \u06A9\u0644\u06CC\u062F \u062F\u0633\u062A\u06AF\u0627\u0647 \u0645\u062A\u0635\u0644 \u0648 \u0645\u0633\u06CC\u0631 \u062F\u0631\u06CC\u0627\u0641\u062A \u0631\u0633\u06CC\u062F\u0647\u0627\u0633\u062A.",
        isDefault: "\u067E\u06CC\u0634\u200C\u0641\u0631\u0636",
        makeDefault: "\u0627\u0646\u062A\u062E\u0627\u0628 \u0628\u0647\u200C\u0639\u0646\u0648\u0627\u0646 \u067E\u06CC\u0634\u200C\u0641\u0631\u0636",
        defaultHint: "\u067E\u06CC\u0627\u0645\u200C\u0647\u0627\u06CC\u06CC \u06A9\u0647 \u0634\u0645\u0627\u0631\u0647\u200C\u0627\u06CC \u0628\u0631\u0627\u06CC\u0634\u0627\u0646 \u0627\u0646\u062A\u062E\u0627\u0628 \u0646\u0634\u062F\u0647 \u0627\u0632 \u0627\u06CC\u0646 \u0634\u0645\u0627\u0631\u0647 \u0627\u0631\u0633\u0627\u0644 \u0645\u06CC\u200C\u0634\u0648\u0646\u062F.",
        active: "\u0641\u0639\u0627\u0644",
        inactive: "\u063A\u06CC\u0631\u0641\u0639\u0627\u0644",
        deactivate: "\u063A\u06CC\u0631\u0641\u0639\u0627\u0644 \u06A9\u0631\u062F\u0646",
        activate: "\u0641\u0639\u0627\u0644 \u06A9\u0631\u062F\u0646",
        // The server refuses this; the client says why BEFORE the click rather
        // than rendering the refusal afterwards.
        cannotDeactivateDefault: "\u0627\u06CC\u0646 \u0634\u0645\u0627\u0631\u0647\u0654 \u067E\u06CC\u0634\u200C\u0641\u0631\u0636 \u0627\u0633\u062A. \u0627\u0628\u062A\u062F\u0627 \u0634\u0645\u0627\u0631\u0647\u0654 \u062F\u06CC\u06AF\u0631\u06CC \u0631\u0627 \u067E\u06CC\u0634\u200C\u0641\u0631\u0636 \u06A9\u0646\u06CC\u062F.",
        notLinkedYet: "\u0647\u0646\u0648\u0632 \u0645\u062A\u0635\u0644 \u0646\u0634\u062F\u0647",
        sendsFrom: "\u0627\u0631\u0633\u0627\u0644 \u0627\u0632",
        rename: "\u062A\u063A\u06CC\u06CC\u0631 \u0646\u0627\u0645",
        perAccountWarmup: "\u0627\u06CC\u0646 \u0634\u0645\u0627\u0631\u0647 \u0628\u0631\u0627\u06CC \u0648\u0627\u062A\u0633\u200C\u0627\u067E \u062A\u0627\u0632\u0647 \u0627\u0633\u062A. \u062D\u062C\u0645 \u0627\u0631\u0633\u0627\u0644 \u0631\u0627 \u0686\u0646\u062F \u0631\u0648\u0632 \u0627\u0648\u0644 \u062A\u062F\u0631\u06CC\u062C\u06CC \u0628\u0627\u0644\u0627 \u0628\u0628\u0631\u06CC\u062F."
    },
    issues: {
        title: "\u0645\u0634\u06A9\u0644\u0627\u062A \u0648 \u0628\u0627\u0632\u062E\u0648\u0631\u062F\u0647\u0627",
        newIssue: "\u062B\u0628\u062A \u0645\u0634\u06A9\u0644",
        issueTitle: "\u0639\u0646\u0648\u0627\u0646",
        description: "\u0634\u0631\u062D",
        kind: "\u0646\u0648\u0639",
        kindProblem: "\u0645\u0634\u06A9\u0644",
        kindCriticism: "\u0627\u0646\u062A\u0642\u0627\u062F",
        kindSuggestion: "\u067E\u06CC\u0634\u0646\u0647\u0627\u062F",
        kindRequest: "\u062F\u0631\u062E\u0648\u0627\u0633\u062A",
        type: "\u062F\u0633\u062A\u0647",
        priority: "\u0627\u0648\u0644\u0648\u06CC\u062A",
        priorityLow: "\u06A9\u0645",
        priorityMedium: "\u0645\u062A\u0648\u0633\u0637",
        priorityHigh: "\u0632\u06CC\u0627\u062F",
        priorityUrgent: "\u0641\u0648\u0631\u06CC",
        status: "\u0648\u0636\u0639\u06CC\u062A",
        statusOpen: "\u0628\u0627\u0632",
        statusInProgress: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0631\u0631\u0633\u06CC",
        statusWaiting: "\u062F\u0631 \u0627\u0646\u062A\u0638\u0627\u0631 \u0645\u062E\u0627\u0637\u0628",
        statusResolved: "\u062D\u0644 \u0634\u062F",
        statusClosed: "\u0628\u0633\u062A\u0647",
        assignee: "\u0645\u0633\u0626\u0648\u0644",
        unassigned: "\u0628\u062F\u0648\u0646 \u0645\u0633\u0626\u0648\u0644",
        assignToMe: "\u0628\u0647 \u0645\u0646 \u0648\u0627\u06AF\u0630\u0627\u0631 \u06A9\u0646",
        reportedAt: "\u062A\u0627\u0631\u06CC\u062E \u062B\u0628\u062A",
        resolution: "\u0646\u062A\u06CC\u062C\u0647",
        resolutionRequired: "\u0628\u0631\u0627\u06CC \xab\u062D\u0644 \u0634\u062F\xbb \u0646\u0648\u0634\u062A\u0646 \u0646\u062A\u06CC\u062C\u0647 \u0627\u0644\u0632\u0627\u0645\u06CC \u0627\u0633\u062A",
        reopenReason: "\u062F\u0644\u06CC\u0644 \u0628\u0627\u0632\u06AF\u0634\u0627\u06CC\u06CC",
        comments: "\u06CC\u0627\u062F\u062F\u0627\u0634\u062A\u200C\u0647\u0627",
        addComment: "\u0627\u0641\u0632\u0648\u062F\u0646 \u06CC\u0627\u062F\u062F\u0627\u0634\u062A",
        internalNote: "\u06CC\u0627\u062F\u062F\u0627\u0634\u062A \u062F\u0627\u062E\u0644\u06CC",
        customerVisible: "\u0642\u0627\u0628\u0644 \u0646\u0645\u0627\u06CC\u0634 \u0628\u0647 \u0645\u062E\u0627\u0637\u0628",
        history: "\u062A\u0627\u0631\u06CC\u062E\u0686\u0647",
        links: "\u067E\u06CC\u0648\u0646\u062F\u0647\u0627",
        orphaned: "\u0645\u062E\u0627\u0637\u0628 \u062D\u0630\u0641 \u0634\u062F\u0647",
        notify: "\u0627\u0637\u0644\u0627\u0639 \u0628\u0647 \u0645\u062E\u0627\u0637\u0628",
        notified: "\u062F\u0631 {date} \u0627\u0637\u0644\u0627\u0639 \u062F\u0627\u062F\u0647 \u0634\u062F",
        notifySent: "\u067E\u06CC\u0627\u0645 \u062F\u0631 \u0635\u0641 \u0627\u0631\u0633\u0627\u0644 \u0642\u0631\u0627\u0631 \u06AF\u0631\u0641\u062A",
        reports: "\u06AF\u0632\u0627\u0631\u0634\u200C\u0647\u0627",
        reportByType: "\u0628\u0631 \u0627\u0633\u0627\u0633 \u062F\u0633\u062A\u0647",
        reportByKind: "\u0628\u0631 \u0627\u0633\u0627\u0633 \u0646\u0648\u0639",
        reportByPriority: "\u0628\u0631 \u0627\u0633\u0627\u0633 \u0627\u0648\u0644\u0648\u06CC\u062A",
        reportByAssignee: "\u0628\u0631 \u0627\u0633\u0627\u0633 \u0645\u0633\u0626\u0648\u0644",
        reportCount: "\u062A\u0639\u062F\u0627\u062F",
        reportMedian: "\u0645\u06CC\u0627\u0646\u0647\u0654 \u0632\u0645\u0627\u0646 \u062D\u0644 (\u0633\u0627\u0639\u062A)",
        reportReopen: "\u0646\u0631\u062E \u0628\u0627\u0632\u06AF\u0634\u0627\u06CC\u06CC",
        reportBucket: "\u0628\u0627\u0632\u0647\u0654 \u0632\u0645\u0627\u0646\u06CC",
        reportMonthly: "\u0645\u0627\u0647\u0627\u0646\u0647",
        reportWeekly: "\u0647\u0641\u062A\u06AF\u06CC",
        reportNone: "\u0628\u062F\u0648\u0646 \u062A\u0641\u06A9\u06CC\u06A9",
        noIssues: "\u0645\u0634\u06A9\u0644\u06CC \u062B\u0628\u062A \u0646\u0634\u062F\u0647",
        urgentUnassigned: "\u0645\u0634\u06A9\u0644 \u0641\u0648\u0631\u06CC \u0628\u062F\u0648\u0646 \u0645\u0633\u0626\u0648\u0644"
    },
    checklists: {
        title: "\u0686\u06A9\u200C\u0644\u06CC\u0633\u062A\u200C\u0647\u0627",
        templates: "\u0627\u0644\u06AF\u0648\u0647\u0627\u06CC \u0686\u06A9\u200C\u0644\u06CC\u0633\u062A",
        newTemplate: "\u0627\u0644\u06AF\u0648\u06CC \u062C\u062F\u06CC\u062F",
        editTemplate: "\u0648\u06CC\u0631\u0627\u06CC\u0634 \u0627\u0644\u06AF\u0648",
        templateTitle: "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u06AF\u0648",
        templateDescription: "\u062A\u0648\u0636\u06CC\u062D",
        items: "\u0645\u0631\u0627\u062D\u0644",
        itemsHint: "\u0647\u0631 \u062E\u0637 \u06CC\u06A9 \u0645\u0631\u062D\u0644\u0647",
        itemsRequired: "\u06CC\u06A9 \u0627\u0644\u06AF\u0648 \u0628\u0627\u06CC\u062F \u062D\u062F\u0627\u0642\u0644 \u06CC\u06A9 \u0645\u0631\u062D\u0644\u0647 \u062F\u0627\u0634\u062A\u0647 \u0628\u0627\u0634\u062F.",
        empty: "\u0647\u0646\u0648\u0632 \u0627\u0644\u06AF\u0648\u06CC\u06CC \u062A\u0639\u0631\u06CC\u0641 \u0646\u0634\u062F\u0647 \u0627\u0633\u062A",
        copyNote: "\u0686\u06A9\u200C\u0644\u06CC\u0633\u062A\u0650 \u0633\u0627\u062E\u062A\u0647\u200C\u0634\u062F\u0647 \u06CC\u06A9 \u06A9\u067E\u06CC \u0627\u0633\u062A\u061B \u0648\u06CC\u0631\u0627\u06CC\u0634 \u0627\u0644\u06AF\u0648\u060C \u0686\u06A9\u200C\u0644\u06CC\u0633\u062A\u200C\u0647\u0627\u06CC \u062F\u0631 \u062C\u0631\u06CC\u0627\u0646 \u0631\u0627 \u062A\u063A\u06CC\u06CC\u0631 \u0646\u0645\u06CC\u200C\u062F\u0647\u062F.",
        addItem: "\u0627\u0641\u0632\u0648\u062F\u0646 \u0645\u0631\u062D\u0644\u0647",
        itemTitle: "\u0639\u0646\u0648\u0627\u0646 \u0645\u0631\u062D\u0644\u0647",
        done: "\u0627\u0646\u062C\u0627\u0645 \u0634\u062F"
    },
    dashboard: {
        title: "\u062F\u0627\u0634\u0628\u0648\u0631\u062F \u0645\u062F\u06CC\u0631\u06CC\u062A",
        subtitle: "\u0647\u0645\u0647\u0654 \u0627\u0639\u062F\u0627\u062F \u0627\u0632 \u06CC\u06A9 \u062A\u0639\u0631\u06CC\u0641 \u0645\u06CC\u200C\u0622\u06CC\u0646\u062F",
        // Presets. «فصل» is Farvardin-Khordad, not January-March: a quarter that
        // started in January would cut Nowruz in half.
        thisMonth: "\u0627\u06CC\u0646 \u0645\u0627\u0647",
        thisQuarter: "\u0641\u0635\u0644 \u062C\u0627\u0631\u06CC",
        thisYear: "\u0633\u0627\u0644 \u062C\u0627\u0631\u06CC",
        last30: "\u06F3\u06F0 \u0631\u0648\u0632 \u0627\u062E\u06CC\u0631",
        custom: "\u0628\u0627\u0632\u0647\u0654 \u062F\u0644\u062E\u0648\u0627\u0647",
        bucket: "\u06AF\u0631\u0648\u0647\u200C\u0628\u0646\u062F\u06CC",
        bucketDay: "\u0631\u0648\u0632\u0627\u0646\u0647",
        bucketWeek: "\u0647\u0641\u062A\u06AF\u06CC",
        bucketMonth: "\u0645\u0627\u0647\u0627\u0646\u0647",
        bucketQuarter: "\u0641\u0635\u0644\u06CC",
        compare: "\u0645\u0642\u0627\u06CC\u0633\u0647 \u0628\u0627 \u062F\u0648\u0631\u0647\u0654 \u0642\u0628\u0644",
        comparedTo: "\u0646\u0633\u0628\u062A \u0628\u0647 \u062F\u0648\u0631\u0647\u0654 \u0642\u0628\u0644",
        refresh: "\u0628\u0647\u200C\u0631\u0648\u0632\u0631\u0633\u0627\u0646\u06CC",
        previousPeriod: "\u062F\u0648\u0631\u0647\u0654 \u0642\u0628\u0644",
        nextPeriod: "\u062F\u0648\u0631\u0647\u0654 \u0628\u0639\u062F",
        sections: {
            funnel: "\u0642\u06CC\u0641 \u0641\u0631\u0648\u0634 \u0648 \u0645\u0648\u0641\u0642\u06CC\u062A",
            failure: "\u0639\u0648\u0627\u0645\u0644 \u0639\u062F\u0645 \u0645\u0648\u0641\u0642\u06CC\u062A",
            market: "\u0634\u0627\u062E\u0635\u200C\u0647\u0627\u06CC \u0628\u0627\u0632\u0627\u0631",
            team: "\u062A\u06CC\u0645 \u0648 \u0639\u0645\u0644\u06CC\u0627\u062A"
        },
        // The ⓘ. Every word of it comes from ListMetricDefinitions.
        definition: "\u062A\u0639\u0631\u06CC\u0641",
        formula: "\u0641\u0631\u0645\u0648\u0644",
        grain: "\u062F\u0627\u0646\u0647\u200C\u0628\u0646\u062F\u06CC",
        sources: "\u0645\u0646\u0627\u0628\u0639",
        caveat: "\u0646\u06A9\u062A\u0647\u0654 \u0645\u0647\u0645",
        // Badged on the card, so a number resting on an unconfirmed assumption
        // says so on the SCREEN and not only in a document nobody opens twice.
        needsConfirmation: "\u0646\u06CC\u0627\u0632\u0645\u0646\u062F \u062A\u0623\u06CC\u06CC\u062F \u0630\u06CC\u200C\u0646\u0641\u0639\u0627\u0646",
        needsConfirmationHint: "\u0627\u06CC\u0646 \u0633\u0646\u062C\u0647 \u0628\u0631 \u062A\u0635\u0645\u06CC\u0645\u06CC \u0627\u0633\u062A\u0648\u0627\u0631 \u0627\u0633\u062A \u06A9\u0647 \u0647\u0646\u0648\u0632 \u0628\u0627 \u0630\u06CC\u200C\u0646\u0641\u0639\u0627\u0646 \u0646\u0647\u0627\u06CC\u06CC \u0646\u0634\u062F\u0647. \u067E\u06CC\u0634 \u0627\u0632 \u0627\u0633\u062A\u0646\u0627\u062F\u060C \u062A\u0639\u0631\u06CC\u0641 \u0631\u0627 \u062F\u0631 docs/kpi-catalogue.md \u0628\u062E\u0648\u0627\u0646\u06CC\u062F.",
        // The FIVE conventions every number on this screen rests on. They are
        // flagged CONFIRM in docs/kpi-catalogue.md exactly like the seven
        // per-metric assumptions are — but they belong to no single metric, so
        // without this they would be the only unconfirmed decisions that never
        // reached the screen. A reader comparing «نسبت به دورهٔ قبل» has no way to
        // know what "the previous period" was chosen to mean.
        conventions: "\u0642\u0631\u0627\u0631\u062F\u0627\u062F\u0647\u0627\u06CC \u0645\u062D\u0627\u0633\u0628\u0647",
        conventionsHint: "\u0647\u0645\u0647\u0654 \u0627\u0639\u062F\u0627\u062F \u0627\u06CC\u0646 \u0635\u0641\u062D\u0647 \u0628\u0631 \u0627\u06CC\u0646 \u067E\u0646\u062C \u062A\u0635\u0645\u06CC\u0645 \u0627\u0633\u062A\u0648\u0627\u0631\u0646\u062F.",
        conventionsList: [
            "\u062A\u0627\u0631\u06CC\u062E\u200C\u0647\u0627 \u0634\u0645\u0633\u06CC\u200C\u0627\u0646\u062F \u0648 \u062F\u0631 \u0645\u0646\u0637\u0642\u0647\u0654 \u0632\u0645\u0627\u0646\u06CC \u062A\u0647\u0631\u0627\u0646 \u06AF\u0631\u0648\u0647\u200C\u0628\u0646\u062F\u06CC \u0645\u06CC\u200C\u0634\u0648\u0646\u062F.",
            "\xab\u062F\u0648\u0631\u0647\u0654 \u0642\u0628\u0644\xbb \u0628\u0627\u0632\u0647\u200C\u0627\u06CC \u0647\u0645\u200C\u0627\u0646\u062F\u0627\u0632\u0647 \u0648 \u0628\u0644\u0627\u0641\u0627\u0635\u0644\u0647 \u067E\u06CC\u0634 \u0627\u0632 \u0628\u0627\u0632\u0647\u0654 \u0627\u0646\u062A\u062E\u0627\u0628\u06CC \u0627\u0633\u062A.",
            "\u0634\u0645\u0627\u0631\u0634 \u0648\u0636\u0639\u06CC\u062A \u0641\u0639\u0644\u06CC\u060C \u0645\u062E\u0627\u0637\u0628\u06CC\u0646 \u062D\u0630\u0641\u200C\u0634\u062F\u0647 \u0631\u0627 \u062F\u0631 \u0628\u0631 \u0646\u0645\u06CC\u200C\u06AF\u06CC\u0631\u062F.",
            "\u0627\u0646\u062A\u0633\u0627\u0628 \u0628\u0647 \u06A9\u0627\u0631\u0628\u0631 \u0628\u0631 \u067E\u0627\u06CC\u0647\u0654 \u0622\u062E\u0631\u06CC\u0646 \u062A\u0639\u0627\u0645\u0644 \u067E\u06CC\u0634 \u0627\u0632 \u062A\u063A\u06CC\u06CC\u0631 \u0627\u0633\u062A.",
            "\u0646\u0631\u062E\u200C\u0647\u0627\u06CC\u06CC \u0628\u0627 \u0645\u062E\u0631\u062C \u06A9\u0645\u062A\u0631 \u0627\u0632 \u062D\u062F \u06A9\u0645\u06CC\u0646\u0647 \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0646\u0645\u06CC\u200C\u0634\u0648\u0646\u062F."
        ],
        conventionsSource: 'docs/kpi-catalogue.md',
        suppressed: "\u0646\u0645\u0648\u0646\u0647 \u0628\u0631\u0627\u06CC \u0645\u062D\u0627\u0633\u0628\u0647 \u06A9\u0627\u0641\u06CC \u0646\u06CC\u0633\u062A",
        suppressedHint: "\u0646\u0631\u062E\u200C\u0647\u0627\u06CC\u06CC \u06A9\u0647 \u0645\u062E\u0631\u062C\u0634\u0627\u0646 \u0627\u0632 \u062D\u062F \u06A9\u0645\u06CC\u0646\u0647 \u06A9\u0645\u062A\u0631 \u0628\u0627\u0634\u062F \u0646\u0645\u0627\u06CC\u0634 \u062F\u0627\u062F\u0647 \u0646\u0645\u06CC\u200C\u0634\u0648\u0646\u062F. \xab\u06F1\u06F0\u06F0\u066A\xbb \u0627\u0632 \u06CC\u06A9 \u0645\u062E\u0627\u0637\u0628 \u0628\u062F\u062A\u0631 \u0627\u0632 \u0646\u0628\u0648\u062F\u0646 \u0639\u062F\u062F \u0627\u0633\u062A \u2014 \u0646\u0642\u0644 \u0645\u06CC\u200C\u0634\u0648\u062F.",
        immature: "\u0647\u0646\u0648\u0632 \u0628\u0647 \u0628\u0644\u0648\u063A \u0646\u0631\u0633\u06CC\u062F\u0647",
        noData: "\u062F\u0627\u062F\u0647\u200C\u0627\u06CC \u062F\u0631 \u0627\u06CC\u0646 \u0628\u0627\u0632\u0647 \u0646\u06CC\u0633\u062A",
        metricFailed: "\u0627\u06CC\u0646 \u0633\u0646\u062C\u0647 \u0645\u062D\u0627\u0633\u0628\u0647 \u0646\u0634\u062F",
        drillDown: "\u0645\u0634\u0627\u0647\u062F\u0647\u0654 \u0641\u0647\u0631\u0633\u062A",
        drillDownTitle: "\u0645\u062E\u0627\u0637\u0628\u06CC\u0646 \u0627\u06CC\u0646 \u0639\u062F\u062F",
        drillDownEmpty: "\u0645\u062E\u0627\u0637\u0628\u06CC \u062F\u0631 \u0627\u06CC\u0646 \u06AF\u0631\u0648\u0647 \u0646\u06CC\u0633\u062A",
        showing: "\u0646\u0645\u0627\u06CC\u0634",
        of: "\u0627\u0632",
        cohortTable: "\u062C\u062F\u0648\u0644 \u06A9\u0648\u0647\u0648\u0631\u062A",
        cohortMonth: "\u0645\u0627\u0647 \u0648\u0631\u0648\u062F",
        cohortSize: "\u062A\u0639\u062F\u0627\u062F",
        trendView: "\u0631\u0648\u0646\u062F",
        staleWarning: "\u062F\u0627\u062F\u0647\u200C\u0647\u0627\u06CC \u062A\u062D\u0644\u06CC\u0644\u06CC \u0639\u0642\u0628 \u0627\u0633\u062A\u061B \u0627\u0639\u062F\u0627\u062F \u0627\u06CC\u0646 \u0635\u0641\u062D\u0647 \u0648\u0636\u0639\u06CC\u062A \u0641\u0639\u0644\u06CC \u0631\u0627 \u0646\u0634\u0627\u0646 \u0646\u0645\u06CC\u200C\u062F\u0647\u0646\u062F."
    },
    ops: {
        title: "\u0633\u0644\u0627\u0645\u062A \u0633\u0627\u0645\u0627\u0646\u0647",
        details: "\u062C\u0632\u0626\u06CC\u0627\u062A",
        sandbox: "\u0622\u0632\u0645\u0627\u06CC\u0634\u06CC",
        live: "\u0645\u062A\u0635\u0644",
        services: "\u0633\u0631\u0648\u06CC\u0633\u200C\u0647\u0627",
        healthy: "\u0633\u0627\u0644\u0645",
        unhealthy: "\u062F\u0631 \u062F\u0633\u062A\u0631\u0633 \u0646\u06CC\u0633\u062A",
        latency: "\u062A\u0623\u062E\u06CC\u0631 \u067E\u0627\u0633\u062E",
        address: "\u0646\u0634\u0627\u0646\u06CC",
        lag: "\u062A\u0623\u062E\u06CC\u0631 \u062F\u0627\u062F\u0647",
        ingest: "\u062F\u0631\u06CC\u0627\u0641\u062A \u0631\u0648\u06CC\u062F\u0627\u062F",
        exchange: "\u0635\u0641",
        applied: "\u0627\u0639\u0645\u0627\u0644\u200C\u0634\u062F\u0647",
        unknown: "\u0646\u0627\u0634\u0646\u0627\u062E\u062A\u0647",
        unknownHint: "\u0631\u0648\u06CC\u062F\u0627\u062F\u0647\u0627\u06CC\u06CC \u06A9\u0647 \u0627\u06CC\u0646 \u0633\u0631\u0648\u06CC\u0633 \u0646\u0645\u06CC\u200C\u0634\u0646\u0627\u0633\u062F. \u0631\u0634\u062F \u0627\u06CC\u0646 \u0639\u062F\u062F \u06CC\u0639\u0646\u06CC \u0633\u0631\u0648\u06CC\u0633\u06CC \u0631\u0648\u06CC\u062F\u0627\u062F \u062A\u0627\u0632\u0647\u200C\u0627\u06CC \u0645\u0646\u062A\u0634\u0631 \u0645\u06CC\u200C\u06A9\u0646\u062F \u06A9\u0647 \u06A9\u0633\u06CC \u0645\u0635\u0631\u0641 \u0646\u0645\u06CC\u200C\u06A9\u0646\u062F.",
        projections: "\u067E\u0631\u0648\u062C\u06A9\u0634\u0646\u200C\u0647\u0627",
        recipients: "\u06AF\u06CC\u0631\u0646\u062F\u06AF\u0627\u0646",
        templates: "\u0642\u0627\u0644\u0628\u200C\u0647\u0627",
        whatsapp: "\u0648\u0627\u062A\u0633\u200C\u0627\u067E",
        rebuild: "\u0628\u0627\u0632\u0633\u0627\u0632\u06CC \u062F\u0627\u062F\u0647\u200C\u0647\u0627\u06CC \u062A\u062D\u0644\u06CC\u0644\u06CC",
        rebuildRunning: "\u0628\u0627\u0632\u0633\u0627\u0632\u06CC \u062F\u0631 \u062C\u0631\u06CC\u0627\u0646 \u0627\u0633\u062A",
        rebuildWarning: "\u062C\u062F\u0648\u0644\u200C\u0647\u0627\u06CC \u062A\u062D\u0644\u06CC\u0644\u06CC \u062E\u0627\u0644\u06CC \u0645\u06CC\u200C\u0634\u0648\u0646\u062F \u0648 \u0627\u0632 \u0646\u0648 \u0633\u0627\u062E\u062A\u0647 \u0645\u06CC\u200C\u0634\u0648\u0646\u062F. \u062A\u0627 \u067E\u0627\u06CC\u0627\u0646 \u06A9\u0627\u0631 \u062F\u0627\u0634\u0628\u0648\u0631\u062F \u0635\u0641\u0631 \u0646\u0634\u0627\u0646 \u0645\u06CC\u200C\u062F\u0647\u062F. \u0639\u0645\u0644\u06CC\u0627\u062A \u062F\u06CC\u06AF\u0631\u06CC \u0645\u062E\u062A\u0644 \u0646\u0645\u06CC\u200C\u0634\u0648\u062F.",
        rebuildConfirm: "\u0628\u0627\u0632\u0633\u0627\u0632\u06CC \u06A9\u0646",
        rebuildDone: "\u0628\u0627\u0632\u0633\u0627\u0632\u06CC \u0627\u0646\u062C\u0627\u0645 \u0634\u062F",
        rebuildPartial: "\u0628\u0627\u0632\u0633\u0627\u0632\u06CC \u0646\u0627\u0642\u0635 \u0645\u0627\u0646\u062F. \u0645\u062F\u0644 \u062E\u0648\u0627\u0646\u062F\u0646\u06CC \u0646\u06CC\u0645\u0647\u200C\u06A9\u0627\u0631\u0647 \u0627\u0633\u062A \u0648 \u0627\u062C\u0631\u0627\u06CC \u062F\u0648\u0628\u0627\u0631\u0647 \u0628\u06CC\u200C\u062E\u0637\u0631 \u0627\u0633\u062A.",
        replayed: "\u0631\u0648\u06CC\u062F\u0627\u062F\u0647\u0627\u06CC \u0628\u0627\u0632\u067E\u062E\u0634\u200C\u0634\u062F\u0647",
        audit: "\u06AF\u0632\u0627\u0631\u0634 \u0645\u0645\u06CC\u0632\u06CC",
        auditActor: "\u06A9\u0627\u0631\u0628\u0631",
        auditAction: "\u0639\u0645\u0644",
        auditEntity: "\u0645\u0648\u062C\u0648\u062F\u06CC\u062A",
        auditWhen: "\u0632\u0645\u0627\u0646",
        auditService: "\u0633\u0631\u0648\u06CC\u0633",
        auditEmpty: "\u0631\u06A9\u0648\u0631\u062F\u06CC \u06CC\u0627\u0641\u062A \u0646\u0634\u062F",
        auditFilterActor: "\u0641\u06CC\u0644\u062A\u0631 \u0628\u0631 \u0627\u0633\u0627\u0633 \u06A9\u0627\u0631\u0628\u0631",
        auditExport: "\u062E\u0631\u0648\u062C\u06CC CSV",
        checkedAt: "\u0622\u062E\u0631\u06CC\u0646 \u0628\u0631\u0631\u0633\u06CC"
    },
    // The two mobile reductions (CLAUDE.md §12). Everything else renders the
    // desktop layout on a phone, unchanged.
    mobile: {
        call: "\u062A\u0645\u0627\u0633 \u0628\u0627",
        whatsapp: "\u0648\u0627\u062A\u0633\u200C\u0627\u067E",
        // Shown once on a phone, so the rep knows the rest of the app is there.
        desktopHint: "\u0628\u0642\u06CC\u0647\u0654 \u0628\u062E\u0634\u200C\u0647\u0627 \u0631\u0648\u06CC \u0646\u0645\u0627\u06CC\u0634\u06AF\u0631 \u0628\u0632\u0631\u06AF\u200C\u062A\u0631 \u0628\u0647\u062A\u0631 \u06A9\u0627\u0631 \u0645\u06CC\u200C\u06A9\u0646\u0646\u062F."
    },
    erasure: {
        action: "\u062D\u0630\u0641 \u06A9\u0627\u0645\u0644 \u0648 \u0628\u06CC\u200C\u0646\u0627\u0645\u200C\u0633\u0627\u0632\u06CC",
        // Two steps, because this cannot be undone and it reaches four services.
        step1Title: "\u062D\u0630\u0641 \u06A9\u0627\u0645\u0644 \u0627\u0637\u0644\u0627\u0639\u0627\u062A \u0627\u06CC\u0646 \u0645\u062E\u0627\u0637\u0628\u061F",
        step1Body: "\u0627\u06CC\u0646 \u06A9\u0627\u0631 \u0628\u0631\u06AF\u0634\u062A\u200C\u0646\u0627\u067E\u0630\u06CC\u0631 \u0627\u0633\u062A. \u0646\u0627\u0645\u060C \u0634\u0645\u0627\u0631\u0647\u0654 \u062A\u0645\u0627\u0633\u060C \u0646\u0634\u0627\u0646\u06CC\u060C \u062A\u0627\u0631\u06CC\u062E \u062A\u0648\u0644\u062F \u0648 \u0645\u062A\u0646 \u062A\u0639\u0627\u0645\u0644\u200C\u0647\u0627 \u0628\u0631\u0627\u06CC \u0647\u0645\u06CC\u0634\u0647 \u067E\u0627\u06A9 \u0645\u06CC\u200C\u0634\u0648\u0646\u062F. \u0633\u0637\u0631 \u0645\u062E\u0627\u0637\u0628 \u0628\u0627\u0642\u06CC \u0645\u06CC\u200C\u0645\u0627\u0646\u062F \u062A\u0627 \u062A\u0627\u0631\u06CC\u062E\u0686\u0647\u200C\u0627\u06CC \u06A9\u0647 \u0628\u0647 \u0622\u0646 \u0627\u0634\u0627\u0631\u0647 \u062F\u0627\u0631\u062F \u0646\u0634\u06A9\u0646\u062F.",
        step1Fields: "\u0641\u06CC\u0644\u062F\u0647\u0627\u06CC\u06CC \u06A9\u0647 \u067E\u0627\u06A9 \u0645\u06CC\u200C\u0634\u0648\u0646\u062F",
        step1Services: "\u0633\u0631\u0648\u06CC\u0633\u200C\u0647\u0627\u06CC\u06CC \u06A9\u0647 \u062A\u063A\u06CC\u06CC\u0631 \u0645\u06CC\u200C\u06A9\u0646\u0646\u062F",
        step2Title: "\u0628\u0631\u0627\u06CC \u062A\u0623\u06CC\u06CC\u062F\u060C \u0646\u0627\u0645 \u062E\u0627\u0646\u0648\u0627\u062F\u06AF\u06CC \u0645\u062E\u0627\u0637\u0628 \u0631\u0627 \u0628\u0646\u0648\u06CC\u0633\u06CC\u062F",
        step2Hint: "\u0627\u06CC\u0646 \u0622\u062E\u0631\u06CC\u0646 \u0641\u0631\u0635\u062A \u0628\u0631\u0627\u06CC \u0627\u0646\u0635\u0631\u0627\u0641 \u0627\u0633\u062A.",
        back: "\u0628\u0627\u0632\u06AF\u0634\u062A",
        reason: "\u062F\u0644\u06CC\u0644 \u062F\u0631\u062E\u0648\u0627\u0633\u062A",
        reasonHint: "\u062F\u0631 \u06AF\u0632\u0627\u0631\u0634 \u0645\u0645\u06CC\u0632\u06CC \u062B\u0628\u062A \u0645\u06CC\u200C\u0634\u0648\u062F. \u0645\u0642\u0627\u062F\u06CC\u0631 \u067E\u0627\u06A9\u200C\u0634\u062F\u0647 \u062B\u0628\u062A \u0646\u0645\u06CC\u200C\u0634\u0648\u0646\u062F.",
        confirm: "\u062D\u0630\u0641 \u06A9\u0627\u0645\u0644",
        cancel: "\u0627\u0646\u0635\u0631\u0627\u0641",
        done: "\u0627\u0637\u0644\u0627\u0639\u0627\u062A \u0627\u06CC\u0646 \u0645\u062E\u0627\u0637\u0628 \u067E\u0627\u06A9 \u0634\u062F",
        mismatch: "\u0646\u0627\u0645 \u0648\u0627\u0631\u062F \u0634\u062F\u0647 \u0628\u0627 \u0646\u0627\u0645 \u0645\u062E\u0627\u0637\u0628 \u06CC\u06A9\u06CC \u0646\u06CC\u0633\u062A",
        onlyDeleted: "\u0641\u0642\u0637 \u0645\u062E\u0627\u0637\u0628\u06CC \u06A9\u0647 \u067E\u06CC\u0634\u200C\u062A\u0631 \u062D\u0630\u0641 (\u0646\u0631\u0645) \u0634\u062F\u0647 \u0628\u0627\u0634\u062F \u0631\u0627 \u0645\u06CC\u200C\u062A\u0648\u0627\u0646 \u06A9\u0627\u0645\u0644 \u067E\u0627\u06A9 \u06A9\u0631\u062F."
    }
};


function $147a9706b8db1779$export$cb2942e573a81e39() {
    const [dismissed, setDismissed] = (0, $3OyDL.useState)(()=>new Set());
    // A fixed `since` per mount rather than a moving window: a value recomputed
    // on every render would change the query variables every render and poll in
    // a loop.
    const since = (0, $3OyDL.useMemo)(()=>new Date(Date.now() - 43200000).toISOString(), []);
    const { data: data } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$292885ccfb78e1d8), {
        variables: {
            since: since
        },
        pollInterval: (0, $370d2fd34ead4cb4$export$a66f137be64912c3),
        fetchPolicy: 'cache-and-network',
        // A failing poll must not take the shell down with it.
        errorPolicy: 'ignore'
    });
    // Step 5: urgent issues nobody has taken, on the same poll. See
    // URGENT_ISSUES_QUERY for why this is a query rather than the event the
    // feedback service emits.
    const { data: urgentData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $047171b3f4119885$export$ae597b5e85500ea1), {
        pollInterval: (0, $370d2fd34ead4cb4$export$a66f137be64912c3),
        errorPolicy: 'ignore'
    });
    const items = (data?.dueReminders ?? []).filter((entry)=>!dismissed.has(entry.reminder.id));
    const urgent = (urgentData?.issues?.items ?? []).filter((issue)=>!dismissed.has(issue.id));
    if (items.length === 0 && urgent.length === 0) return null;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("aside", {
        className: "flex flex-col gap-1 border-t border-border bg-surface p-3",
        "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).reminders.title,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex items-center gap-2 text-xs font-medium text-text-muted",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $85349ebe33ede3d6$export$2e2bcd8739ae039), {
                        size: 13,
                        "aria-hidden": "true"
                    }),
                    (0, $d916753b57975e04$export$25ce5a424b770e84).reminders.title,
                    /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                        type: "button",
                        className: "ms-auto hover:text-text",
                        onClick: ()=>setDismissed(new Set([
                                ...items.map((i)=>i.reminder.id),
                                ...urgent.map((i)=>i.id)
                            ])),
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).reminders.dismissAll
                    })
                ]
            }),
            items.map(({ reminder: reminder, activity: activity })=>/*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                    className: "flex items-start gap-2 rounded border border-border px-2 py-1",
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $8B9Zg.Link), {
                            to: "/calendar",
                            className: "flex flex-1 flex-col text-xs leading-tight hover:text-primary",
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                    className: "truncate font-medium",
                                    children: activity.title
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                    className: "text-text-muted",
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                            dir: "ltr",
                                            children: (0, $d4d460d3ffb6daab$export$3203edd9e5edd663)(activity.startsAt)
                                        }),
                                        activity.contact?.displayName ? ` \xb7 ${activity.contact.displayName}` : ''
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                            type: "button",
                            "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).reminders.dismiss,
                            onClick: ()=>setDismissed((current)=>new Set(current).add(reminder.id)),
                            className: "text-text-muted hover:text-text",
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $bi4P4.default), {
                                size: 13,
                                "aria-hidden": "true"
                            })
                        })
                    ]
                }, reminder.id)),
            urgent.map((issue)=>/*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                    className: "flex items-start gap-2 rounded border border-danger px-2 py-1",
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $8B9Zg.Link), {
                            to: `/issues/${issue.id}`,
                            className: "flex flex-1 flex-col text-xs leading-tight hover:text-primary",
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                    className: "flex items-center gap-1 truncate font-medium text-danger",
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6tkl0.default), {
                                            size: 11,
                                            "aria-hidden": "true"
                                        }),
                                        issue.title
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                    className: "text-text-muted",
                                    children: [
                                        (0, $d916753b57975e04$export$25ce5a424b770e84).issues.urgentUnassigned,
                                        issue.contact?.displayName ? ` \xb7 ${issue.contact.displayName}` : ''
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                            type: "button",
                            "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).reminders.dismiss,
                            onClick: ()=>setDismissed((current)=>new Set(current).add(issue.id)),
                            className: "text-text-muted hover:text-text",
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $bi4P4.default), {
                                size: 13,
                                "aria-hidden": "true"
                            })
                        })
                    ]
                }, issue.id))
        ]
    });
}


/**
 * OIDC Authorization Code + PKCE against Keycloak.
 *
 * Tokens live in memory only — never localStorage/sessionStorage, so an XSS
 * cannot read them and closing the tab ends the client-side session. The cost
 * is that a hard reload has nothing to restore, which is why the app opens with
 * a `prompt=none` attempt: if Keycloak still has an SSO session, that returns a
 * fresh code with no user interaction; if not, it returns `login_required` and
 * we show the sign-in screen.
 *
 * The refresh token (also in memory) drives a timer that renews the access
 * token before it expires, so a working session never blinks.
 */ 
var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");
/**
 * Runtime configuration, resolved once at module load.
 *
 * `window.__ENV__` is written by docker-entrypoint.sh at CONTAINER START from
 * the Deployment's env, so ONE image serves beta1 and production (plan §6.3).
 * The bundle used to have these inlined by Parcel at build time, which made a
 * different environment a different image. `process.env.*` remains the
 * fallback for a local `npm start`, where there is no entrypoint.
 *
 * The platform bundle at /platform reads the SAME env.js
 * (src/platform/lib/runtimeEnv.js): one BFF, one Keycloak client, one
 * environment label for the whole app.
 *
 * Every read is a STATIC `process.env.NAME`: Parcel inlines only those.
 */ const $b5d41e4dbaeacaa2$var$runtime = typeof window !== 'undefined' && window.__ENV__ || {};
const $b5d41e4dbaeacaa2$export$daa4d85031700d6a = $b5d41e4dbaeacaa2$var$runtime.MESHHUB_GRAPHQL_URL || undefined || 'http://localhost:4003/graphql';
const $b5d41e4dbaeacaa2$export$4dc6837bb3c0882f = String($b5d41e4dbaeacaa2$export$daa4d85031700d6a).replace(/\/graphql\/?$/, '').replace(/\/+$/, '');
const $b5d41e4dbaeacaa2$export$724d0d6262f49f68 = String($b5d41e4dbaeacaa2$var$runtime.MESHHUB_OIDC_ISSUER || undefined || 'https://sso.itechtrade.ir/realms/meshhub').replace(/\/+$/, '');
const $b5d41e4dbaeacaa2$export$562652d22cadfa6b = $b5d41e4dbaeacaa2$var$runtime.MESHHUB_OIDC_CLIENT_ID || undefined || 'meshhub-admin-web';
const $b5d41e4dbaeacaa2$export$4d026e62d5555bff = $b5d41e4dbaeacaa2$var$runtime.MESHHUB_KEYCLOAK_ADMIN_URL || undefined || 'https://sso.itechtrade.ir/admin/master/console/#/meshhub/users';
const $b5d41e4dbaeacaa2$export$d83c88e8fa34151c = $b5d41e4dbaeacaa2$var$runtime.PARSINA_ENV || undefined || 'local';
const $b5d41e4dbaeacaa2$export$afb6a0a1b7d83935 = '/platform/';


const $f0578ea5f18e5637$var$AuthContext = /*#__PURE__*/ (0, $3OyDL.createContext)(null);
const $f0578ea5f18e5637$var$config = {
    issuer: (0, $b5d41e4dbaeacaa2$export$724d0d6262f49f68),
    clientId: (0, $b5d41e4dbaeacaa2$export$562652d22cadfa6b),
    // The app root, derived — not configured: the platform bundle beside this one
    // returns to /platform/, and each environment's origin is simply where it is
    // served. (MESHHUB_OIDC_REDIRECT_URI used to be baked in at build time.)
    redirectUri: `${window.location.origin}/`
};
const $f0578ea5f18e5637$var$endpoints = {
    authorize: `${$f0578ea5f18e5637$var$config.issuer}/protocol/openid-connect/auth`,
    token: `${$f0578ea5f18e5637$var$config.issuer}/protocol/openid-connect/token`,
    logout: `${$f0578ea5f18e5637$var$config.issuer}/protocol/openid-connect/logout`
};
/** PKCE lives in sessionStorage only between the redirect and the callback. */ const $f0578ea5f18e5637$var$PKCE_KEY = 'meshhub.pkce';
const $f0578ea5f18e5637$var$SILENT_ATTEMPTED_KEY = 'meshhub.silentAttempted';
/**
 * Keycloak always returns to the registered redirect URI ("/"), so the path the
 * user actually asked for has to be carried across the round trip ourselves —
 * otherwise every deep link silently becomes the home page.
 */ const $f0578ea5f18e5637$var$RETURN_TO_KEY = 'meshhub.returnTo';
function $f0578ea5f18e5637$var$randomString(bytes = 32) {
    const buffer = new Uint8Array(bytes);
    crypto.getRandomValues(buffer);
    return $f0578ea5f18e5637$var$base64Url(buffer);
}
function $f0578ea5f18e5637$var$base64Url(buffer) {
    return btoa(String.fromCharCode(...new Uint8Array(buffer))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
async function $f0578ea5f18e5637$var$challengeFor(verifier) {
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
    return $f0578ea5f18e5637$var$base64Url(digest);
}
async function $f0578ea5f18e5637$var$beginLogin({ silent: silent }) {
    const verifier = $f0578ea5f18e5637$var$randomString();
    const state = $f0578ea5f18e5637$var$randomString(16);
    sessionStorage.setItem($f0578ea5f18e5637$var$PKCE_KEY, JSON.stringify({
        verifier: verifier,
        state: state
    }));
    sessionStorage.setItem($f0578ea5f18e5637$var$RETURN_TO_KEY, window.location.pathname + window.location.search);
    const params = new URLSearchParams({
        client_id: $f0578ea5f18e5637$var$config.clientId,
        redirect_uri: $f0578ea5f18e5637$var$config.redirectUri,
        response_type: 'code',
        scope: 'openid profile email',
        state: state,
        code_challenge: await $f0578ea5f18e5637$var$challengeFor(verifier),
        code_challenge_method: 'S256'
    });
    // prompt=none asks Keycloak to reuse an existing SSO session or fail fast,
    // which is what makes a hard reload seamless without storing tokens.
    if (silent) params.set('prompt', 'none');
    window.location.assign(`${$f0578ea5f18e5637$var$endpoints.authorize}?${params}`);
}
async function $f0578ea5f18e5637$var$exchangeCode(code, verifier) {
    const response = await fetch($f0578ea5f18e5637$var$endpoints.token, {
        method: 'POST',
        headers: {
            'content-type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
            grant_type: 'authorization_code',
            client_id: $f0578ea5f18e5637$var$config.clientId,
            redirect_uri: $f0578ea5f18e5637$var$config.redirectUri,
            code: code,
            code_verifier: verifier
        })
    });
    if (!response.ok) throw new Error(`token exchange failed: ${response.status}`);
    return response.json();
}
async function $f0578ea5f18e5637$var$refreshTokens(refreshToken) {
    const response = await fetch($f0578ea5f18e5637$var$endpoints.token, {
        method: 'POST',
        headers: {
            'content-type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
            grant_type: 'refresh_token',
            client_id: $f0578ea5f18e5637$var$config.clientId,
            refresh_token: refreshToken
        })
    });
    if (!response.ok) throw new Error(`refresh failed: ${response.status}`);
    return response.json();
}
/** Decode a JWT payload for display only — the BFF does the real verification. */ function $f0578ea5f18e5637$var$readClaims(accessToken) {
    try {
        const payload = accessToken.split('.')[1];
        const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
        return JSON.parse(decodeURIComponent(escape(json)));
    } catch  {
        return {};
    }
}
/** Module-level so the Apollo link can read it without a React render. */ let $f0578ea5f18e5637$var$currentAccessToken = null;
const $f0578ea5f18e5637$export$84773cc9bf7dbe87 = ()=>$f0578ea5f18e5637$var$currentAccessToken;
/**
 * The OIDC callback must be handled exactly once per page load, and the
 * authorization code and PKCE verifier are both single-use. StrictMode invokes
 * effects twice in development, which would consume the verifier on the first
 * pass and then fail on the second — so the guard lives at module scope, where
 * "once per page load" is actually true, rather than in component state.
 */ let $f0578ea5f18e5637$var$bootstrapStarted = false;
function $f0578ea5f18e5637$export$87091915187a1a85({ children: children }) {
    const [status, setStatus] = (0, $3OyDL.useState)('loading'); // loading | anonymous | authenticated
    const [claims, setClaims] = (0, $3OyDL.useState)(null);
    const [error, setError] = (0, $3OyDL.useState)(null);
    const refreshTokenRef = (0, $3OyDL.useRef)(null);
    const timerRef = (0, $3OyDL.useRef)(null);
    const applyTokens = (0, $3OyDL.useCallback)((tokens)=>{
        $f0578ea5f18e5637$var$currentAccessToken = tokens.access_token;
        refreshTokenRef.current = tokens.refresh_token ?? refreshTokenRef.current;
        setClaims($f0578ea5f18e5637$var$readClaims(tokens.access_token));
        setStatus('authenticated');
        // Renew a little early so an in-flight request never carries a dead token.
        clearTimeout(timerRef.current);
        const lifetimeMs = Math.max((tokens.expires_in ?? 300) - 30, 30) * 1000;
        timerRef.current = setTimeout(async ()=>{
            try {
                applyTokens(await $f0578ea5f18e5637$var$refreshTokens(refreshTokenRef.current));
            } catch  {
                // The refresh token expired or was revoked: fall back to a silent
                // attempt, which either restores the session or shows the login screen.
                $f0578ea5f18e5637$var$currentAccessToken = null;
                sessionStorage.removeItem($f0578ea5f18e5637$var$SILENT_ATTEMPTED_KEY);
                $f0578ea5f18e5637$var$beginLogin({
                    silent: true
                });
            }
        }, lifetimeMs);
    }, []);
    (0, $3OyDL.useEffect)(()=>{
        if ($f0578ea5f18e5637$var$bootstrapStarted) return undefined;
        $f0578ea5f18e5637$var$bootstrapStarted = true;
        async function bootstrap() {
            const url = new URL(window.location.href);
            const code = url.searchParams.get('code');
            const returnedState = url.searchParams.get('state');
            const oidcError = url.searchParams.get('error');
            // --- returning from Keycloak ---
            if (code || oidcError) {
                const stored = JSON.parse(sessionStorage.getItem($f0578ea5f18e5637$var$PKCE_KEY) || 'null');
                sessionStorage.removeItem($f0578ea5f18e5637$var$PKCE_KEY);
                // Strip the OIDC parameters and restore the path that was asked for,
                // before the router mounts and reads the location.
                const returnTo = sessionStorage.getItem($f0578ea5f18e5637$var$RETURN_TO_KEY) || url.pathname;
                sessionStorage.removeItem($f0578ea5f18e5637$var$RETURN_TO_KEY);
                window.history.replaceState({}, '', returnTo);
                if (oidcError) {
                    // login_required is the expected answer to prompt=none for someone
                    // with no SSO session — not an error worth showing.
                    if (oidcError !== 'login_required' && oidcError !== 'interaction_required') setError(url.searchParams.get('error_description') || oidcError);
                    setStatus('anonymous');
                    return;
                }
                if (!stored || stored.state !== returnedState) {
                    setError("\u067E\u0627\u0633\u062E \u0648\u0631\u0648\u062F \u0645\u0639\u062A\u0628\u0631 \u0646\u0628\u0648\u062F. \u062F\u0648\u0628\u0627\u0631\u0647 \u062A\u0644\u0627\u0634 \u06A9\u0646\u06CC\u062F.");
                    setStatus('anonymous');
                    return;
                }
                try {
                    applyTokens(await $f0578ea5f18e5637$var$exchangeCode(code, stored.verifier));
                } catch (err) {
                    setError(err.message);
                    setStatus('anonymous');
                }
                return;
            }
            // --- fresh load: try to reuse an existing Keycloak SSO session once ---
            if (!sessionStorage.getItem($f0578ea5f18e5637$var$SILENT_ATTEMPTED_KEY)) {
                sessionStorage.setItem($f0578ea5f18e5637$var$SILENT_ATTEMPTED_KEY, '1');
                await $f0578ea5f18e5637$var$beginLogin({
                    silent: true
                });
                return; // navigating away
            }
            setStatus('anonymous');
        }
        bootstrap();
        // No cleanup that cancels the exchange: the guard above already makes this
        // run once, and aborting a half-finished exchange would strand the session.
        return undefined;
    }, [
        applyTokens
    ]);
    const login = (0, $3OyDL.useCallback)(()=>{
        setError(null);
        sessionStorage.removeItem($f0578ea5f18e5637$var$SILENT_ATTEMPTED_KEY);
        $f0578ea5f18e5637$var$beginLogin({
            silent: false
        });
    }, []);
    const logout = (0, $3OyDL.useCallback)(()=>{
        const idToken = $f0578ea5f18e5637$var$currentAccessToken;
        $f0578ea5f18e5637$var$currentAccessToken = null;
        refreshTokenRef.current = null;
        clearTimeout(timerRef.current);
        sessionStorage.removeItem($f0578ea5f18e5637$var$SILENT_ATTEMPTED_KEY);
        setStatus('anonymous');
        setClaims(null);
        if (!idToken) return;
        const params = new URLSearchParams({
            client_id: $f0578ea5f18e5637$var$config.clientId,
            post_logout_redirect_uri: $f0578ea5f18e5637$var$config.redirectUri
        });
        window.location.assign(`${$f0578ea5f18e5637$var$endpoints.logout}?${params}`);
    }, []);
    const value = (0, $3OyDL.useMemo)(()=>({
            status: status,
            error: error,
            login: login,
            logout: logout,
            // Display only. The BFF's `me` query is the authority on role.
            displayName: claims?.name || claims?.preferred_username || '',
            username: claims?.preferred_username || ''
        }), [
        status,
        error,
        login,
        logout,
        claims
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($f0578ea5f18e5637$var$AuthContext.Provider, {
        value: value,
        children: children
    });
}
function $f0578ea5f18e5637$export$1d39dc5b47e56ff0() {
    const context = (0, $3OyDL.useContext)($f0578ea5f18e5637$var$AuthContext);
    if (!context) throw new Error('useAuth must be used inside <AuthProvider>');
    return context;
}


/**
 * Leaving this bundle for the other half of the app (/platform).
 *
 * A full-document navigation, so it lives in one named function: the shell
 * reads as what it means, and a test can see that it happened — jsdom's
 * `window.location` cannot be spied on.
 */ function $e210789b45edc509$export$ecaefb475de7af92(url) {
    window.location.replace(url);
}



/**
 * The signed-in user's *server-verified* identity.
 *
 * The token in the browser carries claims, but the client must never decide
 * authorization from them — a role read out of a JWT client-side is a
 * suggestion. `me` is answered by the BFF after it verified the signature,
 * issuer, audience and expiry, so that is what navigation and route guards use.
 * The token's own claims are display-only (see `auth.jsx`).
 */ 
var $2M70Q = parcelRequire("2M70Q");


var $3OyDL = parcelRequire("3OyDL");

const $00d5d84dffcdf8d5$var$SessionContext = /*#__PURE__*/ (0, $3OyDL.createContext)(null);
function $00d5d84dffcdf8d5$export$d053b53cdff1ea07({ children: children }) {
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$4fdec73565eec05f), {
        fetchPolicy: 'cache-and-network'
    });
    const value = (0, $3OyDL.useMemo)(()=>{
        const me = data?.me ?? null;
        return {
            me: me,
            loading: loading && !me,
            error: error,
            refetch: refetch,
            isAdmin: me?.role === 'ADMIN',
            // The platform back office at /platform (platform_admin), and the CRM
            // itself (a MeshHub role, where the CRM modules are served).
            canPlatform: !!me?.access?.platform,
            canCrm: me?.access ? !!me.access.crm : !!me?.role
        };
    }, [
        data,
        loading,
        error,
        refetch
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($00d5d84dffcdf8d5$var$SessionContext.Provider, {
        value: value,
        children: children
    });
}
function $00d5d84dffcdf8d5$export$ad0a340bf97d63d5() {
    const context = (0, $3OyDL.useContext)($00d5d84dffcdf8d5$var$SessionContext);
    if (!context) throw new Error('useSession must be used inside <SessionProvider>');
    return context;
}


/**
 * THE central keyboard-shortcut registry (CLAUDE.md §12).
 *
 * This module owns the ONE `window` keydown listener in the app. Screens
 * register shortcuts declaratively with `useShortcut(...)`; they must never
 * attach their own listener. `npm run lint` fails the build if any file under
 * `src/` outside this one calls addEventListener('keydown').
 *
 * Reserved keys — do not reassign:
 *   ?   the shortcuts help overlay (this module owns it)
 *   /   focus the search box
 *   Esc close the topmost overlay
 */ 
var $2M70Q = parcelRequire("2M70Q");

var $i5Xd5 = parcelRequire("i5Xd5");

var $3OyDL = parcelRequire("3OyDL");

const $ed3cc4f847deec94$var$ShortcutContext = /*#__PURE__*/ (0, $3OyDL.createContext)(null);
/** Typing in a field must not trigger single-key shortcuts. */ function $ed3cc4f847deec94$var$isEditableTarget(target) {
    if (!target) return false;
    if (target.isContentEditable) return true;
    return [
        'INPUT',
        'TEXTAREA',
        'SELECT'
    ].includes(target.tagName);
}
/**
 * A modal dialog owns the keyboard while it is open.
 *
 * Without this, a screen's shortcut fires *underneath* an open dialog. The
 * concrete bug it fixes: the contact profile registers Escape to go back to the
 * list, so pressing Escape to dismiss the interaction composer both closed the
 * dialog AND navigated away — the user lost the profile they were on for
 * cancelling a form. Radix calls preventDefault on its own Escape handling, but
 * that does not stop this listener, so the registry has to defer explicitly.
 *
 * Detected from the DOM rather than from a counter, because Radix owns the
 * dialogs' open state and a counter would be a second source of truth that
 * drifts the first time someone unmounts a dialog without closing it.
 */ function $ed3cc4f847deec94$var$isModalOpen() {
    return document.querySelector('[role="dialog"][data-state="open"]') !== null;
}
/** Normalize an event to a comparable key string: "?", "/", "mod+k", "Escape". */ function $ed3cc4f847deec94$var$eventKey(event) {
    const parts = [];
    if (event.ctrlKey || event.metaKey) parts.push('mod');
    if (event.altKey) parts.push('alt');
    if (event.shiftKey && event.key.length > 1) parts.push('shift');
    parts.push(event.key);
    return parts.join('+');
}
function $ed3cc4f847deec94$export$87dd7790e69558a9({ children: children }) {
    // Map<key, {handler, description, group, allowInInput}> — a ref so that
    // registering does not re-run the listener effect.
    const registry = (0, $3OyDL.useRef)(new Map());
    const [helpOpen, setHelpOpen] = (0, $3OyDL.useState)(false);
    const [, forceRender] = (0, $3OyDL.useState)(0);
    const register = (0, $3OyDL.useCallback)((key, entry)=>{
        registry.current.set(key, entry);
        forceRender((n)=>n + 1); // the help overlay lists what is registered
        return ()=>{
            registry.current.delete(key);
            forceRender((n)=>n + 1);
        };
    }, []);
    // The app's single keydown listener.
    (0, $3OyDL.useEffect)(()=>{
        function onKeyDown(event) {
            const key = $ed3cc4f847deec94$var$eventKey(event);
            // The help overlay is itself a dialog, so it answers for its own keys
            // before the modal guard below would swallow them.
            if (helpOpen) {
                if (key === 'Escape' || key === '?' && !$ed3cc4f847deec94$var$isEditableTarget(event.target)) setHelpOpen(false);
                return;
            }
            // Any other open dialog owns the keyboard: no screen shortcut fires
            // underneath it, and `?` does not stack the help overlay on top of a form.
            if ($ed3cc4f847deec94$var$isModalOpen()) return;
            if (key === '?' && !$ed3cc4f847deec94$var$isEditableTarget(event.target)) {
                event.preventDefault();
                setHelpOpen(true);
                return;
            }
            const entry = registry.current.get(key);
            if (!entry) return;
            if ($ed3cc4f847deec94$var$isEditableTarget(event.target) && !entry.allowInInput) return;
            event.preventDefault();
            entry.handler(event);
        }
        window.addEventListener('keydown', onKeyDown);
        return ()=>window.removeEventListener('keydown', onKeyDown);
    }, [
        helpOpen
    ]);
    const value = (0, $3OyDL.useMemo)(()=>({
            register: register,
            registry: registry,
            openHelp: ()=>setHelpOpen(true)
        }), [
        register
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($ed3cc4f847deec94$var$ShortcutContext.Provider, {
        value: value,
        children: [
            children,
            /*#__PURE__*/ (0, $2M70Q.jsx)($ed3cc4f847deec94$var$ShortcutHelpOverlay, {
                open: helpOpen,
                onOpenChange: setHelpOpen,
                entries: [
                    ...registry.current.entries()
                ]
            })
        ]
    });
}
function $ed3cc4f847deec94$export$b0ebbe7904d8d94a(key, handler, options = {}) {
    const context = (0, $3OyDL.useContext)($ed3cc4f847deec94$var$ShortcutContext);
    if (!context) throw new Error('useShortcut must be used inside <ShortcutProvider>');
    const { description: description = '', group: group = "\u0639\u0645\u0648\u0645\u06CC", allowInInput: allowInInput = false, enabled: enabled = true } = options;
    const handlerRef = (0, $3OyDL.useRef)(handler);
    handlerRef.current = handler;
    (0, $3OyDL.useEffect)(()=>{
        if (!enabled) return undefined;
        return context.register(key, {
            handler: (event)=>handlerRef.current(event),
            description: description,
            group: group,
            allowInInput: allowInInput
        });
    }, [
        context,
        key,
        description,
        group,
        allowInInput,
        enabled
    ]);
}
function $ed3cc4f847deec94$export$a11896fcfbddc990() {
    const context = (0, $3OyDL.useContext)($ed3cc4f847deec94$var$ShortcutContext);
    return context?.openHelp ?? (()=>{});
}
/* ---------- the help overlay (reserved: `?`) ---------- */ const $ed3cc4f847deec94$var$KEY_LABELS = {
    mod: "\u2318/Ctrl",
    alt: 'Alt',
    shift: 'Shift',
    Escape: 'Esc'
};
function $ed3cc4f847deec94$var$KeyCap({ combo: combo }) {
    return /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
        className: "flex gap-1",
        children: combo.split('+').map((part)=>/*#__PURE__*/ (0, $2M70Q.jsx)("kbd", {
                className: "rounded border border-border bg-surface-hover px-2 py-1 text-xs font-medium",
                children: $ed3cc4f847deec94$var$KEY_LABELS[part] ?? (0, $d4d460d3ffb6daab$export$e9cf274fc1035ec4)(part)
            }, part))
    });
}
function $ed3cc4f847deec94$var$ShortcutHelpOverlay({ open: open, onOpenChange: onOpenChange, entries: entries }) {
    const groups = entries.reduce((acc, [key, entry])=>{
        (acc[entry.group] ??= []).push([
            key,
            entry
        ]);
        return acc;
    }, {});
    return /*#__PURE__*/ (0, $2M70Q.jsx)($i5Xd5.Root, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ (0, $2M70Q.jsxs)($i5Xd5.Portal, {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)($i5Xd5.Overlay, {
                    className: "fixed inset-0 bg-text/30"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsxs)($i5Xd5.Content, {
                    dir: "rtl",
                    className: "fixed left-1/2 top-1/2 w-overlay -translate-x-1/2 -translate-y-1/2 rounded border border-border bg-surface p-6 shadow-overlay",
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)($i5Xd5.Title, {
                            className: "text-lg font-bold text-text",
                            children: "\u0645\u06CC\u0627\u0646\u200C\u0628\u0631\u0647\u0627\u06CC \u0635\u0641\u062D\u0647\u200C\u06A9\u0644\u06CC\u062F"
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsxs)($i5Xd5.Description, {
                            className: "mt-1 text-sm text-text-muted",
                            children: [
                                "\u0628\u0631\u0627\u06CC \u0628\u0633\u062A\u0646\u060C \u06A9\u0644\u06CC\u062F ",
                                /*#__PURE__*/ (0, $2M70Q.jsx)("kbd", {
                                    className: "font-medium",
                                    children: "Esc"
                                }),
                                " \u06CC\u0627 \u062F\u0648\u0628\u0627\u0631\u0647",
                                ' ',
                                /*#__PURE__*/ (0, $2M70Q.jsx)("kbd", {
                                    className: "font-medium",
                                    children: "\u061F"
                                }),
                                " \u0631\u0627 \u0628\u0632\u0646\u06CC\u062F."
                            ]
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                            className: "mt-5 flex flex-col gap-5",
                            children: [
                                Object.entries(groups).map(([group, groupEntries])=>/*#__PURE__*/ (0, $2M70Q.jsxs)("section", {
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)("h3", {
                                                className: "mb-2 text-sm font-medium text-text-muted",
                                                children: group
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
                                                className: "flex flex-col gap-2",
                                                children: groupEntries.map(([key, entry])=>/*#__PURE__*/ (0, $2M70Q.jsxs)("li", {
                                                        className: "flex items-center justify-between gap-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                                className: "text-base text-text",
                                                                children: entry.description || key
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)($ed3cc4f847deec94$var$KeyCap, {
                                                                combo: key
                                                            })
                                                        ]
                                                    }, key))
                                            })
                                        ]
                                    }, group)),
                                /*#__PURE__*/ (0, $2M70Q.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)("h3", {
                                            className: "mb-2 text-sm font-medium text-text-muted",
                                            children: "\u0647\u0645\u06CC\u0634\u0647 \u062F\u0631 \u062F\u0633\u062A\u0631\u0633"
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
                                            className: "flex flex-col gap-2",
                                            children: /*#__PURE__*/ (0, $2M70Q.jsxs)("li", {
                                                className: "flex items-center justify-between gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                        className: "text-base text-text",
                                                        children: "\u0646\u0645\u0627\u06CC\u0634 \u0647\u0645\u06CC\u0646 \u0631\u0627\u0647\u0646\u0645\u0627"
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)($ed3cc4f847deec94$var$KeyCap, {
                                                        combo: "?"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}



const $9c7153815b06adfe$var$ROLE_LABELS = {
    ADMIN: (0, $d916753b57975e04$export$25ce5a424b770e84).auth.roleAdmin,
    USER: (0, $d916753b57975e04$export$25ce5a424b770e84).auth.roleUser
};
const $9c7153815b06adfe$var$navClass = ({ isActive: isActive })=>[
        'flex h-control items-center gap-2 rounded px-4 text-base transition-colors',
        isActive ? 'bg-primary text-primary-contrast' : 'text-text hover:bg-surface-hover'
    ].join(' ');
function $9c7153815b06adfe$export$2afed54d6b7d68d9() {
    const openHelp = (0, $ed3cc4f847deec94$export$a11896fcfbddc990)();
    const { logout: logout, displayName: displayName } = (0, $f0578ea5f18e5637$export$1d39dc5b47e56ff0)();
    const { me: me, isAdmin: isAdmin, canPlatform: canPlatform, canCrm: canCrm } = (0, $00d5d84dffcdf8d5$export$ad0a340bf97d63d5)();
    // Platform-only staff (platform_admin, no MeshHub role) have nothing here:
    // every CRM field would refuse them. They are sent to their half of the app
    // instead of being shown a CRM made of error states. `replace`, so Back does
    // not bounce them here again.
    const platformOnly = !!me && canPlatform && !canCrm;
    (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useEffect(()=>{
        if (platformOnly) (0, $e210789b45edc509$export$ecaefb475de7af92)((0, $b5d41e4dbaeacaa2$export$afb6a0a1b7d83935));
    }, [
        platformOnly
    ]);
    // The badge is the whole point of an inbox: a follow-up nobody looks at is a
    // follow-up that does not happen. `errorPolicy: ignore` because a count is
    // never worth taking the shell down for.
    const { data: followUps } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$20635703b116d48d), {
        variables: {
            state: 'OPEN'
        },
        errorPolicy: 'ignore'
    });
    const openFollowUps = followUps?.followUpSuggestions?.length ?? 0;
    // The other half of the app, as far as this caller may go: the whole
    // platform panel for platform_admin, else the demo-request queue — which
    // lives there and is open to every CRM role.
    const otherHalf = canPlatform ? {
        href: (0, $b5d41e4dbaeacaa2$export$afb6a0a1b7d83935),
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).nav.platform,
        Icon: (0, $8n6ke.default)
    } : canCrm ? {
        href: `${0, $b5d41e4dbaeacaa2$export$afb6a0a1b7d83935}demo-requests`,
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).nav.demoRequests,
        Icon: (0, $vMEqK.default)
    } : null;
    // Registered centrally, like every other shortcut. Ctrl/⌘+Shift+Q rather than
    // a bare key: signing out mid-task by mistyping would be infuriating.
    (0, $ed3cc4f847deec94$export$b0ebbe7904d8d94a)('mod+shift+Q', logout, {
        description: (0, $d916753b57975e04$export$25ce5a424b770e84).shortcuts.actions.signOut,
        group: (0, $d916753b57975e04$export$25ce5a424b770e84).shortcuts.groups.session,
        allowInInput: true
    });
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex min-h-screen",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("aside", {
                className: "flex w-sidebar shrink-0 flex-col border-e border-border bg-surface",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "flex h-toolbar items-center gap-2 border-b border-border px-5",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $dRGZn.default), {
                                size: 18,
                                className: "text-primary",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                className: "text-lg font-bold",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("nav", {
                        className: "flex flex-1 flex-col gap-1 p-3",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $8B9Zg.NavLink), {
                                to: "/",
                                end: true,
                                className: $9c7153815b06adfe$var$navClass,
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $gPhVo.default), {
                                        size: 16,
                                        "aria-hidden": "true"
                                    }),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).nav.dashboard
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $8B9Zg.NavLink), {
                                to: "/contacts",
                                className: $9c7153815b06adfe$var$navClass,
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b5346343988c4f3a$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": "true"
                                    }),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).nav.contacts
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $8B9Zg.NavLink), {
                                to: "/calendar",
                                className: $9c7153815b06adfe$var$navClass,
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $68l1k.default), {
                                        size: 16,
                                        "aria-hidden": "true"
                                    }),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).calendar.title
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $8B9Zg.NavLink), {
                                to: "/followups",
                                className: $9c7153815b06adfe$var$navClass,
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8b130464b09d4cb6$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": "true"
                                    }),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).followUps.title,
                                    openFollowUps > 0 && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                        className: "ms-auto rounded-full bg-accent px-2 text-xs text-primary-contrast",
                                        children: (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(openFollowUps)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $8B9Zg.NavLink), {
                                to: "/messaging",
                                className: $9c7153815b06adfe$var$navClass,
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $7k3Wx.default), {
                                        size: 16,
                                        "aria-hidden": "true"
                                    }),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.title
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $8B9Zg.NavLink), {
                                to: "/issues",
                                className: $9c7153815b06adfe$var$navClass,
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $44e0240d7f2d6793$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": "true"
                                    }),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).issues.title
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $8B9Zg.NavLink), {
                                to: "/settings",
                                className: $9c7153815b06adfe$var$navClass,
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $052f07d1332d4c9e$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": "true"
                                    }),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).nav.settings
                                ]
                            }),
                            otherHalf && /*#__PURE__*/ (0, $2M70Q.jsxs)("a", {
                                href: otherHalf.href,
                                className: `${$9c7153815b06adfe$var$navClass({
                                    isActive: false
                                })} mt-2 border-t border-border pt-2`,
                                "data-testid": "nav-platform",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)(otherHalf.Icon, {
                                        size: 16,
                                        "aria-hidden": "true"
                                    }),
                                    otherHalf.label
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $147a9706b8db1779$export$cb2942e573a81e39), {}),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "border-t border-border",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                className: "flex flex-col gap-1 px-5 py-3",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                        className: "truncate text-base font-medium",
                                        title: me?.displayName ?? displayName,
                                        children: me?.displayName || displayName || (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                        className: "text-xs text-text-muted",
                                        children: [
                                            $9c7153815b06adfe$var$ROLE_LABELS[me?.role] ?? me?.role ?? '',
                                            me?.bypassed ? " \xb7 BYPASS_AUTH" : ''
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                        className: "text-xs text-text-muted",
                                        dir: "ltr",
                                        "data-testid": "shell-env",
                                        children: (0, $b5d41e4dbaeacaa2$export$d83c88e8fa34151c)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("button", {
                                type: "button",
                                onClick: openHelp,
                                className: "flex h-control w-full items-center gap-2 px-5 text-sm text-text-muted hover:bg-surface-hover",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3c721d6b8d7c1a29$export$2e2bcd8739ae039), {
                                        size: 15,
                                        "aria-hidden": "true"
                                    }),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).nav.shortcuts,
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("kbd", {
                                        className: "ms-auto rounded border border-border px-2 text-xs",
                                        children: "\u061F"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("button", {
                                type: "button",
                                onClick: logout,
                                className: "flex h-control w-full items-center gap-2 px-5 text-sm text-text-muted hover:bg-surface-hover hover:text-danger",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3wlwv.default), {
                                        size: 15,
                                        "aria-hidden": "true"
                                    }),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).auth.signOut
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("main", {
                className: "min-w-0 flex-1",
                children: platformOnly ? null : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ZNHD9.Outlet), {})
            })
        ]
    });
}



var $2M70Q = parcelRequire("2M70Q");
/**
 * PLACEHOLDER component kit — the `ui` layer.
 *
 * Every component here is built strictly from the `tokens` layer: no literal
 * colors, radii, or pixel densities. Superseded by the org design-system kit
 * once its git URL is available (see DESIGN.md / todo.md).
 */ 
var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");
const $2d41816c9c811df0$var$cx = (...parts)=>parts.filter(Boolean).join(' ');
/* ---------- Button ---------- */ const $2d41816c9c811df0$var$BUTTON_VARIANTS = {
    primary: 'bg-primary text-primary-contrast hover:bg-primary-hover border-transparent',
    secondary: 'bg-surface text-text hover:bg-surface-hover border-border',
    ghost: 'bg-transparent text-text-muted hover:bg-surface-hover border-transparent',
    danger: 'bg-danger text-text-inverse border-transparent'
};
function $2d41816c9c811df0$export$353f5b6fc5456de1({ variant: variant = 'secondary', className: className, type: type = 'button', ...props }) {
    return /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
        type: type,
        className: $2d41816c9c811df0$var$cx('inline-flex h-control items-center justify-center gap-2 rounded border px-4', 'text-base font-medium transition-colors disabled:opacity-50', 'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1', 'focus-visible:outline-primary', $2d41816c9c811df0$var$BUTTON_VARIANTS[variant], className),
        ...props
    });
}
function $2d41816c9c811df0$export$37acb3580601e69a({ className: className, style: style, ...props }) {
    return /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
        className: $2d41816c9c811df0$var$cx('inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-medium', className),
        style: style,
        ...props
    });
}
const $2d41816c9c811df0$var$STATUS_CLASS = {
    UNKNOWN: 'text-status-unknown',
    INTERESTED: 'text-status-interested',
    CONSULTING: 'text-status-consulting',
    SUBSCRIBER: 'text-status-subscriber'
};
function $2d41816c9c811df0$export$5720c1871db44880({ status: status, label: label, className: className }) {
    return /*#__PURE__*/ (0, $2M70Q.jsxs)($2d41816c9c811df0$export$37acb3580601e69a, {
        className: $2d41816c9c811df0$var$cx('bg-surface-hover', $2d41816c9c811df0$var$STATUS_CLASS[status], className),
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                "aria-hidden": "true",
                className: "text-xs leading-none",
                children: "\u25CF"
            }),
            label ?? status
        ]
    });
}
function $2d41816c9c811df0$export$c21cd4bbffdb84a0({ name: name, colorHex: colorHex, className: className }) {
    return /*#__PURE__*/ (0, $2M70Q.jsx)($2d41816c9c811df0$export$37acb3580601e69a, {
        className: $2d41816c9c811df0$var$cx('border', className),
        style: {
            color: colorHex,
            borderColor: colorHex,
            backgroundColor: `${colorHex}14`
        },
        children: name
    });
}
function $2d41816c9c811df0$export$54ec01a60f47d33d({ className: className, ...props }) {
    return /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
        className: "overflow-x-auto rounded border border-border bg-surface",
        children: /*#__PURE__*/ (0, $2M70Q.jsx)("table", {
            className: $2d41816c9c811df0$var$cx('w-full border-collapse text-base', className),
            ...props
        })
    });
}
function $2d41816c9c811df0$export$c4c2bc57f2e82919(props) {
    return /*#__PURE__*/ (0, $2M70Q.jsx)("thead", {
        className: "bg-surface-hover text-text-muted",
        ...props
    });
}
function $2d41816c9c811df0$export$7005b8a93a167348(props) {
    return /*#__PURE__*/ (0, $2M70Q.jsx)("tbody", {
        ...props
    });
}
function $2d41816c9c811df0$export$5582bd7183a5e873({ className: className, interactive: interactive, ...props }) {
    return /*#__PURE__*/ (0, $2M70Q.jsx)("tr", {
        className: $2d41816c9c811df0$var$cx('h-row border-b border-border last:border-b-0', interactive && 'cursor-pointer hover:bg-surface-hover', className),
        ...props
    });
}
function $2d41816c9c811df0$export$2b39a3648955dd09({ className: className, ...props }) {
    return /*#__PURE__*/ (0, $2M70Q.jsx)("th", {
        scope: "col",
        className: $2d41816c9c811df0$var$cx('h-tablehead px-4 text-start text-sm font-medium whitespace-nowrap', className),
        ...props
    });
}
function $2d41816c9c811df0$export$9cf5b401f969f5e3({ className: className, ...props }) {
    return /*#__PURE__*/ (0, $2M70Q.jsx)("td", {
        className: $2d41816c9c811df0$var$cx('px-4 py-2 align-middle', className),
        ...props
    });
}
function $2d41816c9c811df0$export$60332b2344f7fe41({ className: className, ...props }) {
    return /*#__PURE__*/ (0, $2M70Q.jsx)("section", {
        className: $2d41816c9c811df0$var$cx('rounded border border-border bg-surface p-5 shadow-sm', className),
        ...props
    });
}
function $2d41816c9c811df0$export$a455218a85c89869({ label: label, children: children, className: className }) {
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: $2d41816c9c811df0$var$cx('flex flex-col gap-1', className),
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                className: "text-sm text-text-muted",
                children: label
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: "text-base text-text",
                children: children
            })
        ]
    });
}
function $2d41816c9c811df0$export$7f7cbe89f1eacd2({ className: className }) {
    return /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
        role: "status",
        "aria-label": "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC",
        className: $2d41816c9c811df0$var$cx('inline-block h-5 w-5 animate-spin rounded-full border-2 border-border', 'border-t-primary', className)
    });
}
function $2d41816c9c811df0$export$fddf379e22a74b00({ title: title, hint: hint, className: className }) {
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: $2d41816c9c811df0$var$cx('flex flex-col items-center gap-2 p-7 text-center', className),
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-md text-text",
                children: title
            }),
            hint && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-sm text-text-muted",
                children: hint
            })
        ]
    });
}
/* ---------- Charts (Step 5) ---------- */ /**
 * A BAR CHART, drawn as SVG from the tokens, and NOT a charting library.
 *
 * The brief asked for "a chart lib consistent with the design package". What
 * that requirement actually is — charts must use tokens, not their own palette
 * — is better served by not adding one:
 *
 *  - Every charting library ships its own colour scale, its own font handling
 *    and its own layout units. Making one obey the tokens means overriding all
 *    three, which is more code than drawing rectangles.
 *  - MeshHub is RTL. Chart libraries reason in left-to-right axes; the two
 *    serious ones need per-chart configuration to flip, and the ones that
 *    "support RTL" flip the labels and not the bars.
 *  - This is a bar chart and a table. Adding a dependency for `<rect>` would
 *    also be a dependency the brief did not list, needing a decision the brief
 *    said to ask about.
 *
 * If a deployment ever wants stacked areas or interactive brushing, THAT is
 * when the trade changes; recorded in todo.md.
 *
 * Colours come from `--mh-color-activity-N`, the same slot list the calendar
 * uses (docs/decisions.md #81): a slot list rather than a map, so no code
 * anywhere names a category and a deployment with a ninth wraps around.
 */ const $2d41816c9c811df0$var$CHART_SLOTS = 8;
function $2d41816c9c811df0$export$94aefc399ef206a9({ data: data, valueLabel: valueLabel, formatValue: //: The ROW is passed too, so a caller can render a secondary figure beside
//: the primary one — «۱۵ / ۴» for a distribution and its subscriber subset.
//: Two bars per row would double the height of every card and halve how much
//: of the page fits on a screen.
formatValue = (v)=>String(v), formatLabel: formatLabel = (l)=>l, emptyLabel: emptyLabel = "\u062F\u0627\u062F\u0647\u200C\u0627\u06CC \u0646\u06CC\u0633\u062A", onSelect: //: Optional. When given, each row becomes a button — every number on the
//: dashboard is meant to be clickable through to the contacts behind it.
//: Absent by default, because a bar that looks clickable and is not is worse
//: than one that plainly is not.
onSelect, className: className }) {
    const rows = (data ?? []).filter((d)=>d && Number.isFinite(Number(d.value)));
    if (rows.length === 0) return /*#__PURE__*/ (0, $2M70Q.jsx)($2d41816c9c811df0$export$fddf379e22a74b00, {
        className: className,
        title: emptyLabel
    });
    const max = Math.max(...rows.map((r)=>Number(r.value)), 1);
    // A LIST OF BARS, not an <svg> with computed x/y. RTL then lays every bar out
    // from the right with no `flex-row-reverse` and no transform — the same
    // reasoning that keeps the calendar's Persian week honest (CLAUDE.md §15).
    return /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
        className: $2d41816c9c811df0$var$cx('flex flex-col gap-2', className),
        role: "img",
        "aria-label": valueLabel,
        children: rows.map((row, index)=>{
            const value = Number(row.value);
            const share = Math.max(value / max * 100, value > 0 ? 2 : 0);
            const Row = onSelect ? 'button' : 'div';
            return /*#__PURE__*/ (0, $2M70Q.jsxs)(Row, {
                type: onSelect ? 'button' : undefined,
                onClick: onSelect ? ()=>onSelect(row) : undefined,
                className: $2d41816c9c811df0$var$cx('flex w-full items-center gap-3 text-start', onSelect && 'rounded hover:bg-surface-hover'),
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "w-chartlabel shrink-0 truncate text-sm text-text-muted",
                        title: formatLabel(row.label),
                        children: formatLabel(row.label)
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "h-chartbar flex-1 rounded bg-surface-hover",
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                            className: "block h-full rounded",
                            style: {
                                width: `${share}%`,
                                backgroundColor: `var(--mh-color-activity-${index % $2d41816c9c811df0$var$CHART_SLOTS + 1})`
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "w-chartvalue shrink-0 text-start text-sm tabular-nums",
                        children: formatValue(value, row)
                    })
                ]
            }, row.key ?? row.label ?? index);
        })
    });
}


/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $4a08af80fe71dc12$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m10 17 5-5-5-5",
            key: "1bsop3"
        }
    ],
    [
        "path",
        {
            d: "M15 12H3",
            key: "6jk70r"
        }
    ],
    [
        "path",
        {
            d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4",
            key: "u53s6r"
        }
    ]
];
const $4a08af80fe71dc12$export$2e2bcd8739ae039 = (0, $djixo.default)("log-in", $4a08af80fe71dc12$export$3efd853dbb351e94);


var $dRGZn = parcelRequire("dRGZn");
parcelRequire("3OyDL");


function $3f3b4115b2551f01$export$52c4631a391eb5f8() {
    const { status: status, login: login, error: error } = (0, $f0578ea5f18e5637$export$1d39dc5b47e56ff0)();
    if (status === 'loading') return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex h-screen flex-col items-center justify-center gap-4",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-base text-text-muted",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).auth.signingIn
            })
        ]
    });
    return /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
        className: "flex h-screen items-center justify-center p-6",
        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
            className: "flex w-overlay max-w-full flex-col items-center gap-5 text-center",
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                    className: "flex items-center gap-2 text-xl font-bold",
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $dRGZn.default), {
                            size: 22,
                            className: "text-primary",
                            "aria-hidden": "true"
                        }),
                        (0, $d916753b57975e04$export$25ce5a424b770e84).app.name
                    ]
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                    className: "text-base text-text-muted",
                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).auth.signInHint
                }),
                error && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                    role: "alert",
                    className: "text-base text-danger",
                    children: error
                }),
                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                    variant: "primary",
                    onClick: login,
                    className: "gap-2",
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4a08af80fe71dc12$export$2e2bcd8739ae039), {
                            size: 16,
                            "aria-hidden": "true"
                        }),
                        (0, $d916753b57975e04$export$25ce5a424b770e84).auth.signInAction
                    ]
                })
            ]
        })
    });
}


/**
 * Apollo client. The BFF is the only endpoint the client ever talks to —
 * domain services are not reachable from here by design (CLAUDE.md §3).
 *
 * The access token is attached per request from the in-memory store in
 * `auth.jsx`. The client still never sends its own actor id: identity is
 * derived from the token server-side.
 */ 
var $b8xcN = parcelRequire("b8xcN");




var $b8xcN = parcelRequire("b8xcN");
function $1f6bf889efb01392$export$f29bedd62f56fcb2(starting, operation) {
    var context = (0, $b8xcN.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === "function") context = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, context), next(context));
        else context = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, context), next);
    };
    var getContext = function() {
        return (0, $b8xcN.__assign)({}, context);
    };
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext
    });
    return operation;
}


function $7c8cde293212d75b$export$4f3f7df1b558c729(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    // Best guess at an operation name
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== "string" ? (0, $6d75937eba8e6f1c$export$41bca9dc6871dd4e)(transformedOperation.query) || undefined : "";
    return transformedOperation;
}


function $2443191c53f85b21$export$a92a48117d546c9(operation) {
    var OPERATION_FIELDS = [
        "query",
        "operationName",
        "variables",
        "extensions",
        "context"
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw (0, $c21c2000775800f2$export$3991762405098ea)(58, key);
    }
    return operation;
}


function $b03f28e182db18c2$var$passthrough(op, forward) {
    return forward ? forward(op) : (0, $2027033ce24a9479$export$77cea355fa80b5f4).of();
}
function $b03f28e182db18c2$var$toLink(handler) {
    return typeof handler === "function" ? new $b03f28e182db18c2$export$2fed3d61f740bc7f(handler) : handler;
}
function $b03f28e182db18c2$var$isTerminating(link) {
    return link.request.length <= 1;
}
var $b03f28e182db18c2$export$2fed3d61f740bc7f = /** @class */ function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.empty = function() {
        return new ApolloLink(function() {
            return (0, $2027033ce24a9479$export$77cea355fa80b5f4).of();
        });
    };
    ApolloLink.from = function(links) {
        if (links.length === 0) return ApolloLink.empty();
        return links.map($b03f28e182db18c2$var$toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    };
    ApolloLink.split = function(test, left, right) {
        var leftLink = $b03f28e182db18c2$var$toLink(left);
        var rightLink = $b03f28e182db18c2$var$toLink(right || new ApolloLink($b03f28e182db18c2$var$passthrough));
        var ret;
        if ($b03f28e182db18c2$var$isTerminating(leftLink) && $b03f28e182db18c2$var$isTerminating(rightLink)) ret = new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, $2027033ce24a9479$export$77cea355fa80b5f4).of() : rightLink.request(operation) || (0, $2027033ce24a9479$export$77cea355fa80b5f4).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, $2027033ce24a9479$export$77cea355fa80b5f4).of() : rightLink.request(operation, forward) || (0, $2027033ce24a9479$export$77cea355fa80b5f4).of();
        });
        return Object.assign(ret, {
            left: leftLink,
            right: rightLink
        });
    };
    ApolloLink.execute = function(link, operation) {
        return link.request((0, $1f6bf889efb01392$export$f29bedd62f56fcb2)(operation.context, (0, $7c8cde293212d75b$export$4f3f7df1b558c729)((0, $2443191c53f85b21$export$a92a48117d546c9)(operation)))) || (0, $2027033ce24a9479$export$77cea355fa80b5f4).of();
    };
    ApolloLink.concat = function(first, second) {
        var firstLink = $b03f28e182db18c2$var$toLink(first);
        if ($b03f28e182db18c2$var$isTerminating(firstLink)) {
            globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(47, firstLink);
            return firstLink;
        }
        var nextLink = $b03f28e182db18c2$var$toLink(second);
        var ret;
        if ($b03f28e182db18c2$var$isTerminating(nextLink)) ret = new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, $2027033ce24a9479$export$77cea355fa80b5f4).of();
            }) || (0, $2027033ce24a9479$export$77cea355fa80b5f4).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, $2027033ce24a9479$export$77cea355fa80b5f4).of();
            }) || (0, $2027033ce24a9479$export$77cea355fa80b5f4).of();
        });
        return Object.assign(ret, {
            left: firstLink,
            right: nextLink
        });
    };
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink($b03f28e182db18c2$var$passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw (0, $c21c2000775800f2$export$3991762405098ea)(48);
    };
    /**
     * @deprecated `onError` will be removed with Apollo Client 4.0. Please
     * discontinue using this method.
     */ ApolloLink.prototype.onError = function(error, observer) {
        if (globalThis.__DEV__ !== false) (0, $14465ad01ccc354a$export$606a5c06d13e04b6)("onError", function() {
            globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(49);
        });
        if (observer && observer.error) {
            observer.error(error);
            // Returning false indicates that observer.error does not need to be
            // called again, since it was already called (on the previous line).
            // Calling observer.error again would not cause any real problems,
            // since only the first call matters, but custom onError functions
            // might have other reasons for wanting to prevent the default
            // behavior by returning false.
            return false;
        }
        // Throw errors will be passed to observer.error.
        throw error;
    };
    /**
     * @deprecated `setOnError` will be removed with Apollo Client 4.0. Please
     * discontinue using this method.
     */ ApolloLink.prototype.setOnError = function(fn) {
        if (globalThis.__DEV__ !== false) globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(50);
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}();


var $2ff40892a1abf83c$export$51396ec711da548b = (0, $b03f28e182db18c2$export$2fed3d61f740bc7f).execute;




var $b8xcN = parcelRequire("b8xcN");


var $b8xcN = parcelRequire("b8xcN");



var $b8xcN = parcelRequire("b8xcN");






var $19cabdf265088897$var$TYPENAME_FIELD = {
    kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).FIELD,
    name: {
        kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).NAME,
        value: "__typename"
    }
};
function $19cabdf265088897$var$isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every(function(selection) {
        return selection.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).FRAGMENT_SPREAD && $19cabdf265088897$var$isEmpty(fragmentMap[selection.name.value], fragmentMap);
    });
}
function $19cabdf265088897$var$nullIfDocIsEmpty(doc) {
    return $19cabdf265088897$var$isEmpty((0, $6d75937eba8e6f1c$export$7a5b1fa979d2c158)(doc) || (0, $6d75937eba8e6f1c$export$772111caef41b3f5)(doc), (0, $070763719c7946cb$export$193789b4c8246dd4)((0, $6d75937eba8e6f1c$export$5320a7ba9466a3df)(doc))) ? null : doc;
}
function $19cabdf265088897$var$getDirectiveMatcher(configs) {
    var names = new Map();
    var tests = new Map();
    configs.forEach(function(directive) {
        if (directive) {
            if (directive.name) names.set(directive.name, directive);
            else if (directive.test) tests.set(directive.test, directive);
        }
    });
    return function(directive) {
        var config = names.get(directive.name.value);
        if (!config && tests.size) tests.forEach(function(testConfig, test) {
            if (test(directive)) config = testConfig;
        });
        return config;
    };
}
function $19cabdf265088897$var$makeInUseGetterFunction(defaultKey) {
    var map = new Map();
    return function inUseGetterFunction(key) {
        if (key === void 0) key = defaultKey;
        var inUse = map.get(key);
        if (!inUse) map.set(key, inUse = {
            // Variable and fragment spread names used directly within this
            // operation or fragment definition, as identified by key. These sets
            // will be populated during the first traversal of the document in
            // removeDirectivesFromDocument below.
            variables: new Set(),
            fragmentSpreads: new Set()
        });
        return inUse;
    };
}
function $19cabdf265088897$export$e5ae0530da5fe96c(directives, doc) {
    (0, $6d75937eba8e6f1c$export$a7d0d8111d2386df)(doc);
    // Passing empty strings to makeInUseGetterFunction means we handle anonymous
    // operations as if their names were "". Anonymous fragment definitions are
    // not supposed to be possible, but the same default naming strategy seems
    // appropriate for that case as well.
    var getInUseByOperationName = $19cabdf265088897$var$makeInUseGetterFunction("");
    var getInUseByFragmentName = $19cabdf265088897$var$makeInUseGetterFunction("");
    var getInUse = function(ancestors) {
        for(var p = 0, ancestor = void 0; p < ancestors.length && (ancestor = ancestors[p]); ++p){
            if ((0, $01c8f68cc3e070ef$export$43bee75e5e14138e)(ancestor)) continue;
            if (ancestor.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).OPERATION_DEFINITION) // If an operation is anonymous, we use the empty string as its key.
            return getInUseByOperationName(ancestor.name && ancestor.name.value);
            if (ancestor.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).FRAGMENT_DEFINITION) return getInUseByFragmentName(ancestor.name.value);
        }
        globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).error(124);
        return null;
    };
    var operationCount = 0;
    for(var i = doc.definitions.length - 1; i >= 0; --i)if (doc.definitions[i].kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).OPERATION_DEFINITION) ++operationCount;
    var directiveMatcher = $19cabdf265088897$var$getDirectiveMatcher(directives);
    var shouldRemoveField = function(nodeDirectives) {
        return (0, $01c8f68cc3e070ef$export$d307f5934e447d0e)(nodeDirectives) && nodeDirectives.map(directiveMatcher).some(function(config) {
            return config && config.remove;
        });
    };
    var originalFragmentDefsByPath = new Map();
    // Any time the first traversal of the document below makes a change like
    // removing a fragment (by returning null), this variable should be set to
    // true. Once it becomes true, it should never be set to false again. If this
    // variable remains false throughout the traversal, then we can return the
    // original doc immediately without any modifications.
    var firstVisitMadeChanges = false;
    var fieldOrInlineFragmentVisitor = {
        enter: function(node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        }
    };
    var docWithoutDirectiveSubtrees = (0, $5c27cd6fd658cc32$export$bf638b60ea8b89b7)(doc, {
        // These two AST node types share the same implementation, defined above.
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter: function() {
                // VariableDefinition nodes do not count as variables in use, though
                // they do contain Variable nodes that might be visited below. To avoid
                // counting variable declarations as usages, we skip visiting the
                // contents of this VariableDefinition node by returning false.
                return false;
            }
        },
        Variable: {
            enter: function(node, _key, _parent, _path, ancestors) {
                var inUse = getInUse(ancestors);
                if (inUse) inUse.variables.add(node.name.value);
            }
        },
        FragmentSpread: {
            enter: function(node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                var inUse = getInUse(ancestors);
                if (inUse) inUse.fragmentSpreads.add(node.name.value);
            // We might like to remove this FragmentSpread by returning null here if
            // the corresponding FragmentDefinition node is also going to be removed
            // by the logic below, but we can't control the relative order of those
            // events, so we have to postpone the removal of dangling FragmentSpread
            // nodes until after the current visit of the document has finished.
            }
        },
        FragmentDefinition: {
            enter: function(node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave: function(node, _key, _parent, path) {
                var originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) // If the FragmentNode received by this leave function is identical to
                // the one received by the corresponding enter function (above), then
                // the visitor must not have made any changes within this
                // FragmentDefinition node. This fragment definition may still be
                // removed if there are no ...spread references to it, but it won't be
                // removed just because it has only a __typename field.
                return node;
                if (// This logic applies only if the document contains one or more
                // operations, since removing all fragments from a document containing
                // only fragments makes the document useless.
                operationCount > 0 && node.selectionSet.selections.every(function(selection) {
                    return selection.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).FIELD && selection.name.value === "__typename";
                })) {
                    // This is a somewhat opinionated choice: if a FragmentDefinition ends
                    // up having no fields other than __typename, we remove the whole
                    // fragment definition, and later prune ...spread references to it.
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        },
        Directive: {
            leave: function(node) {
                // If a matching directive is found, remove the directive itself. Note
                // that this does not remove the target (field, argument, etc) of the
                // directive, but only the directive itself.
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        }
    });
    if (!firstVisitMadeChanges) // If our first pass did not change anything about the document, then there
    // is no cleanup we need to do, and we can return the original doc.
    return doc;
    // Utility for making sure inUse.transitiveVars is recursively populated.
    // Because this logic assumes inUse.fragmentSpreads has been completely
    // populated and inUse.removed has been set if appropriate,
    // populateTransitiveVars must be called after that information has been
    // collected by the first traversal of the document.
    var populateTransitiveVars = function(inUse) {
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) inUse.fragmentSpreads.forEach(function(childFragmentName) {
                populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach(function(varName) {
                    inUse.transitiveVars.add(varName);
                });
            });
        }
        return inUse;
    };
    // Since we've been keeping track of fragment spreads used by particular
    // operations and fragment definitions, we now need to compute the set of all
    // spreads used (transitively) by any operations in the document.
    var allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach(function(def) {
        if (def.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).OPERATION_DEFINITION) populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
        else if (def.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
        // definitions count as usages of their own fragment names. This heuristic
        // prevents accidentally removing all fragment definitions from the
        // document just because it contains no operations that use the fragments.
        operationCount === 0 && !getInUseByFragmentName(def.name.value).removed) allFragmentNamesUsed.add(def.name.value);
    });
    // Now that we have added all fragment spreads used by operations to the
    // allFragmentNamesUsed set, we can complete the set by transitively adding
    // all fragment spreads used by those fragments, and so on.
    allFragmentNamesUsed.forEach(function(fragmentName) {
        // Once all the childFragmentName strings added here have been seen already,
        // the top-level allFragmentNamesUsed.forEach loop will terminate.
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    var fragmentWillBeRemoved = function(fragmentName) {
        return !!// A fragment definition will be removed if there are no spreads that refer
        // to it, or the fragment was explicitly removed because it had no fields
        // other than __typename.
        (!allFragmentNamesUsed.has(fragmentName) || getInUseByFragmentName(fragmentName).removed);
    };
    var enterVisitor = {
        enter: function(node) {
            if (fragmentWillBeRemoved(node.name.value)) return null;
        }
    };
    return $19cabdf265088897$var$nullIfDocIsEmpty((0, $5c27cd6fd658cc32$export$bf638b60ea8b89b7)(docWithoutDirectiveSubtrees, {
        // If the fragment is going to be removed, then leaving any dangling
        // FragmentSpread nodes with the same name would be a mistake.
        FragmentSpread: enterVisitor,
        // This is where the fragment definition is actually removed.
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave: function(node) {
                // Upon leaving each operation in the depth-first AST traversal, prune
                // any variables that are declared by the operation but unused within.
                if (node.variableDefinitions) {
                    var usedVariableNames_1 = populateTransitiveVars(// If an operation is anonymous, we use the empty string as its key.
                    getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    // According to the GraphQL spec, all variables declared by an
                    // operation must either be used by that operation or used by some
                    // fragment included transitively into that operation:
                    // https://spec.graphql.org/draft/#sec-All-Variables-Used
                    //
                    // To stay on the right side of this validation rule, if/when we
                    // remove the last $var references from an operation or its fragments,
                    // we must also remove the corresponding $var declaration from the
                    // enclosing operation. This pruning applies only to operations and
                    // not fragment definitions, at the moment. Fragments may be able to
                    // declare variables eventually, but today they can only consume them.
                    if (usedVariableNames_1.size < node.variableDefinitions.length) return (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, node), {
                        variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                            return usedVariableNames_1.has(varDef.variable.name.value);
                        })
                    });
                }
            }
        }
    }));
}
var $19cabdf265088897$export$43b332f87950a467 = Object.assign(function(doc) {
    return (0, $5c27cd6fd658cc32$export$bf638b60ea8b89b7)(doc, {
        SelectionSet: {
            enter: function(node, _key, parent) {
                // Don't add __typename to OperationDefinitions.
                if (parent && parent.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).OPERATION_DEFINITION) return;
                // No changes if no selections.
                var selections = node.selections;
                if (!selections) return;
                // If selections already have a __typename, or are part of an
                // introspection query, do nothing.
                var skip = selections.some(function(selection) {
                    return (0, $6ee6592fd95fa693$export$fb56ad75dd311c12)(selection) && (selection.name.value === "__typename" || selection.name.value.lastIndexOf("__", 0) === 0);
                });
                if (skip) return;
                // If this SelectionSet is @export-ed as an input variable, it should
                // not have a __typename field (see issue #4691).
                var field = parent;
                if ((0, $6ee6592fd95fa693$export$fb56ad75dd311c12)(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === "export";
                })) return;
                // Create and return a new SelectionSet with a __typename Field.
                return (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, node), {
                    selections: (0, $b8xcN.__spreadArray)((0, $b8xcN.__spreadArray)([], selections, true), [
                        $19cabdf265088897$var$TYPENAME_FIELD
                    ], false)
                });
            }
        }
    });
}, {
    added: function(field) {
        return field === $19cabdf265088897$var$TYPENAME_FIELD;
    }
});
var $19cabdf265088897$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === "connection";
        if (willRemove) {
            if (!directive.arguments || !directive.arguments.some(function(arg) {
                return arg.name.value === "key";
            })) globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(125);
        }
        return willRemove;
    }
};
function $19cabdf265088897$export$74985f3324559867(doc) {
    return $19cabdf265088897$export$e5ae0530da5fe96c([
        $19cabdf265088897$var$connectionRemoveConfig
    ], (0, $6d75937eba8e6f1c$export$a7d0d8111d2386df)(doc));
}
function $19cabdf265088897$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return !!selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $19cabdf265088897$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $19cabdf265088897$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!(0, $6ee6592fd95fa693$export$fb56ad75dd311c12)(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($19cabdf265088897$var$getDirectiveMatcher(directives)) || nestedCheck && $19cabdf265088897$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $19cabdf265088897$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).VARIABLE && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $19cabdf265088897$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $19cabdf265088897$var$getArgumentMatcher(config);
    return $19cabdf265088897$var$nullIfDocIsEmpty((0, $5c27cd6fd658cc32$export$bf638b60ea8b89b7)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, node), {
                    // Remove matching top level variables definitions.
                    variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    }) : []
                });
            }
        },
        Field: {
            enter: function(node) {
                // If `remove` is set to true for an argument, and an argument match
                // is found for a field, remove the field as well.
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                // Remove all matching arguments.
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $19cabdf265088897$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $19cabdf265088897$var$nullIfDocIsEmpty((0, $5c27cd6fd658cc32$export$bf638b60ea8b89b7)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $19cabdf265088897$export$57c368c23873f32b(document) {
    var definition = (0, $6d75937eba8e6f1c$export$f431198736b7f96d)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === "query") // Already a query, so return the existing document.
    return document;
    // Build a new query using the selection set of the main operation.
    var modifiedDoc = (0, $5c27cd6fd658cc32$export$bf638b60ea8b89b7)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, node), {
                    operation: "query"
                });
            }
        }
    });
    return modifiedDoc;
}
function $19cabdf265088897$export$8eae69e876ee321e(document) {
    (0, $6d75937eba8e6f1c$export$a7d0d8111d2386df)(document);
    var modifiedDoc = $19cabdf265088897$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === "client";
            },
            remove: true
        }
    ], document);
    return modifiedDoc;
}
function $19cabdf265088897$export$b6125cad5877ac5e(document) {
    (0, $6d75937eba8e6f1c$export$a7d0d8111d2386df)(document);
    return (0, $5c27cd6fd658cc32$export$bf638b60ea8b89b7)(document, {
        FragmentSpread: function(node) {
            var _a;
            // Do not add `@nonreactive` if the fragment is marked with `@unmask`
            // since we want to react to changes in this fragment.
            if ((_a = node.directives) === null || _a === void 0 ? void 0 : _a.some(function(directive) {
                return directive.name.value === "unmask";
            })) return;
            return (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, node), {
                directives: (0, $b8xcN.__spreadArray)((0, $b8xcN.__spreadArray)([], node.directives || [], true), [
                    {
                        kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).DIRECTIVE,
                        name: {
                            kind: (0, $c9d7601e69c085e8$export$a84bdc57c5122798).NAME,
                            value: "nonreactive"
                        }
                    }
                ], false)
            });
        }
    });
}



var $b963aaf136324f3c$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = (0, $c21c2000775800f2$export$3991762405098ea)(54, label, e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};


var $04a54661f6d426bd$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === "function") return fallbackURI(operation);
    else return fallbackURI || "/graphql";
};



var $b8xcN = parcelRequire("b8xcN");
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/index.ts
 */ 
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/async.ts
 */ function $8b95d4b0790677fb$export$2e2bcd8739ae039(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
        next: function() {
            return iterator.next();
        }
    }, _a[Symbol.asyncIterator] = function() {
        return this;
    }, _a;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/nodeStream.ts
 */ 
function $44ddb7f8a9b6265c$export$2e2bcd8739ae039(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error) return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) return shiftedArr[0]({
                value: chunk,
                done: false
            });
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[0]({
                value: undefined,
                done: true
            });
        });
        !cleanup || cleanup();
    }
    cleanup = function() {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function(resolve, reject) {
            if (error) return reject(error);
            if (data.length) return resolve({
                value: data.shift(),
                done: false
            });
            if (done) return resolve({
                value: undefined,
                done: true
            });
            waiting.push([
                resolve,
                reject
            ]);
        });
    }
    var iterator = {
        next: function() {
            return getNext();
        }
    };
    if (0, $138881ab8f31fa6b$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/promise.ts
 */ 
function $8e208a1d28174f22$export$2e2bcd8739ae039(promise) {
    var resolved = false;
    var iterator = {
        next: function() {
            if (resolved) return Promise.resolve({
                value: undefined,
                done: true
            });
            resolved = true;
            return new Promise(function(resolve, reject) {
                promise.then(function(value) {
                    resolve({
                        value: value,
                        done: false
                    });
                }).catch(reject);
            });
        }
    };
    if (0, $138881ab8f31fa6b$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/reader.ts
 */ 
function $f6890797a46dc1a8$export$2e2bcd8739ae039(reader) {
    var iterator = {
        next: function() {
            return reader.read();
        }
    };
    if (0, $138881ab8f31fa6b$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


function $af9bf9bd24242f64$var$isNodeResponse(value) {
    return !!value.body;
}
function $af9bf9bd24242f64$var$isReadableStream(value) {
    return !!value.getReader;
}
function $af9bf9bd24242f64$var$isAsyncIterableIterator(value) {
    return !!((0, $138881ab8f31fa6b$export$c34f882e9f1c1637) && value[Symbol.asyncIterator]);
}
function $af9bf9bd24242f64$var$isStreamableBlob(value) {
    return !!value.stream;
}
function $af9bf9bd24242f64$var$isBlob(value) {
    return !!value.arrayBuffer;
}
function $af9bf9bd24242f64$var$isNodeReadableStream(value) {
    return !!value.pipe;
}
function $af9bf9bd24242f64$export$7e4ac9ed9577f145(response) {
    var body = response;
    if ($af9bf9bd24242f64$var$isNodeResponse(response)) body = response.body;
    if ($af9bf9bd24242f64$var$isAsyncIterableIterator(body)) return (0, $8b95d4b0790677fb$export$2e2bcd8739ae039)(body);
    if ($af9bf9bd24242f64$var$isReadableStream(body)) return (0, $f6890797a46dc1a8$export$2e2bcd8739ae039)(body.getReader());
    // this errors without casting to ReadableStream<T>
    // because Blob.stream() returns a NodeJS ReadableStream
    if ($af9bf9bd24242f64$var$isStreamableBlob(body)) return (0, $f6890797a46dc1a8$export$2e2bcd8739ae039)(body.stream().getReader());
    if ($af9bf9bd24242f64$var$isBlob(body)) return (0, $8e208a1d28174f22$export$2e2bcd8739ae039)(body.arrayBuffer());
    if ($af9bf9bd24242f64$var$isNodeReadableStream(body)) return (0, $44ddb7f8a9b6265c$export$2e2bcd8739ae039)(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}


/**
 * @deprecated `throwServerError` will be removed in Apollo Client 4.0. This is
 * safe to use in Apollo Client 3.x.
 *
 * **Recommended now**
 *
 * No action needed
 *
 * **When migrating**
 *
 * `ServerError` is a subclass of `Error`. To throw a server error, use
 * `throw new ServerError(...)` instead.
 *
 * ```ts
 * throw new ServerError("error message", { response, result });
 * ```
 */ var $0c5c0be8350d10a1$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = "ServerError";
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};






var $b8xcN = parcelRequire("b8xcN");

var $ad19e8268fdfbd88$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $ad19e8268fdfbd88$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $ad19e8268fdfbd88$export$160070228be94b08(sources);
}
function $ad19e8268fdfbd88$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new $ad19e8268fdfbd88$export$509e11c221f576c0();
        for(var i = 1; i < count; ++i)target = merger.merge(target, sources[i]);
    }
    return target;
}
var $ad19e8268fdfbd88$var$defaultReconciler = function(target, source, property) {
    return this.merge(target[property], source[property]);
};
var $ad19e8268fdfbd88$export$509e11c221f576c0 = /** @class */ function() {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) reconciler = $ad19e8268fdfbd88$var$defaultReconciler;
        this.reconciler = reconciler;
        this.isObject = (0, $01d0d880754ccbd1$export$417207af72fad9c9);
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function(target, source) {
        var _this = this;
        var context = [];
        for(var _i = 2; _i < arguments.length; _i++)context[_i - 2] = arguments[_i];
        if ((0, $01d0d880754ccbd1$export$417207af72fad9c9)(source) && (0, $01d0d880754ccbd1$export$417207af72fad9c9)(target)) {
            Object.keys(source).forEach(function(sourceKey) {
                if ($ad19e8268fdfbd88$var$hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0, $b8xcN.__spreadArray)([
                            target,
                            source,
                            sourceKey
                        ], context, false));
                        // A well-implemented reconciler may return targetValue to indicate
                        // the merge changed nothing about the structure of the target.
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                } else {
                    // If there is no collision, the target can safely share memory with
                    // the source, and the recursion can terminate here.
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        // If source (or target) is not an object, let source replace target.
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function(value) {
        if ((0, $01d0d880754ccbd1$export$417207af72fad9c9)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) value = value.slice(0);
                else value = (0, $b8xcN.__assign)({
                    __proto__: Object.getPrototypeOf(value)
                }, value);
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}();


function $c6f9e6ad9f49962f$export$879767c5cdf33cb3(value) {
    return "incremental" in value;
}
function $c6f9e6ad9f49962f$export$6c17a45d8c64ff02(value) {
    return "hasNext" in value && "data" in value;
}
function $c6f9e6ad9f49962f$export$f90dc0a3531b8b83(value) {
    return $c6f9e6ad9f49962f$export$879767c5cdf33cb3(value) || $c6f9e6ad9f49962f$export$6c17a45d8c64ff02(value);
}
function $c6f9e6ad9f49962f$export$3f32b6369f408f33(value) {
    return (0, $01d0d880754ccbd1$export$417207af72fad9c9)(value) && "payload" in value;
}
function $c6f9e6ad9f49962f$export$9a905f57d6393874(prevResult, result) {
    var mergedData = prevResult;
    var merger = new (0, $ad19e8268fdfbd88$export$509e11c221f576c0)();
    if ($c6f9e6ad9f49962f$export$879767c5cdf33cb3(result) && (0, $01c8f68cc3e070ef$export$d307f5934e447d0e)(result.incremental)) result.incremental.forEach(function(_a) {
        var data = _a.data, path = _a.path;
        for(var i = path.length - 1; i >= 0; --i){
            var key = path[i];
            var isNumericKey = !isNaN(+key);
            var parent_1 = isNumericKey ? [] : {};
            parent_1[key] = data;
            data = parent_1;
        }
        mergedData = merger.merge(mergedData, data);
    });
    return mergedData;
}


var $695364ed59a50254$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $695364ed59a50254$export$ccb60864026baf09(response, nextValue) {
    return (0, $b8xcN.__awaiter)(this, void 0, void 0, function() {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _a, value, done, chunk, searchFrom, bi, message, i, headers, contentType_1, body, result, next;
        var _b, _c;
        var _d;
        return (0, $b8xcN.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    if (TextDecoder === undefined) throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    decoder = new TextDecoder("utf-8");
                    contentType = (_d = response.headers) === null || _d === void 0 ? void 0 : _d.get("content-type");
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter)) ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-";
                    boundary = "\r\n--".concat(boundaryVal);
                    buffer = "";
                    iterator = (0, $af9bf9bd24242f64$export$7e4ac9ed9577f145)(response);
                    running = true;
                    _e.label = 1;
                case 1:
                    if (!running) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        iterator.next()
                    ];
                case 2:
                    _a = _e.sent(), value = _a.value, done = _a.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    searchFrom = buffer.length - boundary.length + 1;
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary, searchFrom);
                    while(bi > -1){
                        message = void 0;
                        _b = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length)
                        ], message = _b[0], buffer = _b[1];
                        i = message.indexOf("\r\n\r\n");
                        headers = $695364ed59a50254$export$eea2c1c5e1a37e50(message.slice(0, i));
                        contentType_1 = headers["content-type"];
                        if (contentType_1 && contentType_1.toLowerCase().indexOf("application/json") === -1) throw new Error("Unsupported patch content type: application/json is required.");
                        body = message.slice(i);
                        if (body) {
                            result = $695364ed59a50254$export$759bcb35b0d1bf81(response, body);
                            if (Object.keys(result).length > 1 || "data" in result || "incremental" in result || "errors" in result || "payload" in result) {
                                if ((0, $c6f9e6ad9f49962f$export$3f32b6369f408f33)(result)) {
                                    next = {};
                                    if ("payload" in result) {
                                        if (Object.keys(result).length === 1 && result.payload === null) return [
                                            2 /*return*/ 
                                        ];
                                        next = (0, $b8xcN.__assign)({}, result.payload);
                                    }
                                    if ("errors" in result) next = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, next), {
                                        extensions: (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, "extensions" in next ? next.extensions : null), (_c = {}, _c[0, $03c08328939e6317$export$4995664c1b49842e] = result.errors, _c))
                                    });
                                    nextValue(next);
                                } else // for the last chunk with only `hasNext: false`
                                // we don't need to call observer.next as there is no data/errors
                                nextValue(result);
                            } else if (// If the chunk contains only a "hasNext: false", we can call
                            // observer.complete() immediately.
                            Object.keys(result).length === 1 && "hasNext" in result && !result.hasNext) return [
                                2 /*return*/ 
                            ];
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $695364ed59a50254$export$eea2c1c5e1a37e50(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function(line) {
        var i = line.indexOf(":");
        if (i > -1) {
            // normalize headers to lowercase
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function $695364ed59a50254$export$759bcb35b0d1bf81(response, bodyText) {
    if (response.status >= 300) {
        // Network error
        var getResult = function() {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                return bodyText;
            }
        };
        (0, $0c5c0be8350d10a1$export$c33ef9219f27efd7)(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    } catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function $695364ed59a50254$export$d3da1ecaf1206c58(err, observer) {
    // if it is a network error, BUT there is graphql result info fire
    // the next observer before calling error this gives apollo-client
    // (and react-apollo) the `graphqlErrors` and `networkErrors` to
    // pass to UI this should only happen if we *also* have data as
    // part of the response key per the spec
    if (err.result && err.result.errors && err.result.data) // if we don't call next, the UI can only show networkError
    // because AC didn't get any graphqlErrors this is graphql
    // execution result info (i.e errors and possibly data) this is
    // because there is no formal spec how errors should translate to
    // http status codes. So an auth error (401) could have both data
    // from a public field, errors from a private field, and a status
    // of 401
    // {
    //  user { // this will have errors
    //    firstName
    //  }
    //  products { // this is public so will have data
    //    cost
    //  }
    // }
    //
    // the result of above *could* look like this:
    // {
    //   data: { products: [{ cost: "$10" }] },
    //   errors: [{
    //      message: 'your session has timed out',
    //      path: []
    //   }]
    // }
    // status code of above would be a 401
    // in the UI you want to show data where you can, errors as data where you can
    // and use correct http status codes
    observer.next(err.result);
    observer.error(err);
}
function $695364ed59a50254$export$d4051215bea0639f(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            return $695364ed59a50254$export$759bcb35b0d1bf81(response, bodyText);
        }).then(function(result) {
            if (!Array.isArray(result) && !$695364ed59a50254$var$hasOwnProperty.call(result, "data") && !$695364ed59a50254$var$hasOwnProperty.call(result, "errors")) // Data error
            (0, $0c5c0be8350d10a1$export$c33ef9219f27efd7)(response, result, "Server response was missing for query '".concat(Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName, "'."));
            return result;
        });
    };
}



var $c6ff112ba16d8c93$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === "undefined") throw (0, $c21c2000775800f2$export$3991762405098ea)(51);
};



var $b8xcN = parcelRequire("b8xcN");
/** @category Printing */ 
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 *
 * @internal
 */ function $49b8afe2c3a36515$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($49b8afe2c3a36515$var$escapedRegExp, $49b8afe2c3a36515$var$escapedReplacer)}"`;
}
/** @internal */ // eslint-disable-next-line no-control-regex
const $49b8afe2c3a36515$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $49b8afe2c3a36515$var$escapedReplacer(str) {
    return $49b8afe2c3a36515$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $49b8afe2c3a36515$var$escapeSequences = [
    '\\u0000',
    '\\u0001',
    '\\u0002',
    '\\u0003',
    '\\u0004',
    '\\u0005',
    '\\u0006',
    '\\u0007',
    '\\b',
    '\\t',
    '\\n',
    '\\u000B',
    '\\f',
    '\\r',
    '\\u000E',
    '\\u000F',
    '\\u0010',
    '\\u0011',
    '\\u0012',
    '\\u0013',
    '\\u0014',
    '\\u0015',
    '\\u0016',
    '\\u0017',
    '\\u0018',
    '\\u0019',
    '\\u001A',
    '\\u001B',
    '\\u001C',
    '\\u001D',
    '\\u001E',
    '\\u001F',
    '',
    '',
    '\\"',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\\\',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\u007F',
    '\\u0080',
    '\\u0081',
    '\\u0082',
    '\\u0083',
    '\\u0084',
    '\\u0085',
    '\\u0086',
    '\\u0087',
    '\\u0088',
    '\\u0089',
    '\\u008A',
    '\\u008B',
    '\\u008C',
    '\\u008D',
    '\\u008E',
    '\\u008F',
    '\\u0090',
    '\\u0091',
    '\\u0092',
    '\\u0093',
    '\\u0094',
    '\\u0095',
    '\\u0096',
    '\\u0097',
    '\\u0098',
    '\\u0099',
    '\\u009A',
    '\\u009B',
    '\\u009C',
    '\\u009D',
    '\\u009E',
    '\\u009F'
];



function $8503c5d86d4f30d0$export$c2d084dc44961371(ast) {
    return (0, $5c27cd6fd658cc32$export$bf638b60ea8b89b7)(ast, $8503c5d86d4f30d0$var$printDocASTReducer);
}
const $8503c5d86d4f30d0$var$MAX_LINE_LENGTH = 80;
const $8503c5d86d4f30d0$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>'$' + node.name
    },
    // Document
    Document: {
        leave: (node)=>$8503c5d86d4f30d0$var$join(node.definitions, '\n\n')
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $8503c5d86d4f30d0$var$hasMultilineItems(node.variableDefinitions) ? $8503c5d86d4f30d0$var$wrap('(\n', $8503c5d86d4f30d0$var$join(node.variableDefinitions, '\n'), '\n)') : $8503c5d86d4f30d0$var$wrap('(', $8503c5d86d4f30d0$var$join(node.variableDefinitions, ', '), ')');
            const prefix = $8503c5d86d4f30d0$var$wrap('', node.description, '\n') + $8503c5d86d4f30d0$var$join([
                node.operation,
                $8503c5d86d4f30d0$var$join([
                    node.name,
                    varDefs
                ]),
                $8503c5d86d4f30d0$var$join(node.directives, ' ')
            ], ' '); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives, description: description })=>$8503c5d86d4f30d0$var$wrap('', description, '\n') + variable + ': ' + type + $8503c5d86d4f30d0$var$wrap(' = ', defaultValue) + $8503c5d86d4f30d0$var$wrap(' ', $8503c5d86d4f30d0$var$join(directives, ' '))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$8503c5d86d4f30d0$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $8503c5d86d4f30d0$var$wrap('', alias, ': ') + name;
            let argsLine = prefix + $8503c5d86d4f30d0$var$wrap('(', $8503c5d86d4f30d0$var$join(args, ', '), ')');
            if (argsLine.length > $8503c5d86d4f30d0$var$MAX_LINE_LENGTH) argsLine = prefix + $8503c5d86d4f30d0$var$wrap('(\n', $8503c5d86d4f30d0$var$indent($8503c5d86d4f30d0$var$join(args, '\n')), '\n)');
            return $8503c5d86d4f30d0$var$join([
                argsLine,
                $8503c5d86d4f30d0$var$join(directives, ' '),
                selectionSet
            ], ' ');
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>'...' + name + $8503c5d86d4f30d0$var$wrap(' ', $8503c5d86d4f30d0$var$join(directives, ' '))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$8503c5d86d4f30d0$var$join([
                '...',
                $8503c5d86d4f30d0$var$wrap('on ', typeCondition),
                $8503c5d86d4f30d0$var$join(directives, ' '),
                selectionSet
            ], ' ')
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet, description: description })=>$8503c5d86d4f30d0$var$wrap('', description, '\n') + // Note: fragment variable definitions are experimental and may be changed
            // or removed in the future.
            `fragment ${name}${$8503c5d86d4f30d0$var$wrap('(', $8503c5d86d4f30d0$var$join(variableDefinitions, ', '), ')')} ` + `on ${typeCondition} ${$8503c5d86d4f30d0$var$wrap('', $8503c5d86d4f30d0$var$join(directives, ' '), ' ')}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $6afb3cc02f1d0b54$export$adb6ca997eeb1f45)(value) : (0, $49b8afe2c3a36515$export$3cdec7cf614a0ecc)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? 'true' : 'false'
    },
    NullValue: {
        leave: ()=>'null'
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>'[' + $8503c5d86d4f30d0$var$join(values, ', ') + ']'
    },
    ObjectValue: {
        leave: ({ fields: fields })=>'{' + $8503c5d86d4f30d0$var$join(fields, ', ') + '}'
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>'@' + name + $8503c5d86d4f30d0$var$wrap('(', $8503c5d86d4f30d0$var$join(args, ', '), ')')
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>'[' + type + ']'
    },
    NonNullType: {
        leave: ({ type: type })=>type + '!'
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$8503c5d86d4f30d0$var$wrap('', description, '\n') + $8503c5d86d4f30d0$var$join([
                'schema',
                $8503c5d86d4f30d0$var$join(directives, ' '),
                $8503c5d86d4f30d0$var$block(operationTypes)
            ], ' ')
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ': ' + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$8503c5d86d4f30d0$var$wrap('', description, '\n') + $8503c5d86d4f30d0$var$join([
                'scalar',
                name,
                $8503c5d86d4f30d0$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$8503c5d86d4f30d0$var$wrap('', description, '\n') + $8503c5d86d4f30d0$var$join([
                'type',
                name,
                $8503c5d86d4f30d0$var$wrap('implements ', $8503c5d86d4f30d0$var$join(interfaces, ' & ')),
                $8503c5d86d4f30d0$var$join(directives, ' '),
                $8503c5d86d4f30d0$var$block(fields)
            ], ' ')
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$8503c5d86d4f30d0$var$wrap('', description, '\n') + name + ($8503c5d86d4f30d0$var$hasMultilineItems(args) ? $8503c5d86d4f30d0$var$wrap('(\n', $8503c5d86d4f30d0$var$indent($8503c5d86d4f30d0$var$join(args, '\n')), '\n)') : $8503c5d86d4f30d0$var$wrap('(', $8503c5d86d4f30d0$var$join(args, ', '), ')')) + ': ' + type + $8503c5d86d4f30d0$var$wrap(' ', $8503c5d86d4f30d0$var$join(directives, ' '))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$8503c5d86d4f30d0$var$wrap('', description, '\n') + $8503c5d86d4f30d0$var$join([
                name + ': ' + type,
                $8503c5d86d4f30d0$var$wrap('= ', defaultValue),
                $8503c5d86d4f30d0$var$join(directives, ' ')
            ], ' ')
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$8503c5d86d4f30d0$var$wrap('', description, '\n') + $8503c5d86d4f30d0$var$join([
                'interface',
                name,
                $8503c5d86d4f30d0$var$wrap('implements ', $8503c5d86d4f30d0$var$join(interfaces, ' & ')),
                $8503c5d86d4f30d0$var$join(directives, ' '),
                $8503c5d86d4f30d0$var$block(fields)
            ], ' ')
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$8503c5d86d4f30d0$var$wrap('', description, '\n') + $8503c5d86d4f30d0$var$join([
                'union',
                name,
                $8503c5d86d4f30d0$var$join(directives, ' '),
                $8503c5d86d4f30d0$var$wrap('= ', $8503c5d86d4f30d0$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$8503c5d86d4f30d0$var$wrap('', description, '\n') + $8503c5d86d4f30d0$var$join([
                'enum',
                name,
                $8503c5d86d4f30d0$var$join(directives, ' '),
                $8503c5d86d4f30d0$var$block(values)
            ], ' ')
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$8503c5d86d4f30d0$var$wrap('', description, '\n') + $8503c5d86d4f30d0$var$join([
                name,
                $8503c5d86d4f30d0$var$join(directives, ' ')
            ], ' ')
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$8503c5d86d4f30d0$var$wrap('', description, '\n') + $8503c5d86d4f30d0$var$join([
                'input',
                name,
                $8503c5d86d4f30d0$var$join(directives, ' '),
                $8503c5d86d4f30d0$var$block(fields)
            ], ' ')
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, directives: directives, repeatable: repeatable, locations: locations })=>$8503c5d86d4f30d0$var$wrap('', description, '\n') + 'directive @' + name + ($8503c5d86d4f30d0$var$hasMultilineItems(args) ? $8503c5d86d4f30d0$var$wrap('(\n', $8503c5d86d4f30d0$var$indent($8503c5d86d4f30d0$var$join(args, '\n')), '\n)') : $8503c5d86d4f30d0$var$wrap('(', $8503c5d86d4f30d0$var$join(args, ', '), ')')) + $8503c5d86d4f30d0$var$wrap(' ', $8503c5d86d4f30d0$var$join(directives, ' ')) + (repeatable ? ' repeatable' : '') + ' on ' + $8503c5d86d4f30d0$var$join(locations, ' | ')
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$8503c5d86d4f30d0$var$join([
                'extend schema',
                $8503c5d86d4f30d0$var$join(directives, ' '),
                $8503c5d86d4f30d0$var$block(operationTypes)
            ], ' ')
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$8503c5d86d4f30d0$var$join([
                'extend scalar',
                name,
                $8503c5d86d4f30d0$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$8503c5d86d4f30d0$var$join([
                'extend type',
                name,
                $8503c5d86d4f30d0$var$wrap('implements ', $8503c5d86d4f30d0$var$join(interfaces, ' & ')),
                $8503c5d86d4f30d0$var$join(directives, ' '),
                $8503c5d86d4f30d0$var$block(fields)
            ], ' ')
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$8503c5d86d4f30d0$var$join([
                'extend interface',
                name,
                $8503c5d86d4f30d0$var$wrap('implements ', $8503c5d86d4f30d0$var$join(interfaces, ' & ')),
                $8503c5d86d4f30d0$var$join(directives, ' '),
                $8503c5d86d4f30d0$var$block(fields)
            ], ' ')
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$8503c5d86d4f30d0$var$join([
                'extend union',
                name,
                $8503c5d86d4f30d0$var$join(directives, ' '),
                $8503c5d86d4f30d0$var$wrap('= ', $8503c5d86d4f30d0$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$8503c5d86d4f30d0$var$join([
                'extend enum',
                name,
                $8503c5d86d4f30d0$var$join(directives, ' '),
                $8503c5d86d4f30d0$var$block(values)
            ], ' ')
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$8503c5d86d4f30d0$var$join([
                'extend input',
                name,
                $8503c5d86d4f30d0$var$join(directives, ' '),
                $8503c5d86d4f30d0$var$block(fields)
            ], ' ')
    },
    DirectiveExtension: {
        leave: ({ name: name, directives: directives })=>$8503c5d86d4f30d0$var$join([
                'extend directive @' + name,
                $8503c5d86d4f30d0$var$join(directives, ' ')
            ], ' ')
    },
    // Schema Coordinates
    TypeCoordinate: {
        leave: ({ name: name })=>name
    },
    MemberCoordinate: {
        leave: ({ name: name, memberName: memberName })=>$8503c5d86d4f30d0$var$join([
                name,
                $8503c5d86d4f30d0$var$wrap('.', memberName)
            ])
    },
    ArgumentCoordinate: {
        leave: ({ name: name, fieldName: fieldName, argumentName: argumentName })=>$8503c5d86d4f30d0$var$join([
                name,
                $8503c5d86d4f30d0$var$wrap('.', fieldName),
                $8503c5d86d4f30d0$var$wrap('(', argumentName, ':)')
            ])
    },
    DirectiveCoordinate: {
        leave: ({ name: name })=>$8503c5d86d4f30d0$var$join([
                '@',
                name
            ])
    },
    DirectiveArgumentCoordinate: {
        leave: ({ name: name, argumentName: argumentName })=>$8503c5d86d4f30d0$var$join([
                '@',
                name,
                $8503c5d86d4f30d0$var$wrap('(', argumentName, ':)')
            ])
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 *
 * @internal
 */ function $8503c5d86d4f30d0$var$join(maybeArray, separator = '') {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 *
 * @internal
 */ function $8503c5d86d4f30d0$var$block(array) {
    return $8503c5d86d4f30d0$var$wrap('{\n', $8503c5d86d4f30d0$var$indent($8503c5d86d4f30d0$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 *
 * @internal
 */ function $8503c5d86d4f30d0$var$wrap(start, maybeString, end = '') {
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $8503c5d86d4f30d0$var$indent(str) {
    return $8503c5d86d4f30d0$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $8503c5d86d4f30d0$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes('\n'))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}




var $545086ab9b229dc6$var$printCache;
var $545086ab9b229dc6$export$c2d084dc44961371 = Object.assign(function(ast) {
    var result = $545086ab9b229dc6$var$printCache.get(ast);
    if (!result) {
        result = (0, $8503c5d86d4f30d0$export$c2d084dc44961371)(ast);
        $545086ab9b229dc6$var$printCache.set(ast, result);
    }
    return result;
}, {
    reset: function() {
        $545086ab9b229dc6$var$printCache = new (0, $cee967300b629dc7$export$8dbad6f439bb2331)((0, $d301603631c7863b$export$f29926b23b28936b).print || 2000 /* defaultCacheSizes.print */ );
    }
});
$545086ab9b229dc6$export$c2d084dc44961371.reset();
if (globalThis.__DEV__ !== false) (0, $afbf6f02b98da1f0$export$a8fcd406d9e37621)("print", function() {
    return $545086ab9b229dc6$var$printCache ? $545086ab9b229dc6$var$printCache.size : 0;
});


var $d900b9a6bfb6f4d1$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false
};
var $d900b9a6bfb6f4d1$var$defaultHeaders = {
    // headers are case insensitive (https://stackoverflow.com/a/5259004)
    accept: "*/*",
    // The content-type header describes the type of the body of the request, and
    // so it typically only is sent with requests that actually have bodies. One
    // could imagine that Apollo Client would remove this header when constructing
    // a GET request (which has no body), but we historically have not done that.
    // This means that browsers will preflight all Apollo Client requests (even
    // GET requests). Apollo Server's CSRF prevention feature (introduced in
    // AS3.7) takes advantage of this fact and does not block requests with this
    // header. If you want to drop this header from GET requests, then you should
    // probably replace it with a `apollo-require-preflight` header, or servers
    // with CSRF prevention enabled might block your GET request. See
    // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
    // for more details.
    "content-type": "application/json"
};
var $d900b9a6bfb6f4d1$var$defaultOptions = {
    method: "POST"
};
var $d900b9a6bfb6f4d1$export$dd86f00dc866e75d = {
    http: $d900b9a6bfb6f4d1$var$defaultHttpOptions,
    headers: $d900b9a6bfb6f4d1$var$defaultHeaders,
    options: $d900b9a6bfb6f4d1$var$defaultOptions
};
var $d900b9a6bfb6f4d1$export$e88934976ca4fd65 = function(ast, printer) {
    return printer(ast);
};
function $d900b9a6bfb6f4d1$export$a00ebfd5f1eebfb1(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    configs.unshift(fallbackConfig);
    return $d900b9a6bfb6f4d1$export$12d90ccf75844275.apply(void 0, (0, $b8xcN.__spreadArray)([
        operation,
        $d900b9a6bfb6f4d1$export$e88934976ca4fd65
    ], configs, false));
}
function $d900b9a6bfb6f4d1$export$12d90ccf75844275(operation, printer) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = {};
    var http = {};
    configs.forEach(function(config) {
        options = (0, $b8xcN.__assign)((0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, options), config.options), {
            headers: (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, options.headers), config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, http), config.http);
    });
    if (options.headers) options.headers = $d900b9a6bfb6f4d1$var$removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    //The body depends on the http options
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    // not sending the query (i.e persisted queries)
    if (http.includeQuery) body.query = printer(query, (0, $545086ab9b229dc6$export$c2d084dc44961371));
    return {
        options: options,
        body: body
    };
}
// Remove potential duplicate header names, preserving last (by insertion order).
// This is done to prevent unintentionally duplicating a header instead of
// overwriting it (See #8447 and #8449).
function $d900b9a6bfb6f4d1$var$removeDuplicateHeaders(headers, preserveHeaderCase) {
    // If we're not preserving the case, just remove duplicates w/ normalization.
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = {};
        Object.keys(Object(headers)).forEach(function(name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    // If we are preserving the case, remove duplicates w/ normalization,
    // preserving the original name.
    // This allows for non-http-spec-compliant servers that expect intentionally
    // capitalized header names (See #6741).
    var headerData = {};
    Object.keys(Object(headers)).forEach(function(name) {
        headerData[name.toLowerCase()] = {
            originalName: name,
            value: headers[name]
        };
    });
    var normalizedHeaders = {};
    Object.keys(headerData).forEach(function(name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}



function $97c53b82424f11ee$export$fb82bb094b6f76b5(chosenURI, body) {
    // Implement the standard HTTP GET serialization, plus 'extensions'. Note
    // the extra level of JSON serialization!
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ("query" in body) addQueryParam("query", body.query);
    if (body.operationName) addQueryParam("operationName", body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $b963aaf136324f3c$export$5f8e80ac52052e28)(body.variables, "Variables map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("variables", serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $b963aaf136324f3c$export$5f8e80ac52052e28)(body.extensions, "Extensions map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("extensions", serializedExtensions);
    }
    // Reconstruct the URI with added query params.
    // XXX This assumes that the URI is well-formed and that it doesn't
    //     already contain any of these query params. We could instead use the
    //     URL API and take a polyfill (whatwg-url@6) for older browsers that
    //     don't support URLSearchParams. Note that some browsers (and
    //     versions of whatwg-url) support URL but not URLSearchParams!
    var fragment = "", preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf("#");
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf("?") === -1 ? "?" : "&";
    var newURI = preFragment + queryParamsPrefix + queryParams.join("&") + fragment;
    return {
        newURI: newURI
    };
}



var $b8xcN = parcelRequire("b8xcN");

function $4a200a9fd21410b9$export$de246493ae27fe3f(variables, query) {
    var result = (0, $b8xcN.__assign)({}, variables);
    var unusedNames = new Set(Object.keys(variables));
    (0, $5c27cd6fd658cc32$export$bf638b60ea8b89b7)(query, {
        Variable: function(node, _key, parent) {
            // A variable type definition at the top level of a query is not
            // enough to silence server-side errors about the variable being
            // unused, so variable definitions do not count as usage.
            // https://spec.graphql.org/draft/#sec-All-Variables-Used
            if (parent && parent.kind !== "VariableDefinition") unusedNames.delete(node.name.value);
        }
    });
    unusedNames.forEach(function(name) {
        delete result[name];
    });
    return result;
}


function $e2e2738150ac8ce4$export$4fd972edbe7450d3(errorValue) {
    return new (0, $2027033ce24a9479$export$77cea355fa80b5f4)(function(observer) {
        observer.error(errorValue);
    });
}


var $d0243774c0c3ea75$var$backupFetch = (0, $9ead41c1c895fb32$export$f8b8b9ce72e9ccbf)(function() {
    return fetch;
});
var $d0243774c0c3ea75$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? "/graphql" : _a, // use default global fetch if nothing passed in
    preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? (0, $d900b9a6bfb6f4d1$export$e88934976ca4fd65) : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0, $b8xcN.__rest)(linkOptions, [
        "uri",
        "fetch",
        "print",
        "includeExtensions",
        "preserveHeaderCase",
        "useGETForQueries",
        "includeUnusedVariables"
    ]);
    if (globalThis.__DEV__ !== false) // Make sure at least one of preferredFetch, window.fetch, or backupFetch is
    // defined, so requests won't fail at runtime.
    (0, $c6ff112ba16d8c93$export$8423f0cd3773115e)(preferredFetch || $d0243774c0c3ea75$var$backupFetch);
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions,
            preserveHeaderCase: preserveHeaderCase
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $b03f28e182db18c2$export$2fed3d61f740bc7f)(function(operation) {
        var chosenURI = (0, $04a54661f6d426bd$export$63ccc2571850f81a)(operation, uri);
        var context = operation.getContext();
        // `apollographql-client-*` headers are automatically set if a
        // `clientAwareness` object is found in the context. These headers are
        // set first, followed by the rest of the headers pulled from
        // `context.headers`. If desired, `apollographql-client-*` headers set by
        // the `clientAwareness` object can be overridden by
        // `apollographql-client-*` headers set in `context.headers`.
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders["apollographql-client-name"] = name_1;
            if (version) clientAwarenessHeaders["apollographql-client-version"] = version;
        }
        var contextHeaders = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        if ((0, $5a6e90bd3aec77b4$export$2dafb573e282fe8d)([
            "client"
        ], operation.query)) {
            if (globalThis.__DEV__ !== false) globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(52);
            var transformedQuery = (0, $19cabdf265088897$export$8eae69e876ee321e)(operation.query);
            if (!transformedQuery) return (0, $e2e2738150ac8ce4$export$4fd972edbe7450d3)(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
            operation.query = transformedQuery;
        }
        //uses fallback, link, and then context to build options
        var _b = (0, $d900b9a6bfb6f4d1$export$12d90ccf75844275)(operation, print, (0, $d900b9a6bfb6f4d1$export$dd86f00dc866e75d), linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) body.variables = (0, $4a200a9fd21410b9$export$de246493ae27fe3f)(body.variables, operation.query);
        var controller;
        if (!options.signal && typeof AbortController !== "undefined") {
            controller = new AbortController();
            options.signal = controller.signal;
        }
        // If requested, set method to GET if there are no mutations.
        var definitionIsMutation = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "mutation";
        };
        var definitionIsSubscription = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "subscription";
        };
        var isSubscription = definitionIsSubscription((0, $6d75937eba8e6f1c$export$f431198736b7f96d)(operation.query));
        // does not match custom directives beginning with @defer
        var hasDefer = (0, $5a6e90bd3aec77b4$export$2dafb573e282fe8d)([
            "defer"
        ], operation.query);
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = "GET";
        if (hasDefer || isSubscription) {
            options.headers = options.headers || {};
            var acceptHeader = "multipart/mixed;";
            // Omit defer-specific headers if the user attempts to defer a selection
            // set on a subscription and log a warning.
            if (isSubscription && hasDefer) globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(53);
            if (isSubscription) acceptHeader += "boundary=graphql;subscriptionSpec=1.0,application/json";
            else if (hasDefer) acceptHeader += "deferSpec=20220824,application/json";
            options.headers.accept = acceptHeader;
        }
        if (options.method === "GET") {
            var _c = (0, $97c53b82424f11ee$export$fb82bb094b6f76b5)(chosenURI, body), newURI = _c.newURI, parseError = _c.parseError;
            if (parseError) return (0, $e2e2738150ac8ce4$export$4fd972edbe7450d3)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $b963aaf136324f3c$export$5f8e80ac52052e28)(body, "Payload");
        } catch (parseError) {
            return (0, $e2e2738150ac8ce4$export$4fd972edbe7450d3)(parseError);
        }
        return new (0, $2027033ce24a9479$export$77cea355fa80b5f4)(function(observer) {
            // Prefer linkOptions.fetch (preferredFetch) if provided, and otherwise
            // fall back to the *current* global window.fetch function (see issue
            // #7832), or (if all else fails) the backupFetch function we saved when
            // this module was first evaluated. This last option protects against the
            // removal of window.fetch, which is unlikely but not impossible.
            var currentFetch = preferredFetch || (0, $9ead41c1c895fb32$export$f8b8b9ce72e9ccbf)(function() {
                return fetch;
            }) || $d0243774c0c3ea75$var$backupFetch;
            var observerNext = observer.next.bind(observer);
            currentFetch(chosenURI, options).then(function(response) {
                var _a;
                operation.setContext({
                    response: response
                });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) return (0, $695364ed59a50254$export$ccb60864026baf09)(response, observerNext);
                else return (0, $695364ed59a50254$export$d4051215bea0639f)(operation)(response).then(observerNext);
            }).then(function() {
                controller = undefined;
                observer.complete();
            }).catch(function(err) {
                controller = undefined;
                (0, $695364ed59a50254$export$d3da1ecaf1206c58)(err, observer);
            });
            return function() {
                // XXX support canceling this request
                // https://developers.google.com/web/updates/2017/09/abortable-fetch
                if (controller) controller.abort();
            };
        });
    });
};


var $7f67f06dc899def3$export$f4bbf1aec241cc1 = /** @class */ function(_super) {
    (0, $b8xcN.__extends)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, (0, $d0243774c0c3ea75$export$95180a16573d6675)(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}((0, $b03f28e182db18c2$export$2fed3d61f740bc7f));



var $b8xcN = parcelRequire("b8xcN");




function $ec3d440bb8fa39d3$export$707ee4c4c95d39e3(observable, mapFn, catchFn) {
    return new (0, $2027033ce24a9479$export$77cea355fa80b5f4)(function(observer) {
        var promiseQueue = {
            // Normally we would initialize promiseQueue to Promise.resolve(), but
            // in this case, for backwards compatibility, we need to be careful to
            // invoke the first callback synchronously.
            then: function(callback) {
                return new Promise(function(resolve) {
                    return resolve(callback());
                });
            }
        };
        function makeCallback(examiner, key) {
            return function(arg) {
                if (examiner) {
                    var both = function() {
                        // If the observer is closed, we don't want to continue calling the
                        // mapping function - it's result will be swallowed anyways.
                        return observer.closed ? /* will be swallowed */ 0 : examiner(arg);
                    };
                    promiseQueue = promiseQueue.then(both, both).then(function(result) {
                        return observer.next(result);
                    }, function(error) {
                        return observer.error(error);
                    });
                } else observer[key](arg);
            };
        }
        var handler = {
            next: makeCallback(mapFn, "next"),
            error: makeCallback(catchFn, "error"),
            complete: function() {
                // no need to reassign `promiseQueue`, after `observer.complete`,
                // the observer will be closed and short-circuit everything anyways
                /*promiseQueue = */ promiseQueue.then(function() {
                    return observer.complete();
                });
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}


var $b8xcN = parcelRequire("b8xcN");



function $0cc1d115a29da4c6$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// A Concast<T> observable concatenates the given sources into a single
// non-overlapping sequence of Ts, automatically unwrapping any promises,
// and broadcasts the T elements of that sequence to any number of
// subscribers, all without creating a bunch of intermediary Observable
// wrapper objects.
//
// Even though any number of observers can subscribe to the Concast, each
// source observable is guaranteed to receive at most one subscribe call,
// and the results are multicast to all observers.
//
// In addition to broadcasting every next/error message to this.observers,
// the Concast stores the most recent message using this.latest, so any
// new observers can immediately receive the latest message, even if it
// was originally delivered in the past. This behavior means we can assume
// every active observer in this.observers has received the same most
// recent message.
//
// With the exception of this.latest replay, a Concast is a "hot"
// observable in the sense that it does not replay past results from the
// beginning of time for each new observer.
//
// Could we have used some existing RxJS class instead? Concast<T> is
// similar to a BehaviorSubject<T>, because it is multicast and redelivers
// the latest next/error message to new subscribers. Unlike Subject<T>,
// Concast<T> does not expose an Observer<T> interface (this.handlers is
// intentionally private), since Concast<T> gets its inputs from the
// concatenated sources. If we ever switch to RxJS, there may be some
// value in reusing their code, but for now we use zen-observable, which
// does not contain any Subject implementations.
var $0cc1d115a29da4c6$export$ae0cf2ec7a6fa78e = /** @class */ function(_super) {
    (0, $b8xcN.__extends)(Concast, _super);
    // Not only can the individual elements of the iterable be promises, but
    // also the iterable itself can be wrapped in a promise.
    function Concast(sources) {
        var _this = _super.call(this, function(observer) {
            _this.addObserver(observer);
            return function() {
                return _this.removeObserver(observer);
            };
        }) || this;
        // Active observers receiving broadcast messages. Thanks to this.latest,
        // we can assume all observers in this Set have received the same most
        // recent message, though possibly at different times in the past.
        _this.observers = new Set();
        _this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        // Bound handler functions that can be reused for every internal
        // subscription.
        _this.handlers = {
            next: function(result) {
                if (_this.sub !== null) {
                    _this.latest = [
                        "next",
                        result
                    ];
                    _this.notify("next", result);
                    (0, $16482974f2c55194$export$9f6c99ae166dbeca)(_this.observers, "next", result);
                }
            },
            error: function(error) {
                var sub = _this.sub;
                if (sub !== null) {
                    // Delay unsubscribing from the underlying subscription slightly,
                    // so that immediately subscribing another observer can keep the
                    // subscription active.
                    if (sub) setTimeout(function() {
                        return sub.unsubscribe();
                    });
                    _this.sub = null;
                    _this.latest = [
                        "error",
                        error
                    ];
                    _this.reject(error);
                    _this.notify("error", error);
                    (0, $16482974f2c55194$export$9f6c99ae166dbeca)(_this.observers, "error", error);
                }
            },
            complete: function() {
                var _a = _this, sub = _a.sub, _b = _a.sources, sources = _b === void 0 ? [] : _b;
                if (sub !== null) {
                    // If complete is called before concast.start, this.sources may be
                    // undefined, so we use a default value of [] for sources. That works
                    // here because it falls into the if (!value) {...} block, which
                    // appropriately terminates the Concast, even if this.sources might
                    // eventually have been initialized to a non-empty array.
                    var value = sources.shift();
                    if (!value) {
                        if (sub) setTimeout(function() {
                            return sub.unsubscribe();
                        });
                        _this.sub = null;
                        if (_this.latest && _this.latest[0] === "next") _this.resolve(_this.latest[1]);
                        else _this.resolve();
                        _this.notify("complete");
                        // We do not store this.latest = ["complete"], because doing so
                        // discards useful information about the previous next (or
                        // error) message. Instead, if new observers subscribe after
                        // this Concast has completed, they will receive the final
                        // 'next' message (unless there was an error) immediately
                        // followed by a 'complete' message (see addObserver).
                        (0, $16482974f2c55194$export$9f6c99ae166dbeca)(_this.observers, "complete");
                    } else if ($0cc1d115a29da4c6$var$isPromiseLike(value)) value.then(function(obs) {
                        return _this.sub = obs.subscribe(_this.handlers);
                    }, _this.handlers.error);
                    else _this.sub = value.subscribe(_this.handlers);
                }
            }
        };
        _this.nextResultListeners = new Set();
        // A public way to abort observation and broadcast.
        _this.cancel = function(reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.error(reason);
        };
        // Suppress rejection warnings for this.promise, since it's perfectly
        // acceptable to pay no attention to this.promise if you're consuming
        // the results through the normal observable API.
        _this.promise.catch(function(_) {});
        // If someone accidentally tries to create a Concast using a subscriber
        // function, recover by creating an Observable from that subscriber and
        // using it as the source.
        if (typeof sources === "function") sources = [
            new (0, $2027033ce24a9479$export$77cea355fa80b5f4)(sources)
        ];
        if ($0cc1d115a29da4c6$var$isPromiseLike(sources)) sources.then(function(iterable) {
            return _this.start(iterable);
        }, _this.handlers.error);
        else _this.start(sources);
        return _this;
    }
    Concast.prototype.start = function(sources) {
        if (this.sub !== void 0) return;
        // In practice, sources is most often simply an Array of observables.
        // TODO Consider using sources[Symbol.iterator]() to take advantage
        // of the laziness of non-Array iterables.
        this.sources = Array.from(sources);
        // Calling this.handlers.complete() kicks off consumption of the first
        // source observable. It's tempting to do this step lazily in
        // addObserver, but this.promise can be accessed without calling
        // addObserver, so consumption needs to begin eagerly.
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function(observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) method.call(observer, this.latest[1]);
            // If the subscription is already closed, and the last message was
            // a 'next' message, simulate delivery of the final 'complete'
            // message again.
            if (this.sub === null && nextOrError === "next" && observer.complete) observer.complete();
        }
    };
    Concast.prototype.addObserver = function(observer) {
        if (!this.observers.has(observer)) {
            // Immediately deliver the most recent message, so we can always
            // be sure all observers have the latest information.
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function(observer) {
        if (this.observers.delete(observer) && this.observers.size < 1) // In case there are still any listeners in this.nextResultListeners, and
        // no error or completion has been broadcast yet, make sure those
        // observers have a chance to run and then remove themselves from
        // this.observers.
        this.handlers.complete();
    };
    Concast.prototype.notify = function(method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            // Replacing this.nextResultListeners first ensures it does not grow while
            // we are iterating over it, potentially leading to infinite loops.
            this.nextResultListeners = new Set();
            nextResultListeners.forEach(function(listener) {
                return listener(method, arg);
            });
        }
    };
    // We need a way to run callbacks just *before* the next result (or error or
    // completion) is delivered by this Concast, so we can be sure any code that
    // runs as a result of delivering that result/error observes the effects of
    // running the callback(s). It was tempting to reuse the Observer type instead
    // of introducing NextResultListener, but that messes with the sizing and
    // maintenance of this.observers, and ends up being more code overall.
    Concast.prototype.beforeNext = function(callback) {
        var called = false;
        this.nextResultListeners.add(function(method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}((0, $2027033ce24a9479$export$77cea355fa80b5f4));
// Necessary because the Concast constructor has a different signature
// than the Observable constructor.
(0, $ac8a77922bdd1f1c$export$33c8bd820eece9b2)($0cc1d115a29da4c6$export$ae0cf2ec7a6fa78e);








function $e10872a8609e2fee$var$identity(document) {
    return document;
}
var $e10872a8609e2fee$export$f887060e48e5dc1b = /** @class */ function() {
    function DocumentTransform(transform, options) {
        if (options === void 0) options = Object.create(null);
        this.resultCache = (0, $138881ab8f31fa6b$export$7293b8a0b474028d) ? new WeakSet() : new Set();
        this.transform = transform;
        if (options.getCacheKey) // Override default `getCacheKey` function, which returns [document].
        this.getCacheKey = options.getCacheKey;
        this.cached = options.cache !== false;
        this.resetCache();
    }
    // This default implementation of getCacheKey can be overridden by providing
    // options.getCacheKey to the DocumentTransform constructor. In general, a
    // getCacheKey function may either return an array of keys (often including
    // the document) to be used as a cache key, or undefined to indicate the
    // transform for this document should not be cached.
    DocumentTransform.prototype.getCacheKey = function(document) {
        return [
            document
        ];
    };
    DocumentTransform.identity = function() {
        // No need to cache this transform since it just returns the document
        // unchanged. This should save a bit of memory that would otherwise be
        // needed to populate the `documentCache` of this transform.
        return new DocumentTransform($e10872a8609e2fee$var$identity, {
            cache: false
        });
    };
    DocumentTransform.split = function(predicate, left, right) {
        if (right === void 0) right = DocumentTransform.identity();
        return Object.assign(new DocumentTransform(function(document) {
            var documentTransform = predicate(document) ? left : right;
            return documentTransform.transformDocument(document);
        }, // Reasonably assume both `left` and `right` transforms handle their own caching
        {
            cache: false
        }), {
            left: left,
            right: right
        });
    };
    /**
     * Resets the internal cache of this transform, if it has one.
     */ DocumentTransform.prototype.resetCache = function() {
        var _this = this;
        if (this.cached) {
            var stableCacheKeys_1 = new (0, $722ae841a583e691$export$73571c50d0f2507e)((0, $138881ab8f31fa6b$export$772fbc04a0ad4ce9));
            this.performWork = (0, $2a919cc3f1f126e4$export$4997ffc0176396a6)(DocumentTransform.prototype.performWork.bind(this), {
                makeCacheKey: function(document) {
                    var cacheKeys = _this.getCacheKey(document);
                    if (cacheKeys) {
                        (0, $c21c2000775800f2$export$f5708dca728d7177)(Array.isArray(cacheKeys), 104);
                        return stableCacheKeys_1.lookupArray(cacheKeys);
                    }
                },
                max: (0, $d301603631c7863b$export$f29926b23b28936b)["documentTransform.cache"],
                cache: (0, $2e667e6fa29c5a74$export$87b462129af3b7d4)
            });
        }
    };
    DocumentTransform.prototype.performWork = function(document) {
        (0, $6d75937eba8e6f1c$export$a7d0d8111d2386df)(document);
        return this.transform(document);
    };
    DocumentTransform.prototype.transformDocument = function(document) {
        // If a user passes an already transformed result back to this function,
        // immediately return it.
        if (this.resultCache.has(document)) return document;
        var transformedDocument = this.performWork(document);
        this.resultCache.add(transformedDocument);
        return transformedDocument;
    };
    DocumentTransform.prototype.concat = function(otherTransform) {
        var _this = this;
        return Object.assign(new DocumentTransform(function(document) {
            return otherTransform.transformDocument(_this.transformDocument(document));
        }, // Reasonably assume both transforms handle their own caching
        {
            cache: false
        }), {
            left: this,
            right: otherTransform
        });
    };
    return DocumentTransform;
}();



function $7bc1793b21dca6f3$export$b4df399e879e53ab(result) {
    var errors = $7bc1793b21dca6f3$export$a163557155188b6e(result);
    return (0, $01c8f68cc3e070ef$export$d307f5934e447d0e)(errors);
}
function $7bc1793b21dca6f3$export$a163557155188b6e(result) {
    var graphQLErrors = (0, $01c8f68cc3e070ef$export$d307f5934e447d0e)(result.errors) ? result.errors.slice(0) : [];
    if ((0, $c6f9e6ad9f49962f$export$879767c5cdf33cb3)(result) && (0, $01c8f68cc3e070ef$export$d307f5934e447d0e)(result.incremental)) result.incremental.forEach(function(incrementalResult) {
        if (incrementalResult.errors) graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
    });
    return graphQLErrors;
}








var $b8xcN = parcelRequire("b8xcN");



var $582c5d6426cf649e$var$destructiveMethodCounts = new ((0, $138881ab8f31fa6b$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
function $582c5d6426cf649e$var$wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") // @ts-expect-error this is just too generic to be typed correctly
    cache[methodName] = function() {
        $582c5d6426cf649e$var$destructiveMethodCounts.set(cache, // The %1e15 allows the count to wrap around to 0 safely every
        // quadrillion evictions, so there's no risk of overflow. To be
        // clear, this is more of a pedantic principle than something
        // that matters in any conceivable practical scenario.
        ($582c5d6426cf649e$var$destructiveMethodCounts.get(cache) + 1) % 1e15);
        // @ts-expect-error this is just too generic to be typed correctly
        return original.apply(this, arguments);
    };
}
// A QueryInfo object represents a single query managed by the
// QueryManager, which tracks all QueryInfo objects by queryId in its
// this.queries Map. QueryInfo objects store the latest results and errors
// for the given query, and are responsible for reporting those results to
// the corresponding ObservableQuery, via the QueryInfo.notify method.
// Results are reported asynchronously whenever setDiff marks the
// QueryInfo object as dirty, though a call to the QueryManager's
// broadcastQueries method may trigger the notification before it happens
// automatically. This class used to be a simple interface type without
// any field privacy or meaningful methods, which is why it still has so
// many public fields. The effort to lock down and simplify the QueryInfo
// interface is ongoing, and further improvements are welcome.
var $582c5d6426cf649e$export$79a6120a39c90b6a = /** @class */ function() {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) queryId = queryManager.generateQueryId();
        this.queryId = queryId;
        this.document = null;
        this.lastRequestId = 1;
        this.stopped = false;
        this.observableQuery = null;
        var cache = this.cache = queryManager.cache;
        // Track how often cache.evict is called, since we want eviction to
        // override the feud-stopping logic in the markResult method, by
        // causing shouldWrite to return true. Wrapping the cache.evict method
        // is a bit of a hack, but it saves us from having to make eviction
        // counting an official part of the ApolloCache API.
        if (!$582c5d6426cf649e$var$destructiveMethodCounts.has(cache)) {
            $582c5d6426cf649e$var$destructiveMethodCounts.set(cache, 0);
            $582c5d6426cf649e$var$wrapDestructiveCacheMethod(cache, "evict");
            $582c5d6426cf649e$var$wrapDestructiveCacheMethod(cache, "modify");
            $582c5d6426cf649e$var$wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function(query) {
        var networkStatus = query.networkStatus || (0, $7f070805c91ccc41$export$bd096ddbd246c79c).loading;
        if (this.variables && this.networkStatus !== (0, $7f070805c91ccc41$export$bd096ddbd246c79c).loading && !(0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(this.variables, query.variables)) networkStatus = (0, $7f070805c91ccc41$export$bd096ddbd246c79c).setVariables;
        if (!(0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(query.variables, this.variables)) {
            this.lastDiff = void 0;
            // Ensure we don't continue to receive cache updates for old variables
            this.cancel();
        }
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus
        });
        if (query.observableQuery) this.setObservableQuery(query.observableQuery);
        if (query.lastRequestId) this.lastRequestId = query.lastRequestId;
        return this;
    };
    QueryInfo.prototype.resetDiff = function() {
        this.lastDiff = void 0;
    };
    QueryInfo.prototype.getDiff = function() {
        var _this = this;
        var options = this.getDiffOptions();
        if (this.lastDiff && (0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(options, this.lastDiff.options)) return this.lastDiff.diff;
        this.updateWatch(this.variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return {
            complete: false
        };
        var diff = (0, $14465ad01ccc354a$export$d18d1529326946c4)("canonizeResults", function() {
            return _this.cache.diff(options);
        });
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function(diff, options) {
        this.lastDiff = diff ? {
            diff: diff,
            options: options || this.getDiffOptions()
        } : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function(variables) {
        var _a;
        if (variables === void 0) variables = this.variables;
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults
        };
    };
    QueryInfo.prototype.setDiff = function(diff) {
        var _this = this;
        var _a;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        // If we are trying to deliver an incomplete cache result, we avoid
        // reporting it if the query has errored, otherwise we let the broadcast try
        // and repair the partial result by refetching the query. This check avoids
        // a situation where a query that errors and another succeeds with
        // overlapping data does not report the partial data result to the errored
        // query.
        //
        // See https://github.com/apollographql/apollo-client/issues/11400 for more
        // information on this issue.
        if (diff && !diff.complete && (0, $14465ad01ccc354a$export$d18d1529326946c4)("getLastError", function() {
            var _a;
            return (_a = _this.observableQuery) === null || _a === void 0 ? void 0 : _a.getLastError();
        })) return;
        this.updateLastDiff(diff);
        if (!(0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(oldDiff && oldDiff.result, diff && diff.result)) (_a = this.observableQuery) === null || _a === void 0 || _a["scheduleNotify"]();
    };
    QueryInfo.prototype.setObservableQuery = function(oq) {
        if (oq === this.observableQuery) return;
        this.observableQuery = oq;
        if (oq) oq["queryInfo"] = this;
    };
    QueryInfo.prototype.stop = function() {
        var _a;
        if (!this.stopped) {
            this.stopped = true;
            // Cancel the pending notify timeout
            (_a = this.observableQuery) === null || _a === void 0 || _a["resetNotifications"]();
            this.cancel();
            var oq = this.observableQuery;
            if (oq) oq.stopPolling();
        }
    };
    QueryInfo.prototype.cancel = function() {
        var _a;
        (_a = this.cancelWatch) === null || _a === void 0 || _a.call(this);
        this.cancelWatch = void 0;
    };
    QueryInfo.prototype.updateWatch = function(variables) {
        var _this = this;
        if (variables === void 0) variables = this.variables;
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return;
        var watchOptions = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, this.getDiffOptions(variables)), {
            watcher: this,
            callback: function(diff) {
                return _this.setDiff(diff);
            }
        });
        if (!this.lastWatch || !(0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancelWatch = this.cache.watch(this.lastWatch = watchOptions);
        }
    };
    QueryInfo.prototype.resetLastWrite = function() {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function(result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite && // If cache.evict has been called since the last time we wrote this
        // data into the cache, there's a chance writing this result into
        // the cache will repair what was evicted.
        lastWrite.dmCount === $582c5d6426cf649e$var$destructiveMethodCounts.get(this.cache) && (0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(variables, lastWrite.variables) && (0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function(result, document, options, cacheWriteBehavior) {
        var _this = this;
        var _a;
        var merger = new (0, $ad19e8268fdfbd88$export$509e11c221f576c0)();
        var graphQLErrors = (0, $01c8f68cc3e070ef$export$d307f5934e447d0e)(result.errors) ? result.errors.slice(0) : [];
        // Cancel the pending notify timeout (if it exists) to prevent extraneous network
        // requests. To allow future notify timeouts, diff and dirty are reset as well.
        (_a = this.observableQuery) === null || _a === void 0 || _a["resetNotifications"]();
        if ("incremental" in result && (0, $01c8f68cc3e070ef$export$d307f5934e447d0e)(result.incremental)) {
            var mergedData = (0, $c6f9e6ad9f49962f$export$9a905f57d6393874)(this.getDiff().result, result);
            result.data = mergedData;
        // Detect the first chunk of a deferred query and merge it with existing
        // cache data. This ensures a `cache-first` fetch policy that returns
        // partial cache data or a `cache-and-network` fetch policy that already
        // has full data in the cache does not complain when trying to merge the
        // initial deferred server data with existing cache data.
        } else if ("hasNext" in result && result.hasNext) {
            var diff = this.getDiff();
            result.data = merger.merge(diff.result, result.data);
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === "no-cache") this.updateLastDiff({
            result: result.data,
            complete: true
        }, this.getDiffOptions(options.variables));
        else if (cacheWriteBehavior !== 0 /* CacheWriteBehavior.FORBID */ ) {
            if ($582c5d6426cf649e$export$5f47a9fb9a521654(result, options.errorPolicy)) // Using a transaction here so we have a chance to read the result
            // back from the cache before the watch callback fires as a result
            // of writeQuery, so we can store the new diff quietly and ignore
            // it when we receive it redundantly from the watch callback.
            this.cache.performTransaction(function(cache) {
                if (_this.shouldWrite(result, options.variables)) {
                    cache.writeQuery({
                        query: document,
                        data: result.data,
                        variables: options.variables,
                        overwrite: cacheWriteBehavior === 1 /* CacheWriteBehavior.OVERWRITE */ 
                    });
                    _this.lastWrite = {
                        result: result,
                        variables: options.variables,
                        dmCount: $582c5d6426cf649e$var$destructiveMethodCounts.get(_this.cache)
                    };
                } else // If result is the same as the last result we received from
                // the network (and the variables match too), avoid writing
                // result into the cache again. The wisdom of skipping this
                // cache write is far from obvious, since any cache write
                // could be the one that puts the cache back into a desired
                // state, fixing corruption or missing data. However, if we
                // always write every network result into the cache, we enable
                // feuds between queries competing to update the same data in
                // incompatible ways, which can lead to an endless cycle of
                // cache broadcasts and useless network requests. As with any
                // feud, eventually one side must step back from the brink,
                // letting the other side(s) have the last word(s). There may
                // be other points where we could break this cycle, such as
                // silencing the broadcast for cache.writeQuery (not a good
                // idea, since it just delays the feud a bit) or somehow
                // avoiding the network request that just happened (also bad,
                // because the server could return useful new data). All
                // options considered, skipping this cache write seems to be
                // the least damaging place to break the cycle, because it
                // reflects the intuition that we recently wrote this exact
                // result into the cache, so the cache *should* already/still
                // contain this data. If some other query has clobbered that
                // data in the meantime, that's too bad, but there will be no
                // winners if every query blindly reverts to its own version
                // of the data. This approach also gives the network a chance
                // to return new data, which will be written into the cache as
                // usual, notifying only those queries that are directly
                // affected by the cache updates, as usual. In the future, an
                // even more sophisticated cache could perhaps prevent or
                // mitigate the clobbering somehow, but that would make this
                // particular cache write even less important, and thus
                // skipping it would be even safer than it is today.
                if (_this.lastDiff && _this.lastDiff.diff.complete) {
                    // Reuse data from the last good (complete) diff that we
                    // received, when possible.
                    result.data = _this.lastDiff.diff.result;
                    return;
                }
                var diffOptions = _this.getDiffOptions(options.variables);
                var diff = (0, $14465ad01ccc354a$export$d18d1529326946c4)("canonizeResults", function() {
                    return cache.diff(diffOptions);
                });
                // In case the QueryManager stops this QueryInfo before its
                // results are delivered, it's important to avoid restarting the
                // cache watch when markResult is called. We also avoid updating
                // the watch if we are writing a result that doesn't match the current
                // variables to avoid race conditions from broadcasting the wrong
                // result.
                if (!_this.stopped && (0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(_this.variables, options.variables)) // Any time we're about to update this.diff, we need to make
                // sure we've started watching the cache.
                _this.updateWatch(options.variables);
                // If we're allowed to write to the cache, and we can read a
                // complete result from the cache, update result.data to be the
                // result from the cache, rather than the raw network result.
                // Set without setDiff to avoid triggering a notify call, since
                // we have other ways of notifying for this result.
                _this.updateLastDiff(diff, diffOptions);
                if (diff.complete) result.data = diff.result;
            });
            else this.lastWrite = void 0;
        }
    };
    QueryInfo.prototype.markReady = function() {
        this.networkError = null;
        return this.networkStatus = (0, $7f070805c91ccc41$export$bd096ddbd246c79c).ready;
    };
    QueryInfo.prototype.markError = function(error) {
        var _a;
        this.networkStatus = (0, $7f070805c91ccc41$export$bd096ddbd246c79c).error;
        this.lastWrite = void 0;
        (_a = this.observableQuery) === null || _a === void 0 || _a["resetNotifications"]();
        if (error.graphQLErrors) this.graphQLErrors = error.graphQLErrors;
        if (error.networkError) this.networkError = error.networkError;
        return error;
    };
    return QueryInfo;
}();
function $582c5d6426cf649e$export$5f47a9fb9a521654(result, errorPolicy) {
    if (errorPolicy === void 0) errorPolicy = "none";
    var ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
    var writeWithErrors = !(0, $7bc1793b21dca6f3$export$b4df399e879e53ab)(result);
    if (!writeWithErrors && ignoreErrors && result.data) writeWithErrors = true;
    return writeWithErrors;
}







var $0050593a9a6cc03b$export$dadc3b13206cb3ad = (0, $138881ab8f31fa6b$export$772fbc04a0ad4ce9) ? WeakMap : Map;
var $0050593a9a6cc03b$export$de8324a23c9fae9a = (0, $138881ab8f31fa6b$export$7293b8a0b474028d) ? WeakSet : Set;
var $0050593a9a6cc03b$export$2ddf8815a8abe8b = new (0, $f6d7836b3fbc48f1$export$8c6ed5c666ac1360)();
var $0050593a9a6cc03b$var$issuedWarning = false;
function $0050593a9a6cc03b$export$f21dbf49e2bec78b() {
    if (!$0050593a9a6cc03b$var$issuedWarning) {
        $0050593a9a6cc03b$var$issuedWarning = true;
        globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(64);
    }
}








function $b7ced898ee1c3d24$export$d4ee6fea56447c82(data, selectionSet, context) {
    return (0, $0050593a9a6cc03b$export$2ddf8815a8abe8b).withValue(true, function() {
        var masked = $b7ced898ee1c3d24$var$maskSelectionSet(data, selectionSet, context, false);
        if (Object.isFrozen(data)) (0, $5d04349b74d4efd7$export$7f9c177735b71f18)(masked);
        return masked;
    });
}
function $b7ced898ee1c3d24$var$getMutableTarget(data, mutableTargets) {
    if (mutableTargets.has(data)) return mutableTargets.get(data);
    var mutableTarget = Array.isArray(data) ? [] : Object.create(null);
    mutableTargets.set(data, mutableTarget);
    return mutableTarget;
}
function $b7ced898ee1c3d24$var$maskSelectionSet(data, selectionSet, context, migration, path) {
    var _a;
    var knownChanged = context.knownChanged;
    var memo = $b7ced898ee1c3d24$var$getMutableTarget(data, context.mutableTargets);
    if (Array.isArray(data)) {
        for(var _i = 0, _b = Array.from(data.entries()); _i < _b.length; _i++){
            var _c = _b[_i], index = _c[0], item = _c[1];
            if (item === null) {
                memo[index] = null;
                continue;
            }
            var masked = $b7ced898ee1c3d24$var$maskSelectionSet(item, selectionSet, context, migration, globalThis.__DEV__ !== false ? "".concat(path || "", "[").concat(index, "]") : void 0);
            if (knownChanged.has(masked)) knownChanged.add(memo);
            memo[index] = masked;
        }
        return knownChanged.has(memo) ? memo : data;
    }
    for(var _d = 0, _e = selectionSet.selections; _d < _e.length; _d++){
        var selection = _e[_d];
        var value = void 0;
        // we later want to add acessor warnings to the final result
        // so we need a new object to add the accessor warning to
        if (migration) knownChanged.add(memo);
        if (selection.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).FIELD) {
            var keyName = (0, $6ee6592fd95fa693$export$7d1ad22471852218)(selection);
            var childSelectionSet = selection.selectionSet;
            value = memo[keyName] || data[keyName];
            if (value === void 0) continue;
            if (childSelectionSet && value !== null) {
                var masked = $b7ced898ee1c3d24$var$maskSelectionSet(data[keyName], childSelectionSet, context, migration, globalThis.__DEV__ !== false ? "".concat(path || "", ".").concat(keyName) : void 0);
                if (knownChanged.has(masked)) value = masked;
            }
            if (!(globalThis.__DEV__ !== false)) memo[keyName] = value;
            if (globalThis.__DEV__ !== false) {
                if (migration && keyName !== "__typename" && // either the field is not present in the memo object
                // or it has a `get` descriptor, not a `value` descriptor
                // => it is a warning accessor and we can overwrite it
                // with another accessor
                !((_a = Object.getOwnPropertyDescriptor(memo, keyName)) === null || _a === void 0 ? void 0 : _a.value)) Object.defineProperty(memo, keyName, $b7ced898ee1c3d24$var$getAccessorWarningDescriptor(keyName, value, path || "", context.operationName, context.operationType));
                else {
                    delete memo[keyName];
                    memo[keyName] = value;
                }
            }
        }
        if (selection.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).INLINE_FRAGMENT && (!selection.typeCondition || context.cache.fragmentMatches(selection, data.__typename))) value = $b7ced898ee1c3d24$var$maskSelectionSet(data, selection.selectionSet, context, migration, path);
        if (selection.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).FRAGMENT_SPREAD) {
            var fragmentName = selection.name.value;
            var fragment = context.fragmentMap[fragmentName] || (context.fragmentMap[fragmentName] = context.cache.lookupFragment(fragmentName));
            (0, $c21c2000775800f2$export$f5708dca728d7177)(fragment, 59, fragmentName);
            var mode = (0, $5a6e90bd3aec77b4$export$d6913ace4214003)(selection);
            if (mode !== "mask") value = $b7ced898ee1c3d24$var$maskSelectionSet(data, fragment.selectionSet, context, mode === "migrate", path);
        }
        if (knownChanged.has(value)) knownChanged.add(memo);
    }
    if ("__typename" in data && !("__typename" in memo)) memo.__typename = data.__typename;
    // This check prevents cases where masked fields may accidentally be
    // returned as part of this object when the fragment also selects
    // additional fields from the same child selection.
    if (Object.keys(memo).length !== Object.keys(data).length) knownChanged.add(memo);
    return knownChanged.has(memo) ? memo : data;
}
function $b7ced898ee1c3d24$var$getAccessorWarningDescriptor(fieldName, value, path, operationName, operationType) {
    var getValue = function() {
        if ((0, $0050593a9a6cc03b$export$2ddf8815a8abe8b).getValue()) return value;
        globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(60, operationName ? "".concat(operationType, " '").concat(operationName, "'") : "anonymous ".concat(operationType), "".concat(path, ".").concat(fieldName).replace(/^\./, ""));
        getValue = function() {
            return value;
        };
        return value;
    };
    return {
        get: function() {
            return getValue();
        },
        set: function(newValue) {
            getValue = function() {
                return newValue;
            };
        },
        enumerable: true,
        configurable: true
    };
}



function $7f9612e058b3c19c$export$adbebb59d1aeea97(data, document, cache, fragmentName) {
    if (!cache.fragmentMatches) {
        if (globalThis.__DEV__ !== false) (0, $0050593a9a6cc03b$export$f21dbf49e2bec78b)();
        return data;
    }
    var fragments = document.definitions.filter(function(node) {
        return node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).FRAGMENT_DEFINITION;
    });
    if (typeof fragmentName === "undefined") {
        (0, $c21c2000775800f2$export$f5708dca728d7177)(fragments.length === 1, 61, fragments.length);
        fragmentName = fragments[0].name.value;
    }
    var fragment = fragments.find(function(fragment) {
        return fragment.name.value === fragmentName;
    });
    (0, $c21c2000775800f2$export$f5708dca728d7177)(!!fragment, 62, fragmentName);
    if (data == null) // Maintain the original `null` or `undefined` value
    return data;
    if ((0, $b59b67a8b7fe71c2$export$2e2bcd8739ae039)(data, {})) // Return early and skip the masking algorithm if we don't have any data
    // yet. This can happen when cache.diff returns an empty object which is
    // used from watchFragment.
    return data;
    return (0, $b7ced898ee1c3d24$export$d4ee6fea56447c82)(data, fragment.selectionSet, {
        operationType: "fragment",
        operationName: fragment.name.value,
        fragmentMap: (0, $070763719c7946cb$export$193789b4c8246dd4)((0, $6d75937eba8e6f1c$export$5320a7ba9466a3df)(document)),
        cache: cache,
        mutableTargets: new (0, $0050593a9a6cc03b$export$dadc3b13206cb3ad)(),
        knownChanged: new (0, $0050593a9a6cc03b$export$de8324a23c9fae9a)()
    });
}





function $8b050bd0e4c8f17b$export$74a61e4252a4a2ef(data, document, cache) {
    var _a;
    if (!cache.fragmentMatches) {
        if (globalThis.__DEV__ !== false) (0, $0050593a9a6cc03b$export$f21dbf49e2bec78b)();
        return data;
    }
    var definition = (0, $6d75937eba8e6f1c$export$7a5b1fa979d2c158)(document);
    (0, $c21c2000775800f2$export$f5708dca728d7177)(definition, 63);
    if (data == null) // Maintain the original `null` or `undefined` value
    return data;
    return (0, $b7ced898ee1c3d24$export$d4ee6fea56447c82)(data, definition.selectionSet, {
        operationType: definition.operation,
        operationName: (_a = definition.name) === null || _a === void 0 ? void 0 : _a.value,
        fragmentMap: (0, $070763719c7946cb$export$193789b4c8246dd4)((0, $6d75937eba8e6f1c$export$5320a7ba9466a3df)(document)),
        cache: cache,
        mutableTargets: new (0, $0050593a9a6cc03b$export$dadc3b13206cb3ad)(),
        knownChanged: new (0, $0050593a9a6cc03b$export$de8324a23c9fae9a)()
    });
}


var $1e9add6d358ed7d5$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $1e9add6d358ed7d5$var$IGNORE = Object.create(null);
var $1e9add6d358ed7d5$export$b986383a50b53ea4 = /** @class */ function() {
    function QueryManager(options) {
        var _this = this;
        this.clientAwareness = {};
        // All the queries that the QueryManager is currently managing (not
        // including mutations and subscriptions).
        this.queries = new Map();
        // Maps from queryId strings to Promise rejection functions for
        // currently active queries and fetches.
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.fetchCancelFns = new Map();
        this.transformCache = new (0, $cee967300b629dc7$export$8dbad6f439bb2331)((0, $d301603631c7863b$export$f29926b23b28936b)["queryManager.getDocumentInfo"] || 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ );
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.inFlightLinkObservables = new (0, $722ae841a583e691$export$73571c50d0f2507e)(false);
        this.noCacheWarningsByQueryId = new Set();
        var defaultDocumentTransform = new (0, $e10872a8609e2fee$export$f887060e48e5dc1b)(function(document) {
            return _this.cache.transformDocument(document);
        }, // Allow the apollo cache to manage its own transform caches
        {
            cache: false
        });
        this.cache = options.cache;
        this.link = options.link;
        this.defaultOptions = options.defaultOptions;
        this.queryDeduplication = options.queryDeduplication;
        this.clientAwareness = options.clientAwareness;
        this.localState = options.localState;
        this.ssrMode = options.ssrMode;
        this.assumeImmutableResults = options.assumeImmutableResults;
        this.dataMasking = options.dataMasking;
        var documentTransform = options.documentTransform;
        this.documentTransform = documentTransform ? defaultDocumentTransform.concat(documentTransform)// The custom document transform may add new fragment spreads or new
        // field selections, so we want to give the cache a chance to run
        // again. For example, the InMemoryCache adds __typename to field
        // selections and fragments from the fragment registry.
        .concat(defaultDocumentTransform) : defaultDocumentTransform;
        this.defaultContext = options.defaultContext || Object.create(null);
        if (this.onBroadcast = options.onBroadcast) this.mutationStore = Object.create(null);
    }
    /**
     * Call this method to terminate any active query processes, making it safe
     * to dispose of this QueryManager instance.
     */ QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches((0, $c21c2000775800f2$export$3991762405098ea)(35));
    };
    QueryManager.prototype.cancelPendingFetches = function(error) {
        this.fetchCancelFns.forEach(function(cancel) {
            return cancel(error);
        });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function(_a) {
        return (0, $b8xcN.__awaiter)(this, arguments, void 0, function(_b) {
            var mutationId, hasClientExports, mutationStoreValue, isOptimistic, self;
            var _c, _d;
            var mutation = _b.mutation, variables = _b.variables, optimisticResponse = _b.optimisticResponse, updateQueries = _b.updateQueries, _e = _b.refetchQueries, refetchQueries = _e === void 0 ? [] : _e, _f = _b.awaitRefetchQueries, awaitRefetchQueries = _f === void 0 ? false : _f, updateWithProxyFn = _b.update, onQueryUpdated = _b.onQueryUpdated, _g = _b.fetchPolicy, fetchPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.fetchPolicy) || "network-only" : _g, _h = _b.errorPolicy, errorPolicy = _h === void 0 ? ((_d = this.defaultOptions.mutate) === null || _d === void 0 ? void 0 : _d.errorPolicy) || "none" : _h, keepRootFields = _b.keepRootFields, context = _b.context;
            return (0, $b8xcN.__generator)(this, function(_j) {
                switch(_j.label){
                    case 0:
                        (0, $c21c2000775800f2$export$f5708dca728d7177)(mutation, 36);
                        (0, $c21c2000775800f2$export$f5708dca728d7177)(fetchPolicy === "network-only" || fetchPolicy === "no-cache", 37);
                        mutationId = this.generateMutationId();
                        mutation = this.cache.transformForLink(this.transform(mutation));
                        hasClientExports = this.getDocumentInfo(mutation).hasClientExports;
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _j.sent();
                        _j.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore && (this.mutationStore[mutationId] = {
                            mutation: mutation,
                            variables: variables,
                            loading: true,
                            error: null
                        });
                        isOptimistic = optimisticResponse && this.markMutationOptimistic(optimisticResponse, {
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            fetchPolicy: fetchPolicy,
                            errorPolicy: errorPolicy,
                            context: context,
                            updateQueries: updateQueries,
                            update: updateWithProxyFn,
                            keepRootFields: keepRootFields
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                return (0, $ec3d440bb8fa39d3$export$707ee4c4c95d39e3)(self.getObservableFromLink(mutation, (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, context), {
                                    optimisticResponse: isOptimistic ? optimisticResponse : void 0
                                }), variables, {}, false), function(result) {
                                    if ((0, $7bc1793b21dca6f3$export$b4df399e879e53ab)(result) && errorPolicy === "none") throw new (0, $03c08328939e6317$export$26a337512320b8c6)({
                                        graphQLErrors: (0, $7bc1793b21dca6f3$export$a163557155188b6e)(result)
                                    });
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0, $b8xcN.__assign)({}, result);
                                    if (typeof refetchQueries === "function") refetchQueries = refetchQueries(storeResult);
                                    if (errorPolicy === "ignore" && (0, $7bc1793b21dca6f3$export$b4df399e879e53ab)(storeResult)) delete storeResult.errors;
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: isOptimistic ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields
                                    });
                                }).subscribe({
                                    next: function(storeResult) {
                                        self.broadcastQueries();
                                        // Since mutations might receive multiple payloads from the
                                        // ApolloLink chain (e.g. when used with @defer),
                                        // we resolve with a SingleExecutionResult or after the final
                                        // ExecutionPatchResult has arrived and we have assembled the
                                        // multipart response into a single result.
                                        if (!("hasNext" in storeResult) || storeResult.hasNext === false) resolve((0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, storeResult), {
                                            data: self.maskOperation({
                                                document: mutation,
                                                data: storeResult.data,
                                                fetchPolicy: fetchPolicy,
                                                id: mutationId
                                            })
                                        }));
                                    },
                                    error: function(err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (isOptimistic) self.cache.removeOptimistic(mutationId);
                                        self.broadcastQueries();
                                        reject(err instanceof (0, $03c08328939e6317$export$26a337512320b8c6) ? err : new (0, $03c08328939e6317$export$26a337512320b8c6)({
                                            networkError: err
                                        }));
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function(mutation, cache) {
        var _this = this;
        if (cache === void 0) cache = this.cache;
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && (0, $582c5d6426cf649e$export$5f47a9fb9a521654)(result, mutation.errorPolicy)) {
            if (!(0, $c6f9e6ad9f49962f$export$879767c5cdf33cb3)(result)) cacheWrites.push({
                result: result.data,
                dataId: "ROOT_MUTATION",
                query: mutation.document,
                variables: mutation.variables
            });
            if ((0, $c6f9e6ad9f49962f$export$879767c5cdf33cb3)(result) && (0, $01c8f68cc3e070ef$export$d307f5934e447d0e)(result.incremental)) {
                var diff = cache.diff({
                    id: "ROOT_MUTATION",
                    // The cache complains if passed a mutation where it expects a
                    // query, so we transform mutations and subscriptions to queries
                    // (only once, thanks to this.transformCache).
                    query: this.getDocumentInfo(mutation.document).asQuery,
                    variables: mutation.variables,
                    optimistic: false,
                    returnPartialData: true
                });
                var mergedData = void 0;
                if (diff.result) mergedData = (0, $c6f9e6ad9f49962f$export$9a905f57d6393874)(diff.result, result);
                if (typeof mergedData !== "undefined") {
                    // cast the ExecutionPatchResult to FetchResult here since
                    // ExecutionPatchResult never has `data` when returned from the server
                    result.data = mergedData;
                    cacheWrites.push({
                        result: mergedData,
                        dataId: "ROOT_MUTATION",
                        query: mutation.document,
                        variables: mutation.variables
                    });
                }
            }
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                var queryName = observableQuery && observableQuery.queryName;
                if (!queryName || !$1e9add6d358ed7d5$var$hasOwnProperty.call(updateQueries_1, queryName)) return;
                var updater = updateQueries_1[queryName];
                var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                // Read the current query result from the store.
                var _c = cache.diff({
                    query: document,
                    variables: variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _c.result, complete = _c.complete;
                if (complete && currentQueryResult) {
                    // Run our reducer using the current query result and the mutation result.
                    var nextQueryResult = updater(currentQueryResult, {
                        mutationResult: result,
                        queryName: document && (0, $6d75937eba8e6f1c$export$41bca9dc6871dd4e)(document) || void 0,
                        queryVariables: variables
                    });
                    // Write the modified result back into the store if we got a new result.
                    if (nextQueryResult) cacheWrites.push({
                        result: nextQueryResult,
                        dataId: "ROOT_QUERY",
                        query: document,
                        variables: variables
                    });
                }
            });
        }
        if (cacheWrites.length > 0 || (mutation.refetchQueries || "").length > 0 || mutation.update || mutation.onQueryUpdated || mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function(cache) {
                    if (!skipCache) cacheWrites.forEach(function(write) {
                        return cache.write(write);
                    });
                    // If the mutation has some writes associated with it then we need to
                    // apply those writes to the store by running this reducer again with
                    // a write action.
                    var update = mutation.update;
                    // Determine whether result is a SingleExecutionResult,
                    // or the final ExecutionPatchResult.
                    var isFinalResult = !(0, $c6f9e6ad9f49962f$export$f90dc0a3531b8b83)(result) || (0, $c6f9e6ad9f49962f$export$879767c5cdf33cb3)(result) && !result.hasNext;
                    if (update) {
                        if (!skipCache) {
                            // Re-read the ROOT_MUTATION data we just wrote into the cache
                            // (the first cache.write call in the cacheWrites.forEach loop
                            // above), so field read functions have a chance to run for
                            // fields within mutation result objects.
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                // The cache complains if passed a mutation where it expects a
                                // query, so we transform mutations and subscriptions to queries
                                // (only once, thanks to this.transformCache).
                                query: _this.getDocumentInfo(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true
                            });
                            if (diff.complete) {
                                result = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, result), {
                                    data: diff.result
                                });
                                if ("incremental" in result) delete result.incremental;
                                if ("hasNext" in result) delete result.hasNext;
                            }
                        }
                        // If we've received the whole response,
                        // either a SingleExecutionResult or the final ExecutionPatchResult,
                        // call the update function.
                        if (isFinalResult) update(cache, result, {
                            context: mutation.context,
                            variables: mutation.variables
                        });
                    }
                    // TODO Do this with cache.evict({ id: 'ROOT_MUTATION' }) but make it
                    // shallow to allow rolling back optimistic evictions.
                    if (!skipCache && !mutation.keepRootFields && isFinalResult) cache.modify({
                        id: "ROOT_MUTATION",
                        fields: function(value, _a) {
                            var fieldName = _a.fieldName, DELETE = _a.DELETE;
                            return fieldName === "__typename" ? value : DELETE;
                        }
                    });
                },
                include: mutation.refetchQueries,
                // Write the final mutation.result to the root layer of the cache.
                optimistic: false,
                // Remove the corresponding optimistic layer at the same time as we
                // write the final non-optimistic result.
                removeOptimistic: mutation.removeOptimistic,
                // Let the caller of client.mutate optionally determine the refetching
                // behavior for watched queries after the mutation.update function runs.
                // If no onQueryUpdated function was provided for this mutation, pass
                // null instead of undefined to disable the default refetching behavior.
                onQueryUpdated: mutation.onQueryUpdated || null
            }).forEach(function(result) {
                return results_1.push(result);
            });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) // Returning a promise here makes the mutation await that promise, so we
            // include results in that promise's work if awaitRefetchQueries or an
            // onQueryUpdated function was specified.
            return Promise.all(results_1).then(function() {
                return result;
            });
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function(optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function" ? optimisticResponse(mutation.variables, {
            IGNORE: $1e9add6d358ed7d5$var$IGNORE
        }) : optimisticResponse;
        if (data === $1e9add6d358ed7d5$var$IGNORE) return false;
        this.cache.recordOptimisticTransaction(function(cache) {
            try {
                _this.markMutationResult((0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, mutation), {
                    result: {
                        data: data
                    }
                }), cache);
            } catch (error) {
                globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).error(error);
            }
        }, mutation.mutationId);
        return true;
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, networkStatus) {
        return this.fetchConcastWithInfo(this.getOrCreateQuery(queryId), options, networkStatus).concast.promise;
    };
    QueryManager.prototype.getQueryStore = function() {
        var store = Object.create(null);
        this.queries.forEach(function(info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function(document) {
        return this.documentTransform.transformDocument(document);
    };
    QueryManager.prototype.getDocumentInfo = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cacheEntry = {
                // TODO These three calls (hasClientExports, shouldForceResolvers, and
                // usesNonreactiveDirective) are performing independent full traversals
                // of the transformed document. We should consider merging these
                // traversals into a single pass in the future, though the work is
                // cached after the first time.
                hasClientExports: (0, $5a6e90bd3aec77b4$export$8d1e9e5bbfa5d09a)(document),
                hasForcedResolvers: this.localState.shouldForceResolvers(document),
                hasNonreactiveDirective: (0, $5a6e90bd3aec77b4$export$2dafb573e282fe8d)([
                    "nonreactive"
                ], document),
                nonReactiveQuery: (0, $19cabdf265088897$export$b6125cad5877ac5e)(document),
                clientQuery: this.localState.clientQuery(document),
                serverQuery: (0, $19cabdf265088897$export$e5ae0530da5fe96c)([
                    {
                        name: "client",
                        remove: true
                    },
                    {
                        name: "connection"
                    },
                    {
                        name: "nonreactive"
                    },
                    {
                        name: "unmask"
                    }
                ], document),
                defaultVars: (0, $6d75937eba8e6f1c$export$84c19026e616569e)((0, $6d75937eba8e6f1c$export$7a5b1fa979d2c158)(document)),
                // Transform any mutation or subscription operations to query operations
                // so we can read/write them from/to the cache.
                asQuery: (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, document), {
                    definitions: document.definitions.map(function(def) {
                        if (def.kind === "OperationDefinition" && def.operation !== "query") return (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, def), {
                            operation: "query"
                        });
                        return def;
                    })
                })
            };
            transformCache.set(document, cacheEntry);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, this.getDocumentInfo(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options) {
        var query = this.transform(options.query);
        // assign variable default values if supplied
        // NOTE: We don't modify options.query here with the transformed query to
        // ensure observable.options.query is set to the raw untransformed query.
        options = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, options), {
            variables: this.getVariables(query, options.variables)
        });
        if (typeof options.notifyOnNetworkStatusChange === "undefined") options.notifyOnNetworkStatusChange = false;
        var queryInfo = new (0, $582c5d6426cf649e$export$79a6120a39c90b6a)(this);
        var observable = new (0, $d0d4a90bb058cbe1$export$6c1b56eac59c9584)({
            queryManager: this,
            queryInfo: queryInfo,
            options: options
        });
        observable["lastQuery"] = query;
        if (!(0, $d0d4a90bb058cbe1$export$6c1b56eac59c9584)["inactiveOnCreation"].getValue()) this.queries.set(observable.queryId, queryInfo);
        // We give queryInfo the transformed query to ensure the first cache diff
        // uses the transformed query instead of the raw query
        queryInfo.init({
            document: query,
            observableQuery: observable,
            variables: observable.variables
        });
        return observable;
    };
    QueryManager.prototype.query = function(options, queryId) {
        var _this = this;
        if (queryId === void 0) queryId = this.generateQueryId();
        (0, $c21c2000775800f2$export$f5708dca728d7177)(options.query, 38);
        (0, $c21c2000775800f2$export$f5708dca728d7177)(options.query.kind === "Document", 39);
        (0, $c21c2000775800f2$export$f5708dca728d7177)(!options.returnPartialData, 40);
        (0, $c21c2000775800f2$export$f5708dca728d7177)(!options.pollInterval, 41);
        var query = this.transform(options.query);
        return this.fetchQuery(queryId, (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, options), {
            query: query
        })).then(function(result) {
            return result && (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, result), {
                data: _this.maskOperation({
                    document: query,
                    data: result.data,
                    fetchPolicy: options.fetchPolicy,
                    id: queryId
                })
            });
        }).finally(function() {
            return _this.stopQuery(queryId);
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function() {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function() {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function(options) {
        if (options === void 0) options = {
            discardWatches: true
        };
        // Before we have sent the reset action to the store, we can no longer
        // rely on the results returned by in-flight requests since these may
        // depend on values that previously existed in the data portion of the
        // store. So, we cancel the promises and observers that we have issued
        // so far and not yet resolved (in the case of queries).
        this.cancelPendingFetches((0, $c21c2000775800f2$export$3991762405098ea)(42));
        this.queries.forEach(function(queryInfo) {
            if (queryInfo.observableQuery) // Set loading to true so listeners don't trigger unless they want
            // results with partial data.
            queryInfo.networkStatus = (0, $7f070805c91ccc41$export$bd096ddbd246c79c).loading;
            else queryInfo.stop();
        });
        if (this.mutationStore) this.mutationStore = Object.create(null);
        // begin removing data from the store
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function(include) {
        var _this = this;
        if (include === void 0) include = "active";
        var queries = new Map();
        var queryNames = new Map();
        var queryNamesAndQueryStrings = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) include.forEach(function(desc) {
            if (typeof desc === "string") {
                queryNames.set(desc, desc);
                queryNamesAndQueryStrings.set(desc, false);
            } else if ((0, $6ee6592fd95fa693$export$540432d49fcec6c9)(desc)) {
                var queryString = (0, $545086ab9b229dc6$export$c2d084dc44961371)(_this.transform(desc));
                queryNames.set(queryString, (0, $6d75937eba8e6f1c$export$41bca9dc6871dd4e)(desc));
                queryNamesAndQueryStrings.set(queryString, false);
            } else if ((0, $01d0d880754ccbd1$export$417207af72fad9c9)(desc) && desc.query) legacyQueryOptions.add(desc);
        });
        this.queries.forEach(function(_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" || include === "active" && !oq.hasObservers()) return;
                if (include === "active" || queryName && queryNamesAndQueryStrings.has(queryName) || document && queryNamesAndQueryStrings.has((0, $545086ab9b229dc6$export$c2d084dc44961371)(document))) {
                    queries.set(queryId, oq);
                    if (queryName) queryNamesAndQueryStrings.set(queryName, true);
                    if (document) queryNamesAndQueryStrings.set((0, $545086ab9b229dc6$export$c2d084dc44961371)(document), true);
                }
            }
        });
        if (legacyQueryOptions.size) legacyQueryOptions.forEach(function(options) {
            // We will be issuing a fresh network request for this query, so we
            // pre-allocate a new query ID here, using a special prefix to enable
            // cleaning up these temporary queries later, after fetching.
            var queryId = (0, $b62911f4eb3e0bb3$export$d0c8ec0fe1b18b70)("legacyOneTimeQuery");
            var queryInfo = _this.getOrCreateQuery(queryId).init({
                document: options.query,
                variables: options.variables
            });
            var oq = new (0, $d0d4a90bb058cbe1$export$6c1b56eac59c9584)({
                queryManager: _this,
                queryInfo: queryInfo,
                options: (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, options), {
                    fetchPolicy: "network-only"
                })
            });
            (0, $c21c2000775800f2$export$f5708dca728d7177)(oq.queryId === queryId);
            queryInfo.setObservableQuery(oq);
            queries.set(queryId, oq);
        });
        if (globalThis.__DEV__ !== false && queryNamesAndQueryStrings.size) queryNamesAndQueryStrings.forEach(function(included, nameOrQueryString) {
            if (!included) {
                var queryName = queryNames.get(nameOrQueryString);
                if (queryName) globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(43, queryName);
                else globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(44);
            }
        });
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function(observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            (0, $14465ad01ccc354a$export$d18d1529326946c4)("resetLastResults", function() {
                return observableQuery.resetLastResults();
            });
            if (includeStandby || fetchPolicy !== "standby" && fetchPolicy !== "cache-only") observableQueryPromises.push(observableQuery.refetch());
            (_this.queries.get(queryId) || observableQuery["queryInfo"]).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.startGraphQLSubscription = function(options) {
        var _this = this;
        var query = options.query, variables = options.variables;
        var fetchPolicy = options.fetchPolicy, _a = options.errorPolicy, errorPolicy = _a === void 0 ? "none" : _a, _b = options.context, context = _b === void 0 ? {} : _b, _c = options.extensions, extensions = _c === void 0 ? {} : _c;
        query = this.transform(query);
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, context, variables, extensions).map(function(result) {
                if (fetchPolicy !== "no-cache") {
                    // the subscription interface should handle not sending us results we no longer subscribe to.
                    // XXX I don't think we ever send in an object with errors, but we might in the future...
                    if ((0, $582c5d6426cf649e$export$5f47a9fb9a521654)(result, errorPolicy)) _this.cache.write({
                        query: query,
                        result: result.data,
                        dataId: "ROOT_SUBSCRIPTION",
                        variables: variables
                    });
                    _this.broadcastQueries();
                }
                var hasErrors = (0, $7bc1793b21dca6f3$export$b4df399e879e53ab)(result);
                var hasProtocolErrors = (0, $03c08328939e6317$export$345f95cc6b6b9b0b)(result);
                if (hasErrors || hasProtocolErrors) {
                    var errors = {};
                    if (hasErrors) errors.graphQLErrors = result.errors;
                    if (hasProtocolErrors) errors.protocolErrors = result.extensions[0, $03c08328939e6317$export$4995664c1b49842e];
                    // `errorPolicy` is a mechanism for handling GraphQL errors, according
                    // to our documentation, so we throw protocol errors regardless of the
                    // set error policy.
                    if (errorPolicy === "none" || hasProtocolErrors) throw new (0, $03c08328939e6317$export$26a337512320b8c6)(errors);
                }
                if (errorPolicy === "ignore") delete result.errors;
                return result;
            });
        };
        if (this.getDocumentInfo(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new (0, $2027033ce24a9479$export$77cea355fa80b5f4)(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        var _a;
        // teardown all links
        // Both `QueryManager.fetchRequest` and `QueryManager.query` create separate promises
        // that each add their reject functions to fetchCancelFns.
        // A query created with `QueryManager.query()` could trigger a `QueryManager.fetchRequest`.
        // The same queryId could have two rejection fns for two promises
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            (_a = this.queries.get(queryId)) === null || _a === void 0 || _a.stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function() {
        if (this.onBroadcast) this.onBroadcast();
        this.queries.forEach(function(info) {
            var _a;
            return (_a = info.observableQuery) === null || _a === void 0 ? void 0 : _a["notify"]();
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, extensions, // Prefer context.queryDeduplication if specified.
    deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication;
        var observable;
        var _b = this.getDocumentInfo(query), serverQuery = _b.serverQuery, clientQuery = _b.clientQuery;
        if (serverQuery) {
            var _c = this, inFlightLinkObservables_1 = _c.inFlightLinkObservables, link = _c.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $6d75937eba8e6f1c$export$41bca9dc6871dd4e)(serverQuery) || void 0,
                context: this.prepareContext((0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, context), {
                    forceFetch: !deduplication
                })),
                extensions: extensions
            };
            context = operation.context;
            if (deduplication) {
                var printedServerQuery_1 = (0, $545086ab9b229dc6$export$c2d084dc44961371)(serverQuery);
                var varJson_1 = (0, $e3e8d305ba8d539e$export$88a0ad9b6f961b51)(variables);
                var entry = inFlightLinkObservables_1.lookup(printedServerQuery_1, varJson_1);
                observable = entry.observable;
                if (!observable) {
                    var concast_1 = new (0, $0cc1d115a29da4c6$export$ae0cf2ec7a6fa78e)([
                        (0, $2ff40892a1abf83c$export$51396ec711da548b)(link, operation)
                    ]);
                    observable = entry.observable = concast_1;
                    concast_1.beforeNext(function cb(method, arg) {
                        if (method === "next" && "hasNext" in arg && arg.hasNext) concast_1.beforeNext(cb);
                        else inFlightLinkObservables_1.remove(printedServerQuery_1, varJson_1);
                    });
                }
            } else observable = new (0, $0cc1d115a29da4c6$export$ae0cf2ec7a6fa78e)([
                (0, $2ff40892a1abf83c$export$51396ec711da548b)(link, operation)
            ]);
        } else {
            observable = new (0, $0cc1d115a29da4c6$export$ae0cf2ec7a6fa78e)([
                (0, $2027033ce24a9479$export$77cea355fa80b5f4).of({
                    data: {}
                })
            ]);
            context = this.prepareContext(context);
        }
        if (clientQuery) observable = (0, $ec3d440bb8fa39d3$export$707ee4c4c95d39e3)(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function(queryInfo, cacheWriteBehavior, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        // Performing transformForLink here gives this.cache a chance to fill in
        // missing fragment definitions (for example) before sending this document
        // through the link chain.
        var linkDocument = this.cache.transformForLink(options.query);
        return (0, $ec3d440bb8fa39d3$export$707ee4c4c95d39e3)(this.getObservableFromLink(linkDocument, options.context, options.variables), function(result) {
            var graphQLErrors = (0, $7bc1793b21dca6f3$export$a163557155188b6e)(result);
            var hasErrors = graphQLErrors.length > 0;
            var errorPolicy = options.errorPolicy;
            // If we interrupted this request by calling getResultsFromLink again
            // with the same QueryInfo object, we ignore the old results.
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && errorPolicy === "none") // Throwing here effectively calls observer.error.
                throw queryInfo.markError(new (0, $03c08328939e6317$export$26a337512320b8c6)({
                    graphQLErrors: graphQLErrors
                }));
                // Use linkDocument rather than queryInfo.document so the
                // operation/fragments used to write the result are the same as the
                // ones used to obtain it from the link.
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: (0, $7f070805c91ccc41$export$bd096ddbd246c79c).ready
            };
            // In the case we start multiple network requests simulatenously, we
            // want to ensure we properly set `data` if we're reporting on an old
            // result which will not be caught by the conditional above that ends up
            // throwing the markError result.
            if (hasErrors && errorPolicy === "none") aqr.data = void 0;
            if (hasErrors && errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = (0, $7f070805c91ccc41$export$bd096ddbd246c79c).error;
            }
            return aqr;
        }, function(networkError) {
            var error = (0, $03c08328939e6317$export$17f5e6bd290bb15d)(networkError) ? networkError : new (0, $03c08328939e6317$export$26a337512320b8c6)({
                networkError: networkError
            });
            // Avoid storing errors from older interrupted queries.
            if (requestId >= queryInfo.lastRequestId) queryInfo.markError(error);
            throw error;
        });
    };
    QueryManager.prototype.fetchConcastWithInfo = function(queryInfo, options, // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus, query) {
        var _this = this;
        if (networkStatus === void 0) networkStatus = (0, $7f070805c91ccc41$export$bd096ddbd246c79c).loading;
        if (query === void 0) query = options.query;
        var variables = this.getVariables(query, options.variables);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? defaults && defaults.fetchPolicy || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? defaults && defaults.errorPolicy || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context
        });
        var fromVariables = function(variables) {
            // Since normalized is always a fresh copy of options, it's safe to
            // modify its properties here, rather than creating yet another new
            // WatchQueryOptions object.
            normalized.variables = variables;
            var sourcesWithInfo = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (// If we're in standby, postpone advancing options.fetchPolicy using
            // applyNextFetchPolicy.
            normalized.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
            // this is another way to detect when nothing was done/fetched.
            sourcesWithInfo.sources.length > 0 && queryInfo.observableQuery) queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            return sourcesWithInfo;
        };
        // This cancel function needs to be set before the concast is created,
        // in case concast creation synchronously cancels the request.
        var cleanupCancelFn = function() {
            return _this.fetchCancelFns.delete(queryInfo.queryId);
        };
        this.fetchCancelFns.set(queryInfo.queryId, function(reason) {
            cleanupCancelFn();
            // This delay ensures the concast variable has been initialized.
            setTimeout(function() {
                return concast.cancel(reason);
            });
        });
        var concast, containsDataFromLink;
        // If the query has @export(as: ...) directives, then we need to
        // process those directives asynchronously. When there are no
        // @export directives (the common case), we deliberately avoid
        // wrapping the result of this.fetchQueryByPolicy in a Promise,
        // since the timing of result delivery is (unfortunately) important
        // for backwards compatibility. TODO This code could be simpler if
        // we deprecated and removed LocalState.
        if (this.getDocumentInfo(normalized.query).hasClientExports) {
            concast = new (0, $0cc1d115a29da4c6$export$ae0cf2ec7a6fa78e)(this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables).then(function(sourcesWithInfo) {
                return sourcesWithInfo.sources;
            }));
            // there is just no way we can synchronously get the *right* value here,
            // so we will assume `true`, which is the behaviour before the bug fix in
            // #10597. This means that bug is not fixed in that case, and is probably
            // un-fixable with reasonable effort for the edge case of @export as
            // directives.
            containsDataFromLink = true;
        } else {
            var sourcesWithInfo = fromVariables(normalized.variables);
            containsDataFromLink = sourcesWithInfo.fromLink;
            concast = new (0, $0cc1d115a29da4c6$export$ae0cf2ec7a6fa78e)(sourcesWithInfo.sources);
        }
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return {
            concast: concast,
            fromLink: containsDataFromLink
        };
    };
    QueryManager.prototype.refetchQueries = function(_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? (0, $b62911f4eb3e0bb3$export$d0c8ec0fe1b18b70)("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) this.getObservableQueries(include).forEach(function(oq, queryId) {
            includedQueriesById.set(queryId, {
                oq: oq,
                lastDiff: (_this.queries.get(queryId) || oq["queryInfo"]).getDiff()
            });
        });
        var results = new Map();
        if (updateCache) this.cache.batch({
            update: updateCache,
            // Since you can perform any combination of cache reads and/or writes in
            // the cache.batch update function, its optimistic option can be either
            // a boolean or a string, representing three distinct modes of
            // operation:
            //
            // * false: read/write only the root layer
            // * true: read/write the topmost layer
            // * string: read/write a fresh optimistic layer with that ID string
            //
            // When typeof optimistic === "string", a new optimistic layer will be
            // temporarily created within cache.batch with that string as its ID. If
            // we then pass that same string as the removeOptimistic option, we can
            // make cache.batch immediately remove the optimistic layer after
            // running the updateCache function, triggering only one broadcast.
            //
            // However, the refetchQueries method accepts only true or false for its
            // optimistic option (not string). We interpret true to mean a temporary
            // optimistic layer should be created, to allow efficiently rolling back
            // the effect of the updateCache function, which involves passing a
            // string instead of true as the optimistic option to cache.batch, when
            // refetchQueries receives optimistic: true.
            //
            // In other words, we are deliberately not supporting the use case of
            // writing to an *existing* optimistic layer (using the refetchQueries
            // updateCache function), since that would potentially interfere with
            // other optimistic updates in progress. Instead, you can read/write
            // only the root layer by passing optimistic: false to refetchQueries,
            // or you can read/write a brand new optimistic layer that will be
            // automatically removed by passing optimistic: true.
            optimistic: optimistic && removeOptimistic || false,
            // The removeOptimistic option can also be provided by itself, even if
            // optimistic === false, to remove some previously-added optimistic
            // layer safely and efficiently, like we do in markMutationResult.
            //
            // If an explicit removeOptimistic string is provided with optimistic:
            // true, the removeOptimistic string will determine the ID of the
            // temporary optimistic layer, in case that ever matters.
            removeOptimistic: removeOptimistic,
            onWatchUpdated: function(watch, diff, lastDiff) {
                var oq = watch.watcher instanceof (0, $582c5d6426cf649e$export$79a6120a39c90b6a) && watch.watcher.observableQuery;
                if (oq) {
                    if (onQueryUpdated) {
                        // Since we're about to handle this query now, remove it from
                        // includedQueriesById, in case it was added earlier because of
                        // options.include.
                        includedQueriesById.delete(oq.queryId);
                        var result = onQueryUpdated(oq, diff, lastDiff);
                        if (result === true) // The onQueryUpdated function requested the default refetching
                        // behavior by returning true.
                        result = oq.refetch();
                        // Record the result in the results Map, as long as onQueryUpdated
                        // did not return false to skip/ignore this result.
                        if (result !== false) results.set(oq, result);
                        // Allow the default cache broadcast to happen, except when
                        // onQueryUpdated returns false.
                        return result;
                    }
                    if (onQueryUpdated !== null) // If we don't have an onQueryUpdated function, and onQueryUpdated
                    // was not disabled by passing null, make sure this query is
                    // "included" like any other options.include-specified query.
                    includedQueriesById.set(oq.queryId, {
                        oq: oq,
                        lastDiff: lastDiff,
                        diff: diff
                    });
                }
            }
        });
        if (includedQueriesById.size) includedQueriesById.forEach(function(_a, queryId) {
            var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
            var result;
            // If onQueryUpdated is provided, we want to use it for all included
            // queries, even the QueryOptions ones.
            if (onQueryUpdated) {
                if (!diff) diff = (0, $14465ad01ccc354a$export$d18d1529326946c4)("canonizeResults", function() {
                    return _this.cache.diff(oq["queryInfo"]["getDiffOptions"]());
                });
                result = onQueryUpdated(oq, diff, lastDiff);
            }
            // Otherwise, we fall back to refetching.
            if (!onQueryUpdated || result === true) result = oq.refetch();
            if (result !== false) results.set(oq, result);
            if (queryId.indexOf("legacyOneTimeQuery") >= 0) _this.stopQueryNoBroadcast(queryId);
        });
        if (removeOptimistic) // In case no updateCache callback was provided (so cache.batch was not
        // called above, and thus did not already remove the optimistic layer),
        // remove it here. Since this is a no-op when the layer has already been
        // removed, we do it even if we called cache.batch above, since it's
        // possible this.cache is an instance of some ApolloCache subclass other
        // than InMemoryCache, and does not fully support the removeOptimistic
        // option for cache.batch.
        this.cache.removeOptimistic(removeOptimistic);
        return results;
    };
    QueryManager.prototype.maskOperation = function(options) {
        var _a, _b, _c;
        var document = options.document, data = options.data;
        if (globalThis.__DEV__ !== false) {
            var fetchPolicy = options.fetchPolicy, id = options.id;
            var operationType = (_a = (0, $6d75937eba8e6f1c$export$7a5b1fa979d2c158)(document)) === null || _a === void 0 ? void 0 : _a.operation;
            var operationId = ((_b = operationType === null || operationType === void 0 ? void 0 : operationType[0]) !== null && _b !== void 0 ? _b : "o") + id;
            if (this.dataMasking && fetchPolicy === "no-cache" && !(0, $070763719c7946cb$export$5b84f3d7865d4e49)(document) && !this.noCacheWarningsByQueryId.has(operationId)) {
                this.noCacheWarningsByQueryId.add(operationId);
                globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(45, (_c = (0, $6d75937eba8e6f1c$export$41bca9dc6871dd4e)(document)) !== null && _c !== void 0 ? _c : "Unnamed ".concat(operationType !== null && operationType !== void 0 ? operationType : "operation"));
            }
        }
        return this.dataMasking ? (0, $8b050bd0e4c8f17b$export$74a61e4252a4a2ef)(data, document, this.cache) : data;
    };
    QueryManager.prototype.maskFragment = function(options) {
        var data = options.data, fragment = options.fragment, fragmentName = options.fragmentName;
        return this.dataMasking ? (0, $7f9612e058b3c19c$export$adbebb59d1aeea97)(data, fragment, this.cache, fragmentName) : data;
    };
    QueryManager.prototype.fetchQueryByPolicy = function(queryInfo, _a, // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: query,
            variables: variables,
            networkStatus: networkStatus
        });
        var readCache = function() {
            return queryInfo.getDiff();
        };
        var resultsFromCache = function(diff, networkStatus) {
            if (networkStatus === void 0) networkStatus = queryInfo.networkStatus || (0, $7f070805c91ccc41$export$bd096ddbd246c79c).loading;
            var data = diff.result;
            if (globalThis.__DEV__ !== false && !returnPartialData && !(0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(data, {})) (0, $d0d4a90bb058cbe1$export$b7e1973aacac3ae7)(diff.missing);
            var fromData = function(data) {
                return (0, $2027033ce24a9479$export$77cea355fa80b5f4).of((0, $b8xcN.__assign)({
                    data: data,
                    loading: (0, $7f070805c91ccc41$export$37509604341a3464)(networkStatus),
                    networkStatus: networkStatus
                }, diff.complete ? null : {
                    partial: true
                }));
            };
            if (data && _this.getDocumentInfo(query).hasForcedResolvers) return _this.localState.runResolvers({
                document: query,
                remoteResult: {
                    data: data
                },
                context: context,
                variables: variables,
                onlyRunForcedResolvers: true
            }).then(function(resolved) {
                return fromData(resolved.data || void 0);
            });
            // Resolves https://github.com/apollographql/apollo-client/issues/10317.
            // If errorPolicy is 'none' and notifyOnNetworkStatusChange is true,
            // data was incorrectly returned from the cache on refetch:
            // if diff.missing exists, we should not return cache data.
            if (errorPolicy === "none" && networkStatus === (0, $7f070805c91ccc41$export$bd096ddbd246c79c).refetch && Array.isArray(diff.missing)) return fromData(void 0);
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 /* CacheWriteBehavior.FORBID */  : networkStatus === (0, $7f070805c91ccc41$export$bd096ddbd246c79c).refetch && refetchWritePolicy !== "merge" ? 1 /* CacheWriteBehavior.OVERWRITE */  : 2 /* CacheWriteBehavior.MERGE */ ;
        var resultsFromLink = function() {
            return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
                query: query,
                variables: variables,
                context: context,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy
            });
        };
        var shouldNotify = notifyOnNetworkStatusChange && typeof oldNetworkStatus === "number" && oldNetworkStatus !== networkStatus && (0, $7f070805c91ccc41$export$37509604341a3464)(networkStatus);
        switch(fetchPolicy){
            default:
            case "cache-first":
                var diff = readCache();
                if (diff.complete) return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(diff, queryInfo.markReady())
                    ]
                };
                if (returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-and-network":
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-only":
                return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(readCache(), queryInfo.markReady())
                    ]
                };
            case "network-only":
                if (shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(readCache()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "no-cache":
                if (shouldNotify) return {
                    fromLink: true,
                    // Note that queryInfo.getDiff() for no-cache queries does not call
                    // cache.diff, but instead returns a { complete: false } stub result
                    // when there is no queryInfo.diff already defined.
                    sources: [
                        resultsFromCache(queryInfo.getDiff()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "standby":
                return {
                    fromLink: false,
                    sources: []
                };
        }
    };
    QueryManager.prototype.getOrCreateQuery = function(queryId) {
        if (queryId && !this.queries.has(queryId)) this.queries.set(queryId, new (0, $582c5d6426cf649e$export$79a6120a39c90b6a)(this, queryId));
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $b8xcN.__assign)((0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, this.defaultContext), newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    return QueryManager;
}();



var $b8xcN = parcelRequire("b8xcN");

/** @category AST Predicates */ 
function $9f8b16cebdbb6117$export$e7ecd7c16613ccfd(node) {
    return $9f8b16cebdbb6117$export$4cedd8740794bd78(node) || $9f8b16cebdbb6117$export$b05c7141ec7770ba(node) || $9f8b16cebdbb6117$export$fbc18e88163d676d(node);
}
function $9f8b16cebdbb6117$export$4cedd8740794bd78(node) {
    return node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).OPERATION_DEFINITION || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).FRAGMENT_DEFINITION;
}
function $9f8b16cebdbb6117$export$65772b71e1d017ba(node) {
    return node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).FIELD || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).FRAGMENT_SPREAD || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).INLINE_FRAGMENT;
}
function $9f8b16cebdbb6117$export$ab65b54ec7cbe9e4(node) {
    return node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).VARIABLE || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).INT || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).FLOAT || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).STRING || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).BOOLEAN || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).NULL || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).ENUM || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).LIST || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).OBJECT;
}
function $9f8b16cebdbb6117$export$f95bfad9e6aea45f(node) {
    return $9f8b16cebdbb6117$export$ab65b54ec7cbe9e4(node) && (node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).LIST ? node.values.some($9f8b16cebdbb6117$export$f95bfad9e6aea45f) : node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).OBJECT ? node.fields.some((field)=>$9f8b16cebdbb6117$export$f95bfad9e6aea45f(field.value)) : node.kind !== (0, $c9d7601e69c085e8$export$a84bdc57c5122798).VARIABLE);
}
function $9f8b16cebdbb6117$export$26e8a4730f4310f4(node) {
    return node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).NAMED_TYPE || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).LIST_TYPE || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).NON_NULL_TYPE;
}
function $9f8b16cebdbb6117$export$b05c7141ec7770ba(node) {
    return node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).SCHEMA_DEFINITION || $9f8b16cebdbb6117$export$a3584bba04f5bfe0(node) || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).DIRECTIVE_DEFINITION;
}
function $9f8b16cebdbb6117$export$a3584bba04f5bfe0(node) {
    return node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).UNION_TYPE_DEFINITION || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION;
}
function $9f8b16cebdbb6117$export$fbc18e88163d676d(node) {
    return node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).SCHEMA_EXTENSION || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).DIRECTIVE_EXTENSION || $9f8b16cebdbb6117$export$d7907721b241e11f(node);
}
function $9f8b16cebdbb6117$export$d7907721b241e11f(node) {
    return node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).UNION_TYPE_EXTENSION || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION;
}
function $9f8b16cebdbb6117$export$9c93c002c59dc2d6(node) {
    return node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).TYPE_COORDINATE || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).MEMBER_COORDINATE || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).ARGUMENT_COORDINATE || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).DIRECTIVE_COORDINATE || node.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).DIRECTIVE_ARGUMENT_COORDINATE;
}




var $dc81f3128dc8fcdb$export$ac9723609f5c76c2 = new (0, $f6d7836b3fbc48f1$export$8c6ed5c666ac1360)();
var $dc81f3128dc8fcdb$var$cacheInfoMap = new WeakMap();
function $dc81f3128dc8fcdb$var$getCacheInfo(cache) {
    var info = $dc81f3128dc8fcdb$var$cacheInfoMap.get(cache);
    if (!info) $dc81f3128dc8fcdb$var$cacheInfoMap.set(cache, info = {
        vars: new Set(),
        dep: (0, $aed695b3db154433$export$c723b7eff9d8f870)()
    });
    return info;
}
function $dc81f3128dc8fcdb$export$cbe12faed7725318(cache) {
    $dc81f3128dc8fcdb$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.forgetCache(cache);
    });
}
function $dc81f3128dc8fcdb$export$f342bdd61b3e9412(cache) {
    $dc81f3128dc8fcdb$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.attachCache(cache);
    });
}
function $dc81f3128dc8fcdb$export$5345c8ac69b4a9db(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function(newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function(cache) {
                    // Invalidate any fields with custom read functions that
                    // consumed this variable, so query results involving those
                    // fields will be recomputed the next time we read them.
                    $dc81f3128dc8fcdb$var$getCacheInfo(cache).dep.dirty(rv);
                    // Broadcast changes to any caches that have previously read
                    // from this variable.
                    $dc81f3128dc8fcdb$var$broadcast(cache);
                });
                // Finally, notify any listeners added via rv.onNextChange.
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function(listener) {
                    return listener(value);
                });
            }
        } else {
            // When reading from the variable, obtain the current cache from
            // context via cacheSlot. This isn't entirely foolproof, but it's
            // the same system that powers varDep.
            var cache = $dc81f3128dc8fcdb$export$ac9723609f5c76c2.getValue();
            if (cache) {
                attach(cache);
                $dc81f3128dc8fcdb$var$getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function(listener) {
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function(cache) {
        caches.add(cache);
        $dc81f3128dc8fcdb$var$getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function(cache) {
        return caches.delete(cache);
    };
    return rv;
}
function $dc81f3128dc8fcdb$var$broadcast(cache) {
    if (cache.broadcastWatches) cache.broadcastWatches();
}


var $fe65c9fcaf499ecf$export$19901bcd339c3ded = /** @class */ function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.selectionsToResolveCache = new WeakMap();
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $ad19e8268fdfbd88$export$dd702b3c8240390c)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $ad19e8268fdfbd88$export$dd702b3c8240390c)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    // Run local client resolvers against the incoming query and remote data.
    // Locally resolved field values are merged with the incoming remote data,
    // and returned. Note that locally resolved fields will overwrite
    // remote data using the same field name.
    LocalState.prototype.runResolvers = function(_a) {
        return (0, $b8xcN.__awaiter)(this, arguments, void 0, function(_b) {
            var document = _b.document, remoteResult = _b.remoteResult, context = _b.context, variables = _b.variables, _c = _b.onlyRunForcedResolvers, onlyRunForcedResolvers = _c === void 0 ? false : _c;
            return (0, $b8xcN.__generator)(this, function(_d) {
                if (document) return [
                    2 /*return*/ ,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2 /*return*/ ,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    // Client queries contain everything in the incoming document (if a @client
    // directive is found).
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $5a6e90bd3aec77b4$export$2dafb573e282fe8d)([
            "client"
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    // Server queries are stripped of all @client based selection sets.
    LocalState.prototype.serverQuery = function(document) {
        return (0, $19cabdf265088897$export$8eae69e876ee321e)(document);
    };
    LocalState.prototype.prepareContext = function(context) {
        var cache = this.cache;
        return (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, context), {
            cache: cache,
            // Getting an entry's cache key is useful for local state resolvers.
            getCacheKey: function(obj) {
                return cache.identify(obj);
            }
        });
    };
    // To support `@client @export(as: "someVar")` syntax, we'll first resolve
    // @client @export fields locally, then pass the resolved values back to be
    // used alongside the original operation variables.
    LocalState.prototype.addExportedVariables = function(document_1) {
        return (0, $b8xcN.__awaiter)(this, arguments, void 0, function(document, variables, context) {
            if (variables === void 0) variables = {};
            if (context === void 0) context = {};
            return (0, $b8xcN.__generator)(this, function(_a) {
                if (document) return [
                    2 /*return*/ ,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2 /*return*/ ,
                    (0, $b8xcN.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $5c27cd6fd658cc32$export$bf638b60ea8b89b7)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === "client" && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === "always" && arg.value.kind === "BooleanValue" && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $5c27cd6fd658cc32$export$a89c95c098ac2a58;
                    }
                }
            }
        });
        return forceResolvers;
    };
    // Query the cache and return matching data.
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $19cabdf265088897$export$57c368c23873f32b)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document_1, rootValue_1) {
        return (0, $b8xcN.__awaiter)(this, arguments, void 0, function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
            var mainDefinition, fragments, fragmentMap, selectionsToResolve, definitionOperation, defaultOperationType, _a, cache, client, execContext, isClientFieldDescendant;
            if (context === void 0) context = {};
            if (variables === void 0) variables = {};
            if (fragmentMatcher === void 0) fragmentMatcher = function() {
                return true;
            };
            if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
            return (0, $b8xcN.__generator)(this, function(_b) {
                mainDefinition = (0, $6d75937eba8e6f1c$export$f431198736b7f96d)(document);
                fragments = (0, $6d75937eba8e6f1c$export$5320a7ba9466a3df)(document);
                fragmentMap = (0, $070763719c7946cb$export$193789b4c8246dd4)(fragments);
                selectionsToResolve = this.collectSelectionsToResolve(mainDefinition, fragmentMap);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? definitionOperation.charAt(0).toUpperCase() + definitionOperation.slice(1) : "Query";
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    selectionsToResolve: selectionsToResolve,
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                isClientFieldDescendant = false;
                return [
                    2 /*return*/ ,
                    this.resolveSelectionSet(mainDefinition.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, isClientFieldDescendant, rootValue, execContext) {
        return (0, $b8xcN.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $b8xcN.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $b8xcN.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $b8xcN.__generator)(this, function(_a) {
                            if (!isClientFieldDescendant && !execContext.selectionsToResolve.has(selection)) // Skip selections without @client directives
                            // (still processing if one of the ancestors or one of the child fields has @client directive)
                            return [
                                2 /*return*/ 
                            ];
                            if (!(0, $5a6e90bd3aec77b4$export$3dc388a5f013b4a5)(selection, variables)) // Skip this entirely.
                            return [
                                2 /*return*/ 
                            ];
                            if ((0, $6ee6592fd95fa693$export$fb56ad75dd311c12)(selection)) return [
                                2 /*return*/ ,
                                this.resolveField(selection, isClientFieldDescendant, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== "undefined") resultsToMerge.push((_a = {}, _a[(0, $6ee6592fd95fa693$export$7d1ad22471852218)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $6ee6592fd95fa693$export$22a1cdafaf27bcff)(selection)) fragment = selection;
                            else {
                                // This is a named fragment.
                                fragment = fragmentMap[selection.name.value];
                                (0, $c21c2000775800f2$export$f5708dca728d7177)(fragment, 21, selection.name.value);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2 /*return*/ ,
                                    this.resolveSelectionSet(fragment.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                };
                return [
                    2 /*return*/ ,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $ad19e8268fdfbd88$export$160070228be94b08)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, isClientFieldDescendant, rootValue, execContext) {
        return (0, $b8xcN.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $b8xcN.__generator)(this, function(_a) {
                if (!rootValue) return [
                    2 /*return*/ ,
                    null
                ];
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $6ee6592fd95fa693$export$7d1ad22471852218)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                // Usually all local resolvers are run when passing through here, but
                // if we've specifically identified that we only want to run forced
                // resolvers (that is, resolvers for fields marked with
                // `@client(always: true)`), then we'll skip running non-forced resolvers.
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(// In case the resolve function accesses reactive variables,
                        // set cacheSlot to the current cache instance.
                        (0, $dc81f3128dc8fcdb$export$ac9723609f5c76c2).withValue(this.cache, resolve, [
                            rootValue,
                            (0, $6ee6592fd95fa693$export$3f5a60fb6a781b4f)(field, variables),
                            execContext.context,
                            {
                                field: field,
                                fragmentMap: execContext.fragmentMap
                            }
                        ]));
                    }
                }
                return [
                    2 /*return*/ ,
                    resultPromise.then(function(result) {
                        var _a, _b;
                        if (result === void 0) result = defaultResult;
                        // If an @export directive is associated with the current field, store
                        // the `as` export variable name and current result for later use.
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === "export" && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === "as" && arg.value.kind === "StringValue") execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        // Handle all scalar types here.
                        if (!field.selectionSet) return result;
                        // From here down, the field has a selection set, which means it's trying
                        // to query a GraphQLObjectType.
                        if (result == null) // Basically any field in a GraphQL response can be null, or missing
                        return result;
                        var isClientField = (_b = (_a = field.directives) === null || _a === void 0 ? void 0 : _a.some(function(d) {
                            return d.name.value === "client";
                        })) !== null && _b !== void 0 ? _b : false;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant || isClientField, result, execContext);
                        // Returned value is an object, and the query has a sub-selection. Recurse.
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant || isClientField, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, isClientFieldDescendant, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            // This is a nested array, recurse.
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant, item, execContext);
            // This is an object, run the selection set on it.
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant, item, execContext);
        }));
    };
    // Collect selection nodes on paths from document root down to all @client directives.
    // This function takes into account transitive fragment spreads.
    // Complexity equals to a single `visit` over the full document.
    LocalState.prototype.collectSelectionsToResolve = function(mainDefinition, fragmentMap) {
        var isSingleASTNode = function(node) {
            return !Array.isArray(node);
        };
        var selectionsToResolveCache = this.selectionsToResolveCache;
        function collectByDefinition(definitionNode) {
            if (!selectionsToResolveCache.has(definitionNode)) {
                var matches_1 = new Set();
                selectionsToResolveCache.set(definitionNode, matches_1);
                (0, $5c27cd6fd658cc32$export$bf638b60ea8b89b7)(definitionNode, {
                    Directive: function(node, _, __, ___, ancestors) {
                        if (node.name.value === "client") ancestors.forEach(function(node) {
                            if (isSingleASTNode(node) && (0, $9f8b16cebdbb6117$export$65772b71e1d017ba)(node)) matches_1.add(node);
                        });
                    },
                    FragmentSpread: function(spread, _, __, ___, ancestors) {
                        var fragment = fragmentMap[spread.name.value];
                        (0, $c21c2000775800f2$export$f5708dca728d7177)(fragment, 22, spread.name.value);
                        var fragmentSelections = collectByDefinition(fragment);
                        if (fragmentSelections.size > 0) {
                            // Fragment for this spread contains @client directive (either directly or transitively)
                            // Collect selection nodes on paths from the root down to fields with the @client directive
                            ancestors.forEach(function(node) {
                                if (isSingleASTNode(node) && (0, $9f8b16cebdbb6117$export$65772b71e1d017ba)(node)) matches_1.add(node);
                            });
                            matches_1.add(spread);
                            fragmentSelections.forEach(function(selection) {
                                matches_1.add(selection);
                            });
                        }
                    }
                });
            }
            return selectionsToResolveCache.get(definitionNode);
        }
        return collectByDefinition(mainDefinition);
    };
    return LocalState;
}();




var $c881dafd782f0198$var$hasSuggestedDevtools = false;
/**
 * This is the primary Apollo Client class. It is used to send GraphQL documents (i.e. queries
 * and mutations) to a GraphQL spec-compliant server over an `ApolloLink` instance,
 * receive results from the server and cache the results in a store. It also delivers updates
 * to GraphQL queries through `Observable` instances.
 */ var $c881dafd782f0198$export$13f5a5f0f1dbab88 = /** @class */ function() {
    /**
     * Constructs an instance of `ApolloClient`.
     *
     * @example
     * ```js
     * import { ApolloClient, InMemoryCache } from '@apollo/client';
     *
     * const cache = new InMemoryCache();
     *
     * const client = new ApolloClient({
     *   // Provide required constructor fields
     *   cache: cache,
     *   uri: 'http://localhost:4000/',
     *
     *   // Provide some optional constructor fields
     *   name: 'react-web-client',
     *   version: '1.3',
     *   queryDeduplication: false,
     *   defaultOptions: {
     *     watchQuery: {
     *       fetchPolicy: 'cache-and-network',
     *     },
     *   },
     * });
     * ```
     */ function ApolloClient(options) {
        var _this = this;
        var _a, _b, _c;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        if (!options.cache) throw (0, $c21c2000775800f2$export$3991762405098ea)(16);
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, documentTransform = options.documentTransform, _d = options.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = options.ssrForceFetchDelay, ssrForceFetchDelay = _e === void 0 ? 0 : _e, // Expose the client instance as window.__APOLLO_CLIENT__ and call
        // onBroadcast in queryManager.broadcastQueries to enable browser
        // devtools, but disable them by default in production.
        connectToDevTools = options.connectToDevTools, _f = options.queryDeduplication, queryDeduplication = _f === void 0 ? true : _f, defaultOptions = options.defaultOptions, defaultContext = options.defaultContext, _g = options.assumeImmutableResults, assumeImmutableResults = _g === void 0 ? cache.assumeImmutableResults : _g, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwareness = options.clientAwareness, clientAwarenessName = options.name, clientAwarenessVersion = options.version, devtools = options.devtools, dataMasking = options.dataMasking;
        if (globalThis.__DEV__ !== false) {
            (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(options, "connectToDevTools", "ApolloClient", "Please use `devtools.enabled` instead.");
            (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(options, "uri", "ApolloClient", "Please initialize an instance of `HttpLink` with `uri` instead.");
            (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(options, "credentials", "ApolloClient", "Please initialize an instance of `HttpLink` with `credentials` instead.");
            (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(options, "headers", "ApolloClient", "Please initialize an instance of `HttpLink` with `headers` instead.");
            (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(options, "name", "ApolloClient", "Please use the `clientAwareness.name` option instead.");
            (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(options, "version", "ApolloClient", "Please use the `clientAwareness.version` option instead.");
            (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(options, "typeDefs", "ApolloClient");
            if (!options.link) globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(17);
        }
        var link = options.link;
        if (!link) link = uri ? new (0, $7f67f06dc899def3$export$f4bbf1aec241cc1)({
            uri: uri,
            credentials: credentials,
            headers: headers
        }) : (0, $b03f28e182db18c2$export$2fed3d61f740bc7f).empty();
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        this.devtoolsConfig = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, devtools), {
            enabled: (_a = devtools === null || devtools === void 0 ? void 0 : devtools.enabled) !== null && _a !== void 0 ? _a : connectToDevTools
        });
        if (this.devtoolsConfig.enabled === undefined) this.devtoolsConfig.enabled = globalThis.__DEV__ !== false;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.watchFragment = this.watchFragment.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        this.version = (0, $533b640056a7d99c$export$83d89fbfd8236492);
        this.localState = new (0, $fe65c9fcaf499ecf$export$19901bcd339c3ded)({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new (0, $1e9add6d358ed7d5$export$b986383a50b53ea4)({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            defaultContext: defaultContext,
            documentTransform: documentTransform,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            dataMasking: !!dataMasking,
            clientAwareness: {
                name: (_b = clientAwareness === null || clientAwareness === void 0 ? void 0 : clientAwareness.name) !== null && _b !== void 0 ? _b : clientAwarenessName,
                version: (_c = clientAwareness === null || clientAwareness === void 0 ? void 0 : clientAwareness.version) !== null && _c !== void 0 ? _c : clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: this.devtoolsConfig.enabled ? function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.getQueryStore(),
                        mutations: _this.queryManager.mutationStore || {}
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            } : void 0
        });
        if (this.devtoolsConfig.enabled) this.connectToDevTools();
    }
    Object.defineProperty(ApolloClient.prototype, "prioritizeCacheValues", {
        /**
         * Whether to prioritize cache values over network results when `query` or `watchQuery` is called.
         * This will essentially turn a `"network-only"` or `"cache-and-network"` fetchPolicy into a `"cache-first"` fetchPolicy,
         * but without influencing the `fetchPolicy` of the created `ObservableQuery` long-term.
         *
         * This can e.g. be used to prioritize the cache during the first render after SSR.
         */ get: function() {
            return this.disableNetworkFetches;
        },
        set: function(value) {
            this.disableNetworkFetches = value;
        },
        enumerable: false,
        configurable: true
    });
    ApolloClient.prototype.connectToDevTools = function() {
        if (typeof window === "undefined") return;
        var windowWithDevTools = window;
        var devtoolsSymbol = Symbol.for("apollo.devtools");
        (windowWithDevTools[devtoolsSymbol] = windowWithDevTools[devtoolsSymbol] || []).push(this);
        windowWithDevTools.__APOLLO_CLIENT__ = this;
        /**
         * Suggest installing the devtools for developers who don't have them
         */ if (!$c881dafd782f0198$var$hasSuggestedDevtools && globalThis.__DEV__ !== false) {
            $c881dafd782f0198$var$hasSuggestedDevtools = true;
            if (window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol)) setTimeout(function() {
                if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                    var nav = window.navigator;
                    var ua = nav && nav.userAgent;
                    var url = void 0;
                    if (typeof ua === "string") {
                        if (ua.indexOf("Chrome/") > -1) url = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                        else if (ua.indexOf("Firefox/") > -1) url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                    }
                    if (url) globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).log("Download the Apollo DevTools for a better development experience: %s", url);
                }
            }, 10000);
        }
    };
    Object.defineProperty(ApolloClient.prototype, "documentTransform", {
        /**
         * The `DocumentTransform` used to modify GraphQL documents before a request
         * is made. If a custom `DocumentTransform` is not provided, this will be the
         * default document transform.
         */ get: function() {
            return this.queryManager.documentTransform;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Call this method to terminate any active client processes, making it safe
     * to dispose of this `ApolloClient` instance.
     */ ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    /**
     * This watches the cache store of the query according to the options specified and
     * returns an `ObservableQuery`. We can subscribe to this `ObservableQuery` and
     * receive updated results through an observer when the cache store changes.
     *
     * Note that this method is not an implementation of GraphQL subscriptions. Rather,
     * it uses Apollo's store in order to reactively deliver updates to your query results.
     *
     * For example, suppose you call watchQuery on a GraphQL query that fetches a person's
     * first and last name and this person has a particular object identifier, provided by
     * dataIdFromObject. Later, a different query fetches that same person's
     * first and last name and the first name has now changed. Then, any observers associated
     * with the results of the first query will be updated with a new result object.
     *
     * Note that if the cache does not change, the subscriber will *not* be notified.
     *
     * See [here](https://medium.com/apollo-stack/the-concepts-of-graphql-bc68bd819be3#.3mb0cbcmc) for
     * a description of store reactivity.
     */ ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $a76f045ea055af6d$export$235b7fc70b9fc359)(this.defaultOptions.watchQuery, options);
        // XXX Overwriting options is probably not the best way to do this long term...
        if (this.disableNetworkFetches && (options.fetchPolicy === "network-only" || options.fetchPolicy === "cache-and-network")) options = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, options), {
            fetchPolicy: "cache-first"
        });
        if (globalThis.__DEV__ !== false) {
            (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(options, "canonizeResults", "client.watchQuery");
            (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(options, "partialRefetch", "client.watchQuery");
        }
        return this.queryManager.watchQuery(options);
    };
    /**
     * This resolves a single query according to the options specified and
     * returns a `Promise` which is either resolved with the resulting data
     * or rejected with an error.
     *
     * @param options - An object of type `QueryOptions` that allows us to
     * describe how this query should be treated e.g. whether it should hit the
     * server at all or just resolve from the cache, etc.
     */ ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $a76f045ea055af6d$export$235b7fc70b9fc359)(this.defaultOptions.query, options);
        (0, $c21c2000775800f2$export$f5708dca728d7177)(options.fetchPolicy !== "cache-and-network", 18);
        if (this.disableNetworkFetches && options.fetchPolicy === "network-only") options = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, options), {
            fetchPolicy: "cache-first"
        });
        if (globalThis.__DEV__ !== false) {
            (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(options, "canonizeResults", "client.query");
            (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(options, "notifyOnNetworkStatusChange", "client.query", "This option does not affect `client.query` and can be safely removed.");
            if (options.fetchPolicy === "standby") globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(19);
        }
        return this.queryManager.query(options);
    };
    /**
     * This resolves a single mutation according to the options specified and returns a
     * Promise which is either resolved with the resulting data or rejected with an
     * error. In some cases both `data` and `errors` might be undefined, for example
     * when `errorPolicy` is set to `'ignore'`.
     *
     * It takes options as an object with the following keys and values:
     */ ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $a76f045ea055af6d$export$235b7fc70b9fc359)(this.defaultOptions.mutate, options);
        return this.queryManager.mutate(options);
    };
    /**
     * This subscribes to a graphql subscription according to the options specified and returns an
     * `Observable` which either emits received data or an error.
     */ ApolloClient.prototype.subscribe = function(options) {
        var _this = this;
        var id = this.queryManager.generateQueryId();
        return this.queryManager.startGraphQLSubscription(options).map(function(result) {
            return (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, result), {
                data: _this.queryManager.maskOperation({
                    document: options.query,
                    data: result.data,
                    fetchPolicy: options.fetchPolicy,
                    id: id
                })
            });
        });
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL query without making a network request. This method will start at
     * the root query. To start at a specific id returned by `dataIdFromObject`
     * use `readFragment`.
     *
     * @param optimistic - Set to `true` to allow `readQuery` to return
     * optimistic results. Is `false` by default.
     */ ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    /**
     * Watches the cache store of the fragment according to the options specified
     * and returns an `Observable`. We can subscribe to this
     * `Observable` and receive updated results through an
     * observer when the cache store changes.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     *
     * @since 3.10.0
     * @param options - An object of type `WatchFragmentOptions` that allows
     * the cache to identify the fragment and optionally specify whether to react
     * to optimistic updates.
     */ ApolloClient.prototype.watchFragment = function(options) {
        var _a;
        return this.cache.watchFragment((0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, options), (_a = {}, _a[Symbol.for("apollo.dataMasking")] = this.queryManager.dataMasking, _a)));
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL fragment without making a network request. This method will read a
     * GraphQL fragment from any arbitrary id that is currently cached, unlike
     * `readQuery` which will only read from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     *
     * @param optimistic - Set to `true` to allow `readFragment` to return
     * optimistic results. Is `false` by default.
     */ ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    /**
     * Writes some data in the shape of the provided GraphQL query directly to
     * the store. This method will start at the root query. To start at a
     * specific id returned by `dataIdFromObject` then use `writeFragment`.
     */ ApolloClient.prototype.writeQuery = function(options) {
        var ref = this.cache.writeQuery(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    /**
     * Writes some data in the shape of the provided GraphQL fragment directly to
     * the store. This method will write to a GraphQL fragment from any arbitrary
     * id that is currently cached, unlike `writeQuery` which will only write
     * from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are writing. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     */ ApolloClient.prototype.writeFragment = function(options) {
        var ref = this.cache.writeFragment(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $2ff40892a1abf83c$export$51396ec711da548b)(this.link, payload);
    };
    /**
     * Resets your entire store by clearing out your cache and then re-executing
     * all of your active queries. This makes it so that you may guarantee that
     * there is no data left in your store from a time before you called this
     * method.
     *
     * `resetStore()` is useful when your user just logged out. You’ve removed the
     * user session, and you now want to make sure that any references to data you
     * might have fetched while the user session was active is gone.
     *
     * It is important to remember that `resetStore()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: false
            });
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    /**
     * Remove all data from the store. Unlike `resetStore`, `clearStore` will
     * not refetch any active queries.
     */ ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: true
            });
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * reset. `onResetStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * cleared. `onClearStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    /**
     * Refetches all of your active queries.
     *
     * `reFetchObservableQueries()` is useful if you want to bring the client back to proper state in case of a network outage
     *
     * It is important to remember that `reFetchObservableQueries()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     * Takes optional parameter `includeStandby` which will include queries in standby-mode when refetching.
     */ ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    /**
     * Refetches specified active queries. Similar to "reFetchObservableQueries()" but with a specific list of queries.
     *
     * `refetchQueries()` is useful for use cases to imperatively refresh a selection of queries.
     *
     * It is important to remember that `refetchQueries()` *will* refetch specified active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ ApolloClient.prototype.refetchQueries = function(options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function(result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        // In case you need the raw results immediately, without awaiting
        // Promise.all(results):
        result.queries = queries;
        result.results = results;
        // If you decide to ignore the result Promise because you're using
        // result.queries and result.results instead, you shouldn't have to worry
        // about preventing uncaught rejections for the Promise.all result.
        result.catch(function(error) {
            globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).debug(20, error);
        });
        return result;
    };
    /**
     * Get all currently active `ObservableQuery` objects, in a `Map` keyed by
     * query ID strings.
     *
     * An "active" query is one that has observers and a `fetchPolicy` other than
     * "standby" or "cache-only".
     *
     * You can include all `ObservableQuery` objects (including the inactive ones)
     * by passing "all" instead of "active", or you can include just a subset of
     * active queries by passing an array of query names or DocumentNode objects.
     */ ApolloClient.prototype.getObservableQueries = function(include) {
        if (include === void 0) include = "active";
        return this.queryManager.getObservableQueries(include);
    };
    /**
     * Exposes the cache's complete state, in a serializable format for later restoration.
     */ ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    /**
     * Replaces existing state in the cache (if any) with the values expressed by
     * `serializedState`.
     *
     * Called when hydrating a cache (server side rendering, or offline storage),
     * and also (potentially) during hot reloads.
     */ ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    /**
     * Add additional local resolvers.
     *
     * @deprecated `addResolvers` will been removed in Apollo Client 4.0. It is
     * safe to continue using this method in Apollo Client 3.x.
     *
     * **Recommended now**
     *
     * No action needed
     *
     * **When upgrading**
     *
     * Use `client.localState.addResolvers(resolvers)`. Alternatively, store
     * the `LocalState` instance in a separate variable and call `addResolvers` on
     * that.
     */ ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    /**
     * Set (override existing) local resolvers.
     *
     * @deprecated `setResolvers` will been removed in Apollo Client 4.0. It is
     * safe to continue using this method in Apollo Client 3.x.
     *
     * **Recommended now**
     *
     * If possible, stop using the `setResolvers` method.
     *
     * **When upgrading**
     *
     * Remove the use of `setResolvers`.
     */ ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    /**
     * Get all registered local resolvers.
     *
     * @deprecated `getResolvers` will be removed in Apollo Client 4.0. It is
     * safe to continue using this method in Apollo Client 3.x.
     *
     * **Recommended now**
     *
     * If possible, stop using the `getResolvers` method.
     *
     * **When upgrading**
     *
     * Remove the use of `getResolvers`.
     */ ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    /**
     * Set a custom local state fragment matcher.
     *
     * @deprecated Custom fragment matchers will no longer be supported in Apollo
     * Client 4.0 and has been replaced by `cache.fragmentMatches`. It is safe to
     * continue using `setLocalStateFragmentMatcher` in Apollo Client 3.x.
     *
     * **Recommended now**
     *
     * No action needed
     *
     * **When upgrading**
     *
     * Leverage `possibleTypes` with `InMemoryCache` to ensure fragments match
     * correctly. Ensure `possibleTypes` include local types if needed. If working
     * with a 3rd party cache implementation, ensure the 3rd party cache implements
     * the `cache.fragmentMatches` method. This function should no longer be used.
     */ ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    /**
     * Define a new ApolloLink (or link chain) that Apollo Client will use.
     */ ApolloClient.prototype.setLink = function(newLink) {
        this.link = this.queryManager.link = newLink;
    };
    Object.defineProperty(ApolloClient.prototype, "defaultContext", {
        get: function() {
            return this.queryManager.defaultContext;
        },
        enumerable: false,
        configurable: true
    });
    return ApolloClient;
}();
if (globalThis.__DEV__ !== false) $c881dafd782f0198$export$13f5a5f0f1dbab88.prototype.getMemoryInternals = (0, $afbf6f02b98da1f0$export$dfdba94ce46d2ea5);


var $f81266456f9cf9a5$export$6788812c4e6611e6 = (0, $b03f28e182db18c2$export$2fed3d61f740bc7f).from;


var $b8xcN = parcelRequire("b8xcN");





var $b8xcN = parcelRequire("b8xcN");







var $a586c9827fcb602f$export$5fc74f25506aa9c = /** @class */ function() {
    function ApolloCache() {
        this.assumeImmutableResults = false;
        // Make sure we compute the same (===) fragment query document every
        // time we receive the same fragment in readFragment.
        this.getFragmentDoc = (0, $2a919cc3f1f126e4$export$4997ffc0176396a6)((0, $070763719c7946cb$export$abbf37c7cf644e41), {
            max: (0, $d301603631c7863b$export$f29926b23b28936b)["cache.fragmentQueryDocuments"] || 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
            cache: (0, $2e667e6fa29c5a74$export$87b462129af3b7d4)
        });
    }
    // Function used to lookup a fragment when a fragment definition is not part
    // of the GraphQL document. This is useful for caches, such as InMemoryCache,
    // that register fragments ahead of time so they can be referenced by name.
    ApolloCache.prototype.lookupFragment = function(fragmentName) {
        return null;
    };
    // Transactional API
    // The batch method is intended to replace/subsume both performTransaction
    // and recordOptimisticTransaction, but performTransaction came first, so we
    // provide a default batch implementation that's just another way of calling
    // performTransaction. Subclasses of ApolloCache (such as InMemoryCache) can
    // override the batch method to do more interesting things with its options.
    ApolloCache.prototype.batch = function(options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic : options.optimistic === false ? null : void 0;
        var updateResult;
        this.performTransaction(function() {
            return updateResult = options.update(_this);
        }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function(transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    // Optional API
    // Called once per input document, allowing the cache to make static changes
    // to the query, such as adding __typename fields.
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    // Called before each ApolloLink request, allowing the cache to make dynamic
    // changes to the query, such as filling in missing fragment definitions.
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.identify = function(object) {
        return;
    };
    ApolloCache.prototype.gc = function() {
        return [];
    };
    ApolloCache.prototype.modify = function(options) {
        return false;
    };
    // DataProxy API
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        var _this = this;
        if (optimistic === void 0) optimistic = !!options.optimistic;
        if (globalThis.__DEV__ !== false) (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(options, "canonizeResults", "cache.readQuery");
        return (0, $14465ad01ccc354a$export$d18d1529326946c4)("canonizeResults", function() {
            return _this.read((0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, options), {
                rootId: options.id || "ROOT_QUERY",
                optimistic: optimistic
            }));
        });
    };
    /** {@inheritDoc @apollo/client!ApolloClient#watchFragment:member(1)} */ ApolloCache.prototype.watchFragment = function(options) {
        var _this = this;
        var fragment = options.fragment, fragmentName = options.fragmentName, from = options.from, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, otherOptions = (0, $b8xcN.__rest)(options, [
            "fragment",
            "fragmentName",
            "from",
            "optimistic"
        ]);
        var query = this.getFragmentDoc(fragment, fragmentName);
        // While our TypeScript types do not allow for `undefined` as a valid
        // `from`, its possible `useFragment` gives us an `undefined` since it
        // calls` cache.identify` and provides that value to `from`. We are
        // adding this fix here however to ensure those using plain JavaScript
        // and using `cache.identify` themselves will avoid seeing the obscure
        // warning.
        var id = typeof from === "undefined" || typeof from === "string" ? from : this.identify(from);
        var dataMasking = !!options[Symbol.for("apollo.dataMasking")];
        if (globalThis.__DEV__ !== false) {
            var actualFragmentName = fragmentName || (0, $6d75937eba8e6f1c$export$772111caef41b3f5)(fragment).name.value;
            if (!id) globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(1, actualFragmentName);
        }
        var diffOptions = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, otherOptions), {
            returnPartialData: true,
            id: id,
            query: query,
            optimistic: optimistic
        });
        var latestDiff;
        return new (0, $2027033ce24a9479$export$77cea355fa80b5f4)(function(observer) {
            return _this.watch((0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, diffOptions), {
                immediate: true,
                callback: function(diff) {
                    var data = dataMasking ? (0, $7f9612e058b3c19c$export$adbebb59d1aeea97)(diff.result, fragment, _this, fragmentName) : diff.result;
                    if (// Always ensure we deliver the first result
                    latestDiff && (0, $c138ca7e3590aefa$export$5e40714c5ad44445)(query, {
                        data: latestDiff.result
                    }, {
                        data: data
                    }, // TODO: Fix the type on WatchFragmentOptions so that TVars
                    // extends OperationVariables
                    options.variables)) return;
                    var result = {
                        data: data,
                        complete: !!diff.complete
                    };
                    if (diff.missing) result.missing = (0, $ad19e8268fdfbd88$export$160070228be94b08)(diff.missing.map(function(error) {
                        return error.missing;
                    }));
                    latestDiff = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, diff), {
                        result: data
                    });
                    observer.next(result);
                }
            }));
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        var _this = this;
        if (optimistic === void 0) optimistic = !!options.optimistic;
        if (globalThis.__DEV__ !== false) (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(options, "canonizeResults", "cache.readFragment");
        return (0, $14465ad01ccc354a$export$d18d1529326946c4)("canonizeResults", function() {
            return _this.read((0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, options), {
                query: _this.getFragmentDoc(options.fragment, options.fragmentName),
                rootId: options.id,
                optimistic: optimistic
            }));
        });
    };
    ApolloCache.prototype.writeQuery = function(_a) {
        var id = _a.id, data = _a.data, options = (0, $b8xcN.__rest)(_a, [
            "id",
            "data"
        ]);
        return this.write(Object.assign(options, {
            dataId: id || "ROOT_QUERY",
            result: data
        }));
    };
    ApolloCache.prototype.writeFragment = function(_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = (0, $b8xcN.__rest)(_a, [
            "id",
            "data",
            "fragment",
            "fragmentName"
        ]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data
        }));
    };
    ApolloCache.prototype.updateQuery = function(options, update) {
        if (globalThis.__DEV__ !== false) (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(options, "canonizeResults", "cache.updateQuery");
        return this.batch({
            update: function(cache) {
                var value = (0, $14465ad01ccc354a$export$d18d1529326946c4)("canonizeResults", function() {
                    return cache.readQuery(options);
                });
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeQuery((0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    ApolloCache.prototype.updateFragment = function(options, update) {
        if (globalThis.__DEV__ !== false) (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(options, "canonizeResults", "cache.updateFragment");
        return this.batch({
            update: function(cache) {
                var value = (0, $14465ad01ccc354a$export$d18d1529326946c4)("canonizeResults", function() {
                    return cache.readFragment(options);
                });
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeFragment((0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    return ApolloCache;
}();
if (globalThis.__DEV__ !== false) $a586c9827fcb602f$export$5fc74f25506aa9c.prototype.getMemoryInternals = (0, $afbf6f02b98da1f0$export$e7ed438e82606689);



var $b8xcN = parcelRequire("b8xcN");
var $abe96c5581ab8a1e$export$257c68286583b0f9 = /** @class */ function(_super) {
    (0, $b8xcN.__extends)(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        // 'Error' breaks prototype chain here
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for(var i = _this.path.length - 1; i >= 0; --i)_this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
        } else _this.missing = _this.path;
        // We're not using `Object.setPrototypeOf` here as it isn't fully supported
        // on Android (see issue #3236).
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error);




var $b8xcN = parcelRequire("b8xcN");





var $b8xcN = parcelRequire("b8xcN");






var $21d6b69e155d5d08$export$b5a638e9b3fff9f3 = Object.prototype.hasOwnProperty;
function $21d6b69e155d5d08$export$b931b78cbb3caf86(value) {
    return value === null || value === void 0;
}
function $21d6b69e155d5d08$export$bd03c5a9c99d6bce(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) context.keyObject = !$21d6b69e155d5d08$export$b931b78cbb3caf86(id) ? {
            id: id
        } : !$21d6b69e155d5d08$export$b931b78cbb3caf86(_id) ? {
            _id: _id
        } : void 0;
        // If there is no object.id, fall back to object._id.
        if ($21d6b69e155d5d08$export$b931b78cbb3caf86(id) && !$21d6b69e155d5d08$export$b931b78cbb3caf86(_id)) id = _id;
        if (!$21d6b69e155d5d08$export$b931b78cbb3caf86(id)) return "".concat(__typename, ":").concat(typeof id === "number" || typeof id === "string" ? id : JSON.stringify(id));
    }
}
var $21d6b69e155d5d08$var$defaultConfig = {
    dataIdFromObject: $21d6b69e155d5d08$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    // Thanks to the shouldCanonizeResults helper, this should be the only line
    // you have to change to reenable canonization by default in the future.
    canonizeResults: false
};
function $21d6b69e155d5d08$export$fa542f9ee3f7f4e2(config) {
    return (0, $b37018ac55880203$export$8e16b83750b44988)($21d6b69e155d5d08$var$defaultConfig, config);
}
function $21d6b69e155d5d08$export$3ac2a95fbd99c479(config) {
    var value = config.canonizeResults;
    return value === void 0 ? $21d6b69e155d5d08$var$defaultConfig.canonizeResults : value;
}
function $21d6b69e155d5d08$export$fdef206c83ff2c09(store, objectOrReference) {
    return (0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(objectOrReference) ? store.get(objectOrReference.__ref, "__typename") : objectOrReference && objectOrReference.__typename;
}
var $21d6b69e155d5d08$export$6ed54d4784f1ce28 = /^[_a-z][_0-9a-z]*/i;
function $21d6b69e155d5d08$export$37874422037b6029(storeFieldName) {
    var match = storeFieldName.match($21d6b69e155d5d08$export$6ed54d4784f1ce28);
    return match ? match[0] : storeFieldName;
}
function $21d6b69e155d5d08$export$60bd1cbb09c1a4a2(selectionSet, result, variables) {
    if ((0, $01d0d880754ccbd1$export$417207af72fad9c9)(result)) return (0, $01c8f68cc3e070ef$export$43bee75e5e14138e)(result) ? result.every(function(item) {
        return $21d6b69e155d5d08$export$60bd1cbb09c1a4a2(selectionSet, item, variables);
    }) : selectionSet.selections.every(function(field) {
        if ((0, $6ee6592fd95fa693$export$fb56ad75dd311c12)(field) && (0, $5a6e90bd3aec77b4$export$3dc388a5f013b4a5)(field, variables)) {
            var key = (0, $6ee6592fd95fa693$export$7d1ad22471852218)(field);
            return $21d6b69e155d5d08$export$b5a638e9b3fff9f3.call(result, key) && (!field.selectionSet || $21d6b69e155d5d08$export$60bd1cbb09c1a4a2(field.selectionSet, result[key], variables));
        }
        // If the selection has been skipped with @skip(true) or
        // @include(false), it should not count against the matching. If
        // the selection is not a field, it must be a fragment (inline or
        // named). We will determine if selectionSetMatchesResult for that
        // fragment when we get to it, so for now we return true.
        return true;
    });
    return false;
}
function $21d6b69e155d5d08$export$4f39afca21bd938e(value) {
    return (0, $01d0d880754ccbd1$export$417207af72fad9c9)(value) && !(0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(value) && !(0, $01c8f68cc3e070ef$export$43bee75e5e14138e)(value);
}
function $21d6b69e155d5d08$export$b874a818f7a2fa6d() {
    return new (0, $ad19e8268fdfbd88$export$509e11c221f576c0)();
}
function $21d6b69e155d5d08$export$3a33c00f0ae4a480(document, fragments) {
    // FragmentMap consisting only of fragments defined directly in document, not
    // including other fragments registered in the FragmentRegistry.
    var fragmentMap = (0, $070763719c7946cb$export$193789b4c8246dd4)((0, $6d75937eba8e6f1c$export$5320a7ba9466a3df)(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function(name) {
            var def = fragmentMap[name];
            if (!def && fragments) def = fragments.lookup(name);
            return def || null;
        }
    };
}


var $f2796c17db7cbf02$var$DELETE = Object.create(null);
var $f2796c17db7cbf02$var$delModifier = function() {
    return $f2796c17db7cbf02$var$DELETE;
};
var $f2796c17db7cbf02$var$INVALIDATE = Object.create(null);
var $f2796c17db7cbf02$export$cb507f57054c7321 = /** @class */ function() {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        // Maps root entity IDs to the number of times they have been retained, minus
        // the number of times they have been released. Retained entities keep other
        // entities they reference (even indirectly) from being garbage collected.
        this.rootIds = Object.create(null);
        // Lazily tracks { __ref: <dataId> } strings contained by this.data[dataId].
        this.refs = Object.create(null);
        // Bound function that can be passed around to provide easy access to fields
        // of Reference objects as well as ordinary objects.
        this.getFieldValue = function(objectOrReference, storeFieldName) {
            return (0, $5d04349b74d4efd7$export$7f9c177735b71f18)((0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(objectOrReference) ? _this.get(objectOrReference.__ref, storeFieldName) : objectOrReference && objectOrReference[storeFieldName]);
        };
        // Returns true for non-normalized StoreObjects and non-dangling
        // References, indicating that readField(name, objOrRef) has a chance of
        // working. Useful for filtering out dangling references from lists.
        this.canRead = function(objOrRef) {
            return (0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(objOrRef) ? _this.has(objOrRef.__ref) : typeof objOrRef === "object";
        };
        // Bound function that converts an id or an object with a __typename and
        // primary key fields to a Reference object. If called with a Reference object,
        // that same Reference object is returned. Pass true for mergeIntoStore to persist
        // an object into the store.
        this.toReference = function(objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") return (0, $6ee6592fd95fa693$export$634ae0e932e9be99)(objOrIdOrRef);
            if ((0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(objOrIdOrRef)) return objOrIdOrRef;
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = (0, $6ee6592fd95fa693$export$634ae0e932e9be99)(id);
                if (mergeIntoStore) _this.merge(id, objOrIdOrRef);
                return ref;
            }
        };
    }
    // Although the EntityStore class is abstract, it contains concrete
    // implementations of the various NormalizedCache interface methods that
    // are inherited by the Root and Layer subclasses.
    EntityStore.prototype.toObject = function() {
        return (0, $b8xcN.__assign)({}, this.data);
    };
    EntityStore.prototype.has = function(dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function(dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if ((0, $21d6b69e155d5d08$export$b5a638e9b3fff9f3).call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && (0, $21d6b69e155d5d08$export$b5a638e9b3fff9f3).call(storeObject, fieldName)) return storeObject[fieldName];
        }
        if (fieldName === "__typename" && (0, $21d6b69e155d5d08$export$b5a638e9b3fff9f3).call(this.policies.rootTypenamesById, dataId)) return this.policies.rootTypenamesById[dataId];
        if (this instanceof $f2796c17db7cbf02$var$Layer) return this.parent.get(dataId, fieldName);
    };
    EntityStore.prototype.lookup = function(dataId, dependOnExistence) {
        // The has method (above) calls lookup with dependOnExistence = true, so
        // that it can later be invalidated when we add or remove a StoreObject for
        // this dataId. Any consumer who cares about the contents of the StoreObject
        // should not rely on this dependency, since the contents could change
        // without the object being added or removed.
        if (dependOnExistence) this.group.depend(dataId, "__exists");
        if ((0, $21d6b69e155d5d08$export$b5a638e9b3fff9f3).call(this.data, dataId)) return this.data[dataId];
        if (this instanceof $f2796c17db7cbf02$var$Layer) return this.parent.lookup(dataId, dependOnExistence);
        if (this.policies.rootTypenamesById[dataId]) return Object.create(null);
    };
    EntityStore.prototype.merge = function(older, newer) {
        var _this = this;
        var dataId;
        // Convert unexpected references to ID strings.
        if ((0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(older)) older = older.__ref;
        if ((0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(newer)) newer = newer.__ref;
        var existing = typeof older === "string" ? this.lookup(dataId = older) : older;
        var incoming = typeof newer === "string" ? this.lookup(dataId = newer) : newer;
        // If newer was a string ID, but that ID was not defined in this store,
        // then there are no fields to be merged, so we're done.
        if (!incoming) return;
        (0, $c21c2000775800f2$export$f5708dca728d7177)(typeof dataId === "string", 2);
        var merged = new (0, $ad19e8268fdfbd88$export$509e11c221f576c0)($f2796c17db7cbf02$var$storeObjectReconciler).merge(existing, incoming);
        // Even if merged === existing, existing may have come from a lower
        // layer, so we always need to set this.data[dataId] on this level.
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                // If we added a new StoreObject where there was previously none, dirty
                // anything that depended on the existence of this dataId, such as the
                // EntityStore#has method.
                if (!existing) fieldsToDirty_1.__exists = 1;
                // Now invalidate dependents who called getFieldValue for any fields
                // that are changing as a result of this merge.
                Object.keys(incoming).forEach(function(storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        // Always dirty the full storeFieldName, which may include
                        // serialized arguments following the fieldName prefix.
                        fieldsToDirty_1[storeFieldName] = 1;
                        // Also dirty fieldNameFromStoreName(storeFieldName) if it's
                        // different from storeFieldName and this field does not have
                        // keyArgs configured, because that means the cache can't make
                        // any assumptions about how field values with the same field
                        // name but different arguments might be interrelated, so it
                        // must err on the side of invalidating all field values that
                        // share the same short fieldName, regardless of arguments.
                        var fieldName = (0, $21d6b69e155d5d08$export$37874422037b6029)(storeFieldName);
                        if (fieldName !== storeFieldName && !_this.policies.hasKeyArgs(merged.__typename, fieldName)) fieldsToDirty_1[fieldName] = 1;
                        // If merged[storeFieldName] has become undefined, and this is the
                        // Root layer, actually delete the property from the merged object,
                        // which is guaranteed to have been created fresh in this method.
                        if (merged[storeFieldName] === void 0 && !(_this instanceof $f2796c17db7cbf02$var$Layer)) delete merged[storeFieldName];
                    }
                });
                if (fieldsToDirty_1.__typename && !(existing && existing.__typename) && // Since we return default root __typename strings
                // automatically from store.get, we don't need to dirty the
                // ROOT_QUERY.__typename field if merged.__typename is equal
                // to the default string (usually "Query").
                this.policies.rootTypenamesById[dataId] === merged.__typename) delete fieldsToDirty_1.__typename;
                Object.keys(fieldsToDirty_1).forEach(function(fieldName) {
                    return _this.group.dirty(dataId, fieldName);
                });
            }
        }
    };
    EntityStore.prototype.modify = function(dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: $f2796c17db7cbf02$var$DELETE,
                INVALIDATE: $f2796c17db7cbf02$var$INVALIDATE,
                isReference: (0, $6ee6592fd95fa693$export$fa99cac1c0883c47),
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function(fieldNameOrOptions, from) {
                    return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                        fieldName: fieldNameOrOptions,
                        from: from || (0, $6ee6592fd95fa693$export$634ae0e932e9be99)(dataId)
                    } : fieldNameOrOptions, {
                        store: _this
                    });
                }
            };
            Object.keys(storeObject).forEach(function(storeFieldName) {
                var fieldName = (0, $21d6b69e155d5d08$export$37874422037b6029)(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0) return;
                var modify = typeof fields === "function" ? fields : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === $f2796c17db7cbf02$var$delModifier ? $f2796c17db7cbf02$var$DELETE : modify((0, $5d04349b74d4efd7$export$7f9c177735b71f18)(fieldValue), (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, sharedDetails_1), {
                        fieldName: fieldName,
                        storeFieldName: storeFieldName,
                        storage: _this.getStorage(dataId, storeFieldName)
                    }));
                    if (newValue === $f2796c17db7cbf02$var$INVALIDATE) _this.group.dirty(dataId, storeFieldName);
                    else {
                        if (newValue === $f2796c17db7cbf02$var$DELETE) newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                            if (globalThis.__DEV__ !== false) {
                                var checkReference = function(ref) {
                                    if (_this.lookup(ref.__ref) === undefined) {
                                        globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(3, ref);
                                        return true;
                                    }
                                };
                                if ((0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(newValue)) checkReference(newValue);
                                else if (Array.isArray(newValue)) {
                                    // Warn about writing "mixed" arrays of Reference and non-Reference objects
                                    var seenReference = false;
                                    var someNonReference = void 0;
                                    for(var _i = 0, newValue_1 = newValue; _i < newValue_1.length; _i++){
                                        var value = newValue_1[_i];
                                        if ((0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(value)) {
                                            seenReference = true;
                                            if (checkReference(value)) break;
                                        } else // Do not warn on primitive values, since those could never be represented
                                        // by a reference. This is a valid (albeit uncommon) use case.
                                        if (typeof value === "object" && !!value) {
                                            var id = _this.policies.identify(value)[0];
                                            // check if object could even be referenced, otherwise we are not interested in it for this warning
                                            if (id) someNonReference = value;
                                        }
                                        if (seenReference && someNonReference !== undefined) {
                                            globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(4, someNonReference);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (fieldValue !== void 0) allDeleted_1 = false;
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof $f2796c17db7cbf02$var$Layer) this.data[dataId] = void 0;
                    else delete this.data[dataId];
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    // If called with only one argument, removes the entire entity
    // identified by dataId. If called with a fieldName as well, removes all
    // fields of that entity whose names match fieldName according to the
    // fieldNameFromStoreName helper function. If called with a fieldName
    // and variables, removes all fields of that entity whose names match fieldName
    // and whose arguments when cached exactly match the variables passed.
    EntityStore.prototype.delete = function(dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args ? this.policies.getStoreFieldName({
                typename: typename,
                fieldName: fieldName,
                args: args
            }) : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {}, _a[storeFieldName] = $f2796c17db7cbf02$var$delModifier, _a) : $f2796c17db7cbf02$var$delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function(options, limit) {
        var evicted = false;
        if (options.id) {
            if ((0, $21d6b69e155d5d08$export$b5a638e9b3fff9f3).call(this.data, options.id)) evicted = this.delete(options.id, options.fieldName, options.args);
            if (this instanceof $f2796c17db7cbf02$var$Layer && this !== limit) evicted = this.parent.evict(options, limit) || evicted;
            // Always invalidate the field to trigger rereading of watched
            // queries, even if no cache data was modified by the eviction,
            // because queries may depend on computed fields with custom read
            // functions, whose values are not stored in the EntityStore.
            if (options.fieldName || evicted) this.group.dirty(options.id, options.fieldName || "__exists");
        }
        return evicted;
    };
    EntityStore.prototype.clear = function() {
        this.replace(null);
    };
    EntityStore.prototype.extract = function() {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function(id) {
            if (!(0, $21d6b69e155d5d08$export$b5a638e9b3fff9f3).call(_this.policies.rootTypenamesById, id)) extraRootIds.push(id);
        });
        if (extraRootIds.length) obj.__META = {
            extraRootIds: extraRootIds.sort()
        };
        return obj;
    };
    EntityStore.prototype.replace = function(newData) {
        var _this = this;
        Object.keys(this.data).forEach(function(dataId) {
            if (!(newData && (0, $21d6b69e155d5d08$export$b5a638e9b3fff9f3).call(newData, dataId))) _this.delete(dataId);
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0, $b8xcN.__rest)(newData, [
                "__META"
            ]);
            Object.keys(rest_1).forEach(function(dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) __META.extraRootIds.forEach(this.retain, this);
        }
    };
    EntityStore.prototype.retain = function(rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function(rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count) delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    // Return a Set<string> of all the ID strings that have been retained by
    // this layer/root *and* any layers/roots beneath it.
    EntityStore.prototype.getRootIdSet = function(ids) {
        if (ids === void 0) ids = new Set();
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof $f2796c17db7cbf02$var$Layer) this.parent.getRootIdSet(ids);
        else // Official singleton IDs like ROOT_QUERY and ROOT_MUTATION are
        // always considered roots for garbage collection, regardless of
        // their retainment counts in this.rootIds.
        Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        return ids;
    };
    // The goal of garbage collection is to remove IDs from the Root layer of the
    // store that are no longer reachable starting from any IDs that have been
    // explicitly retained (see retain and release, above). Returns an array of
    // dataId strings that were removed from the store.
    EntityStore.prototype.gc = function() {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function(id) {
            if ((0, $21d6b69e155d5d08$export$b5a638e9b3fff9f3).call(snapshot, id)) {
                // Because we are iterating over an ECMAScript Set, the IDs we add here
                // will be visited in later iterations of the forEach loop only if they
                // were not previously contained by the Set.
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                // By removing IDs from the snapshot object here, we protect them from
                // getting removed from the root store layer below.
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while(root_1 instanceof $f2796c17db7cbf02$var$Layer)root_1 = root_1.parent;
            idsToRemove.forEach(function(id) {
                return root_1.delete(id);
            });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function(dataId) {
        if (!(0, $21d6b69e155d5d08$export$b5a638e9b3fff9f3).call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var root = this.data[dataId];
            if (!root) return found_1;
            var workSet_1 = new Set([
                root
            ]);
            // Within the store, only arrays and objects can contain child entity
            // references, so we can prune the traversal using this predicate:
            workSet_1.forEach(function(obj) {
                if ((0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(obj)) found_1[obj.__ref] = true;
                if ((0, $01d0d880754ccbd1$export$417207af72fad9c9)(obj)) Object.keys(obj).forEach(function(key) {
                    var child = obj[key];
                    // No need to add primitive values to the workSet, since they cannot
                    // contain reference objects.
                    if ((0, $01d0d880754ccbd1$export$417207af72fad9c9)(child)) workSet_1.add(child);
                });
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function() {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}();
// A single CacheGroup represents a set of one or more EntityStore objects,
// typically the Root store in a CacheGroup by itself, and all active Layer
// stores in a group together. A single EntityStore object belongs to only
// one CacheGroup, store.group. The CacheGroup is responsible for tracking
// dependencies, so store.group is helpful for generating unique keys for
// cached results that need to be invalidated when/if those dependencies
// change. If we used the EntityStore objects themselves as cache keys (that
// is, store rather than store.group), the cache would become unnecessarily
// fragmented by all the different Layer objects. Instead, the CacheGroup
// approach allows all optimistic Layer objects in the same linked list to
// belong to one CacheGroup, with the non-optimistic Root object belonging
// to another CacheGroup, allowing resultCaching dependencies to be tracked
// separately for optimistic and non-optimistic entity data.
var $f2796c17db7cbf02$var$CacheGroup = /** @class */ function() {
    function CacheGroup(caching, parent) {
        if (parent === void 0) parent = null;
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function() {
        this.d = this.caching ? (0, $aed695b3db154433$export$c723b7eff9d8f870)() : null;
        this.keyMaker = new (0, $722ae841a583e691$export$73571c50d0f2507e)((0, $138881ab8f31fa6b$export$772fbc04a0ad4ce9));
    };
    CacheGroup.prototype.depend = function(dataId, storeFieldName) {
        if (this.d) {
            this.d($f2796c17db7cbf02$var$makeDepKey(dataId, storeFieldName));
            var fieldName = (0, $21d6b69e155d5d08$export$37874422037b6029)(storeFieldName);
            if (fieldName !== storeFieldName) // Fields with arguments that contribute extra identifying
            // information to the fieldName (thus forming the storeFieldName)
            // depend not only on the full storeFieldName but also on the
            // short fieldName, so the field can be invalidated using either
            // level of specificity.
            this.d($f2796c17db7cbf02$var$makeDepKey(dataId, fieldName));
            if (this.parent) this.parent.depend(dataId, storeFieldName);
        }
    };
    CacheGroup.prototype.dirty = function(dataId, storeFieldName) {
        if (this.d) this.d.dirty($f2796c17db7cbf02$var$makeDepKey(dataId, storeFieldName), // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        storeFieldName === "__exists" ? "forget" : "setDirty");
    };
    return CacheGroup;
}();
function $f2796c17db7cbf02$var$makeDepKey(dataId, storeFieldName) {
    // Since field names cannot have '#' characters in them, this method
    // of joining the field name and the ID should be unambiguous, and much
    // cheaper than JSON.stringify([dataId, fieldName]).
    return storeFieldName + "#" + dataId;
}
function $f2796c17db7cbf02$export$f8068a30967ddc18(store, entityId) {
    if ($f2796c17db7cbf02$export$488c0743feab3d61(store)) // We use this pseudo-field __exists elsewhere in the EntityStore code to
    // represent changes in the existence of the entity object identified by
    // entityId. This dependency gets reliably dirtied whenever an object with
    // this ID is deleted (or newly created) within this group, so any result
    // cache entries (for example, StoreReader#executeSelectionSet results) that
    // depend on __exists for this entityId will get dirtied as well, leading to
    // the eventual recomputation (instead of reuse) of those result objects the
    // next time someone reads them from the cache.
    store.group.depend(entityId, "__exists");
}
(function(EntityStore) {
    // Refer to this class as EntityStore.Root outside this namespace.
    var Root = /** @class */ function(_super) {
        (0, $b8xcN.__extends)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new $f2796c17db7cbf02$var$CacheGroup(resultCaching)) || this;
            _this.stump = new $f2796c17db7cbf02$var$Stump(_this);
            _this.storageTrie = new (0, $722ae841a583e691$export$73571c50d0f2507e)((0, $138881ab8f31fa6b$export$772fbc04a0ad4ce9));
            if (seed) _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function(layerId, replay) {
            // Adding an optimistic Layer on top of the Root actually adds the Layer
            // on top of the Stump, so the Stump always comes between the Root and
            // any Layer objects that we've added.
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function() {
            // Never remove the root layer.
            return this;
        };
        Root.prototype.getStorage = function() {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore);
    EntityStore.Root = Root;
})($f2796c17db7cbf02$export$cb507f57054c7321 || ($f2796c17db7cbf02$export$cb507f57054c7321 = {}));
// Not exported, since all Layer instances are created by the addLayer method
// of the EntityStore.Root class.
var $f2796c17db7cbf02$var$Layer = /** @class */ function(_super) {
    (0, $b8xcN.__extends)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function(layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function(layerId) {
        var _this = this;
        // Remove all instances of the given id, not just the first one.
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) // Dirty every ID we're removing. Technically we might be able to avoid
            // dirtying fields that have values in higher layers, but we don't have
            // easy access to higher layers here, and we're about to recreate those
            // layers anyway (see parent.addLayer below).
            Object.keys(this.data).forEach(function(dataId) {
                var ownStoreObject = _this.data[dataId];
                var parentStoreObject = parent["lookup"](dataId);
                if (!parentStoreObject) // The StoreObject identified by dataId was defined in this layer
                // but will be undefined in the parent layer, so we can delete the
                // whole entity using this.delete(dataId). Since we're about to
                // throw this layer away, the only goal of this deletion is to dirty
                // the removed fields.
                _this.delete(dataId);
                else if (!ownStoreObject) {
                    // This layer had an entry for dataId but it was undefined, which
                    // means the entity was deleted in this layer, and it's about to
                    // become undeleted when we remove this layer, so we need to dirty
                    // all fields that are about to be reexposed.
                    _this.group.dirty(dataId, "__exists");
                    Object.keys(parentStoreObject).forEach(function(storeFieldName) {
                        _this.group.dirty(dataId, storeFieldName);
                    });
                } else if (ownStoreObject !== parentStoreObject) // If ownStoreObject is not exactly the same as parentStoreObject,
                // dirty any fields whose values will change as a result of this
                // removal.
                Object.keys(ownStoreObject).forEach(function(storeFieldName) {
                    if (!(0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) _this.group.dirty(dataId, storeFieldName);
                });
            });
            return parent;
        }
        // No changes are necessary if the parent chain remains identical.
        if (parent === this.parent) return this;
        // Recreate this layer on top of the new parent.
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function() {
        return (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function(dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return (0, $21d6b69e155d5d08$export$b5a638e9b3fff9f3).call(this.data, dataId) ? (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function() {
        var p = this.parent;
        while(p.parent)p = p.parent;
        return p.getStorage.apply(p, // @ts-expect-error
        arguments);
    };
    return Layer;
}($f2796c17db7cbf02$export$cb507f57054c7321);
// Represents a Layer permanently installed just above the Root, which allows
// reading optimistically (and registering optimistic dependencies) even when
// no optimistic layers are currently active. The stump.group CacheGroup object
// is shared by any/all Layer objects added on top of the Stump.
var $f2796c17db7cbf02$var$Stump = /** @class */ function(_super) {
    (0, $b8xcN.__extends)(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function() {}, new $f2796c17db7cbf02$var$CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function() {
        // Never remove the Stump layer.
        return this;
    };
    Stump.prototype.merge = function(older, newer) {
        // We never want to write any data into the Stump, so we forward any merge
        // calls to the Root instead. Another option here would be to throw an
        // exception, but the toReference(object, true) function can sometimes
        // trigger Stump writes (which used to be Root writes, before the Stump
        // concept was introduced).
        return this.parent.merge(older, newer);
    };
    return Stump;
}($f2796c17db7cbf02$var$Layer);
function $f2796c17db7cbf02$var$storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    // Wherever there is a key collision, prefer the incoming value, unless
    // it is deeply equal to the existing value. It's worth checking deep
    // equality here (even though blindly returning incoming would be
    // logically correct) because preserving the referential identity of
    // existing data can prevent needless rereading and rerendering.
    return (0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function $f2796c17db7cbf02$export$488c0743feab3d61(store) {
    // When result caching is disabled, store.depend will be null.
    return !!(store instanceof $f2796c17db7cbf02$export$cb507f57054c7321 && store.group.caching);
}





var $b8xcN = parcelRequire("b8xcN");



function $2f47a00046febb71$var$shallowCopy(value) {
    if ((0, $01d0d880754ccbd1$export$417207af72fad9c9)(value)) return (0, $01c8f68cc3e070ef$export$43bee75e5e14138e)(value) ? value.slice(0) : (0, $b8xcN.__assign)({
        __proto__: Object.getPrototypeOf(value)
    }, value);
    return value;
}
// When programmers talk about the "canonical form" of an object, they
// usually have the following meaning in mind, which I've copied from
// https://en.wiktionary.org/wiki/canonical_form:
//
// 1. A standard or normal presentation of a mathematical entity [or
//    object]. A canonical form is an element of a set of representatives
//    of equivalence classes of forms such that there is a function or
//    procedure which projects every element of each equivalence class
//    onto that one element, the canonical form of that equivalence
//    class. The canonical form is expected to be simpler than the rest of
//    the forms in some way.
//
// That's a long-winded way of saying any two objects that have the same
// canonical form may be considered equivalent, even if they are !==,
// which usually means the objects are structurally equivalent (deeply
// equal), but don't necessarily use the same memory.
//
// Like a literary or musical canon, this ObjectCanon class represents a
// collection of unique canonical items (JavaScript objects), with the
// important property that canon.admit(a) === canon.admit(b) if a and b
// are deeply equal to each other. In terms of the definition above, the
// canon.admit method is the "function or procedure which projects every"
// object "onto that one element, the canonical form."
//
// In the worst case, the canonicalization process may involve looking at
// every property in the provided object tree, so it takes the same order
// of time as deep equality checking. Fortunately, already-canonicalized
// objects are returned immediately from canon.admit, so the presence of
// canonical subtrees tends to speed up canonicalization.
//
// Since consumers of canonical objects can check for deep equality in
// constant time, canonicalizing cache results can massively improve the
// performance of application code that skips re-rendering unchanged
// results, such as "pure" UI components in a framework like React.
//
// Of course, since canonical objects may be shared widely between
// unrelated consumers, it's important to think of them as immutable, even
// though they are not actually frozen with Object.freeze in production,
// due to the extra performance overhead that comes with frozen objects.
//
// Custom scalar objects whose internal class name is neither Array nor
// Object can be included safely in the admitted tree, but they will not
// be replaced with a canonical version (to put it another way, they are
// assumed to be canonical already).
//
// If we ignore custom objects, no detection of cycles or repeated object
// references is currently required by the StoreReader class, since
// GraphQL result objects are JSON-serializable trees (and thus contain
// neither cycles nor repeated subtrees), so we can avoid the complexity
// of keeping track of objects we've already seen during the recursion of
// the admit method.
//
// In the future, we may consider adding additional cases to the switch
// statement to handle other common object types, such as "[object Date]"
// objects, as needed.
var $2f47a00046febb71$export$c2e7fdd82233f4a4 = /** @class */ function() {
    function ObjectCanon() {
        // Set of all canonical objects this ObjectCanon has admitted, allowing
        // canon.admit to return previously-canonicalized objects immediately.
        this.known = new ((0, $138881ab8f31fa6b$export$7293b8a0b474028d) ? WeakSet : Set)();
        // Efficient storage/lookup structure for canonical objects.
        this.pool = new (0, $722ae841a583e691$export$73571c50d0f2507e)((0, $138881ab8f31fa6b$export$772fbc04a0ad4ce9));
        // Make the ObjectCanon assume this value has already been
        // canonicalized.
        this.passes = new WeakMap();
        // Arrays that contain the same elements in a different order can share
        // the same SortedKeysInfo object, to save memory.
        this.keysByJSON = new Map();
        // This has to come last because it depends on keysByJSON.
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function(value) {
        return (0, $01d0d880754ccbd1$export$417207af72fad9c9)(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function(value) {
        if ((0, $01d0d880754ccbd1$export$417207af72fad9c9)(value)) {
            var copy = $2f47a00046febb71$var$shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function(value) {
        var _this = this;
        if ((0, $01d0d880754ccbd1$export$417207af72fad9c9)(value)) {
            var original = this.passes.get(value);
            if (original) return original;
            var proto = Object.getPrototypeOf(value);
            switch(proto){
                case Array.prototype:
                    if (this.known.has(value)) return value;
                    var array = value.map(this.admit, this);
                    // Arrays are looked up in the Trie using their recursively
                    // canonicalized elements, and the known version of the array is
                    // preserved as node.array.
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add(node.array = array);
                        // Since canonical arrays may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) Object.freeze(array);
                    }
                    return node.array;
                case null:
                case Object.prototype:
                    if (this.known.has(value)) return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [
                        proto_1
                    ];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function(key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    // Objects are looked up in the Trie by their prototype (which
                    // is *not* recursively canonicalized), followed by a JSON
                    // representation of their (sorted) keys, followed by the
                    // sequence of recursively canonicalized values corresponding to
                    // those keys. To keep the final results unambiguous with other
                    // sequences (such as arrays that just happen to contain [proto,
                    // keys.json, value1, value2, ...]), the known version of the
                    // object is stored as node.object.
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = node.object = Object.create(proto_1);
                        this.known.add(obj_1);
                        keys.sorted.forEach(function(key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        // Since canonical objects may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) Object.freeze(obj_1);
                    }
                    return node.object;
            }
        }
        return value;
    };
    // It's worthwhile to cache the sorting of arrays of strings, since the
    // same initial unsorted arrays tend to be encountered many times.
    // Fortunately, we can reuse the Trie machinery to look up the sorted
    // arrays in linear time (which is faster than sorting large arrays).
    ObjectCanon.prototype.sortedKeys = function(obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) this.keysByJSON.set(json, node.keys = {
                sorted: keys,
                json: json
            });
        }
        return node.keys;
    };
    return ObjectCanon;
}();


function $e7357c9a775afaef$var$execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        // We split out this property so we can pass different values
        // independently without modifying options.context itself.
        options.context.canonizeResults
    ];
}
var $e7357c9a775afaef$export$628ef07ba8965f12 = /** @class */ function() {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new ((0, $138881ab8f31fa6b$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
        this.config = (0, $b37018ac55880203$export$8e16b83750b44988)(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: (0, $21d6b69e155d5d08$export$3ac2a95fbd99c479)(config)
        });
        this.canon = config.canon || new (0, $2f47a00046febb71$export$c2e7fdd82233f4a4)();
        // memoized functions in this class will be "garbage-collected"
        // by recreating the whole `StoreReader` in
        // `InMemoryCache.resetResultsCache`
        // (triggered from `InMemoryCache.gc` with `resetResultCache: true`)
        this.executeSelectionSet = (0, $2a919cc3f1f126e4$export$4997ffc0176396a6)(function(options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = $e7357c9a775afaef$var$execSelectionSetKeyArgs(options);
            // Negate this boolean option so we can find out if we've already read
            // this result using the other boolean value.
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) return (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, other), {
                    // If we previously read this result without canonizing it, we can
                    // reuse that result simply by canonizing it now.
                    result: _this.canon.admit(other.result)
                });
                // If we previously read this result with canonization enabled, we can
                // return that canonized result as-is.
                return other;
            }
            (0, $f2796c17db7cbf02$export$f8068a30967ddc18)(options.context.store, options.enclosingRef.__ref);
            // Finally, if we didn't find any useful previous results, run the real
            // execSelectionSetImpl method with the given options.
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $d301603631c7863b$export$f29926b23b28936b)["inMemoryCache.executeSelectionSet"] || 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
            keyArgs: $e7357c9a775afaef$var$execSelectionSetKeyArgs,
            // Note that the parameters of makeCacheKey are determined by the
            // array returned by keyArgs.
            makeCacheKey: function(selectionSet, parent, context, canonizeResults) {
                if ((0, $f2796c17db7cbf02$export$488c0743feab3d61)(context.store)) return context.store.makeCacheKey(selectionSet, (0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(parent) ? parent.__ref : parent, context.varString, canonizeResults);
            }
        });
        this.executeSubSelectedArray = (0, $2a919cc3f1f126e4$export$4997ffc0176396a6)(function(options) {
            (0, $f2796c17db7cbf02$export$f8068a30967ddc18)(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $d301603631c7863b$export$f29926b23b28936b)["inMemoryCache.executeSubSelectedArray"] || 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ ,
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if ((0, $f2796c17db7cbf02$export$488c0743feab3d61)(context.store)) return context.store.makeCacheKey(field, array, context.varString);
            }
        });
    }
    StoreReader.prototype.resetCanon = function() {
        this.canon = new (0, $2f47a00046febb71$export$c2e7fdd82233f4a4)();
    };
    /**
     * Given a store and a query, return as much of the result as possible and
     * identify if any data was missing from the store.
     */ StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? "ROOT_QUERY" : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, (0, $6d75937eba8e6f1c$export$84c19026e616569e)((0, $6d75937eba8e6f1c$export$d96b2213c1b9d3a9)(query))), variables);
        var rootRef = (0, $6ee6592fd95fa693$export$634ae0e932e9be99)(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: (0, $6d75937eba8e6f1c$export$f431198736b7f96d)(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: (0, $b8xcN.__assign)({
                store: store,
                query: query,
                policies: policies,
                variables: variables,
                varString: (0, $e3e8d305ba8d539e$export$88a0ad9b6f961b51)(variables),
                canonizeResults: canonizeResults
            }, (0, $21d6b69e155d5d08$export$3a33c00f0ae4a480)(query, this.config.fragments))
        });
        var missing;
        if (execResult.missing) {
            // For backwards compatibility we still report an array of
            // MissingFieldError objects, even though there will only ever be at most
            // one of them, now that all missing field error messages are grouped
            // together in the execResult.missing tree.
            missing = [
                new (0, $abe96c5581ab8a1e$export$257c68286583b0f9)($e7357c9a775afaef$var$firstMissing(execResult.missing), execResult.missing, query, variables)
            ];
            if (!returnPartialData) throw missing[0];
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing
        };
    };
    StoreReader.prototype.isFresh = function(result, parent, selectionSet, context) {
        if ((0, $f2796c17db7cbf02$export$488c0743feab3d61)(context.store) && this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, // If result is canonical, then it could only have been previously
            // cached by the canonizing version of executeSelectionSet, so we can
            // avoid checking both possibilities here.
            this.canon.isKnown(result));
            if (latest && result === latest.result) return true;
        }
        return false;
    };
    // Uncached version of executeSelectionSet.
    StoreReader.prototype.execSelectionSetImpl = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if ((0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(objectOrReference) && !context.policies.rootTypenamesById[objectOrReference.__ref] && !context.store.has(objectOrReference.__ref)) return {
            result: this.canon.empty,
            missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object")
        };
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new (0, $ad19e8268fdfbd88$export$509e11c221f576c0)();
        if (this.config.addTypename && typeof typename === "string" && !policies.rootIdsByTypename[typename]) // Ensure we always include a default value for the __typename
        // field, if we have one, and this.config.addTypename is true. Note
        // that this field can be overridden by other merged objects.
        objectsToMerge.push({
            __typename: typename
        });
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = result.missing, _a));
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function(selection) {
            var _a, _b;
            // Omit fields with directives @skip(if: <truthy value>) or
            // @include(if: <falsy value>).
            if (!(0, $5a6e90bd3aec77b4$export$3dc388a5f013b4a5)(selection, variables)) return;
            if ((0, $6ee6592fd95fa693$export$fb56ad75dd311c12)(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference
                }, context);
                var resultName = (0, $6ee6592fd95fa693$export$7d1ad22471852218)(selection);
                if (fieldValue === void 0) {
                    if (!(0, $19cabdf265088897$export$43b332f87950a467).added(selection)) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat((0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(objectOrReference) ? objectOrReference.__ref + " object" : "object " + JSON.stringify(objectOrReference, null, 2)), _a));
                } else if ((0, $01c8f68cc3e070ef$export$43bee75e5e14138e)(fieldValue)) {
                    if (fieldValue.length > 0) fieldValue = handleMissing(_this.executeSubSelectedArray({
                        field: selection,
                        array: fieldValue,
                        enclosingRef: enclosingRef,
                        context: context
                    }), resultName);
                } else if (!selection.selectionSet) // If the field does not have a selection set, then we handle it
                // as a scalar value. To keep this.canon from canonicalizing
                // this value, we use this.canon.pass to wrap fieldValue in a
                // Pass object that this.canon.admit will later unwrap as-is.
                {
                    if (context.canonizeResults) fieldValue = _this.canon.pass(fieldValue);
                } else if (fieldValue != null) // In this case, because we know the field has a selection set,
                // it must be trying to query a GraphQLObjectType, which is why
                // fieldValue must be != null.
                fieldValue = handleMissing(_this.executeSelectionSet({
                    selectionSet: selection.selectionSet,
                    objectOrReference: fieldValue,
                    enclosingRef: (0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(fieldValue) ? fieldValue : enclosingRef,
                    context: context
                }), resultName);
                if (fieldValue !== void 0) objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
            } else {
                var fragment = (0, $070763719c7946cb$export$f80bdb85f299186)(selection, context.lookupFragment);
                if (!fragment && selection.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).FRAGMENT_SPREAD) throw (0, $c21c2000775800f2$export$3991762405098ea)(10, selection.name.value);
                if (fragment && policies.fragmentMatches(fragment, typename)) fragment.selectionSet.selections.forEach(workSet.add, workSet);
            }
        });
        var result = (0, $ad19e8268fdfbd88$export$160070228be94b08)(objectsToMerge);
        var finalResult = {
            result: result,
            missing: missing
        };
        var frozen = context.canonizeResults ? this.canon.admit(finalResult) : (0, $5d04349b74d4efd7$export$7f9c177735b71f18)(finalResult);
        // Store this result with its selection set so that we can quickly
        // recognize it again in the StoreReader#isFresh method.
        if (frozen.result) this.knownResults.set(frozen.result, selectionSet);
        return frozen;
    };
    // Uncached version of executeSubSelectedArray.
    StoreReader.prototype.execSubSelectedArrayImpl = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new (0, $ad19e8268fdfbd88$export$509e11c221f576c0)();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            return childResult.result;
        }
        if (field.selectionSet) array = array.filter(context.store.canRead);
        array = array.map(function(item, i) {
            // null value in array
            if (item === null) return null;
            // This is a nested array, recurse
            if ((0, $01c8f68cc3e070ef$export$43bee75e5e14138e)(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                enclosingRef: enclosingRef,
                context: context
            }), i);
            // This is an object, run the selection set on it
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                objectOrReference: item,
                enclosingRef: (0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(item) ? item : enclosingRef,
                context: context
            }), i);
            if (globalThis.__DEV__ !== false) $e7357c9a775afaef$var$assertSelectionSetForIdValue(context.store, field, item);
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $e7357c9a775afaef$var$firstMissing(tree) {
    try {
        JSON.stringify(tree, function(_, value) {
            if (typeof value === "string") throw value;
            return value;
        });
    } catch (result) {
        return result;
    }
}
function $e7357c9a775afaef$var$assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([
            fieldValue
        ]);
        workSet_1.forEach(function(value) {
            if ((0, $01d0d880754ccbd1$export$417207af72fad9c9)(value)) {
                (0, $c21c2000775800f2$export$f5708dca728d7177)(!(0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(value), 11, (0, $21d6b69e155d5d08$export$fdef206c83ff2c09)(store, value), field.name.value);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}



var $b8xcN = parcelRequire("b8xcN");







var $b8xcN = parcelRequire("b8xcN");







// Mapping from JSON-encoded KeySpecifier strings to associated information.
var $0bb0e9bad8a8de3f$var$specifierInfoCache = Object.create(null);
function $0bb0e9bad8a8de3f$var$lookupSpecifierInfo(spec) {
    // It's safe to encode KeySpecifier arrays with JSON.stringify, since they're
    // just arrays of strings or nested KeySpecifier arrays, and the order of the
    // array elements is important (and suitably preserved by JSON.stringify).
    var cacheKey = JSON.stringify(spec);
    return $0bb0e9bad8a8de3f$var$specifierInfoCache[cacheKey] || ($0bb0e9bad8a8de3f$var$specifierInfoCache[cacheKey] = Object.create(null));
}
function $0bb0e9bad8a8de3f$export$f1953a0407594d2c(specifier) {
    var info = $0bb0e9bad8a8de3f$var$lookupSpecifierInfo(specifier);
    return info.keyFieldsFn || (info.keyFieldsFn = function(object, context) {
        var extract = function(from, key) {
            return context.readField(key, from);
        };
        var keyObject = context.keyObject = $0bb0e9bad8a8de3f$export$2db31da99613c21f(specifier, function(schemaKeyPath) {
            var extracted = $0bb0e9bad8a8de3f$export$e8f64f7a025887d3(context.storeObject, schemaKeyPath, // Using context.readField to extract paths from context.storeObject
            // allows the extraction to see through Reference objects and respect
            // custom read functions.
            extract);
            if (extracted === void 0 && object !== context.storeObject && (0, $21d6b69e155d5d08$export$b5a638e9b3fff9f3).call(object, schemaKeyPath[0])) // If context.storeObject fails to provide a value for the requested
            // path, fall back to the raw result object, if it has a top-level key
            // matching the first key in the path (schemaKeyPath[0]). This allows
            // key fields included in the written data to be saved in the cache
            // even if they are not selected explicitly in context.selectionSet.
            // Not being mentioned by context.selectionSet is convenient here,
            // since it means these extra fields cannot be affected by field
            // aliasing, which is why we can use extractKey instead of
            // context.readField for this extraction.
            extracted = $0bb0e9bad8a8de3f$export$e8f64f7a025887d3(object, schemaKeyPath, $0bb0e9bad8a8de3f$var$extractKey);
            (0, $c21c2000775800f2$export$f5708dca728d7177)(extracted !== void 0, 5, schemaKeyPath.join("."), object);
            return extracted;
        });
        return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
    });
}
function $0bb0e9bad8a8de3f$export$550737ee0cc371ac(specifier) {
    var info = $0bb0e9bad8a8de3f$var$lookupSpecifierInfo(specifier);
    return info.keyArgsFn || (info.keyArgsFn = function(args, _a) {
        var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
        var collected = $0bb0e9bad8a8de3f$export$2db31da99613c21f(specifier, function(keyPath) {
            var firstKey = keyPath[0];
            var firstChar = firstKey.charAt(0);
            if (firstChar === "@") {
                if (field && (0, $01c8f68cc3e070ef$export$d307f5934e447d0e)(field.directives)) {
                    var directiveName_1 = firstKey.slice(1);
                    // If the directive appears multiple times, only the first
                    // occurrence's arguments will be used. TODO Allow repetition?
                    // TODO Cache this work somehow, a la aliasMap?
                    var d = field.directives.find(function(d) {
                        return d.name.value === directiveName_1;
                    });
                    // Fortunately argumentsObjectFromField works for DirectiveNode!
                    var directiveArgs = d && (0, $6ee6592fd95fa693$export$3f5a60fb6a781b4f)(d, variables);
                    // For directives without arguments (d defined, but directiveArgs ===
                    // null), the presence or absence of the directive still counts as
                    // part of the field key, so we return null in those cases. If no
                    // directive with this name was found for this field (d undefined and
                    // thus directiveArgs undefined), we return undefined, which causes
                    // this value to be omitted from the key object returned by
                    // collectSpecifierPaths.
                    return directiveArgs && $0bb0e9bad8a8de3f$export$e8f64f7a025887d3(directiveArgs, // If keyPath.length === 1, this code calls extractKeyPath with an
                    // empty path, which works because it uses directiveArgs as the
                    // extracted value.
                    keyPath.slice(1));
                }
                // If the key started with @ but there was no corresponding directive,
                // we want to omit this value from the key object, not fall through to
                // treating @whatever as a normal argument name.
                return;
            }
            if (firstChar === "$") {
                var variableName = firstKey.slice(1);
                if (variables && (0, $21d6b69e155d5d08$export$b5a638e9b3fff9f3).call(variables, variableName)) {
                    var varKeyPath = keyPath.slice(0);
                    varKeyPath[0] = variableName;
                    return $0bb0e9bad8a8de3f$export$e8f64f7a025887d3(variables, varKeyPath);
                }
                // If the key started with $ but there was no corresponding variable, we
                // want to omit this value from the key object, not fall through to
                // treating $whatever as a normal argument name.
                return;
            }
            if (args) return $0bb0e9bad8a8de3f$export$e8f64f7a025887d3(args, keyPath);
        });
        var suffix = JSON.stringify(collected);
        // If no arguments were passed to this field, and it didn't have any other
        // field key contributions from directives or variables, hide the empty
        // :{} suffix from the field key. However, a field passed no arguments can
        // still end up with a non-empty :{...} suffix if its key configuration
        // refers to directives or variables.
        if (args || suffix !== "{}") fieldName += ":" + suffix;
        return fieldName;
    });
}
function $0bb0e9bad8a8de3f$export$2db31da99613c21f(specifier, extractor) {
    // For each path specified by specifier, invoke the extractor, and repeatedly
    // merge the results together, with appropriate ancestor context.
    var merger = new (0, $ad19e8268fdfbd88$export$509e11c221f576c0)();
    return $0bb0e9bad8a8de3f$export$eca459f173e85801(specifier).reduce(function(collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            // This path is not expected to contain array indexes, so the toMerge
            // reconstruction will not contain arrays. TODO Fix this?
            for(var i = path.length - 1; i >= 0; --i)toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function $0bb0e9bad8a8de3f$export$eca459f173e85801(spec) {
    var info = $0bb0e9bad8a8de3f$var$lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = info.paths = [];
        var currentPath_1 = [];
        spec.forEach(function(s, i) {
            if ((0, $01c8f68cc3e070ef$export$43bee75e5e14138e)(s)) {
                $0bb0e9bad8a8de3f$export$eca459f173e85801(s).forEach(function(p) {
                    return paths_1.push(currentPath_1.concat(p));
                });
                currentPath_1.length = 0;
            } else {
                currentPath_1.push(s);
                if (!(0, $01c8f68cc3e070ef$export$43bee75e5e14138e)(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function $0bb0e9bad8a8de3f$var$extractKey(object, key) {
    return object[key];
}
function $0bb0e9bad8a8de3f$export$e8f64f7a025887d3(object, path, extract) {
    // For each key in path, extract the corresponding child property from obj,
    // flattening arrays if encountered (uncommon for keyFields and keyArgs, but
    // possible). The final result of path.reduce is normalized so unexpected leaf
    // objects have their keys safely sorted. That final result is difficult to
    // type as anything other than any. You're welcome to try to improve the
    // return type, but keep in mind extractKeyPath is not a public function
    // (exported only for testing), so the effort may not be worthwhile unless the
    // limited set of actual callers (see above) pass arguments that TypeScript
    // can statically type. If we know only that path is some array of strings
    // (and not, say, a specific tuple of statically known strings), any (or
    // possibly unknown) is the honest answer.
    extract = extract || $0bb0e9bad8a8de3f$var$extractKey;
    return $0bb0e9bad8a8de3f$var$normalize(path.reduce(function reducer(obj, key) {
        return (0, $01c8f68cc3e070ef$export$43bee75e5e14138e)(obj) ? obj.map(function(child) {
            return reducer(child, key);
        }) : obj && extract(obj, key);
    }, object));
}
function $0bb0e9bad8a8de3f$var$normalize(value) {
    // Usually the extracted value will be a scalar value, since most primary
    // key fields are scalar, but just in case we get an object or an array, we
    // need to do some normalization of the order of (nested) keys.
    if ((0, $01d0d880754ccbd1$export$417207af72fad9c9)(value)) {
        if ((0, $01c8f68cc3e070ef$export$43bee75e5e14138e)(value)) return value.map($0bb0e9bad8a8de3f$var$normalize);
        return $0bb0e9bad8a8de3f$export$2db31da99613c21f(Object.keys(value).sort(), function(path) {
            return $0bb0e9bad8a8de3f$export$e8f64f7a025887d3(value, path);
        });
    }
    return value;
}



function $7f695981f5b939c9$var$argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args : spec.field ? (0, $6ee6592fd95fa693$export$3f5a60fb6a781b4f)(spec.field, spec.variables) : null;
}
var $7f695981f5b939c9$var$nullKeyFieldsFn = function() {
    return void 0;
};
var $7f695981f5b939c9$var$simpleKeyArgsFn = function(_args, context) {
    return context.fieldName;
};
// These merge functions can be selected by specifying merge:true or
// merge:false in a field policy.
var $7f695981f5b939c9$var$mergeTrueFn = function(existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var $7f695981f5b939c9$var$mergeFalseFn = function(_, incoming) {
    return incoming;
};
var $7f695981f5b939c9$export$e9859ad90648930b = /** @class */ function() {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        // Map from subtype names to sets of supertype names. Note that this
        // representation inverts the structure of possibleTypes (whose keys are
        // supertypes and whose values are arrays of subtypes) because it tends
        // to be much more efficient to search upwards than downwards.
        this.supertypeMap = new Map();
        // Any fuzzy subtypes specified by possibleTypes will be converted to
        // RegExp objects and recorded here. Every key of this map can also be
        // found in supertypeMap. In many cases this Map will be empty, which
        // means no fuzzy subtype checking will happen in fragmentMatches.
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0, $b8xcN.__assign)({
            dataIdFromObject: (0, $21d6b69e155d5d08$export$bd03c5a9c99d6bce)
        }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) this.addPossibleTypes(config.possibleTypes);
        if (config.typePolicies) this.addTypePolicies(config.typePolicies);
    }
    Policies.prototype.identify = function(object, partialContext) {
        var _a;
        var policies = this;
        var typename = partialContext && (partialContext.typename || ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename)) || object.__typename;
        // It should be possible to write root Query fields with writeFragment,
        // using { __typename: "Query", ... } as the data, but it does not make
        // sense to allow the same identification behavior for the Mutation and
        // Subscription types, since application code should never be writing
        // directly to (or reading directly from) those root objects.
        if (typename === this.rootTypenamesById.ROOT_QUERY) return [
            "ROOT_QUERY"
        ];
        // Default context.storeObject to object if not otherwise provided.
        var storeObject = partialContext && partialContext.storeObject || object;
        var context = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, partialContext), {
            typename: typename,
            storeObject: storeObject,
            readField: partialContext && partialContext.readField || function() {
                var options = $7f695981f5b939c9$export$1ad7a877581bdf2e(arguments, storeObject);
                return policies.readField(options, {
                    store: policies.cache["data"],
                    variables: options.variables
                });
            }
        });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        (0, $0050593a9a6cc03b$export$2ddf8815a8abe8b).withValue(true, function() {
            while(keyFn){
                var specifierOrId = keyFn((0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, object), storeObject), context);
                if ((0, $01c8f68cc3e070ef$export$43bee75e5e14138e)(specifierOrId)) keyFn = (0, $0bb0e9bad8a8de3f$export$f1953a0407594d2c)(specifierOrId);
                else {
                    id = specifierOrId;
                    break;
                }
            }
        });
        id = id ? String(id) : void 0;
        return context.keyObject ? [
            id,
            context.keyObject
        ] : [
            id
        ];
    };
    Policies.prototype.addTypePolicies = function(typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function(typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0, $b8xcN.__rest)(_a, [
                "queryType",
                "mutationType",
                "subscriptionType"
            ]);
            // Though {query,mutation,subscription}Type configurations are rare,
            // it's important to call setRootTypename as early as possible,
            // since these configurations should apply consistently for the
            // entire lifetime of the cache. Also, since only one __typename can
            // qualify as one of these root types, these three properties cannot
            // be inherited, unlike the rest of the incoming properties. That
            // restriction is convenient, because the purpose of this.toBeAdded
            // is to delay the processing of type/field policies until the first
            // time they're used, allowing policies to be added in any order as
            // long as all relevant policies (including policies for supertypes)
            // have been added by the time a given policy is used for the first
            // time. In other words, since inheritance doesn't matter for these
            // properties, there's also no need to delay their processing using
            // the this.toBeAdded queue.
            if (queryType) _this.setRootTypename("Query", typename);
            if (mutationType) _this.setRootTypename("Mutation", typename);
            if (subscriptionType) _this.setRootTypename("Subscription", typename);
            if ((0, $21d6b69e155d5d08$export$b5a638e9b3fff9f3).call(_this.toBeAdded, typename)) _this.toBeAdded[typename].push(incoming);
            else _this.toBeAdded[typename] = [
                incoming
            ];
        });
    };
    Policies.prototype.updateTypePolicy = function(typename, incoming, existingFieldPolicies) {
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge = typeof merge === "function" ? merge : merge === true ? $7f695981f5b939c9$var$mergeTrueFn : merge === false ? $7f695981f5b939c9$var$mergeFalseFn : existing.merge;
        }
        // Type policies can define merge functions, as an alternative to
        // using field policies to merge child objects.
        setMerge(existing, incoming.merge);
        existing.keyFn = // Pass false to disable normalization for this typename.
        keyFields === false ? $7f695981f5b939c9$var$nullKeyFieldsFn : (0, $01c8f68cc3e070ef$export$43bee75e5e14138e)(keyFields) ? (0, $0bb0e9bad8a8de3f$export$f1953a0407594d2c)(keyFields) : typeof keyFields === "function" ? keyFields : existing.keyFn;
        if (fields) Object.keys(fields).forEach(function(fieldName) {
            var existing = existingFieldPolicies[fieldName];
            // Field policy inheritance is atomic/shallow: you can't inherit a
            // field policy and then override just its read function, since read
            // and merge functions often need to cooperate, so changing only one
            // of them would be a recipe for inconsistency.
            // So here we avoid merging an inherited field policy with an updated one.
            if (!existing || (existing === null || existing === void 0 ? void 0 : existing.typename) !== typename) existing = existingFieldPolicies[fieldName] = {
                typename: typename
            };
            var incoming = fields[fieldName];
            if (typeof incoming === "function") existing.read = incoming;
            else {
                var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                existing.keyFn = // Pass false to disable argument-based differentiation of
                // field identities.
                keyArgs === false ? $7f695981f5b939c9$var$simpleKeyArgsFn : (0, $01c8f68cc3e070ef$export$43bee75e5e14138e)(keyArgs) ? (0, $0bb0e9bad8a8de3f$export$550737ee0cc371ac)(keyArgs) : typeof keyArgs === "function" ? keyArgs : existing.keyFn;
                if (typeof read === "function") existing.read = read;
                setMerge(existing, merge);
            }
            if (existing.read && existing.merge) // If we have both a read and a merge function, assume
            // keyArgs:false, because read and merge together can take
            // responsibility for interpreting arguments in and out. This
            // default assumption can always be overridden by specifying
            // keyArgs explicitly in the FieldPolicy.
            existing.keyFn = existing.keyFn || $7f695981f5b939c9$var$simpleKeyArgsFn;
        });
    };
    Policies.prototype.setRootTypename = function(which, typename) {
        if (typename === void 0) typename = which;
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            (0, $c21c2000775800f2$export$f5708dca728d7177)(!old || old === which, 6, which);
            // First, delete any old __typename associated with this rootId from
            // rootIdsByTypename.
            if (old) delete this.rootIdsByTypename[old];
            // Now make this the only __typename that maps to this rootId.
            this.rootIdsByTypename[typename] = rootId;
            // Finally, update the __typename associated with this rootId.
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function(possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function(supertype) {
            // Make sure all types have an entry in this.supertypeMap, even if
            // their supertype set is empty, so we can return false immediately
            // from policies.fragmentMatches for unknown supertypes.
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function(subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match((0, $21d6b69e155d5d08$export$6ed54d4784f1ce28));
                if (!match || match[0] !== subtype) // TODO Don't interpret just any invalid typename as a RegExp.
                _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
            });
        });
    };
    Policies.prototype.getTypePolicy = function(typename) {
        var _this = this;
        if (!(0, $21d6b69e155d5d08$export$b5a638e9b3fff9f3).call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            // When the TypePolicy for typename is first accessed, instead of
            // starting with an empty policy object, inherit any properties or
            // fields from the type policies of the supertypes of typename.
            //
            // Any properties or fields defined explicitly within the TypePolicy
            // for typename will take precedence, and if there are multiple
            // supertypes, the properties of policies whose types were added
            // later via addPossibleTypes will take precedence over those of
            // earlier supertypes. TODO Perhaps we should warn about these
            // conflicts in development, and recommend defining the property
            // explicitly in the subtype policy?
            //
            // Field policy inheritance is atomic/shallow: you can't inherit a
            // field policy and then override just its read function, since read
            // and merge functions often need to cooperate, so changing only one
            // of them would be a recipe for inconsistency.
            //
            // Once the TypePolicy for typename has been accessed, its properties can
            // still be updated directly using addTypePolicies, but future changes to
            // inherited supertype policies will not be reflected in this subtype
            // policy, because this code runs at most once per typename.
            var supertypes_1 = this.supertypeMap.get(typename);
            if (!supertypes_1 && this.fuzzySubtypes.size) {
                // To make the inheritance logic work for unknown typename strings that
                // may have fuzzy supertypes, we give this typename an empty supertype
                // set and then populate it with any fuzzy supertypes that match.
                supertypes_1 = this.getSupertypeSet(typename, true);
                // This only works for typenames that are directly matched by a fuzzy
                // supertype. What if there is an intermediate chain of supertypes?
                // While possible, that situation can only be solved effectively by
                // specifying the intermediate relationships via possibleTypes, manually
                // and in a non-fuzzy way.
                this.fuzzySubtypes.forEach(function(regExp, fuzzy) {
                    if (regExp.test(typename)) {
                        // The fuzzy parameter is just the original string version of regExp
                        // (not a valid __typename string), but we can look up the
                        // associated supertype(s) in this.supertypeMap.
                        var fuzzySupertypes = _this.supertypeMap.get(fuzzy);
                        if (fuzzySupertypes) fuzzySupertypes.forEach(function(supertype) {
                            return supertypes_1.add(supertype);
                        });
                    }
                });
            }
            if (supertypes_1 && supertypes_1.size) supertypes_1.forEach(function(supertype) {
                var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0, $b8xcN.__rest)(_a, [
                    "fields"
                ]);
                Object.assign(policy_1, rest);
                Object.assign(policy_1.fields, fields);
            });
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) // Merge the pending policies into this.typePolicies, in the order they
        // were originally passed to addTypePolicy.
        inbox.splice(0).forEach(function(policy) {
            _this.updateTypePolicy(typename, policy, _this.typePolicies[typename].fields);
        });
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function(typename, fieldName) {
        if (typename) return this.getTypePolicy(typename).fields[fieldName];
    };
    Policies.prototype.getSupertypeSet = function(subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) this.supertypeMap.set(subtype, supertypeSet = new Set());
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function(fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition) return true;
        // If the fragment has a type condition but the object we're matching
        // against does not have a __typename, the fragment cannot match.
        if (!typename) return false;
        var supertype = fragment.typeCondition.name.value;
        // Common case: fragment type condition and __typename are the same.
        if (typename === supertype) return true;
        if (this.usingPossibleTypes && this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [
                typenameSupertypeSet
            ];
            var maybeEnqueue_1 = function(subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet && supertypeSet.size && workQueue_1.indexOf(supertypeSet) < 0) workQueue_1.push(supertypeSet);
            };
            // We need to check fuzzy subtypes only if we encountered fuzzy
            // subtype strings in addPossibleTypes, and only while writing to
            // the cache, since that's when selectionSetMatchesResult gives a
            // strong signal of fragment matching. The StoreReader class calls
            // policies.fragmentMatches without passing a result object, so
            // needToCheckFuzzySubtypes is always false while reading.
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            // It's important to keep evaluating workQueue.length each time through
            // the loop, because the queue can grow while we're iterating over it.
            for(var i = 0; i < workQueue_1.length; ++i){
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(7, typename, supertype);
                        // Record positive results for faster future lookup.
                        // Unfortunately, we cannot safely cache negative results,
                        // because new possibleTypes data could always be added to the
                        // Policies class.
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes && // Start checking fuzzy subtypes only after exhausting all
                // non-fuzzy subtypes (after the final iteration of the loop).
                i === workQueue_1.length - 1 && // We could wait to compare fragment.selectionSet to result
                // after we verify the supertype, but this check is often less
                // expensive than that search, and we will have to do the
                // comparison anyway whenever we find a potential match.
                (0, $21d6b69e155d5d08$export$60bd1cbb09c1a4a2)(fragment.selectionSet, result, variables)) {
                    // We don't always need to check fuzzy subtypes (if no result
                    // was provided, or !this.fuzzySubtypes.size), but, when we do,
                    // we only want to check them once.
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    // If we find any fuzzy subtypes that match typename, extend the
                    // workQueue to search through the supertypes of those fuzzy
                    // subtypes. Otherwise the for-loop will terminate and we'll
                    // return false below.
                    this.fuzzySubtypes.forEach(function(regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) maybeEnqueue_1(fuzzyString);
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function(fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables
            };
            var args = $7f695981f5b939c9$var$argsFromFieldSpecifier(fieldSpec);
            while(keyFn){
                var specifierOrString = keyFn(args, context);
                if ((0, $01c8f68cc3e070ef$export$43bee75e5e14138e)(specifierOrString)) keyFn = (0, $0bb0e9bad8a8de3f$export$550737ee0cc371ac)(specifierOrString);
                else {
                    // If the custom keyFn returns a falsy value, fall back to
                    // fieldName instead.
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) storeFieldName = fieldSpec.field ? (0, $6ee6592fd95fa693$export$54be8689c65f3b56)(fieldSpec.field, fieldSpec.variables) : (0, $6ee6592fd95fa693$export$3cdb6c178b88cabe)(fieldName, $7f695981f5b939c9$var$argsFromFieldSpecifier(fieldSpec));
        // Returning false from a keyArgs function is like configuring
        // keyArgs: false, but more dynamic.
        if (storeFieldName === false) return fieldName;
        // Make sure custom field names start with the actual field.name.value
        // of the field, so we can always figure out which properties of a
        // StoreObject correspond to which original field names.
        return fieldName === (0, $21d6b69e155d5d08$export$37874422037b6029)(storeFieldName) ? storeFieldName : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function(options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference) return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField) return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename) options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = (0, $21d6b69e155d5d08$export$37874422037b6029)(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName);
        var read = policy && policy.read;
        if (read) {
            var readOptions = $7f695981f5b939c9$var$makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(objectOrReference) ? objectOrReference.__ref : objectOrReference, storeFieldName));
            // Call read(existing, readOptions) with cacheSlot holding this.cache.
            return (0, $dc81f3128dc8fcdb$export$ac9723609f5c76c2).withValue(this.cache, read, [
                existing,
                readOptions
            ]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function(parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function(existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === $7f695981f5b939c9$var$mergeTrueFn) // Instead of going to the trouble of creating a full
        // FieldFunctionOptions object and calling mergeTrueFn, we can
        // simply call mergeObjects, as mergeTrueFn would.
        return $7f695981f5b939c9$var$makeMergeObjectsFunction(context.store)(existing, incoming);
        if (merge === $7f695981f5b939c9$var$mergeFalseFn) // Likewise for mergeFalseFn, whose implementation is even simpler.
        return incoming;
        // If cache.writeQuery or cache.writeFragment was called with
        // options.overwrite set to true, we still call merge functions, but
        // the existing data is always undefined, so the merge function will
        // not attempt to combine the incoming data with the existing data.
        if (context.overwrite) existing = void 0;
        return merge(existing, incoming, $7f695981f5b939c9$var$makeFieldFunctionOptions(this, // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0, {
            typename: typename,
            fieldName: field.name.value,
            field: field,
            variables: context.variables
        }, context, storage || Object.create(null)));
    };
    return Policies;
}();
function $7f695981f5b939c9$var$makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = (0, $21d6b69e155d5d08$export$37874422037b6029)(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: $7f695981f5b939c9$var$argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: (0, $6ee6592fd95fa693$export$fa99cac1c0883c47),
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function() {
            return policies.readField($7f695981f5b939c9$export$1ad7a877581bdf2e(arguments, objectOrReference, variables), context);
        },
        mergeObjects: $7f695981f5b939c9$var$makeMergeObjectsFunction(context.store)
    };
}
function $7f695981f5b939c9$export$1ad7a877581bdf2e(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") options = {
        fieldName: fieldNameOrOptions,
        // Default to objectOrReference only when no second argument was
        // passed for the from parameter, not when undefined is explicitly
        // passed as the second argument.
        from: argc > 1 ? from : objectOrReference
    };
    else {
        options = (0, $b8xcN.__assign)({}, fieldNameOrOptions);
        // Default to objectOrReference only when fieldNameOrOptions.from is
        // actually omitted, rather than just undefined.
        if (!(0, $21d6b69e155d5d08$export$b5a638e9b3fff9f3).call(options, "from")) options.from = objectOrReference;
    }
    if (globalThis.__DEV__ !== false && options.from === void 0) globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(8, (0, $f890162f7853cd70$export$f341b4883239463f)(Array.from(readFieldArgs)));
    if (void 0 === options.variables) options.variables = variables;
    return options;
}
function $7f695981f5b939c9$var$makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if ((0, $01c8f68cc3e070ef$export$43bee75e5e14138e)(existing) || (0, $01c8f68cc3e070ef$export$43bee75e5e14138e)(incoming)) throw (0, $c21c2000775800f2$export$3991762405098ea)(9);
        // These dynamic checks are necessary because the parameters of a
        // custom merge function can easily have the any type, so the type
        // system cannot always enforce the StoreObject | Reference parameter
        // types of options.mergeObjects.
        if ((0, $01d0d880754ccbd1$export$417207af72fad9c9)(existing) && (0, $01d0d880754ccbd1$export$417207af72fad9c9)(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) return incoming;
            if ((0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(existing) && (0, $21d6b69e155d5d08$export$4f39afca21bd938e)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // existing.__ref, preferring/overwriting any fields contributed by the
                // newer incoming StoreObject.
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if ((0, $21d6b69e155d5d08$export$4f39afca21bd938e)(existing) && (0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // incoming.__ref, taking fields from the older existing object only if
                // those fields are not already present in the newer StoreObject
                // identified by incoming.__ref.
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if ((0, $21d6b69e155d5d08$export$4f39afca21bd938e)(existing) && (0, $21d6b69e155d5d08$export$4f39afca21bd938e)(incoming)) return (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, existing), incoming);
        }
        return incoming;
    };
}


// Since there are only four possible combinations of context.clientOnly and
// context.deferred values, we should need at most four "flavors" of any given
// WriteContext. To avoid creating multiple copies of the same context, we cache
// the contexts in the context.flavors Map (shared by all flavors) according to
// their clientOnly and deferred values (always in that order).
function $13c65a4b486a4604$var$getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) context.flavors.set(key, flavored = context.clientOnly === clientOnly && context.deferred === deferred ? context : (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, context), {
        clientOnly: clientOnly,
        deferred: deferred
    }));
    return flavored;
}
var $13c65a4b486a4604$export$eb8361c5d132fb8f = /** @class */ function() {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function(store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = (0, $6d75937eba8e6f1c$export$7a5b1fa979d2c158)(query);
        var merger = (0, $21d6b69e155d5d08$export$b874a818f7a2fa6d)();
        variables = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, (0, $6d75937eba8e6f1c$export$84c19026e616569e)(operationDefinition)), variables);
        var context = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({
            store: store,
            written: Object.create(null),
            merge: function(existing, incoming) {
                return merger.merge(existing, incoming);
            },
            variables: variables,
            varString: (0, $e3e8d305ba8d539e$export$88a0ad9b6f961b51)(variables)
        }, (0, $21d6b69e155d5d08$export$3a33c00f0ae4a480)(query, this.fragments)), {
            overwrite: !!overwrite,
            incomingById: new Map(),
            clientOnly: false,
            deferred: false,
            flavors: new Map()
        });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: {
                map: new Map()
            },
            context: context
        });
        if (!(0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(ref)) throw (0, $c21c2000775800f2$export$3991762405098ea)(12, result);
        // So far, the store has not been modified, so now it's time to process
        // context.incomingById and merge those incoming fields into context.store.
        context.incomingById.forEach(function(_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = (0, $6ee6592fd95fa693$export$634ae0e932e9be99)(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if ((0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(applied)) // Assume References returned by applyMerges have already been merged
                // into the store. See makeMergeObjectsFunction in policies.ts for an
                // example of how this can happen.
                return;
                // Otherwise, applyMerges returned a StoreObject, whose fields we should
                // merge into the store (see store.merge statement below).
                storeObject = applied;
            }
            if (globalThis.__DEV__ !== false && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function(field) {
                    if (field.selectionSet) fieldsWithSelectionSets_1[field.name.value] = true;
                });
                var hasSelectionSet_1 = function(storeFieldName) {
                    return fieldsWithSelectionSets_1[(0, $21d6b69e155d5d08$export$37874422037b6029)(storeFieldName)] === true;
                };
                var hasMergeFunction_1 = function(storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function(storeFieldName) {
                    // If a merge function was defined for this field, trust that it
                    // did the right thing about (not) clobbering data. If the field
                    // has no selection set, it's a scalar field, so it doesn't need
                    // a merge function (even if it's an object, like JSON data).
                    if (hasSelectionSet_1(storeFieldName) && !hasMergeFunction_1(storeFieldName)) $13c65a4b486a4604$var$warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                });
            }
            store.merge(dataId, storeObject);
        });
        // Any IDs written explicitly to the cache will be retained as
        // reachable root IDs for garbage collection purposes. Although this
        // logic includes root IDs like ROOT_QUERY and ROOT_MUTATION, their
        // retainment counts are effectively ignored because cache.gc() always
        // includes them in its root ID set.
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function(_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, // This object allows processSelectionSet to report useful information
        // to its callers without explicitly returning that information.
        mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        // This variable will be repeatedly updated using context.merge to
        // accumulate all fields that need to be written into the store.
        var incoming = Object.create(null);
        // If typename was not passed in, infer it. Note that typename is
        // always passed in for tricky-to-infer cases such as "Query" for
        // ROOT_QUERY.
        var typename = dataId && policies.rootTypenamesById[dataId] || (0, $6ee6592fd95fa693$export$cf7bf7e4f289cc26)(result, selectionSet, context.fragmentMap) || dataId && context.store.get(dataId, "__typename");
        if ("string" === typeof typename) incoming.__typename = typename;
        // This readField function will be passed as context.readField in the
        // KeyFieldsContext object created within policies.identify (called below).
        // In addition to reading from the existing context.store (thanks to the
        // policies.readField(options, context) line at the very bottom), this
        // version of readField can read from Reference objects that are currently
        // pending in context.incomingById, which is important whenever keyFields
        // need to be extracted from a child object that processSelectionSet has
        // turned into a Reference.
        var readField = function() {
            var options = (0, $7f695981f5b939c9$export$1ad7a877581bdf2e)(arguments, incoming, context.variables);
            if ((0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField((0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, options), {
                        from: info.storeObject
                    }), context);
                    if (result_1 !== void 0) return result_1;
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        context, typename).forEach(function(context, field) {
            var _a;
            var resultFieldKey = (0, $6ee6592fd95fa693$export$7d1ad22471852218)(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables
                });
                var childTree = $13c65a4b486a4604$var$getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, // Reset context.clientOnly and context.deferred to their default
                // values before processing nested selection sets.
                field.selectionSet ? $13c65a4b486a4604$var$getContextFlavor(context, false, false) : context, childTree);
                // To determine if this field holds a child object with a merge function
                // defined in its type policy (see PR #7070), we need to figure out the
                // child object's __typename.
                var childTypename = void 0;
                // The field's value can be an object that has a __typename only if the
                // field has a selection set. Otherwise incomingValue is scalar.
                if (field.selectionSet && ((0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(incomingValue) || (0, $21d6b69e155d5d08$export$4f39afca21bd938e)(incomingValue))) childTypename = readField("__typename", incomingValue);
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) childTree.info = {
                    // TODO Check compatibility against any existing childTree.field?
                    field: field,
                    typename: typename,
                    merge: merge
                };
                else $13c65a4b486a4604$var$maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                incoming = context.merge(incoming, (_a = {}, _a[storeFieldName] = incomingValue, _a));
            } else if (globalThis.__DEV__ !== false && !context.clientOnly && !context.deferred && !(0, $19cabdf265088897$export$43b332f87950a467).added(field) && // If the field has a read function, it may be a synthetic field or
            // provide a default value, so its absence from the written data should
            // not be cause for alarm.
            !policies.getReadFunction(typename, field.name.value)) globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).error(13, (0, $6ee6592fd95fa693$export$7d1ad22471852218)(field), result);
        });
        // Identify the result object, even if dataId was already provided,
        // since we always need keyObject below.
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField
            }), id = _b[0], keyObject = _b[1];
            // If dataId was not provided, fall back to the id just generated by
            // policies.identify.
            dataId = dataId || id;
            // Write any key fields that were used during identification, even if
            // they were not mentioned in the original query.
            if (keyObject) // TODO Reverse the order of the arguments?
            incoming = context.merge(incoming, keyObject);
        } catch (e) {
            // If dataId was provided, tolerate failure of policies.identify.
            if (!dataId) throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = (0, $6ee6592fd95fa693$export$634ae0e932e9be99)(dataId);
            // Avoid processing the same entity object using the same selection
            // set more than once. We use an array instead of a Set since most
            // entity IDs will be written using only one selection set, so the
            // size of this array is likely to be very small, meaning indexOf is
            // likely to be faster than Set.prototype.has.
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0) return dataRef;
            sets.push(selectionSet);
            // If we're about to write a result object into the store, but we
            // happen to know that the exact same (===) result object would be
            // returned if we were to reread the result with the same inputs,
            // then we can skip the rest of the processSelectionSet work for
            // this object, and immediately return a Reference to it.
            if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) return dataRef;
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = $13c65a4b486a4604$var$mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function(field) {
                    return previous_1.fieldNodeSet.add(field);
                });
            } else context.incomingById.set(dataId, {
                storeObject: incoming,
                // Save a reference to mergeTree only if it is not empty, because
                // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
                // reused for entirely different parts of the result tree.
                mergeTree: $13c65a4b486a4604$var$mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                fieldNodeSet: fieldNodeSet
            });
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function(value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) // In development, we need to clone scalar values so that they can be
        // safely frozen with maybeDeepFreeze in readFromStore.ts. In production,
        // it's cheaper to store the scalar values directly in the cache.
        return globalThis.__DEV__ !== false ? (0, $778668322a5c03d6$export$629a2bd3f5a49ecc)(value) : value;
        if ((0, $01c8f68cc3e070ef$export$43bee75e5e14138e)(value)) return value.map(function(item, i) {
            var value = _this.processFieldValue(item, field, context, $13c65a4b486a4604$var$getChildMergeTree(mergeTree, i));
            $13c65a4b486a4604$var$maybeRecycleChildMergeTree(mergeTree, i);
            return value;
        });
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree
        });
    };
    // Implements https://spec.graphql.org/draft/#sec-Field-Collection, but with
    // some additions for tracking @client and @defer directives.
    StoreWriter.prototype.flattenFields = function(selectionSet, result, context, typename) {
        if (typename === void 0) typename = (0, $6ee6592fd95fa693$export$cf7bf7e4f289cc26)(result, selectionSet, context.fragmentMap);
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new (0, $722ae841a583e691$export$73571c50d0f2507e)(false); // No need for WeakMap, since limitingTrie does not escape.
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, // Because we take inheritedClientOnly and inheritedDeferred into
            // consideration here (in addition to selectionSet), it's possible for
            // the same selection set to be flattened more than once, if it appears
            // in the query with different @client and/or @directive configurations.
            inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited) return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function(selection) {
                if (!(0, $5a6e90bd3aec77b4$export$3dc388a5f013b4a5)(selection, context.variables)) return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (// Since the presence of @client or @defer on this field can only
                // cause clientOnly or deferred to become true, we can skip the
                // forEach loop if both clientOnly and deferred are already true.
                !(clientOnly && deferred) && (0, $01c8f68cc3e070ef$export$d307f5934e447d0e)(selection.directives)) selection.directives.forEach(function(dir) {
                    var name = dir.name.value;
                    if (name === "client") clientOnly = true;
                    if (name === "defer") {
                        var args = (0, $6ee6592fd95fa693$export$3f5a60fb6a781b4f)(dir, context.variables);
                        // The @defer directive takes an optional args.if boolean
                        // argument, similar to @include(if: boolean). Note that
                        // @defer(if: false) does not make context.deferred false, but
                        // instead behaves as if there was no @defer directive.
                        if (!args || args.if !== false) deferred = true;
                    // TODO In the future, we may want to record args.label using
                    // context.deferred, if a label is specified.
                    }
                });
                if ((0, $6ee6592fd95fa693$export$fb56ad75dd311c12)(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        // If this field has been visited along another recursive path
                        // before, the final context should have clientOnly or deferred set
                        // to true only if *all* paths have the directive (hence the &&).
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, $13c65a4b486a4604$var$getContextFlavor(context, clientOnly, deferred));
                } else {
                    var fragment = (0, $070763719c7946cb$export$f80bdb85f299186)(selection, context.lookupFragment);
                    if (!fragment && selection.kind === (0, $c9d7601e69c085e8$export$a84bdc57c5122798).FRAGMENT_SPREAD) throw (0, $c21c2000775800f2$export$3991762405098ea)(14, selection.name.value);
                    if (fragment && policies.fragmentMatches(fragment, typename, result, context.variables)) flatten(fragment.selectionSet, $13c65a4b486a4604$var$getContextFlavor(context, clientOnly, deferred));
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function(mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !(0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(incoming)) {
            var e_1 = // Items in the same position in different arrays are not
            // necessarily related to each other, so when incoming is an array
            // we process its elements as if there was no existing data.
            !(0, $01c8f68cc3e070ef$export$43bee75e5e14138e)(incoming) && // Likewise, existing must be either a Reference or a StoreObject
            // in order for its fields to be safe to merge with the fields of
            // the incoming object.
            ((0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(existing) || (0, $21d6b69e155d5d08$export$4f39afca21bd938e)(existing)) ? existing : void 0;
            // This narrowing is implied by mergeTree.map.size > 0 and
            // !isReference(incoming), though TypeScript understandably cannot
            // hope to infer this type.
            var i_1 = incoming;
            // The options.storage objects provided to read and merge functions
            // are derived from the identity of the parent object plus a
            // sequence of storeFieldName strings/numbers identifying the nested
            // field name path of each field value to be merged.
            if (e_1 && !getStorageArgs) getStorageArgs = [
                (0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(e_1) ? e_1.__ref : e_1
            ];
            // It's possible that applying merge functions to this subtree will
            // not change the incoming data, so this variable tracks the fields
            // that did change, so we can create a new incoming object when (and
            // only when) at least one incoming field has changed. We use a Map
            // to preserve the type of numeric keys.
            var changedFields_1;
            var getValue_1 = function(from, name) {
                return (0, $01c8f68cc3e070ef$export$43bee75e5e14138e)(from) ? typeof name === "number" ? from[name] : void 0 : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function(childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                // If we have no incoming data, leave any existing data untouched.
                if (void 0 === iVal) return;
                if (getStorageArgs) getStorageArgs.push(storeFieldName);
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map();
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) (0, $c21c2000775800f2$export$f5708dca728d7177)(getStorageArgs.pop() === storeFieldName);
            });
            if (changedFields_1) {
                // Shallow clone i so we can add changed fields to it.
                incoming = (0, $01c8f68cc3e070ef$export$43bee75e5e14138e)(i_1) ? i_1.slice(0) : (0, $b8xcN.__assign)({}, i_1);
                changedFields_1.forEach(function(value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        return incoming;
    };
    return StoreWriter;
}();
var $13c65a4b486a4604$var$emptyMergeTreePool = [];
function $13c65a4b486a4604$var$getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) map.set(name, $13c65a4b486a4604$var$emptyMergeTreePool.pop() || {
        map: new Map()
    });
    return map.get(name);
}
function $13c65a4b486a4604$var$mergeMergeTrees(left, right) {
    if (left === right || !right || $13c65a4b486a4604$var$mergeTreeIsEmpty(right)) return left;
    if (!left || $13c65a4b486a4604$var$mergeTreeIsEmpty(left)) return right;
    var info = left.info && right.info ? (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map() : left.map.size ? left.map : right.map;
    var merged = {
        info: info,
        map: map
    };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function(leftTree, key) {
            merged.map.set(key, $13c65a4b486a4604$var$mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function(key) {
            merged.map.set(key, $13c65a4b486a4604$var$mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function $13c65a4b486a4604$var$mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function $13c65a4b486a4604$var$maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && $13c65a4b486a4604$var$mergeTreeIsEmpty(childTree)) {
        $13c65a4b486a4604$var$emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var $13c65a4b486a4604$var$warnings = new Set();
// Note that this function is unused in production, and thus should be
// pruned by any well-configured minifier.
function $13c65a4b486a4604$var$warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function(objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing) return;
    var incoming = getChild(incomingObj);
    if (!incoming) return;
    // It's always safe to replace a reference, since it refers to data
    // safely stored elsewhere.
    if ((0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(existing)) return;
    // If the values are structurally equivalent, we do not need to worry
    // about incoming replacing existing.
    if ((0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(existing, incoming)) return;
    // If we're replacing every key of the existing object, then the
    // existing data would be overwritten even if the objects were
    // normalized, so warning would not be helpful here.
    if (Object.keys(existing).every(function(key) {
        return store.getFieldValue(incoming, key) !== void 0;
    })) return;
    var parentType = store.getFieldValue(existingRef, "__typename") || store.getFieldValue(incomingObj, "__typename");
    var fieldName = (0, $21d6b69e155d5d08$export$37874422037b6029)(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    // Avoid warning more than once for the same type and field name.
    if ($13c65a4b486a4604$var$warnings.has(typeDotName)) return;
    $13c65a4b486a4604$var$warnings.add(typeDotName);
    var childTypenames = [];
    // Arrays do not have __typename fields, and always need a custom merge
    // function, even if their elements are normalized entities.
    if (!(0, $01c8f68cc3e070ef$export$43bee75e5e14138e)(existing) && !(0, $01c8f68cc3e070ef$export$43bee75e5e14138e)(incoming)) [
        existing,
        incoming
    ].forEach(function(child) {
        var typename = store.getFieldValue(child, "__typename");
        if (typeof typename === "string" && !childTypenames.includes(typename)) childTypenames.push(typename);
    });
    globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(15, fieldName, parentType, childTypenames.length ? "either ensure all objects of type " + childTypenames.join(" and ") + " have an ID or a custom merge function, or " : "", typeDotName, (0, $b8xcN.__assign)({}, existing), (0, $b8xcN.__assign)({}, incoming));
}







var $50779dffca98a95f$export$467265324939f47f = /** @class */ function(_super) {
    (0, $b8xcN.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.addTypenameTransform = new (0, $e10872a8609e2fee$export$f887060e48e5dc1b)((0, $19cabdf265088897$export$43b332f87950a467));
        // Override the default value, since InMemoryCache result objects are frozen
        // in development and expected to remain logically immutable in production.
        _this.assumeImmutableResults = true;
        _this.makeVar = (0, $dc81f3128dc8fcdb$export$5345c8ac69b4a9db);
        _this.txCount = 0;
        if (globalThis.__DEV__ !== false) {
            (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(config, "addTypename", "InMemoryCache", "Please remove the `addTypename` option when initializing `InMemoryCache`.");
            (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(config, "canonizeResults", "InMemoryCache", "Please remove the `canonizeResults` option when initializing `InMemoryCache`.");
        }
        _this.config = (0, $21d6b69e155d5d08$export$fa542f9ee3f7f4e2)(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new (0, $7f695981f5b939c9$export$e9859ad90648930b)({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function() {
        // Passing { resultCaching: false } in the InMemoryCache constructor options
        // will completely disable dependency tracking, which will improve memory
        // usage but worsen the performance of repeated reads.
        var rootStore = this.data = new (0, $f2796c17db7cbf02$export$cb507f57054c7321).Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching
        });
        // When no optimistic writes are currently active, cache.optimisticData ===
        // cache.data, so there are no additional layers on top of the actual data.
        // When an optimistic update happens, this.optimisticData will become a
        // linked list of EntityStore Layer objects that terminates with the
        // original this.data cache object.
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function(resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        this.addTypenameTransform.resetCache();
        fragments === null || fragments === void 0 || fragments.resetCaches();
        // The StoreWriter is mostly stateless and so doesn't really need to be
        // reset, but it does need to have its writer.storeReader reference updated,
        // so it's simpler to update this.storeWriter as well.
        this.storeWriter = new (0, $13c65a4b486a4604$export$eb8361c5d132fb8f)(this, this.storeReader = new (0, $e7357c9a775afaef$export$628ef07ba8965f12)({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: (0, $21d6b69e155d5d08$export$3ac2a95fbd99c479)(this.config),
            canon: resetResultIdentities ? void 0 : previousReader && previousReader.canon,
            fragments: fragments
        }), fragments);
        this.maybeBroadcastWatch = (0, $2a919cc3f1f126e4$export$4997ffc0176396a6)(function(c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $d301603631c7863b$export$f29926b23b28936b)["inMemoryCache.maybeBroadcastWatch"] || 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
            makeCacheKey: function(c) {
                // Return a cache key (thus enabling result caching) only if we're
                // currently using a data store that can track cache dependencies.
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if ((0, $f2796c17db7cbf02$export$488c0743feab3d61)(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, // Different watches can have the same query, optimistic
                    // status, rootId, and variables, but if their callbacks are
                    // different, the (identical) result needs to be delivered to
                    // each distinct callback. The easiest way to achieve that
                    // separation is to include c.callback in the cache key for
                    // maybeBroadcastWatch calls. See issue #5733.
                    c.callback, (0, $e3e8d305ba8d539e$export$88a0ad9b6f961b51)({
                        optimistic: optimistic,
                        id: id,
                        variables: variables
                    }));
                }
            }
        });
        // Since we have thrown away all the cached functions that depend on the
        // CacheGroup dependencies maintained by EntityStore, we should also reset
        // all CacheGroup dependency information.
        new Set([
            this.data.group,
            this.optimisticData.group
        ]).forEach(function(group) {
            return group.resetCaching();
        });
    };
    InMemoryCache.prototype.restore = function(data) {
        this.init();
        // Since calling this.init() discards/replaces the entire StoreReader, along
        // with the result caches it maintains, this.data.replace(data) won't have
        // to bother deleting the old data.
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function(options) {
        if (globalThis.__DEV__ !== false) (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(options, "canonizeResults", "cache.read");
        var // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        _a = options.returnPartialData, // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore((0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, options), {
                store: options.optimistic ? this.optimisticData : this.data,
                config: this.config,
                returnPartialData: returnPartialData
            })).result || null;
        } catch (e) {
            if (e instanceof (0, $abe96c5581ab8a1e$export$257c68286583b0f9)) // Swallow MissingFieldError and return null, so callers do not need to
            // worry about catching "normal" exceptions resulting from incomplete
            // cache data. Unexpected errors will be re-thrown. If you need more
            // information about which fields were missing, use cache.diff instead,
            // and examine diffResult.missing.
            return null;
            throw e;
        }
    };
    InMemoryCache.prototype.write = function(options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.modify = function(options) {
        if ((0, $21d6b69e155d5d08$export$b5a638e9b3fff9f3).call(options, "id") && !options.id) // To my knowledge, TypeScript does not currently provide a way to
        // enforce that an optional property?:type must *not* be undefined
        // when present. That ability would be useful here, because we want
        // options.id to default to ROOT_QUERY only when no options.id was
        // provided. If the caller attempts to pass options.id with a
        // falsy/undefined value (perhaps because cache.identify failed), we
        // should not assume the goal was to modify the ROOT_QUERY object.
        // We could throw, but it seems natural to return false to indicate
        // that nothing was modified.
        return false;
        var store = options.optimistic // Defaults to false.
         ? this.optimisticData : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.diff = function(options) {
        if (globalThis.__DEV__ !== false) (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(options, "canonizeResults", "cache.diff");
        return this.storeReader.diffQueryAgainstStore((0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, options), {
            store: options.optimistic ? this.optimisticData : this.data,
            rootId: options.id || "ROOT_QUERY",
            config: this.config
        }));
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        if (!this.watches.size) // In case we previously called forgetCache(this) because
        // this.watches became empty (see below), reattach this cache to any
        // reactive variables on which it previously depended. It might seem
        // paradoxical that we're able to recall something we supposedly
        // forgot, but the point of calling forgetCache(this) is to silence
        // useless broadcasts while this.watches is empty, and to allow the
        // cache to be garbage collected. If, however, we manage to call
        // recallCache(this) here, this cache object must not have been
        // garbage collected yet, and should resume receiving updates from
        // reactive variables, now that it has a watcher to notify.
        (0, $dc81f3128dc8fcdb$export$f342bdd61b3e9412)(this);
        this.watches.add(watch);
        if (watch.immediate) this.maybeBroadcastWatch(watch);
        return function() {
            // Once we remove the last watch from this.watches, cache.broadcastWatches
            // no longer does anything, so we preemptively tell the reactive variable
            // system to exclude this cache from future broadcasts.
            if (_this.watches.delete(watch) && !_this.watches.size) (0, $dc81f3128dc8fcdb$export$cbe12faed7725318)(_this);
            // Remove this watch from the LRU cache managed by the
            // maybeBroadcastWatch OptimisticWrapperFunction, to prevent memory
            // leaks involving the closure of watch.callback.
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function(options) {
        if (globalThis.__DEV__ !== false) (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(options || {}, "resetResultIdentities", "cache.gc", "First ensure all usages of `canonizeResults` are removed, then remove this option.");
        (0, $e3e8d305ba8d539e$export$88a0ad9b6f961b51).reset();
        (0, $545086ab9b229dc6$export$c2d084dc44961371).reset();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) this.resetResultCache(options.resetResultIdentities);
            else if (options.resetResultIdentities) this.storeReader.resetCanon();
        }
        return ids;
    };
    // Call this method to ensure the given root ID remains in the cache after
    // garbage collection, along with its transitive child entities. Note that
    // the cache automatically retains all directly written entities. By default,
    // the retainment persists after optimistic updates are removed. Pass true
    // for the optimistic argument if you would prefer for the retainment to be
    // discarded when the top-most optimistic layer is removed. Returns the
    // resulting (non-negative) retainment count.
    InMemoryCache.prototype.retain = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    // Call this method to undo the effect of the retain method, above. Once the
    // retainment count falls to zero, the given ID will no longer be preserved
    // during garbage collection, though it may still be preserved by other safe
    // entities that refer to it. Returns the resulting (non-negative) retainment
    // count, in case that's useful.
    InMemoryCache.prototype.release = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    // Returns the canonical ID for a given StoreObject, obeying typePolicies
    // and keyFields (and dataIdFromObject, if you still use that). At minimum,
    // the object must contain a __typename and any primary key fields required
    // to identify entities of that type. If you pass a query result object, be
    // sure that none of the primary key fields have been renamed by aliasing.
    // If you pass a Reference object, its __ref ID string will be returned.
    InMemoryCache.prototype.identify = function(object) {
        if ((0, $6ee6592fd95fa693$export$fa99cac1c0883c47)(object)) return object.__ref;
        try {
            return this.policies.identify(object)[0];
        } catch (e) {
            globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(e);
        }
    };
    InMemoryCache.prototype.evict = function(options) {
        if (!options.id) {
            if ((0, $21d6b69e155d5d08$export$b5a638e9b3fff9f3).call(options, "id")) // See comment in modify method about why we return false when
            // options.id exists but is falsy/undefined.
            return false;
            options = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, options), {
                id: "ROOT_QUERY"
            });
        }
        try {
            // It's unlikely that the eviction will end up invoking any other
            // cache update operations while it's running, but {in,de}crementing
            // this.txCount still seems like a good idea, for uniformity with
            // the other update methods.
            ++this.txCount;
            // Pass this.data as a limit on the depth of the eviction, so evictions
            // during optimistic updates (when this.data is temporarily set equal to
            // this.optimisticData) do not escape their optimistic Layer.
            return this.optimisticData.evict(options, this.data);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.reset = function(options) {
        var _this = this;
        this.init();
        (0, $e3e8d305ba8d539e$export$88a0ad9b6f961b51).reset();
        if (options && options.discardWatches) {
            // Similar to what happens in the unsubscribe function returned by
            // cache.watch, applied to all current watches.
            this.watches.forEach(function(watch) {
                return _this.maybeBroadcastWatch.forget(watch);
            });
            this.watches.clear();
            (0, $dc81f3128dc8fcdb$export$cbe12faed7725318)(this);
        } else // Calling this.init() above unblocks all maybeBroadcastWatch caching, so
        // this.broadcastWatches() triggers a broadcast to every current watcher
        // (letting them know their data is now missing). This default behavior is
        // convenient because it means the watches do not have to be manually
        // reestablished after resetting the cache. To prevent this broadcast and
        // cancel all watches, pass true for options.discardWatches.
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function(options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function(layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) _this.data = _this.optimisticData = layer;
            try {
                return updateResult = update(_this);
            } finally{
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) // If an options.onWatchUpdated callback is provided, we want to call it
        // with only the Cache.WatchOptions objects affected by options.update,
        // but there might be dirty watchers already waiting to be broadcast that
        // have nothing to do with the update. To prevent including those watchers
        // in the post-update broadcast, we perform this initial broadcast to
        // collect the dirty watchers, so we can re-dirty them later, after the
        // post-update broadcast, allowing them to receive their pending
        // broadcasts the next time broadcastWatches is called, just as they would
        // if we never called cache.batch.
        this.broadcastWatches((0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, options), {
            onWatchUpdated: function(watch) {
                alreadyDirty.add(watch);
                return false;
            }
        }));
        if (typeof optimistic === "string") // Note that there can be multiple layers with the same optimistic ID.
        // When removeOptimistic(id) is called for that id, all matching layers
        // will be removed, and the remaining layers will be reapplied.
        this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        else if (optimistic === false) // Ensure both this.data and this.optimisticData refer to the root
        // (non-optimistic) layer of the cache during the update. Note that
        // this.data could be a Layer if we are currently executing an optimistic
        // update function, but otherwise will always be an EntityStore.Root
        // instance.
        perform(this.data);
        else // Otherwise, leave this.data and this.optimisticData unchanged and run
        // the update with broadcast batching.
        perform();
        if (typeof removeOptimistic === "string") this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        // Note: if this.txCount > 0, then alreadyDirty.size === 0, so this code
        // takes the else branch and calls this.broadcastWatches(options), which
        // does nothing when this.txCount > 0.
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches((0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, options), {
                onWatchUpdated: function(watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) // Since onWatchUpdated did not return false, this diff is
                    // about to be broadcast to watch.callback, so we don't need
                    // to re-dirty it with the other alreadyDirty watches below.
                    alreadyDirty.delete(watch);
                    return result;
                }
            }));
            // Silently re-dirty any watches that were already dirty before the update
            // was performed, and were not broadcast just now.
            if (alreadyDirty.size) alreadyDirty.forEach(function(watch) {
                return _this.maybeBroadcastWatch.dirty(watch);
            });
        } else // If alreadyDirty is empty or we don't have an onWatchUpdated
        // function, we don't need to go to the trouble of wrapping
        // options.onWatchUpdated.
        this.broadcastWatches(options);
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function(update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || optimisticId !== null
        });
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        return this.addTypenameToDocument(this.addFragmentsToDocument(document));
    };
    InMemoryCache.prototype.fragmentMatches = function(fragment, typename) {
        return this.policies.fragmentMatches(fragment, typename);
    };
    InMemoryCache.prototype.lookupFragment = function(fragmentName) {
        var _a;
        return ((_a = this.config.fragments) === null || _a === void 0 ? void 0 : _a.lookup(fragmentName)) || null;
    };
    InMemoryCache.prototype.broadcastWatches = function(options) {
        var _this = this;
        if (!this.txCount) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c, options);
        });
    };
    InMemoryCache.prototype.addFragmentsToDocument = function(document) {
        var fragments = this.config.fragments;
        return fragments ? fragments.transform(document) : document;
    };
    InMemoryCache.prototype.addTypenameToDocument = function(document) {
        if (this.addTypename) return this.addTypenameTransform.transformDocument(document);
        return document;
    };
    // This method is wrapped by maybeBroadcastWatch, which is called by
    // broadcastWatches, so that we compute and broadcast results only when
    // the data that would be broadcast might have changed. It would be
    // simpler to check for changes after recomputing a result but before
    // broadcasting it, but this wrapping approach allows us to skip both
    // the recomputation and the broadcast, in most cases.
    InMemoryCache.prototype.broadcastWatch = function(c, options) {
        var _this = this;
        var lastDiff = c.lastDiff;
        // Both WatchOptions and DiffOptions extend ReadOptions, and DiffOptions
        // currently requires no additional properties, so we can use c (a
        // WatchOptions object) as DiffOptions, without having to allocate a new
        // object, and without having to enumerate the relevant properties (query,
        // variables, etc.) explicitly. There will be some additional properties
        // (lastDiff, callback, etc.), but cache.diff ignores them.
        var diff = (0, $14465ad01ccc354a$export$d18d1529326946c4)("canonizeResults", function() {
            return _this.diff(c);
        });
        if (options) {
            if (c.optimistic && typeof options.optimistic === "string") diff.fromOptimisticTransaction = true;
            if (options.onWatchUpdated && options.onWatchUpdated.call(this, c, diff, lastDiff) === false) // Returning false from the onWatchUpdated callback will prevent
            // calling c.callback(diff) for this watcher.
            return;
        }
        if (!lastDiff || !(0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(lastDiff.result, diff.result)) c.callback(c.lastDiff = diff, lastDiff);
    };
    return InMemoryCache;
}((0, $a586c9827fcb602f$export$5fc74f25506aa9c));
if (globalThis.__DEV__ !== false) $50779dffca98a95f$export$467265324939f47f.prototype.getMemoryInternals = (0, $afbf6f02b98da1f0$export$e95a5a2210e62466);



var $b8xcN = parcelRequire("b8xcN");


function $ef678dd544af947d$export$2f04de43fe27971a(setter) {
    return new (0, $b03f28e182db18c2$export$2fed3d61f740bc7f)(function(operation, forward) {
        var request = (0, $b8xcN.__rest)(operation, []);
        return new (0, $2027033ce24a9479$export$77cea355fa80b5f4)(function(observer) {
            var handle;
            var closed = false;
            Promise.resolve(request).then(function(req) {
                return setter(req, operation.getContext());
            }).then(operation.setContext).then(function() {
                // if the observer is already closed, no need to subscribe.
                if (closed) return;
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            }).catch(observer.error.bind(observer));
            return function() {
                closed = true;
                if (handle) handle.unsubscribe();
            };
        });
    });
}




const $b5f638428a9d7094$var$uri = (0, $b5d41e4dbaeacaa2$export$daa4d85031700d6a);
const $b5f638428a9d7094$var$authLink = (0, $ef678dd544af947d$export$2f04de43fe27971a)((_operation, { headers: headers })=>{
    const token = (0, $f0578ea5f18e5637$export$84773cc9bf7dbe87)();
    return {
        headers: token ? {
            ...headers,
            authorization: `Bearer ${token}`
        } : headers
    };
});
const $b5f638428a9d7094$export$d1325c0cda90af4f = new (0, $c881dafd782f0198$export$13f5a5f0f1dbab88)({
    link: (0, $f81266456f9cf9a5$export$6788812c4e6611e6)([
        $b5f638428a9d7094$var$authLink,
        new (0, $7f67f06dc899def3$export$f4bbf1aec241cc1)({
            uri: $b5f638428a9d7094$var$uri
        })
    ]),
    cache: new (0, $50779dffca98a95f$export$467265324939f47f)(),
    defaultOptions: {
        watchQuery: {
            fetchPolicy: 'cache-and-network'
        }
    }
});
function $b5f638428a9d7094$export$dbfe74f291058e97(error) {
    return error?.graphQLErrors?.[0]?.extensions?.code ?? null;
}
const $b5f638428a9d7094$export$7e9cf63a972dd62 = (error)=>$b5f638428a9d7094$export$dbfe74f291058e97(error) === 'FORBIDDEN';
const $b5f638428a9d7094$export$1724ecfee73c4768 = (error)=>$b5f638428a9d7094$export$dbfe74f291058e97(error) === 'UNAUTHENTICATED';





/**
 * The calendar (`/calendar`).
 *
 * Week is the default view because a week is the unit a sales rep plans in;
 * day exists for a full one, and the agenda list for scanning what is next
 * without reading a grid.
 *
 * Shortcuts are registered in the central registry like everything else
 * (CLAUDE.md §12): `t` today, `[` / `]` previous and next, `n` a new activity.
 * `[` and `]` are the physical keys either side of Enter on both a Persian and
 * a Latin layout, so they land in the same place whichever the user has.
 */ 
var $2M70Q = parcelRequire("2M70Q");

var $b8xcN = parcelRequire("b8xcN");








var $a18155047725579a$export$700979bc83e7db82 = (0, $138881ab8f31fa6b$export$71594e8a50f746f4) ? $631d82cb14744748$exports.useLayoutEffect : $631d82cb14744748$exports.useEffect;



function $97378baea225b83b$export$609860bf8b0084c(mutation, options) {
    if (globalThis.__DEV__ !== false) // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
    (0, $5371af004b6fa366$export$d5e35053e4aec331)(options || {}, "ignoreResults", "useMutation", "If you don't want to synchronize component state with the mutation, please use the `useApolloClient` hook to get the client instance and call `client.mutate` directly.");
    var client = (0, $2b2c5bfb3bce7a5b$export$eb9a56e7a29e494)(options === null || options === void 0 ? void 0 : options.client);
    (0, $67539dbfe6b21900$export$6dfb8732f737404c)(mutation, (0, $67539dbfe6b21900$export$d1d99cf900472499).Mutation);
    var _a = $631d82cb14744748$exports.useState({
        called: false,
        loading: false,
        client: client
    }), result = _a[0], setResult = _a[1];
    var ref = $631d82cb14744748$exports.useRef({
        result: result,
        mutationId: 0,
        isMounted: true,
        client: client,
        mutation: mutation,
        options: options
    });
    (0, $a18155047725579a$export$700979bc83e7db82)(function() {
        Object.assign(ref.current, {
            client: client,
            options: options,
            mutation: mutation
        });
    });
    var execute = $631d82cb14744748$exports.useCallback(function(executeOptions) {
        if (executeOptions === void 0) executeOptions = {};
        var _a = ref.current, options = _a.options, mutation = _a.mutation;
        var baseOptions = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, options), {
            mutation: mutation
        });
        var client = executeOptions.client || ref.current.client;
        if (!ref.current.result.loading && !baseOptions.ignoreResults && ref.current.isMounted) setResult(ref.current.result = {
            loading: true,
            error: void 0,
            data: void 0,
            called: true,
            client: client
        });
        var mutationId = ++ref.current.mutationId;
        var clientOptions = (0, $a76f045ea055af6d$export$235b7fc70b9fc359)(baseOptions, executeOptions);
        return client.mutate(clientOptions).then(function(response) {
            var _a, _b;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0 ? new (0, $03c08328939e6317$export$26a337512320b8c6)({
                graphQLErrors: errors
            }) : void 0;
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (error && onError) onError(error, clientOptions);
            if (mutationId === ref.current.mutationId && !clientOptions.ignoreResults) {
                var result_1 = {
                    called: true,
                    loading: false,
                    data: data,
                    error: error,
                    client: client
                };
                if (ref.current.isMounted && !(0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(ref.current.result, result_1)) setResult(ref.current.result = result_1);
            }
            var onCompleted = executeOptions.onCompleted || ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onCompleted);
            if (!error) onCompleted === null || onCompleted === void 0 || onCompleted(response.data, clientOptions);
            return response;
        }, function(error) {
            var _a;
            if (mutationId === ref.current.mutationId && ref.current.isMounted) {
                var result_2 = {
                    loading: false,
                    error: error,
                    data: void 0,
                    called: true,
                    client: client
                };
                if (!(0, $b59b67a8b7fe71c2$export$411ce8e5a71e3069)(ref.current.result, result_2)) setResult(ref.current.result = result_2);
            }
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (onError) {
                onError(error, clientOptions);
                // TODO(brian): why are we returning this here???
                return {
                    data: void 0,
                    errors: error
                };
            }
            throw error;
        });
    }, []);
    var reset = $631d82cb14744748$exports.useCallback(function() {
        if (ref.current.isMounted) {
            var result_3 = {
                called: false,
                loading: false,
                client: ref.current.client
            };
            Object.assign(ref.current, {
                mutationId: 0,
                result: result_3
            });
            setResult(result_3);
        }
    }, []);
    $631d82cb14744748$exports.useEffect(function() {
        var current = ref.current;
        current.isMounted = true;
        return function() {
            current.isMounted = false;
        };
    }, []);
    return [
        execute,
        (0, $b8xcN.__assign)({
            reset: reset
        }, result)
    ];
}


/**
 * JS mirror of tokens.css, for code that cannot read a CSS custom property
 * (chart libraries, canvas, inline style computation). Keep in sync with
 * tokens.css — it is the source of truth for the rendered values.
 */ const $dd0263804d68f882$export$8f45430ccf837300 = {
    primary: 'var(--mh-color-primary)',
    primaryHover: 'var(--mh-color-primary-hover)',
    primaryContrast: 'var(--mh-color-primary-contrast)',
    accent: 'var(--mh-color-accent)',
    bg: 'var(--mh-color-bg)',
    surface: 'var(--mh-color-surface)',
    surfaceHover: 'var(--mh-color-surface-hover)',
    border: 'var(--mh-color-border)',
    borderStrong: 'var(--mh-color-border-strong)',
    text: 'var(--mh-color-text)',
    textMuted: 'var(--mh-color-text-muted)',
    textInverse: 'var(--mh-color-text-inverse)',
    danger: 'var(--mh-color-danger)',
    warning: 'var(--mh-color-warning)',
    success: 'var(--mh-color-success)',
    info: 'var(--mh-color-info)'
};
const $dd0263804d68f882$export$6881c75116d5bd6e = {
    UNKNOWN: 'var(--mh-color-status-unknown)',
    INTERESTED: 'var(--mh-color-status-interested)',
    CONSULTING: 'var(--mh-color-status-consulting)',
    SUBSCRIBER: 'var(--mh-color-status-subscriber)'
};
const $dd0263804d68f882$export$32d227f17c113340 = [
    'var(--mh-color-activity-1)',
    'var(--mh-color-activity-2)',
    'var(--mh-color-activity-3)',
    'var(--mh-color-activity-4)',
    'var(--mh-color-activity-5)',
    'var(--mh-color-activity-6)',
    'var(--mh-color-activity-7)',
    'var(--mh-color-activity-8)'
];
const $dd0263804d68f882$export$872dd985a098dd45 = {
    base: 'var(--mh-radius)',
    full: 'var(--mh-radius-full)'
};
const $dd0263804d68f882$export$73d8d529e966c7d9 = {
    rowHeight: 'var(--mh-density-row-height)',
    rowPaddingY: 'var(--mh-density-row-padding-y)',
    hour: 'var(--mh-density-hour)',
    timeGutter: 'var(--mh-density-time-gutter)',
    drawerWidth: 'var(--mh-density-drawer-width)',
    rowPaddingX: 'var(--mh-density-row-padding-x)',
    headerHeight: 'var(--mh-density-header-height)',
    controlHeight: 'var(--mh-density-control-height)',
    toolbarHeight: 'var(--mh-density-toolbar-height)',
    sidebarWidth: 'var(--mh-density-sidebar-width)',
    overlayWidth: 'var(--mh-density-overlay-width)',
    overlayWidthWide: 'var(--mh-density-overlay-wide)',
    thumb: 'var(--mh-density-thumb)',
    mediaPreview: 'var(--mh-density-media-preview)',
    avatar: 'var(--mh-density-avatar)',
    chartBar: 'var(--mh-density-chart-bar)',
    chartLabel: 'var(--mh-density-chart-label)',
    chartValue: 'var(--mh-density-chart-value)',
    filterWidth: 'var(--mh-density-filter-width)',
    filterSectionMax: 'var(--mh-density-filter-section-max)'
};
const $dd0263804d68f882$export$d846a084e680d8e = {
    fontFamily: 'var(--mh-font-family)',
    sizeXs: 'var(--mh-font-size-xs)',
    sizeSm: 'var(--mh-font-size-sm)',
    sizeBase: 'var(--mh-font-size-base)',
    sizeMd: 'var(--mh-font-size-md)',
    sizeLg: 'var(--mh-font-size-lg)',
    sizeXl: 'var(--mh-font-size-xl)'
};
const $dd0263804d68f882$export$19e2e41f5a1b2902 = [
    {
        name: 'teal',
        value: '#1d6f6a'
    },
    {
        name: 'terracotta',
        value: '#c2703d'
    },
    {
        name: 'amber',
        value: '#b45309'
    },
    {
        name: 'green',
        value: '#15803d'
    },
    {
        name: 'blue',
        value: '#1d4ed8'
    },
    {
        name: 'red',
        value: '#b91c1c'
    },
    {
        name: 'violet',
        value: '#7c3aed'
    },
    {
        name: 'pink',
        value: '#db2777'
    },
    {
        name: 'slate',
        value: '#6a7674'
    }
];
const $dd0263804d68f882$export$3a830fa5ba207950 = $dd0263804d68f882$export$19e2e41f5a1b2902[0].value;




var $68l1k = parcelRequire("68l1k");
var $1tMez = parcelRequire("1tMez");
var $eH742 = parcelRequire("eH742");
var $6PxCH = parcelRequire("6PxCH");

var $3OyDL = parcelRequire("3OyDL");
/**
 * One activity, as it appears on the grid or in a list.
 *
 * The colour comes from the activity TYPE, via a palette slot — no code here or
 * anywhere else names a type, because which types exist is deployment data
 * (product-neutrality rule, CLAUDE.md §1). A deployment that renames its
 * install type keeps its colour; one that adds a ninth type wraps around.
 *
 * The three badges are the whole reason this is a component rather than a div:
 * a synced activity, one that lost a conflict, and one whose contact was
 * deleted all need to say so at a glance, and all three are easy to forget.
 */ 
var $2M70Q = parcelRequire("2M70Q");

var $6tkl0 = parcelRequire("6tkl0");/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $d7cb66c6995a6673$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8 2v3",
            key: "1ioesn"
        }
    ],
    [
        "path",
        {
            d: "M16 2v3",
            key: "otl347"
        }
    ],
    [
        "rect",
        {
            x: "3",
            y: "3",
            width: "18",
            height: "18",
            rx: "2",
            key: "h1oib"
        }
    ],
    [
        "path",
        {
            d: "M3 9h18",
            key: "1pudct"
        }
    ],
    [
        "path",
        {
            d: "m9 15 2 2 4-4",
            key: "1grp1n"
        }
    ]
];
const $d7cb66c6995a6673$export$2e2bcd8739ae039 = (0, $djixo.default)("calendar-check", $d7cb66c6995a6673$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $85c01c71da36a916$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ],
    [
        "line",
        {
            x1: "17",
            x2: "22",
            y1: "8",
            y2: "13",
            key: "3nzzx3"
        }
    ],
    [
        "line",
        {
            x1: "22",
            x2: "17",
            y1: "8",
            y2: "13",
            key: "1swrse"
        }
    ]
];
const $85c01c71da36a916$export$2e2bcd8739ae039 = (0, $djixo.default)("user-x", $85c01c71da36a916$export$3efd853dbb351e94);


parcelRequire("3OyDL");


/** Finished or abandoned activities recede; the ones still owed stand out. */ const $f62f9853e6211882$var$STATUS_CLASS = {
    DONE: 'opacity-60',
    CANCELLED: 'opacity-50 line-through',
    MISSED: 'ring-1 ring-danger',
    SCHEDULED: ''
};
function $f62f9853e6211882$export$814296134552cdcd({ activity: activity, color: color, compact: compact = false, onClick: onClick, onMouseDown: onMouseDown }) {
    const conflict = activity.sync?.hasConflict;
    const synced = Boolean(activity.sync?.googleEventId);
    const title = [
        activity.title,
        activity.contact?.displayName,
        (0, $d4d460d3ffb6daab$export$b274e447bdddfc87)[activity.status],
        conflict ? (0, $d916753b57975e04$export$25ce5a424b770e84).calendar.conflictHint : null,
        activity.orphaned ? (0, $d916753b57975e04$export$25ce5a424b770e84).calendar.orphanedHint : null
    ].filter(Boolean).join(" \xb7 ");
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("button", {
        type: "button",
        onClick: onClick,
        onMouseDown: onMouseDown,
        title: title,
        className: [
            'flex h-full w-full flex-col overflow-hidden rounded border-s-4 bg-surface px-2 py-1',
            'text-start text-xs leading-tight shadow-sm hover:bg-surface-hover',
            $f62f9853e6211882$var$STATUS_CLASS[activity.status] ?? ''
        ].join(' '),
        // The only inline style: the palette slot for this activity's type. It is
        // a token reference, not a literal.
        style: {
            borderInlineStartColor: color
        },
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                className: "flex items-center gap-1 truncate font-medium text-text",
                children: [
                    !compact && !activity.allDay && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-text-muted",
                        dir: "ltr",
                        children: (0, $d4d460d3ffb6daab$export$3203edd9e5edd663)(activity.startsAt)
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "truncate",
                        children: activity.title
                    })
                ]
            }),
            activity.contact?.displayName && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                className: "truncate text-text-muted",
                children: activity.contact.displayName
            }),
            (conflict || activity.orphaned || synced) && /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                className: "mt-auto flex items-center gap-1 pt-1",
                children: [
                    conflict && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6tkl0.default), {
                        size: 11,
                        className: "text-warning",
                        "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).calendar.conflict
                    }),
                    activity.orphaned && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $85c01c71da36a916$export$2e2bcd8739ae039), {
                        size: 11,
                        className: "text-danger",
                        "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).calendar.orphaned
                    }),
                    synced && !conflict && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d7cb66c6995a6673$export$2e2bcd8739ae039), {
                        size: 11,
                        className: "text-text-muted",
                        "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).calendar.syncedWithGoogle
                    })
                ]
            })
        ]
    });
}


/**
 * Create and edit an activity, and move it through its lifecycle.
 *
 * The rule this dialog exists to make honest: **DONE requires a result**. The
 * server enforces it, and so does this form — not because the server needs
 * help, but because a rep who clicks «انجام شد» and gets a red banner has
 * already lost the thought they were about to write down. The field appears
 * first and the button waits.
 *
 * Reopening a finished activity is an ADMIN act that owes a reason, and the
 * control is simply absent for a USER — the same shape as every other
 * ADMIN-only affordance in this app (hidden here, refused at the BFF, refused
 * again at the service).
 */ 
var $2M70Q = parcelRequire("2M70Q");

/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $e6a0b4aa733f75fd$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551",
            key: "1miecu"
        }
    ]
];
const $e6a0b4aa733f75fd$export$2e2bcd8739ae039 = (0, $djixo.default)("paperclip", $e6a0b4aa733f75fd$export$3efd853dbb351e94);


var $6PxCH = parcelRequire("6PxCH");/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $8750d1d3edd41705$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 11v6",
            key: "nco0om"
        }
    ],
    [
        "path",
        {
            d: "M14 11v6",
            key: "outv1u"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6",
            key: "miytrc"
        }
    ],
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
            key: "e791ji"
        }
    ]
];
const $8750d1d3edd41705$export$2e2bcd8739ae039 = (0, $djixo.default)("trash-2", $8750d1d3edd41705$export$3efd853dbb351e94);


var $bi4P4 = parcelRequire("bi4P4");

var $3OyDL = parcelRequire("3OyDL");

/**
 * Form primitives shared by every screen that edits something.
 *
 * These started life in `settings/SettingsKit.web.jsx` when settings was the
 * only editing surface. Step 3 made contacts editable too, so they moved here
 * and SettingsKit re-exports them — one definition, and the settings screens
 * did not need touching.
 *
 * They live in the app rather than the design system because they encode
 * MeshHub's form conventions (RTL dialogs, server-error surfacing, Jalali date
 * entry), not generic visual primitives. `Button`, `Card`, `Spinner` and the
 * rest still come from `@meshhub/design-tokens/ui`.
 */ 
var $2M70Q = parcelRequire("2M70Q");

var $i5Xd5 = parcelRequire("i5Xd5");


var $68l1k = parcelRequire("68l1k");
var $1tMez = parcelRequire("1tMez");
var $eH742 = parcelRequire("eH742");
var $krsAQ = parcelRequire("krsAQ");

var $3OyDL = parcelRequire("3OyDL");

var $8B9Zg = parcelRequire("8B9Zg");


const $03dbd597abd3b4b7$var$FIELD_BASE = "h-control rounded border border-border bg-bg text-base outline-none focus:border-primary disabled:opacity-60";
const $03dbd597abd3b4b7$var$FIELD_CLASS = `${$03dbd597abd3b4b7$var$FIELD_BASE} px-4`;
/**
 * The same field, with room for an icon button inside it.
 *
 * The arithmetic is why this is a separate class rather than an extra utility
 * appended to the one above. The adornment starts at `space-2` and is `w-6`
 * wide, so it ends at `space-2 + space-6` — while `px-4` starts the text at
 * `space-4`, which is well inside that. The value was drawn straight through
 * the icon, which is exactly what a user reported. `space-7` is the first step
 * on the scale that clears it, and every term here is a token, so a deployment
 * that rescales its spacing keeps the relationship rather than reopening the
 * bug.
 *
 * Composed rather than layered (`px-4 pl-7`) so nothing depends on the order
 * Tailwind happens to emit `px-*` and `pl-*` in.
 */ const $03dbd597abd3b4b7$var$FIELD_CLASS_ADORNED = `${$03dbd597abd3b4b7$var$FIELD_BASE} pl-7 pr-4`;
/**
 * Label, hint and error for one control, wired by id rather than by wrapping.
 *
 * A wrapping `<label>` would make the hint part of the control's accessible
 * name — a screen reader would announce «یادداشت اولین تماس یادداشت به‌عنوان
 * اولین تعامل ثبت می‌شود» as the field's name. `htmlFor` plus
 * `aria-describedby` keeps the name short and the guidance separate, which is
 * what both a screen reader and a test expect.
 */ function $03dbd597abd3b4b7$var$useFieldIds(hasHint, hasError) {
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useId();
    return {
        id: id,
        describedBy: [
            hasHint && `${id}-hint`,
            hasError && `${id}-error`
        ].filter(Boolean).join(' ') || undefined,
        hintId: `${id}-hint`,
        errorId: `${id}-error`
    };
}
function $03dbd597abd3b4b7$var$FieldFrame({ label: label, hint: hint, error: error, ids: ids, className: className, children: children }) {
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: `flex flex-col gap-1 ${className ?? ''}`,
        children: [
            label && /*#__PURE__*/ (0, $2M70Q.jsx)("label", {
                htmlFor: ids.id,
                className: "text-sm text-text-muted",
                children: label
            }),
            children,
            hint && !error && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                id: ids.hintId,
                className: "text-xs text-text-muted",
                children: hint
            }),
            error && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                id: ids.errorId,
                role: "alert",
                className: "text-xs text-danger",
                children: error
            })
        ]
    });
}
function $03dbd597abd3b4b7$export$2cc85109a937009e({ open: open, onOpenChange: onOpenChange, title: title, message: message, confirmLabel: confirmLabel, onConfirm: onConfirm, danger: danger, children: children }) {
    return /*#__PURE__*/ (0, $2M70Q.jsx)($i5Xd5.Root, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ (0, $2M70Q.jsxs)($i5Xd5.Portal, {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)($i5Xd5.Overlay, {
                    className: "fixed inset-0 bg-text/30"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsxs)($i5Xd5.Content, {
                    dir: "rtl",
                    className: "fixed left-1/2 top-1/2 w-overlay -translate-x-1/2 -translate-y-1/2 rounded border border-border bg-surface p-6 shadow-overlay",
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)($i5Xd5.Title, {
                            className: "text-md font-bold",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)($i5Xd5.Description, {
                            className: "mt-3 text-base text-text-muted",
                            children: message
                        }),
                        children && /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                            className: "mt-4",
                            children: children
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                            className: "mt-6 flex justify-start gap-3",
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                    variant: danger ? 'danger' : 'primary',
                                    onClick: ()=>{
                                        onConfirm();
                                        onOpenChange(false);
                                    },
                                    children: confirmLabel ?? (0, $d916753b57975e04$export$25ce5a424b770e84).app.confirm
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                    onClick: ()=>onOpenChange(false),
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.cancel
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
/**
 * A modal form.
 *
 * `wide` picks the second of the design system's two overlay widths — a
 * composer with a dropzone and a long textarea needs more room than a confirm
 * dialog, and two named widths beat a per-screen guess.
 */ /**
 * How a field's own popover tells the dialog around it "Esc is mine".
 *
 * WHY A CONTEXT AND NOT A KEY HANDLER. Radix's dialog listens for Escape on
 * `document` in the CAPTURE phase, so nothing inside the dialog — a React
 * handler on a wrapper, a native listener on the popover — can ever run first
 * and stop it. The only two places that could are a `window` capture listener,
 * which the doctrine reserves for `lib/shortcuts.jsx` and `npm run lint`
 * enforces, and Radix's own `onEscapeKeyDown` hook. This is that hook.
 *
 * A COUNT rather than a boolean: two fields on one form can each have a
 * popover, and a boolean would be cleared by whichever closed first.
 *
 * The popover still closes itself — Radix's `preventDefault` stops the
 * dismiss, not the propagation, so the event still bubbles to the field's own
 * handler. What this stops is Escape throwing away a half-filled form because
 * somebody wanted to dismiss a calendar.
 */ const $03dbd597abd3b4b7$var$PopoverGuard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).createContext(null);
/** Hold the guard while `open`. Returns nothing; the effect is the point. */ function $03dbd597abd3b4b7$var$useEscapeGuard(open) {
    const guard = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useContext($03dbd597abd3b4b7$var$PopoverGuard);
    (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useEffect(()=>{
        if (!open || !guard) return undefined;
        guard.current += 1;
        return ()=>{
            guard.current -= 1;
        };
    }, [
        open,
        guard
    ]);
}
function $03dbd597abd3b4b7$export$ed8869c34b2bb205({ open: open, onOpenChange: onOpenChange, title: title, hint: hint, onSubmit: onSubmit, submitLabel: submitLabel, busy: busy, canSubmit: canSubmit = true, error: error, wide: wide, footer: footer, children: children }) {
    // How many field popovers inside this dialog are open right now.
    const openPopovers = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useRef(0);
    return /*#__PURE__*/ (0, $2M70Q.jsx)($i5Xd5.Root, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ (0, $2M70Q.jsxs)($i5Xd5.Portal, {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)($i5Xd5.Overlay, {
                    className: "fixed inset-0 bg-text/30"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)($i5Xd5.Content, {
                    dir: "rtl",
                    // The innermost overlay wins. With a date grid or a time list open,
                    // Escape dismisses THAT and the form survives.
                    onEscapeKeyDown: (event)=>{
                        if (openPopovers.current > 0) event.preventDefault();
                    },
                    className: `fixed left-1/2 top-1/2 max-h-[85vh] -translate-x-1/2 -translate-y-1/2
                      overflow-auto rounded border border-border bg-surface p-6 shadow-overlay
                      ${wide ? 'w-overlay-wide' : 'w-overlay'}`,
                    children: /*#__PURE__*/ (0, $2M70Q.jsxs)($03dbd597abd3b4b7$var$PopoverGuard.Provider, {
                        value: openPopovers,
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)($i5Xd5.Title, {
                                className: "text-md font-bold",
                                children: title
                            }),
                            hint ? /*#__PURE__*/ (0, $2M70Q.jsx)($i5Xd5.Description, {
                                className: "mt-1 text-sm text-text-muted",
                                children: hint
                            }) : // Radix warns when a dialog has no description; an empty one is
                            // the documented way to say "deliberately none".
                            /*#__PURE__*/ (0, $2M70Q.jsx)($i5Xd5.Description, {
                                className: "sr-only",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("form", {
                                className: "mt-5 flex flex-col gap-4",
                                onSubmit: (event)=>{
                                    event.preventDefault();
                                    onSubmit();
                                },
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)($03dbd597abd3b4b7$export$10c788363424e94e, {
                                        error: error
                                    }),
                                    children,
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                        className: "mt-2 flex items-center justify-start gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                                type: "submit",
                                                variant: "primary",
                                                disabled: busy || !canSubmit,
                                                children: busy ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {}) : submitLabel ?? (0, $d916753b57975e04$export$25ce5a424b770e84).app.save
                                            }),
                                            footer,
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                                type: "button",
                                                onClick: ()=>onOpenChange(false),
                                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.cancel
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
const $03dbd597abd3b4b7$export$2c73285ae9390cec = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).forwardRef(function TextField({ label: label, hint: hint, error: error, className: className, adornment: adornment, ...props }, ref) {
    const ids = $03dbd597abd3b4b7$var$useFieldIds(Boolean(hint), Boolean(error));
    const input = /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
        ref: ref,
        id: ids.id,
        "aria-describedby": ids.describedBy,
        "aria-invalid": error ? true : undefined,
        className: adornment ? `${$03dbd597abd3b4b7$var$FIELD_CLASS_ADORNED} w-full` : $03dbd597abd3b4b7$var$FIELD_CLASS,
        ...props
    });
    return /*#__PURE__*/ (0, $2M70Q.jsx)($03dbd597abd3b4b7$var$FieldFrame, {
        label: label,
        hint: hint,
        error: error,
        ids: ids,
        className: className,
        children: adornment ? // PHYSICAL left, not `start`: the fields that use this render their
        // value `dir="ltr"` inside an RTL page, so the text begins at the left
        // edge and that is the edge the icon has to keep clear of.
        /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
            className: "relative flex",
            children: [
                input,
                /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                    className: "absolute inset-y-0 left-2 flex items-center",
                    children: adornment
                })
            ]
        }) : input
    });
});
const $03dbd597abd3b4b7$export$f5c9f3c2c4054eec = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).forwardRef(function TextArea({ label: label, hint: hint, error: error, rows: rows = 4, className: className, ...props }, ref) {
    const ids = $03dbd597abd3b4b7$var$useFieldIds(Boolean(hint), Boolean(error));
    return /*#__PURE__*/ (0, $2M70Q.jsx)($03dbd597abd3b4b7$var$FieldFrame, {
        label: label,
        hint: hint,
        error: error,
        ids: ids,
        className: className,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)("textarea", {
            ref: ref,
            id: ids.id,
            rows: rows,
            "aria-describedby": ids.describedBy,
            "aria-invalid": error ? true : undefined,
            className: "rounded border border-border bg-bg px-4 py-2 text-base outline-none focus:border-primary disabled:opacity-60",
            ...props
        })
    });
});
function $03dbd597abd3b4b7$export$d55b50a564d0b931({ label: label, hint: hint, error: error, className: className, children: children, ...props }) {
    const ids = $03dbd597abd3b4b7$var$useFieldIds(Boolean(hint), Boolean(error));
    return /*#__PURE__*/ (0, $2M70Q.jsx)($03dbd597abd3b4b7$var$FieldFrame, {
        label: label,
        hint: hint,
        error: error,
        ids: ids,
        className: className,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)("select", {
            id: ids.id,
            "aria-describedby": ids.describedBy,
            "aria-invalid": error ? true : undefined,
            className: $03dbd597abd3b4b7$var$FIELD_CLASS,
            ...props,
            children: children
        })
    });
}
function $03dbd597abd3b4b7$export$94195a47b94ed396({ label: label, ...props }) {
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("label", {
        className: "flex items-center gap-2 text-base",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                type: "checkbox",
                className: "accent-primary",
                ...props
            }),
            label
        ]
    });
}
function $03dbd597abd3b4b7$export$ce0a41819d728248({ label: label, value: value, onChange: onChange, hint: hint, error: error, className: className, ...props }) {
    const [text, setText] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(()=>(0, $d4d460d3ffb6daab$export$aae69b02cbc5f8df)(value));
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(false);
    // Which month the grid is showing. Follows the value while there is one, so
    // reopening the picker lands where the date is rather than on today.
    const [month, setMonth] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(()=>value || (0, $d4d460d3ffb6daab$export$42f3f62cb506de78)());
    const lastEmitted = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useRef(value);
    const boxRef = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useRef(null);
    $03dbd597abd3b4b7$var$useEscapeGuard(open);
    // Re-sync when the value changes from outside (a form reset, a fresh
    // record) — but not on our own emissions, which would fight the typist.
    (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useEffect(()=>{
        if (value !== lastEmitted.current) {
            lastEmitted.current = value;
            setText((0, $d4d460d3ffb6daab$export$aae69b02cbc5f8df)(value));
            if (value) setMonth(value);
        }
    }, [
        value
    ]);
    // A click anywhere else closes the grid. `mousedown` rather than `click`, so
    // the grid is gone before the thing underneath it reacts.
    (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useEffect(()=>{
        if (!open) return undefined;
        const away = (event)=>{
            if (!boxRef.current?.contains(event.target)) setOpen(false);
        };
        document.addEventListener('mousedown', away);
        return ()=>document.removeEventListener('mousedown', away);
    }, [
        open
    ]);
    const emit = (iso)=>{
        lastEmitted.current = iso;
        setText((0, $d4d460d3ffb6daab$export$aae69b02cbc5f8df)(iso));
        onChange(iso);
    };
    const handleTyping = (raw)=>{
        setText(raw);
        const iso = (0, $d4d460d3ffb6daab$export$b0a6e191e6afdfa)(raw);
        // An empty box clears the date; a half-typed one emits nothing, so the
        // form does not see «۱۴۰» as a date.
        if (raw.trim() === '' || iso) {
            lastEmitted.current = iso;
            if (iso) setMonth(iso);
            onChange(iso);
        }
    };
    const invalid = text.trim() !== '' && (0, $d4d460d3ffb6daab$export$b0a6e191e6afdfa)(text) === null;
    return(// Esc closes the grid without closing the DIALOG this field sits in — the
    // innermost overlay wins, which is the rule the shortcut registry already
    // keeps for dialogs over screens.
    //
    // The handler is on the WRAPPER, not on the input. Once somebody clicks a
    // day the focus is on that BUTTON, so an input-only handler never saw the
    // key and Radix closed the whole activity dialog underneath — losing a
    // half-filled form to the key people press to dismiss a popover.
    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        ref: boxRef,
        className: `relative flex flex-col ${className ?? ''}`,
        onKeyDown: (event)=>{
            if (event.key === 'Escape' && open) {
                event.stopPropagation();
                setOpen(false);
            }
        },
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)($03dbd597abd3b4b7$export$2c73285ae9390cec, {
                label: label,
                value: text,
                onChange: (event)=>handleTyping(event.target.value),
                onFocus: ()=>setOpen(true),
                placeholder: (0, $d4d460d3ffb6daab$export$e9cf274fc1035ec4)('1405/01/01'),
                inputMode: "numeric",
                dir: "ltr",
                autoComplete: "off",
                hint: hint,
                error: error ?? (invalid ? (0, $d916753b57975e04$export$25ce5a424b770e84).interaction.invalidDate : null),
                adornment: /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                    type: "button",
                    className: "flex h-6 w-6 items-center justify-center rounded text-text-muted hover:text-text",
                    "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).app.pickDate,
                    "aria-expanded": open,
                    title: (0, $d916753b57975e04$export$25ce5a424b770e84).app.pickDate,
                    onClick: ()=>setOpen((v)=>!v),
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $68l1k.default), {
                        size: 15,
                        "aria-hidden": "true"
                    })
                }),
                ...props
            }),
            open && /*#__PURE__*/ (0, $2M70Q.jsx)($03dbd597abd3b4b7$var$JalaliMonthGrid, {
                month: month,
                selected: value,
                onMonth: setMonth,
                onPick: (iso)=>{
                    emit(iso);
                    setOpen(false);
                }
            })
        ]
    }));
}
function $03dbd597abd3b4b7$export$311766d331443d38({ value: value, onPick: onPick, label: label, className: className, children: children }) {
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(false);
    const [month, setMonth] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(()=>value || (0, $d4d460d3ffb6daab$export$42f3f62cb506de78)());
    const boxRef = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useRef(null);
    $03dbd597abd3b4b7$var$useEscapeGuard(open);
    // Follow the caller: stepping the calendar a week at a time and then opening
    // the grid must land on the week being looked at, not on the month it was
    // last opened in.
    (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useEffect(()=>{
        if (value) setMonth(value);
    }, [
        value
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useEffect(()=>{
        if (!open) return undefined;
        const away = (event)=>{
            if (!boxRef.current?.contains(event.target)) setOpen(false);
        };
        document.addEventListener('mousedown', away);
        return ()=>document.removeEventListener('mousedown', away);
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        ref: boxRef,
        className: `relative ${className ?? ''}`,
        onKeyDown: (event)=>{
            if (event.key === 'Escape' && open) {
                event.stopPropagation();
                setOpen(false);
            }
        },
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("button", {
                type: "button",
                className: "flex items-center gap-2 rounded px-2 py-1 hover:bg-surface-hover",
                "aria-label": label,
                "aria-expanded": open,
                title: label,
                onClick: ()=>setOpen((v)=>!v),
                children: [
                    children,
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $68l1k.default), {
                        size: 14,
                        className: "text-text-muted",
                        "aria-hidden": "true"
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $2M70Q.jsx)($03dbd597abd3b4b7$var$JalaliMonthGrid, {
                month: month,
                selected: value,
                onMonth: setMonth,
                onPick: (iso)=>{
                    onPick(iso);
                    setOpen(false);
                }
            })
        ]
    });
}
/** The popover itself. Split out only so `JalaliDateField` stays readable. */ function $03dbd597abd3b4b7$var$JalaliMonthGrid({ month: month, selected: selected, onMonth: onMonth, onPick: onPick }) {
    const weeks = (0, $d4d460d3ffb6daab$export$5960e8f7b4114e63)(month);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        role: "dialog",
        "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).app.pickDate,
        className: "absolute top-full z-20 mt-1 w-64 rounded border border-border bg-surface p-3 shadow-overlay",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "mb-2 flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                        type: "button",
                        "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).app.nextMonth,
                        className: "rounded px-1 text-text-muted hover:text-text",
                        onClick: ()=>onMonth((0, $d4d460d3ffb6daab$export$2d14dc66f38a5d5f)(month, 1)),
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1tMez.default), {
                            size: 16,
                            "aria-hidden": "true"
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-sm font-medium",
                        children: (0, $d4d460d3ffb6daab$export$3d9a2d9d5742b9a)(month)
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                        type: "button",
                        "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).app.previousMonth,
                        className: "rounded px-1 text-text-muted hover:text-text",
                        onClick: ()=>onMonth((0, $d4d460d3ffb6daab$export$2d14dc66f38a5d5f)(month, -1)),
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $eH742.default), {
                            size: 16,
                            "aria-hidden": "true"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "grid grid-cols-7 gap-0.5 text-center",
                children: [
                    (0, $d4d460d3ffb6daab$export$54a58e9738ad4e5d).map((initial, index)=>/*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                            className: "py-1 text-xs text-text-muted",
                            "aria-hidden": "true",
                            children: initial
                        }, initial + index)),
                    weeks.flat().map((cell)=>{
                        const isSelected = cell.iso === selected;
                        return /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                            type: "button",
                            onClick: ()=>onPick(cell.iso),
                            "aria-current": cell.isToday ? 'date' : undefined,
                            "aria-pressed": isSelected,
                            // The GREGORIAN date on hover — the same pairing the calendar
                            // header shows, for the same reason.
                            title: `${(0, $d4d460d3ffb6daab$export$e9cf274fc1035ec4)((0, $d4d460d3ffb6daab$export$aae69b02cbc5f8df)(cell.iso))} \u{2014} ${(0, $d4d460d3ffb6daab$export$59226c665b47d8a8)(cell.iso)}`,
                            className: [
                                'rounded py-1 text-sm',
                                isSelected ? 'bg-primary text-text-inverse' : cell.inMonth ? 'text-text hover:bg-surface-hover' : 'text-text-muted hover:bg-surface-hover',
                                cell.isToday && !isSelected ? 'border border-primary' : '',
                                cell.isWeekend && !isSelected ? 'text-danger' : ''
                            ].join(' '),
                            children: cell.label
                        }, cell.iso);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                type: "button",
                className: "mt-2 w-full rounded py-1 text-xs text-primary hover:bg-surface-hover",
                onClick: ()=>onPick((0, $d4d460d3ffb6daab$export$42f3f62cb506de78)()),
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.today
            })
        ]
    });
}
function $03dbd597abd3b4b7$export$5eaee2322dd727eb({ label: label, value: value, onChange: onChange, hint: hint, error: error, className: className, minuteStep: minuteStep = 5, ...props }) {
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useState(false);
    const boxRef = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useRef(null);
    $03dbd597abd3b4b7$var$useEscapeGuard(open);
    (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useEffect(()=>{
        if (!open) return undefined;
        const away = (event)=>{
            if (!boxRef.current?.contains(event.target)) setOpen(false);
        };
        document.addEventListener('mousedown', away);
        return ()=>document.removeEventListener('mousedown', away);
    }, [
        open
    ]);
    // Persian digits are accepted and folded at the edge, exactly as they are in
    // the phone and date fields — a Persian keyboard is what is already open.
    const handleTyping = (raw)=>onChange((0, $d4d460d3ffb6daab$export$365a38b4fc2bed91)(raw));
    const [hour, minute] = /^(\d{1,2}):(\d{2})$/.exec(value ?? '')?.slice(1) ?? [];
    const setPart = (h, m)=>onChange(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`);
    const hours = Array.from({
        length: 24
    }, (_, i)=>i);
    const minutes = Array.from({
        length: Math.ceil(60 / minuteStep)
    }, (_, i)=>i * minuteStep);
    return(// Same wrapper-level Esc as the date field, for the same reason: after a
    // pick the focus is on a button inside the popover.
    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        ref: boxRef,
        className: `relative flex flex-col ${className ?? ''}`,
        onKeyDown: (event)=>{
            if (event.key === 'Escape' && open) {
                event.stopPropagation();
                setOpen(false);
            }
        },
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)($03dbd597abd3b4b7$export$2c73285ae9390cec, {
                label: label,
                value: value ?? '',
                onChange: (event)=>handleTyping(event.target.value),
                onFocus: ()=>setOpen(true),
                placeholder: "09:00",
                inputMode: "numeric",
                dir: "ltr",
                autoComplete: "off",
                hint: hint,
                error: error,
                adornment: /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                    type: "button",
                    className: "flex h-6 w-6 items-center justify-center rounded text-text-muted hover:text-text",
                    "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).app.pickTime,
                    "aria-expanded": open,
                    title: (0, $d916753b57975e04$export$25ce5a424b770e84).app.pickTime,
                    onClick: ()=>setOpen((v)=>!v),
                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $krsAQ.default), {
                        size: 15,
                        "aria-hidden": "true"
                    })
                }),
                ...props
            }),
            open && /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                role: "dialog",
                "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).app.pickTime,
                className: "absolute top-full z-20 mt-1 flex gap-2 rounded border border-border bg-surface p-2 shadow-overlay",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)($03dbd597abd3b4b7$var$TimeColumn, {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).app.hour,
                        values: hours,
                        current: hour === undefined ? null : Number(hour),
                        onPick: (h)=>setPart(h, minute ?? 0)
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)($03dbd597abd3b4b7$var$TimeColumn, {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).app.minute,
                        values: minutes,
                        current: minute === undefined ? null : Number(minute),
                        onPick: (m)=>setPart(hour ?? 9, m)
                    })
                ]
            })
        ]
    }));
}
/** One scrolling column of the time picker. */ function $03dbd597abd3b4b7$var$TimeColumn({ label: label, values: values, current: current, onPick: onPick }) {
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                className: "pb-1 text-center text-xs text-text-muted",
                children: label
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: "h-40 w-14 overflow-y-auto",
                children: values.map((v)=>/*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                        type: "button",
                        onClick: ()=>onPick(v),
                        className: `block w-full rounded py-1 text-center text-sm tabular-nums ${v === current ? 'bg-primary text-text-inverse' : 'text-text hover:bg-surface-hover'}`,
                        children: (0, $d4d460d3ffb6daab$export$e9cf274fc1035ec4)(String(v).padStart(2, '0'))
                    }, v))
            })
        ]
    });
}
function $03dbd597abd3b4b7$export$10c788363424e94e({ error: error }) {
    if (!error) return null;
    const duplicate = error.graphQLErrors?.[0]?.extensions;
    if (duplicate?.code === 'DUPLICATE_PHONE') return /*#__PURE__*/ (0, $2M70Q.jsx)($03dbd597abd3b4b7$var$DuplicatePhoneError, {
        ...duplicate
    });
    const message = error.graphQLErrors?.[0]?.message ?? error.message ?? (0, $d916753b57975e04$export$25ce5a424b770e84).app.unknownError;
    return /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
        role: "alert",
        className: "rounded border border-danger px-4 py-2 text-base text-danger",
        children: message
    });
}
/**
 * The CRM refused a number a live contact already holds. Every form that
 * writes a number renders its errors here — quick-add on desktop and phone,
 * the profile's phones panel — so one branch covers all of them. The link is
 * the point: at a congress the useful answer to «duplicate» is «open the one
 * we already have», not «try again».
 */ function $03dbd597abd3b4b7$var$DuplicatePhoneError({ contactId: contactId, contactName: contactName, number: number, sameContact: sameContact }) {
    // An LTR isolate (U+2066 … U+2069), or the «+» of «+۹۸۹۱۲…» lands on the
    // wrong end of the number inside a right-to-left sentence.
    const shown = `\u2066${(0, $d4d460d3ffb6daab$export$10c09b2cff9813eb)(number)}\u2069`;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
        role: "alert",
        className: "rounded border border-danger px-4 py-2 text-base text-danger",
        children: [
            sameContact ? (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.duplicatePhoneSameContact(shown) : (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.duplicatePhone(shown, contactName),
            !sameContact && contactId && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                children: [
                    ' ',
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8B9Zg.Link), {
                        to: `/contacts/${contactId}`,
                        className: "font-medium text-primary underline",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.openExistingContact
                    })
                ]
            })
        ]
    });
}
function $03dbd597abd3b4b7$export$4b2346c6725d60cc({ loading: loading, empty: empty, emptyTitle: emptyTitle, emptyHint: emptyHint }) {
    if (loading) return /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
        className: "flex justify-center p-7",
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {})
    });
    if (empty) return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$fddf379e22a74b00), {
        title: emptyTitle ?? (0, $d916753b57975e04$export$25ce5a424b770e84).app.notFound,
        hint: emptyHint
    });
    return null;
}




/**
 * Attachment uploads and downloads.
 *
 * Not GraphQL, and not a proxy either. The BFF hands out presigned URLs and
 * the browser talks to object storage directly:
 *
 *   1. POST /files/initiate   -> { uploadUrl, requiredHeaders, attachment }
 *   2. PUT  uploadUrl         -> the bytes, straight to storage
 *   3. POST /files/complete   -> the attachment becomes visible
 *
 * Step 2 is a plain XMLHttpRequest rather than fetch, for one reason: fetch
 * still cannot report upload progress. A sales rep on a congress-hall
 * connection uploading a 5 MB photo needs a progress bar, and `xhr.upload`
 * is the only browser API that provides one.
 *
 * If the user abandons the flow between 1 and 3, the reservation stays PENDING
 * and invisible; `discardUpload` cleans it up when they remove the file
 * deliberately, and the service's cleanup job catches the rest.
 */ 

const $d305624b55b31f43$var$BASE = (0, $b5d41e4dbaeacaa2$export$4dc6837bb3c0882f);
class $d305624b55b31f43$export$7511510da883ea99 extends Error {
    constructor(message, code){
        super(message);
        this.name = 'FileError';
        this.code = code ?? 'INTERNAL_SERVER_ERROR';
    }
}
async function $d305624b55b31f43$var$callBff(path, { method: method = 'GET', body: body } = {}) {
    const token = (0, $f0578ea5f18e5637$export$84773cc9bf7dbe87)();
    const response = await fetch(`${$d305624b55b31f43$var$BASE}${path}`, {
        method: method,
        headers: {
            ...body ? {
                'content-type': 'application/json'
            } : {},
            ...token ? {
                authorization: `Bearer ${token}`
            } : {}
        },
        body: body ? JSON.stringify(body) : undefined
    });
    const payload = await response.json().catch(()=>null);
    if (!response.ok) throw new $d305624b55b31f43$export$7511510da883ea99(payload?.error?.message ?? `request failed (${response.status})`, payload?.error?.code);
    return payload;
}
/** PUT the bytes to storage, reporting progress. Resolves when storage accepts. */ function $d305624b55b31f43$var$putToStorage(url, headers, file, onProgress, signal) {
    return new Promise((resolve, reject)=>{
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', url);
        for (const [name, value] of Object.entries(headers ?? {}))xhr.setRequestHeader(name, value);
        xhr.upload.addEventListener('progress', (event)=>{
            if (event.lengthComputable) onProgress?.(event.loaded / event.total);
        });
        xhr.addEventListener('load', ()=>xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new $d305624b55b31f43$export$7511510da883ea99(`storage rejected the upload (${xhr.status})`, 'UPLOAD_FAILED')));
        xhr.addEventListener('error', ()=>reject(new $d305624b55b31f43$export$7511510da883ea99('could not reach object storage', 'UPLOAD_FAILED')));
        xhr.addEventListener('abort', ()=>reject(new $d305624b55b31f43$export$7511510da883ea99('upload cancelled', 'UPLOAD_CANCELLED')));
        signal?.addEventListener('abort', ()=>xhr.abort(), {
            once: true
        });
        xhr.send(file);
    });
}
async function $d305624b55b31f43$export$a5575dbeeffdad98({ file: file, ownerType: ownerType, ownerId: ownerId, onProgress: onProgress, signal: signal }) {
    const initiated = await $d305624b55b31f43$var$callBff('/files/initiate', {
        method: 'POST',
        body: {
            ownerType: ownerType,
            ownerId: ownerId,
            fileName: file.name,
            mimeType: file.type || 'application/octet-stream',
            sizeBytes: file.size
        }
    });
    try {
        await $d305624b55b31f43$var$putToStorage(initiated.uploadUrl, initiated.requiredHeaders, file, onProgress, signal);
    } catch (err) {
        // The reservation is useless now; drop it so it does not sit in the
        // cleanup job's report. Best effort — the row is invisible either way.
        await $d305624b55b31f43$export$90653d7df52e8e82(initiated.attachment.id).catch(()=>{});
        throw err;
    }
    const completed = await $d305624b55b31f43$var$callBff('/files/complete', {
        method: 'POST',
        body: {
            attachmentId: initiated.attachment.id
        }
    });
    return completed.attachment;
}
function $d305624b55b31f43$export$90653d7df52e8e82(attachmentId) {
    return $d305624b55b31f43$var$callBff('/files/discard', {
        method: 'POST',
        body: {
            attachmentId: attachmentId
        }
    });
}
async function $d305624b55b31f43$export$7097499bf5735f0a(attachmentId) {
    const response = await $d305624b55b31f43$var$callBff(`/files/${attachmentId}/url`);
    return response.url;
}
async function $d305624b55b31f43$export$70cccf46c7504cdc(attachmentId) {
    const url = await $d305624b55b31f43$export$7097499bf5735f0a(attachmentId);
    window.open(url, '_blank', 'noopener,noreferrer');
}




/**
 * An activity's checklists.
 *
 * The note it carries is not decoration: a checklist made from a template is a
 * COPY. Editing the template afterwards does not rewrite work already under
 * way, and a rep half through an installation should be able to see that
 * promise rather than discover it.
 */ 
var $2M70Q = parcelRequire("2M70Q");

/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $74429f95599e26c6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M13 5h8",
            key: "a7qcls"
        }
    ],
    [
        "path",
        {
            d: "M13 12h8",
            key: "h98zly"
        }
    ],
    [
        "path",
        {
            d: "M13 19h8",
            key: "c3s6r1"
        }
    ],
    [
        "path",
        {
            d: "m3 17 2 2 4-4",
            key: "1jhpwq"
        }
    ],
    [
        "path",
        {
            d: "m3 7 2 2 4-4",
            key: "1obspn"
        }
    ]
];
const $74429f95599e26c6$export$2e2bcd8739ae039 = (0, $djixo.default)("list-checks", $74429f95599e26c6$export$3efd853dbb351e94);


var $6PxCH = parcelRequire("6PxCH");

var $3OyDL = parcelRequire("3OyDL");




function $52d5b714f6b851c0$export$7658b7b3805eab9a({ activityId: activityId }) {
    const [templateId, setTemplateId] = (0, $3OyDL.useState)('');
    const [newItem, setNewItem] = (0, $3OyDL.useState)({});
    const { data: data, refetch: refetch } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$48bc793f71228ca6), {
        variables: {
            ownerType: 'ACTIVITY',
            ownerId: activityId
        },
        skip: !activityId
    });
    const { data: templateData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$68d6e722992ca7ca));
    const [createChecklist] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$fbd174fc100d5ca5), {
        onCompleted: ()=>refetch()
    });
    const [toggleItem] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$196a6e805067bdb6));
    const [addItem] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$1d1a45c6fc413210), {
        onCompleted: ()=>refetch()
    });
    const checklists = data?.checklists ?? [];
    const templates = templateData?.checklistTemplates ?? [];
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("section", {
        className: "flex flex-col gap-3 rounded border border-border p-3",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("h3", {
                className: "flex items-center gap-2 text-sm font-medium",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $74429f95599e26c6$export$2e2bcd8739ae039), {
                        size: 15,
                        "aria-hidden": "true"
                    }),
                    (0, $d916753b57975e04$export$25ce5a424b770e84).activity.checklists
                ]
            }),
            checklists.map((checklist)=>{
                const done = checklist.items.filter((item)=>item.isDone).length;
                return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                    className: "flex flex-col gap-1",
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                    className: "text-sm font-medium",
                                    children: checklist.title
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                    className: "text-xs text-text-muted",
                                    dir: "ltr",
                                    children: [
                                        done,
                                        "/",
                                        checklist.items.length
                                    ]
                                })
                            ]
                        }),
                        checklist.items.map((item)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$94195a47b94ed396), {
                                label: item.title,
                                checked: item.isDone,
                                onChange: (event)=>toggleItem({
                                        variables: {
                                            itemId: item.id,
                                            isDone: event.target.checked
                                        }
                                    })
                            }, item.id)),
                        /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                            className: "flex items-end gap-2",
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                                    label: (0, $d916753b57975e04$export$25ce5a424b770e84).checklists.itemTitle,
                                    value: newItem[checklist.id] ?? '',
                                    onChange: (event)=>setNewItem((current)=>({
                                                ...current,
                                                [checklist.id]: event.target.value
                                            }))
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                    type: "button",
                                    disabled: !(newItem[checklist.id] ?? '').trim(),
                                    onClick: async ()=>{
                                        await addItem({
                                            variables: {
                                                checklistId: checklist.id,
                                                title: newItem[checklist.id].trim()
                                            }
                                        });
                                        setNewItem((current)=>({
                                                ...current,
                                                [checklist.id]: ''
                                            }));
                                    },
                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                                        size: 14,
                                        "aria-hidden": "true"
                                    })
                                })
                            ]
                        })
                    ]
                }, checklist.id);
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex items-end gap-2",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.fromTemplate,
                        value: templateId,
                        onChange: (event)=>setTemplateId(event.target.value),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                value: "",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.blankChecklist
                            }),
                            templates.map((template)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                    value: template.id,
                                    children: template.title
                                }, template.id))
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        type: "button",
                        onClick: ()=>createChecklist({
                                variables: {
                                    ownerType: 'ACTIVITY',
                                    ownerId: activityId,
                                    templateId: templateId || null,
                                    title: templateId ? null : (0, $d916753b57975e04$export$25ce5a424b770e84).activity.checklists
                                }
                            }),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                                size: 14,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).activity.addChecklist
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-xs text-text-muted",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).checklists.copyNote
            })
        ]
    });
}


/**
 * A vocabulary picker that can FILL ITSELF.
 *
 * The bug this exists for: a fresh deployment's `ACTIVITY_TYPE` vocabulary is
 * empty, so «نوع فعالیت» on the calendar offered nothing, and there was no
 * screen anywhere in the app that could add one — the only ways in were a seed
 * script with database access or a hand-written GraphQL mutation. A required
 * field with no reachable values is a dead end, not a form.
 *
 * The rules it keeps:
 *
 * - **An empty vocabulary opens the creator by itself.** Somebody who came here
 *   to book a meeting should not have to work out that the «+» is what unblocks
 *   them; the input is already there with the cursor in it.
 * - **One field: the label.** The `code` is derived (`lib/lookupCode.js`) and
 *   shown, not asked for. It is immutable after creation and the settings
 *   screens exist for anyone who cares which one they get.
 * - **The control is absent for a role that cannot use it.** Creating a
 *   vocabulary row is ADMIN at the BFF and again at the service, so a USER gets
 *   a sentence naming what to ask for instead of a button that returns
 *   «دسترسی ندارید» (CLAUDE.md §12 — a control that cannot help is its own kind
 *   of lie).
 * - **The new row is SELECTED, not merely created.** The mutation resolves
 *   after its refetch, so the option exists by the time the value points at it.
 *
 * Product-neutrality (CLAUDE.md §1): nothing here names a vocabulary or a
 * value. The caller supplies the options, the mutation and a code prefix.
 */ 
var $2M70Q = parcelRequire("2M70Q");


var $6PxCH = parcelRequire("6PxCH");
var $bi4P4 = parcelRequire("bi4P4");

var $3OyDL = parcelRequire("3OyDL");

/**
 * A lookup CODE derived from the label a person typed.
 *
 * Every vocabulary row needs a `code` matching `^[A-Z][A-Z0-9_]{1,63}$` — the
 * same regex in the CRM, scheduling and feedback services — and it is
 * IMMUTABLE after creation. That is a fine thing to ask an administrator for on
 * a settings screen, and a terrible thing to ask a rep who opened the calendar
 * to book a meeting and found the type picker empty. So the inline creator asks
 * for the half a human reads (the Persian label) and derives the other half.
 *
 * This mirrors `domain/import_service.py::source_code` in the CRM, which faces
 * the identical problem with congress names from a spreadsheet: «کنگره قلب
 * ۱۴۰۵» has no ASCII letters at all and cannot produce a code, so a non-Latin
 * label gets a transliteration-free fallback and keeps its original text as the
 * LABEL. Transliterating Persian into ASCII would invent a spelling nobody
 * chose and two people would spell the same congress differently.
 *
 * The hash is FNV-1a, not `Math.random()` or a timestamp: the same label must
 * derive the same code every time, so two people adding «جلسه حضوری» minutes
 * apart collide on the server's unique index and the second one is told the
 * type already exists — rather than quietly producing a second row that means
 * exactly the same thing. (The CRM importer reaches for `hashlib` over Python's
 * salted builtin `hash()` for this same reason; CLAUDE.md §15.)
 */ /** FNV-1a over the string's code points, as 8 uppercase hex digits. */ function $07ca0f97a2bd5399$var$stableHash(text) {
    let hash = 0x811c9dc5;
    for (const char of text){
        hash ^= char.codePointAt(0);
        // The classic FNV prime, multiplied in 32-bit space via Math.imul.
        hash = Math.imul(hash, 0x01000193) >>> 0;
    }
    return hash.toString(16).toUpperCase().padStart(8, '0');
}
function $07ca0f97a2bd5399$export$ee36c3544963506c(label, prefix = 'CUSTOM') {
    const text = (label ?? '').trim();
    if (!text) return '';
    const ascii = text.normalize('NFKD').replace(/[^A-Za-z0-9]+/g, '_').replace(/^_+|_+$/g, '').toUpperCase();
    // `A` alone is a valid identifier but not a valid code: the regex demands at
    // least two characters.
    if (/^[A-Z]/.test(ascii) && ascii.length >= 2) return ascii.slice(0, 64);
    if (ascii) return `${prefix}_${ascii}`.slice(0, 64);
    return `${prefix}_${$07ca0f97a2bd5399$var$stableHash(text)}`;
}



function $4436e89d3ef1c462$export$bc36ad93e482d2f8({ label: label, value: value, onChange: onChange, options: options = [], loading: loading = false, includeNone: includeNone = false, noneLabel: noneLabel = (0, $d916753b57975e04$export$25ce5a424b770e84).app.none, required: required = false, hint: hint, canCreate: canCreate = false, codePrefix: codePrefix = 'CUSTOM', onCreate: onCreate, creating: creating = false, createError: createError }) {
    const empty = options.length === 0;
    const [adding, setAdding] = (0, $3OyDL.useState)(false);
    const [draft, setDraft] = (0, $3OyDL.useState)('');
    const inputRef = (0, $3OyDL.useRef)(null);
    // An empty REQUIRED vocabulary is the whole reason this component exists:
    // open the creator rather than making the user find it. Only while it IS
    // empty — reopening it after the first row is added would fight a typist.
    //
    // REQUIRED IS THE CONDITION, and it was missing. The creator focuses its own
    // input, so an OPTIONAL empty picker stole the cursor from whatever the user
    // was actually typing — on quick-add, «محصول مورد علاقه» with no products
    // seeded grabbed focus away from the surname, which is the one field that
    // form exists to capture. A required picker with nothing in it is a dead end
    // worth interrupting for; an optional one is not, and it still shows the
    // empty notice and the «گزینه تازه» button.
    (0, $3OyDL.useEffect)(()=>{
        if (required && empty && canCreate && !loading) setAdding(true);
    }, [
        required,
        empty,
        canCreate,
        loading
    ]);
    (0, $3OyDL.useEffect)(()=>{
        if (adding) inputRef.current?.focus();
    }, [
        adding
    ]);
    const code = (0, $07ca0f97a2bd5399$export$ee36c3544963506c)(draft, codePrefix);
    const canSubmit = Boolean(draft.trim()) && !creating;
    async function submit() {
        if (!canSubmit) return;
        const created = await onCreate({
            labelFa: draft.trim(),
            code: code
        });
        const id = typeof created === 'string' ? created : created?.id;
        if (!id) return;
        onChange(id);
        setDraft('');
        setAdding(false);
    }
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex items-end gap-2",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                        label: label,
                        hint: hint,
                        value: value ?? '',
                        required: required,
                        className: "flex-1",
                        onChange: (event)=>onChange(event.target.value),
                        children: [
                            (includeNone || empty) && /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                value: "",
                                children: empty ? (0, $d916753b57975e04$export$25ce5a424b770e84).vocabulary.none : noneLabel
                            }),
                            options.map((option)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                    value: option.id,
                                    children: option.labelFa
                                }, option.id))
                        ]
                    }),
                    canCreate && !adding && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        type: "button",
                        variant: "ghost",
                        className: "mb-1 gap-1",
                        title: (0, $d916753b57975e04$export$25ce5a424b770e84).vocabulary.addNew,
                        onClick: ()=>setAdding(true),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                                size: 15,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).vocabulary.addNewShort
                        ]
                    })
                ]
            }),
            adding && /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex flex-col gap-2 rounded border border-border bg-surface p-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "flex items-end gap-2",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                                ref: inputRef,
                                className: "flex-1",
                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).vocabulary.newLabel,
                                hint: draft.trim() ? (0, $d916753b57975e04$export$25ce5a424b770e84).vocabulary.codeIs(code) : (0, $d916753b57975e04$export$25ce5a424b770e84).vocabulary.newHint,
                                value: draft,
                                onChange: (event)=>setDraft(event.target.value),
                                // Enter here means "add this option", NOT "submit the activity" —
                                // the surrounding FormDialog is a <form>, so without this the key
                                // that most obviously finishes this little input would save a
                                // half-filled activity instead.
                                onKeyDown: (event)=>{
                                    if (event.key !== 'Enter') return;
                                    event.preventDefault();
                                    submit();
                                }
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                type: "button",
                                variant: "primary",
                                className: "mb-1",
                                disabled: !canSubmit,
                                onClick: submit,
                                children: creating ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.saving : (0, $d916753b57975e04$export$25ce5a424b770e84).app.add
                            }),
                            !empty && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                type: "button",
                                variant: "ghost",
                                className: "mb-1",
                                title: (0, $d916753b57975e04$export$25ce5a424b770e84).app.cancel,
                                "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).app.cancel,
                                onClick: ()=>{
                                    setDraft('');
                                    setAdding(false);
                                },
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $bi4P4.default), {
                                    size: 15,
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                        error: createError
                    })
                ]
            }),
            empty && !canCreate && !loading && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-xs text-text-muted",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).vocabulary.emptyUser
            })
        ]
    });
}


/** Reminder offsets a person actually picks, in minutes before the start. */ const $a337acc1647f440c$var$OFFSETS = [
    10,
    30,
    60,
    1440
];
/**
 * How many contacts the picker lists before search is the only way through.
 *
 * Matches the affiliation and referrer pickers, which have always used 25. It
 * was 10 here, and a plain `<select>` gives no hint that a page even exists —
 * so five of fifteen contacts were simply unreachable.
 */ const $a337acc1647f440c$var$CONTACT_PICKER_SIZE = 25;
const $a337acc1647f440c$var$emptyForm = (seed = {})=>({
        typeId: '',
        title: '',
        contactId: '',
        description: '',
        allDay: false,
        date: '',
        startTime: '09:00',
        endTime: '10:00',
        // Who is responsible for DOING this. Empty means the caller, which is what
        // the scheduling service reads an empty `assigned_to` as — so a USER, who
        // may not assign to anybody else, sends nothing and gets themselves.
        //
        // It used to be absent from this object entirely while a text box on the
        // form bound to `form.assignedTo`, so the box wrote to a key nothing read
        // and `submit()` never sent it. Typing in it did nothing at all.
        assignedTo: '',
        reminders: [],
        ...seed
    });
/** An activity (or a drag range, or a suggestion prefill) -> form state. */ function $a337acc1647f440c$var$toForm(activity, prefill) {
    if (activity) {
        const start = (0, $d4d460d3ffb6daab$export$a32865ea4a905df9)(activity.startsAt);
        const end = activity.endsAt ? (0, $d4d460d3ffb6daab$export$a32865ea4a905df9)(activity.endsAt) : null;
        return $a337acc1647f440c$var$emptyForm({
            typeId: activity.type?.id ?? '',
            title: activity.title ?? '',
            contactId: activity.contactId ?? '',
            description: activity.description ?? '',
            allDay: activity.allDay ?? false,
            assignedTo: activity.assignedTo ?? '',
            date: start.date,
            startTime: start.time,
            endTime: end?.time ?? '',
            reminders: (activity.reminders ?? []).filter((r)=>!r.firedAt).map((r)=>({
                    offset: Math.round((new Date(activity.startsAt) - new Date(r.remindAt)) / 60000),
                    channel: r.channel
                }))
        });
    }
    if (prefill?.startsAt) {
        const start = (0, $d4d460d3ffb6daab$export$a32865ea4a905df9)(prefill.startsAt.toISOString?.() ?? prefill.startsAt);
        const end = prefill.endsAt ? (0, $d4d460d3ffb6daab$export$a32865ea4a905df9)(prefill.endsAt.toISOString?.() ?? prefill.endsAt) : null;
        return $a337acc1647f440c$var$emptyForm({
            date: start.date,
            startTime: start.time,
            endTime: end?.time ?? '',
            contactId: prefill.contactId ?? '',
            title: prefill.title ?? '',
            typeId: prefill.typeId ?? ''
        });
    }
    return $a337acc1647f440c$var$emptyForm(prefill ?? {});
}
function $a337acc1647f440c$export$29a29aaae5ee2157({ open: open, onOpenChange: onOpenChange, activity: activity, prefill: prefill, onSaved: onSaved, onCreate: onCreate }) {
    const { isAdmin: isAdmin, me: me } = (0, $00d5d84dffcdf8d5$export$ad0a340bf97d63d5)();
    const [form, setForm] = (0, $3OyDL.useState)(()=>$a337acc1647f440c$var$toForm(activity, prefill));
    const [resultNote, setResultNote] = (0, $3OyDL.useState)('');
    const [reopenReason, setReopenReason] = (0, $3OyDL.useState)('');
    const [showResult, setShowResult] = (0, $3OyDL.useState)(false);
    const [showReopen, setShowReopen] = (0, $3OyDL.useState)(false);
    const [confirmDelete, setConfirmDelete] = (0, $3OyDL.useState)(false);
    const [contactSearch, setContactSearch] = (0, $3OyDL.useState)('');
    // Files chosen but not yet uploaded. Same shape and same flow as the
    // interaction composer's, because it is the same three-step protocol.
    const [files, setFiles] = (0, $3OyDL.useState)([]);
    const [uploadError, setUploadError] = (0, $3OyDL.useState)(null);
    const fileInputRef = (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useRef(null);
    const uploading = files.some((f)=>f.state === 'uploading');
    const addFiles = (list)=>{
        // MATERIALISED HERE, not inside the updater. `list` is the input's live
        // `FileList`, and the handler resets `input.value` immediately so choosing
        // the same file twice fires another change event — which EMPTIES the
        // FileList. React runs the updater afterwards, so spreading `list` in
        // there produced an empty array and the file silently vanished between
        // being chosen and being listed.
        const chosen = [
            ...list
        ].map((file)=>({
                key: `${file.name}:${file.size}:${file.lastModified}`,
                file: file,
                state: 'queued',
                progress: 0,
                error: null
            }));
        setFiles((current)=>{
            const known = new Set(current.map((f)=>f.key));
            return [
                ...current,
                ...chosen.filter((f)=>!known.has(f.key))
            ];
        });
    };
    const patchFile = (key, patch)=>setFiles((current)=>current.map((f)=>f.key === key ? {
                    ...f,
                    ...patch
                } : f));
    const isEdit = Boolean(activity?.id);
    const terminal = activity?.status === 'DONE' || activity?.status === 'CANCELLED';
    (0, $3OyDL.useEffect)(()=>{
        if (!open) return;
        setForm($a337acc1647f440c$var$toForm(activity, prefill));
        setResultNote('');
        setReopenReason('');
        setShowResult(false);
        setShowReopen(false);
        setContactSearch('');
        setFiles([]);
        setUploadError(null);
    }, [
        open,
        activity,
        prefill
    ]);
    const { data: typeData, loading: typesLoading } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$76905cee0d96ad5e), {
        skip: !open
    });
    const types = (0, $3OyDL.useMemo)(()=>typeData?.activityTypes ?? [], [
        typeData
    ]);
    // A DEPLOYMENT WITH NO ACTIVITY TYPES CANNOT BOOK ANYTHING, and until this
    // existed the only ways to add one were a seed script with database access or
    // a hand-written mutation. `awaitRefetchQueries` matters: the picker selects
    // what it just created, and the option has to be in the list first.
    const [createType, createTypeState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$39328c7d9faf3888), {
        refetchQueries: [
            'ActivityTypes'
        ],
        awaitRefetchQueries: true
    });
    // The default type is the first ACTIVE one in the deployment's own ordering.
    // No code names a type — that would break product-neutrality the moment
    // somebody adopted MeshHub with a different vocabulary.
    (0, $3OyDL.useEffect)(()=>{
        if (!form.typeId && types.length > 0) setForm((current)=>({
                ...current,
                typeId: types[0].id
            }));
    }, [
        types,
        form.typeId
    ]);
    // WHY THE PAGE SIZE MATTERS HERE. This is a `<select>`, not an infinite
    // list: whatever the first page holds is the whole world as far as the user
    // can tell, and there is no "load more" to reveal the rest. At ten, a
    // deployment with fifteen contacts showed ten and silently hid five — the
    // reported bug. It is the *same* CONTACTS_QUERY the affiliation and referrer
    // pickers use, and both of those already asked for 25.
    //
    // `totalCount` is selected so the form can SAY when the list is truncated,
    // rather than leaving the user to wonder. Searching narrows server-side and
    // is the intended path past the cap.
    const { data: contactData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$9b2e8c059cb38823), {
        variables: {
            page: 1,
            pageSize: $a337acc1647f440c$var$CONTACT_PICKER_SIZE,
            search: contactSearch || null
        },
        skip: !open
    });
    const contacts = contactData?.contacts?.items ?? [];
    const contactTotal = contactData?.contacts?.totalCount ?? 0;
    const hiddenContacts = Math.max(0, contactTotal - contacts.length);
    // The SAME query the calendar's ADMIN user switcher runs; Apollo dedupes
    // them when both are mounted. Skipped for a USER, who may not assign to
    // anybody else and would be refused by the ADMIN-only `users` field anyway.
    const { data: userData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$bba36a65d26d4ad8), {
        variables: {
            page: 1,
            pageSize: 100
        },
        skip: !open || !isAdmin,
        errorPolicy: 'ignore'
    });
    const users = userData?.users?.items ?? [];
    // Only when editing: a new activity has no id and therefore no files, and
    // the calendar must not pay for this on every activity it renders.
    const { data: fileData, refetch: refetchFiles } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$7579a9be522a8054), {
        variables: {
            id: activity?.id
        },
        skip: !open || !activity?.id,
        fetchPolicy: 'cache-and-network'
    });
    const stored = fileData?.activity?.attachments ?? [];
    const [createActivity, createState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$ed4256ea0078549b));
    const [updateActivity, updateState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$d6c64a6ab1cc0107));
    const [changeStatus, statusState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$3e128542718f832c));
    const [deleteActivity] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$621d5565408ec3f3));
    const [setReminders] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$123be1de0d50e4e3));
    const busy = createState.loading || updateState.loading || statusState.loading || uploading;
    const error = createState.error ?? updateState.error ?? statusState.error ?? uploadError;
    const startsAt = (0, $d4d460d3ffb6daab$export$747b60771a8a4ce9)(form.date, form.allDay ? '00:00' : form.startTime);
    const endsAt = form.allDay ? null : form.endTime ? (0, $d4d460d3ffb6daab$export$747b60771a8a4ce9)(form.date, form.endTime) : null;
    const set = (field)=>(event)=>{
            const value = event?.target?.type === 'checkbox' ? event.target.checked : event?.target?.value ?? event;
            setForm((current)=>({
                    ...current,
                    [field]: value
                }));
        };
    function reminderInputs() {
        if (!startsAt) return [];
        return form.reminders.map((r)=>({
                remindAt: new Date(new Date(startsAt).getTime() - r.offset * 60000).toISOString(),
                channel: r.channel
            }));
    }
    /**
   * Upload one queued file against an activity that now exists.
   *
   * `ownerType: 'ACTIVITY'` goes to the CRM's attachment store, which is where
   * every other attachment in MeshHub lives; the scheduling service holds no
   * files at all. Same `/files/initiate → PUT → /files/complete` flow, same
   * `lib/files.js`, no second implementation.
   */ async function uploadOne(entry, activityId) {
        patchFile(entry.key, {
            state: 'uploading',
            progress: 0,
            error: null
        });
        try {
            await (0, $d305624b55b31f43$export$a5575dbeeffdad98)({
                file: entry.file,
                ownerType: 'ACTIVITY',
                ownerId: activityId,
                onProgress: (fraction)=>patchFile(entry.key, {
                        progress: fraction
                    })
            });
            patchFile(entry.key, {
                state: 'done',
                progress: 1
            });
            return true;
        } catch (err) {
            patchFile(entry.key, {
                state: 'failed',
                error: err.message
            });
            return false;
        }
    }
    async function submit() {
        if (!startsAt) return;
        const input = {
            typeId: form.typeId,
            title: form.title,
            startsAt: startsAt,
            endsAt: endsAt,
            allDay: form.allDay,
            contactId: form.contactId || null,
            description: form.description || null,
            // Omitted means "the caller" at the service, so an unset picker is not
            // the same as sending an empty id — send the key only when there is one.
            ...form.assignedTo ? {
                assignedTo: form.assignedTo
            } : {}
        };
        let activityId = activity?.id ?? null;
        if (isEdit) {
            await updateActivity({
                variables: {
                    id: activity.id,
                    input: input
                }
            });
            await setReminders({
                variables: {
                    activityId: activity.id,
                    reminders: reminderInputs()
                }
            });
        } else if (onCreate) // The follow-up inbox creates through `acceptSuggestion`, which returns
        // the suggestion rather than the activity — so there is no id to attach
        // to here, and the file picker is hidden on that path.
        await onCreate({
            ...input,
            reminders: reminderInputs()
        });
        else {
            const created = await createActivity({
                variables: {
                    input: {
                        ...input,
                        reminders: reminderInputs()
                    }
                }
            });
            activityId = created.data?.createActivity?.id ?? null;
        }
        // AFTER the activity exists, because an attachment needs an owner id — the
        // same ordering, and the same one-at-a-time pacing, as the interaction
        // composer: a congress-hall connection does better sequentially and the
        // progress bars stay legible.
        const pending = files.filter((f)=>f.state !== 'done');
        let allUploaded = true;
        if (activityId) {
            for (const entry of pending)allUploaded = await uploadOne(entry, activityId) && allUploaded;
            // ONLY when editing. `useQuery` hands back a `refetch` even while
            // `skip` is true, and calling it on a create — where there is no
            // `activity.id` yet — fires the query with no variables and throws
            // «Variable "$id" of required type "ID!" was not provided», which
            // aborted `submit` and left the dialog open on a successful save.
            // A freshly created activity's list is the files just uploaded anyway.
            if (pending.length > 0 && activity?.id) await refetchFiles();
        }
        onSaved?.(activityId);
        if (!allUploaded) {
            // The activity SAVED; only some files did not. Keeping the dialog open
            // lets those be retried without retyping anything.
            setUploadError(new Error((0, $d916753b57975e04$export$25ce5a424b770e84).activity.uploadFailed));
            return;
        }
        onOpenChange(false);
    }
    async function applyStatus(toStatus, extra = {}) {
        await changeStatus({
            variables: {
                id: activity.id,
                toStatus: toStatus,
                ...extra
            }
        });
        onSaved?.(activity.id);
        onOpenChange(false);
    }
    const statusActions = !isEdit ? null : /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex flex-col gap-3 rounded border border-border bg-bg p-3",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-sm font-medium",
                        children: (0, $d4d460d3ffb6daab$export$b274e447bdddfc87)[activity.status] ?? activity.status
                    }),
                    activity.resultedAt && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-xs text-text-muted",
                        children: (0, $d4d460d3ffb6daab$export$8b492ed8828f789c)(activity.resultedAt)
                    })
                ]
            }),
            activity.resultNote && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "whitespace-pre-wrap text-sm text-text-muted",
                children: activity.resultNote
            }),
            !terminal && /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex flex-wrap gap-2",
                children: [
                    !showResult ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        type: "button",
                        variant: "primary",
                        onClick: ()=>setShowResult(true),
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.markDone
                    }) : null,
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        type: "button",
                        onClick: ()=>applyStatus('CANCELLED'),
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.markCancelled
                    }),
                    activity.status === 'SCHEDULED' && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        type: "button",
                        onClick: ()=>applyStatus('MISSED'),
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.markMissed
                    })
                ]
            }),
            showResult && /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$f5c9f3c2c4054eec), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.result,
                        hint: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.resultRequired,
                        rows: 3,
                        value: resultNote,
                        onChange: (event)=>setResultNote(event.target.value)
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                type: "button",
                                variant: "primary",
                                disabled: !resultNote.trim() || busy,
                                onClick: ()=>applyStatus('DONE', {
                                        resultNote: resultNote
                                    }),
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.markDone
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                type: "button",
                                onClick: ()=>setShowResult(false),
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.cancel
                            })
                        ]
                    })
                ]
            }),
            terminal && isAdmin && !showReopen && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                type: "button",
                onClick: ()=>setShowReopen(true),
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.reopen
            }),
            terminal && isAdmin && showReopen && /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.reopenReason,
                        hint: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.reopenReasonHint,
                        value: reopenReason,
                        onChange: (event)=>setReopenReason(event.target.value)
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                type: "button",
                                variant: "primary",
                                disabled: !reopenReason.trim() || busy,
                                onClick: ()=>applyStatus('SCHEDULED', {
                                        reason: reopenReason
                                    }),
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.reopen
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                type: "button",
                                onClick: ()=>setShowReopen(false),
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.cancel
                            })
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
                open: open,
                onOpenChange: onOpenChange,
                wide: true,
                title: isEdit ? (0, $d916753b57975e04$export$25ce5a424b770e84).activity.edit : (0, $d916753b57975e04$export$25ce5a424b770e84).activity.create,
                submitLabel: isEdit ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.save : (0, $d916753b57975e04$export$25ce5a424b770e84).activity.create,
                busy: busy,
                onSubmit: submit,
                footer: isEdit ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                    type: "button",
                    variant: "ghost",
                    onClick: ()=>setConfirmDelete(true),
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8750d1d3edd41705$export$2e2bcd8739ae039), {
                            size: 14,
                            "aria-hidden": "true"
                        }),
                        (0, $d916753b57975e04$export$25ce5a424b770e84).activity.delete
                    ]
                }) : null,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                        error: error
                    }),
                    statusActions,
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4436e89d3ef1c462$export$bc36ad93e482d2f8), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.type,
                        value: form.typeId,
                        onChange: (id)=>setForm((current)=>({
                                    ...current,
                                    typeId: id
                                })),
                        options: types,
                        loading: typesLoading,
                        required: true,
                        canCreate: isAdmin,
                        codePrefix: "ACTIVITY",
                        creating: createTypeState.loading,
                        createError: createTypeState.error,
                        onCreate: async (input)=>{
                            const created = await createType({
                                variables: {
                                    input: input
                                }
                            });
                            return created.data?.createActivityType;
                        }
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.subject,
                        value: form.title,
                        onChange: set('title'),
                        required: true
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "flex flex-col gap-1",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.contact,
                                hint: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.contactHint,
                                placeholder: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.searchContact,
                                value: contactSearch,
                                onChange: (event)=>setContactSearch(event.target.value)
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.contact,
                                value: form.contactId,
                                onChange: set('contactId'),
                                className: "sr-only-label",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                        value: "",
                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.noContact
                                    }),
                                    activity?.contact && !contacts.some((c)=>c.id === activity.contact.id) && /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                        value: activity.contact.id,
                                        children: activity.contact.displayName
                                    }),
                                    contacts.map((contact)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                            value: contact.id,
                                            children: contact.displayName
                                        }, contact.id))
                                ]
                            }),
                            hiddenContacts > 0 && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                className: "text-xs text-text-muted",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.moreContacts((0, $d4d460d3ffb6daab$export$104ee80c24270f18)(hiddenContacts))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$94195a47b94ed396), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.allDay,
                        checked: form.allDay,
                        onChange: set('allDay')
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "flex gap-3",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$ce0a41819d728248), {
                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.date,
                                className: "flex-1",
                                value: form.date,
                                onChange: (value)=>setForm((current)=>({
                                            ...current,
                                            date: value
                                        }))
                            }),
                            !form.allDay && /*#__PURE__*/ (0, $2M70Q.jsxs)("fieldset", {
                                className: "flex flex-1 gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("legend", {
                                        className: "sr-only",
                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.time
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$5eaee2322dd727eb), {
                                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.startTime,
                                        className: "flex-1",
                                        value: form.startTime,
                                        onChange: (value)=>setForm((current)=>({
                                                    ...current,
                                                    startTime: value
                                                }))
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$5eaee2322dd727eb), {
                                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.endTime,
                                        className: "flex-1",
                                        value: form.endTime,
                                        onChange: (value)=>setForm((current)=>({
                                                    ...current,
                                                    endTime: value
                                                }))
                                    })
                                ]
                            })
                        ]
                    }),
                    isAdmin ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.assignee,
                        hint: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.assigneeHint,
                        value: form.assignedTo,
                        onChange: set('assignedTo'),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                value: "",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.assigneeSelf
                            }),
                            users.map((user)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                    value: user.id,
                                    children: user.displayName
                                }, user.id))
                        ]
                    }) : /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                        className: "text-sm text-text-muted",
                        children: [
                            (0, $d916753b57975e04$export$25ce5a424b770e84).activity.assignee,
                            ": ",
                            me?.displayName ?? (0, $d916753b57975e04$export$25ce5a424b770e84).activity.assigneeSelf
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$f5c9f3c2c4054eec), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.description,
                        rows: 3,
                        value: form.description,
                        onChange: set('description')
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("fieldset", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("legend", {
                                className: "text-sm font-medium",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.reminders
                            }),
                            form.reminders.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                className: "text-xs text-text-muted",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.noReminders
                            }),
                            form.reminders.map((reminder, index)=>/*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                    className: "flex items-end gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                                            label: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.reminderOffset,
                                            value: String(reminder.offset),
                                            onChange: (event)=>setForm((current)=>({
                                                        ...current,
                                                        reminders: current.reminders.map((r, i)=>i === index ? {
                                                                ...r,
                                                                offset: Number(event.target.value)
                                                            } : r)
                                                    })),
                                            children: $a337acc1647f440c$var$OFFSETS.map((offset)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                                    value: offset,
                                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.reminderOffsets[String(offset)]
                                                }, offset))
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                                            label: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.reminderChannel,
                                            value: reminder.channel,
                                            onChange: (event)=>setForm((current)=>({
                                                        ...current,
                                                        reminders: current.reminders.map((r, i)=>i === index ? {
                                                                ...r,
                                                                channel: event.target.value
                                                            } : r)
                                                    })),
                                            children: Object.entries((0, $d4d460d3ffb6daab$export$6fb89037e97dc785)).map(([value, label])=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                                    value: value,
                                                    children: label
                                                }, value))
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                            type: "button",
                                            variant: "ghost",
                                            "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).app.close,
                                            onClick: ()=>setForm((current)=>({
                                                        ...current,
                                                        reminders: current.reminders.filter((_, i)=>i !== index)
                                                    })),
                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $bi4P4.default), {
                                                size: 14,
                                                "aria-hidden": "true"
                                            })
                                        })
                                    ]
                                }, `${reminder.offset}-${reminder.channel}`)),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                type: "button",
                                onClick: ()=>setForm((current)=>({
                                            ...current,
                                            reminders: [
                                                ...current.reminders,
                                                {
                                                    offset: 30,
                                                    channel: 'IN_APP'
                                                }
                                            ]
                                        })),
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                                        size: 14,
                                        "aria-hidden": "true"
                                    }),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).activity.addReminder
                                ]
                            })
                        ]
                    }),
                    !onCreate && /*#__PURE__*/ (0, $2M70Q.jsxs)("fieldset", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("legend", {
                                className: "text-sm font-medium",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.attachments
                            }),
                            stored.map((file)=>/*#__PURE__*/ (0, $2M70Q.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>(0, $d305624b55b31f43$export$70cccf46c7504cdc)(file.id),
                                    title: `${file.fileName} \u{2014} ${(0, $d4d460d3ffb6daab$export$e1a3971de07c83b5)(file.sizeBytes)}`,
                                    className: "flex items-center gap-2 self-start rounded border border-border px-3 py-1 text-sm text-text-muted hover:bg-surface-hover hover:text-text",
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e6a0b4aa733f75fd$export$2e2bcd8739ae039), {
                                            size: 13,
                                            "aria-hidden": "true"
                                        }),
                                        file.fileName
                                    ]
                                }, file.id)),
                            files.map((entry)=>/*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                    className: "flex items-center gap-2 text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e6a0b4aa733f75fd$export$2e2bcd8739ae039), {
                                            size: 13,
                                            "aria-hidden": "true",
                                            className: "text-text-muted"
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                            className: "truncate",
                                            children: entry.file.name
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                            className: "text-xs text-text-muted",
                                            children: entry.state === 'uploading' ? `${Math.round(entry.progress * 100)}\u{66A}` : (0, $d4d460d3ffb6daab$export$e1a3971de07c83b5)(entry.file.size)
                                        }),
                                        entry.error && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                            className: "text-xs text-danger",
                                            children: entry.error
                                        }),
                                        entry.state !== 'uploading' && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                            type: "button",
                                            variant: "ghost",
                                            "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).app.remove,
                                            onClick: ()=>setFiles((current)=>current.filter((f)=>f.key !== entry.key)),
                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $bi4P4.default), {
                                                size: 13,
                                                "aria-hidden": "true"
                                            })
                                        })
                                    ]
                                }, entry.key)),
                            stored.length === 0 && files.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                className: "text-xs text-text-muted",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.noFiles
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                type: "button",
                                className: "self-start",
                                disabled: uploading,
                                onClick: ()=>fileInputRef.current?.click(),
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                                        size: 14,
                                        "aria-hidden": "true"
                                    }),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).activity.addFile
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                                ref: fileInputRef,
                                type: "file",
                                multiple: true,
                                className: "hidden",
                                "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).activity.addFile,
                                onChange: (event)=>{
                                    if (event.target.files?.length) addFiles(event.target.files);
                                    event.target.value = '';
                                }
                            }),
                            files.length > 0 && !isEdit && // Said out loud, because the dialog stays open a moment longer
                            // than the button suggests — the activity has to exist before a
                            // file can belong to it.
                            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                className: "text-xs text-text-muted",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.filesAfterSave
                            })
                        ]
                    }),
                    isEdit && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $52d5b714f6b851c0$export$7658b7b3805eab9a), {
                        activityId: activity.id
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2cc85109a937009e), {
                open: confirmDelete,
                onOpenChange: setConfirmDelete,
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.delete,
                description: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.deleteConfirm,
                confirmLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.delete,
                destructive: true,
                onConfirm: async ()=>{
                    await deleteActivity({
                        variables: {
                            id: activity.id
                        }
                    });
                    setConfirmDelete(false);
                    onSaved?.(null);
                    onOpenChange(false);
                }
            })
        ]
    });
}


/**
 * The week / day grid.
 *
 * Three things about it are Persian-specific and all three live in
 * `lib/format.js` rather than here: the week starts on SATURDAY, the headers
 * are Jalali, and the digits are Persian. Every date library in the ecosystem
 * defaults to a Sunday or Monday week, so getting this wrong is the default
 * outcome — which is why the component asks for `persianWeekDays()` instead of
 * doing arithmetic of its own.
 *
 * RTL falls out of the document direction: the day columns are flex children in
 * calendar order, and an RTL container lays the first one out on the right,
 * where شنبه belongs. There is no `flex-row-reverse` anywhere.
 *
 * POSITIONING uses `calc(... * var(--mh-density-hour))` rather than pixel
 * arithmetic. One hour is the unit, and it is a design token: changing the
 * grid's density is a token edit, not a hunt through this file. (It is also
 * what keeps `npm run lint` — which fails on any raw px in app code — happy,
 * and that rule is why the constraint is worth having.)
 */ 
var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");




const $73978b36a04e84b2$var$HOURS = Array.from({
    length: (0, $370d2fd34ead4cb4$export$89f380dcb6ef7bfb) - (0, $370d2fd34ead4cb4$export$f3ef51d640bae134)
}, (_, index)=>(0, $370d2fd34ead4cb4$export$f3ef51d640bae134) + index);
/** Minutes since the top of the grid, snapped. */ function $73978b36a04e84b2$var$snap(minutes) {
    return Math.round(minutes / (0, $370d2fd34ead4cb4$export$a8491cebaea55fc3)) * (0, $370d2fd34ead4cb4$export$a8491cebaea55fc3);
}
/** A y offset inside a day column -> minutes past DAY_START_HOUR. */ function $73978b36a04e84b2$var$minutesFromOffset(offsetY, columnHeight) {
    const totalMinutes = ((0, $370d2fd34ead4cb4$export$89f380dcb6ef7bfb) - (0, $370d2fd34ead4cb4$export$f3ef51d640bae134)) * 60;
    const ratio = Math.min(Math.max(offsetY / columnHeight, 0), 1);
    return $73978b36a04e84b2$var$snap(ratio * totalMinutes);
}
function $73978b36a04e84b2$var$atMinutes(day, minutes) {
    const out = new Date(day);
    out.setHours((0, $370d2fd34ead4cb4$export$f3ef51d640bae134), 0, 0, 0);
    out.setMinutes(out.getMinutes() + minutes);
    return out;
}
/** Where an activity sits in its column, as fractions of an hour. */ function $73978b36a04e84b2$var$placement(activity) {
    const start = new Date(activity.startsAt);
    const end = activity.endsAt ? new Date(activity.endsAt) : new Date(start.getTime() + (0, $370d2fd34ead4cb4$export$6f5a30ba6fce13da) * 60000);
    const startHours = start.getHours() + start.getMinutes() / 60 - (0, $370d2fd34ead4cb4$export$f3ef51d640bae134);
    const endHours = end.getHours() + end.getMinutes() / 60 - (0, $370d2fd34ead4cb4$export$f3ef51d640bae134);
    return {
        top: Math.max(startHours, 0),
        // A floor so a fifteen-minute call is still readable rather than a hairline.
        height: Math.max(endHours - Math.max(startHours, 0), 0.5)
    };
}
/**
 * Lay overlapping activities side by side.
 *
 * Two meetings at ten o'clock must both be visible; stacking them would hide
 * one entirely, and a calendar that hides a meeting is worse than no calendar.
 * A simple sweep is enough at the density a person actually books.
 */ function $73978b36a04e84b2$var$withColumns(activities) {
    const sorted = [
        ...activities
    ].sort((a, b)=>new Date(a.startsAt) - new Date(b.startsAt));
    const lanes = [];
    return sorted.map((activity)=>{
        const place = $73978b36a04e84b2$var$placement(activity);
        const end = place.top + place.height;
        let lane = lanes.findIndex((laneEnd)=>laneEnd <= place.top + 0.01);
        if (lane === -1) {
            lane = lanes.length;
            lanes.push(end);
        } else lanes[lane] = end;
        return {
            activity: activity,
            place: place,
            lane: lane
        };
    });
}
function $73978b36a04e84b2$var$laneStyle(lane, laneCount) {
    const width = 100 / laneCount;
    // `insetInlineStart`, not `left`: in an RTL column the lanes must run from
    // the right edge, and a physical property would put them on the wrong side.
    return {
        insetInlineStart: `${lane * width}%`,
        width: `${width}%`
    };
}
function $73978b36a04e84b2$export$cf52ea19f3edfb16({ days: days, activities: activities, colorForType: colorForType, onCreate: onCreate, onOpen: onOpen, onMove: onMove, readOnly: readOnly = false }) {
    const [drag, setDrag] = (0, $3OyDL.useState)(null);
    const columnRefs = (0, $3OyDL.useRef)({});
    /**
   * The live drag, for the HANDLERS to read.
   *
   * `drag` state drives the preview; this ref is what `mouseup` consults. They
   * are not redundant: a state update from `mousemove` is scheduled, not
   * applied, so a `mouseup` arriving in the same React batch would read the
   * position from before the last movement and drop it. The browser normally
   * delivers the two as separate tasks so the state would flush in between —
   * but "normally" is doing a lot of work in that sentence, and a ref costs
   * nothing.
   */ const dragRef = (0, $3OyDL.useRef)(null);
    const updateDrag = (0, $3OyDL.useCallback)((next)=>{
        dragRef.current = typeof next === 'function' ? next(dragRef.current) : next;
        setDrag(dragRef.current);
    }, []);
    const byDay = (0, $3OyDL.useMemo)(()=>{
        const map = new Map(days.map((day)=>[
                day.toDateString(),
                []
            ]));
        for (const activity of activities){
            if (activity.allDay) continue;
            const key = new Date(activity.startsAt).toDateString();
            if (map.has(key)) map.get(key).push(activity);
        }
        return map;
    }, [
        days,
        activities
    ]);
    const allDay = (0, $3OyDL.useMemo)(()=>{
        const map = new Map(days.map((day)=>[
                day.toDateString(),
                []
            ]));
        for (const activity of activities){
            if (!activity.allDay) continue;
            const key = new Date(activity.startsAt).toDateString();
            if (map.has(key)) map.get(key).push(activity);
        }
        return map;
    }, [
        days,
        activities
    ]);
    /**
   * Drag lives on `window`, not on the column.
   *
   * A pointer that leaves the column mid-drag — which it does constantly near
   * an edge — would otherwise strand the gesture with no mouseup, leaving a
   * ghost selection the user cannot clear.
   */ (0, $3OyDL.useEffect)(()=>{
        if (!drag) return undefined;
        function onMove_(event) {
            const current = dragRef.current;
            if (!current) return;
            const column = columnRefs.current[current.dayKey];
            if (!column) return;
            const rect = column.getBoundingClientRect();
            const minutes = $73978b36a04e84b2$var$minutesFromOffset(event.clientY - rect.top, rect.height);
            updateDrag((previous)=>previous ? {
                    ...previous,
                    currentMinutes: minutes
                } : previous);
        }
        function onUp() {
            // Read from the REF, not the closure: this handler was installed when the
            // drag began, and the closed-over `drag` is that first frame's value.
            const finished = dragRef.current;
            updateDrag(null);
            if (!finished) return;
            const day = days.find((d)=>d.toDateString() === finished.dayKey);
            if (!day) return;
            if (finished.kind === 'create') {
                const from = Math.min(finished.startMinutes, finished.currentMinutes);
                const to = Math.max(finished.startMinutes, finished.currentMinutes);
                onCreate?.({
                    startsAt: $73978b36a04e84b2$var$atMinutes(day, from),
                    // A click (no movement) means "an hour here", which is what someone
                    // clicking an empty slot almost always wants.
                    endsAt: $73978b36a04e84b2$var$atMinutes(day, to > from ? to : from + (0, $370d2fd34ead4cb4$export$6f5a30ba6fce13da))
                });
            } else if (finished.kind === 'move' && finished.currentMinutes !== finished.startMinutes) onMove?.(finished.activity, finished.currentMinutes - finished.startMinutes, day);
        }
        window.addEventListener('mousemove', onMove_);
        window.addEventListener('mouseup', onUp);
        return ()=>{
            window.removeEventListener('mousemove', onMove_);
            window.removeEventListener('mouseup', onUp);
        };
    // Depends on whether a drag is IN PROGRESS, not on its position: the
    // handlers read the position from the ref, so re-subscribing on every
    // mousemove would be pure churn.
    }, [
        drag !== null,
        days,
        onCreate,
        onMove,
        updateDrag
    ]);
    const startCreate = (0, $3OyDL.useCallback)((event, day)=>{
        if (readOnly || event.button !== 0) return;
        const rect = event.currentTarget.getBoundingClientRect();
        const minutes = $73978b36a04e84b2$var$minutesFromOffset(event.clientY - rect.top, rect.height);
        updateDrag({
            kind: 'create',
            dayKey: day.toDateString(),
            startMinutes: minutes,
            currentMinutes: minutes
        });
    }, [
        readOnly,
        updateDrag
    ]);
    const startMove = (0, $3OyDL.useCallback)((event, activity, day)=>{
        if (readOnly || event.button !== 0) return;
        event.stopPropagation();
        const column = columnRefs.current[day.toDateString()];
        if (!column) return;
        const rect = column.getBoundingClientRect();
        const minutes = $73978b36a04e84b2$var$minutesFromOffset(event.clientY - rect.top, rect.height);
        updateDrag({
            kind: 'move',
            dayKey: day.toDateString(),
            activity: activity,
            startMinutes: minutes,
            currentMinutes: minutes
        });
    }, [
        readOnly,
        updateDrag
    ]);
    const today = new Date();
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex flex-1 flex-col overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex border-b border-border bg-surface",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                        className: "w-gutter shrink-0"
                    }),
                    days.map((day, index)=>{
                        const isToday = (0, $d4d460d3ffb6daab$export$ea39ec197993aef0)(day, today);
                        return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                            className: [
                                'flex flex-1 flex-col items-center border-s border-border py-2',
                                index === (0, $d4d460d3ffb6daab$export$87b71208d3952cb3) ? 'bg-surface-hover' : '',
                                isToday ? 'text-primary' : ''
                            ].join(' '),
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                    className: "text-xs text-text-muted",
                                    children: (0, $d4d460d3ffb6daab$export$949ded4877079784)[index]
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                    className: `text-sm ${isToday ? 'font-bold' : 'font-medium'}`,
                                    children: (0, $d4d460d3ffb6daab$export$905b00761e12531b)(day)
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                    dir: "ltr",
                                    className: "text-xs text-text-muted",
                                    children: (0, $d4d460d3ffb6daab$export$59226c665b47d8a8)(day, {
                                        withYear: false
                                    })
                                })
                            ]
                        }, day.toISOString());
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex border-b border-border bg-surface",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                        className: "flex w-gutter shrink-0 items-center justify-center py-1 text-xs text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).calendar.allDay
                    }),
                    days.map((day)=>/*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                            className: "flex min-h-row flex-1 flex-col gap-1 border-s border-border p-1",
                            children: (allDay.get(day.toDateString()) ?? []).map((activity)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $f62f9853e6211882$export$814296134552cdcd), {
                                    activity: activity,
                                    color: colorForType(activity.type?.id),
                                    compact: true,
                                    onClick: ()=>onOpen?.(activity)
                                }, activity.id))
                        }, day.toISOString()))
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex flex-1 overflow-y-auto",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                        className: "w-gutter shrink-0",
                        children: $73978b36a04e84b2$var$HOURS.map((hour)=>/*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                                className: "h-hour border-b border-s border-border pe-2 text-end text-xs leading-none text-text-muted",
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                    className: "relative -top-px",
                                    dir: "ltr",
                                    children: (0, $d4d460d3ffb6daab$export$e9cf274fc1035ec4)(String(hour).padStart(2, '0'))
                                })
                            }, hour))
                    }),
                    days.map((day, index)=>{
                        const key = day.toDateString();
                        const laid = $73978b36a04e84b2$var$withColumns(byDay.get(key) ?? []);
                        const laneCount = Math.max(1, ...laid.map((entry)=>entry.lane + 1));
                        const dragging = drag?.dayKey === key;
                        return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                            ref: (node)=>{
                                columnRefs.current[key] = node;
                            },
                            onMouseDown: (event)=>startCreate(event, day),
                            className: [
                                'relative flex-1 border-s border-border',
                                index === (0, $d4d460d3ffb6daab$export$87b71208d3952cb3) ? 'bg-surface-hover' : 'bg-surface',
                                readOnly ? '' : 'cursor-crosshair'
                            ].join(' '),
                            children: [
                                $73978b36a04e84b2$var$HOURS.map((hour)=>/*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                                        className: "h-hour border-b border-border"
                                    }, hour)),
                                dragging && drag.kind === 'create' && /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                                    "aria-hidden": "true",
                                    className: "pointer-events-none absolute inset-x-0 rounded border border-primary bg-primary/20",
                                    style: {
                                        top: `calc(${Math.min(drag.startMinutes, drag.currentMinutes) / 60} * var(--mh-density-hour))`,
                                        height: `calc(${Math.max(Math.abs(drag.currentMinutes - drag.startMinutes) / 60, 0.25)} * var(--mh-density-hour))`
                                    }
                                }),
                                laid.map(({ activity: activity, place: place, lane: lane })=>{
                                    const shift = dragging && drag.kind === 'move' && drag.activity?.id === activity.id ? (drag.currentMinutes - drag.startMinutes) / 60 : 0;
                                    return /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                                        className: "absolute px-px",
                                        style: {
                                            top: `calc(${place.top + shift} * var(--mh-density-hour))`,
                                            height: `calc(${place.height} * var(--mh-density-hour))`,
                                            ...$73978b36a04e84b2$var$laneStyle(lane, laneCount)
                                        },
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f62f9853e6211882$export$814296134552cdcd), {
                                            activity: activity,
                                            color: colorForType(activity.type?.id),
                                            onMouseDown: (event)=>startMove(event, activity, day),
                                            onClick: ()=>onOpen?.(activity)
                                        })
                                    }, activity.id);
                                })
                            ]
                        }, day.toISOString());
                    })
                ]
            })
        ]
    });
}








const $930b20b193f67514$var$VIEWS = [
    {
        key: 'week',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).calendar.week
    },
    {
        key: 'day',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).calendar.day
    },
    {
        key: 'agenda',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).calendar.agenda
    }
];
function $930b20b193f67514$export$4084ba14934f75cb() {
    const { isAdmin: isAdmin } = (0, $00d5d84dffcdf8d5$export$ad0a340bf97d63d5)();
    const [anchor, setAnchor] = (0, $3OyDL.useState)(()=>(0, $d4d460d3ffb6daab$export$63fa379ae8a9ba2)(new Date()));
    const [view, setView] = (0, $3OyDL.useState)('week');
    const [selectedUsers, setSelectedUsers] = (0, $3OyDL.useState)([]);
    const [dialog, setDialog] = (0, $3OyDL.useState)(null); // { activity } | { prefill }
    const days = (0, $3OyDL.useMemo)(()=>view === 'day' ? [
            anchor
        ] : (0, $d4d460d3ffb6daab$export$b28d13d660cf3bf3)(anchor), [
        anchor,
        view
    ]);
    // The whole visible range, as instants. `calendar` returns everything that
    // OVERLAPS it, so an activity starting before the window still appears.
    const range = (0, $3OyDL.useMemo)(()=>{
        const from = new Date(days[0]);
        const to = new Date(days[days.length - 1]);
        to.setHours(23, 59, 59, 999);
        return {
            dateFrom: from.toISOString(),
            dateTo: to.toISOString()
        };
    }, [
        days
    ]);
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$30b197584a180028), {
        variables: {
            ...range,
            users: selectedUsers.length ? selectedUsers : null
        },
        fetchPolicy: 'cache-and-network'
    });
    const { data: typeData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$76905cee0d96ad5e));
    const { data: userData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$bba36a65d26d4ad8), {
        variables: {
            page: 1,
            pageSize: 100
        },
        skip: !isAdmin
    });
    const [updateActivity, updateState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$d6c64a6ab1cc0107));
    const activities = data?.calendar ?? [];
    /**
   * A colour per activity type, by POSITION in the vocabulary.
   *
   * No code names a type — which types exist is deployment data. A slot list
   * means a deployment that renames its install type keeps its colour, and one
   * that adds a ninth wraps around rather than losing colour entirely.
   */ const colorForType = (0, $3OyDL.useCallback)((typeId)=>{
        const types = typeData?.activityTypes ?? [];
        const index = types.findIndex((type)=>type.id === typeId);
        return (0, $dd0263804d68f882$export$32d227f17c113340)[(index < 0 ? 0 : index) % (0, $dd0263804d68f882$export$32d227f17c113340).length];
    }, [
        typeData
    ]);
    const step = view === 'day' ? 1 : 7;
    const goToday = (0, $3OyDL.useCallback)(()=>setAnchor((0, $d4d460d3ffb6daab$export$63fa379ae8a9ba2)(new Date())), []);
    // Jumping to an arbitrary date. `[` and `]` step and `t` returns to today,
    // but «هفته اول مهر» was reachable only by pressing `]` five times — and a
    // congress three months out is not reachable at all in practice.
    const goToDate = (0, $3OyDL.useCallback)((iso)=>{
        const picked = (0, $d4d460d3ffb6daab$export$2052d237514e69a0)(iso);
        if (picked) setAnchor((0, $d4d460d3ffb6daab$export$63fa379ae8a9ba2)(picked));
    }, []);
    const goPrev = (0, $3OyDL.useCallback)(()=>setAnchor((current)=>(0, $d4d460d3ffb6daab$export$dd412b56f1e4d8aa)(current, -step)), [
        step
    ]);
    const goNext = (0, $3OyDL.useCallback)(()=>setAnchor((current)=>(0, $d4d460d3ffb6daab$export$dd412b56f1e4d8aa)(current, step)), [
        step
    ]);
    const newActivity = (0, $3OyDL.useCallback)(()=>setDialog({
            prefill: {}
        }), []);
    (0, $ed3cc4f847deec94$export$b0ebbe7904d8d94a)('t', goToday, {
        description: (0, $d916753b57975e04$export$25ce5a424b770e84).shortcuts.actions.today,
        group: (0, $d916753b57975e04$export$25ce5a424b770e84).shortcuts.groups.calendar
    });
    (0, $ed3cc4f847deec94$export$b0ebbe7904d8d94a)('[', goPrev, {
        description: (0, $d916753b57975e04$export$25ce5a424b770e84).shortcuts.actions.prevWeek,
        group: (0, $d916753b57975e04$export$25ce5a424b770e84).shortcuts.groups.calendar
    });
    (0, $ed3cc4f847deec94$export$b0ebbe7904d8d94a)(']', goNext, {
        description: (0, $d916753b57975e04$export$25ce5a424b770e84).shortcuts.actions.nextWeek,
        group: (0, $d916753b57975e04$export$25ce5a424b770e84).shortcuts.groups.calendar
    });
    (0, $ed3cc4f847deec94$export$b0ebbe7904d8d94a)('n', newActivity, {
        description: (0, $d916753b57975e04$export$25ce5a424b770e84).shortcuts.actions.newActivity,
        group: (0, $d916753b57975e04$export$25ce5a424b770e84).shortcuts.groups.calendar
    });
    /** Dragging an activity moves it, keeping its duration. */ async function move(activity, deltaMinutes, day) {
        const start = new Date(activity.startsAt);
        const duration = activity.endsAt ? new Date(activity.endsAt) - start : 0;
        const moved = new Date(day);
        moved.setHours(start.getHours(), start.getMinutes() + deltaMinutes, 0, 0);
        await updateActivity({
            variables: {
                id: activity.id,
                input: {
                    startsAt: moved.toISOString(),
                    endsAt: duration ? new Date(moved.getTime() + duration).toISOString() : null
                }
            }
        });
        refetch();
    }
    const title = view === 'day' ? (0, $d4d460d3ffb6daab$export$905b00761e12531b)(anchor) : (0, $d4d460d3ffb6daab$export$1563a4bbc9fdec3a)(anchor);
    // The same range in Gregorian, beside the Jalali one rather than instead of
    // it. A single day needs one date; a week needs both ends, or «۲۹ Aug» would
    // describe only the Saturday.
    const gregorianTitle = view === 'day' ? (0, $d4d460d3ffb6daab$export$59226c665b47d8a8)(anchor) : `${(0, $d4d460d3ffb6daab$export$59226c665b47d8a8)(days[0], {
        withYear: false
    })} \u{2013} ${(0, $d4d460d3ffb6daab$export$59226c665b47d8a8)(days[6])}`;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex h-screen flex-col",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("header", {
                className: "flex h-toolbar shrink-0 items-center gap-3 border-b border-border bg-surface px-5",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $68l1k.default), {
                        size: 18,
                        className: "text-primary",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h1", {
                        className: "text-md font-bold",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).calendar.title
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "flex items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                type: "button",
                                variant: "ghost",
                                onClick: goPrev,
                                "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).shortcuts.actions.prevWeek,
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $eH742.default), {
                                    size: 16,
                                    "aria-hidden": "true"
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                type: "button",
                                onClick: goToday,
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).calendar.today
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                type: "button",
                                variant: "ghost",
                                onClick: goNext,
                                "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).shortcuts.actions.nextWeek,
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1tMez.default), {
                                    size: 16,
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$311766d331443d38), {
                        value: (0, $d4d460d3ffb6daab$export$ba57117c6378084d)(anchor),
                        onPick: goToDate,
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).calendar.jumpToDate,
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                            className: "flex items-baseline gap-2",
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                    className: "text-base font-medium",
                                    children: title
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                    dir: "ltr",
                                    className: "text-xs text-text-muted",
                                    children: gregorianTitle
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "ms-auto flex items-center gap-2",
                        children: [
                            isAdmin && /*#__PURE__*/ (0, $2M70Q.jsxs)("select", {
                                "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).calendar.whose,
                                value: selectedUsers[0] ?? '',
                                onChange: (event)=>setSelectedUsers(event.target.value ? [
                                        event.target.value
                                    ] : []),
                                className: "h-control rounded border border-border bg-surface px-2 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                        value: "",
                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).calendar.everyone
                                    }),
                                    (userData?.users?.items ?? []).map((user)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                            value: user.id,
                                            children: user.displayName
                                        }, user.id))
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                                className: "flex rounded border border-border",
                                children: $930b20b193f67514$var$VIEWS.map((entry)=>/*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setView(entry.key),
                                        className: [
                                            'h-control px-3 text-sm',
                                            view === entry.key ? 'bg-primary text-primary-contrast' : 'text-text hover:bg-surface-hover'
                                        ].join(' '),
                                        children: entry.label
                                    }, entry.key))
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                type: "button",
                                variant: "primary",
                                onClick: newActivity,
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                                        size: 15,
                                        "aria-hidden": "true"
                                    }),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).calendar.newActivity
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: error ?? updateState.error
            }),
            loading && activities.length === 0 ? /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: "flex flex-1 items-center justify-center",
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {})
            }) : view === 'agenda' ? /*#__PURE__*/ (0, $2M70Q.jsx)($930b20b193f67514$var$AgendaList, {
                activities: activities,
                colorForType: colorForType,
                onOpen: (activity)=>setDialog({
                        activity: activity
                    })
            }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $73978b36a04e84b2$export$cf52ea19f3edfb16), {
                days: days,
                activities: activities,
                colorForType: colorForType,
                onCreate: (prefill)=>setDialog({
                        prefill: prefill
                    }),
                onOpen: (activity)=>setDialog({
                        activity: activity
                    }),
                onMove: move
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("footer", {
                className: "shrink-0 border-t border-border bg-surface px-5 py-2 text-xs text-text-muted",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).calendar.dragHint
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a337acc1647f440c$export$29a29aaae5ee2157), {
                open: Boolean(dialog),
                onOpenChange: (open)=>!open && setDialog(null),
                activity: dialog?.activity,
                prefill: dialog?.prefill,
                onSaved: ()=>refetch()
            })
        ]
    });
}
/** The same activities, read as a list. Grouped by day, newest first within it. */ function $930b20b193f67514$var$AgendaList({ activities: activities, colorForType: colorForType, onOpen: onOpen }) {
    const grouped = (0, $3OyDL.useMemo)(()=>{
        const map = new Map();
        for (const activity of [
            ...activities
        ].sort((a, b)=>new Date(a.startsAt) - new Date(b.startsAt))){
            const key = new Date(activity.startsAt).toDateString();
            if (!map.has(key)) map.set(key, []);
            map.get(key).push(activity);
        }
        return [
            ...map.entries()
        ];
    }, [
        activities
    ]);
    if (grouped.length === 0) return /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
        className: "flex flex-1 items-center justify-center text-sm text-text-muted",
        children: (0, $d916753b57975e04$export$25ce5a424b770e84).calendar.noActivities
    });
    return /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
        className: "flex-1 overflow-y-auto p-5",
        children: /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
            className: "flex flex-col gap-5",
            children: grouped.map(([key, dayActivities])=>/*#__PURE__*/ (0, $2M70Q.jsxs)("section", {
                    className: "flex flex-col gap-2",
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsxs)("h2", {
                            className: "flex items-baseline gap-2 text-sm font-medium text-text-muted",
                            children: [
                                (0, $d4d460d3ffb6daab$export$905b00761e12531b)(new Date(key)),
                                /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                    dir: "ltr",
                                    className: "text-xs",
                                    children: (0, $d4d460d3ffb6daab$export$59226c665b47d8a8)(new Date(key), {
                                        withYear: false
                                    })
                                })
                            ]
                        }),
                        dayActivities.map((activity)=>/*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                                className: "h-row",
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f62f9853e6211882$export$814296134552cdcd), {
                                    activity: activity,
                                    color: colorForType(activity.type?.id),
                                    onClick: ()=>onOpen(activity)
                                })
                            }, activity.id))
                    ]
                }, key))
        })
    });
}


/**
 * The contact profile — the screen a rep spends their day on.
 *
 * A header that stays put (photo, name, status, primary number, tags) over a
 * two-column body: what the contact *is* on the right, what has *happened* on
 * the left. Sections rather than tabs, because a back-office user comparing
 * "they wanted the voice bot" against "we called them in March" should not have
 * to remember which tab held which.
 *
 * Every panel re-reads the whole contact after it saves. One extra query buys
 * a guarantee that the screen shows what the server actually stored — and the
 * server is where the interesting rules live (one primary number, custom-field
 * types, the backward-status guard), so optimistic updates here would be
 * guessing at their outcome.
 */ 
var $2M70Q = parcelRequire("2M70Q");



var $74E7N = parcelRequire("74E7N");/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $652705894d580044$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
            key: "18887p"
        }
    ],
    [
        "path",
        {
            d: "M12 8v6",
            key: "1ib9pf"
        }
    ],
    [
        "path",
        {
            d: "M9 11h6",
            key: "1fldmi"
        }
    ]
];
const $652705894d580044$export$2e2bcd8739ae039 = (0, $djixo.default)("message-square-plus", $652705894d580044$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $96e39fbe36da68cb$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
            key: "1357e3"
        }
    ],
    [
        "path",
        {
            d: "M3 3v5h5",
            key: "1xhq8a"
        }
    ]
];
const $96e39fbe36da68cb$export$2e2bcd8739ae039 = (0, $djixo.default)("rotate-ccw", $96e39fbe36da68cb$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $d23d04f6959f82b1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ],
    [
        "path",
        {
            d: "M5 5a1 1 0 0 0-1 1v7c0 5 3.5 7.5 7.67 8.94a1 1 0 0 0 .67.01c2.35-.82 4.48-1.97 5.9-3.71",
            key: "1jlk70"
        }
    ],
    [
        "path",
        {
            d: "M9.309 3.652A12.252 12.252 0 0 0 11.24 2.28a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v7a9.784 9.784 0 0 1-.08 1.264",
            key: "18rp1v"
        }
    ]
];
const $d23d04f6959f82b1$export$2e2bcd8739ae039 = (0, $djixo.default)("shield-off", $d23d04f6959f82b1$export$3efd853dbb351e94);



var $3OyDL = parcelRequire("3OyDL");

var $8B9Zg = parcelRequire("8B9Zg");
var $ZNHD9 = parcelRequire("ZNHD9");

var $2M70Q = parcelRequire("2M70Q");

var $3OyDL = parcelRequire("3OyDL");

var $3j7Yq = parcelRequire("3j7Yq");

var $i8Ljd = parcelRequire("i8Ljd");

var $9DRZr = parcelRequire("9DRZr");

var $dTBEM = parcelRequire("dTBEM");

var $lQlfC = parcelRequire("lQlfC");

var $3OyDL = parcelRequire("3OyDL");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $f3f8fa57c0a6e7bd$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $f3f8fa57c0a6e7bd$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $f3f8fa57c0a6e7bd$export$803cd8101b6c182b = /*#__PURE__*/ $f3f8fa57c0a6e7bd$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $f3f8fa57c0a6e7bd$export$27b07d8a310ed8b5[0], side + "-" + $f3f8fa57c0a6e7bd$export$27b07d8a310ed8b5[1]), []);
const $f3f8fa57c0a6e7bd$export$96ec731ed4dcb222 = Math.min;
const $f3f8fa57c0a6e7bd$export$8960430cfd85939f = Math.max;
const $f3f8fa57c0a6e7bd$export$2077e0241d6afd3c = Math.round;
const $f3f8fa57c0a6e7bd$export$a3fe094919f356fd = Math.floor;
const $f3f8fa57c0a6e7bd$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $f3f8fa57c0a6e7bd$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $f3f8fa57c0a6e7bd$export$7d15b64cf5a3a4c4(start, value, end) {
    return $f3f8fa57c0a6e7bd$export$8960430cfd85939f(start, $f3f8fa57c0a6e7bd$export$96ec731ed4dcb222(value, end));
}
function $f3f8fa57c0a6e7bd$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $f3f8fa57c0a6e7bd$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $f3f8fa57c0a6e7bd$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $f3f8fa57c0a6e7bd$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $f3f8fa57c0a6e7bd$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $f3f8fa57c0a6e7bd$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $f3f8fa57c0a6e7bd$export$2b57e0052a6d6d4c(placement) {
    return $f3f8fa57c0a6e7bd$export$8a000a963141ac32($f3f8fa57c0a6e7bd$export$f28e8f882010718a(placement));
}
function $f3f8fa57c0a6e7bd$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $f3f8fa57c0a6e7bd$export$f0989780f32bfcda(placement);
    const alignmentAxis = $f3f8fa57c0a6e7bd$export$2b57e0052a6d6d4c(placement);
    const length = $f3f8fa57c0a6e7bd$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $f3f8fa57c0a6e7bd$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $f3f8fa57c0a6e7bd$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $f3f8fa57c0a6e7bd$export$496432a3699e50b1(placement) {
    const oppositePlacement = $f3f8fa57c0a6e7bd$export$9c5e28bad23365fa(placement);
    return [
        $f3f8fa57c0a6e7bd$export$2b182c584985588b(placement),
        oppositePlacement,
        $f3f8fa57c0a6e7bd$export$2b182c584985588b(oppositePlacement)
    ];
}
function $f3f8fa57c0a6e7bd$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $f3f8fa57c0a6e7bd$var$lrPlacement = [
    'left',
    'right'
];
const $f3f8fa57c0a6e7bd$var$rlPlacement = [
    'right',
    'left'
];
const $f3f8fa57c0a6e7bd$var$tbPlacement = [
    'top',
    'bottom'
];
const $f3f8fa57c0a6e7bd$var$btPlacement = [
    'bottom',
    'top'
];
function $f3f8fa57c0a6e7bd$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $f3f8fa57c0a6e7bd$var$rlPlacement : $f3f8fa57c0a6e7bd$var$lrPlacement;
            return isStart ? $f3f8fa57c0a6e7bd$var$lrPlacement : $f3f8fa57c0a6e7bd$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $f3f8fa57c0a6e7bd$var$tbPlacement : $f3f8fa57c0a6e7bd$var$btPlacement;
        default:
            return [];
    }
}
function $f3f8fa57c0a6e7bd$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $f3f8fa57c0a6e7bd$export$f0989780f32bfcda(placement);
    let list = $f3f8fa57c0a6e7bd$var$getSideList($f3f8fa57c0a6e7bd$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($f3f8fa57c0a6e7bd$export$2b182c584985588b));
    }
    return list;
}
function $f3f8fa57c0a6e7bd$export$9c5e28bad23365fa(placement) {
    const side = $f3f8fa57c0a6e7bd$export$3c915306cb7fc97a(placement);
    return $f3f8fa57c0a6e7bd$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $f3f8fa57c0a6e7bd$export$1c66dbf1a9e34223(padding) {
    var _padding$top, _padding$right, _padding$bottom, _padding$left;
    return {
        top: (_padding$top = padding.top) != null ? _padding$top : 0,
        right: (_padding$right = padding.right) != null ? _padding$right : 0,
        bottom: (_padding$bottom = padding.bottom) != null ? _padding$bottom : 0,
        left: (_padding$left = padding.left) != null ? _padding$left : 0
    };
}
function $f3f8fa57c0a6e7bd$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $f3f8fa57c0a6e7bd$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $f3f8fa57c0a6e7bd$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $bd11d81e56a70d73$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $f3f8fa57c0a6e7bd$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $f3f8fa57c0a6e7bd$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $f3f8fa57c0a6e7bd$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $f3f8fa57c0a6e7bd$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    const alignment = (0, $f3f8fa57c0a6e7bd$export$f0989780f32bfcda)(placement);
    if (alignment) coords[alignmentAxis] += commonAlign * (alignment === 'end' ? 1 : -1) * (rtl && isVertical ? -1 : 1);
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $bd11d81e56a70d73$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $f3f8fa57c0a6e7bd$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $f3f8fa57c0a6e7bd$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $f3f8fa57c0a6e7bd$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) && await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $f3f8fa57c0a6e7bd$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $bd11d81e56a70d73$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $bd11d81e56a70d73$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $bd11d81e56a70d73$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $bd11d81e56a70d73$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $bd11d81e56a70d73$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $bd11d81e56a70d73$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $bd11d81e56a70d73$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $f3f8fa57c0a6e7bd$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $f3f8fa57c0a6e7bd$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $f3f8fa57c0a6e7bd$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $f3f8fa57c0a6e7bd$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $f3f8fa57c0a6e7bd$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $f3f8fa57c0a6e7bd$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $f3f8fa57c0a6e7bd$export$7d15b64cf5a3a4c4)(minPadding, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $f3f8fa57c0a6e7bd$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < minPadding ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < minPadding ? center - minPadding : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $bd11d81e56a70d73$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $f3f8fa57c0a6e7bd$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $f3f8fa57c0a6e7bd$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $f3f8fa57c0a6e7bd$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $f3f8fa57c0a6e7bd$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $f3f8fa57c0a6e7bd$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $bd11d81e56a70d73$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $f3f8fa57c0a6e7bd$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $f3f8fa57c0a6e7bd$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $f3f8fa57c0a6e7bd$export$803cd8101b6c182b) ? $bd11d81e56a70d73$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const alignmentSides = (0, $f3f8fa57c0a6e7bd$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            const currentOverflows = [
                overflow[(0, $f3f8fa57c0a6e7bd$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $f3f8fa57c0a6e7bd$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $f3f8fa57c0a6e7bd$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $bd11d81e56a70d73$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $f3f8fa57c0a6e7bd$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $f3f8fa57c0a6e7bd$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $f3f8fa57c0a6e7bd$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $f3f8fa57c0a6e7bd$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $f3f8fa57c0a6e7bd$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $f3f8fa57c0a6e7bd$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $f3f8fa57c0a6e7bd$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $f3f8fa57c0a6e7bd$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $f3f8fa57c0a6e7bd$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $f3f8fa57c0a6e7bd$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $f3f8fa57c0a6e7bd$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $bd11d81e56a70d73$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $bd11d81e56a70d73$var$isAnySideFullyClipped(overflow) {
    return (0, $f3f8fa57c0a6e7bd$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $bd11d81e56a70d73$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $f3f8fa57c0a6e7bd$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $bd11d81e56a70d73$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $bd11d81e56a70d73$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $bd11d81e56a70d73$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $bd11d81e56a70d73$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $bd11d81e56a70d73$var$getBoundingRect(rects) {
    const minX = (0, $f3f8fa57c0a6e7bd$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $f3f8fa57c0a6e7bd$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $f3f8fa57c0a6e7bd$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $f3f8fa57c0a6e7bd$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $bd11d81e56a70d73$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $f3f8fa57c0a6e7bd$export$ee05aea0aeecbad4)($bd11d81e56a70d73$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $bd11d81e56a70d73$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $f3f8fa57c0a6e7bd$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            // No rects (e.g. a hidden or detached reference, or a collapsed range) —
            // keep the existing reference rect rather than resetting to an invalid
            // one with non-finite values.
            if (!nativeClientRects.length) return {};
            const clientRects = $bd11d81e56a70d73$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $f3f8fa57c0a6e7bd$export$ee05aea0aeecbad4)($bd11d81e56a70d73$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $f3f8fa57c0a6e7bd$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && (clientRects[0].left > clientRects[1].right || clientRects[1].left > clientRects[0].right) && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $f3f8fa57c0a6e7bd$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $f3f8fa57c0a6e7bd$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        return (0, $f3f8fa57c0a6e7bd$export$ee05aea0aeecbad4)({
                            x: left,
                            y: top,
                            width: right - left,
                            height: bottom - top
                        });
                    }
                    const isLeftSide = (0, $f3f8fa57c0a6e7bd$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $f3f8fa57c0a6e7bd$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $f3f8fa57c0a6e7bd$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    return (0, $f3f8fa57c0a6e7bd$export$ee05aea0aeecbad4)({
                        x: minLeft,
                        y: top,
                        width: maxRight - minLeft,
                        height: bottom - top
                    });
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $bd11d81e56a70d73$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $bd11d81e56a70d73$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $f3f8fa57c0a6e7bd$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $f3f8fa57c0a6e7bd$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $f3f8fa57c0a6e7bd$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $bd11d81e56a70d73$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $f3f8fa57c0a6e7bd$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $bd11d81e56a70d73$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $bd11d81e56a70d73$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $bd11d81e56a70d73$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $f3f8fa57c0a6e7bd$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $f3f8fa57c0a6e7bd$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $f3f8fa57c0a6e7bd$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const clampCoord = (axis, coord)=>(0, $f3f8fa57c0a6e7bd$export$7d15b64cf5a3a4c4)(coord + overflow[axis === 'y' ? 'top' : 'left'], coord, coord - overflow[axis === 'y' ? 'bottom' : 'right']);
            if (checkMainAxis) mainAxisCoord = clampCoord(mainAxis, mainAxisCoord);
            if (checkCrossAxis) crossAxisCoord = clampCoord(crossAxis, crossAxisCoord);
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $bd11d81e56a70d73$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            var _rawOffset$mainAxis, _rawOffset$crossAxis;
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $f3f8fa57c0a6e7bd$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $f3f8fa57c0a6e7bd$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $f3f8fa57c0a6e7bd$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $f3f8fa57c0a6e7bd$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: (_rawOffset$mainAxis = rawOffset.mainAxis) != null ? _rawOffset$mainAxis : 0,
                crossAxis: (_rawOffset$crossAxis = rawOffset.crossAxis) != null ? _rawOffset$crossAxis : 0
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $bd11d81e56a70d73$var$originSides.has((0, $f3f8fa57c0a6e7bd$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
// Method syntax keeps callback parameters bivariant, but expressing the
// explicit `| undefined` required by `exactOptionalPropertyTypes` needs
// property syntax, which is contravariant under `strictFunctionTypes`.
// Extracting the function from a method position restores that bivariance so
// consumers can still assign callbacks with narrower parameter types.
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $bd11d81e56a70d73$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $f3f8fa57c0a6e7bd$export$fef61f332f2c0afc)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $f3f8fa57c0a6e7bd$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $f3f8fa57c0a6e7bd$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $f3f8fa57c0a6e7bd$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $f3f8fa57c0a6e7bd$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $f3f8fa57c0a6e7bd$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const shiftData = state.middlewareData.shift;
            const noShift = !shiftData;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (shiftData != null && shiftData.enabled.x) availableWidth = maximumClippingWidth;
            if (shiftData != null && shiftData.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                if (isYAxis) availableWidth = width - 2 * (0, $f3f8fa57c0a6e7bd$export$8960430cfd85939f)(overflow.left, overflow.right);
                else availableHeight = height - 2 * (0, $f3f8fa57c0a6e7bd$export$8960430cfd85939f)(overflow.top, overflow.bottom);
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $c21a5a2424207adb$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $c21a5a2424207adb$export$651544f548703224(node) {
    if ($c21a5a2424207adb$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $c21a5a2424207adb$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $c21a5a2424207adb$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($c21a5a2424207adb$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $c21a5a2424207adb$export$8ee0fc9ee280b4ee(value) {
    if (!$c21a5a2424207adb$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $c21a5a2424207adb$export$38b2d434cce3ea22(value).Node;
}
function $c21a5a2424207adb$export$45a5e7f76e0caa8d(value) {
    if (!$c21a5a2424207adb$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $c21a5a2424207adb$export$38b2d434cce3ea22(value).Element;
}
function $c21a5a2424207adb$export$1b3bfaa9684536aa(value) {
    if (!$c21a5a2424207adb$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $c21a5a2424207adb$export$38b2d434cce3ea22(value).HTMLElement;
}
function $c21a5a2424207adb$export$af51f0f06c0f328a(value) {
    if (!$c21a5a2424207adb$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $c21a5a2424207adb$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $c21a5a2424207adb$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $c21a5a2424207adb$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $c21a5a2424207adb$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($c21a5a2424207adb$export$651544f548703224(element));
}
function $c21a5a2424207adb$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $c21a5a2424207adb$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $c21a5a2424207adb$var$containRe = /paint|layout|strict|content/;
const $c21a5a2424207adb$var$isNotNone = (value)=>!!value && value !== 'none';
let $c21a5a2424207adb$var$isWebKitValue;
function $c21a5a2424207adb$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $c21a5a2424207adb$export$45a5e7f76e0caa8d(elementOrCss) ? $c21a5a2424207adb$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $c21a5a2424207adb$var$isNotNone(css.transform) || $c21a5a2424207adb$var$isNotNone(css.translate) || $c21a5a2424207adb$var$isNotNone(css.scale) || $c21a5a2424207adb$var$isNotNone(css.rotate) || $c21a5a2424207adb$var$isNotNone(css.perspective) || !$c21a5a2424207adb$export$78551043582a6a98() && ($c21a5a2424207adb$var$isNotNone(css.backdropFilter) || $c21a5a2424207adb$var$isNotNone(css.filter)) || $c21a5a2424207adb$var$willChangeRe.test(css.willChange || '') || $c21a5a2424207adb$var$containRe.test(css.contain || '');
}
function $c21a5a2424207adb$export$940d8225183e1404(element) {
    let currentNode = $c21a5a2424207adb$export$4e12058fc4d51d56(element);
    while($c21a5a2424207adb$export$1b3bfaa9684536aa(currentNode) && !$c21a5a2424207adb$export$d1162fb0b6d4cd51(currentNode)){
        if ($c21a5a2424207adb$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($c21a5a2424207adb$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $c21a5a2424207adb$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $c21a5a2424207adb$export$78551043582a6a98() {
    if ($c21a5a2424207adb$var$isWebKitValue == null) $c21a5a2424207adb$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $c21a5a2424207adb$var$isWebKitValue;
}
function $c21a5a2424207adb$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($c21a5a2424207adb$export$651544f548703224(node));
}
function $c21a5a2424207adb$export$3735103072e4a80(element) {
    return $c21a5a2424207adb$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $c21a5a2424207adb$export$dc8fc79fa2800137(element) {
    if ($c21a5a2424207adb$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $c21a5a2424207adb$export$4e12058fc4d51d56(node) {
    if ($c21a5a2424207adb$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $c21a5a2424207adb$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $c21a5a2424207adb$export$e495491855dc5418(node);
    return $c21a5a2424207adb$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $c21a5a2424207adb$export$7cd01a57c8ca906c(node) {
    const parentNode = $c21a5a2424207adb$export$4e12058fc4d51d56(node);
    if ($c21a5a2424207adb$export$d1162fb0b6d4cd51(parentNode)) return (node.ownerDocument || node).body;
    if ($c21a5a2424207adb$export$1b3bfaa9684536aa(parentNode) && $c21a5a2424207adb$export$989e911fa9af580a(parentNode)) return parentNode;
    return $c21a5a2424207adb$export$7cd01a57c8ca906c(parentNode);
}
function $c21a5a2424207adb$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $c21a5a2424207adb$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $c21a5a2424207adb$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $c21a5a2424207adb$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $c21a5a2424207adb$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $c21a5a2424207adb$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $c21a5a2424207adb$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $c21a5a2424207adb$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $4d3779babf1d63bf$var$getCssDimensions(element) {
    const css = (0, $c21a5a2424207adb$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $c21a5a2424207adb$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $f3f8fa57c0a6e7bd$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $f3f8fa57c0a6e7bd$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $4d3779babf1d63bf$var$unwrapElement(element) {
    return !(0, $c21a5a2424207adb$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $4d3779babf1d63bf$var$getScale(element) {
    const domElement = $4d3779babf1d63bf$var$unwrapElement(element);
    if (!(0, $c21a5a2424207adb$export$1b3bfaa9684536aa)(domElement)) return (0, $f3f8fa57c0a6e7bd$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $4d3779babf1d63bf$var$getCssDimensions(domElement);
    let x = ($ ? (0, $f3f8fa57c0a6e7bd$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $f3f8fa57c0a6e7bd$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $4d3779babf1d63bf$var$noOffsets = /*#__PURE__*/ (0, $f3f8fa57c0a6e7bd$export$a397704b5e280835)(0);
function $4d3779babf1d63bf$var$getVisualOffsets(element) {
    const win = (0, $c21a5a2424207adb$export$38b2d434cce3ea22)(element);
    if (!(0, $c21a5a2424207adb$export$78551043582a6a98)() || !win.visualViewport) return $4d3779babf1d63bf$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $4d3779babf1d63bf$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    return !!floatingOffsetParent && isFixed && floatingOffsetParent === (0, $c21a5a2424207adb$export$38b2d434cce3ea22)(element);
}
function $4d3779babf1d63bf$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $4d3779babf1d63bf$var$unwrapElement(element);
    let scale = (0, $f3f8fa57c0a6e7bd$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $c21a5a2424207adb$export$45a5e7f76e0caa8d)(offsetParent)) scale = $4d3779babf1d63bf$var$getScale(offsetParent);
        } else scale = $4d3779babf1d63bf$var$getScale(element);
    }
    const visualOffsets = $4d3779babf1d63bf$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $4d3779babf1d63bf$var$getVisualOffsets(domElement) : (0, $f3f8fa57c0a6e7bd$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement && offsetParent) {
        const win = (0, $c21a5a2424207adb$export$38b2d434cce3ea22)(domElement);
        const offsetWin = (0, $c21a5a2424207adb$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $c21a5a2424207adb$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $c21a5a2424207adb$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetWin !== currentWin){
            const iframeScale = $4d3779babf1d63bf$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $c21a5a2424207adb$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $c21a5a2424207adb$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $c21a5a2424207adb$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $f3f8fa57c0a6e7bd$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $4d3779babf1d63bf$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $c21a5a2424207adb$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $4d3779babf1d63bf$var$getBoundingClientRect((0, $c21a5a2424207adb$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $4d3779babf1d63bf$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $4d3779babf1d63bf$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $4d3779babf1d63bf$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $c21a5a2424207adb$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $c21a5a2424207adb$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $f3f8fa57c0a6e7bd$export$a397704b5e280835)(1);
    const offsets = (0, $f3f8fa57c0a6e7bd$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $c21a5a2424207adb$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $c21a5a2424207adb$export$651544f548703224)(offsetParent) !== 'body' || (0, $c21a5a2424207adb$export$989e911fa9af580a)(documentElement)) scroll = (0, $c21a5a2424207adb$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $4d3779babf1d63bf$var$getBoundingClientRect(offsetParent);
            scale = $4d3779babf1d63bf$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $4d3779babf1d63bf$var$getHTMLOffset(documentElement, scroll) : (0, $f3f8fa57c0a6e7bd$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $4d3779babf1d63bf$var$getClientRects(element) {
    return element.getClientRects ? Array.from(element.getClientRects()) : [];
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $4d3779babf1d63bf$var$getDocumentRect(html) {
    const scroll = (0, $c21a5a2424207adb$export$dc8fc79fa2800137)(html);
    const body = html.ownerDocument.body;
    const width = (0, $f3f8fa57c0a6e7bd$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $f3f8fa57c0a6e7bd$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $4d3779babf1d63bf$var$getWindowScrollBarX(html);
    const y = -scroll.scrollTop;
    if ((0, $c21a5a2424207adb$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $f3f8fa57c0a6e7bd$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $4d3779babf1d63bf$var$SCROLLBAR_MAX = 25;
function $4d3779babf1d63bf$var$getViewportRect(element, strategy, rootBoundary) {
    if (rootBoundary === void 0) rootBoundary = 'viewport';
    const isLayoutViewport = rootBoundary === 'layoutViewport';
    const win = (0, $c21a5a2424207adb$export$38b2d434cce3ea22)(element);
    const html = (0, $c21a5a2424207adb$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        // Client coordinates are relative to the layout viewport, except in
        // WebKit with an `absolute` strategy, where they are relative to the
        // visual viewport.
        const layoutRelativeClientCoords = !(0, $c21a5a2424207adb$export$78551043582a6a98)() || strategy === 'fixed';
        if (isLayoutViewport) {
            if (!layoutRelativeClientCoords) {
                x = -visualViewport.offsetLeft;
                y = -visualViewport.offsetTop;
            }
        } else {
            width = visualViewport.width;
            height = visualViewport.height;
            if (layoutRelativeClientCoords) {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
    }
    const windowScrollbarX = $4d3779babf1d63bf$var$getWindowScrollBarX(html);
    // `scrollbar-gutter: stable` on the <html> reserves gutter space that shrinks
    // the visual width but isn't reflected in `html.clientWidth`, so subtract it.
    // Only the inline-end (right) gutter can hold the scrollbar; `both-edges` also
    // reserves an empty inline-start gutter that clips nothing, so exclude just
    // the one scrollbar-side gutter — halve the measured (two-gutter) total. A
    // left-side scrollbar (`windowScrollbarX > 0`) is already handled by
    // `getHTMLOffset`/`visualViewport.width`; skip it here.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const reservedWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        const gutter = getComputedStyle(html).scrollbarGutter === 'stable both-edges' ? reservedWidth / 2 : reservedWidth;
        if (gutter <= $4d3779babf1d63bf$var$SCROLLBAR_MAX) width -= gutter;
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $4d3779babf1d63bf$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $4d3779babf1d63bf$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = $4d3779babf1d63bf$var$getScale(element);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $4d3779babf1d63bf$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport' || clippingAncestor === 'layoutViewport') rect = $4d3779babf1d63bf$var$getViewportRect(element, strategy, clippingAncestor);
    else if (clippingAncestor === 'document') rect = $4d3779babf1d63bf$var$getDocumentRect((0, $c21a5a2424207adb$export$e495491855dc5418)(element));
    else if ((0, $c21a5a2424207adb$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $4d3779babf1d63bf$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $4d3779babf1d63bf$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $f3f8fa57c0a6e7bd$export$ee05aea0aeecbad4)(rect);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $4d3779babf1d63bf$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $c21a5a2424207adb$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $c21a5a2424207adb$export$45a5e7f76e0caa8d)(el) && (0, $c21a5a2424207adb$export$651544f548703224)(el) !== 'body');
    let lastKeptComputedStyle = null;
    const elementIsFixed = (0, $c21a5a2424207adb$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $c21a5a2424207adb$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $c21a5a2424207adb$export$45a5e7f76e0caa8d)(currentNode) && !(0, $c21a5a2424207adb$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $c21a5a2424207adb$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $c21a5a2424207adb$export$d6c4e8150c35fed1)(currentNode);
        // Position of the containing block chain below the current node. A fixed
        // element whose containing block hasn't been found yet is a fixed chain.
        const lastPosition = lastKeptComputedStyle ? lastKeptComputedStyle.position : elementIsFixed ? 'fixed' : '';
        // A non-containing ancestor does not clip the element when the chain
        // below it escapes it: a fixed chain escapes all ancestors up to the
        // next containing block, an absolute chain escapes static ancestors.
        const shouldDropCurrentNode = !currentNodeIsContaining && (lastPosition === 'fixed' || lastPosition === 'absolute' && computedStyle.position === 'static');
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // The kept node carries the chain position for the next iteration.
        lastKeptComputedStyle = computedStyle;
        currentNode = (0, $c21a5a2424207adb$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $4d3779babf1d63bf$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $c21a5a2424207adb$export$89e651af02346cd4)(element) ? [] : $4d3779babf1d63bf$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $4d3779babf1d63bf$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $4d3779babf1d63bf$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $f3f8fa57c0a6e7bd$export$8960430cfd85939f)(rect.top, top);
        right = (0, $f3f8fa57c0a6e7bd$export$96ec731ed4dcb222)(rect.right, right);
        bottom = (0, $f3f8fa57c0a6e7bd$export$96ec731ed4dcb222)(rect.bottom, bottom);
        left = (0, $f3f8fa57c0a6e7bd$export$8960430cfd85939f)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $4d3779babf1d63bf$var$getDimensions(element) {
    const { width: width, height: height } = $4d3779babf1d63bf$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $4d3779babf1d63bf$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $c21a5a2424207adb$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $c21a5a2424207adb$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $4d3779babf1d63bf$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $f3f8fa57c0a6e7bd$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isFixed) {
        if ((0, $c21a5a2424207adb$export$651544f548703224)(offsetParent) !== 'body' || (0, $c21a5a2424207adb$export$989e911fa9af580a)(documentElement)) scroll = (0, $c21a5a2424207adb$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $4d3779babf1d63bf$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    if (!isOffsetParentAnElement && documentElement) offsets.x = $4d3779babf1d63bf$var$getWindowScrollBarX(documentElement);
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $4d3779babf1d63bf$var$getHTMLOffset(documentElement, scroll) : (0, $f3f8fa57c0a6e7bd$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $4d3779babf1d63bf$var$isStaticPositioned(element) {
    return (0, $c21a5a2424207adb$export$3735103072e4a80)(element).position === 'static';
}
function $4d3779babf1d63bf$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $c21a5a2424207adb$export$1b3bfaa9684536aa)(element) || (0, $c21a5a2424207adb$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $c21a5a2424207adb$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $4d3779babf1d63bf$var$getOffsetParent(element, polyfill) {
    const win = (0, $c21a5a2424207adb$export$38b2d434cce3ea22)(element);
    if ((0, $c21a5a2424207adb$export$89e651af02346cd4)(element)) return win;
    if (!(0, $c21a5a2424207adb$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $c21a5a2424207adb$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $c21a5a2424207adb$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $c21a5a2424207adb$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$4d3779babf1d63bf$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $c21a5a2424207adb$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $4d3779babf1d63bf$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $c21a5a2424207adb$export$71535ffaa902797f)(offsetParent) && $4d3779babf1d63bf$var$isStaticPositioned(offsetParent))offsetParent = $4d3779babf1d63bf$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $c21a5a2424207adb$export$d1162fb0b6d4cd51)(offsetParent) && $4d3779babf1d63bf$var$isStaticPositioned(offsetParent) && !(0, $c21a5a2424207adb$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $c21a5a2424207adb$export$940d8225183e1404)(element) || win;
}
const $4d3779babf1d63bf$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $4d3779babf1d63bf$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $4d3779babf1d63bf$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $4d3779babf1d63bf$var$isRTL(element) {
    return (0, $c21a5a2424207adb$export$3735103072e4a80)(element).direction === 'rtl';
}
const $4d3779babf1d63bf$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $4d3779babf1d63bf$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $c21a5a2424207adb$export$e495491855dc5418,
    getClippingRect: $4d3779babf1d63bf$var$getClippingRect,
    getOffsetParent: $4d3779babf1d63bf$var$getOffsetParent,
    getElementRects: $4d3779babf1d63bf$var$getElementRects,
    getClientRects: $4d3779babf1d63bf$var$getClientRects,
    getDimensions: $4d3779babf1d63bf$var$getDimensions,
    getScale: $4d3779babf1d63bf$var$getScale,
    isElement: $c21a5a2424207adb$export$45a5e7f76e0caa8d,
    isRTL: $4d3779babf1d63bf$var$isRTL
};
function $4d3779babf1d63bf$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $4d3779babf1d63bf$var$observeMove(element, onMove, ancestorResize) {
    let io = null;
    let timeoutId;
    const root = (0, $c21a5a2424207adb$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $f3f8fa57c0a6e7bd$export$a3fe094919f356fd)(top);
        const insetRight = (0, $f3f8fa57c0a6e7bd$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $f3f8fa57c0a6e7bd$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $f3f8fa57c0a6e7bd$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $f3f8fa57c0a6e7bd$export$8960430cfd85939f)(0, (0, $f3f8fa57c0a6e7bd$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            // The entry is a snapshot, so the reference may have moved since the
            // intersection was computed (under performance constraints, or between
            // consecutive frames of a multi-frame layout shift). The reported ratio
            // and the observed area are stale in that case and cannot be trusted to
            // detect subsequent movement, so refresh regardless of the ratio.
            if (!$4d3779babf1d63bf$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) return refresh();
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped in place, the ratio is 0. Throttle
                // the refresh to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    const win = (0, $c21a5a2424207adb$export$38b2d434cce3ea22)(element);
    // The window is a resize ancestor, so when `ancestorResize` is enabled its
    // listener already runs the update on resize. Here we only need to rebuild
    // the `IntersectionObserver` for the new root size, skipping a redundant
    // update. When `ancestorResize` is disabled, this becomes the sole update.
    const handleResize = ()=>refresh(ancestorResize);
    win.addEventListener('resize', handleResize);
    refresh(true);
    return ()=>{
        win.removeEventListener('resize', handleResize);
        cleanup();
    };
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $4d3779babf1d63bf$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $4d3779babf1d63bf$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $c21a5a2424207adb$export$3b57c1601291186b)(referenceEl) : [],
        ...floating ? (0, $c21a5a2424207adb$export$3b57c1601291186b)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update);
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $4d3779babf1d63bf$var$observeMove(referenceEl, update, ancestorResize) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $4d3779babf1d63bf$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $4d3779babf1d63bf$var$getBoundingClientRect(reference);
        if (prevRefRect && !$4d3779babf1d63bf$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $4d3779babf1d63bf$export$37b6bde19b108ecc = (0, $bd11d81e56a70d73$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $4d3779babf1d63bf$export$cc800923e997bb8 = (0, $bd11d81e56a70d73$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $4d3779babf1d63bf$export$91fb6ecbd551914 = (0, $bd11d81e56a70d73$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $4d3779babf1d63bf$export$fba63a578e423eb = (0, $bd11d81e56a70d73$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $4d3779babf1d63bf$export$8a83211c878a3f1f = (0, $bd11d81e56a70d73$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $4d3779babf1d63bf$export$346677f925de839c = (0, $bd11d81e56a70d73$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $4d3779babf1d63bf$export$fe8985bb6374093c = (0, $bd11d81e56a70d73$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $4d3779babf1d63bf$export$f2120bbfa5450bd2 = (0, $bd11d81e56a70d73$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $4d3779babf1d63bf$export$18c8ad048e32c7d5 = (0, $bd11d81e56a70d73$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $4d3779babf1d63bf$export$7bf07e38f3dc4b69 = (0, $bd11d81e56a70d73$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $4d3779babf1d63bf$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = options != null ? options : {};
    const platformWithCache = {
        ...$4d3779babf1d63bf$export$722a64dea1b767dc,
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $bd11d81e56a70d73$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $3OyDL = parcelRequire("3OyDL");

var $dy6Cj = parcelRequire("dy6Cj");
var $3859e87ff69fb157$var$isClient = typeof document !== 'undefined';
var $3859e87ff69fb157$var$noop = function noop() {};
var $3859e87ff69fb157$var$index = $3859e87ff69fb157$var$isClient ? (0, $3OyDL.useLayoutEffect) : $3859e87ff69fb157$var$noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $3859e87ff69fb157$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$3859e87ff69fb157$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$3859e87ff69fb157$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $3859e87ff69fb157$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $3859e87ff69fb157$var$roundByDPR(element, value) {
    const dpr = $3859e87ff69fb157$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $3859e87ff69fb157$var$useLatestRef(value) {
    const ref = $3OyDL.useRef(value);
    $3859e87ff69fb157$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $3859e87ff69fb157$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $3OyDL.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $3OyDL.useState(middleware);
    if (!$3859e87ff69fb157$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $3OyDL.useState(null);
    const [_floating, _setFloating] = $3OyDL.useState(null);
    const setReference = $3OyDL.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $3OyDL.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $3OyDL.useRef(null);
    const floatingRef = $3OyDL.useRef(null);
    const dataRef = $3OyDL.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $3859e87ff69fb157$var$useLatestRef(whileElementsMounted);
    const platformRef = $3859e87ff69fb157$var$useLatestRef(platform);
    const openRef = $3859e87ff69fb157$var$useLatestRef(open);
    const update = $3OyDL.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $4d3779babf1d63bf$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$3859e87ff69fb157$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $dy6Cj.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $3859e87ff69fb157$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $3OyDL.useRef(false);
    $3859e87ff69fb157$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $3859e87ff69fb157$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $3OyDL.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $3OyDL.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $3OyDL.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $3859e87ff69fb157$var$roundByDPR(elements.floating, data.x);
        const y = $3859e87ff69fb157$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$3859e87ff69fb157$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $3OyDL.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $3859e87ff69fb157$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $4d3779babf1d63bf$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $4d3779babf1d63bf$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $3859e87ff69fb157$export$cc800923e997bb8 = (options, deps)=>{
    const result = (0, $4d3779babf1d63bf$export$cc800923e997bb8)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $3859e87ff69fb157$export$fba63a578e423eb = (options, deps)=>{
    const result = (0, $4d3779babf1d63bf$export$fba63a578e423eb)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $3859e87ff69fb157$export$7bf07e38f3dc4b69 = (options, deps)=>{
    const result = (0, $4d3779babf1d63bf$export$7bf07e38f3dc4b69)(options);
    return {
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $3859e87ff69fb157$export$8a83211c878a3f1f = (options, deps)=>{
    const result = (0, $4d3779babf1d63bf$export$8a83211c878a3f1f)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $3859e87ff69fb157$export$346677f925de839c = (options, deps)=>{
    const result = (0, $4d3779babf1d63bf$export$346677f925de839c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $3859e87ff69fb157$export$91fb6ecbd551914 = (options, deps)=>{
    const result = (0, $4d3779babf1d63bf$export$91fb6ecbd551914)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $3859e87ff69fb157$export$fe8985bb6374093c = (options, deps)=>{
    const result = (0, $4d3779babf1d63bf$export$fe8985bb6374093c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $3859e87ff69fb157$export$18c8ad048e32c7d5 = (options, deps)=>{
    const result = (0, $4d3779babf1d63bf$export$18c8ad048e32c7d5)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $3859e87ff69fb157$export$f2120bbfa5450bd2 = (options, deps)=>{
    const result = $3859e87ff69fb157$var$arrow$1(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};


// src/arrow.tsx

var $3OyDL = parcelRequire("3OyDL");

var $869fj = parcelRequire("869fj");

var $2M70Q = parcelRequire("2M70Q");
var $3088616668b6c94c$var$NAME = "Arrow";
var $3088616668b6c94c$export$21b07c8f274aebd5 = $3OyDL.forwardRef((props, forwardedRef)=>{
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /* @__PURE__ */ (0, $2M70Q.jsx)((0, $869fj.Primitive).svg, {
        ...arrowProps,
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        children: props.asChild ? children : /* @__PURE__ */ (0, $2M70Q.jsx)("polygon", {
            points: "0,0 30,0 15,10"
        })
    });
});
$3088616668b6c94c$export$21b07c8f274aebd5.displayName = $3088616668b6c94c$var$NAME;
var $3088616668b6c94c$export$be92b6f5f03c0fe9 = $3088616668b6c94c$export$21b07c8f274aebd5;



var $i8Ljd = parcelRequire("i8Ljd");

var $9DRZr = parcelRequire("9DRZr");

var $869fj = parcelRequire("869fj");

var $fMVre = parcelRequire("fMVre");

var $4mdWM = parcelRequire("4mdWM");
// src/use-size.tsx

var $3OyDL = parcelRequire("3OyDL");

var $4mdWM = parcelRequire("4mdWM");
function $55d193d8c0a4043f$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = $3OyDL.useState(void 0);
    (0, $4mdWM.useLayoutEffect)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}



var $2M70Q = parcelRequire("2M70Q");
"use client";
var $5ea073c63c3cd5c5$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
var $5ea073c63c3cd5c5$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
var $5ea073c63c3cd5c5$var$POPPER_NAME = "Popper";
var [$5ea073c63c3cd5c5$var$createPopperContext, $5ea073c63c3cd5c5$export$722aac194ae923] = (0, $9DRZr.createContextScope)($5ea073c63c3cd5c5$var$POPPER_NAME);
var [$5ea073c63c3cd5c5$var$PopperProvider, $5ea073c63c3cd5c5$var$usePopperContext] = $5ea073c63c3cd5c5$var$createPopperContext($5ea073c63c3cd5c5$var$POPPER_NAME);
var $5ea073c63c3cd5c5$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = $3OyDL.useState(null);
    const [placementState, setPlacementState] = $3OyDL.useState(void 0);
    return /* @__PURE__ */ (0, $2M70Q.jsx)($5ea073c63c3cd5c5$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor,
        placementState: placementState,
        setPlacementState: setPlacementState,
        children: children
    });
};
$5ea073c63c3cd5c5$export$badac9ada3a0bdf9.displayName = $5ea073c63c3cd5c5$var$POPPER_NAME;
var $5ea073c63c3cd5c5$var$ANCHOR_NAME = "PopperAnchor";
var $5ea073c63c3cd5c5$export$ecd4e1ccab6ed6d = $3OyDL.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $5ea073c63c3cd5c5$var$usePopperContext($5ea073c63c3cd5c5$var$ANCHOR_NAME, __scopePopper);
    const ref = $3OyDL.useRef(null);
    const onAnchorChange = context.onAnchorChange;
    const callbackRef = $3OyDL.useCallback((node)=>{
        ref.current = node;
        if (node) onAnchorChange(node);
    }, [
        onAnchorChange
    ]);
    const composedRefs = (0, $i8Ljd.useComposedRefs)(forwardedRef, callbackRef);
    const anchorRef = $3OyDL.useRef(null);
    $3OyDL.useEffect(()=>{
        if (!virtualRef) return;
        const previousAnchor = anchorRef.current;
        anchorRef.current = virtualRef.current;
        if (previousAnchor !== anchorRef.current) onAnchorChange(anchorRef.current);
    });
    const sideAndAlign = context.placementState && $5ea073c63c3cd5c5$var$getSideAndAlignFromPlacement(context.placementState);
    const placedSide = sideAndAlign?.[0];
    const placedAlign = sideAndAlign?.[1];
    return virtualRef ? null : /* @__PURE__ */ (0, $2M70Q.jsx)((0, $869fj.Primitive).div, {
        "data-radix-popper-side": placedSide,
        "data-radix-popper-align": placedAlign,
        ...anchorProps,
        ref: composedRefs
    });
});
$5ea073c63c3cd5c5$export$ecd4e1ccab6ed6d.displayName = $5ea073c63c3cd5c5$var$ANCHOR_NAME;
var $5ea073c63c3cd5c5$var$CONTENT_NAME = "PopperContent";
var [$5ea073c63c3cd5c5$var$PopperContentProvider, $5ea073c63c3cd5c5$var$useContentContext] = $5ea073c63c3cd5c5$var$createPopperContext($5ea073c63c3cd5c5$var$CONTENT_NAME);
var $5ea073c63c3cd5c5$export$bc4ae5855d3c4fc = $3OyDL.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, side: side = "bottom", sideOffset: sideOffset = 0, align: align = "center", alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, avoidCollisions: avoidCollisions = true, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = "partial", hideWhenDetached: hideWhenDetached = false, updatePositionStrategy: updatePositionStrategy = "optimized", onPlaced: onPlaced, ...contentProps } = props;
    const context = $5ea073c63c3cd5c5$var$usePopperContext($5ea073c63c3cd5c5$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = $3OyDL.useState(null);
    const composedRefs = (0, $i8Ljd.useComposedRefs)(forwardedRef, setContent);
    const [arrow, setArrow] = $3OyDL.useState(null);
    const arrowSize = (0, $55d193d8c0a4043f$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = arrowSize?.width ?? 0;
    const arrowHeight = arrowSize?.height ?? 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($5ea073c63c3cd5c5$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs, floatingStyles: floatingStyles, placement: placement, isPositioned: isPositioned, middlewareData: middlewareData } = (0, $3859e87ff69fb157$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $4d3779babf1d63bf$export$deee3a793edee05f)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $3859e87ff69fb157$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $3859e87ff69fb157$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $3859e87ff69fb157$export$7bf07e38f3dc4b69)() : void 0,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $3859e87ff69fb157$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }),
            (0, $3859e87ff69fb157$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements, rects: rects, availableWidth: availableWidth, availableHeight: availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $3859e87ff69fb157$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $5ea073c63c3cd5c5$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $3859e87ff69fb157$export$fe8985bb6374093c)({
                strategy: "referenceHidden",
                ...detectOverflowOptions,
                // `hide` detects whether the anchor (reference) is clipped, so when
                // no explicit `collisionBoundary` is set we fall back to Floating
                // UI's default clipping ancestors (e.g. a scrollable menu). This
                // lets an occluded submenu hide once its anchor scrolls out of view
                // (#3237). The collision/size middlewares deliberately keep the
                // viewport-based default to avoid clamping content rendered inside
                // transformed or overflow-clipping portal containers.
                boundary: hasExplicitBoundaries ? detectOverflowOptions.boundary : void 0
            })
        ]
    });
    const setPlacementState = context.setPlacementState;
    (0, $4mdWM.useLayoutEffect)(()=>{
        setPlacementState(placement);
        return ()=>{
            setPlacementState(void 0);
        };
    }, [
        placement,
        setPlacementState
    ]);
    const [placedSide, placedAlign] = $5ea073c63c3cd5c5$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $fMVre.useCallbackRef)(onPlaced);
    (0, $4mdWM.useLayoutEffect)(()=>{
        if (isPositioned) handlePlaced?.();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = middlewareData.arrow?.x;
    const arrowY = middlewareData.arrow?.y;
    const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
    const [contentZIndex, setContentZIndex] = $3OyDL.useState();
    (0, $4mdWM.useLayoutEffect)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /* @__PURE__ */ (0, $2M70Q.jsx)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            "--radix-popper-transform-origin": [
                middlewareData.transformOrigin?.x,
                middlewareData.transformOrigin?.y
            ].join(" "),
            // hide the content if using the hide middleware and should be hidden
            // set visibility to hidden and disable pointer events so the UI behaves
            // as if the PopperContent isn't there at all
            ...middlewareData.hide?.referenceHidden && {
                visibility: "hidden",
                pointerEvents: "none"
            }
        },
        dir: props.dir,
        children: /* @__PURE__ */ (0, $2M70Q.jsx)($5ea073c63c3cd5c5$var$PopperContentProvider, {
            scope: __scopePopper,
            placedSide: placedSide,
            placedAlign: placedAlign,
            onArrowChange: setArrow,
            arrowX: arrowX,
            arrowY: arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ (0, $2M70Q.jsx)((0, $869fj.Primitive).div, {
                "data-side": placedSide,
                "data-align": placedAlign,
                ...contentProps,
                ref: composedRefs,
                style: {
                    ...contentProps.style,
                    // if the PopperContent hasn't been placed yet (not all measurements done)
                    // we prevent animations so that users's animation don't kick in too early referring wrong sides
                    animation: !isPositioned ? "none" : void 0
                }
            })
        })
    });
});
$5ea073c63c3cd5c5$export$bc4ae5855d3c4fc.displayName = $5ea073c63c3cd5c5$var$CONTENT_NAME;
var $5ea073c63c3cd5c5$var$ARROW_NAME = "PopperArrow";
var $5ea073c63c3cd5c5$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
var $5ea073c63c3cd5c5$export$79d62cd4e10a3fd0 = $3OyDL.forwardRef(function PopperArrow2(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $5ea073c63c3cd5c5$var$useContentContext($5ea073c63c3cd5c5$var$ARROW_NAME, __scopePopper);
    const baseSide = $5ea073c63c3cd5c5$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(// we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ (0, $2M70Q.jsx)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ (0, $2M70Q.jsx)($3088616668b6c94c$export$be92b6f5f03c0fe9, {
            ...arrowProps,
            ref: forwardedRef,
            style: {
                ...arrowProps.style,
                // ensures the element can be measured correctly (mostly for if SVG)
                display: "block"
            }
        })
    }));
});
$5ea073c63c3cd5c5$export$79d62cd4e10a3fd0.displayName = $5ea073c63c3cd5c5$var$ARROW_NAME;
function $5ea073c63c3cd5c5$var$isNotNull(value) {
    return value !== null;
}
var $5ea073c63c3cd5c5$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $5ea073c63c3cd5c5$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = (middlewareData.arrow?.x ?? 0) + arrowWidth / 2;
            const arrowYCenter = (middlewareData.arrow?.y ?? 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $5ea073c63c3cd5c5$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
var $5ea073c63c3cd5c5$export$be92b6f5f03c0fe9 = $5ea073c63c3cd5c5$export$badac9ada3a0bdf9;
var $5ea073c63c3cd5c5$export$b688253958b8dfe7 = $5ea073c63c3cd5c5$export$ecd4e1ccab6ed6d;
var $5ea073c63c3cd5c5$export$7c6e2c02157bb7d2 = $5ea073c63c3cd5c5$export$bc4ae5855d3c4fc;
var $5ea073c63c3cd5c5$export$21b07c8f274aebd5 = $5ea073c63c3cd5c5$export$79d62cd4e10a3fd0;



var $74zAC = parcelRequire("74zAC");

var $c1I0K = parcelRequire("c1I0K");

var $869fj = parcelRequire("869fj");

var $aDFmZ = parcelRequire("aDFmZ");

var $2UbMs = parcelRequire("2UbMs");
// src/visually-hidden.tsx

var $3OyDL = parcelRequire("3OyDL");

var $869fj = parcelRequire("869fj");

var $2M70Q = parcelRequire("2M70Q");
var $290a874c174c5692$export$f23ec2f542b3b173 = Object.freeze({
    // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal"
});
var $290a874c174c5692$var$NAME = "VisuallyHidden";
var $290a874c174c5692$export$439d29a4e110a164 = $3OyDL.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, $2M70Q.jsx)((0, $869fj.Primitive).span, {
        ...props,
        ref: forwardedRef,
        style: {
            ...$290a874c174c5692$export$f23ec2f542b3b173,
            ...props.style
        }
    });
});
$290a874c174c5692$export$439d29a4e110a164.displayName = $290a874c174c5692$var$NAME;
var $290a874c174c5692$export$be92b6f5f03c0fe9 = $290a874c174c5692$export$439d29a4e110a164;



var $2M70Q = parcelRequire("2M70Q");
"use client";
var [$223a2adcee98292d$var$createTooltipContext, $223a2adcee98292d$export$1c540a2224f0d865] = (0, $9DRZr.createContextScope)("Tooltip", [
    (0, $5ea073c63c3cd5c5$export$722aac194ae923)
]);
var $223a2adcee98292d$var$usePopperScope = (0, $5ea073c63c3cd5c5$export$722aac194ae923)();
var $223a2adcee98292d$var$PROVIDER_NAME = "TooltipProvider";
var $223a2adcee98292d$var$DEFAULT_DELAY_DURATION = 700;
var $223a2adcee98292d$var$TOOLTIP_OPEN = "tooltip.open";
var [$223a2adcee98292d$var$TooltipProviderContextProvider, $223a2adcee98292d$var$useTooltipProviderContext] = $223a2adcee98292d$var$createTooltipContext($223a2adcee98292d$var$PROVIDER_NAME);
var $223a2adcee98292d$export$f78649fb9ca566b8 = (props)=>{
    const { __scopeTooltip: __scopeTooltip, delayDuration: delayDuration = $223a2adcee98292d$var$DEFAULT_DELAY_DURATION, skipDelayDuration: skipDelayDuration = 300, disableHoverableContent: disableHoverableContent = false, children: children } = props;
    const isOpenDelayedRef = $3OyDL.useRef(true);
    const isPointerInTransitRef = $3OyDL.useRef(false);
    const skipDelayTimerRef = $3OyDL.useRef(0);
    $3OyDL.useEffect(()=>{
        const skipDelayTimer = skipDelayTimerRef.current;
        return ()=>window.clearTimeout(skipDelayTimer);
    }, []);
    return /* @__PURE__ */ (0, $2M70Q.jsx)($223a2adcee98292d$var$TooltipProviderContextProvider, {
        scope: __scopeTooltip,
        isOpenDelayedRef: isOpenDelayedRef,
        delayDuration: delayDuration,
        onOpen: $3OyDL.useCallback(()=>{
            if (skipDelayDuration <= 0) return;
            window.clearTimeout(skipDelayTimerRef.current);
            isOpenDelayedRef.current = false;
        }, [
            skipDelayDuration
        ]),
        onClose: $3OyDL.useCallback(()=>{
            if (skipDelayDuration <= 0) return;
            window.clearTimeout(skipDelayTimerRef.current);
            skipDelayTimerRef.current = window.setTimeout(()=>isOpenDelayedRef.current = true, skipDelayDuration);
        }, [
            skipDelayDuration
        ]),
        isPointerInTransitRef: isPointerInTransitRef,
        onPointerInTransitChange: $3OyDL.useCallback((inTransit)=>{
            isPointerInTransitRef.current = inTransit;
        }, []),
        disableHoverableContent: disableHoverableContent,
        children: children
    });
};
$223a2adcee98292d$export$f78649fb9ca566b8.displayName = $223a2adcee98292d$var$PROVIDER_NAME;
var $223a2adcee98292d$var$TOOLTIP_NAME = "Tooltip";
var [$223a2adcee98292d$var$TooltipContextProvider, $223a2adcee98292d$var$useTooltipContext] = $223a2adcee98292d$var$createTooltipContext($223a2adcee98292d$var$TOOLTIP_NAME);
var $223a2adcee98292d$export$28c660c63b792dea = (props)=>{
    const { __scopeTooltip: __scopeTooltip, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, disableHoverableContent: disableHoverableContentProp, delayDuration: delayDurationProp } = props;
    const providerContext = $223a2adcee98292d$var$useTooltipProviderContext($223a2adcee98292d$var$TOOLTIP_NAME, props.__scopeTooltip);
    const popperScope = $223a2adcee98292d$var$usePopperScope(__scopeTooltip);
    const [trigger, setTrigger] = $3OyDL.useState(null);
    const contentId = (0, $lQlfC.useId)();
    const openTimerRef = $3OyDL.useRef(0);
    const disableHoverableContent = disableHoverableContentProp ?? providerContext.disableHoverableContent;
    const delayDuration = delayDurationProp ?? providerContext.delayDuration;
    const wasOpenDelayedRef = $3OyDL.useRef(false);
    const [open, setOpen] = (0, $2UbMs.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: (open2)=>{
            if (open2) {
                providerContext.onOpen();
                document.dispatchEvent(new CustomEvent($223a2adcee98292d$var$TOOLTIP_OPEN));
            } else providerContext.onClose();
            onOpenChange?.(open2);
        },
        caller: $223a2adcee98292d$var$TOOLTIP_NAME
    });
    const stateAttribute = $3OyDL.useMemo(()=>{
        return open ? wasOpenDelayedRef.current ? "delayed-open" : "instant-open" : "closed";
    }, [
        open
    ]);
    const handleOpen = $3OyDL.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = 0;
        wasOpenDelayedRef.current = false;
        setOpen(true);
    }, [
        setOpen
    ]);
    const handleClose = $3OyDL.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = 0;
        setOpen(false);
    }, [
        setOpen
    ]);
    const handleDelayedOpen = $3OyDL.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = window.setTimeout(()=>{
            wasOpenDelayedRef.current = true;
            setOpen(true);
            openTimerRef.current = 0;
        }, delayDuration);
    }, [
        delayDuration,
        setOpen
    ]);
    $3OyDL.useEffect(()=>{
        return ()=>{
            if (openTimerRef.current) {
                window.clearTimeout(openTimerRef.current);
                openTimerRef.current = 0;
            }
        };
    }, []);
    return /* @__PURE__ */ (0, $2M70Q.jsx)($5ea073c63c3cd5c5$export$be92b6f5f03c0fe9, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $2M70Q.jsx)($223a2adcee98292d$var$TooltipContextProvider, {
            scope: __scopeTooltip,
            contentId: contentId,
            open: open,
            stateAttribute: stateAttribute,
            trigger: trigger,
            onTriggerChange: setTrigger,
            onTriggerEnter: $3OyDL.useCallback(()=>{
                if (providerContext.isOpenDelayedRef.current) handleDelayedOpen();
                else handleOpen();
            }, [
                providerContext.isOpenDelayedRef,
                handleDelayedOpen,
                handleOpen
            ]),
            onTriggerLeave: $3OyDL.useCallback(()=>{
                if (disableHoverableContent) handleClose();
                else {
                    window.clearTimeout(openTimerRef.current);
                    openTimerRef.current = 0;
                }
            }, [
                handleClose,
                disableHoverableContent
            ]),
            onOpen: handleOpen,
            onClose: handleClose,
            disableHoverableContent: disableHoverableContent,
            children: children
        })
    });
};
$223a2adcee98292d$export$28c660c63b792dea.displayName = $223a2adcee98292d$var$TOOLTIP_NAME;
var $223a2adcee98292d$var$TRIGGER_NAME = "TooltipTrigger";
var $223a2adcee98292d$export$8c610744efcf8a1d = $3OyDL.forwardRef((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, ...triggerProps } = props;
    const context = $223a2adcee98292d$var$useTooltipContext($223a2adcee98292d$var$TRIGGER_NAME, __scopeTooltip);
    const providerContext = $223a2adcee98292d$var$useTooltipProviderContext($223a2adcee98292d$var$TRIGGER_NAME, __scopeTooltip);
    const popperScope = $223a2adcee98292d$var$usePopperScope(__scopeTooltip);
    const ref = $3OyDL.useRef(null);
    const composedRefs = (0, $i8Ljd.useComposedRefs)(forwardedRef, ref, context.onTriggerChange);
    const isPointerDownRef = $3OyDL.useRef(false);
    const hasPointerMoveOpenedRef = $3OyDL.useRef(false);
    const handlePointerUp = $3OyDL.useCallback(()=>isPointerDownRef.current = false, []);
    $3OyDL.useEffect(()=>{
        return ()=>document.removeEventListener("pointerup", handlePointerUp);
    }, [
        handlePointerUp
    ]);
    return /* @__PURE__ */ (0, $2M70Q.jsx)($5ea073c63c3cd5c5$export$b688253958b8dfe7, {
        asChild: true,
        ...popperScope,
        children: /* @__PURE__ */ (0, $2M70Q.jsx)((0, $869fj.Primitive).button, {
            "aria-describedby": context.open ? context.contentId : void 0,
            "data-state": context.stateAttribute,
            ...triggerProps,
            ref: composedRefs,
            onPointerMove: (0, $3j7Yq.composeEventHandlers)(props.onPointerMove, (event)=>{
                if (event.pointerType === "touch") return;
                if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
                    context.onTriggerEnter();
                    hasPointerMoveOpenedRef.current = true;
                }
            }),
            onPointerLeave: (0, $3j7Yq.composeEventHandlers)(props.onPointerLeave, ()=>{
                context.onTriggerLeave();
                hasPointerMoveOpenedRef.current = false;
            }),
            onPointerDown: (0, $3j7Yq.composeEventHandlers)(props.onPointerDown, ()=>{
                if (context.open) context.onClose();
                isPointerDownRef.current = true;
                document.addEventListener("pointerup", handlePointerUp, {
                    once: true
                });
            }),
            onFocus: (0, $3j7Yq.composeEventHandlers)(props.onFocus, ()=>{
                if (!isPointerDownRef.current) context.onOpen();
            }),
            onBlur: (0, $3j7Yq.composeEventHandlers)(props.onBlur, context.onClose),
            onClick: (0, $3j7Yq.composeEventHandlers)(props.onClick, context.onClose)
        })
    });
});
$223a2adcee98292d$export$8c610744efcf8a1d.displayName = $223a2adcee98292d$var$TRIGGER_NAME;
var $223a2adcee98292d$var$PORTAL_NAME = "TooltipPortal";
var [$223a2adcee98292d$var$PortalProvider, $223a2adcee98292d$var$usePortalContext] = $223a2adcee98292d$var$createTooltipContext($223a2adcee98292d$var$PORTAL_NAME, {
    forceMount: void 0
});
var $223a2adcee98292d$export$7b36b8f925ab7497 = (props)=>{
    const { __scopeTooltip: __scopeTooltip, forceMount: forceMount, children: children, container: container } = props;
    const context = $223a2adcee98292d$var$useTooltipContext($223a2adcee98292d$var$PORTAL_NAME, __scopeTooltip);
    return /* @__PURE__ */ (0, $2M70Q.jsx)($223a2adcee98292d$var$PortalProvider, {
        scope: __scopeTooltip,
        forceMount: forceMount,
        children: /* @__PURE__ */ (0, $2M70Q.jsx)((0, $c1I0K.Presence), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $2M70Q.jsx)((0, $74zAC.Portal), {
                asChild: true,
                container: container,
                children: children
            })
        })
    });
};
$223a2adcee98292d$export$7b36b8f925ab7497.displayName = $223a2adcee98292d$var$PORTAL_NAME;
var $223a2adcee98292d$var$CONTENT_NAME = "TooltipContent";
var $223a2adcee98292d$export$e9003e2be37ec060 = $3OyDL.forwardRef((props, forwardedRef)=>{
    const portalContext = $223a2adcee98292d$var$usePortalContext($223a2adcee98292d$var$CONTENT_NAME, props.__scopeTooltip);
    const { forceMount: forceMount = portalContext.forceMount, side: side = "top", ...contentProps } = props;
    const context = $223a2adcee98292d$var$useTooltipContext($223a2adcee98292d$var$CONTENT_NAME, props.__scopeTooltip);
    return /* @__PURE__ */ (0, $2M70Q.jsx)((0, $c1I0K.Presence), {
        present: forceMount || context.open,
        children: context.disableHoverableContent ? /* @__PURE__ */ (0, $2M70Q.jsx)($223a2adcee98292d$var$TooltipContentImpl, {
            side: side,
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $2M70Q.jsx)($223a2adcee98292d$var$TooltipContentHoverable, {
            side: side,
            ...contentProps,
            ref: forwardedRef
        })
    });
});
var $223a2adcee98292d$var$TooltipContentHoverable = $3OyDL.forwardRef((props, forwardedRef)=>{
    const context = $223a2adcee98292d$var$useTooltipContext($223a2adcee98292d$var$CONTENT_NAME, props.__scopeTooltip);
    const providerContext = $223a2adcee98292d$var$useTooltipProviderContext($223a2adcee98292d$var$CONTENT_NAME, props.__scopeTooltip);
    const ref = $3OyDL.useRef(null);
    const composedRefs = (0, $i8Ljd.useComposedRefs)(forwardedRef, ref);
    const [pointerGraceArea, setPointerGraceArea] = $3OyDL.useState(null);
    const { trigger: trigger, onClose: onClose } = context;
    const content = ref.current;
    const { onPointerInTransitChange: onPointerInTransitChange } = providerContext;
    const handleRemoveGraceArea = $3OyDL.useCallback(()=>{
        setPointerGraceArea(null);
        onPointerInTransitChange(false);
    }, [
        onPointerInTransitChange
    ]);
    const handleCreateGraceArea = $3OyDL.useCallback((event, hoverTarget)=>{
        const currentTarget = event.currentTarget;
        const exitPoint = {
            x: event.clientX,
            y: event.clientY
        };
        const exitSide = $223a2adcee98292d$var$getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
        const paddedExitPoints = $223a2adcee98292d$var$getPaddedExitPoints(exitPoint, exitSide);
        const hoverTargetPoints = $223a2adcee98292d$var$getPointsFromRect(hoverTarget.getBoundingClientRect());
        const graceArea = $223a2adcee98292d$var$getHull([
            ...paddedExitPoints,
            ...hoverTargetPoints
        ]);
        setPointerGraceArea(graceArea);
        onPointerInTransitChange(true);
    }, [
        onPointerInTransitChange
    ]);
    $3OyDL.useEffect(()=>{
        return ()=>handleRemoveGraceArea();
    }, [
        handleRemoveGraceArea
    ]);
    $3OyDL.useEffect(()=>{
        if (trigger && content) {
            const handleTriggerLeave = (event)=>handleCreateGraceArea(event, content);
            const handleContentLeave = (event)=>handleCreateGraceArea(event, trigger);
            trigger.addEventListener("pointerleave", handleTriggerLeave);
            content.addEventListener("pointerleave", handleContentLeave);
            return ()=>{
                trigger.removeEventListener("pointerleave", handleTriggerLeave);
                content.removeEventListener("pointerleave", handleContentLeave);
            };
        }
    }, [
        trigger,
        content,
        handleCreateGraceArea,
        handleRemoveGraceArea
    ]);
    $3OyDL.useEffect(()=>{
        if (pointerGraceArea) {
            const handleTrackPointerGrace = (event)=>{
                const target = event.target;
                const pointerPosition = {
                    x: event.clientX,
                    y: event.clientY
                };
                const hasEnteredTarget = trigger?.contains(target) || content?.contains(target);
                const isPointerOutsideGraceArea = !$223a2adcee98292d$var$isPointInPolygon(pointerPosition, pointerGraceArea);
                if (hasEnteredTarget) handleRemoveGraceArea();
                else if (isPointerOutsideGraceArea) {
                    handleRemoveGraceArea();
                    onClose();
                }
            };
            document.addEventListener("pointermove", handleTrackPointerGrace);
            return ()=>document.removeEventListener("pointermove", handleTrackPointerGrace);
        }
    }, [
        trigger,
        content,
        pointerGraceArea,
        onClose,
        handleRemoveGraceArea
    ]);
    return /* @__PURE__ */ (0, $2M70Q.jsx)($223a2adcee98292d$var$TooltipContentImpl, {
        ...props,
        ref: composedRefs
    });
});
var [$223a2adcee98292d$var$VisuallyHiddenContentContextProvider, $223a2adcee98292d$var$useVisuallyHiddenContentContext] = $223a2adcee98292d$var$createTooltipContext($223a2adcee98292d$var$TOOLTIP_NAME, {
    isInside: false
});
var $223a2adcee98292d$var$Slottable = (0, $aDFmZ.createSlottable)("TooltipContent");
var $223a2adcee98292d$var$TooltipContentImpl = $3OyDL.forwardRef((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, children: children, "aria-label": ariaLabel, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, ...contentProps } = props;
    const context = $223a2adcee98292d$var$useTooltipContext($223a2adcee98292d$var$CONTENT_NAME, __scopeTooltip);
    const popperScope = $223a2adcee98292d$var$usePopperScope(__scopeTooltip);
    const { onClose: onClose } = context;
    $3OyDL.useEffect(()=>{
        document.addEventListener($223a2adcee98292d$var$TOOLTIP_OPEN, onClose);
        return ()=>document.removeEventListener($223a2adcee98292d$var$TOOLTIP_OPEN, onClose);
    }, [
        onClose
    ]);
    $3OyDL.useEffect(()=>{
        if (context.trigger) {
            const handleScroll = (event)=>{
                if (event.target instanceof Node && event.target.contains(context.trigger)) onClose();
            };
            window.addEventListener("scroll", handleScroll, {
                capture: true
            });
            return ()=>window.removeEventListener("scroll", handleScroll, {
                    capture: true
                });
        }
    }, [
        context.trigger,
        onClose
    ]);
    return /* @__PURE__ */ (0, $2M70Q.jsx)((0, $dTBEM.DismissableLayer), {
        asChild: true,
        disableOutsidePointerEvents: false,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: (event)=>event.preventDefault(),
        onDismiss: onClose,
        children: /* @__PURE__ */ (0, $2M70Q.jsxs)($5ea073c63c3cd5c5$export$7c6e2c02157bb7d2, {
            "data-state": context.stateAttribute,
            ...popperScope,
            ...contentProps,
            ref: forwardedRef,
            style: {
                ...contentProps.style,
                "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
                "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
                "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
                "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
                "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
                /* @__PURE__ */ (0, $2M70Q.jsx)($223a2adcee98292d$var$Slottable, {
                    children: children
                }),
                /* @__PURE__ */ (0, $2M70Q.jsx)($223a2adcee98292d$var$VisuallyHiddenContentContextProvider, {
                    scope: __scopeTooltip,
                    isInside: true,
                    children: /* @__PURE__ */ (0, $2M70Q.jsx)($290a874c174c5692$export$be92b6f5f03c0fe9, {
                        id: context.contentId,
                        role: "tooltip",
                        children: ariaLabel || children
                    })
                })
            ]
        })
    });
});
$223a2adcee98292d$export$e9003e2be37ec060.displayName = $223a2adcee98292d$var$CONTENT_NAME;
var $223a2adcee98292d$var$ARROW_NAME = "TooltipArrow";
var $223a2adcee98292d$export$c27ee0ad710f7559 = $3OyDL.forwardRef((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, ...arrowProps } = props;
    const popperScope = $223a2adcee98292d$var$usePopperScope(__scopeTooltip);
    const visuallyHiddenContentContext = $223a2adcee98292d$var$useVisuallyHiddenContentContext($223a2adcee98292d$var$ARROW_NAME, __scopeTooltip);
    return visuallyHiddenContentContext.isInside ? null : /* @__PURE__ */ (0, $2M70Q.jsx)($5ea073c63c3cd5c5$export$21b07c8f274aebd5, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$223a2adcee98292d$export$c27ee0ad710f7559.displayName = $223a2adcee98292d$var$ARROW_NAME;
function $223a2adcee98292d$var$getExitSideFromRect(point, rect) {
    const top = Math.abs(rect.top - point.y);
    const bottom = Math.abs(rect.bottom - point.y);
    const right = Math.abs(rect.right - point.x);
    const left = Math.abs(rect.left - point.x);
    switch(Math.min(top, bottom, right, left)){
        case left:
            return "left";
        case right:
            return "right";
        case top:
            return "top";
        case bottom:
            return "bottom";
        default:
            throw new Error("unreachable");
    }
}
function $223a2adcee98292d$var$getPaddedExitPoints(exitPoint, exitSide, padding = 5) {
    const paddedExitPoints = [];
    switch(exitSide){
        case "top":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "bottom":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            });
            break;
        case "left":
            paddedExitPoints.push({
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "right":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            });
            break;
    }
    return paddedExitPoints;
}
function $223a2adcee98292d$var$getPointsFromRect(rect) {
    const { top: top, right: right, bottom: bottom, left: left } = rect;
    return [
        {
            x: left,
            y: top
        },
        {
            x: right,
            y: top
        },
        {
            x: right,
            y: bottom
        },
        {
            x: left,
            y: bottom
        }
    ];
}
function $223a2adcee98292d$var$isPointInPolygon(point, polygon) {
    const { x: x, y: y } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const ii = polygon[i];
        const jj = polygon[j];
        const xi = ii.x;
        const yi = ii.y;
        const xj = jj.x;
        const yj = jj.y;
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function $223a2adcee98292d$var$getHull(points) {
    const newPoints = points.slice();
    newPoints.sort((a, b)=>{
        if (a.x < b.x) return -1;
        else if (a.x > b.x) return 1;
        else if (a.y < b.y) return -1;
        else if (a.y > b.y) return 1;
        else return 0;
    });
    return $223a2adcee98292d$var$getHullPresorted(newPoints);
}
function $223a2adcee98292d$var$getHullPresorted(points) {
    if (points.length <= 1) return points.slice();
    const upperHull = [];
    for(let i = 0; i < points.length; i++){
        const p = points[i];
        while(upperHull.length >= 2){
            const q = upperHull[upperHull.length - 1];
            const r = upperHull[upperHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) upperHull.pop();
            else break;
        }
        upperHull.push(p);
    }
    upperHull.pop();
    const lowerHull = [];
    for(let i = points.length - 1; i >= 0; i--){
        const p = points[i];
        while(lowerHull.length >= 2){
            const q = lowerHull[lowerHull.length - 1];
            const r = lowerHull[lowerHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) lowerHull.pop();
            else break;
        }
        lowerHull.push(p);
    }
    lowerHull.pop();
    if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) return upperHull;
    else return upperHull.concat(lowerHull);
}
var $223a2adcee98292d$export$2881499e37b75b9a = $223a2adcee98292d$export$f78649fb9ca566b8;
var $223a2adcee98292d$export$be92b6f5f03c0fe9 = $223a2adcee98292d$export$28c660c63b792dea;
var $223a2adcee98292d$export$41fb9f06171c75f4 = $223a2adcee98292d$export$8c610744efcf8a1d;
var $223a2adcee98292d$export$602eac185826482c = $223a2adcee98292d$export$7b36b8f925ab7497;
var $223a2adcee98292d$export$7c6e2c02157bb7d2 = $223a2adcee98292d$export$e9003e2be37ec060;
var $223a2adcee98292d$export$21b07c8f274aebd5 = $223a2adcee98292d$export$c27ee0ad710f7559;



var $hZu6m = parcelRequire("hZu6m");
var $619y7 = parcelRequire("619y7");
var $c7uHF = parcelRequire("c7uHF");
parcelRequire("3OyDL");
/**
 * Channel icons for a phone number. One number can be active on several
 * channels simultaneously, so this renders a set, not a single badge.
 *
 * Channel *codes* come from seed data (product-neutrality rule) — this map is
 * presentation only, and an unknown code degrades to a neutral icon rather
 * than breaking. It never decides which channels exist.
 */ const $ccacecf78328396f$var$CHANNEL_ICONS = {
    PHONE_CALL: (0, $619y7.default),
    WHATSAPP: (0, $hZu6m.default),
    BALE: (0, $c7uHF.default),
    EITAA: (0, $c7uHF.default),
    INSTAGRAM: (0, $hZu6m.default)
};
function $ccacecf78328396f$export$f9f39c056569f034({ channels: channels = [] }) {
    if (channels.length === 0) return /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
        className: "text-text-muted",
        children: "\u2014"
    });
    return /*#__PURE__*/ (0, $2M70Q.jsx)($223a2adcee98292d$export$2881499e37b75b9a, {
        delayDuration: 200,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
            className: "flex items-center gap-2",
            children: channels.map((channel)=>{
                const Icon = $ccacecf78328396f$var$CHANNEL_ICONS[channel.code] ?? (0, $hZu6m.default);
                return /*#__PURE__*/ (0, $2M70Q.jsxs)($223a2adcee98292d$export$be92b6f5f03c0fe9, {
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)($223a2adcee98292d$export$41fb9f06171c75f4, {
                            asChild: true,
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                className: "text-text-muted",
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)(Icon, {
                                    size: 14,
                                    "aria-label": channel.labelFa
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)($223a2adcee98292d$export$602eac185826482c, {
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)($223a2adcee98292d$export$7c6e2c02157bb7d2, {
                                dir: "rtl",
                                sideOffset: 4,
                                className: "rounded border border-border bg-surface px-3 py-1 text-xs shadow-md",
                                children: channel.labelFa
                            })
                        })
                    ]
                }, channel.id);
            })
        })
    });
}


/**
 * A contact's photo, with a gender-aware placeholder and an initials fallback.
 *
 * Two sizes, both from the design system's density tokens: `thumb` for the
 * dense table, `avatar` for the profile header. Nothing in between — a third
 * size would be a per-screen guess.
 *
 * The photo is an attachment like any other (owner_type CONTACT_PHOTO); the
 * upload goes through the same initiate/PUT/complete flow as a file on an
 * interaction, with an images-only allowlist and a smaller cap enforced
 * server-side.
 *
 * THE THREE STATES, in order:
 *
 *   1. a real photo    — always wins;
 *   2. no photo, gender on file — the ♂/♀ glyph;
 *   3. no photo, no gender      — the initials, which is what this component
 *      has always shown and the fallback the deployment already has.
 *
 * **Why a glyph and not an illustration.** No image assets ship with this
 * client — only the Vazirmatn faces — and adding a pair of drawn avatars would
 * be a new asset for a circle the size of a table thumbnail. `lucide-react` is
 * already the icon set
 * everywhere, and `Mars`/`Venus` are the only pair in it that actually
 * distinguishes the two; `User` and `UserRound` differ by shoulder shape, not
 * by gender. **No colour coding**: both glyphs render in the same muted token
 * as the initials they replace, because pink-and-blue would be a second, worse
 * way of saying what the glyph already says.
 *
 * The trade-off is real and deliberate: a named male contact shows ♂ rather
 * than their own initials, which carry more information. That is what the
 * placeholder was asked to do, and gender-unknown still keeps the initials.
 */ 
var $2M70Q = parcelRequire("2M70Q");


var $jVTfU = parcelRequire("jVTfU");/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $f0e5b453377c4c59$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 3h5v5",
            key: "1806ms"
        }
    ],
    [
        "path",
        {
            d: "m21 3-6.75 6.75",
            key: "pv0uzu"
        }
    ],
    [
        "circle",
        {
            cx: "10",
            cy: "14",
            r: "6",
            key: "1qwbdc"
        }
    ]
];
const $f0e5b453377c4c59$export$2e2bcd8739ae039 = (0, $djixo.default)("mars", $f0e5b453377c4c59$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $17369866e6c80feb$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 15v7",
            key: "t2xh3l"
        }
    ],
    [
        "path",
        {
            d: "M9 19h6",
            key: "456am0"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "9",
            r: "6",
            key: "1nw4tq"
        }
    ]
];
const $17369866e6c80feb$export$2e2bcd8739ae039 = (0, $djixo.default)("venus", $17369866e6c80feb$export$3efd853dbb351e94);



var $3OyDL = parcelRequire("3OyDL");


/** Initials from a display name — the fallback when there is no photo. */ function $f1ac2c7aaec4c80d$var$initials(name) {
    const parts = (name ?? '').trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return "\u061F";
    if (parts.length === 1) return parts[0].slice(0, 1);
    return `${parts[0].slice(0, 1)}${parts[parts.length - 1].slice(0, 1)}`;
}
/** MALE and FEMALE only. OTHER and unset both fall through to the initials —
 *  a glyph for "other" would be guessing at how somebody wants to be shown. */ const $f1ac2c7aaec4c80d$var$GENDER_GLYPH = {
    MALE: (0, $f0e5b453377c4c59$export$2e2bcd8739ae039),
    FEMALE: (0, $17369866e6c80feb$export$2e2bcd8739ae039)
};
function $f1ac2c7aaec4c80d$export$5f6775a0d87895ab({ name: name, url: url, gender: gender, size: size = 'thumb' }) {
    const box = size === 'avatar' ? 'h-avatar w-avatar text-lg' : 'h-thumb w-thumb text-xs';
    if (url) return /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
        src: url,
        alt: "",
        className: `${box} shrink-0 rounded-full border border-border object-cover`
    });
    const Glyph = $f1ac2c7aaec4c80d$var$GENDER_GLYPH[gender];
    const label = Glyph ? (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.genderAvatar[gender] : undefined;
    return /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
        // The glyph SAYS something (this contact is a man / a woman), so unlike
        // the initials it is not decorative and carries a label. The initials
        // stay aria-hidden: they repeat the name in the cell beside them.
        "aria-hidden": Glyph ? undefined : 'true',
        role: Glyph ? 'img' : undefined,
        "aria-label": label,
        title: label,
        className: `${box} flex shrink-0 items-center justify-center rounded-full border
                  border-border bg-surface-hover font-medium text-text-muted`,
        children: Glyph ? /*#__PURE__*/ (0, $2M70Q.jsx)(Glyph, {
            size: size === 'avatar' ? 22 : 14,
            "aria-hidden": "true"
        }) : $f1ac2c7aaec4c80d$var$initials(name)
    });
}
function $f1ac2c7aaec4c80d$export$35cbab2db7d9997e({ contactId: contactId, name: name, url: url, gender: gender, onUploaded: onUploaded, disabled: disabled }) {
    const inputRef = (0, $3OyDL.useRef)(null);
    const [busy, setBusy] = (0, $3OyDL.useState)(false);
    const [error, setError] = (0, $3OyDL.useState)(null);
    async function handleFile(file) {
        if (!file) return;
        setBusy(true);
        setError(null);
        try {
            await (0, $d305624b55b31f43$export$a5575dbeeffdad98)({
                file: file,
                ownerType: 'CONTACT_PHOTO',
                ownerId: contactId
            });
            await onUploaded?.();
        } catch (err) {
            setError(err.message);
        } finally{
            setBusy(false);
            // Reset so choosing the same file twice fires a change event again.
            if (inputRef.current) inputRef.current.value = '';
        }
    }
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex flex-col items-center gap-1",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("button", {
                type: "button",
                disabled: disabled || busy,
                onClick: ()=>inputRef.current?.click(),
                title: url ? (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.replacePhoto : (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.uploadPhoto,
                "aria-label": url ? (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.replacePhoto : (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.uploadPhoto,
                className: "group relative rounded-full focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-primary disabled:opacity-60",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)($f1ac2c7aaec4c80d$export$5f6775a0d87895ab, {
                        name: name,
                        url: url,
                        gender: gender,
                        size: "avatar"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "absolute inset-0 flex items-center justify-center rounded-full bg-text/50 text-text-inverse opacity-0 transition-opacity group-hover:opacity-100",
                        children: busy ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {}) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $jVTfU.default), {
                            size: 18,
                            "aria-hidden": "true"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                ref: inputRef,
                type: "file",
                accept: "image/*",
                className: "hidden",
                onChange: (event)=>handleFile(event.target.files?.[0])
            }),
            error && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                role: "alert",
                className: "max-w-avatar text-center text-xs text-danger",
                children: error
            })
        ]
    });
}



/**
 * «حذف مخاطب» — the one confirmation, used by the profile AND the contacts list.
 *
 * One component rather than two copies, because the promise it makes — hidden
 * from lists, history untouched, an ADMIN can restore it — is the same promise
 * wherever the button sits, and two dialogs would drift into two wordings of
 * it. It is a SOFT delete: erasure stays where it was, on an already-deleted
 * contact's profile, two deliberate steps away.
 *
 * The dialog closes on confirm (ConfirmDialog's contract), so a refusal cannot
 * be shown inside it; it goes to `onError` for the screen to render.
 */ 
var $2M70Q = parcelRequire("2M70Q");


var $3OyDL = parcelRequire("3OyDL");



function $7f1b88b42a536c5f$export$5879ef5716dc8de0({ contact: contact, open: open, onOpenChange: onOpenChange, onDeleted: onDeleted, onError: onError }) {
    const [reason, setReason] = (0, $3OyDL.useState)('');
    const [deleteContact] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$a5e8620403de4a6c));
    if (!contact) return null;
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2cc85109a937009e), {
        open: open,
        onOpenChange: (next)=>{
            onOpenChange(next);
            if (!next) setReason('');
        },
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.deleteContact,
        message: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.confirmDelete(contact.displayName),
        confirmLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).app.delete,
        danger: true,
        onConfirm: async ()=>{
            onError?.(null);
            try {
                await deleteContact({
                    variables: {
                        id: contact.id,
                        reason: reason.trim() || null
                    }
                });
                onDeleted?.();
            } catch (err) {
                onError?.(err);
            }
        },
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
            label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.deleteReason,
            hint: (0, $d916753b57975e04$export$25ce5a424b770e84).app.optional,
            value: reason,
            onChange: (event)=>setReason(event.target.value)
        })
    });
}


/**
 * Right to erasure — the two-step confirmation.
 *
 * TWO STEPS, because this is the only irreversible action in MeshHub and it
 * reaches four services. A single «مطمئنید؟» is the confirmation people click
 * through without reading; typing the contact's own surname is the smallest
 * ceremony that makes a misclick impossible.
 *
 * The first step lists **what will be cleared** and **which services will
 * change**, and both lists come from the server. Retyping them in Persian here
 * would be a promise this dialog makes that the code might not keep — and the
 * whole point of naming them is that the person clicking can see the blast
 * radius while it is still cancellable.
 */ 
var $2M70Q = parcelRequire("2M70Q");



var $6tkl0 = parcelRequire("6tkl0");

var $3OyDL = parcelRequire("3OyDL");



//: The field names the server reports, in Persian. Kept here rather than
//: server-side because this is presentation, and an unknown key falls back to
//: the raw name rather than vanishing — a field we forgot to translate must
//: still be listed, or the dialog under-promises what it destroys.
const $31457bd6012dbd66$var$FIELD_LABELS = {
    first_name: "\u0646\u0627\u0645",
    last_name: "\u0646\u0627\u0645 \u062E\u0627\u0646\u0648\u0627\u062F\u06AF\u06CC",
    org_name: "\u0646\u0627\u0645 \u0633\u0627\u0632\u0645\u0627\u0646",
    birth_date: "\u062A\u0627\u0631\u06CC\u062E \u062A\u0648\u0644\u062F",
    gender: "\u062C\u0646\u0633\u06CC\u062A",
    address: "\u0646\u0634\u0627\u0646\u06CC",
    instagram_id: "\u0627\u06CC\u0646\u0633\u062A\u0627\u06AF\u0631\u0627\u0645",
    description: "\u062A\u0648\u0636\u06CC\u062D\u0627\u062A",
    extra_attributes: "\u0641\u06CC\u0644\u062F\u0647\u0627\u06CC \u0633\u0641\u0627\u0631\u0634\u06CC",
    photo_attachment_id: "\u0639\u06A9\u0633",
    phone_number: "\u0634\u0645\u0627\u0631\u0647\u200C\u0647\u0627\u06CC \u062A\u0645\u0627\u0633"
};
const $31457bd6012dbd66$var$SERVICE_LABELS = {
    scheduling: "\u062A\u0642\u0648\u06CC\u0645 \u0648 \u0641\u0639\u0627\u0644\u06CC\u062A\u200C\u0647\u0627",
    messaging: "\u067E\u06CC\u0627\u0645\u200C\u0647\u0627",
    feedback: "\u0627\u06CC\u0634\u0648\u0647\u0627",
    analytics: "\u062F\u0627\u0634\u0628\u0648\u0631\u062F"
};
function $31457bd6012dbd66$export$7b4ce26856c96fdc({ open: open, onOpenChange: onOpenChange, contact: contact, onErased: onErased }) {
    const [step, setStep] = (0, $3OyDL.useState)(1);
    const [reason, setReason] = (0, $3OyDL.useState)('');
    const [typed, setTyped] = (0, $3OyDL.useState)('');
    const [result, setResult] = (0, $3OyDL.useState)(null);
    const [erase, state] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $c0a10c62685d2613$export$fa44c7e576a03193), {
        onCompleted: (d)=>{
            setResult(d.eraseContact);
            setStep(3);
            onErased?.(d.eraseContact);
        }
    });
    // The surname is what must be typed. `displayName` would include an
    // honorific a user never thinks of as part of the name.
    const expected = (contact?.lastName ?? contact?.displayName ?? '').trim();
    const matches = typed.trim() === expected && expected.length > 0;
    function close(next) {
        if (!next) {
            setStep(1);
            setTyped('');
            setReason('');
            setResult(null);
        }
        onOpenChange(next);
    }
    if (step === 3 && result) return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: open,
        onOpenChange: close,
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).erasure.done,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-sm text-text",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).erasure.done
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
                className: "mt-2 flex flex-wrap gap-1",
                children: result.downstreamServices.map((s)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                        className: "bg-surface-hover text-text-muted",
                        children: $31457bd6012dbd66$var$SERVICE_LABELS[s] ?? s
                    }, s))
            })
        ]
    });
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: open,
        onOpenChange: close,
        title: step === 1 ? (0, $d916753b57975e04$export$25ce5a424b770e84).erasure.step1Title : (0, $d916753b57975e04$export$25ce5a424b770e84).erasure.step2Title,
        submitLabel: step === 1 ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.next : (0, $d916753b57975e04$export$25ce5a424b770e84).erasure.confirm,
        busy: state.loading,
        onSubmit: step === 1 ? ()=>setStep(2) : ()=>matches && erase({
                variables: {
                    contactId: contact.id,
                    reason: reason.trim()
                }
            }),
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex items-start gap-2 rounded border border-warning bg-warning-subtle p-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6tkl0.default), {
                        size: 16,
                        className: "mt-px shrink-0 text-warning",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                        className: "text-sm text-text",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).erasure.step1Body
                    })
                ]
            }),
            step === 1 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("section", {
                        className: "mt-3",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("h3", {
                                className: "text-sm font-medium text-text",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).erasure.step1Fields
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
                                className: "mt-1 flex flex-wrap gap-1",
                                children: (contact?.erasureFields ?? Object.keys($31457bd6012dbd66$var$FIELD_LABELS)).map((f)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                                        className: "bg-surface-hover text-text-muted",
                                        children: $31457bd6012dbd66$var$FIELD_LABELS[f] ?? f
                                    }, f))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("section", {
                        className: "mt-3",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("h3", {
                                className: "text-sm font-medium text-text",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).erasure.step1Services
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
                                className: "mt-1 flex flex-wrap gap-1",
                                children: Object.entries($31457bd6012dbd66$var$SERVICE_LABELS).map(([key, label])=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                                        className: "bg-surface-hover text-text-muted",
                                        children: label
                                    }, key))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).erasure.reason,
                        hint: (0, $d916753b57975e04$export$25ce5a424b770e84).erasure.reasonHint,
                        value: reason,
                        onChange: (e)=>setReason(e.target.value)
                    })
                ]
            }),
            step === 2 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                        label: `${(0, $d916753b57975e04$export$25ce5a424b770e84).erasure.step2Title}: \xab${expected}\xbb`,
                        hint: (0, $d916753b57975e04$export$25ce5a424b770e84).erasure.step2Hint,
                        value: typed,
                        onChange: (e)=>setTyped(e.target.value),
                        error: typed && !matches ? (0, $d916753b57975e04$export$25ce5a424b770e84).erasure.mismatch : undefined,
                        autoFocus: true
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                        error: state.error
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "ghost",
                        onClick: ()=>setStep(1),
                        type: "button",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).erasure.back
                    })
                ]
            })
        ]
    });
}


/**
 * The contact's own fields, including the custom ones an administrator defined
 * in Step 2 — this is where those definitions finally become a form.
 *
 * Custom fields arrive from the BFF already merged with their values
 * (`Contact.customFields`), so this renders a list rather than joining two.
 * Two rules show up visibly:
 *
 *  - a field whose definition was **deactivated** but which still holds a value
 *    renders read-only rather than vanishing — the value is real, and hiding it
 *    would be a silent data loss to anyone reading the profile;
 *  - the values are submitted as one JSON object, and the server validates each
 *    against its definition, so a wrong-typed value comes back as a field-level
 *    error rather than a form-wide one.
 */ 
var $2M70Q = parcelRequire("2M70Q");



var $2vK0R = parcelRequire("2vK0R");

var $3OyDL = parcelRequire("3OyDL");

var $8B9Zg = parcelRequire("8B9Zg");


/**
 * The CRM profile fields — the ONE definition of them, rendered by both the
 * create form and the edit form.
 *
 * WHY A SHARED COMPONENT AND NOT TWO COPIES. Exactly the reasoning behind
 * `useQuickAdd` (CLAUDE.md §12): the natural way to add these fields to a
 * second form is to copy the first one, and three months later the two build
 * different payloads and only one of them sends the referrer. So the value
 * object, the payload builder and the markup live here, once, and both forms
 * render this.
 *
 * WHY NOTHING HERE NAMES A VALUE. Every picker is fed from a lookup
 * vocabulary — «سرنخ واجد شرایط», «کلینیک» and «تهران» are seed rows, not
 * strings in this file (CLAUDE.md §1). An ADMIN who needs one that is missing
 * adds it inline, because `VocabularyField` opens its own creator; a USER gets
 * a sentence naming what to ask for, because creating a vocabulary row is
 * ADMIN at the BFF and again at the service.
 *
 * THE ONE RULE WITH TEETH: «نام مرکز» is required when the chosen «نوع مخاطب»
 * carries `requiresDetail`. That flag is a property of the vocabulary ROW, not
 * a code compared in this file — so a deployment with its own facility types
 * ticks the box on whichever of theirs needs a name and changes nothing here.
 * The server enforces it too; this is the half that tells you before you save.
 */ 
var $2M70Q = parcelRequire("2M70Q");



var $8PPl0 = parcelRequire("8PPl0");
var $bi4P4 = parcelRequire("bi4P4");

var $3OyDL = parcelRequire("3OyDL");





const $d3b76cf2615e480d$export$6bee59b7d92f98d6 = {
    cityId: '',
    professionalCode: '',
    lifecycleStageId: '',
    salesStageId: '',
    customerHealthId: '',
    engagementStatusId: '',
    isGold: false,
    facilityTypeId: '',
    centerName: '',
    acquisitionSourceId: '',
    referrerContactId: ''
};
function $d3b76cf2615e480d$export$4a002612e58c4202(contact) {
    return {
        cityId: contact.city?.id ?? '',
        professionalCode: contact.professionalCode ?? '',
        lifecycleStageId: contact.lifecycleStage?.id ?? '',
        salesStageId: contact.salesStage?.id ?? '',
        customerHealthId: contact.customerHealth?.id ?? '',
        engagementStatusId: contact.engagementStatus?.id ?? '',
        isGold: Boolean(contact.isGold),
        facilityTypeId: contact.facilityType?.id ?? '',
        centerName: contact.centerName ?? '',
        acquisitionSourceId: contact.acquisitionSource?.id ?? '',
        referrerContactId: contact.referrerContactId ?? ''
    };
}
function $d3b76cf2615e480d$export$ebc5546235840192(values) {
    return {
        cityId: values.cityId || null,
        professionalCode: values.professionalCode.trim() || null,
        lifecycleStageId: values.lifecycleStageId || null,
        salesStageId: values.salesStageId || null,
        customerHealthId: values.customerHealthId || null,
        engagementStatusId: values.engagementStatusId || null,
        isGold: Boolean(values.isGold),
        facilityTypeId: values.facilityTypeId || null,
        // NOT NULL in the schema: the server stores '' for "unrecorded".
        centerName: values.centerName.trim(),
        acquisitionSourceId: values.acquisitionSourceId || null,
        referrerContactId: values.referrerContactId || null
    };
}
function $d3b76cf2615e480d$export$f0f0ae48cc65aad6(values, facilityTypes) {
    const chosen = facilityTypes.find((f)=>f.id === values.facilityTypeId);
    if (!chosen?.requiresDetail) return null;
    return values.centerName.trim() ? null : (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.centerNameRequired;
}
/** One `lookups` query per vocabulary, plus the inline creator's mutation. */ function $d3b76cf2615e480d$var$useVocabulary(kind) {
    const { isAdmin: isAdmin } = (0, $00d5d84dffcdf8d5$export$ad0a340bf97d63d5)();
    const variables = {
        kind: kind,
        includeInactive: false
    };
    const { data: data, loading: loading } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$d2d584f4325fcf08), {
        variables: variables
    });
    const [createLookup, { loading: creating, error: error }] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$bceff013a27ec1ea), {
        refetchQueries: [
            {
                query: (0, $13be303c7211393a$export$d2d584f4325fcf08),
                variables: variables
            }
        ],
        // The new row must EXIST by the time the value points at it, so the
        // mutation resolves after its refetch (the VocabularyField contract).
        awaitRefetchQueries: true
    });
    return {
        options: data?.lookups ?? [],
        loading: loading,
        canCreate: isAdmin,
        creating: creating,
        createError: error,
        onCreate: async ({ labelFa: labelFa, code: code })=>{
            const { data: created } = await createLookup({
                variables: {
                    input: {
                        kind: kind,
                        code: code,
                        labelFa: labelFa
                    }
                }
            });
            return created?.createLookup?.id;
        }
    };
}
function $d3b76cf2615e480d$export$f9cad722f60dcf76({ kind: kind, label: label, value: value, onChange: onChange, hint: hint }) {
    const vocabulary = $d3b76cf2615e480d$var$useVocabulary(kind);
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4436e89d3ef1c462$export$bc36ad93e482d2f8), {
        label: label,
        hint: hint,
        value: value,
        onChange: onChange,
        includeNone: true,
        codePrefix: kind,
        ...vocabulary
    });
}
/**
 * Pick a contact as the referrer.
 *
 * Deliberately the same shape as the affiliation dialog's picker — a search
 * box narrowing a select — because it is the same question, and a second way
 * of choosing a contact would be a second thing to learn. Unlike affiliations
 * it accepts either kind: a clinic can introduce a doctor and a doctor can
 * introduce a clinic.
 */ function $d3b76cf2615e480d$var$ReferrerField({ value: value, currentName: currentName, excludeId: excludeId, onChange: onChange }) {
    const [open, setOpen] = (0, $3OyDL.useState)(false);
    const [search, setSearch] = (0, $3OyDL.useState)('');
    // The name of whoever was picked in THIS session. Apollo returns no data for
    // a skipped query, so once the picker closes the candidate list is gone and
    // the closed state would fall back to the name the server sent — which is
    // the PREVIOUS referrer's, until a save and a refetch. Remembering it here
    // is what stops the field showing the person you just replaced.
    const [pickedName, setPickedName] = (0, $3OyDL.useState)(null);
    const { data: data, loading: loading } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$9b2e8c059cb38823), {
        variables: {
            page: 1,
            pageSize: 25,
            search: search.trim() || null
        },
        skip: !open
    });
    const candidates = (data?.contacts?.items ?? []).filter((c)=>c.id !== excludeId);
    // The chosen referrer's own name, so an already-linked contact reads as a
    // person rather than as a UUID that happens to be selected.
    const chosen = candidates.find((c)=>c.id === value);
    const chosenName = chosen?.displayName ?? pickedName ?? currentName ?? '';
    if (!open) return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex items-end gap-2",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex flex-1 flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-sm text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.referrer
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-base",
                        children: value ? chosenName || (0, $d916753b57975e04$export$25ce5a424b770e84).app.none : (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.noReferrer
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                type: "button",
                variant: "ghost",
                onClick: ()=>setOpen(true),
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8PPl0.default), {
                        size: 14,
                        "aria-hidden": "true"
                    }),
                    value ? (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.changeReferrer : (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.addReferrer
                ]
            }),
            value && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                type: "button",
                variant: "ghost",
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.removeReferrer,
                "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.removeReferrer,
                onClick: ()=>{
                    setPickedName(null);
                    onChange('');
                },
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $bi4P4.default), {
                    size: 14,
                    "aria-hidden": "true"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex flex-col gap-2 rounded border border-border bg-surface p-3",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.referrer,
                placeholder: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.searchContact,
                value: search,
                autoFocus: true,
                onChange: (event)=>setSearch(event.target.value),
                // Enter here means "narrow the list", never "save the contact" — the
                // surrounding FormDialog is a <form>, and without this the key that
                // most obviously finishes this input would submit a half-filled form.
                onKeyDown: (event)=>event.key === 'Enter' && event.preventDefault()
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).app.search,
                value: value,
                onChange: (event)=>{
                    const id = event.target.value;
                    setPickedName(candidates.find((c)=>c.id === id)?.displayName ?? null);
                    onChange(id);
                    setOpen(false);
                },
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: "",
                        children: loading ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.loading : (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    candidates.map((candidate)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                            value: candidate.id,
                            children: candidate.displayName
                        }, candidate.id))
                ]
            })
        ]
    });
}
function $d3b76cf2615e480d$export$6a9747c59f9c0f7e({ values: values, onChange: onChange, contactId: contactId, referrerName: referrerName, facilityTypes: facilityTypes = [] }) {
    const centerError = $d3b76cf2615e480d$export$f0f0ae48cc65aad6(values, facilityTypes);
    const centerRequired = Boolean(facilityTypes.find((f)=>f.id === values.facilityTypeId)?.requiresDetail);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)($d3b76cf2615e480d$var$Section, {
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.sections.professional,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)($d3b76cf2615e480d$export$f9cad722f60dcf76, {
                        kind: "CITY",
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.city,
                        value: values.cityId,
                        onChange: (id)=>onChange({
                                cityId: id
                            })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.professionalCode,
                        value: values.professionalCode,
                        dir: "ltr",
                        onChange: (event)=>onChange({
                                professionalCode: event.target.value
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)($d3b76cf2615e480d$var$Section, {
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.sections.crm,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)($d3b76cf2615e480d$export$f9cad722f60dcf76, {
                        kind: "LIFECYCLE_STAGE",
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.lifecycleStage,
                        value: values.lifecycleStageId,
                        onChange: (id)=>onChange({
                                lifecycleStageId: id
                            })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)($d3b76cf2615e480d$export$f9cad722f60dcf76, {
                        kind: "SALES_STAGE",
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.salesStage,
                        value: values.salesStageId,
                        onChange: (id)=>onChange({
                                salesStageId: id
                            })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)($d3b76cf2615e480d$export$f9cad722f60dcf76, {
                        kind: "CUSTOMER_HEALTH",
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.customerHealth,
                        value: values.customerHealthId,
                        onChange: (id)=>onChange({
                                customerHealthId: id
                            })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)($d3b76cf2615e480d$export$f9cad722f60dcf76, {
                        kind: "ENGAGEMENT_STATUS",
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.engagementStatus,
                        value: values.engagementStatusId,
                        onChange: (id)=>onChange({
                                engagementStatusId: id
                            })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                        className: "col-span-2 flex items-end",
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$94195a47b94ed396), {
                            label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.isGold,
                            checked: values.isGold,
                            onChange: (event)=>onChange({
                                    isGold: event.target.checked
                                })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)($d3b76cf2615e480d$var$Section, {
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.sections.facility,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)($d3b76cf2615e480d$export$f9cad722f60dcf76, {
                        kind: "FACILITY_TYPE",
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.facilityType,
                        value: values.facilityTypeId,
                        onChange: (id)=>onChange({
                                facilityTypeId: id
                            })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.centerName,
                        value: values.centerName,
                        error: centerError,
                        // The asterisk follows the chosen ROW's flag, not the current error,
                        // so it appears the moment «کلینیک» is picked rather than after the
                        // field has already been left empty. Same source the server reads.
                        required: centerRequired || undefined,
                        onChange: (event)=>onChange({
                                centerName: event.target.value
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)($d3b76cf2615e480d$var$Section, {
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.sections.relations,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)($d3b76cf2615e480d$export$f9cad722f60dcf76, {
                        kind: "ACQUISITION_SOURCE",
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.acquisitionSource,
                        value: values.acquisitionSourceId,
                        onChange: (id)=>onChange({
                                acquisitionSourceId: id
                            })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                        className: "col-span-2",
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)($d3b76cf2615e480d$var$ReferrerField, {
                            value: values.referrerContactId,
                            currentName: referrerName,
                            excludeId: contactId,
                            onChange: (id)=>onChange({
                                    referrerContactId: id
                                })
                        })
                    })
                ]
            })
        ]
    });
}
function $d3b76cf2615e480d$var$Section({ title: title, children: children }) {
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("section", {
        className: "border-t border-border pt-4",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("h3", {
                className: "mb-3 text-sm font-medium text-text-muted",
                children: title
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: "grid grid-cols-2 gap-4",
                children: children
            })
        ]
    });
}




const $728688e7e2fdee35$var$GENDERS = [
    'MALE',
    'FEMALE',
    'OTHER'
];
const $728688e7e2fdee35$var$SUBSCRIPTION_TYPES = [
    'WHITELABEL',
    'STANDARD',
    'BARTER'
];
/** A stored custom-field value (JSON-encoded) as text for display. */ function $728688e7e2fdee35$var$displayValue(field) {
    if (field.value === null) return (0, $d916753b57975e04$export$25ce5a424b770e84).app.none;
    const parsed = JSON.parse(field.value);
    if (field.type === 'BOOLEAN') return parsed ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.yes : (0, $d916753b57975e04$export$25ce5a424b770e84).app.no;
    if (field.type === 'DATE') return (0, $d4d460d3ffb6daab$export$3ae94a2503e890a1)(parsed);
    if (Array.isArray(parsed)) return parsed.join("\u060C ");
    return String(parsed);
}
function $728688e7e2fdee35$export$e54a7f2505304e20({ contact: contact, onSaved: onSaved, readOnly: readOnly }) {
    const [editing, setEditing] = (0, $3OyDL.useState)(false);
    const isPerson = contact.kind === 'PERSON';
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "mb-4 flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                        className: "text-md font-bold",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.profile
                    }),
                    !readOnly && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "ghost",
                        className: "ms-auto",
                        onClick: ()=>setEditing(true),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2vK0R.default), {
                                size: 14,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.editProfile
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "grid grid-cols-2 gap-4",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.kind,
                        children: (0, $d4d460d3ffb6daab$export$dab5d6c7a52ba3f8)[contact.kind]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.fieldOfWork,
                        children: contact.fieldOfWork?.labelFa ?? (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    isPerson && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.specialty,
                                children: contact.specialty?.labelFa ?? (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.subSpecialty,
                                children: contact.subSpecialty?.labelFa ?? (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.gender,
                                children: contact.gender ? (0, $d4d460d3ffb6daab$export$fc6fe25248839a29)[contact.gender] : (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.birthDate,
                                children: contact.birthDate ? (0, $d4d460d3ffb6daab$export$3ae94a2503e890a1)(contact.birthDate) : (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.collaborationStatus,
                        children: (0, $d4d460d3ffb6daab$export$3c3cfc169bd4703d)[contact.collaborationStatus]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.subscriptionType,
                        children: contact.subscriptionType ? (0, $d4d460d3ffb6daab$export$c2e265752f50ea92)[contact.subscriptionType] : (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.city,
                        children: contact.city?.labelFa ?? (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.professionalCode,
                        children: contact.professionalCode ? /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                            dir: "ltr",
                            children: contact.professionalCode
                        }) : (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.lifecycleStage,
                        children: contact.lifecycleStage?.labelFa ?? (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.salesStage,
                        children: contact.salesStage?.labelFa ?? (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.customerHealth,
                        children: contact.customerHealth?.labelFa ?? (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.engagementStatus,
                        children: contact.engagementStatus?.labelFa ?? (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.isGold,
                        children: contact.isGold ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.yes : (0, $d916753b57975e04$export$25ce5a424b770e84).app.no
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.facilityType,
                        children: contact.facilityType?.labelFa ?? (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.centerName,
                        children: contact.centerName || (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.acquisitionSource,
                        children: contact.acquisitionSource?.labelFa ?? (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.referrer,
                        children: contact.referrerContactId ? // A link, because "who introduced them" is a question that
                        // usually leads straight to the next profile.
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8B9Zg.Link), {
                            to: `/contacts/${contact.referrerContactId}`,
                            className: "text-primary hover:underline",
                            children: contact.referrerName || contact.referrerContactId
                        }) : (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.instagram,
                        children: contact.instagramId ? /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                            dir: "ltr",
                            children: [
                                "@",
                                contact.instagramId
                            ]
                        }) : (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.address,
                        className: "col-span-2",
                        children: contact.address || (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.description,
                        className: "col-span-2",
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                            className: "whitespace-pre-line",
                            children: contact.description || (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                        })
                    })
                ]
            }),
            contact.customFields.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)("section", {
                className: "mt-6 border-t border-border pt-5",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h3", {
                        className: "mb-4 text-sm font-medium text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.customFields
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                        className: "grid grid-cols-2 gap-4",
                        children: contact.customFields.map((field)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                                label: field.isActive ? field.labelFa : // Deactivated definition, value retained: labelled so the
                                // reader knows why it is not on the edit form.
                                /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        field.labelFa,
                                        /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                            className: "text-xs",
                                            children: [
                                                "(",
                                                (0, $d916753b57975e04$export$25ce5a424b770e84).app.inactive,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                children: $728688e7e2fdee35$var$displayValue(field)
                            }, field.id))
                    })
                ]
            }),
            editing && /*#__PURE__*/ (0, $2M70Q.jsx)($728688e7e2fdee35$var$EditDialog, {
                contact: contact,
                open: editing,
                onOpenChange: setEditing,
                onSaved: onSaved
            })
        ]
    });
}
function $728688e7e2fdee35$var$EditDialog({ contact: contact, open: open, onOpenChange: onOpenChange, onSaved: onSaved }) {
    const isPerson = contact.kind === 'PERSON';
    const [form, setForm] = (0, $3OyDL.useState)(()=>({
            firstName: contact.firstName ?? '',
            lastName: contact.lastName ?? '',
            orgName: contact.orgName ?? '',
            birthDate: contact.birthDate ?? null,
            gender: contact.gender ?? '',
            fieldOfWorkId: contact.fieldOfWork?.id ?? '',
            specialtyId: contact.specialty?.id ?? '',
            subSpecialtyId: contact.subSpecialty?.id ?? '',
            subscriptionType: contact.subscriptionType ?? '',
            instagramId: contact.instagramId ?? '',
            address: contact.address ?? '',
            description: contact.description ?? ''
        }));
    // The CRM profile fields, kept in their own object so the shared component
    // and its payload builder own them end to end — the create form uses the
    // same two, which is what stops the two forms from drifting.
    const [crm, setCrm] = (0, $3OyDL.useState)(()=>(0, $d3b76cf2615e480d$export$4a002612e58c4202)(contact));
    // Only ACTIVE definitions are editable; an inactive one is displayed on the
    // panel but has no input here, which is exactly "readable but not writable".
    const [custom, setCustom] = (0, $3OyDL.useState)(()=>Object.fromEntries(contact.customFields.filter((f)=>f.isActive).map((f)=>[
                f.name,
                f.value === null ? $728688e7e2fdee35$var$emptyFor(f) : JSON.parse(f.value)
            ])));
    const [error, setError] = (0, $3OyDL.useState)(null);
    const { data: fieldsOfWork } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$d2d584f4325fcf08), {
        variables: {
            kind: 'FIELD_OF_WORK',
            includeInactive: false
        }
    });
    const { data: specialties } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$d2d584f4325fcf08), {
        variables: {
            kind: 'SPECIALTY',
            includeInactive: false
        }
    });
    // Hoisted rather than read inside ContactCrmFields, because submit has to
    // check the center-name rule before it sends. Apollo dedupes it with the
    // component's own query, so this is one request, not two.
    const { data: facilityTypeData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$d2d584f4325fcf08), {
        variables: {
            kind: 'FACILITY_TYPE',
            includeInactive: false
        }
    });
    const facilityTypes = facilityTypeData?.lookups ?? [];
    const [updateContact, { loading: loading }] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$2882fad028843c4d));
    const set = (patch)=>setForm((current)=>({
                ...current,
                ...patch
            }));
    const setField = (name, value)=>setCustom((current)=>({
                ...current,
                [name]: value
            }));
    const allSpecialties = specialties?.lookups ?? [];
    const roots = allSpecialties.filter((s)=>!s.parentId);
    const children = allSpecialties.filter((s)=>s.parentId === form.specialtyId);
    async function submit() {
        setError(null);
        // Refused HERE as well as on the server. The server's answer is the one
        // that counts; this one arrives without a round trip and points at the
        // field rather than at the form.
        const centerError = (0, $d3b76cf2615e480d$export$f0f0ae48cc65aad6)(crm, facilityTypes);
        if (centerError) {
            setError(new Error(centerError));
            return;
        }
        try {
            await updateContact({
                variables: {
                    id: contact.id,
                    input: {
                        ...isPerson ? {
                            firstName: form.firstName.trim() || null,
                            lastName: form.lastName.trim(),
                            birthDate: form.birthDate,
                            gender: form.gender || null,
                            specialtyId: form.specialtyId || null,
                            subSpecialtyId: form.subSpecialtyId || null
                        } : {
                            orgName: form.orgName.trim()
                        },
                        fieldOfWorkId: form.fieldOfWorkId || null,
                        subscriptionType: form.subscriptionType || null,
                        instagramId: form.instagramId.trim() || null,
                        address: form.address,
                        description: form.description,
                        extraAttributes: JSON.stringify(custom),
                        ...(0, $d3b76cf2615e480d$export$ebc5546235840192)(crm)
                    }
                }
            });
            await onSaved?.();
            onOpenChange(false);
        } catch (err) {
            setError(err);
        }
    }
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: open,
        onOpenChange: onOpenChange,
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.editProfile,
        onSubmit: submit,
        busy: loading,
        wide: true,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: error
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "grid grid-cols-2 gap-4",
                children: [
                    isPerson ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.lastName,
                                value: form.lastName,
                                onChange: (e)=>set({
                                        lastName: e.target.value
                                    }),
                                required: true
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.firstName,
                                value: form.firstName,
                                onChange: (e)=>set({
                                        firstName: e.target.value
                                    })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.gender,
                                value: form.gender,
                                onChange: (e)=>set({
                                        gender: e.target.value
                                    }),
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                        value: "",
                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                                    }),
                                    $728688e7e2fdee35$var$GENDERS.map((g)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                            value: g,
                                            children: (0, $d4d460d3ffb6daab$export$fc6fe25248839a29)[g]
                                        }, g))
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$ce0a41819d728248), {
                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.birthDate,
                                value: form.birthDate,
                                onChange: (iso)=>set({
                                        birthDate: iso
                                    })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.orgName,
                        className: "col-span-2",
                        value: form.orgName,
                        onChange: (e)=>set({
                                orgName: e.target.value
                            }),
                        required: true
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.fieldOfWork,
                        value: form.fieldOfWorkId,
                        onChange: (e)=>set({
                                fieldOfWorkId: e.target.value
                            }),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                value: "",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                            }),
                            (fieldsOfWork?.lookups ?? []).map((f)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                    value: f.id,
                                    children: f.labelFa
                                }, f.id))
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.subscriptionType,
                        value: form.subscriptionType,
                        onChange: (e)=>set({
                                subscriptionType: e.target.value
                            }),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                value: "",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                            }),
                            $728688e7e2fdee35$var$SUBSCRIPTION_TYPES.map((t)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                    value: t,
                                    children: (0, $d4d460d3ffb6daab$export$c2e265752f50ea92)[t]
                                }, t))
                        ]
                    }),
                    isPerson && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.specialty,
                                value: form.specialtyId,
                                onChange: (e)=>set({
                                        specialtyId: e.target.value,
                                        subSpecialtyId: ''
                                    }),
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                        value: "",
                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                                    }),
                                    roots.map((s)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                            value: s.id,
                                            children: s.labelFa
                                        }, s.id))
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.subSpecialty,
                                value: form.subSpecialtyId,
                                onChange: (e)=>set({
                                        subSpecialtyId: e.target.value
                                    }),
                                // Sub-specialties are the children of the chosen specialty, so
                                // the tree the admin built drives the picker directly.
                                disabled: children.length === 0,
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                        value: "",
                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                                    }),
                                    children.map((s)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                            value: s.id,
                                            children: s.labelFa
                                        }, s.id))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.instagram,
                        value: form.instagramId,
                        onChange: (e)=>set({
                                instagramId: e.target.value
                            }),
                        dir: "ltr"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.address,
                        value: form.address,
                        onChange: (e)=>set({
                                address: e.target.value
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$f5c9f3c2c4054eec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.description,
                rows: 3,
                value: form.description,
                onChange: (e)=>set({
                        description: e.target.value
                    })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d3b76cf2615e480d$export$6a9747c59f9c0f7e), {
                values: crm,
                onChange: (patch)=>setCrm((current)=>({
                            ...current,
                            ...patch
                        })),
                contactId: contact.id,
                referrerName: contact.referrerName,
                facilityTypes: facilityTypes
            }),
            contact.customFields.some((f)=>f.isActive) && /*#__PURE__*/ (0, $2M70Q.jsxs)("section", {
                className: "border-t border-border pt-4",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h3", {
                        className: "mb-3 text-sm font-medium text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.customFields
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                        className: "grid grid-cols-2 gap-4",
                        children: contact.customFields.filter((f)=>f.isActive).map((field)=>/*#__PURE__*/ (0, $2M70Q.jsx)($728688e7e2fdee35$var$CustomFieldInput, {
                                field: field,
                                value: custom[field.name],
                                onChange: (value)=>setField(field.name, value)
                            }, field.id))
                    })
                ]
            })
        ]
    });
}
/** The empty value a field type starts from, so the JSON payload stays typed. */ function $728688e7e2fdee35$var$emptyFor(field) {
    if (field.type === 'MULTISELECT') return [];
    if (field.type === 'BOOLEAN') return false;
    return '';
}
/** One input per custom-field type. The server validates again regardless. */ function $728688e7e2fdee35$var$CustomFieldInput({ field: field, value: value, onChange: onChange }) {
    switch(field.type){
        case 'NUMBER':
            return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: field.labelFa,
                value: value ?? '',
                inputMode: "numeric",
                // Persian digits are converted here so the payload is a real number;
                // the server would reject «۱۲» as text otherwise.
                onChange: (e)=>{
                    const text = (0, $d4d460d3ffb6daab$export$365a38b4fc2bed91)(e.target.value).trim();
                    onChange(text === '' ? '' : Number.isNaN(Number(text)) ? text : Number(text));
                }
            });
        case 'DATE':
            return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$ce0a41819d728248), {
                label: field.labelFa,
                value: value || null,
                onChange: (iso)=>onChange(iso ?? ''),
                hint: value ? (0, $d4d460d3ffb6daab$export$aae69b02cbc5f8df)(value) : undefined
            });
        case 'BOOLEAN':
            return /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: "flex items-end",
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$94195a47b94ed396), {
                    label: field.labelFa,
                    checked: Boolean(value),
                    onChange: (e)=>onChange(e.target.checked)
                })
            });
        case 'SELECT':
            return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: field.labelFa,
                value: value ?? '',
                onChange: (e)=>onChange(e.target.value),
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: "",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    field.options.map((option)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                            value: option,
                            children: option
                        }, option))
                ]
            });
        case 'MULTISELECT':
            {
                const chosen = Array.isArray(value) ? value : [];
                return /*#__PURE__*/ (0, $2M70Q.jsxs)("fieldset", {
                    className: "flex flex-col gap-2",
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)("legend", {
                            className: "text-sm text-text-muted",
                            children: field.labelFa
                        }),
                        field.options.map((option)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$94195a47b94ed396), {
                                label: option,
                                checked: chosen.includes(option),
                                onChange: ()=>onChange(chosen.includes(option) ? chosen.filter((v)=>v !== option) : [
                                        ...chosen,
                                        option
                                    ])
                            }, option))
                    ]
                });
            }
        default:
            return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: field.labelFa,
                value: value ?? '',
                onChange: (e)=>onChange(e.target.value)
            });
    }
}


/**
 * Record an interaction: type, when, what happened, files, outcome.
 *
 * Two pieces are worth reading closely.
 *
 * **Dictation.** The mic writes into the description and nowhere else. Final
 * utterances are appended to whatever is already typed, so speaking and typing
 * mix freely; interim results render underneath as a live preview rather than
 * in the textarea, because rewriting the field on every syllable would fight
 * anyone editing while they speak. Audio never leaves the browser — see
 * lib/voice.jsx.
 *
 * **Attachments upload before the interaction exists.** They cannot: an
 * attachment needs an owner id. So the interaction is created FIRST, and files
 * upload against it afterwards. That ordering is why the dialog reports
 * per-file progress and lets a failed file be retried without losing the text
 * — the interaction is already safe by then.
 */ 
var $2M70Q = parcelRequire("2M70Q");


/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $9c3f9cc44ddc2285$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8",
            key: "1p45f6"
        }
    ],
    [
        "path",
        {
            d: "M21 3v5h-5",
            key: "1q7to0"
        }
    ]
];
const $9c3f9cc44ddc2285$export$2e2bcd8739ae039 = (0, $djixo.default)("rotate-cw", $9c3f9cc44ddc2285$export$3efd853dbb351e94);


var $bi4P4 = parcelRequire("bi4P4");

var $3OyDL = parcelRequire("3OyDL");





/**
 * Voice-to-text for the interaction description, and nowhere else.
 *
 * **Privacy, stated plainly:** this uses the browser's own Web Speech API. No
 * audio ever reaches a MeshHub server — the CRM service and the BFF never see
 * it and have no code that could. What the browser itself does with the audio
 * is between the user and their browser vendor (Chrome, for instance, sends it
 * to Google's speech service). Only the finished text is submitted, and only
 * when the user saves the interaction. This is repeated in root CLAUDE.md.
 *
 * **Feature detection, not a polyfill.** Firefox has no SpeechRecognition, so
 * the control is absent there rather than present and broken. `isVoiceSupported`
 * is exported separately so a caller can decide *not to render* rather than
 * render a disabled button — a greyed-out mic invites clicks that go nowhere.
 */ 
var $2M70Q = parcelRequire("2M70Q");
/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $9a2a84c958bb7df7$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 19v3",
            key: "npa21l"
        }
    ],
    [
        "path",
        {
            d: "M19 10v2a7 7 0 0 1-14 0v-2",
            key: "1vc78b"
        }
    ],
    [
        "rect",
        {
            x: "9",
            y: "2",
            width: "6",
            height: "13",
            rx: "3",
            key: "s6n7sd"
        }
    ]
];
const $9a2a84c958bb7df7$export$2e2bcd8739ae039 = (0, $djixo.default)("mic", $9a2a84c958bb7df7$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $f339e14daab56456$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 19v3",
            key: "npa21l"
        }
    ],
    [
        "path",
        {
            d: "M15 9.34V5a3 3 0 0 0-5.68-1.33",
            key: "1gzdoj"
        }
    ],
    [
        "path",
        {
            d: "M16.95 16.95A7 7 0 0 1 5 12v-2",
            key: "cqa7eg"
        }
    ],
    [
        "path",
        {
            d: "M18.89 13.23A7 7 0 0 0 19 12v-2",
            key: "16hl24"
        }
    ],
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ],
    [
        "path",
        {
            d: "M9 9v3a3 3 0 0 0 5.12 2.12",
            key: "r2i35w"
        }
    ]
];
const $f339e14daab56456$export$2e2bcd8739ae039 = (0, $djixo.default)("mic-off", $f339e14daab56456$export$3efd853dbb351e94);



var $3OyDL = parcelRequire("3OyDL");

/** Persian. Configured here, once, like every other locale decision. */ const $9ea591071a6a48b8$var$RECOGNITION_LANG = 'fa-IR';
function $9ea591071a6a48b8$var$recognitionConstructor() {
    if (typeof window === 'undefined') return null;
    return window.SpeechRecognition ?? window.webkitSpeechRecognition ?? null;
}
function $9ea591071a6a48b8$export$e9a5ff1b2cc9ee5d() {
    return $9ea591071a6a48b8$var$recognitionConstructor() !== null;
}
const $9ea591071a6a48b8$var$ERROR_MESSAGES = {
    'not-allowed': (0, $d916753b57975e04$export$25ce5a424b770e84).voice.denied,
    'service-not-allowed': (0, $d916753b57975e04$export$25ce5a424b770e84).voice.denied,
    'no-speech': (0, $d916753b57975e04$export$25ce5a424b770e84).voice.noSpeech
};
function $9ea591071a6a48b8$export$9f942a4e4811ebf5({ onTranscript: onTranscript, onInterim: onInterim }) {
    const [listening, setListening] = (0, $3OyDL.useState)(false);
    const [error, setError] = (0, $3OyDL.useState)(null);
    const recognitionRef = (0, $3OyDL.useRef)(null);
    // Refs, not deps: a caller that recreates its handlers each render (the
    // normal case) would otherwise tear down and restart recognition mid-sentence.
    const handlers = (0, $3OyDL.useRef)({
        onTranscript: onTranscript,
        onInterim: onInterim
    });
    handlers.current = {
        onTranscript: onTranscript,
        onInterim: onInterim
    };
    const stop = (0, $3OyDL.useCallback)(()=>{
        recognitionRef.current?.stop();
        setListening(false);
    }, []);
    const start = (0, $3OyDL.useCallback)(()=>{
        const Recognition = $9ea591071a6a48b8$var$recognitionConstructor();
        if (!Recognition) return;
        setError(null);
        const recognition = new Recognition();
        recognition.lang = $9ea591071a6a48b8$var$RECOGNITION_LANG;
        recognition.continuous = true;
        // Interim results are what make dictation feel live: the user sees words
        // appear as they speak instead of after a pause.
        recognition.interimResults = true;
        recognition.onresult = (event)=>{
            let interim = '';
            for(let i = event.resultIndex; i < event.results.length; i += 1){
                const result = event.results[i];
                const text = result[0]?.transcript ?? '';
                if (result.isFinal) handlers.current.onTranscript?.(text.trim());
                else interim += text;
            }
            handlers.current.onInterim?.(interim.trim());
        };
        recognition.onerror = (event)=>{
            // 'aborted' is what stop() produces — not something to show the user.
            if (event.error === 'aborted') return;
            setError($9ea591071a6a48b8$var$ERROR_MESSAGES[event.error] ?? (0, $d916753b57975e04$export$25ce5a424b770e84).voice.failed);
            setListening(false);
        };
        recognition.onend = ()=>{
            setListening(false);
            handlers.current.onInterim?.('');
        };
        recognitionRef.current = recognition;
        recognition.start();
        setListening(true);
    }, []);
    // Unmounting mid-sentence must release the microphone, or the browser keeps
    // its indicator lit long after the dialog has closed.
    (0, $3OyDL.useEffect)(()=>()=>recognitionRef.current?.abort(), []);
    return {
        listening: listening,
        error: error,
        start: start,
        stop: stop,
        toggle: ()=>listening ? stop() : start()
    };
}
function $9ea591071a6a48b8$export$86de4a341ed9487f({ listening: listening, onToggle: onToggle, disabled: disabled }) {
    if (!$9ea591071a6a48b8$export$e9a5ff1b2cc9ee5d()) return null;
    const Icon = listening ? (0, $f339e14daab56456$export$2e2bcd8739ae039) : (0, $9a2a84c958bb7df7$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("button", {
        type: "button",
        onClick: onToggle,
        disabled: disabled,
        "aria-pressed": listening,
        "aria-label": listening ? (0, $d916753b57975e04$export$25ce5a424b770e84).voice.stop : (0, $d916753b57975e04$export$25ce5a424b770e84).voice.start,
        title: listening ? (0, $d916753b57975e04$export$25ce5a424b770e84).voice.stop : (0, $d916753b57975e04$export$25ce5a424b770e84).voice.start,
        className: `inline-flex h-control items-center gap-2 rounded border px-3 text-sm
                  transition-colors disabled:opacity-50 ${listening ? 'border-danger bg-surface-hover text-danger' : 'border-border bg-surface text-text-muted hover:bg-surface-hover'}`,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)(Icon, {
                size: 14,
                "aria-hidden": "true"
            }),
            listening ? (0, $d916753b57975e04$export$25ce5a424b770e84).voice.listening : (0, $d916753b57975e04$export$25ce5a424b770e84).voice.start
        ]
    });
}




const $de39eaf1449f169c$var$INTERACTION_STATUSES = [
    'DONE',
    'PLANNED',
    'CANCELLED'
];
/** One queued file and where it got to. */ const $de39eaf1449f169c$var$queued = (file)=>({
        key: `${file.name}-${file.size}-${file.lastModified}`,
        file: file,
        progress: 0,
        state: 'queued',
        error: null
    });
/** A blank composer, dated now — the overwhelmingly common case. */ const $de39eaf1449f169c$var$blankForm = ()=>{
    const now = (0, $d4d460d3ffb6daab$export$a32865ea4a905df9)(new Date().toISOString());
    return {
        typeId: '',
        date: now.date,
        time: now.time,
        description: '',
        outcome: '',
        status: 'DONE',
        followUp: ''
    };
};
function $de39eaf1449f169c$export$2310fe575ea26aef({ open: open, onOpenChange: onOpenChange, contactId: contactId, onRecorded: onRecorded }) {
    const [form, setForm] = (0, $3OyDL.useState)($de39eaf1449f169c$var$blankForm);
    const [files, setFiles] = (0, $3OyDL.useState)([]);
    const [interim, setInterim] = (0, $3OyDL.useState)('');
    const [error, setError] = (0, $3OyDL.useState)(null);
    const [busy, setBusy] = (0, $3OyDL.useState)(false);
    const fileInputRef = (0, $3OyDL.useRef)(null);
    const { isAdmin: isAdmin } = (0, $00d5d84dffcdf8d5$export$ad0a340bf97d63d5)();
    const { data: typeData, loading: typesLoading } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$d2d584f4325fcf08), {
        variables: {
            kind: 'INTERACTION_TYPE',
            includeInactive: false
        },
        skip: !open
    });
    const [recordInteraction] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$b21d8737225985c0));
    // «نوع تعامل» is required, so an unseeded INTERACTION_TYPE vocabulary is the
    // same dead end the calendar had: the composer opens and cannot be saved.
    const [createType, createTypeState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$bceff013a27ec1ea), {
        refetchQueries: [
            'AdminLookups'
        ],
        awaitRefetchQueries: true
    });
    const types = typeData?.lookups ?? [];
    const set = (patch)=>setForm((current)=>({
                ...current,
                ...patch
            }));
    const dictation = (0, $9ea591071a6a48b8$export$9f942a4e4811ebf5)({
        onTranscript: (text)=>setForm((current)=>({
                    ...current,
                    description: current.description ? `${current.description} ${text}` : text
                })),
        onInterim: setInterim
    });
    (0, $3OyDL.useEffect)(()=>{
        if (open) {
            setForm($de39eaf1449f169c$var$blankForm());
            setFiles([]);
            setError(null);
            setInterim('');
        }
    }, [
        open
    ]);
    const addFiles = (list)=>{
        // THE FILELIST IS MATERIALISED HERE, before `setFiles` is called.
        //
        // `list` is the input element's LIVE `FileList`, and the change handler
        // resets `input.value` immediately afterwards so that choosing the same
        // file twice fires another change event. That reset EMPTIES the FileList.
        // React runs a functional updater during the render that follows the
        // handler, by which time the spread inside it saw nothing — so a file
        // picked with the button was dropped between being chosen and being
        // listed, and no error appeared anywhere.
        //
        // Dropping a file worked, which is why this survived: `dataTransfer.files`
        // is not the input's list and nothing resets it. So the feature was broken
        // exactly on the path most people use.
        const chosen = [
            ...list
        ].map($de39eaf1449f169c$var$queued);
        setFiles((current)=>{
            const known = new Set(current.map((f)=>f.key));
            return [
                ...current,
                ...chosen.filter((f)=>!known.has(f.key))
            ];
        });
    };
    const patchFile = (key, patch)=>setFiles((current)=>current.map((f)=>f.key === key ? {
                    ...f,
                    ...patch
                } : f));
    async function uploadOne(entry, interactionId) {
        patchFile(entry.key, {
            state: 'uploading',
            progress: 0,
            error: null
        });
        try {
            await (0, $d305624b55b31f43$export$a5575dbeeffdad98)({
                file: entry.file,
                ownerType: 'INTERACTION',
                ownerId: interactionId,
                onProgress: (fraction)=>patchFile(entry.key, {
                        progress: fraction
                    })
            });
            patchFile(entry.key, {
                state: 'done',
                progress: 1
            });
            return true;
        } catch (err) {
            patchFile(entry.key, {
                state: 'failed',
                error: err.message
            });
            return false;
        }
    }
    async function submit() {
        if (!form.typeId) {
            setError(new Error((0, $d916753b57975e04$export$25ce5a424b770e84).interaction.typeRequired));
            return;
        }
        const occurredAt = (0, $d4d460d3ffb6daab$export$747b60771a8a4ce9)(form.date, form.time);
        if (!occurredAt) {
            setError(new Error((0, $d916753b57975e04$export$25ce5a424b770e84).interaction.invalidDate));
            return;
        }
        setError(null);
        setBusy(true);
        if (dictation.listening) dictation.stop();
        try {
            // The follow-up note rides along at the end of the description until the
            // scheduling service gives it a home (Step 4; see todo.md). Labelled in
            // the text so it is obviously a note and not part of the account.
            const followUp = form.followUp.trim();
            const description = followUp ? `${form.description.trim()}

\u{2014} ${(0, $d916753b57975e04$export$25ce5a424b770e84).interaction.followUpNote}: ${followUp}` : form.description.trim();
            const { data: data } = await recordInteraction({
                variables: {
                    input: {
                        contactId: contactId,
                        typeId: form.typeId,
                        occurredAt: occurredAt,
                        description: description,
                        outcome: form.outcome.trim() || null,
                        status: form.status
                    }
                }
            });
            const interactionId = data.recordInteraction.id;
            const pending = files.filter((f)=>f.state !== 'done');
            const results = [];
            for (const entry of pending)// Sequential rather than parallel: a congress-hall connection does
            // better with one upload at a time, and the progress bars stay legible.
            results.push(await uploadOne(entry, interactionId));
            await onRecorded?.();
            if (results.every(Boolean)) onOpenChange(false);
            else // The interaction saved; only some files did not. Keeping the dialog
            // open lets those be retried without retyping anything.
            setError(new Error((0, $d916753b57975e04$export$25ce5a424b770e84).interaction.uploadFailed));
        } catch (err) {
            setError(err);
        } finally{
            setBusy(false);
        }
    }
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: open,
        onOpenChange: onOpenChange,
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).interaction.title,
        onSubmit: submit,
        submitLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).app.save,
        busy: busy,
        wide: true,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: error
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "grid grid-cols-3 gap-4",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4436e89d3ef1c462$export$bc36ad93e482d2f8), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).interaction.type,
                        value: form.typeId,
                        onChange: (id)=>set({
                                typeId: id
                            }),
                        options: types,
                        loading: typesLoading,
                        includeNone: true,
                        required: true,
                        canCreate: isAdmin,
                        codePrefix: "INTERACTION",
                        creating: createTypeState.loading,
                        createError: createTypeState.error,
                        onCreate: async ({ code: code, labelFa: labelFa })=>{
                            const created = await createType({
                                variables: {
                                    input: {
                                        kind: 'INTERACTION_TYPE',
                                        code: code,
                                        labelFa: labelFa
                                    }
                                }
                            });
                            return created.data?.createLookup;
                        }
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$ce0a41819d728248), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).interaction.date,
                        value: form.date,
                        onChange: (iso)=>set({
                                date: iso
                            })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).interaction.time,
                        value: form.time,
                        onChange: (e)=>set({
                                time: e.target.value
                            }),
                        dir: "ltr",
                        inputMode: "numeric",
                        placeholder: "14:30"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                        className: "flex items-end gap-3",
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$f5c9f3c2c4054eec), {
                            label: (0, $d916753b57975e04$export$25ce5a424b770e84).interaction.description,
                            className: "flex-1",
                            rows: 5,
                            value: form.description,
                            onChange: (e)=>set({
                                    description: e.target.value
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9ea591071a6a48b8$export$86de4a341ed9487f), {
                                listening: dictation.listening,
                                onToggle: dictation.toggle,
                                disabled: busy
                            }),
                            dictation.error && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                role: "alert",
                                className: "text-xs text-danger",
                                children: dictation.error
                            }),
                            interim && /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                className: "text-sm text-text-muted",
                                children: [
                                    interim,
                                    "\u2026"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)($de39eaf1449f169c$var$Dropzone, {
                files: files,
                onAdd: addFiles,
                onRemove: (key)=>setFiles((c)=>c.filter((f)=>f.key !== key)),
                onRetry: (entry)=>patchFile(entry.key, {
                        state: 'queued',
                        error: null
                    }),
                inputRef: fileInputRef,
                disabled: busy
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "grid grid-cols-2 gap-4",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).interaction.outcome,
                        value: form.outcome,
                        onChange: (e)=>set({
                                outcome: e.target.value
                            })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).interaction.status,
                        value: form.status,
                        onChange: (e)=>set({
                                status: e.target.value
                            }),
                        children: $de39eaf1449f169c$var$INTERACTION_STATUSES.map((status)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                value: status,
                                children: (0, $d4d460d3ffb6daab$export$a204b71704535ad8)[status]
                            }, status))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).interaction.followUpNote,
                hint: (0, $d916753b57975e04$export$25ce5a424b770e84).interaction.followUpHint,
                value: form.followUp,
                onChange: (e)=>set({
                        followUp: e.target.value
                    })
            })
        ]
    });
}
function $de39eaf1449f169c$var$Dropzone({ files: files, onAdd: onAdd, onRemove: onRemove, onRetry: onRetry, inputRef: inputRef, disabled: disabled }) {
    const [over, setOver] = (0, $3OyDL.useState)(false);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                className: "text-sm text-text-muted",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).interaction.attachments
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("button", {
                type: "button",
                disabled: disabled,
                onClick: ()=>inputRef.current?.click(),
                onDragOver: (e)=>{
                    e.preventDefault();
                    setOver(true);
                },
                onDragLeave: ()=>setOver(false),
                onDrop: (e)=>{
                    e.preventDefault();
                    setOver(false);
                    onAdd(e.dataTransfer.files);
                },
                className: `flex h-toolbar items-center justify-center gap-2 rounded border border-dashed
                    text-sm transition-colors disabled:opacity-50 ${over ? 'border-primary bg-surface-hover text-primary' : 'border-border text-text-muted hover:bg-surface-hover'}`,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e6a0b4aa733f75fd$export$2e2bcd8739ae039), {
                        size: 14,
                        "aria-hidden": "true"
                    }),
                    (0, $d916753b57975e04$export$25ce5a424b770e84).interaction.dropzone
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                ref: inputRef,
                type: "file",
                multiple: true,
                className: "hidden",
                onChange: (event)=>{
                    onAdd(event.target.files);
                    event.target.value = '';
                }
            }),
            files.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
                className: "flex flex-col gap-2",
                children: files.map((entry)=>/*#__PURE__*/ (0, $2M70Q.jsxs)("li", {
                        className: "flex items-center gap-3 rounded border border-border px-4 py-2 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                className: "min-w-0 flex-1 truncate",
                                title: entry.file.name,
                                children: entry.file.name
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                className: "text-text-muted",
                                children: (0, $d4d460d3ffb6daab$export$e1a3971de07c83b5)(entry.file.size)
                            }),
                            entry.state === 'uploading' && /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                className: "flex items-center gap-2 text-text-muted",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {}),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).interaction.uploading
                                ]
                            }),
                            entry.state === 'done' && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                className: "text-success",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.saved
                            }),
                            entry.state === 'failed' && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                        className: "text-danger",
                                        title: entry.error,
                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).interaction.uploadFailed
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                        variant: "ghost",
                                        onClick: ()=>onRetry(entry),
                                        title: (0, $d916753b57975e04$export$25ce5a424b770e84).app.retry,
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9c3f9cc44ddc2285$export$2e2bcd8739ae039), {
                                            size: 14,
                                            "aria-hidden": "true"
                                        })
                                    })
                                ]
                            }),
                            entry.state !== 'done' && entry.state !== 'uploading' && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                variant: "ghost",
                                onClick: ()=>onRemove(entry.key),
                                "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).app.remove,
                                title: (0, $d916753b57975e04$export$25ce5a424b770e84).app.remove,
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $bi4P4.default), {
                                    size: 14,
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    }, entry.key))
            })
        ]
    });
}


/**
 * Products this contact is interested in, and — for a person — which
 * organizations they belong to.
 *
 * The interests checklist is where Step 2's admin-created PRODUCT lookups
 * finally show up in daily work: nothing here names a product, so a deployment
 * that sells something else gets its own list by editing seed data
 * (CLAUDE.md §1).
 */ 
var $2M70Q = parcelRequire("2M70Q");



var $6PxCH = parcelRequire("6PxCH");

var $3OyDL = parcelRequire("3OyDL");






var $8B9Zg = parcelRequire("8B9Zg");
function $4b23b4f4ec62558e$export$ccdaf0435354dc8f({ contact: contact, onSaved: onSaved, readOnly: readOnly }) {
    const [error, setError] = (0, $3OyDL.useState)(null);
    const { isAdmin: isAdmin } = (0, $00d5d84dffcdf8d5$export$ad0a340bf97d63d5)();
    const variables = {
        kind: 'PRODUCT',
        includeInactive: false
    };
    const { data: data, loading: loading } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$d2d584f4325fcf08), {
        variables: variables
    });
    const [setInterests, { loading: saving }] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$592dd87ffcd0d16a));
    // «اگر محصول موردنظر در لیست نبود، نامش را وارد کنید» — through the SAME
    // vocabulary mechanism every other picker uses, so this is not a second
    // product catalogue. The control is absent for a USER, who would be refused
    // at the BFF and again at the service.
    const [createLookup, createState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$bceff013a27ec1ea), {
        refetchQueries: [
            {
                query: (0, $13be303c7211393a$export$d2d584f4325fcf08),
                variables: variables
            }
        ],
        awaitRefetchQueries: true
    });
    const products = data?.lookups ?? [];
    const chosen = new Set(contact.interests.map((i)=>i.product.id));
    // A product deactivated after this contact showed interest still belongs on
    // the profile — it is history — so it is appended to the active list.
    const retired = contact.interests.map((i)=>i.product).filter((p)=>!products.some((active)=>active.id === p.id));
    async function toggle(productId) {
        setError(null);
        const next = chosen.has(productId) ? [
            ...chosen
        ].filter((id)=>id !== productId) : [
            ...chosen,
            productId
        ];
        try {
            await setInterests({
                variables: {
                    contactId: contact.id,
                    productIds: next
                }
            });
            await onSaved?.();
        } catch (err) {
            setError(err);
        }
    }
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "mb-4 flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                        className: "text-md font-bold",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.interests
                    }),
                    saving && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {})
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: error
            }),
            loading && products.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {}),
            !loading && products.length === 0 && contact.interests.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-text-muted",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.noInterests
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    products.map((product)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$94195a47b94ed396), {
                            label: product.labelFa,
                            checked: chosen.has(product.id),
                            disabled: readOnly || saving,
                            onChange: ()=>toggle(product.id)
                        }, product.id)),
                    retired.map((product)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$94195a47b94ed396), {
                            label: `${product.labelFa} (${(0, $d916753b57975e04$export$25ce5a424b770e84).app.inactive})`,
                            checked: true,
                            disabled: true
                        }, product.id))
                ]
            }),
            !readOnly && /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: "mt-4 border-t border-border pt-4",
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4436e89d3ef1c462$export$bc36ad93e482d2f8), {
                    label: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.product,
                    value: "",
                    // Choosing an existing row here TICKS it, so the picker doubles as
                    // "add one I can see" and "add one that is missing" — one control
                    // for one intent, rather than a select beside a plus.
                    onChange: (id)=>id && !chosen.has(id) && toggle(id),
                    options: products,
                    loading: loading,
                    includeNone: true,
                    canCreate: isAdmin,
                    codePrefix: "PRODUCT",
                    creating: createState.loading,
                    createError: createState.error,
                    onCreate: async ({ labelFa: labelFa, code: code })=>{
                        const { data: created } = await createLookup({
                            variables: {
                                input: {
                                    kind: 'PRODUCT',
                                    code: code,
                                    labelFa: labelFa
                                }
                            }
                        });
                        const id = created?.createLookup?.id;
                        if (id) await toggle(id);
                        return id;
                    }
                })
            })
        ]
    });
}
function $4b23b4f4ec62558e$export$ff908043192c6bb6({ contact: contact, onSaved: onSaved, readOnly: readOnly }) {
    const [adding, setAdding] = (0, $3OyDL.useState)(false);
    const [removing, setRemoving] = (0, $3OyDL.useState)(null);
    const [error, setError] = (0, $3OyDL.useState)(null);
    const [removeAffiliation] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$c1cd75f1a3d9800f));
    const isPerson = contact.kind === 'PERSON';
    async function remove(affiliation) {
        setError(null);
        try {
            await removeAffiliation({
                variables: {
                    personContactId: affiliation.personContactId,
                    organizationContactId: affiliation.organizationContactId
                }
            });
            await onSaved?.();
        } catch (err) {
            setError(err);
        }
    }
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "mb-4 flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                        className: "text-md font-bold",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.affiliations
                    }),
                    !readOnly && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "ghost",
                        className: "ms-auto",
                        onClick: ()=>setAdding(true),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                                size: 14,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.addAffiliation
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: error
            }),
            contact.affiliations.length === 0 ? /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-text-muted",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.noAffiliations
            }) : /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
                className: "flex flex-col gap-3",
                children: contact.affiliations.map((affiliation)=>{
                    // One row, read from whichever end this contact is not.
                    const otherName = isPerson ? affiliation.organizationName : affiliation.personName;
                    const otherId = isPerson ? affiliation.organizationContactId : affiliation.personContactId;
                    return /*#__PURE__*/ (0, $2M70Q.jsxs)("li", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8B9Zg.Link), {
                                to: `/contacts/${otherId}`,
                                className: "text-primary hover:underline",
                                children: otherName
                            }),
                            affiliation.roleTitle && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                className: "text-sm text-text-muted",
                                children: affiliation.roleTitle
                            }),
                            !readOnly && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                variant: "ghost",
                                className: "ms-auto",
                                onClick: ()=>setRemoving(affiliation),
                                "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).app.remove,
                                title: (0, $d916753b57975e04$export$25ce5a424b770e84).app.remove,
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8750d1d3edd41705$export$2e2bcd8739ae039), {
                                    size: 14,
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    }, affiliation.id);
                })
            }),
            adding && /*#__PURE__*/ (0, $2M70Q.jsx)($4b23b4f4ec62558e$var$AffiliationDialog, {
                contact: contact,
                open: adding,
                onOpenChange: setAdding,
                onSaved: onSaved
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2cc85109a937009e), {
                open: Boolean(removing),
                onOpenChange: (next)=>!next && setRemoving(null),
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).app.remove,
                message: removing ? (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.confirmRemoveAffiliation(isPerson ? removing.organizationName : removing.personName) : '',
                confirmLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).app.remove,
                danger: true,
                onConfirm: ()=>remove(removing)
            })
        ]
    });
}
/**
 * Pick the counterpart and give them a role title.
 *
 * The picker searches the *other* kind: a person's dialog lists organizations
 * and vice versa. That mirrors the domain rule (person ↔ organization only) in
 * the UI, so the invalid combination is unreachable rather than merely refused.
 */ function $4b23b4f4ec62558e$var$AffiliationDialog({ contact: contact, open: open, onOpenChange: onOpenChange, onSaved: onSaved }) {
    const isPerson = contact.kind === 'PERSON';
    const [search, setSearch] = (0, $3OyDL.useState)('');
    const [chosenId, setChosenId] = (0, $3OyDL.useState)('');
    const [roleTitle, setRoleTitle] = (0, $3OyDL.useState)('');
    const [error, setError] = (0, $3OyDL.useState)(null);
    const { data: data, loading: loading } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$9b2e8c059cb38823), {
        variables: {
            page: 1,
            pageSize: 25,
            search: search.trim() || null
        }
    });
    const [setAffiliation, { loading: saving }] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$c0bfd20ca7055609));
    const wanted = isPerson ? 'ORGANIZATION' : 'PERSON';
    const candidates = (data?.contacts?.items ?? []).filter((c)=>c.kind === wanted && c.id !== contact.id);
    async function submit() {
        if (!chosenId) return;
        setError(null);
        try {
            await setAffiliation({
                variables: {
                    personContactId: isPerson ? contact.id : chosenId,
                    organizationContactId: isPerson ? chosenId : contact.id,
                    roleTitle: roleTitle.trim() || null
                }
            });
            await onSaved?.();
            onOpenChange(false);
        } catch (err) {
            setError(err);
        }
    }
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: open,
        onOpenChange: onOpenChange,
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.addAffiliation,
        onSubmit: submit,
        busy: saving,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: error
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: isPerson ? (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.organization : (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.person,
                placeholder: isPerson ? (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.searchOrganization : (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.searchPerson,
                value: search,
                onChange: (event)=>setSearch(event.target.value)
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).app.search,
                value: chosenId,
                onChange: (event)=>setChosenId(event.target.value),
                required: true,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: "",
                        children: loading ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.loading : (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    candidates.map((candidate)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                            value: candidate.id,
                            children: candidate.displayName
                        }, candidate.id))
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.roleTitle,
                value: roleTitle,
                onChange: (event)=>setRoleTitle(event.target.value)
            })
        ]
    });
}


/**
 * Files attached to the CONTACT — a scanned licence, a signed quote, the
 * clinic's price list.
 *
 * Nothing here is new infrastructure. `ownerType: 'CONTACT'` has been a valid
 * attachment owner since Step 3 and `ListAttachments` has answered for it ever
 * since; what was missing was a screen that asked. So this is the interaction
 * composer's upload flow and the timeline's download button, over the contact
 * instead of over one interaction:
 *
 *   POST /files/initiate  →  PUT straight to storage  →  POST /files/complete
 *
 * The bytes never pass through the BFF, the PUT reports progress because it is
 * an XHR, and a download URL is minted per CLICK rather than rendered as an
 * href — a presigned URL expires in minutes, so a link built at render time is
 * dead by the time anybody uses it.
 *
 * A PENDING row is invisible to every read path, so an abandoned upload leaks
 * a row rather than showing as a broken attachment.
 */ 
var $2M70Q = parcelRequire("2M70Q");


var $6PxCH = parcelRequire("6PxCH");

var $3OyDL = parcelRequire("3OyDL");




function $0f5a1967626d2e5c$export$5287a4f9fdec4248({ contact: contact, onSaved: onSaved, readOnly: readOnly }) {
    const inputRef = (0, $3OyDL.useRef)(null);
    const [uploading, setUploading] = (0, $3OyDL.useState)(null); // { name, progress }
    const [error, setError] = (0, $3OyDL.useState)(null);
    const files = contact.attachments ?? [];
    async function add(list) {
        setError(null);
        for (const file of [
            ...list
        ]){
            setUploading({
                name: file.name,
                progress: 0
            });
            try {
                await (0, $d305624b55b31f43$export$a5575dbeeffdad98)({
                    file: file,
                    ownerType: 'CONTACT',
                    ownerId: contact.id,
                    onProgress: (fraction)=>setUploading({
                            name: file.name,
                            progress: fraction
                        })
                });
            } catch (err) {
                setError(err);
                break;
            } finally{
                setUploading(null);
            }
        }
        // Re-read rather than appending locally: the server decides what is READY,
        // and the panel showing something the server would not list is exactly the
        // divergence the profile's refetch-after-save rule exists to avoid.
        await onSaved?.();
        if (inputRef.current) inputRef.current.value = '';
    }
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "mb-4 flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                        className: "text-md font-bold",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.files
                    }),
                    !readOnly && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                variant: "ghost",
                                className: "ms-auto",
                                onClick: ()=>inputRef.current?.click(),
                                disabled: Boolean(uploading),
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                                        size: 14,
                                        "aria-hidden": "true"
                                    }),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.addFile
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                                ref: inputRef,
                                type: "file",
                                multiple: true,
                                className: "hidden",
                                "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.addFile,
                                onChange: (event)=>event.target.files?.length && add(event.target.files)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: error
            }),
            uploading && /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                role: "status",
                className: "mb-3 flex items-center gap-2 text-sm text-text-muted",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {}),
                    uploading.name,
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                        className: "tabular-nums",
                        children: [
                            Math.round(uploading.progress * 100),
                            "\u066A"
                        ]
                    })
                ]
            }),
            files.length === 0 && !uploading ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$fddf379e22a74b00), {
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.noFiles
            }) : /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
                className: "flex flex-col gap-2",
                children: files.map((file)=>/*#__PURE__*/ (0, $2M70Q.jsxs)("li", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("button", {
                                type: "button",
                                onClick: ()=>(0, $d305624b55b31f43$export$70cccf46c7504cdc)(file.id),
                                title: `${file.fileName} \u{2014} ${(0, $d4d460d3ffb6daab$export$e1a3971de07c83b5)(file.sizeBytes)}`,
                                className: "flex items-center gap-2 rounded border border-border px-3 py-1 text-sm text-text-muted hover:bg-surface-hover hover:text-text",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e6a0b4aa733f75fd$export$2e2bcd8739ae039), {
                                        size: 13,
                                        "aria-hidden": "true"
                                    }),
                                    file.fileName
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                className: "text-xs text-text-muted",
                                children: (0, $d4d460d3ffb6daab$export$e1a3971de07c83b5)(file.sizeBytes)
                            }),
                            file.createdAt && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                className: "ms-auto text-xs text-text-muted",
                                children: (0, $d4d460d3ffb6daab$export$3ae94a2503e890a1)(file.createdAt)
                            })
                        ]
                    }, file.id))
            })
        ]
    });
}


/**
 * Phone numbers: add, edit, set primary, choose channels, remove.
 *
 * The primary is a radio, not a checkbox, because exactly one number is primary
 * — a rule the server enforces in a single transaction. Rendering it as a
 * checkbox would suggest a state ("two primaries", "none") that cannot exist.
 *
 * Removal is the one hard delete in MeshHub and is guarded server-side, so the
 * confirm dialog says «این حذف قطعی است» rather than the softer wording every
 * deactivation uses. A refusal from the domain guard surfaces as the error
 * message it came with, not a generic failure.
 */ 
var $2M70Q = parcelRequire("2M70Q");



var $2vK0R = parcelRequire("2vK0R");
var $6PxCH = parcelRequire("6PxCH");

var $3OyDL = parcelRequire("3OyDL");





function $bae3dbaf0eb4dc53$export$32f640202e9e5673({ contact: contact, onSaved: onSaved, readOnly: readOnly }) {
    const [editing, setEditing] = (0, $3OyDL.useState)(null); // null | 'new' | phone object
    const [removing, setRemoving] = (0, $3OyDL.useState)(null);
    const [error, setError] = (0, $3OyDL.useState)(null);
    const { data: channelData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$d2d584f4325fcf08), {
        variables: {
            kind: 'COMMUNICATION_CHANNEL',
            includeInactive: false
        }
    });
    const channels = channelData?.lookups ?? [];
    const [setPrimary] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$9199c4a746e9200));
    const [setChannels] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$ad4a4d3fb42d49a6));
    const [removePhone] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$243aac1b21f2c5ae));
    const run = async (fn)=>{
        setError(null);
        try {
            await fn();
            await onSaved?.();
        } catch (err) {
            setError(err);
        }
    };
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "mb-4 flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                        className: "text-md font-bold",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.phones
                    }),
                    !readOnly && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "ghost",
                        className: "ms-auto",
                        onClick: ()=>setEditing('new'),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                                size: 14,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.addPhone
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: error
            }),
            contact.phoneNumbers.length === 0 ? /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-text-muted",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.noPhones
            }) : /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
                className: "flex flex-col gap-4",
                children: contact.phoneNumbers.map((phone)=>/*#__PURE__*/ (0, $2M70Q.jsxs)("li", {
                        className: "flex flex-col gap-2 border-b border-border pb-4 last:border-b-0 last:pb-0",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                className: "flex flex-wrap items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)("label", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                                                type: "radio",
                                                name: `primary-${contact.id}`,
                                                className: "accent-primary",
                                                checked: phone.isPrimary,
                                                disabled: readOnly,
                                                onChange: ()=>run(()=>setPrimary({
                                                            variables: {
                                                                phoneNumberId: phone.id
                                                            }
                                                        })),
                                                "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.makePrimary
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                dir: "ltr",
                                                className: "font-medium tabular-nums",
                                                children: (0, $d4d460d3ffb6daab$export$10c09b2cff9813eb)(phone.number)
                                            })
                                        ]
                                    }),
                                    phone.label && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                        className: "text-sm text-text-muted",
                                        children: phone.label
                                    }),
                                    phone.isPrimary && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                        className: "text-xs text-primary",
                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.primary
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                        className: "ms-auto flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ccacecf78328396f$export$f9f39c056569f034), {
                                                channels: phone.channels
                                            }),
                                            !readOnly && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                                        variant: "ghost",
                                                        onClick: ()=>setEditing(phone),
                                                        "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.editPhone,
                                                        title: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.editPhone,
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2vK0R.default), {
                                                            size: 14,
                                                            "aria-hidden": "true"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                                        variant: "ghost",
                                                        onClick: ()=>setRemoving(phone),
                                                        "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).app.remove,
                                                        title: (0, $d916753b57975e04$export$25ce5a424b770e84).app.remove,
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8750d1d3edd41705$export$2e2bcd8739ae039), {
                                                            size: 14,
                                                            "aria-hidden": "true"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !readOnly && /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                                className: "flex flex-wrap gap-4 ps-6",
                                children: channels.map((channel)=>{
                                    const active = phone.channels.some((c)=>c.code === channel.code);
                                    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$94195a47b94ed396), {
                                        label: channel.labelFa,
                                        checked: active,
                                        onChange: ()=>run(()=>setChannels({
                                                    variables: {
                                                        phoneNumberId: phone.id,
                                                        channelCodes: active ? phone.channels.filter((c)=>c.code !== channel.code).map((c)=>c.code) : [
                                                            ...phone.channels.map((c)=>c.code),
                                                            channel.code
                                                        ]
                                                    }
                                                }))
                                    }, channel.id);
                                })
                            })
                        ]
                    }, phone.id))
            }),
            editing && /*#__PURE__*/ (0, $2M70Q.jsx)($bae3dbaf0eb4dc53$var$PhoneDialog, {
                contactId: contact.id,
                phone: editing === 'new' ? null : editing,
                channels: channels,
                open: Boolean(editing),
                onOpenChange: (next)=>!next && setEditing(null),
                onSaved: onSaved
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2cc85109a937009e), {
                open: Boolean(removing),
                onOpenChange: (next)=>!next && setRemoving(null),
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).app.remove,
                message: removing ? (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.confirmRemovePhone((0, $d4d460d3ffb6daab$export$10c09b2cff9813eb)(removing.number)) : '',
                confirmLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).app.remove,
                danger: true,
                onConfirm: ()=>run(()=>removePhone({
                            variables: {
                                phoneNumberId: removing.id
                            }
                        }))
            })
        ]
    });
}
function $bae3dbaf0eb4dc53$var$PhoneDialog({ contactId: contactId, phone: phone, channels: channels, open: open, onOpenChange: onOpenChange, onSaved: onSaved }) {
    const [form, setForm] = (0, $3OyDL.useState)(()=>({
            numberRaw: phone?.number ?? '',
            label: phone?.label ?? '',
            notes: phone?.notes ?? '',
            channelCodes: phone?.channels.map((c)=>c.code) ?? []
        }));
    const [error, setError] = (0, $3OyDL.useState)(null);
    const [addPhone, { loading: adding }] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$7846c1e041428763));
    const [updatePhone, { loading: updating }] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$f4b9f8e7332ad2b2));
    const [setChannels] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$ad4a4d3fb42d49a6));
    const set = (patch)=>setForm((current)=>({
                ...current,
                ...patch
            }));
    const toggle = (code)=>set({
            channelCodes: form.channelCodes.includes(code) ? form.channelCodes.filter((c)=>c !== code) : [
                ...form.channelCodes,
                code
            ]
        });
    async function submit() {
        setError(null);
        // Digits are normalized here so the API always receives ASCII, whichever
        // keyboard the user had open (CLAUDE.md §12).
        const numberRaw = (0, $d4d460d3ffb6daab$export$365a38b4fc2bed91)(form.numberRaw).trim();
        try {
            if (phone) {
                await updatePhone({
                    variables: {
                        phoneNumberId: phone.id,
                        numberRaw: numberRaw,
                        label: form.label.trim(),
                        notes: form.notes.trim()
                    }
                });
                await setChannels({
                    variables: {
                        phoneNumberId: phone.id,
                        channelCodes: form.channelCodes
                    }
                });
            } else await addPhone({
                variables: {
                    contactId: contactId,
                    phoneNumber: {
                        numberRaw: numberRaw,
                        label: form.label.trim() || null,
                        notes: form.notes.trim() || null,
                        channelCodes: form.channelCodes
                    }
                }
            });
            await onSaved?.();
            onOpenChange(false);
        } catch (err) {
            setError(err);
        }
    }
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: open,
        onOpenChange: onOpenChange,
        title: phone ? (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.editPhone : (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.addPhone,
        onSubmit: submit,
        busy: adding || updating,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: error
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.phoneNumber,
                value: form.numberRaw,
                onChange: (e)=>set({
                        numberRaw: e.target.value
                    }),
                dir: "ltr",
                inputMode: "tel",
                required: true
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.phoneLabel,
                value: form.label,
                onChange: (e)=>set({
                        label: e.target.value
                    })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.phoneNotes,
                value: form.notes,
                onChange: (e)=>set({
                        notes: e.target.value
                    })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("fieldset", {
                className: "flex flex-wrap gap-4",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("legend", {
                        className: "mb-2 text-sm text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.channels
                    }),
                    channels.map((channel)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$94195a47b94ed396), {
                            label: channel.labelFa,
                            checked: form.channelCodes.includes(channel.code),
                            onChange: ()=>toggle(channel.code)
                        }, channel.id))
                ]
            })
        ]
    });
}


/**
 * Change a contact's pipeline stage, with the history underneath.
 *
 * The rule worth stating: **moving backwards requires a reason.** Enforced in
 * the domain layer (SUBSCRIBER → INTERESTED means something went wrong, and
 * whoever reads that history in six months needs to know what). Mirrored here
 * only so the user finds out before submitting — the server is what actually
 * decides, and its refusal surfaces as a normal field error if this check is
 * ever wrong.
 *
 * The history is shown in the same dialog because the question "should this
 * move backwards?" is almost always answered by "what happened last time?".
 */ 
var $2M70Q = parcelRequire("2M70Q");



var $3OyDL = parcelRequire("3OyDL");




/** The pipeline, in order. Order is what "backwards" means. */ const $d8283146ac3977c4$var$PIPELINE = [
    'UNKNOWN',
    'INTERESTED',
    'CONSULTING',
    'SUBSCRIBER'
];
const $d8283146ac3977c4$var$isBackward = (from, to)=>$d8283146ac3977c4$var$PIPELINE.indexOf(to) < $d8283146ac3977c4$var$PIPELINE.indexOf(from);
function $d8283146ac3977c4$export$53b9a9c3865589e7({ open: open, onOpenChange: onOpenChange, contact: contact, onChanged: onChanged }) {
    const [toStatus, setToStatus] = (0, $3OyDL.useState)('');
    const [reason, setReason] = (0, $3OyDL.useState)('');
    const [error, setError] = (0, $3OyDL.useState)(null);
    const [changeStatus, { loading: loading }] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$b75cf570f6a6871c));
    (0, $3OyDL.useEffect)(()=>{
        if (open) {
            setToStatus('');
            setReason('');
            setError(null);
        }
    }, [
        open
    ]);
    const backward = toStatus && $d8283146ac3977c4$var$isBackward(contact.collaborationStatus, toStatus);
    const reasonMissing = backward && !reason.trim();
    async function submit() {
        if (!toStatus) return;
        if (reasonMissing) {
            setError(new Error((0, $d916753b57975e04$export$25ce5a424b770e84).status.reasonRequiredBackward));
            return;
        }
        setError(null);
        try {
            await changeStatus({
                variables: {
                    contactId: contact.id,
                    toStatus: toStatus,
                    reason: reason.trim() || null
                }
            });
            await onChanged?.();
            onOpenChange(false);
        } catch (err) {
            setError(err);
        }
    }
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: open,
        onOpenChange: onOpenChange,
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).status.title,
        onSubmit: submit,
        submitLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).status.submit,
        busy: loading,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: error
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-sm text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).status.current
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$5720c1871db44880), {
                        status: contact.collaborationStatus,
                        label: (0, $d4d460d3ffb6daab$export$3c3cfc169bd4703d)[contact.collaborationStatus]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).status.next,
                value: toStatus,
                onChange: (event)=>setToStatus(event.target.value),
                required: true,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: "",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    $d8283146ac3977c4$var$PIPELINE.filter((status)=>status !== contact.collaborationStatus).map((status)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                            value: status,
                            children: (0, $d4d460d3ffb6daab$export$3c3cfc169bd4703d)[status]
                        }, status))
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$f5c9f3c2c4054eec), {
                label: backward ? (0, $d916753b57975e04$export$25ce5a424b770e84).status.reason : (0, $d916753b57975e04$export$25ce5a424b770e84).status.reasonOptional,
                rows: 3,
                value: reason,
                onChange: (event)=>setReason(event.target.value),
                hint: backward ? (0, $d916753b57975e04$export$25ce5a424b770e84).status.reasonRequiredBackward : undefined,
                required: backward
            }),
            contact.statusHistory.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h3", {
                        className: "mb-2 text-sm font-medium text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).status.history
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("ol", {
                        className: "flex max-h-[30vh] flex-col gap-3 overflow-auto",
                        children: contact.statusHistory.map((change)=>/*#__PURE__*/ (0, $2M70Q.jsxs)("li", {
                                className: "flex flex-col gap-1 border-s-2 border-border ps-4",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                        className: "flex flex-wrap items-center gap-2",
                                        children: [
                                            change.fromStatus && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                        className: "text-sm text-text-muted",
                                                        children: (0, $d4d460d3ffb6daab$export$3c3cfc169bd4703d)[change.fromStatus]
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                        className: "text-text-muted",
                                                        "aria-hidden": "true",
                                                        children: "\u2190"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$5720c1871db44880), {
                                                status: change.toStatus,
                                                label: (0, $d4d460d3ffb6daab$export$3c3cfc169bd4703d)[change.toStatus]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                className: "ms-auto text-xs text-text-muted",
                                                children: (0, $d4d460d3ffb6daab$export$8b492ed8828f789c)(change.changedAt)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                                        className: "text-xs text-text-muted",
                                        children: [
                                            (0, $d916753b57975e04$export$25ce5a424b770e84).status.by,
                                            " ",
                                            change.changedByName
                                        ]
                                    }),
                                    change.reason && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                        className: "text-sm text-text-muted",
                                        children: change.reason
                                    })
                                ]
                            }, change.id))
                    })
                ]
            })
        ]
    });
}


/**
 * Inline tag editing in the profile header.
 *
 * A popover of the active tags with the contact's own ticked, rather than a
 * dialog: tagging is a one-click judgement made while reading the profile, and
 * a modal for it would be heavier than the decision.
 *
 * Only *active* tags can be added; a tag deactivated after it was applied stays
 * on the contact and stays visible, because deactivation is not deletion
 * (CLAUDE.md §5). Tag colours come from the API — the one legitimate place a
 * colour value reaches app code, since admins choose them (client CLAUDE.md).
 */ 
var $2M70Q = parcelRequire("2M70Q");



var $6PxCH = parcelRequire("6PxCH");

var $3OyDL = parcelRequire("3OyDL");



function $4d83a78eafaaee98$export$ed0487506eb44813({ contact: contact, onSaved: onSaved, readOnly: readOnly }) {
    const [open, setOpen] = (0, $3OyDL.useState)(false);
    const [error, setError] = (0, $3OyDL.useState)(null);
    const { data: data, loading: loading } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$c064f18f2e294629), {
        variables: {
            includeInactive: false
        },
        skip: !open
    });
    const [tagContact, { loading: tagging }] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$d4645122950b3dd3));
    const [untagContact, { loading: untagging }] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$f5d4460b81cdbdcf));
    const applied = new Set(contact.tags.map((t)=>t.id));
    async function toggle(tagId) {
        setError(null);
        try {
            const mutate = applied.has(tagId) ? untagContact : tagContact;
            await mutate({
                variables: {
                    contactId: contact.id,
                    tagId: tagId
                }
            });
            await onSaved?.();
        } catch (err) {
            setError(err);
        }
    }
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                className: "flex flex-wrap items-center gap-1",
                children: [
                    contact.tags.map((tag)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$c21cd4bbffdb84a0), {
                            name: tag.name,
                            colorHex: tag.colorHex
                        }, tag.id)),
                    !readOnly && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "ghost",
                        onClick: ()=>setOpen(true),
                        "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.addTag,
                        title: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.addTag,
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                            size: 14,
                            "aria-hidden": "true"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
                open: open,
                onOpenChange: setOpen,
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.tags,
                onSubmit: ()=>setOpen(false),
                submitLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).app.close,
                busy: tagging || untagging,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                        error: error
                    }),
                    loading && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {}),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                        className: "flex flex-col gap-2",
                        children: (data?.tags ?? []).map((tag)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$94195a47b94ed396), {
                                label: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$c21cd4bbffdb84a0), {
                                    name: tag.name,
                                    colorHex: tag.colorHex
                                }),
                                checked: applied.has(tag.id),
                                onChange: ()=>toggle(tag.id)
                            }, tag.id))
                    })
                ]
            })
        ]
    });
}


/**
 * The interaction timeline: everything that has happened with this contact,
 * newest first, filterable by type and date range.
 *
 * **Paged, not infinite scroll**, with an explicit «نمایش بیشتر». Three
 * reasons, recorded in docs/decisions.md: the timeline shares a scroll
 * container with the rest of the profile, so an infinite list would hijack the
 * page's scrollbar; a filtered view usually fits on one page, making automatic
 * loading invisible work; and a back-office user reading history wants to know
 * how much there is, which a total count and a button tell them and an endless
 * list does not.
 *
 * Attachment links are minted per click, never rendered as hrefs — a presigned
 * URL expires in minutes, so a link built at render time would be dead by the
 * time anyone clicked it.
 */ 
var $2M70Q = parcelRequire("2M70Q");



var $bcl5v = parcelRequire("bcl5v");
var $b6UhZ = parcelRequire("b6UhZ");

var $3OyDL = parcelRequire("3OyDL");

var $8B9Zg = parcelRequire("8B9Zg");






const $0dfe5b82a0098687$var$NO_FILTERS = {
    typeId: '',
    dateFrom: null,
    dateTo: null
};
function $0dfe5b82a0098687$export$e6a97ba2cae5bb94({ contactId: contactId, types: types, reloadToken: reloadToken = 0, onFollowUp: onFollowUp }) {
    const [filters, setFilters] = (0, $3OyDL.useState)($0dfe5b82a0098687$var$NO_FILTERS);
    const [pageSize, setPageSize] = (0, $3OyDL.useState)((0, $370d2fd34ead4cb4$export$6341774785f0a1ff));
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$b16b176cffe7eb2b), {
        variables: {
            contactId: contactId,
            page: 1,
            pageSize: pageSize,
            typeId: filters.typeId || null,
            dateFrom: filters.dateFrom ? (0, $d4d460d3ffb6daab$export$747b60771a8a4ce9)(filters.dateFrom, '00:00') : null,
            // Inclusive to the end of the chosen day, which is what «تا ۸ شهریور»
            // means to a person reading a date range.
            dateTo: filters.dateTo ? (0, $d4d460d3ffb6daab$export$747b60771a8a4ce9)(filters.dateTo, '23:59') : null
        },
        fetchPolicy: 'cache-and-network'
    });
    // The parent bumps `reloadToken` after recording an interaction. A token
    // rather than a callback ref because the composer finishes *after* its file
    // uploads, and the parent is the only place that knows the whole flow is done.
    (0, $3OyDL.useEffect)(()=>{
        if (reloadToken > 0) refetch();
    }, [
        reloadToken,
        refetch
    ]);
    const interactions = data?.interactions?.items ?? [];
    const total = data?.interactions?.totalCount ?? 0;
    const hasMore = interactions.length < total;
    const filtered = filters.typeId || filters.dateFrom || filters.dateTo;
    const set = (patch)=>{
        setFilters((current)=>({
                ...current,
                ...patch
            }));
        setPageSize((0, $370d2fd34ead4cb4$export$6341774785f0a1ff)); // a new filter starts at the first page
    };
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "mb-4 flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                        className: "text-md font-bold",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.interactions
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-sm text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.count((0, $d4d460d3ffb6daab$export$104ee80c24270f18)(total))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "mb-5 grid grid-cols-4 items-end gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).interaction.filterType,
                        value: filters.typeId,
                        onChange: (event)=>set({
                                typeId: event.target.value
                            }),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                value: "",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.all
                            }),
                            types.map((type)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                    value: type.id,
                                    children: type.labelFa
                                }, type.id))
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$ce0a41819d728248), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).interaction.filterFrom,
                        value: filters.dateFrom,
                        onChange: (iso)=>set({
                                dateFrom: iso
                            })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$ce0a41819d728248), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).interaction.filterTo,
                        value: filters.dateTo,
                        onChange: (iso)=>set({
                                dateTo: iso
                            })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "ghost",
                        disabled: !filtered,
                        onClick: ()=>set($0dfe5b82a0098687$var$NO_FILTERS),
                        className: "justify-self-start",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).interaction.clearFilters
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                role: "alert",
                className: "text-base text-danger",
                children: error.message
            }),
            loading && interactions.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: "flex justify-center p-7",
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {})
            }),
            !loading && interactions.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-text-muted",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.noInteractions
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("ol", {
                className: "flex flex-col gap-5",
                children: interactions.map((interaction)=>/*#__PURE__*/ (0, $2M70Q.jsxs)("li", {
                        className: "border-s-2 border-border ps-4",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                className: "flex flex-wrap items-baseline gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $bcl5v.default), {
                                        size: 14,
                                        "aria-hidden": "true",
                                        className: "text-text-muted"
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                        className: "font-medium",
                                        children: interaction.type.labelFa
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                        className: "text-sm text-text-muted",
                                        children: (0, $d4d460d3ffb6daab$export$8fbbfd65594f46a0)(interaction.occurredAt)
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                        className: "ms-auto text-xs text-text-muted",
                                        children: (0, $d4d460d3ffb6daab$export$a204b71704535ad8)[interaction.status]
                                    })
                                ]
                            }),
                            interaction.description && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                className: "mt-1 whitespace-pre-line text-base",
                                children: interaction.description
                            }),
                            interaction.attachments.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
                                className: "mt-2 flex flex-wrap gap-2",
                                children: interaction.attachments.map((file)=>/*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("button", {
                                            type: "button",
                                            onClick: ()=>(0, $d305624b55b31f43$export$70cccf46c7504cdc)(file.id),
                                            title: `${file.fileName} \u{2014} ${(0, $d4d460d3ffb6daab$export$e1a3971de07c83b5)(file.sizeBytes)}`,
                                            className: "flex items-center gap-1 rounded border border-border px-3 py-1 text-xs text-text-muted hover:bg-surface-hover hover:text-text",
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e6a0b4aa733f75fd$export$2e2bcd8739ae039), {
                                                    size: 12,
                                                    "aria-hidden": "true"
                                                }),
                                                file.fileName
                                            ]
                                        })
                                    }, file.id))
                            }),
                            interaction.outcome && /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                                className: "mt-1 text-sm text-text-muted",
                                children: [
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.outcome,
                                    ": ",
                                    interaction.outcome
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                                className: "mt-1 text-xs text-text-muted",
                                children: [
                                    (0, $d4d460d3ffb6daab$export$8b492ed8828f789c)(interaction.occurredAt),
                                    " \u2014 ",
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).interaction.by,
                                    ' ',
                                    interaction.createdByName
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                                className: "mt-1",
                                children: interaction.followUpActivityId ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $8B9Zg.Link), {
                                    to: "/calendar",
                                    className: "inline-flex items-center gap-1 text-xs text-primary hover:underline",
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b6UhZ.default), {
                                            size: 12,
                                            "aria-hidden": "true"
                                        }),
                                        (0, $d916753b57975e04$export$25ce5a424b770e84).activity.linkedActivity
                                    ]
                                }) : onFollowUp && /*#__PURE__*/ (0, $2M70Q.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>onFollowUp(interaction),
                                    className: "inline-flex items-center gap-1 text-xs text-text-muted hover:text-primary",
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b6UhZ.default), {
                                            size: 12,
                                            "aria-hidden": "true"
                                        }),
                                        (0, $d916753b57975e04$export$25ce5a424b770e84).activity.createdFromInteraction
                                    ]
                                })
                            })
                        ]
                    }, interaction.id))
            }),
            hasMore && /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: "mt-5 flex justify-center",
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                    onClick: ()=>setPageSize((size)=>size + (0, $370d2fd34ead4cb4$export$6341774785f0a1ff)),
                    children: loading ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {}) : (0, $d916753b57975e04$export$25ce5a424b770e84).interaction.loadMore
                })
            })
        ]
    });
}


/**
 * A contact's activities, on their profile.
 *
 * The panel that finally makes the two services visible as one thing to a user:
 * these rows come from the scheduling service, this screen came from the CRM,
 * and the person reading it has no reason to know that.
 */ 
var $2M70Q = parcelRequire("2M70Q");




var $b6UhZ = parcelRequire("b6UhZ");

var $3OyDL = parcelRequire("3OyDL");





function $bfa1dc9a53e438a4$export$39a2fda5a9a1f773({ contactId: contactId }) {
    const [dialog, setDialog] = (0, $3OyDL.useState)(null);
    const { data: data, loading: loading, refetch: refetch } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$169c53b8a8e588c8), {
        variables: {
            contactId: contactId,
            page: 1,
            pageSize: 25
        },
        skip: !contactId,
        fetchPolicy: 'cache-and-network'
    });
    const { data: typeData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$76905cee0d96ad5e));
    const colorForType = (0, $3OyDL.useCallback)((typeId)=>{
        const types = typeData?.activityTypes ?? [];
        const index = types.findIndex((type)=>type.id === typeId);
        return (0, $dd0263804d68f882$export$32d227f17c113340)[(index < 0 ? 0 : index) % (0, $dd0263804d68f882$export$32d227f17c113340).length];
    }, [
        typeData
    ]);
    const activities = data?.activities?.items ?? [];
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("section", {
        className: "flex flex-col gap-3 rounded border border-border bg-surface p-4",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("header", {
                className: "flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                        className: "text-sm font-medium",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.activitiesTab
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        type: "button",
                        className: "ms-auto",
                        onClick: ()=>setDialog({
                                prefill: {
                                    contactId: contactId
                                }
                            }),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b6UhZ.default), {
                                size: 14,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).calendar.newActivity
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$4b2346c6725d60cc), {
                loading: loading && activities.length === 0,
                empty: !loading && activities.length === 0,
                emptyTitle: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.noActivities
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
                className: "flex flex-col gap-1",
                children: activities.map((activity)=>/*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("button", {
                            type: "button",
                            onClick: ()=>setDialog({
                                    activity: activity
                                }),
                            className: "flex w-full items-center gap-3 rounded border-s-4 px-3 py-2 text-start text-sm hover:bg-surface-hover",
                            style: {
                                borderInlineStartColor: colorForType(activity.type?.id)
                            },
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                    className: "flex-1 truncate",
                                    children: activity.title
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                    className: "text-xs text-text-muted",
                                    children: (0, $d4d460d3ffb6daab$export$8b492ed8828f789c)(activity.startsAt)
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                    className: [
                                        'rounded px-2 py-px text-xs',
                                        activity.status === 'MISSED' ? 'bg-danger text-text-inverse' : 'bg-surface-hover text-text-muted'
                                    ].join(' '),
                                    children: (0, $d4d460d3ffb6daab$export$b274e447bdddfc87)[activity.status]
                                })
                            ]
                        })
                    }, activity.id))
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a337acc1647f440c$export$29a29aaae5ee2157), {
                open: Boolean(dialog),
                onOpenChange: (open)=>!open && setDialog(null),
                activity: dialog?.activity,
                prefill: dialog?.prefill,
                onSaved: ()=>refetch()
            })
        ]
    });
}


/** A contact's issues, on their profile. */ 
var $2M70Q = parcelRequire("2M70Q");



var $6PxCH = parcelRequire("6PxCH");

var $3OyDL = parcelRequire("3OyDL");

var $8B9Zg = parcelRequire("8B9Zg");
/**
 * Create an issue. Used from the list and from a contact's profile.
 *
 * `contactId` is optional and that is deliberate — «سرور دیروز کند بود» is an
 * internal problem nobody reported from outside, and inventing a contact for it
 * would be worse than admitting it has none. The feedback service allows a NULL
 * contact for the same reason.
 */ 
var $2M70Q = parcelRequire("2M70Q");


var $3OyDL = parcelRequire("3OyDL");


/**
 * Persian labels for the feedback service's enums.
 *
 * In `lib/` rather than in a screen because the list, the detail, the profile
 * panel and the reports all render the same four vocabularies — and four
 * copies is four chances for «در حال بررسی» to be worded two ways
 * (CLAUDE.md §12).
 */ 
const $8be8610b9776ae98$export$7b239963c3289a2 = {
    PROBLEM: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.kindProblem,
    CRITICISM: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.kindCriticism,
    SUGGESTION: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.kindSuggestion,
    REQUEST: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.kindRequest
};
const $8be8610b9776ae98$export$e1e838806c3b27c5 = {
    LOW: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.priorityLow,
    MEDIUM: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.priorityMedium,
    HIGH: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.priorityHigh,
    URGENT: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.priorityUrgent
};
const $8be8610b9776ae98$export$3b558bfbd454e1bc = {
    OPEN: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.statusOpen,
    IN_PROGRESS: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.statusInProgress,
    WAITING_ON_CONTACT: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.statusWaiting,
    RESOLVED: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.statusResolved,
    CLOSED: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.statusClosed
};
const $8be8610b9776ae98$export$bd92a918e489f48a = {
    LOW: 'text-text-muted',
    MEDIUM: 'text-text',
    HIGH: 'text-warning',
    URGENT: 'text-danger'
};
const $8be8610b9776ae98$export$fce5400eb9b3fa56 = {
    OPEN: 'text-info',
    IN_PROGRESS: 'text-primary',
    WAITING_ON_CONTACT: 'text-warning',
    RESOLVED: 'text-success',
    CLOSED: 'text-text-muted'
};
const $8be8610b9776ae98$export$b2677d2be83a902c = {
    OPEN: [
        'IN_PROGRESS',
        'CLOSED'
    ],
    IN_PROGRESS: [
        'WAITING_ON_CONTACT',
        'RESOLVED',
        'OPEN'
    ],
    WAITING_ON_CONTACT: [
        'IN_PROGRESS',
        'CLOSED'
    ],
    RESOLVED: [
        'CLOSED',
        'IN_PROGRESS'
    ],
    CLOSED: [
        'IN_PROGRESS'
    ]
};





function $4d7077ffa15cf8ad$export$2e00bb6c96d50ef3({ open: open, onOpenChange: onOpenChange, contactId: contactId = null, linkTargetType: linkTargetType = null, linkTargetId: linkTargetId = null, onCreated: onCreated }) {
    const [title, setTitle] = (0, $3OyDL.useState)('');
    const [description, setDescription] = (0, $3OyDL.useState)('');
    const [kind, setKind] = (0, $3OyDL.useState)('PROBLEM');
    const [priority, setPriority] = (0, $3OyDL.useState)('MEDIUM');
    const [typeId, setTypeId] = (0, $3OyDL.useState)('');
    const { isAdmin: isAdmin } = (0, $00d5d84dffcdf8d5$export$ad0a340bf97d63d5)();
    const { data: data, loading: typesLoading } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $047171b3f4119885$export$f08810cd3a46d5f8), {
        variables: {
            includeInactive: false
        },
        errorPolicy: 'ignore'
    });
    const [create, { loading: loading, error: error }] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$a84692caf5a334ea));
    // `typeId` is REQUIRED by the feedback service, so an unseeded ISSUE_TYPE
    // vocabulary makes «ثبت مسئله» unusable — the same dead end as the calendar's.
    const [createType, createTypeState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$ee884be3a3453f7a), {
        refetchQueries: [
            'IssueTypes'
        ],
        awaitRefetchQueries: true
    });
    const types = data?.issueTypes ?? [];
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: open,
        onOpenChange: onOpenChange,
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.newIssue,
        submitLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).app.create,
        busy: loading,
        error: error,
        canSubmit: Boolean(title.trim() && (typeId || types[0]?.id)),
        onSubmit: async ()=>{
            const created = await create({
                variables: {
                    kind: kind,
                    typeId: typeId || types[0]?.id,
                    title: title.trim(),
                    description: description.trim() || null,
                    contactId: contactId,
                    priority: priority,
                    linkTargetType: linkTargetType,
                    linkTargetId: linkTargetId
                }
            });
            setTitle('');
            setDescription('');
            onOpenChange(false);
            onCreated?.(created.data?.createIssue);
        },
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.issueTitle,
                value: title,
                onChange: (event)=>setTitle(event.target.value)
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$f5c9f3c2c4054eec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.description,
                value: description,
                onChange: (event)=>setDescription(event.target.value)
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.kind,
                value: kind,
                onChange: (event)=>setKind(event.target.value),
                children: Object.entries((0, $8be8610b9776ae98$export$7b239963c3289a2)).map(([value, label])=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: value,
                        children: label
                    }, value))
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4436e89d3ef1c462$export$bc36ad93e482d2f8), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.type,
                value: typeId,
                onChange: setTypeId,
                options: types,
                loading: typesLoading,
                required: true,
                canCreate: isAdmin,
                codePrefix: "ISSUE",
                creating: createTypeState.loading,
                createError: createTypeState.error,
                onCreate: async ({ code: code, labelFa: labelFa })=>{
                    const created = await createType({
                        variables: {
                            code: code,
                            labelFa: labelFa
                        }
                    });
                    return created.data?.createIssueType;
                }
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.priority,
                value: priority,
                onChange: (event)=>setPriority(event.target.value),
                children: Object.entries((0, $8be8610b9776ae98$export$e1e838806c3b27c5)).map(([value, label])=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: value,
                        children: label
                    }, value))
            })
        ]
    });
}






function $c131ddcbc5d2c4f0$export$bf6413248a84a816({ contact: contact }) {
    const [creating, setCreating] = (0, $3OyDL.useState)(false);
    const { data: data, loading: loading, refetch: refetch } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $047171b3f4119885$export$f1d9713146d025f5), {
        variables: {
            page: 1,
            pageSize: 20,
            contactId: contact.id
        },
        errorPolicy: 'ignore'
    });
    const issues = data?.issues?.items ?? [];
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
        className: "flex flex-col gap-3",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                        className: "text-md font-bold",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.title
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "primary",
                        onClick: ()=>setCreating(true),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                                size: 13,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).issues.newIssue
                        ]
                    })
                ]
            }),
            loading && issues.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {}),
            !loading && issues.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$fddf379e22a74b00), {
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.noIssues
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
                className: "flex flex-col gap-2",
                children: issues.map((issue)=>/*#__PURE__*/ (0, $2M70Q.jsxs)("li", {
                        className: "flex items-center gap-2 border-b border-border pb-2 last:border-b-0",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8B9Zg.Link), {
                                to: `/issues/${issue.id}`,
                                className: "flex-1 truncate text-primary",
                                children: issue.title
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                                className: `bg-surface-hover ${(0, $8be8610b9776ae98$export$bd92a918e489f48a)[issue.priority]}`,
                                children: (0, $8be8610b9776ae98$export$e1e838806c3b27c5)[issue.priority]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                                className: `bg-surface-hover ${(0, $8be8610b9776ae98$export$fce5400eb9b3fa56)[issue.status]}`,
                                children: (0, $8be8610b9776ae98$export$3b558bfbd454e1bc)[issue.status]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                className: "text-xs text-text-muted",
                                children: (0, $d4d460d3ffb6daab$export$3ae94a2503e890a1)(issue.reportedAt)
                            })
                        ]
                    }, issue.id))
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4d7077ffa15cf8ad$export$2e00bb6c96d50ef3), {
                open: creating,
                onOpenChange: setCreating,
                contactId: contact.id,
                onCreated: ()=>refetch()
            })
        ]
    });
}


/**
 * A contact's message history, on their profile.
 *
 * The opt-out toggle lives here rather than in the details panel because this
 * is where somebody is thinking about messaging them — and because a consent
 * switch belongs next to the evidence of what has been sent.
 */ 
var $2M70Q = parcelRequire("2M70Q");



var $c7uHF = parcelRequire("c7uHF");

var $3OyDL = parcelRequire("3OyDL");

/**
 * Send a message to one contact, or to a selection of them.
 *
 * ONE DIALOG, TWO SHAPES, because the decisions are the same ones: which
 * channel, which template or what text, and — once a deployment has more than
 * one number — which number it leaves from. A second dialog for "the same
 * thing but to more people" is how the two come to disagree about the
 * suppression rules.
 *
 * WHAT DIFFERS IS WHAT IT WRITES. One contact queues one message. A SELECTION
 * creates a CAMPAIGN, which is ADMIN-only and deliberately so: the blast
 * radius of a mistake is the difference between one awkward message and a
 * banned business number (CLAUDE.md §8e). The campaign is also what makes a
 * bulk send reviewable afterwards — a frozen recipient list, a cancel path
 * while it drains, and counters in the Outbox — none of which a loop of
 * single sends would leave behind.
 *
 * THE PREVIEW IS NOT COSMETIC. It runs the server's own suppression rules —
 * `previewSend` calls the same `decide` a real send calls — and shows the
 * reason the server WOULD give. So somebody about to tick «ارسال با وجود
 * هشدار» can read what they are overriding rather than guess.
 *
 * And what they can override is exactly one thing: a DUPLICATE. Opt-out is
 * never overridable, here or anywhere, which is why the hint says so.
 *
 * TWO CHANNELS, ONE PATH. Both go through the messaging service — queue,
 * suppression chain, preview, Outbox — and differ only where the media do:
 * an SMS has no picture and no WhatsApp number to leave from, and nothing
 * reports its delivery. SMS goes out through Parsina's Kavenegar service
 * (CLAUDE.md §5b), and whether this deployment HAS that route is the server's
 * answer (`smsStatus`), never assumed here. With no route the tab shows the
 * قالب پیامک, says so, and its send button is disabled; with the sandbox it
 * says «آزمایشی». «sandbox» and «sent» must never be confusable — and neither
 * must «ارسال شد» and «راه‌اندازی نشده». A button that quietly did nothing
 * would be the worse failure by far.
 */ 
var $2M70Q = parcelRequire("2M70Q");



var $3OyDL = parcelRequire("3OyDL");


/**
 * The message placeholders, and how to put one into a text box.
 *
 * THE LIST IS A PROMISE, KEPT BY THE SERVER. The CRM refuses to store a
 * template using anything else (`domain/config_rules.py`), and the messaging
 * service substitutes exactly these three (`domain/rendering.py`) — in a
 * template body and in free text alike, per recipient, so «سلام {{fullName}}»
 * sent to forty doctors greets each by their own name. This copy is only the
 * FALLBACK the chips render before the server's `validatePlaceholders` has
 * answered; whether a body is valid is always the server's call, never this
 * file's.
 */ const $6837d294924011ed$export$ac64a8171c5e2d33 = [
    'firstName',
    'lastName',
    'fullName'
];
const $6837d294924011ed$export$53053b021729abbd = (name)=>`{{${name}}}`;
function $6837d294924011ed$export$9b8f467139d3ef05(element, value, text) {
    const start = element?.selectionStart ?? value.length;
    const end = element?.selectionEnd ?? value.length;
    const next = `${value.slice(0, start)}${text}${value.slice(end)}`;
    return {
        value: next,
        caret: start + text.length
    };
}


/**
 * The outbox — every message, with the reason for each one that did not go.
 *
 * THE SUPPRESSION REASON IS THE POINT OF THIS SCREEN. «ارسال نشد» on its own
 * is an accusation; «ارسال نشد — انصراف مخاطب» is a correct decision somebody
 * can read and agree with. So the reason is a column, not a tooltip.
 *
 * The two banners at the top are the other half: whether this deployment is in
 * SANDBOX (nothing is really sent) and how far behind the recipient projection
 * is. A stale projection sends a greeting to somebody who opted out last week,
 * so it is shown rather than discovered.
 */ 
var $2M70Q = parcelRequire("2M70Q");



var $6tkl0 = parcelRequire("6tkl0");
var $jqtUP = parcelRequire("jqtUP");

var $3OyDL = parcelRequire("3OyDL");

var $8B9Zg = parcelRequire("8B9Zg");






const $acda559a4124e8af$export$df38876927d1acfd = {
    QUEUED: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.statusQueued,
    SENT: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.statusSent,
    DELIVERED: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.statusDelivered,
    READ: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.statusRead,
    FAILED: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.statusFailed,
    SUPPRESSED: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.statusSuppressed
};
const $acda559a4124e8af$export$54acd9ca24ae2a90 = {
    OPT_OUT: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.reasonOptOut,
    NO_CHANNEL: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.reasonNoChannel,
    DUPLICATE: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.reasonDuplicate,
    CAMPAIGN_CANCELLED: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.reasonCampaignCancelled,
    QUIET_HOURS: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.reasonQuietHours,
    RATE_LIMIT: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.reasonRateLimit
};
function $acda559a4124e8af$export$823148a3db117854(reason, channel) {
    if (reason === 'NO_CHANNEL' && channel === 'SMS') return (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.reasonNoMobile;
    return $acda559a4124e8af$export$54acd9ca24ae2a90[reason] ?? reason;
}
const $acda559a4124e8af$var$STATUS_CLASS = {
    QUEUED: 'text-text-muted',
    SENT: 'text-info',
    DELIVERED: 'text-info',
    READ: 'text-success',
    FAILED: 'text-danger',
    SUPPRESSED: 'text-warning'
};
const $acda559a4124e8af$var$FILTERS = [
    null,
    'QUEUED',
    'SENT',
    'DELIVERED',
    'READ',
    'FAILED',
    'SUPPRESSED'
];
function $acda559a4124e8af$export$a8c88d5b67476873({ status: status, projection: projection, onReplayed: onReplayed }) {
    const { isAdmin: isAdmin } = (0, $00d5d84dffcdf8d5$export$ad0a340bf97d63d5)();
    const [replay, replayState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$6e5785418e8671b9), {
        onCompleted: ()=>onReplayed?.()
    });
    if (!status) return null;
    const sandbox = status.provider !== 'hypermeow';
    const lag = (projection?.sources ?? []).find((s)=>s.source === 'crm');
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex flex-wrap items-center gap-4 border-b border-border px-6 py-2 text-sm",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                className: `flex items-center gap-2 font-medium ${sandbox ? 'text-warning' : 'text-success'}`,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6tkl0.default), {
                        size: 14,
                        "aria-hidden": "true"
                    }),
                    sandbox ? (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.sandboxBanner : (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.liveBanner
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                className: "text-text-muted",
                children: [
                    (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.projectionRecipients.replace('{n}', (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(projection?.recipientCount ?? 0)),
                    lag?.lastAppliedAt ? ` \xb7 ${(0, $d4d460d3ffb6daab$export$8b492ed8828f789c)(lag.lastAppliedAt)}` : ''
                ]
            }),
            isAdmin && /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                type: "button",
                className: "ms-auto text-primary disabled:opacity-60",
                disabled: replayState.loading,
                onClick: ()=>replay().catch(()=>{}),
                children: replayState.loading ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.loading : (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.replayProjections
            }),
            replayState.data != null && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                role: "status",
                className: "text-success",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.replayDone.replace('{n}', (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(replayState.data.replayProjections))
            }),
            replayState.error && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                role: "status",
                className: "text-danger",
                children: replayState.error.message
            })
        ]
    });
}
function $acda559a4124e8af$export$2f71c932e14ae53c() {
    const [status, setStatus] = (0, $3OyDL.useState)(null);
    const [page, setPage] = (0, $3OyDL.useState)(1);
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $047171b3f4119885$export$5378220b4be5edb8), {
        variables: {
            page: page,
            pageSize: (0, $370d2fd34ead4cb4$export$8ec3d08588d2eeda),
            statuses: status ? [
                status
            ] : null
        }
    });
    const { data: providerData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $047171b3f4119885$export$562f31d2c926639d), {
        errorPolicy: 'ignore'
    });
    const [retry, retryState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$9e01144bce1e85f6), {
        onCompleted: ()=>refetch()
    });
    const messages = data?.messages?.items ?? [];
    const totalCount = data?.messages?.totalCount ?? 0;
    const pageCount = Math.max(1, Math.ceil(totalCount / (0, $370d2fd34ead4cb4$export$8ec3d08588d2eeda)));
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex h-screen flex-col",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("header", {
                className: "flex h-toolbar shrink-0 items-center gap-4 border-b border-border bg-surface px-6",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h1", {
                        className: "text-lg font-bold",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.outbox
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-sm text-text-muted",
                        children: (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(totalCount)
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8B9Zg.Link), {
                        to: "/messaging/campaigns",
                        className: "ms-auto text-sm text-primary",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.campaigns
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)($acda559a4124e8af$export$a8c88d5b67476873, {
                status: providerData?.whatsappStatus,
                projection: providerData?.projectionStatus
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: "flex shrink-0 flex-wrap items-center gap-2 border-b border-border bg-surface px-6 py-2",
                children: $acda559a4124e8af$var$FILTERS.map((value)=>/*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            setStatus(value);
                            setPage(1);
                        },
                        "aria-pressed": status === value,
                        className: `rounded-full border px-3 py-1 text-sm ${status === value ? 'border-primary bg-primary text-primary-contrast' : 'border-border bg-surface text-text-muted hover:bg-surface-hover'}`,
                        children: value ? $acda559a4124e8af$export$df38876927d1acfd[value] : (0, $d916753b57975e04$export$25ce5a424b770e84).app.all
                    }, value ?? 'all'))
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "min-h-0 flex-1 overflow-auto p-6",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                        error: error ?? retryState.error
                    }),
                    loading && messages.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                        className: "flex justify-center p-7",
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {})
                    }),
                    !loading && messages.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$fddf379e22a74b00), {
                        title: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.noMessages
                    }),
                    messages.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$54ec01a60f47d33d), {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$c4c2bc57f2e82919), {
                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.recipient
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.body
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.status
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.sentAt
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7005b8a93a167348), {
                                children: messages.map((message)=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                className: "font-medium",
                                                children: message.contact ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8B9Zg.Link), {
                                                    to: `/contacts/${message.contact.id}`,
                                                    className: "text-primary",
                                                    children: message.contact.displayName
                                                }) : /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                    dir: "ltr",
                                                    children: message.phoneE164
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                className: "max-w-0 truncate text-text-muted",
                                                title: message.renderedBody,
                                                children: message.renderedBody
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                children: [
                                                    message.channel === 'SMS' && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                                                        className: "me-2 bg-surface-hover text-text-muted",
                                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.smsBadge
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                        className: $acda559a4124e8af$var$STATUS_CLASS[message.status],
                                                        children: $acda559a4124e8af$export$df38876927d1acfd[message.status]
                                                    }),
                                                    message.suppressionReason && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                                                        className: "ms-2 bg-surface-hover text-warning",
                                                        children: $acda559a4124e8af$export$823148a3db117854(message.suppressionReason, message.channel)
                                                    }),
                                                    message.error && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                        className: "ms-2 text-xs text-danger",
                                                        title: message.error,
                                                        children: "\u26A0"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                className: "text-text-muted",
                                                children: message.sentAt ? (0, $d4d460d3ffb6daab$export$8b492ed8828f789c)(message.sentAt) : (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                children: message.status === 'FAILED' && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                                    variant: "ghost",
                                                    onClick: ()=>retry({
                                                            variables: {
                                                                id: message.id
                                                            }
                                                        }),
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $jqtUP.default), {
                                                            size: 13,
                                                            "aria-hidden": "true"
                                                        }),
                                                        (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.retry
                                                    ]
                                                })
                                            })
                                        ]
                                    }, message.id))
                            })
                        ]
                    })
                ]
            }),
            pageCount > 1 && /*#__PURE__*/ (0, $2M70Q.jsxs)("footer", {
                className: "flex h-control shrink-0 items-center justify-center gap-4 border-t border-border bg-surface text-sm",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                        type: "button",
                        disabled: page <= 1,
                        onClick: ()=>setPage((p)=>p - 1),
                        className: "text-primary disabled:text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.previous
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.pageOf((0, $d4d460d3ffb6daab$export$104ee80c24270f18)(page), (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(pageCount))
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                        type: "button",
                        disabled: page >= pageCount,
                        onClick: ()=>setPage((p)=>p + 1),
                        className: "text-primary disabled:text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.next
                    })
                ]
            })
        ]
    });
}





/**
 * A picture or a video to send over WhatsApp.
 *
 * It uploads the moment a file is chosen, through the same three-step
 * presigned flow every other attachment uses (initiate → PUT straight to
 * storage → complete), so the bytes never pass through the BFF and the
 * progress bar is real. What it hands its parent is the ATTACHMENT, and the
 * parent sends only its id: the storage key is the CRM's internal naming.
 *
 * THE ACCEPTED TYPES ARE EXACTLY WHAT WHATSAPP RENDERS INLINE — JPEG and PNG
 * become an image, MP4 and 3GPP a playable video. Checked here as well as on
 * the server, and the reason is timing: a HEIC photo from an iPhone refused by
 * the server after a 12 MB upload is the same answer delivered a minute later.
 * The server's check is the one that counts; this one is manners.
 */ 
var $2M70Q = parcelRequire("2M70Q");

/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $d9a3d1004079b21e$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            key: "afitv7"
        }
    ],
    [
        "path",
        {
            d: "M7 3v18",
            key: "bbkbws"
        }
    ],
    [
        "path",
        {
            d: "M3 7.5h4",
            key: "zfgn84"
        }
    ],
    [
        "path",
        {
            d: "M3 12h18",
            key: "1i2n21"
        }
    ],
    [
        "path",
        {
            d: "M3 16.5h4",
            key: "1230mu"
        }
    ],
    [
        "path",
        {
            d: "M17 3v18",
            key: "in4fa5"
        }
    ],
    [
        "path",
        {
            d: "M17 7.5h4",
            key: "myr1c1"
        }
    ],
    [
        "path",
        {
            d: "M17 16.5h4",
            key: "go4c1d"
        }
    ]
];
const $d9a3d1004079b21e$export$2e2bcd8739ae039 = (0, $djixo.default)("film", $d9a3d1004079b21e$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $4e72c7e114cd1a08$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 5h6",
            key: "1vod17"
        }
    ],
    [
        "path",
        {
            d: "M19 2v6",
            key: "4bpg5p"
        }
    ],
    [
        "path",
        {
            d: "M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5",
            key: "1ue2ih"
        }
    ],
    [
        "path",
        {
            d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21",
            key: "1xmnt7"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "9",
            r: "2",
            key: "af1f0g"
        }
    ]
];
const $4e72c7e114cd1a08$export$2e2bcd8739ae039 = (0, $djixo.default)("image-plus", $4e72c7e114cd1a08$export$3efd853dbb351e94);


var $bi4P4 = parcelRequire("bi4P4");

var $3OyDL = parcelRequire("3OyDL");



const $86e0eaff0a61b7cc$export$aa9233018fda55b1 = [
    'image/jpeg',
    'image/png',
    'video/mp4',
    'video/3gpp'
];
const $86e0eaff0a61b7cc$export$9d36fecbf961a560 = 15728640;
function $86e0eaff0a61b7cc$export$3c3dcc0b41d7c7e9({ value: value, onChange: onChange, onBusyChange: onBusyChange, disabled: disabled }) {
    const inputRef = (0, $3OyDL.useRef)(null);
    const [progress, setProgress] = (0, $3OyDL.useState)(null);
    const [error, setError] = (0, $3OyDL.useState)(null);
    const [preview, setPreview] = (0, $3OyDL.useState)(null); // { url, isVideo, name }
    const abortRef = (0, $3OyDL.useRef)(null);
    // An object URL is a reference the browser holds until told to let go.
    (0, $3OyDL.useEffect)(()=>()=>preview && URL.revokeObjectURL(preview.url), [
        preview
    ]);
    // Leaving mid-upload must stop the PUT, not let it finish into a reservation
    // nobody will ever complete.
    (0, $3OyDL.useEffect)(()=>()=>abortRef.current?.abort(), []);
    async function pick(event) {
        // MATERIALISE THE FILE BEFORE RESETTING THE INPUT. A live FileList is
        // emptied by `value = ''`, and a state updater runs too late to have read
        // it — which is exactly how the interaction composer's picker lost every
        // file chosen with the button for two steps (CLAUDE.md §15).
        const file = event.target.files?.[0] ?? null;
        event.target.value = '';
        if (!file) return;
        setError(null);
        if (!$86e0eaff0a61b7cc$export$aa9233018fda55b1.includes(file.type)) {
            setError((0, $d916753b57975e04$export$25ce5a424b770e84).messaging.mediaWrongType);
            return;
        }
        if (file.size > $86e0eaff0a61b7cc$export$9d36fecbf961a560) {
            setError((0, $d916753b57975e04$export$25ce5a424b770e84).messaging.mediaTooLarge.replace('{mb}', (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(Math.round($86e0eaff0a61b7cc$export$9d36fecbf961a560 / 1048576))));
            return;
        }
        const next = {
            url: URL.createObjectURL(file),
            isVideo: file.type.startsWith('video/'),
            name: file.name
        };
        setPreview(next);
        setProgress(0);
        const controller = new AbortController();
        abortRef.current = controller;
        try {
            const attachment = await (0, $d305624b55b31f43$export$a5575dbeeffdad98)({
                file: file,
                ownerType: 'MESSAGE_MEDIA',
                // Owned by nothing that exists yet: the message it travels with is
                // queued AFTER this upload, and a bulk send has no single contact to
                // hang it on. A fresh id per file, which the CRM does not check.
                ownerId: crypto.randomUUID(),
                onProgress: (fraction)=>setProgress(fraction),
                signal: controller.signal
            });
            onChange(attachment);
        } catch (err) {
            if (controller.signal.aborted) return;
            setError(err.message || (0, $d916753b57975e04$export$25ce5a424b770e84).app.unknownError);
            setPreview(null);
            onChange(null);
        } finally{
            setProgress(null);
            abortRef.current = null;
        }
    }
    function clear() {
        abortRef.current?.abort();
        setPreview(null);
        setError(null);
        setProgress(null);
        onChange(null);
    }
    const uploading = progress !== null;
    // THE PARENT MUST KNOW, because the alternative is a caption sent WITHOUT
    // its picture: attach a video, type a line, press send before the upload
    // finishes — and the form, seeing text and no media yet, would happily send
    // just the text. That is the failure that looks exactly like success.
    (0, $3OyDL.useEffect)(()=>{
        onBusyChange?.(uploading);
    }, [
        uploading,
        onBusyChange
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                ref: inputRef,
                type: "file",
                accept: $86e0eaff0a61b7cc$export$aa9233018fda55b1.join(','),
                className: "hidden",
                onChange: pick,
                "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.mediaAdd
            }),
            !preview && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                variant: "ghost",
                disabled: disabled,
                onClick: ()=>inputRef.current?.click(),
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4e72c7e114cd1a08$export$2e2bcd8739ae039), {
                        size: 14,
                        "aria-hidden": "true"
                    }),
                    (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.mediaAdd
                ]
            }),
            preview && /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex items-start gap-3 rounded border border-border bg-surface-hover p-2",
                children: [
                    preview.isVideo ? // Muted and without autoplay: this is a check of WHAT was
                    // attached, not a playback surface.
                    /*#__PURE__*/ (0, $2M70Q.jsx)("video", {
                        src: preview.url,
                        className: "h-mediapreview w-auto rounded",
                        controls: true,
                        muted: true,
                        "aria-label": preview.name
                    }) : /*#__PURE__*/ (0, $2M70Q.jsx)("img", {
                        src: preview.url,
                        alt: preview.name,
                        className: "h-mediapreview w-auto rounded object-contain"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "flex min-w-0 flex-1 flex-col gap-1 text-xs",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                className: "flex items-center gap-1 truncate text-text-muted",
                                children: [
                                    preview.isVideo && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d9a3d1004079b21e$export$2e2bcd8739ae039), {
                                        size: 12,
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                        dir: "ltr",
                                        className: "truncate",
                                        children: preview.name
                                    })
                                ]
                            }),
                            uploading ? /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                role: "status",
                                className: "text-text-muted",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.mediaUploading.replace('{pct}', (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(Math.round(progress * 100)))
                            }) : value && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                className: "text-success",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.mediaReady
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                className: "text-text-muted",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.mediaCaptionHint
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "ghost",
                        onClick: clear,
                        "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.mediaRemove,
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $bi4P4.default), {
                            size: 14,
                            "aria-hidden": "true"
                        })
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                role: "alert",
                className: "text-sm text-danger",
                children: error
            })
        ]
    });
}


/**
 * The transports MeshHub itself has, keyed by COMMUNICATION_CHANNEL code.
 *
 * A code and not a label, so a deployment renaming «واتساپ» changes nothing
 * here — the same contract `ChannelIcons` already keeps. Whether a channel is
 * SENDABLE is decided per render from the server: WhatsApp always is (its
 * sandbox is labelled elsewhere), SMS only when `smsStatus` says a route
 * exists.
 */ const $d044b66b3f88fefb$var$CHANNELS = [
    {
        code: 'WHATSAPP',
        label: ()=>(0, $d916753b57975e04$export$25ce5a424b770e84).messaging.whatsapp,
        templateLabel: ()=>(0, $d916753b57975e04$export$25ce5a424b770e84).messaging.whatsappTemplate
    },
    {
        code: 'SMS',
        label: ()=>(0, $d916753b57975e04$export$25ce5a424b770e84).messaging.sms,
        templateLabel: ()=>(0, $d916753b57975e04$export$25ce5a424b770e84).messaging.smsTemplate
    }
];
function $d044b66b3f88fefb$export$59cc7642dbe0bf15({ open: open, onOpenChange: onOpenChange, contact: contact, onSent: onSent, selector: /** Many-recipient mode: a BulkSelector ({ contactIds } | { filter }). */ selector, recipientCount: /** How many that selector matches, for the title and the confirmation. */ recipientCount, sampleContact: /**
   * A contact to preview AGAINST in many-recipient mode. The rendered body is
   * per person — «{{firstName}} عزیز» is a different string for each — so the
   * preview shows one real example and says so, rather than a rendering that
   * belongs to nobody.
   */ sampleContact }) {
    const many = Boolean(selector);
    const previewContact = many ? sampleContact : contact;
    const [channelCode, setChannelCode] = (0, $3OyDL.useState)($d044b66b3f88fefb$var$CHANNELS[0].code);
    const [templateId, setTemplateId] = (0, $3OyDL.useState)('');
    const [freeBody, setFreeBody] = (0, $3OyDL.useState)('');
    const [force, setForce] = (0, $3OyDL.useState)(false);
    // Which number to send from. '' means the deployment's default, resolved by
    // the server — never computed here, because a second implementation of the
    // resolution order is how a preview and a send come to disagree.
    const [accountId, setAccountId] = (0, $3OyDL.useState)('');
    // The campaign's name, which is what the Outbox lists it under. Prefilled so
    // the common case is one click, editable because a list of «ارسال گروهی»
    // rows is not something anybody can read back later.
    const [campaignName, setCampaignName] = (0, $3OyDL.useState)('');
    // A picture or a video, as the ATTACHMENT it was uploaded as. Only its id
    // leaves this component; the BFF turns it into something the messaging
    // service can fetch at send time.
    const [media, setMedia] = (0, $3OyDL.useState)(null);
    const [mediaBusy, setMediaBusy] = (0, $3OyDL.useState)(false);
    // SKIPPED WHILE CLOSED, like the accounts below. Failing it leaves SMS
    // unsendable — the safe reading of «we could not ask».
    const { data: smsData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $047171b3f4119885$export$14ef471adc6a5e99), {
        skip: !open,
        fetchPolicy: 'cache-and-network'
    });
    const sms = smsData?.smsStatus;
    const found = $d044b66b3f88fefb$var$CHANNELS.find((c)=>c.code === channelCode) ?? $d044b66b3f88fefb$var$CHANNELS[0];
    const isWhatsapp = found.code === 'WHATSAPP';
    const channel = {
        ...found,
        sendable: isWhatsapp || Boolean(sms?.configured)
    };
    const { data: templateData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$53468eed769bf661), {
        variables: {
            includeInactive: false
        },
        errorPolicy: 'ignore'
    });
    // The body the PREVIEW asks about, one debounce behind the box. Typing is
    // the only input here that changes on every keystroke; a template is a click.
    const [settledBody, setSettledBody] = (0, $3OyDL.useState)('');
    (0, $3OyDL.useEffect)(()=>{
        const timer = setTimeout(()=>setSettledBody(freeBody), (0, $370d2fd34ead4cb4$export$ddf7aeb94920d3f5));
        return ()=>clearTimeout(timer);
    }, [
        freeBody
    ]);
    const previewBody = templateId ? null : settledBody.trim() || null;
    // PLACEHOLDERS IN FREE TEXT. «سلام {{fullName}}» is rendered per recipient
    // by the server — the same `render` a template goes through — which is what
    // makes a batch send greet forty doctors by forty names. The chips insert a
    // token at the CARET (typing braces into an RTL box is where people give
    // up), and whether what was typed is a known placeholder is the SERVER's
    // answer: the renderer blanks an unknown one rather than leaking braces to
    // a doctor, so «{{fullname}}» would go out as «سلام » with nothing on this
    // screen saying why. Asked only once a brace is typed; a body without one
    // has nothing to validate.
    const bodyRef = (0, $3OyDL.useRef)(null);
    const { data: placeholderData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$6b3f4b0350c29d0e), {
        variables: {
            body: settledBody
        },
        skip: !open || Boolean(templateId) || !settledBody.includes('{{'),
        errorPolicy: 'ignore'
    });
    const placeholderCheck = placeholderData?.validatePlaceholders ?? null;
    const allowedPlaceholders = placeholderCheck?.allowed ?? (0, $6837d294924011ed$export$ac64a8171c5e2d33);
    const insertPlaceholder = (name)=>{
        const element = bodyRef.current;
        const { value: value, caret: caret } = (0, $6837d294924011ed$export$9b8f467139d3ef05)(element, freeBody, (0, $6837d294924011ed$export$53053b021729abbd)(name));
        setFreeBody(value);
        // The controlled box shows the new value on the NEXT render; the caret is
        // placed after that, or the browser leaves it at the end.
        if (element) requestAnimationFrame(()=>{
            element.focus();
            element.setSelectionRange(caret, caret);
        });
    };
    // The LABELS, so the preview can say «شمارهٔ فروش» rather than an opaque id.
    // Failing this query must not break the dialog — a send with no label is
    // still a send — so its absence degrades to showing the id.
    const { data: accountsData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $047171b3f4119885$export$f08c69326971bdb2), {
        skip: !open,
        fetchPolicy: 'cache-first'
    });
    const accounts = accountsData?.whatsappAccounts ?? [];
    const { data: previewData, previousData: previousData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $047171b3f4119885$export$5fb40de85b536fc0), {
        variables: {
            contactId: previewContact?.id,
            templateId: templateId || null,
            freeBody: previewBody,
            force: force,
            accountId: isWhatsapp ? accountId || null : null,
            // The server reads the number FOR THIS CHANNEL, so an SMS preview names
            // the mobile the text would really go to.
            channel: channel.code
        },
        // Only a sendable channel has a preview to ask for: with no SMS route the
        // server would refuse the question, not answer it.
        skip: !open || !previewContact?.id || !channel.sendable,
        fetchPolicy: 'network-only'
    });
    const [send, sendState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$a55094a4f4e56a9e));
    const [createCampaign, campaignState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$5406bbed7d677353));
    // A CAMPAIGN IS CREATED AS A DRAFT, and the worker only runs campaigns that
    // are SCHEDULED with a due timestamp — so creating one and stopping leaves
    // it sitting there forever under a button that said «ارسال». Scheduling it
    // with no time means «now»: the messaging service stamps a past timestamp
    // and the next dispatch pass picks it up, which keeps ONE run path rather
    // than a second send-now that bypasses the runner.
    const [scheduleCampaign, scheduleState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$431dc0c2ff5a4e9a));
    const { loading: loading, error: error } = many ? {
        loading: campaignState.loading || scheduleState.loading,
        error: campaignState.error ?? scheduleState.error
    } : sendState;
    // A default name the moment the dialog opens, so «ارسال» is one click.
    //
    // ONCE PER OPENING, not whenever the field is empty. Keying it on
    // `!campaignName` re-filled the box the instant somebody cleared it, so the
    // name could not be changed at all — typing appended to the default instead
    // of replacing it. A ref, because "has this opening been prefilled" is not
    // something the render needs to know.
    const prefilled = (0, $3OyDL.useRef)(false);
    (0, $3OyDL.useEffect)(()=>{
        if (!open) {
            prefilled.current = false;
            return;
        }
        if (many && !prefilled.current) {
            prefilled.current = true;
            setCampaignName((0, $d916753b57975e04$export$25ce5a424b770e84).messaging.bulkDefaultName.replace('{n}', (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(recipientCount ?? 0)).replace('{date}', (0, $d4d460d3ffb6daab$export$3ae94a2503e890a1)(new Date().toISOString())));
        }
    }, [
        open,
        many,
        recipientCount
    ]);
    // Templates are filtered by their own channel, so «قالب پیامک» and «قالب
    // پیام واتساپ» are the same list read two ways rather than two lists.
    const templates = (templateData?.messageTemplates ?? []).filter((template)=>template.channel?.code === channel.code);
    const chosen = templates.find((template)=>template.id === templateId);
    // HOLD THE LAST PREVIEW WHILE THE NEXT ONE LOADS. `network-only` blanks
    // `data` for the duration of every refetch, so reading it directly made the
    // whole panel unmount and remount on each keystroke — reported from the
    // running deployment as the preview opening and closing while typing.
    // `previousData` is what keeps the panel on screen and merely stale, which
    // is what a preview should be between renders.
    // Queried even with nothing drafted, deliberately: OPT_OUT, NO_CHANNEL and
    // CONTACT_DELETED are facts about the CONTACT, and knowing not to bother
    // composing is worth more before the message is written than after.
    const preview = previewData?.previewSend ?? previousData?.previewSend;
    // Only the accounts that can actually take a send. A deactivated number is
    // not offered, matching what the server would resolve.
    const sendableAccounts = accounts.filter((a)=>a.isActive);
    function pickChannel(code) {
        setChannelCode(code);
        // A template belongs to one channel, so the previous choice cannot survive
        // the switch — clearing it beats leaving a selection that is not in the
        // list any more.
        setTemplateId('');
        setFreeBody('');
        setForce(false);
        // A picture cannot ride along into a text, and an SMS leaves from no
        // WhatsApp number.
        if (code !== 'WHATSAPP') {
            setMedia(null);
            setAccountId('');
        }
    }
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: open,
        onOpenChange: onOpenChange,
        title: many ? (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.sendToMany.replace('{n}', (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(recipientCount ?? 0)) : (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.sendTo.replace('{name}', contact?.displayName ?? ''),
        submitLabel: many ? (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.sendToManyAction : isWhatsapp ? (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.sendViaWhatsapp : (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.sendSms,
        busy: loading,
        error: error,
        canSubmit: // A picture or a video alone is a complete message; its text is only
        // a caption. What is refused is a send with nothing in it — and a
        // send while the file is still uploading, which would otherwise go
        // out as the caption alone.
        Boolean(templateId || freeBody.trim() || media) && !mediaBusy && channel.sendable && (!many || Boolean(campaignName.trim())),
        onSubmit: async ()=>{
            // A template WINS over free text when both are present, matching the
            // server: `sendMessage` renders the template and ignores freeBody.
            // Sending both and letting the server pick would make the preview the
            // user just read a guess about which one it chose.
            const body = templateId ? null : freeBody.trim() || null;
            if (many) {
                // A CAMPAIGN, not a loop of sends. The recipient list is frozen
                // server-side at creation, the whole thing is cancellable while it
                // drains, and the Outbox can account for it afterwards — none of
                // which N separate mutations would leave behind.
                //
                // `selector` is {contactIds} or {filter}, and the filter form is
                // what «انتخاب همهٔ N مورد منطبق» produces: the client never held
                // those ids, so it sends the question and the BFF resolves it once.
                const created = await createCampaign({
                    variables: {
                        name: campaignName.trim(),
                        templateId: templateId || null,
                        freeBody: body,
                        contactIds: selector.contactIds ?? null,
                        filter: selector.filter ?? null,
                        accountId: isWhatsapp ? accountId || null : null,
                        media: isWhatsapp && media ? {
                            attachmentId: media.id
                        } : null,
                        channel: channel.code
                    }
                });
                // TWO CALLS, and the window between them is real: if this second one
                // fails the campaign exists as a DRAFT and nothing has been sent.
                // That is a safe, visible, recoverable state — it is listed on the
                // campaigns screen with its own «start» control — so the error is
                // surfaced rather than compensated by deleting somebody's audit
                // trail. Same reasoning as the follow-up saga (CLAUDE.md §8b).
                const id = created?.data?.createCampaign?.id;
                if (id) await scheduleCampaign({
                    variables: {
                        id: id,
                        scheduledAt: null
                    }
                });
            } else await send({
                variables: {
                    contactId: contact.id,
                    templateId: templateId || null,
                    freeBody: body,
                    force: force,
                    accountId: isWhatsapp ? accountId || null : null,
                    media: isWhatsapp && media ? {
                        attachmentId: media.id
                    } : null,
                    channel: channel.code
                }
            });
            setTemplateId('');
            setFreeBody('');
            setForce(false);
            setAccountId('');
            setCampaignName('');
            setMedia(null);
            onOpenChange(false);
            onSent?.();
        },
        children: [
            many && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.campaignName,
                hint: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.bulkNameHint,
                value: campaignName,
                onChange: (event)=>setCampaignName(event.target.value)
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.channel,
                value: channelCode,
                onChange: (event)=>pickChannel(event.target.value),
                children: $d044b66b3f88fefb$var$CHANNELS.map((option)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: option.code,
                        children: option.label()
                    }, option.code))
            }),
            isWhatsapp && sendableAccounts.length > 1 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.sendsFrom,
                hint: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.defaultHint,
                value: accountId,
                onChange: (event)=>setAccountId(event.target.value),
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: "",
                        children: sendableAccounts.find((a)=>a.isDefault)?.label ?? (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.isDefault
                    }),
                    sendableAccounts.map((account)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                            value: account.accountId,
                            children: account.label
                        }, account.id))
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: channel.templateLabel(),
                value: templateId,
                onChange: (event)=>setTemplateId(event.target.value),
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: "",
                        children: templates.length === 0 ? (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.noTemplateForChannel : (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    templates.map((template)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                            value: template.id,
                            children: template.name
                        }, template.id))
                ]
            }),
            channel.sendable && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$f5c9f3c2c4054eec), {
                ref: bodyRef,
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.freeBody,
                hint: templateId ? (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.freeBodyIgnored : (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.freeBodyHint,
                value: freeBody,
                disabled: Boolean(templateId),
                onChange: (event)=>setFreeBody(event.target.value)
            }),
            channel.sendable && !templateId && /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                className: "text-xs text-text-muted",
                                children: [
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.placeholders,
                                    ":"
                                ]
                            }),
                            allowedPlaceholders.map((name)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                    type: "button",
                                    variant: "ghost",
                                    className: "text-xs",
                                    onClick: ()=>insertPlaceholder(name),
                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                        dir: "ltr",
                                        children: (0, $6837d294924011ed$export$53053b021729abbd)(name)
                                    })
                                }, name))
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                        className: "text-xs text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.placeholderHint
                    }),
                    placeholderCheck && !placeholderCheck.valid && /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
                        className: "flex flex-col gap-1",
                        role: "alert",
                        children: placeholderCheck.errors.map((error)=>/*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                                className: "text-xs text-danger",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.placeholderUnknown.replace('{token}', (0, $6837d294924011ed$export$53053b021729abbd)(error.placeholder)).replace('{allowed}', allowedPlaceholders.map((0, $6837d294924011ed$export$53053b021729abbd)).join("\u060C "))
                            }, `${error.placeholder}-${error.position}`))
                    })
                ]
            }),
            isWhatsapp && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $86e0eaff0a61b7cc$export$3c3dcc0b41d7c7e9), {
                value: media,
                onChange: setMedia,
                onBusyChange: setMediaBusy,
                disabled: loading
            }),
            channel.sendable && preview && /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex flex-col gap-2 rounded border border-border bg-surface-hover p-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                        className: "text-sm font-medium",
                        children: many ? (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.previewSample.replace('{name}', previewContact?.displayName ?? '') : (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.preview
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                        className: "whitespace-pre-wrap text-sm",
                        children: preview.renderedBody || /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                            className: "text-text-muted",
                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.previewEmpty
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                        dir: "ltr",
                        className: "text-start text-xs text-text-muted",
                        children: preview.phoneE164 || (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    isWhatsapp && accounts.length > 1 && !accountId && preview.accountId && /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                        className: "text-xs text-text-muted",
                        children: [
                            (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.sendsFrom,
                            ": ",
                            $d044b66b3f88fefb$var$accountLabel(accounts, preview.accountId)
                        ]
                    }),
                    !preview.wouldSend && /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                        className: "flex items-center gap-2 text-sm text-warning",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                                className: "bg-surface text-warning",
                                children: (0, $acda559a4124e8af$export$823148a3db117854)(preview.reason, channel.code)
                            }),
                            many ? (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.previewSampleSuppressed : preview.detail
                        ]
                    })
                ]
            }),
            !isWhatsapp && channel.sendable && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                role: "status",
                className: sms?.provider === 'fake' ? 'rounded border border-warning px-4 py-2 text-sm text-warning' : 'text-xs text-text-muted',
                children: sms?.provider === 'fake' ? (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.smsSandbox : (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.smsLive
            }),
            !channel.sendable && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                children: [
                    chosen && /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "flex flex-col gap-2 rounded border border-border bg-surface-hover p-3",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                className: "text-sm font-medium",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.smsTemplate
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                className: "whitespace-pre-wrap text-sm",
                                children: chosen.body
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                        role: "status",
                        className: "rounded border border-warning px-4 py-2 text-sm text-warning",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.smsNotConfigured
                    })
                ]
            }),
            channel.sendable && preview && !preview.wouldSend && preview.reason === 'DUPLICATE' && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$94195a47b94ed396), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.force,
                checked: force,
                onChange: (event)=>setForce(event.target.checked)
            }),
            channel.sendable && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-xs text-text-muted",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.forceHint
            })
        ]
    });
}
/** The label for an account id, falling back to the id itself.

 *  The fallback matters: an account the list does not carry (a rule pointing
 *  at one since deactivated) must still name something, and an id is a worse
 *  answer than a label but a much better one than a blank. */ function $d044b66b3f88fefb$var$accountLabel(accounts, accountId) {
    return accounts.find((a)=>a.accountId === accountId)?.label ?? accountId;
}






function $8d5e83f479aff161$export$2b90e891e9f3a5cd({ contact: contact, onChanged: onChanged }) {
    const [sending, setSending] = (0, $3OyDL.useState)(false);
    const [confirmOptOut, setConfirmOptOut] = (0, $3OyDL.useState)(false);
    const { data: data, loading: loading, refetch: refetch } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $047171b3f4119885$export$5378220b4be5edb8), {
        variables: {
            page: 1,
            pageSize: 20,
            contactId: contact.id
        },
        errorPolicy: 'ignore'
    });
    const [setOptOut, optOutState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$81043027b6e6a14b), {
        onCompleted: ()=>onChanged?.()
    });
    const messages = data?.messages?.items ?? [];
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
        className: "flex flex-col gap-3",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                        className: "text-md font-bold",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.title
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "primary",
                        onClick: ()=>setSending(true),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c7uHF.default), {
                                size: 13,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.send
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("label", {
                        className: "ms-auto flex items-center gap-2 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                                type: "checkbox",
                                className: "accent-primary",
                                checked: contact.messagingOptOut,
                                onChange: ()=>setConfirmOptOut(true)
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).search.optedOut
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: optOutState.error
            }),
            loading && messages.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {}),
            !loading && messages.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$fddf379e22a74b00), {
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.noMessages
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
                className: "flex flex-col gap-2",
                children: messages.map((message)=>/*#__PURE__*/ (0, $2M70Q.jsxs)("li", {
                        className: "border-b border-border pb-2 last:border-b-0",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                                className: "flex flex-wrap items-center gap-2 text-xs text-text-muted",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                        children: (0, $acda559a4124e8af$export$df38876927d1acfd)[message.status]
                                    }),
                                    message.suppressionReason && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                                        className: "bg-surface-hover text-warning",
                                        children: (0, $acda559a4124e8af$export$54acd9ca24ae2a90)[message.suppressionReason]
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                        children: message.sentAt ? (0, $d4d460d3ffb6daab$export$8b492ed8828f789c)(message.sentAt) : (0, $d4d460d3ffb6daab$export$8b492ed8828f789c)(message.createdAt)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                className: "whitespace-pre-wrap text-sm",
                                children: message.renderedBody
                            })
                        ]
                    }, message.id))
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d044b66b3f88fefb$export$59cc7642dbe0bf15), {
                open: sending,
                onOpenChange: setSending,
                contact: contact,
                onSent: ()=>refetch()
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2cc85109a937009e), {
                open: confirmOptOut,
                onOpenChange: setConfirmOptOut,
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).search.optedOut,
                body: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.forceHint,
                confirmLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).app.confirm,
                onConfirm: async ()=>{
                    await setOptOut({
                        variables: {
                            contactId: contact.id,
                            optedOut: !contact.messagingOptOut
                        }
                    });
                    setConfirmOptOut(false);
                }
            })
        ]
    });
}


/**
 * Plan a follow-up for an interaction — the client half of Step 3's deferral.
 *
 * Step 3's «یادداشت پیگیری» rode in the interaction's description tail, labelled
 * as a placeholder, because there was nowhere else to put it: the real
 * follow-up is an activity with a date, a reminder and a calendar, and that
 * object did not exist yet. It does now, and this is what creates it.
 *
 * It goes through `createFollowUpFromInteraction` rather than a plain
 * `createActivity`, because two things must happen together: the activity is
 * created in the scheduling service AND the interaction in the CRM is pointed
 * at it. That is a saga, not a transaction — the BFF compensates by cancelling
 * the activity when the link fails, and says so when even that fails.
 */ 
var $2M70Q = parcelRequire("2M70Q");


var $3OyDL = parcelRequire("3OyDL");




/**
 * The follow-up inbox (`/followups`).
 *
 * The scheduling service stores structured facts — an activity, a reason, a
 * date — and nothing else, because it is not allowed to know a contact's name.
 * The Persian sentence a person reads is composed HERE, where the name arrives
 * through the BFF's join. That is not an accident of layering: storing the
 * rendered sentence would freeze the wording at the moment the watchdog ran, so
 * a later rename would leave the inbox quoting a name that no longer exists.
 *
 * Accepting opens the activity dialog PREFILLED — same contact, follow-up type,
 * next working day — because the whole point of a prompt is that acting on it
 * should be faster than ignoring it.
 */ 
var $2M70Q = parcelRequire("2M70Q");



var $aNyTM = parcelRequire("aNyTM");
var $bi4P4 = parcelRequire("bi4P4");

var $3OyDL = parcelRequire("3OyDL");

var $8B9Zg = parcelRequire("8B9Zg");





function $bc3777a1cb64c617$export$3019241a33f346aa(from = new Date()) {
    const day = new Date(from);
    day.setDate(day.getDate() + 1);
    day.setHours(9, 0, 0, 0);
    if ((0, $d4d460d3ffb6daab$export$cfc9e8d9ee3dc0f4)(day) === (0, $d4d460d3ffb6daab$export$87b71208d3952cb3)) day.setDate(day.getDate() + 1);
    return day;
}
function $bc3777a1cb64c617$export$22fbcc98bad4cd3d(suggestion) {
    const name = suggestion.contact?.displayName || (0, $d916753b57975e04$export$25ce5a424b770e84).app.none;
    const subject = suggestion.activity?.title ? `${suggestion.activity.title} (${name})` : name;
    const date = (0, $d4d460d3ffb6daab$export$3ae94a2503e890a1)(suggestion.activity?.startsAt ?? suggestion.suggestedAt);
    const template = (0, $d916753b57975e04$export$25ce5a424b770e84).followUps.sentence[suggestion.reason];
    return template ? template(subject, date) : subject;
}
function $bc3777a1cb64c617$export$6a510118c5e7961() {
    const [accepting, setAccepting] = (0, $3OyDL.useState)(null);
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$20635703b116d48d), {
        variables: {
            state: 'OPEN'
        },
        fetchPolicy: 'cache-and-network'
    });
    const { data: typeData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$76905cee0d96ad5e));
    const [acceptSuggestion, acceptState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$a374dbe2b0fba9f6), {
        onCompleted: ()=>refetch()
    });
    const [dismissSuggestion, dismissState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$9c1728c7497ad15d), {
        onCompleted: ()=>refetch()
    });
    const suggestions = data?.followUpSuggestions ?? [];
    /**
   * The follow-up type, by CODE rather than position.
   *
   * The one place a code is named — and it names a *mechanism* («this is the
   * kind of activity a follow-up is»), not a Parsina concept. A deployment
   * whose vocabulary has no such code simply gets its first type, which is
   * still usable; the alternative, hardcoding an index, would silently change
   * meaning the first time somebody reordered the list.
   */ const followUpType = (0, $3OyDL.useMemo)(()=>{
        const types = typeData?.activityTypes ?? [];
        return types.find((type)=>type.code === 'SALES_FOLLOW_UP') ?? types[0];
    }, [
        typeData
    ]);
    function prefillFor(suggestion) {
        const start = $bc3777a1cb64c617$export$3019241a33f346aa();
        const end = new Date(start);
        end.setHours(end.getHours() + 1);
        return {
            startsAt: start,
            endsAt: end,
            contactId: suggestion.contactId ?? '',
            typeId: followUpType?.id ?? '',
            title: suggestion.activity?.title ? `${(0, $d916753b57975e04$export$25ce5a424b770e84).activity.createdFromInteraction}: ${suggestion.activity.title}` : (0, $d916753b57975e04$export$25ce5a424b770e84).followUps.accept
        };
    }
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex h-screen flex-col",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("header", {
                className: "flex h-toolbar shrink-0 items-center gap-3 border-b border-border bg-surface px-5",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8b130464b09d4cb6$export$2e2bcd8739ae039), {
                        size: 18,
                        className: "text-primary",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h1", {
                        className: "text-md font-bold",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).followUps.title
                    }),
                    suggestions.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "rounded-full bg-primary px-2 py-px text-xs text-primary-contrast",
                        children: suggestions.length
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: error ?? acceptState.error ?? dismissState.error
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex-1 overflow-y-auto p-5",
                children: [
                    loading && suggestions.length === 0 ? /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                        className: "flex justify-center py-8",
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {})
                    }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$4b2346c6725d60cc), {
                        loading: false,
                        empty: suggestions.length === 0,
                        emptyTitle: (0, $d916753b57975e04$export$25ce5a424b770e84).followUps.empty,
                        emptyHint: (0, $d916753b57975e04$export$25ce5a424b770e84).followUps.emptyHint
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
                        className: "flex flex-col gap-2",
                        children: suggestions.map((suggestion)=>/*#__PURE__*/ (0, $2M70Q.jsxs)("li", {
                                className: "flex items-center gap-4 rounded border border-border bg-surface px-4 py-3",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                        className: "flex flex-1 flex-col gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                                className: "text-base text-text",
                                                children: $bc3777a1cb64c617$export$22fbcc98bad4cd3d(suggestion)
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                                className: "flex items-center gap-3 text-xs text-text-muted",
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                        className: "rounded bg-surface-hover px-2 py-px",
                                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).followUps.reasonLabels[suggestion.reason] ?? suggestion.reason
                                                    }),
                                                    suggestion.contactId && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8B9Zg.Link), {
                                                        to: `/contacts/${suggestion.contactId}`,
                                                        className: "text-primary hover:underline",
                                                        children: suggestion.contact?.displayName ?? (0, $d916753b57975e04$export$25ce5a424b770e84).activity.contact
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                        type: "button",
                                        variant: "primary",
                                        onClick: ()=>setAccepting(suggestion),
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $aNyTM.default), {
                                                size: 14,
                                                "aria-hidden": "true"
                                            }),
                                            (0, $d916753b57975e04$export$25ce5a424b770e84).followUps.accept
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                        type: "button",
                                        onClick: ()=>dismissSuggestion({
                                                variables: {
                                                    id: suggestion.id
                                                }
                                            }),
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $bi4P4.default), {
                                                size: 14,
                                                "aria-hidden": "true"
                                            }),
                                            (0, $d916753b57975e04$export$25ce5a424b770e84).followUps.dismiss
                                        ]
                                    })
                                ]
                            }, suggestion.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $a337acc1647f440c$export$29a29aaae5ee2157), {
                open: Boolean(accepting),
                onOpenChange: (open)=>!open && setAccepting(null),
                prefill: accepting ? prefillFor(accepting) : undefined,
                onCreate: async (input)=>{
                    await acceptSuggestion({
                        variables: {
                            id: accepting.id,
                            input: input
                        }
                    });
                    setAccepting(null);
                }
            })
        ]
    });
}




function $58de81430a24d377$export$d9ceb3199f1f8bbd({ interaction: interaction, contactId: contactId, onOpenChange: onOpenChange, onCreated: onCreated }) {
    const open = Boolean(interaction);
    const { isAdmin: isAdmin } = (0, $00d5d84dffcdf8d5$export$ad0a340bf97d63d5)();
    const [form, setForm] = (0, $3OyDL.useState)({
        typeId: '',
        title: '',
        date: '',
        time: '09:00'
    });
    const { data: typeData, loading: typesLoading } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$76905cee0d96ad5e), {
        skip: !open
    });
    const types = typeData?.activityTypes ?? [];
    const [createFollowUp, state] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$67cc7384e85bd2f2));
    // The same dead end as the calendar's: an empty vocabulary would make
    // planning a follow-up impossible from here too.
    const [createType, createTypeState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$39328c7d9faf3888), {
        refetchQueries: [
            'ActivityTypes'
        ],
        awaitRefetchQueries: true
    });
    (0, $3OyDL.useEffect)(()=>{
        if (!open) return;
        // Prefilled for the next working day, like the inbox's Accept: the value of
        // a one-click follow-up is entirely in not having to fill a form.
        const when = (0, $d4d460d3ffb6daab$export$a32865ea4a905df9)((0, $bc3777a1cb64c617$export$3019241a33f346aa)().toISOString());
        setForm({
            typeId: '',
            title: interaction?.type?.labelFa ? `${(0, $d916753b57975e04$export$25ce5a424b770e84).activity.createdFromInteraction}: ${interaction.type.labelFa}` : (0, $d916753b57975e04$export$25ce5a424b770e84).activity.createdFromInteraction,
            date: when.date,
            time: when.time
        });
    }, [
        open,
        interaction
    ]);
    (0, $3OyDL.useEffect)(()=>{
        if (!form.typeId && types.length > 0) setForm((current)=>({
                ...current,
                typeId: types[0].id
            }));
    }, [
        types,
        form.typeId
    ]);
    async function submit() {
        const startsAt = (0, $d4d460d3ffb6daab$export$747b60771a8a4ce9)(form.date, form.time);
        if (!startsAt) return;
        await createFollowUp({
            variables: {
                interactionId: interaction.id,
                input: {
                    typeId: form.typeId,
                    title: form.title,
                    startsAt: startsAt,
                    contactId: contactId
                }
            }
        });
        onCreated?.();
    }
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: open,
        onOpenChange: onOpenChange,
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.createdFromInteraction,
        submitLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.create,
        busy: state.loading,
        onSubmit: submit,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: state.error
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4436e89d3ef1c462$export$bc36ad93e482d2f8), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.type,
                value: form.typeId,
                onChange: (id)=>setForm((c)=>({
                            ...c,
                            typeId: id
                        })),
                options: types,
                loading: typesLoading,
                required: true,
                canCreate: isAdmin,
                codePrefix: "ACTIVITY",
                creating: createTypeState.loading,
                createError: createTypeState.error,
                onCreate: async (input)=>{
                    const created = await createType({
                        variables: {
                            input: input
                        }
                    });
                    return created.data?.createActivityType;
                }
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.subject,
                value: form.title,
                onChange: (event)=>setForm((c)=>({
                            ...c,
                            title: event.target.value
                        })),
                required: true
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$ce0a41819d728248), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.date,
                        value: form.date,
                        onChange: (value)=>setForm((c)=>({
                                    ...c,
                                    date: value
                                }))
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).activity.startTime,
                        value: form.time,
                        onChange: (event)=>setForm((c)=>({
                                    ...c,
                                    time: event.target.value
                                })),
                        dir: "ltr"
                    })
                ]
            })
        ]
    });
}







function $aad89f91096fa167$export$835a716917aceefd() {
    const { id: id } = (0, $ZNHD9.useParams)();
    const navigate = (0, $8B9Zg.useNavigate)();
    const { isAdmin: isAdmin } = (0, $00d5d84dffcdf8d5$export$ad0a340bf97d63d5)();
    const [composerOpen, setComposerOpen] = (0, $3OyDL.useState)(false);
    const [statusOpen, setStatusOpen] = (0, $3OyDL.useState)(false);
    const [deleteOpen, setDeleteOpen] = (0, $3OyDL.useState)(false);
    const [undeleteOpen, setUndeleteOpen] = (0, $3OyDL.useState)(false);
    const [eraseOpen, setEraseOpen] = (0, $3OyDL.useState)(false);
    const [timelineToken, setTimelineToken] = (0, $3OyDL.useState)(0);
    const [followUpFor, setFollowUpFor] = (0, $3OyDL.useState)(null);
    const [actionError, setActionError] = (0, $3OyDL.useState)(null);
    (0, $ed3cc4f847deec94$export$b0ebbe7904d8d94a)('Escape', ()=>navigate('/'), {
        description: (0, $d916753b57975e04$export$25ce5a424b770e84).shortcuts.actions.backToList,
        group: (0, $d916753b57975e04$export$25ce5a424b770e84).shortcuts.groups.contacts
    });
    (0, $ed3cc4f847deec94$export$b0ebbe7904d8d94a)('i', ()=>setComposerOpen(true), {
        description: (0, $d916753b57975e04$export$25ce5a424b770e84).shortcuts.actions.recordInteraction,
        group: (0, $d916753b57975e04$export$25ce5a424b770e84).shortcuts.groups.contacts
    });
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$40a76660d65736ce), {
        variables: {
            id: id
        }
    });
    const { data: typeData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$d2d584f4325fcf08), {
        variables: {
            kind: 'INTERACTION_TYPE',
            includeInactive: true
        }
    });
    const [undeleteContact] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$2fcd14942149ca8f));
    const contact = data?.contact;
    if (loading && !contact) return /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
        className: "flex justify-center p-7",
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {})
    });
    if (error || !contact) return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$fddf379e22a74b00), {
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.notFound,
        hint: error?.message,
        className: "text-danger"
    });
    const isDeleted = Boolean(contact.deletedAt);
    // A deleted contact is readable — history points at it — but not editable.
    const readOnly = isDeleted;
    const run = async (fn)=>{
        setActionError(null);
        try {
            await fn();
            await refetch();
        } catch (err) {
            setActionError(err);
        }
    };
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex h-screen flex-col",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("header", {
                className: "flex shrink-0 items-start gap-5 border-b border-border bg-surface px-6 py-4",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f1ac2c7aaec4c80d$export$35cbab2db7d9997e), {
                        contactId: contact.id,
                        name: contact.displayName,
                        url: contact.photoUrl,
                        gender: contact.gender,
                        onUploaded: refetch,
                        disabled: readOnly
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "flex min-w-0 flex-1 flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                className: "flex flex-wrap items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $8B9Zg.Link), {
                                        to: "/",
                                        className: "flex items-center gap-1 text-sm text-text-muted hover:text-text",
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $74E7N.default), {
                                                size: 15,
                                                "aria-hidden": "true"
                                            }),
                                            (0, $d916753b57975e04$export$25ce5a424b770e84).nav.contacts
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("h1", {
                                        className: "text-lg font-bold",
                                        children: contact.displayName
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                                        type: "button",
                                        disabled: readOnly,
                                        onClick: ()=>setStatusOpen(true),
                                        title: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.changeStatus,
                                        className: "disabled:cursor-default",
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$5720c1871db44880), {
                                            status: contact.collaborationStatus,
                                            label: (0, $d4d460d3ffb6daab$export$3c3cfc169bd4703d)[contact.collaborationStatus]
                                        })
                                    }),
                                    contact.primaryPhone && /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                dir: "ltr",
                                                className: "tabular-nums text-base",
                                                children: (0, $d4d460d3ffb6daab$export$10c09b2cff9813eb)(contact.primaryPhone.number)
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ccacecf78328396f$export$f9f39c056569f034), {
                                                channels: contact.primaryPhone.channels
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4d83a78eafaaee98$export$ed0487506eb44813), {
                                contact: contact,
                                onSaved: refetch,
                                readOnly: readOnly
                            }),
                            isDeleted && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                role: "status",
                                className: "rounded border border-danger px-4 py-2 text-sm text-danger",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.deletedNotice
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "flex shrink-0 items-center gap-3",
                        children: [
                            !isDeleted && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                        variant: "primary",
                                        onClick: ()=>setComposerOpen(true),
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $652705894d580044$export$2e2bcd8739ae039), {
                                                size: 14,
                                                "aria-hidden": "true"
                                            }),
                                            (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.recordInteraction
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                        onClick: ()=>setStatusOpen(true),
                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.changeStatus
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                        variant: "ghost",
                                        onClick: ()=>setDeleteOpen(true),
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8750d1d3edd41705$export$2e2bcd8739ae039), {
                                                size: 14,
                                                "aria-hidden": "true"
                                            }),
                                            (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.deleteContact
                                        ]
                                    })
                                ]
                            }),
                            isDeleted && isAdmin && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                variant: "primary",
                                onClick: ()=>setUndeleteOpen(true),
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $96e39fbe36da68cb$export$2e2bcd8739ae039), {
                                        size: 14,
                                        "aria-hidden": "true"
                                    }),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.undeleteContact
                                ]
                            }),
                            isDeleted && isAdmin && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                variant: "ghost",
                                onClick: ()=>setEraseOpen(true),
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d23d04f6959f82b1$export$2e2bcd8739ae039), {
                                        size: 14,
                                        "aria-hidden": "true"
                                    }),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).erasure.action
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "min-h-0 flex-1 overflow-auto p-6",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                        error: actionError
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "grid grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)] gap-6",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                className: "flex flex-col gap-6",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $728688e7e2fdee35$export$e54a7f2505304e20), {
                                        contact: contact,
                                        onSaved: refetch,
                                        readOnly: readOnly
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $bae3dbaf0eb4dc53$export$32f640202e9e5673), {
                                        contact: contact,
                                        onSaved: refetch,
                                        readOnly: readOnly
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4b23b4f4ec62558e$export$ccdaf0435354dc8f), {
                                        contact: contact,
                                        onSaved: refetch,
                                        readOnly: readOnly
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4b23b4f4ec62558e$export$ff908043192c6bb6), {
                                        contact: contact,
                                        onSaved: refetch,
                                        readOnly: readOnly
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $0f5a1967626d2e5c$export$5287a4f9fdec4248), {
                                        contact: contact,
                                        onSaved: refetch,
                                        readOnly: readOnly
                                    }),
                                    !readOnly && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8d5e83f479aff161$export$2b90e891e9f3a5cd), {
                                        contact: contact,
                                        onChanged: refetch
                                    }),
                                    !readOnly && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c131ddcbc5d2c4f0$export$bf6413248a84a816), {
                                        contact: contact
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                className: "flex flex-col gap-6",
                                children: [
                                    !readOnly && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $bfa1dc9a53e438a4$export$39a2fda5a9a1f773), {
                                        contactId: contact.id
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $0dfe5b82a0098687$export$e6a97ba2cae5bb94), {
                                        contactId: contact.id,
                                        types: typeData?.lookups ?? [],
                                        reloadToken: timelineToken,
                                        onFollowUp: readOnly ? undefined : setFollowUpFor
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $de39eaf1449f169c$export$2310fe575ea26aef), {
                open: composerOpen,
                onOpenChange: setComposerOpen,
                contactId: contact.id,
                onRecorded: async ()=>{
                    setTimelineToken((token)=>token + 1);
                    await refetch();
                }
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $58de81430a24d377$export$d9ceb3199f1f8bbd), {
                interaction: followUpFor,
                contactId: contact.id,
                onOpenChange: (open)=>!open && setFollowUpFor(null),
                onCreated: ()=>{
                    setTimelineToken((token)=>token + 1);
                    setFollowUpFor(null);
                }
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d8283146ac3977c4$export$53b9a9c3865589e7), {
                open: statusOpen,
                onOpenChange: setStatusOpen,
                contact: contact,
                onChanged: refetch
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $31457bd6012dbd66$export$7b4ce26856c96fdc), {
                open: eraseOpen,
                onOpenChange: setEraseOpen,
                contact: contact,
                // Back to the list: the contact still exists, but there is nothing
                // left on this page to look at.
                onErased: ()=>navigate('/contacts')
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $7f1b88b42a536c5f$export$5879ef5716dc8de0), {
                contact: contact,
                open: deleteOpen,
                onOpenChange: setDeleteOpen,
                onDeleted: refetch,
                onError: setActionError
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2cc85109a937009e), {
                open: undeleteOpen,
                onOpenChange: setUndeleteOpen,
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.undeleteContact,
                message: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.confirmUndelete(contact.displayName),
                confirmLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).app.restore,
                onConfirm: ()=>run(()=>undeleteContact({
                            variables: {
                                id: contact.id
                            }
                        }))
            })
        ]
    });
}


/**
 * The management dashboard — «چطور داریم پیش می‌رویم؟».
 *
 * FOUR SECTIONS, mirroring docs/kpi-catalogue.md: the funnel, why deals fail,
 * what the market looks like, and how the team is doing. The last is ADMIN
 * only, and that is a product decision rather than a security one: a USER sees
 * their own row because the analytics service narrows them to it.
 *
 * TWO RULES SHAPE EVERY CARD ON THIS PAGE.
 *
 * 1. **The ⓘ comes from the server.** Formula, grain and caveat all arrive with
 *    the number, from the one catalogue. There is no Persian formula text in
 *    any component here.
 * 2. **Every number is clickable.** A dashboard that shows «۱۲ مخاطب ریزش
 *    کردند» and cannot say WHICH twelve is a dashboard that ends the
 *    conversation instead of starting it.
 *
 * The sections are collapsible, and that is a feature rather than a
 * concession: a dashboard with four cards people read beats one with forty
 * they scroll past, and hiding a section they never use is the right answer.
 */ 
var $2M70Q = parcelRequire("2M70Q");



var $9ZCAD = parcelRequire("9ZCAD");
var $gcf4m = parcelRequire("gcf4m");
var $jqtUP = parcelRequire("jqtUP");

var $3OyDL = parcelRequire("3OyDL");

var $8B9Zg = parcelRequire("8B9Zg");
/**
 * The cohort table: «درصد موفقیت» by month of first contact.
 *
 * THE GREY CELLS ARE THE POINT. A cohort met last week has not had time to
 * subscribe, so a recent row always looks terrible — and drawing that as a low
 * number invents a decline that is an artefact of the calendar rather than a
 * fact about the business. An immature cell is empty and grey; a cell that
 * genuinely converted nobody is a `۰`.
 *
 * That distinction survives the whole way from the analytics service, which
 * sends a null mask beside its values because a proto3 double cannot be null.
 */ 
var $2M70Q = parcelRequire("2M70Q");
parcelRequire("3OyDL");


function $2155312196e86c4e$var$cellColour(value) {
    if (value === null || value === undefined) return 'bg-surface-hover text-transparent';
    if (value >= 50) return 'bg-primary text-primary-contrast';
    if (value >= 25) return 'bg-primary/60 text-text';
    if (value > 0) return 'bg-primary/25 text-text';
    return 'bg-surface text-text-muted';
}
function $2155312196e86c4e$export$83b34e3e0dae0bfd({ metric: metric }) {
    if (!metric?.rows?.length) return /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
        className: "p-4 text-sm text-text-muted",
        children: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.noData
    });
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "overflow-x-auto",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("table", {
                className: "w-full border-collapse text-xs",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("tr", {
                            className: "text-text-muted",
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)("th", {
                                    className: "sticky start-0 bg-surface p-2 text-start font-medium",
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.cohortMonth
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)("th", {
                                    className: "p-2 text-start font-medium",
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.cohortSize
                                }),
                                metric.buckets.map((b)=>/*#__PURE__*/ (0, $2M70Q.jsx)("th", {
                                        className: "p-2 text-center font-medium",
                                        children: (0, $d4d460d3ffb6daab$export$e9cf274fc1035ec4)(b)
                                    }, b))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("tbody", {
                        children: metric.rows.map((row)=>/*#__PURE__*/ (0, $2M70Q.jsxs)("tr", {
                                className: "border-t border-border",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("th", {
                                        scope: "row",
                                        className: "sticky start-0 whitespace-nowrap bg-surface p-2 text-start font-normal",
                                        children: row.label
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("td", {
                                        className: "p-2 tabular-nums text-text-muted",
                                        children: (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(JSON.parse(row.extraJson ?? '{}').denominator ?? 0)
                                    }),
                                    row.values.map((value, i)=>/*#__PURE__*/ (0, $2M70Q.jsx)("td", {
                                            className: `p-2 text-center tabular-nums ${$2155312196e86c4e$var$cellColour(value)}`,
                                            title: value === null || value === undefined ? (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.immature : `${(0, $d4d460d3ffb6daab$export$e9cf274fc1035ec4)(value.toFixed(1))}\u{66A}`,
                                            children: value === null || value === undefined ? "\xb7" : (0, $d4d460d3ffb6daab$export$e9cf274fc1035ec4)(Math.round(value))
                                        }, i))
                                ]
                            }, row.key))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                className: "p-2 text-xs text-text-muted",
                children: [
                    (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.immature,
                    ": \xb7"
                ]
            })
        ]
    });
}


/**
 * A market distribution: how many, and how many of those subscribed.
 *
 * BOTH COLUMNS, always. The gap between «who we meet» and «who buys» is the
 * interesting part, and splitting them across two cards makes a reader hold
 * one in their head while they look at the other.
 *
 * Drawn with the tokenized BarChart, which is flex rows rather than a charting
 * library — the only chart this page needs is a horizontal bar, and a library
 * would bring its own colours, font sizing and opinion about RTL to override.
 */ 
var $2M70Q = parcelRequire("2M70Q");

/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $5a1900bd77631f6a$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 16v-4",
            key: "1dtifu"
        }
    ],
    [
        "path",
        {
            d: "M12 8h.01",
            key: "e9boi3"
        }
    ]
];
const $5a1900bd77631f6a$export$2e2bcd8739ae039 = (0, $djixo.default)("info", $5a1900bd77631f6a$export$3efd853dbb351e94);



var $3OyDL = parcelRequire("3OyDL");


function $f712af9a8f4f5e89$export$8c9185ab3d8f0582({ metric: metric, onDrillDown: onDrillDown }) {
    const [showInfo, setShowInfo] = (0, $3OyDL.useState)(false);
    const { definition: d } = metric;
    const data = metric.rows.map((row)=>({
            label: row.label,
            value: row.values[0] ?? 0,
            // The subscriber subset, rendered as the secondary number rather than a
            // second bar: two bars per row doubles the height of the card and halves
            // how much of it fits on a screen.
            secondary: row.values[1] ?? 0,
            key: row.key
        }));
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
        className: "flex flex-col gap-2 p-4",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex items-start justify-between gap-2",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h3", {
                        className: "text-sm font-medium text-text",
                        children: d.titleFa
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                        type: "button",
                        onClick: ()=>setShowInfo((v)=>!v),
                        "aria-expanded": showInfo,
                        "aria-label": `${(0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.definition}: ${d.titleFa}`,
                        className: "shrink-0 rounded p-1 text-text-muted hover:bg-surface-hover hover:text-text",
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $5a1900bd77631f6a$export$2e2bcd8739ae039), {
                            size: 14,
                            "aria-hidden": "true"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$94aefc399ef206a9), {
                data: data,
                valueLabel: metric.buckets[0],
                formatValue: (v, row)=>`${(0, $d4d460d3ffb6daab$export$104ee80c24270f18)(v)}${row?.secondary ? ` / ${(0, $d4d460d3ffb6daab$export$104ee80c24270f18)(row.secondary)}` : ''}`,
                emptyLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.noData,
                onSelect: onDrillDown ? (row)=>onDrillDown(metric, row.key) : undefined
            }),
            showInfo && /*#__PURE__*/ (0, $2M70Q.jsxs)("dl", {
                className: "flex flex-col gap-2 border-t border-border pt-2 text-xs",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("dt", {
                                className: "font-medium text-text",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.formula
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("dd", {
                                className: "text-text-muted",
                                children: d.formula
                            })
                        ]
                    }),
                    d.caveat && /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("dt", {
                                className: "font-medium text-warning",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.caveat
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("dd", {
                                className: "text-text",
                                children: d.caveat
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/**
 * One number, its trend, and the ⓘ that says what it means.
 *
 * THE ⓘ IS NOT DECORATION. Every word of it — the formula, the grain, the
 * caveat — comes from `ListMetricDefinitions`, which serves
 * docs/kpi-catalogue.md. There is deliberately no Persian formula text in this
 * file: two definitions of «نرخ تبدیل» would eventually disagree, and the one
 * on the screen would be the one people believed.
 *
 * Three states this component exists to render honestly, because each of them
 * is a number that would otherwise be wrong:
 *
 *   «—»          the denominator was too small. "100% conversion" from one
 *                contact is worse than no number: it gets quoted.
 *   badge        the metric rests on a decision the stakeholders have not
 *                confirmed. Saying so on the SCREEN, not only in a document
 *                nobody opens twice.
 *   grey cell    an immature cohort. NOT a zero — plotting it as one invents
 *                a decline that is an artefact of the calendar.
 */ 
var $2M70Q = parcelRequire("2M70Q");


var $6tkl0 = parcelRequire("6tkl0");/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $cd772c651cb1e32d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m7 7 10 10",
            key: "1fmybs"
        }
    ],
    [
        "path",
        {
            d: "M17 7v10H7",
            key: "6fjiku"
        }
    ]
];
const $cd772c651cb1e32d$export$2e2bcd8739ae039 = (0, $djixo.default)("arrow-down-right", $cd772c651cb1e32d$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $9a7db399c14d9217$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M7 7h10v10",
            key: "1tivn9"
        }
    ],
    [
        "path",
        {
            d: "M7 17 17 7",
            key: "1vkiza"
        }
    ]
];
const $9a7db399c14d9217$export$2e2bcd8739ae039 = (0, $djixo.default)("arrow-up-right", $9a7db399c14d9217$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $13468574f2ab19dc$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ]
];
const $13468574f2ab19dc$export$2e2bcd8739ae039 = (0, $djixo.default)("minus", $13468574f2ab19dc$export$3efd853dbb351e94);



var $3OyDL = parcelRequire("3OyDL");


function $0fa68d3d098ea8a4$export$12e5d7722aad47d(value, { isRate: isRate, suppressed: suppressed }) {
    if (suppressed || value === null || value === undefined) return "\u2014";
    if (isRate) return `${(0, $d4d460d3ffb6daab$export$e9cf274fc1035ec4)(Number(value).toFixed(1))}\u{66A}`;
    return (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(Math.round(Number(value) * 100) / 100);
}
function $0fa68d3d098ea8a4$var$Delta({ value: value }) {
    if (value === null || value === undefined) return /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
        className: "flex items-center gap-1 text-xs text-text-muted",
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $13468574f2ab19dc$export$2e2bcd8739ae039), {
            size: 12,
            "aria-hidden": "true"
        })
    });
    const up = value > 0;
    const Icon = up ? (0, $9a7db399c14d9217$export$2e2bcd8739ae039) : (0, $cd772c651cb1e32d$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
        className: `flex items-center gap-1 text-xs ${up ? 'text-success' : 'text-danger'}`,
        // A delta with no baseline is meaningless, so the title always names
        // what it is measured against rather than leaving the reader to guess.
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.comparedTo,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)(Icon, {
                size: 12,
                "aria-hidden": "true"
            }),
            (0, $d4d460d3ffb6daab$export$e9cf274fc1035ec4)(Math.abs(value).toFixed(1)),
            "\u066A"
        ]
    });
}
/**
 * A sparkline as flex rows, like the BarChart — no charting library.
 *
 * NULLS ARE GAPS, not zeros. A cohort that has not matured must not be drawn
 * at the bottom of the chart beside one that converted nobody.
 */ function $0fa68d3d098ea8a4$var$Sparkline({ values: values }) {
    const present = values.filter((v)=>v !== null && v !== undefined);
    if (present.length < 2) return null;
    const max = Math.max(...present, 0);
    const min = Math.min(...present, 0);
    const span = max - min || 1;
    return /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
        className: "flex h-sparkline items-end gap-px",
        "aria-hidden": "true",
        children: values.map((v, i)=>{
            const missing = v === null || v === undefined;
            return /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: missing ? 'flex-1 bg-transparent' : 'flex-1 bg-primary/40',
                // A PERCENTAGE, not a pixel: the bar's height is a share of the
                // sparkline's own token height, so changing that token rescales
                // every bar rather than leaving a hardcoded floor behind.
                //
                // A missing point is a GAP with a hairline, not a zero bar. An
                // immature cohort drawn at the bottom of the chart beside one that
                // converted nobody would say the two are the same thing.
                style: {
                    height: missing ? '2%' : `${Math.max(6, (v - min) / span * 100)}%`
                }
            }, i);
        })
    });
}
function $0fa68d3d098ea8a4$export$8b799af4f3123f30({ metric: metric, error: error, onDrillDown: onDrillDown }) {
    const [showInfo, setShowInfo] = (0, $3OyDL.useState)(false);
    if (error) // ONE broken card beside nineteen working ones. The dashboard renders the
    // message in place of the number rather than failing the page.
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
        className: "flex flex-col gap-2 p-4",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: "text-sm font-medium text-text",
                children: error.name
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex items-start gap-2 text-xs text-danger",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6tkl0.default), {
                        size: 14,
                        className: "mt-px shrink-0",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                        children: [
                            (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.metricFailed,
                            ": ",
                            error.message
                        ]
                    })
                ]
            })
        ]
    });
    const { definition: d } = metric;
    const primary = metric.rows.length === 1 ? metric.rows[0] : null;
    const series = primary?.values ?? [];
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
        className: "flex flex-col gap-2 p-4",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex items-start justify-between gap-2",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h3", {
                        className: "text-sm font-medium text-text",
                        children: d.titleFa
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                        type: "button",
                        onClick: ()=>setShowInfo((v)=>!v),
                        "aria-expanded": showInfo,
                        "aria-label": `${(0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.definition}: ${d.titleFa}`,
                        className: "shrink-0 rounded p-1 text-text-muted hover:bg-surface-hover hover:text-text",
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $5a1900bd77631f6a$export$2e2bcd8739ae039), {
                            size: 14,
                            "aria-hidden": "true"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex items-end justify-between gap-2",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-2xl font-bold tabular-nums text-text",
                        children: $0fa68d3d098ea8a4$export$12e5d7722aad47d(metric.total, {
                            isRate: d.isRate,
                            suppressed: metric.suppressed
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)($0fa68d3d098ea8a4$var$Delta, {
                        value: metric.deltaPct
                    })
                ]
            }),
            series.length > 1 && /*#__PURE__*/ (0, $2M70Q.jsx)($0fa68d3d098ea8a4$var$Sparkline, {
                values: series
            }),
            metric.suppressed && /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                className: "text-xs text-text-muted",
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.suppressedHint,
                children: [
                    (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.suppressed,
                    metric.denominator > 0 && ` (${(0, $d4d460d3ffb6daab$export$104ee80c24270f18)(metric.denominator)})`
                ]
            }),
            d.needsConfirmation && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                className: "w-fit bg-warning-subtle text-warning",
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.needsConfirmationHint,
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.needsConfirmation
            }),
            onDrillDown && /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                type: "button",
                onClick: ()=>onDrillDown(metric, primary?.key ?? ''),
                className: "w-fit text-xs text-primary hover:underline",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.drillDown
            }),
            showInfo && /*#__PURE__*/ (0, $2M70Q.jsxs)("dl", {
                className: "flex flex-col gap-2 border-t border-border pt-2 text-xs",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("dt", {
                                className: "font-medium text-text",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.formula
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("dd", {
                                className: "text-text-muted",
                                children: d.formula
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("dt", {
                                className: "font-medium text-text",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.grain
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("dd", {
                                className: "text-text-muted",
                                children: d.grain
                            })
                        ]
                    }),
                    d.caveat && /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("dt", {
                                className: "font-medium text-warning",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.caveat
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("dd", {
                                className: "text-text",
                                children: d.caveat
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("dt", {
                                className: "font-medium text-text",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.sources
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("dd", {
                                className: "text-text-muted",
                                dir: "ltr",
                                children: d.sources.join("\u060C ")
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




/**
 * The dashboard's date range: Jalali presets in, a UTC interval out.
 *
 * WHY THIS IS ITS OWN MODULE. «این ماه» must mean the same Jalali month
 * everywhere — the toolbar, a shared link, the comparison period — and three
 * screens each computing it from `new Date()` is three chances for one of them
 * to use a Gregorian month and be wrong by up to eleven days.
 *
 * The conversion uses `Intl.DateTimeFormat` with the `persian` calendar, which
 * the platform already ships and gets right, rather than a second
 * implementation of the arithmetic the services carry. That is the same
 * division of labour as everywhere else: storage and comparison are UTC,
 * display and selection are Jalali, and this module is the boundary.
 */ 
const $7d3db79f4948d211$var$JALALI = new Intl.DateTimeFormat('en-u-ca-persian-nu-latn', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    timeZone: 'UTC'
});
function $7d3db79f4948d211$export$413e19f965719fc(date) {
    const parts = Object.fromEntries($7d3db79f4948d211$var$JALALI.formatToParts(date).map((p)=>[
            p.type,
            p.value
        ]));
    return {
        jy: Number(parts.year),
        jm: Number(parts.month),
        jd: Number(parts.day)
    };
}
function $7d3db79f4948d211$export$2254637a575f247e(jy, jm, jd = 1) {
    // 1 Farvardin 1349 is 21 March 1970. Anchoring there makes the estimate
    // close enough that the search is a handful of steps.
    const estimate = Date.UTC(1970, 2, 21) + Math.round((jy - 1349) * 365.2422 + (jm - 1) * 30.4 + (jd - 1)) * 86400000;
    let low = estimate - 34560000000;
    let high = estimate + 34560000000;
    const target = jy * 10000 + jm * 100 + jd;
    while(low <= high){
        const mid = low + Math.floor((high - low) / 2 / 86400000) * 86400000;
        const { jy: y, jm: m, jd: d } = $7d3db79f4948d211$export$413e19f965719fc(new Date(mid));
        const value = y * 10000 + m * 100 + d;
        if (value === target) return new Date(mid);
        if (value < target) low = mid + 86400000;
        else high = mid - 86400000;
    }
    return new Date(estimate);
}
function $7d3db79f4948d211$export$2d14dc66f38a5d5f(date, months) {
    const { jy: jy, jm: jm, jd: jd } = $7d3db79f4948d211$export$413e19f965719fc(date);
    const total = jy * 12 + (jm - 1) + months;
    const ny = Math.floor(total / 12);
    const nm = total % 12 + 1;
    // Clamp the day: Esfand 30 exists only in a leap year, and a cohort table
    // walks forward in months on every render.
    let day = jd;
    for(; day > 28; day -= 1){
        const candidate = $7d3db79f4948d211$export$2254637a575f247e(ny, nm, day);
        const parts = $7d3db79f4948d211$export$413e19f965719fc(candidate);
        if (parts.jm === nm && parts.jd === day) break;
    }
    return $7d3db79f4948d211$export$2254637a575f247e(ny, nm, day);
}
const $7d3db79f4948d211$export$9265403940be6b4 = [
    'this_month',
    'this_quarter',
    'this_year',
    'last_30'
];
function $7d3db79f4948d211$export$4a616570ea409e04(preset, now = new Date()) {
    const { jy: jy, jm: jm } = $7d3db79f4948d211$export$413e19f965719fc(now);
    let from;
    let to;
    switch(preset){
        case 'this_month':
            from = $7d3db79f4948d211$export$2254637a575f247e(jy, jm, 1);
            to = $7d3db79f4948d211$export$2d14dc66f38a5d5f(from, 1);
            break;
        case 'this_quarter':
            {
                const qStart = Math.floor((jm - 1) / 3) * 3 + 1;
                from = $7d3db79f4948d211$export$2254637a575f247e(jy, qStart, 1);
                to = $7d3db79f4948d211$export$2d14dc66f38a5d5f(from, 3);
                break;
            }
        case 'this_year':
            from = $7d3db79f4948d211$export$2254637a575f247e(jy, 1, 1);
            to = $7d3db79f4948d211$export$2d14dc66f38a5d5f(from, 12);
            break;
        case 'last_30':
            to = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1));
            from = new Date(to.getTime() - 2592000000);
            break;
        default:
            throw new Error(`unknown preset ${preset}`);
    }
    return {
        dateFrom: from.toISOString(),
        dateTo: to.toISOString()
    };
}
function $7d3db79f4948d211$export$406d290c065fb197({ dateFrom: dateFrom, dateTo: dateTo }, preset) {
    if (!dateFrom || !dateTo) return '';
    const a = $7d3db79f4948d211$export$413e19f965719fc(new Date(dateFrom));
    // The END is exclusive, so the label must describe the last day INSIDE it —
    // «تا ۱ مهر» for a month ending at Mehr 1 would name a day the data excludes.
    const b = $7d3db79f4948d211$export$413e19f965719fc(new Date(new Date(dateTo).getTime() - 86400000));
    if (preset === 'this_month') return `${(0, $d4d460d3ffb6daab$export$3d5cc8a1339f76b9)[a.jm - 1]} ${a.jy}`;
    if (preset === 'this_quarter') return `\u{641}\u{635}\u{644} ${Math.floor((a.jm - 1) / 3) + 1} ${a.jy}`;
    if (preset === 'this_year') return `\u{633}\u{627}\u{644} ${a.jy}`;
    const fmt = (p)=>`${p.jy}/${String(p.jm).padStart(2, '0')}/${String(p.jd).padStart(2, '0')}`;
    return `${fmt(a)} \u{2013} ${fmt(b)}`;
}
function $7d3db79f4948d211$export$ff8202ee262ff0ca({ dateFrom: dateFrom, dateTo: dateTo }, preset, direction) {
    if (preset === 'last_30' || !$7d3db79f4948d211$export$9265403940be6b4.includes(preset)) {
        const span = new Date(dateTo) - new Date(dateFrom);
        return {
            dateFrom: new Date(new Date(dateFrom).getTime() + direction * span).toISOString(),
            dateTo: new Date(new Date(dateTo).getTime() + direction * span).toISOString()
        };
    }
    const months = {
        this_month: 1,
        this_quarter: 3,
        this_year: 12
    }[preset];
    const from = $7d3db79f4948d211$export$2d14dc66f38a5d5f(new Date(dateFrom), direction * months);
    return {
        dateFrom: from.toISOString(),
        dateTo: $7d3db79f4948d211$export$2d14dc66f38a5d5f(from, months).toISOString()
    };
}






/**
 * Which metrics each section asks for, in one place.
 *
 * Named here rather than assembled per card so the page makes ONE round trip
 * for twenty numbers. Twenty sequential queries is twenty round trips before
 * anything paints.
 */ const $da893dccebb0c931$var$SECTIONS = [
    {
        id: 'funnel',
        scalars: [
            'conversion_rate',
            'velocity',
            'median_time_in_stage'
        ],
        distributions: [
            'contacts_by_status'
        ],
        cohort: 'success_percentage',
        trend: 'success_trend'
    },
    {
        id: 'failure',
        scalars: [
            'churn_rate',
            'missed_activity_rate',
            'issues_per_subscriber'
        ],
        distributions: [
            'backward_transitions',
            'stalled_contacts',
            'suggestion_outcomes'
        ]
    },
    {
        id: 'market',
        scalars: [
            'reachability',
            'affiliation_coverage'
        ],
        distributions: [
            'contacts_by_field_of_work',
            'contacts_by_specialty',
            'contacts_by_gender',
            'subscribers_by_subscription_type',
            'product_interest',
            'interest_to_subscription',
            'new_contacts'
        ]
    },
    {
        id: 'team',
        adminOnly: true,
        scalars: [],
        distributions: [
            'user_activity_summary',
            'campaign_performance',
            'automation_performance'
        ]
    }
];
const $da893dccebb0c931$var$PRESET_LABELS = {
    this_month: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.thisMonth,
    this_quarter: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.thisQuarter,
    this_year: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.thisYear,
    last_30: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.last30
};
const $da893dccebb0c931$var$BUCKET_LABELS = {
    DAY: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.bucketDay,
    WEEK: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.bucketWeek,
    MONTH: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.bucketMonth,
    QUARTER: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.bucketQuarter
};
function $da893dccebb0c931$var$Section({ id: id, children: children, count: count }) {
    const [open, setOpen] = (0, $3OyDL.useState)(true);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("section", {
        className: "flex flex-col gap-3",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("button", {
                type: "button",
                onClick: ()=>setOpen((v)=>!v),
                "aria-expanded": open,
                className: "flex items-center gap-2 text-start text-base font-bold text-text",
                children: [
                    open ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $gcf4m.default), {
                        size: 16,
                        "aria-hidden": "true"
                    }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9ZCAD.default), {
                        size: 16,
                        "aria-hidden": "true"
                    }),
                    (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.sections[id],
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                        className: "text-xs font-normal text-text-muted",
                        children: [
                            "(",
                            (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(count),
                            ")"
                        ]
                    })
                ]
            }),
            open && children
        ]
    });
}
function $da893dccebb0c931$export$5786b26ef2cb7933() {
    const { isAdmin: isAdmin } = (0, $00d5d84dffcdf8d5$export$ad0a340bf97d63d5)();
    const [preset, setPreset] = (0, $3OyDL.useState)('this_quarter');
    const [range, setRange] = (0, $3OyDL.useState)(()=>(0, $7d3db79f4948d211$export$4a616570ea409e04)('this_quarter'));
    const [bucket, setBucket] = (0, $3OyDL.useState)('MONTH');
    const [drill, setDrill] = (0, $3OyDL.useState)(null);
    const sections = (0, $3OyDL.useMemo)(()=>$da893dccebb0c931$var$SECTIONS.filter((s)=>!s.adminOnly || isAdmin), [
        isAdmin
    ]);
    const names = (0, $3OyDL.useMemo)(()=>{
        const out = new Set([
            'system_health'
        ]);
        for (const s of sections){
            s.scalars.forEach((n)=>out.add(n));
            s.distributions.forEach((n)=>out.add(n));
            if (s.cohort) out.add(s.cohort);
            if (s.trend) out.add(s.trend);
        }
        return [
            ...out
        ];
    }, [
        sections
    ]);
    const filter = (0, $3OyDL.useMemo)(()=>({
            dateFrom: range.dateFrom,
            dateTo: range.dateTo,
            bucket: bucket
        }), [
        range,
        bucket
    ]);
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $c0a10c62685d2613$export$906dd73ee0044751), {
        variables: {
            names: names,
            filter: filter
        },
        // The dashboard is read on arrival and left open. Refetching on focus
        // would re-run twenty queries every time somebody alt-tabs back.
        fetchPolicy: 'cache-and-network'
    });
    const applyPreset = (0, $3OyDL.useCallback)((next)=>{
        setPreset(next);
        setRange((0, $7d3db79f4948d211$export$4a616570ea409e04)(next));
    }, []);
    const shift = (0, $3OyDL.useCallback)((direction)=>setRange((r)=>(0, $7d3db79f4948d211$export$ff8202ee262ff0ca)(r, preset, direction)), [
        preset
    ]);
    (0, $ed3cc4f847deec94$export$b0ebbe7904d8d94a)('r', ()=>refetch(), {
        description: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.refresh,
        group: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.title
    });
    (0, $ed3cc4f847deec94$export$b0ebbe7904d8d94a)('[', ()=>shift(-1), {
        description: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.previousPeriod,
        group: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.title
    });
    (0, $ed3cc4f847deec94$export$b0ebbe7904d8d94a)(']', ()=>shift(1), {
        description: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.nextPeriod,
        group: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.title
    });
    const byName = (0, $3OyDL.useMemo)(()=>{
        const map = new Map();
        for (const m of data?.metrics?.metrics ?? [])map.set(m.name, m);
        return map;
    }, [
        data
    ]);
    const errors = (0, $3OyDL.useMemo)(()=>{
        const map = new Map();
        for (const e of data?.metrics?.errors ?? [])map.set(e.name, e);
        return map;
    }, [
        data
    ]);
    // Ingest lag, shown as a banner rather than buried on the ops panel: a
    // business number computed from a read model three days behind is a wrong
    // number that looks right, and the person who needs to know is whoever is
    // reading it (docs/kpi-catalogue.md §4).
    const health = byName.get('system_health');
    const staleSeconds = Math.max(0, ...(health?.rows ?? []).map((r)=>r.values?.[0] ?? 0));
    const isStale = staleSeconds > 600;
    const openDrill = (0, $3OyDL.useCallback)((metric, key)=>{
        setDrill({
            metric: metric.name,
            key: key,
            title: metric.definition.titleFa
        });
    }, []);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex h-full flex-col gap-4 overflow-y-auto p-4",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("header", {
                className: "flex flex-wrap items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("h1", {
                                className: "text-lg font-bold text-text",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.title
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                className: "text-xs text-text-muted",
                                children: (0, $7d3db79f4948d211$export$406d290c065fb197)(range, preset)
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("details", {
                                className: "mt-1",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("summary", {
                                        className: "cursor-pointer text-xs text-text-muted hover:text-text",
                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.conventions
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                        className: "mt-1 rounded border border-border bg-surface p-3 text-xs text-text-muted",
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                                className: "mb-1",
                                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.conventionsHint
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
                                                className: "list-disc space-y-1 pe-4",
                                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.conventionsList.map((line)=>/*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                                                        children: line
                                                    }, line))
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                                className: "mt-2 font-mono",
                                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.conventionsSource
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                        className: "flex flex-wrap items-center gap-1",
                        children: (0, $7d3db79f4948d211$export$9265403940be6b4).map((p)=>/*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                                type: "button",
                                onClick: ()=>applyPreset(p),
                                "aria-pressed": preset === p,
                                className: `rounded-full border px-3 py-1 text-xs ${preset === p ? 'border-primary bg-primary text-primary-contrast' : 'border-border text-text-muted hover:bg-surface-hover'}`,
                                children: $da893dccebb0c931$var$PRESET_LABELS[p]
                            }, p))
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("label", {
                        className: "flex items-center gap-2 text-xs text-text-muted",
                        children: [
                            (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.bucket,
                            /*#__PURE__*/ (0, $2M70Q.jsx)("select", {
                                value: bucket,
                                onChange: (e)=>setBucket(e.target.value),
                                className: "h-control rounded border border-border bg-bg px-2 text-xs",
                                children: Object.entries($da893dccebb0c931$var$BUCKET_LABELS).map(([value, label])=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                        value: value,
                                        children: label
                                    }, value))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "ghost",
                        onClick: ()=>refetch(),
                        "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.refresh,
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $jqtUP.default), {
                                size: 14,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.refresh
                        ]
                    })
                ]
            }),
            isStale && /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "rounded border border-warning bg-warning-subtle p-3 text-sm text-text",
                children: [
                    (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.staleWarning,
                    ' ',
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8B9Zg.Link), {
                        to: "/settings/system",
                        className: "text-primary hover:underline",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.title
                    })
                ]
            }),
            loading && !data && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {}),
            error && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$fddf379e22a74b00), {
                title: error.message
            }),
            data && sections.map((section)=>{
                const cards = [
                    ...section.scalars,
                    ...section.distributions
                ];
                return /*#__PURE__*/ (0, $2M70Q.jsxs)($da893dccebb0c931$var$Section, {
                    id: section.id,
                    count: cards.length,
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                            className: "grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3",
                            children: [
                                section.scalars.map((name)=>{
                                    const metric = byName.get(name);
                                    const err = errors.get(name);
                                    if (!metric && !err) return null;
                                    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $0fa68d3d098ea8a4$export$8b799af4f3123f30), {
                                        metric: metric,
                                        error: err,
                                        onDrillDown: metric ? openDrill : undefined
                                    }, name);
                                }),
                                section.distributions.map((name)=>{
                                    const metric = byName.get(name);
                                    const err = errors.get(name);
                                    if (err) return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $0fa68d3d098ea8a4$export$8b799af4f3123f30), {
                                        error: err
                                    }, name);
                                    if (!metric) return null;
                                    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f712af9a8f4f5e89$export$8c9185ab3d8f0582), {
                                        metric: metric,
                                        onDrillDown: openDrill
                                    }, name);
                                })
                            ]
                        }),
                        section.cohort && byName.get(section.cohort) && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
                            className: "p-2",
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)("h3", {
                                    className: "p-2 text-sm font-medium text-text",
                                    children: byName.get(section.cohort).definition.titleFa
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2155312196e86c4e$export$83b34e3e0dae0bfd), {
                                    metric: byName.get(section.cohort)
                                })
                            ]
                        })
                    ]
                }, section.id);
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)($da893dccebb0c931$var$DrillDownDialog, {
                drill: drill,
                filter: filter,
                onClose: ()=>setDrill(null)
            })
        ]
    });
}
/**
 * The contacts behind a number.
 *
 * The ids come from analytics, which holds no names; the names are composed in
 * the BFF through the CRM loader. This dialog is where that composition
 * becomes visible to a user, and it is the reason the drill-down exists at
 * all: «۱۲ مخاطب ریزش کردند» without a list is a fact nobody can act on.
 */ function $da893dccebb0c931$var$DrillDownDialog({ drill: drill, filter: filter, onClose: onClose }) {
    const { data: data, loading: loading } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $c0a10c62685d2613$export$f24c3e189ef0415a), {
        variables: {
            metric: drill?.metric,
            key: drill?.key ?? '',
            filter: filter,
            limit: 100
        },
        skip: !drill
    });
    if (!drill) return null;
    const result = data?.metricDrillDown;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: true,
        onOpenChange: onClose,
        title: `${(0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.drillDownTitle} \u{2014} ${drill.title}`,
        wide: true,
        children: [
            loading && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {}),
            result && result.contacts.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$fddf379e22a74b00), {
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.drillDownEmpty
            }),
            result && result.contacts.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                        className: "pb-2 text-xs text-text-muted",
                        children: [
                            (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.showing,
                            " ",
                            (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(result.contacts.length),
                            " ",
                            (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.of,
                            ' ',
                            (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(result.total)
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
                        className: "flex flex-col divide-y divide-border",
                        children: result.contacts.map((c)=>/*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                                className: "py-2",
                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $8B9Zg.Link), {
                                    to: `/contacts/${c.id}`,
                                    className: "flex items-center justify-between gap-2 hover:underline",
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                            className: "text-sm text-text",
                                            children: c.displayName
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                            className: "text-xs text-text-muted",
                                            dir: "ltr",
                                            children: c.primaryPhoneE164 ? (0, $d4d460d3ffb6daab$export$e9cf274fc1035ec4)(c.primaryPhoneE164) : ''
                                        })
                                    ]
                                })
                            }, c.id))
                    })
                ]
            })
        ]
    });
}


/**
 * Contact lookup, MOBILE — the second and last mobile reduction.
 *
 * WHY THIS FLOW. A rep standing in a corridor needs to answer "what was that
 * doctor's number" and then call them. That is a search box, a list, and two
 * buttons — and on a phone it is a better experience than the desktop table
 * could ever be, which is the test for whether a mobile variant is worth
 * having at all.
 *
 * It uses the SAME `searchContacts` query the workbench uses, with the same
 * filter shape. No mobile-only endpoint, no mobile-only field: a second query
 * would be a second definition of what "matching" means, and Persian digit
 * folding is exactly the kind of thing that would then be right in one place
 * and wrong in the other.
 *
 * **The deep links are the point.** `tel:` and `https://wa.me/…` hand the
 * number to the phone's own dialer and WhatsApp app. MeshHub sends nothing:
 * this is not the messaging service, no message is recorded, and no opt-out is
 * consulted — because the rep is placing a call, not the system sending a
 * broadcast. Conflating the two would put an unlogged, unsuppressed send into
 * the one surface that has no suppression chain.
 */ 
var $2M70Q = parcelRequire("2M70Q");



var $hZu6m = parcelRequire("hZu6m");
var $619y7 = parcelRequire("619y7");
var $6PxCH = parcelRequire("6PxCH");
var $8PPl0 = parcelRequire("8PPl0");

var $3OyDL = parcelRequire("3OyDL");
/**
 * Quick-add, MOBILE — the first and only mobile variant in MeshHub, and a
 * REDUCTION of `QuickAdd.web.jsx` rather than a fork.
 *
 * WHY THIS ONE FLOW AND NOT THE APP. Exhibitions happen on phones. A rep at a
 * congress has a doctor in front of them and thirty seconds, and asking them
 * to find a laptop is asking them not to record the contact. Everything else —
 * the calendar, campaigns, the dashboard — is desk work that a phone would
 * make worse, so on mobile those routes render the desktop layout unchanged
 * and the user pinches to zoom, which is honest.
 *
 * WHAT "REDUCTION" MEANS HERE, concretely:
 *
 *   * the payload comes from `useQuickAdd`, the SAME hook the desktop dialog
 *     uses. `tests/mobile.test.jsx` asserts a narrow viewport submits exactly
 *     what the desktop one does;
 *   * it is a full-screen sheet rather than a centred dialog, because a modal
 *     with a backdrop on a phone-width screen leaves a form barely wider than
 *     its own padding;
 *   * the field-of-work select and the channel checkboxes are BELOW the fold,
 *     under a disclosure. Surname and phone are what a rep types while talking;
 *   * touch targets use the token control height, which is already large
 *     enough — nothing new was invented for mobile.
 *
 * Nothing is REMOVED that the desktop form can do. A reduction that dropped a
 * field would make the two produce different contacts, which is the failure
 * this file's whole structure exists to prevent.
 */ 
var $2M70Q = parcelRequire("2M70Q");


var $9ZCAD = parcelRequire("9ZCAD");
var $gcf4m = parcelRequire("gcf4m");
var $bi4P4 = parcelRequire("bi4P4");

var $3OyDL = parcelRequire("3OyDL");

/**
 * Quick-add's state, validation and submit — the logic BOTH variants share.
 *
 * WHY THIS HOOK EXISTS. The doctrine says a `.mobile.jsx` is a *reduction* of
 * the web variant and never a fork (CLAUDE.md §12). That is easy to say and
 * easy to violate: the natural way to write a mobile screen is to copy the
 * desktop one and delete things, and three months later the two build slightly
 * different payloads and only one of them sets the interaction type.
 *
 * So the payload is built HERE, once. Both variants render different markup
 * over the same hook, and `tests/mobile.test.jsx` asserts that a narrow
 * viewport submits byte-for-byte what the desktop dialog submits. The variants
 * differ in layout and in nothing else.
 */ 

var $3OyDL = parcelRequire("3OyDL");




const $e4a7b3005db96355$export$d7fdce0ed354b60b = {
    firstName: '',
    lastName: '',
    phone: '',
    channels: [],
    fieldOfWorkId: '',
    note: '',
    // The product this contact is interested in. Applied with `setInterests`
    // after the create, because interests are their own relation rather than a
    // column — the same mutation the profile's interests panel uses, so there is
    // one way a product interest gets recorded.
    productId: '',
    // The CRM profile fields, behind a disclosure in both variants. One object,
    // one payload builder, shared with the edit form.
    ...(0, $d3b76cf2615e480d$export$6bee59b7d92f98d6)
};
function $e4a7b3005db96355$export$11a5163cdfa605d7({ open: open, onCreated: onCreated, onDone: onDone }) {
    const [form, setForm] = (0, $3OyDL.useState)($e4a7b3005db96355$export$d7fdce0ed354b60b);
    const [error, setError] = (0, $3OyDL.useState)(null);
    const [justAdded, setJustAdded] = (0, $3OyDL.useState)(null);
    const lastNameRef = (0, $3OyDL.useRef)(null);
    const { data: channelData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$d2d584f4325fcf08), {
        variables: {
            kind: 'COMMUNICATION_CHANNEL',
            includeInactive: false
        },
        skip: !open
    });
    // FIELD_OF_WORK and PRODUCT are deliberately NOT fetched here: both are
    // rendered by `LookupField`, which owns its own query so it can also CREATE
    // a missing option. Fetching them here as well would be the same request
    // twice per open — and, in a test, two consumers racing one mock.
    const { data: typeData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$d2d584f4325fcf08), {
        variables: {
            kind: 'INTERACTION_TYPE',
            includeInactive: false
        },
        skip: !open
    });
    // Needed by `submit` to apply the center-name rule before the round trip, so
    // it is read here rather than only inside ContactCrmFields.
    const { data: facilityTypeData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$d2d584f4325fcf08), {
        variables: {
            kind: 'FACILITY_TYPE',
            includeInactive: false
        },
        skip: !open
    });
    const [createContact, { loading: creating }] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$fe262e7837b23f20));
    const [recordInteraction] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$b21d8737225985c0));
    const [setInterests] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$592dd87ffcd0d16a));
    const channels = channelData?.lookups ?? [];
    const facilityTypes = facilityTypeData?.lookups ?? [];
    // "The seeded default" for the note's interaction type: the first active
    // INTERACTION_TYPE in the deployment's own sort order. No code names a type —
    // that would be a Parsina value in app code (CLAUDE.md §1).
    const defaultType = (typeData?.lookups ?? [])[0];
    (0, $3OyDL.useEffect)(()=>{
        if (!open) {
            setForm($e4a7b3005db96355$export$d7fdce0ed354b60b);
            setError(null);
            setJustAdded(null);
        }
    }, [
        open
    ]);
    const set = (0, $3OyDL.useCallback)((patch)=>setForm((current)=>({
                ...current,
                ...patch
            })), []);
    const toggleChannel = (0, $3OyDL.useCallback)((code)=>setForm((current)=>({
                ...current,
                channels: current.channels.includes(code) ? current.channels.filter((c)=>c !== code) : [
                    ...current.channels,
                    code
                ]
            })), []);
    /**
   * The contact payload. Exported so a test can assert the two variants agree
   * without going through Apollo — the assertion that matters is about this
   * object, not about which button was pressed.
   */ const buildInput = (0, $3OyDL.useCallback)((current = form)=>({
            kind: 'PERSON',
            firstName: current.firstName.trim() || null,
            lastName: current.lastName.trim(),
            fieldOfWorkId: current.fieldOfWorkId || null,
            // Exactly the slice the edit form sends, from exactly the same builder.
            ...(0, $d3b76cf2615e480d$export$ebc5546235840192)(current),
            phoneNumbers: (0, $d4d460d3ffb6daab$export$365a38b4fc2bed91)(current.phone).trim() ? [
                {
                    // Digits are normalized at the EDGE: `number_raw` preserves the
                    // formatting a user typed, not the digit glyphs, and Persian
                    // digits stored there make the number unfindable (CLAUDE.md §15).
                    numberRaw: (0, $d4d460d3ffb6daab$export$365a38b4fc2bed91)(current.phone).trim(),
                    isPrimary: true,
                    channelCodes: current.channels
                }
            ] : []
        }), [
        form
    ]);
    const submit = (0, $3OyDL.useCallback)(async ({ keepOpen: keepOpen })=>{
        if (!form.lastName.trim()) {
            setError(new Error((0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.lastNameRequired));
            return null;
        }
        // The server refuses this too; refusing here saves a round trip and
        // names the field. Reads the chosen vocabulary row's own flag — no code
        // in this file knows what a clinic is.
        const centerError = (0, $d3b76cf2615e480d$export$f0f0ae48cc65aad6)(form, facilityTypes);
        if (centerError) {
            setError(new Error(centerError));
            return null;
        }
        setError(null);
        try {
            const { data: data } = await createContact({
                variables: {
                    input: buildInput()
                }
            });
            const contact = data.createContact;
            // A product interest is a relation, so it is a second call — the same
            // trade quick-add already makes for the note, and for the same reason:
            // a "create a contact and maybe an interest" special case in the
            // domain would be worse than a few milliseconds on a form that takes
            // twenty seconds to fill.
            if (form.productId) await setInterests({
                variables: {
                    contactId: contact.id,
                    productIds: [
                        form.productId
                    ]
                }
            });
            const note = form.note.trim();
            if (note && defaultType) await recordInteraction({
                variables: {
                    input: {
                        contactId: contact.id,
                        typeId: defaultType.id,
                        occurredAt: new Date().toISOString(),
                        description: note,
                        status: 'DONE'
                    }
                }
            });
            onCreated?.(contact);
            if (keepOpen) {
                setForm($e4a7b3005db96355$export$d7fdce0ed354b60b);
                // The CONTACT, not just its name: the success banner offers to
                // message the person who was just added, and that needs an id.
                setJustAdded(contact);
                lastNameRef.current?.focus();
            } else onDone?.();
            return contact;
        } catch (err) {
            setError(err);
            return null;
        }
    }, [
        form,
        buildInput,
        createContact,
        recordInteraction,
        setInterests,
        facilityTypes,
        defaultType,
        onCreated,
        onDone
    ]);
    return {
        form: form,
        set: set,
        toggleChannel: toggleChannel,
        submit: submit,
        buildInput: buildInput,
        error: error,
        justAdded: justAdded,
        creating: creating,
        channels: channels,
        facilityTypes: facilityTypes,
        defaultType: defaultType,
        lastNameRef: lastNameRef
    };
}




function $482d7f91af9454ec$export$a41cf941a3f713df({ open: open, onOpenChange: onOpenChange, onCreated: onCreated }) {
    const [showMore, setShowMore] = (0, $3OyDL.useState)(false);
    const { form: form, set: set, toggleChannel: toggleChannel, submit: submit, error: error, justAdded: justAdded, creating: creating, channels: channels, facilityTypes: facilityTypes, defaultType: defaultType, lastNameRef: lastNameRef } = (0, $e4a7b3005db96355$export$11a5163cdfa605d7)({
        open: open,
        onCreated: onCreated,
        onDone: ()=>onOpenChange(false)
    });
    if (!open) return null;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        dir: "rtl",
        role: "dialog",
        "aria-modal": "true",
        "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.title,
        // FULL SCREEN. A centred modal on a phone leaves a form barely wider
        // than the backdrop's own padding.
        className: "fixed inset-0 z-50 flex flex-col bg-bg",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("header", {
                className: "flex items-center gap-2 border-b border-border p-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h1", {
                        className: "flex-1 text-base font-bold text-text",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.title
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                        type: "button",
                        onClick: ()=>onOpenChange(false),
                        "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).app.cancel,
                        className: "h-control w-control rounded text-text-muted",
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $bi4P4.default), {
                            size: 18,
                            "aria-hidden": "true"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("form", {
                className: "flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto p-3",
                onSubmit: (e)=>{
                    e.preventDefault();
                    submit({
                        keepOpen: false
                    });
                },
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                        error: error
                    }),
                    justAdded && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                        role: "status",
                        className: "rounded border border-success px-3 py-2 text-sm text-success",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.added(justAdded.displayName)
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                        ref: lastNameRef,
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.lastName,
                        value: form.lastName,
                        onChange: (e)=>set({
                                lastName: e.target.value
                            }),
                        required: true,
                        autoFocus: true
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.firstName,
                        value: form.firstName,
                        onChange: (e)=>set({
                                firstName: e.target.value
                            })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.phone,
                        value: form.phone,
                        onChange: (e)=>set({
                                phone: e.target.value
                            }),
                        // `tel` brings up the numeric keypad. `dir=ltr` because an RTL
                        // context reorders a phone number, which is the same rule the
                        // desktop form follows (CLAUDE.md §12).
                        type: "tel",
                        inputMode: "tel",
                        dir: "ltr"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$f5c9f3c2c4054eec), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.note,
                        hint: defaultType ? (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.noteBecomesInteraction : undefined,
                        value: form.note,
                        onChange: (e)=>set({
                                note: e.target.value
                            }),
                        rows: 3
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("button", {
                        type: "button",
                        onClick: ()=>setShowMore((v)=>!v),
                        "aria-expanded": showMore,
                        className: "flex items-center gap-2 text-start text-sm text-text-muted",
                        children: [
                            showMore ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $gcf4m.default), {
                                size: 14,
                                "aria-hidden": "true"
                            }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9ZCAD.default), {
                                size: 14,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.more
                        ]
                    }),
                    showMore && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d3b76cf2615e480d$export$f9cad722f60dcf76), {
                                kind: "FIELD_OF_WORK",
                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.fieldOfWork,
                                value: form.fieldOfWorkId,
                                onChange: (id)=>set({
                                        fieldOfWorkId: id
                                    })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("fieldset", {
                                className: "flex flex-wrap gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("legend", {
                                        className: "pb-1 text-sm text-text-muted",
                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.channels
                                    }),
                                    channels.map((c)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$94195a47b94ed396), {
                                            label: c.labelFa,
                                            checked: form.channels.includes(c.code),
                                            onChange: ()=>toggleChannel(c.code)
                                        }, c.id))
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d3b76cf2615e480d$export$f9cad722f60dcf76), {
                                kind: "PRODUCT",
                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.product,
                                value: form.productId,
                                onChange: (id)=>set({
                                        productId: id
                                    })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d3b76cf2615e480d$export$6a9747c59f9c0f7e), {
                                values: form,
                                onChange: set,
                                facilityTypes: facilityTypes
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("footer", {
                className: "flex gap-2 border-t border-border p-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "primary",
                        className: "flex-1",
                        disabled: creating,
                        onClick: ()=>submit({
                                keepOpen: false
                            }),
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.submit
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        className: "flex-1",
                        disabled: creating,
                        onClick: ()=>submit({
                                keepOpen: true
                            }),
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.submitAndAnother
                    })
                ]
            })
        ]
    });
}





/**
 * A number for `wa.me`, which wants digits only — no `+`, no separators.
 *
 * Returns null rather than a broken link when there is no number: a WhatsApp
 * button that opens an empty chat is worse than no button.
 */ function $f696f03a05e1f5bc$var$whatsappHref(e164) {
    if (!e164) return null;
    const digits = String(e164).replace(/\D/g, '');
    return digits ? `https://wa.me/${digits}` : null;
}
function $f696f03a05e1f5bc$export$f0815673d0dbc6e9() {
    const [term, setTerm] = (0, $3OyDL.useState)('');
    const [addOpen, setAddOpen] = (0, $3OyDL.useState)(false);
    // Deferred rather than debounced: the workbench debounces its query
    // variables, and on a phone the list is short enough that React's own
    // deferral gives a smoother keystroke without a second timing mechanism.
    const deferred = (0, $3OyDL.useDeferredValue)(term);
    const { data: data, loading: loading } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $047171b3f4119885$export$3b9cdff68986504e), {
        variables: {
            filter: deferred.trim() ? {
                term: deferred.trim()
            } : {},
            page: 1,
            pageSize: 25,
            withFacets: false
        },
        skip: !deferred.trim()
    });
    const items = data?.searchContacts?.items ?? [];
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        dir: "rtl",
        className: "flex h-screen flex-col bg-bg",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("header", {
                className: "flex items-center gap-2 border-b border-border p-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "relative flex-1",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8PPl0.default), {
                                size: 16,
                                className: "absolute inset-y-0 end-3 my-auto text-text-muted",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                                value: term,
                                onChange: (e)=>setTerm(e.target.value),
                                placeholder: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.searchPlaceholder,
                                "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.searchLabel,
                                // `search` rather than `text`: iOS gives a clear button and a
                                // "Search" key on the keyboard for free.
                                type: "search",
                                autoFocus: true,
                                className: "h-control w-full rounded border border-border bg-surface px-3 pe-9 text-base outline-none focus:border-primary"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                        type: "button",
                        onClick: ()=>setAddOpen(true),
                        "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.open,
                        className: "h-control w-control rounded bg-primary text-primary-contrast",
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                            size: 18,
                            "aria-hidden": "true"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("main", {
                className: "min-h-0 flex-1 overflow-y-auto",
                children: [
                    loading && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {}),
                    !loading && deferred.trim() && items.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$fddf379e22a74b00), {
                        title: (0, $d916753b57975e04$export$25ce5a424b770e84).app.notFound,
                        hint: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.emptyHint
                    }),
                    !deferred.trim() && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$fddf379e22a74b00), {
                        title: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.searchPlaceholder
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
                        className: "flex flex-col divide-y divide-border",
                        children: items.map((contact)=>{
                            const wa = $f696f03a05e1f5bc$var$whatsappHref(contact.primaryPhoneE164);
                            return /*#__PURE__*/ (0, $2M70Q.jsxs)("li", {
                                className: "flex items-center gap-2 p-3",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                        className: "min-w-0 flex-1",
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                                className: "truncate text-base text-text",
                                                children: contact.displayName
                                            }),
                                            contact.primaryPhone && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                                className: "text-sm text-text-muted",
                                                dir: "ltr",
                                                children: (0, $d4d460d3ffb6daab$export$e9cf274fc1035ec4)(contact.primaryPhone)
                                            })
                                        ]
                                    }),
                                    contact.primaryPhoneE164 && /*#__PURE__*/ (0, $2M70Q.jsx)("a", {
                                        href: `tel:${contact.primaryPhoneE164}`,
                                        "aria-label": `${(0, $d916753b57975e04$export$25ce5a424b770e84).mobile.call} ${contact.displayName}`,
                                        className: "flex h-control w-control items-center justify-center rounded border border-border text-primary",
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $619y7.default), {
                                            size: 18,
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    wa && /*#__PURE__*/ (0, $2M70Q.jsx)("a", {
                                        href: wa,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        "aria-label": `${(0, $d916753b57975e04$export$25ce5a424b770e84).mobile.whatsapp} ${contact.displayName}`,
                                        className: "flex h-control w-control items-center justify-center rounded border border-border text-success",
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $hZu6m.default), {
                                            size: 18,
                                            "aria-hidden": "true"
                                        })
                                    })
                                ]
                            }, contact.id);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $482d7f91af9454ec$export$a41cf941a3f713df), {
                open: addOpen,
                onOpenChange: setAddOpen
            })
        ]
    });
}


/**
 * Which layout to render: desktop, or one of the two mobile reductions.
 *
 * The breakpoint itself lives in `constants/density.js`, which is the only
 * place in the app allowed to hold a pixel value — a breakpoint is a density
 * decision, and the doctrine check enforces that (CLAUDE.md §12).
 *
 * A media query rather than `window.innerWidth` read once, because a rotated
 * phone must re-render and a resized window is how anybody tests this.
 */ 
var $3OyDL = parcelRequire("3OyDL");

const $0f92c7a8ccedf081$export$18de7db3b0bad892 = (0, $370d2fd34ead4cb4$export$dcc4079bc63af6b8);
function $0f92c7a8ccedf081$export$2b96349243a56116() {
    const [isMobile, setIsMobile] = (0, $3OyDL.useState)(()=>typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia($0f92c7a8ccedf081$export$18de7db3b0bad892).matches : false);
    (0, $3OyDL.useEffect)(()=>{
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
        const mql = window.matchMedia($0f92c7a8ccedf081$export$18de7db3b0bad892);
        const onChange = (event)=>setIsMobile(event.matches);
        // `addEventListener` with an `addListener` fallback: Safari before 14
        // only has the deprecated form, and a rep's phone is exactly where an old
        // Safari turns up.
        if (mql.addEventListener) mql.addEventListener('change', onChange);
        else mql.addListener(onChange);
        setIsMobile(mql.matches);
        return ()=>{
            if (mql.removeEventListener) mql.removeEventListener('change', onChange);
            else mql.removeListener(onChange);
        };
    }, []);
    return isMobile;
}


/**
 * The contacts screen — a search WORKBENCH as of Step 5.
 *
 * Three things changed from the Step 3 table, and each is a different idea:
 *
 * 1. **Filter state lives in the URL** (`src/lib/filters.js`). A filtered view
 *    is something people send each other, and the back button should undo a
 *    drill-down. It also means the CSV export and campaign creation take the
 *    same filter object the table is showing — not a re-derivation of it.
 *
 * 2. **"Select all matching (N)" sends the FILTER, not ids.** The client never
 *    held those 4,812 ids; it only ever saw one page. The server re-resolves
 *    and refuses above the cap.
 *
 * 3. **Facet counts** beside every option, which is what makes a filter panel
 *    worth more than a search box: you can see what is there before clicking.
 *
 * Dense by doctrine, as before: the results body is the only scroll region.
 */ 
var $2M70Q = parcelRequire("2M70Q");


/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $fd6556f9b67f337f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 15V3",
            key: "m9g1x1"
        }
    ],
    [
        "path",
        {
            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
            key: "ih7n3h"
        }
    ],
    [
        "path",
        {
            d: "m7 10 5 5 5-5",
            key: "brsn70"
        }
    ]
];
const $fd6556f9b67f337f$export$2e2bcd8739ae039 = (0, $djixo.default)("download", $fd6556f9b67f337f$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $95214ae28e44529c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z",
            key: "sc7q7i"
        }
    ]
];
const $95214ae28e44529c$export$2e2bcd8739ae039 = (0, $djixo.default)("funnel", $95214ae28e44529c$export$3efd853dbb351e94);


var $7k3Wx = parcelRequire("7k3Wx");
var $6PxCH = parcelRequire("6PxCH");

var $3OyDL = parcelRequire("3OyDL");

var $8B9Zg = parcelRequire("8B9Zg");
/**
 * The bulk action bar.
 *
 * IT APPEARS ONLY WHEN SOMETHING IS SELECTED, and the first thing it offers is
 * «انتخاب همهٔ N مورد منطبق» — because the difference between "these 25 rows"
 * and "all 4,812 matching" is the single most consequential ambiguity on this
 * screen, and a checkbox in a header cannot express it.
 *
 * When "all matching" is chosen the bar sends the FILTER downstream, never a
 * list of ids. The client never held those ids.
 */ 
var $2M70Q = parcelRequire("2M70Q");



var $aNyTM = parcelRequire("aNyTM");
var $7k3Wx = parcelRequire("7k3Wx");
var $9sIvk = parcelRequire("9sIvk");
var $bQbUH = parcelRequire("bQbUH");
var $bi4P4 = parcelRequire("bi4P4");

var $3OyDL = parcelRequire("3OyDL");




const $96a2e77fcd195696$var$PIPELINE = [
    'UNKNOWN',
    'INTERESTED',
    'CONSULTING',
    'SUBSCRIBER'
];
function $96a2e77fcd195696$export$c6b3b1c12d3baf2d({ selector: selector, selectedCount: selectedCount, totalCount: totalCount, allMatching: allMatching, bulkLimit: bulkLimit, isAdmin: isAdmin, tags: tags, sampleContact: /**
   * A contact from the current page, to preview the message AGAINST. The
   * rendered body is per person, so the dialog shows one real example rather
   * than a rendering that belongs to nobody. Undefined is fine — the dialog
   * then simply has no preview.
   */ sampleContact, onSelectAllMatching: onSelectAllMatching, onClear: onClear, onDone: onDone }) {
    const [message, setMessage] = (0, $3OyDL.useState)(null);
    const [error, setError] = (0, $3OyDL.useState)(null);
    const [mode, setMode] = (0, $3OyDL.useState)(null); // 'tag' | 'untag' | 'status'
    const [statusReason, setStatusReason] = (0, $3OyDL.useState)('');
    const [sending, setSending] = (0, $3OyDL.useState)(false);
    const [bulkTag, tagState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$878d5942ff911a0b));
    const [bulkUntag, untagState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$86079382de63686a));
    const [bulkStatus, statusState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$ba2e208fd7624519));
    const busy = tagState.loading || untagState.loading || statusState.loading;
    const run = async (fn)=>{
        setError(null);
        setMessage(null);
        try {
            const result = await fn();
            const payload = Object.values(result.data ?? {})[0];
            setMessage((0, $d916753b57975e04$export$25ce5a424b770e84).search.bulkDone.replace('{n}', (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(payload?.affected ?? 0)));
            setMode(null);
            onDone();
        } catch (err) {
            // The server's own words. It refuses above the cap with the real number
            // in the message, and paraphrasing that would lose it.
            setError(err.message);
        }
    };
    const overLimit = allMatching && totalCount > bulkLimit;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex shrink-0 flex-col gap-2 border-b border-border bg-surface-hover px-6 py-2",
        role: "region",
        "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).search.selectedCount.replace('{n}', (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(selectedCount)),
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex flex-wrap items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-sm font-medium",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).search.selectedCount.replace('{n}', (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(selectedCount))
                    }),
                    !allMatching && totalCount > selectedCount && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "ghost",
                        onClick: onSelectAllMatching,
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).search.selectAllMatching.replace('{n}', (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(totalCount))
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        onClick: ()=>setMode(mode === 'tag' ? null : 'tag'),
                        disabled: busy,
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9sIvk.default), {
                                size: 13,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).search.bulkTag
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        onClick: ()=>setMode(mode === 'untag' ? null : 'untag'),
                        disabled: busy,
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).search.bulkUntag
                    }),
                    isAdmin && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        onClick: ()=>setMode(mode === 'status' ? null : 'status'),
                        disabled: busy,
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $bQbUH.default), {
                                size: 13,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).search.bulkStatus
                        ]
                    }),
                    isAdmin && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        onClick: ()=>setSending(true),
                        disabled: busy || overLimit,
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $7k3Wx.default), {
                                size: 13,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.bulkSend
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "ghost",
                        className: "ms-auto",
                        onClick: onClear,
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $bi4P4.default), {
                                size: 13,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).search.clearSelection
                        ]
                    })
                ]
            }),
            overLimit && /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                className: "text-sm text-warning",
                children: [
                    (0, $d916753b57975e04$export$25ce5a424b770e84).search.bulkTooLarge,
                    " (",
                    (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(totalCount),
                    " / ",
                    (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(bulkLimit),
                    ")"
                ]
            }),
            mode === 'tag' || mode === 'untag' ? /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: "flex flex-wrap items-center gap-2",
                children: tags.map((tag)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        disabled: busy,
                        onClick: ()=>run(()=>(mode === 'tag' ? bulkTag : bulkUntag)({
                                    variables: {
                                        selector: selector,
                                        tagId: tag.id
                                    }
                                })),
                        children: tag.name
                    }, tag.id))
            }) : null,
            mode === 'status' && /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex flex-wrap items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                        value: statusReason,
                        onChange: (event)=>setStatusReason(event.target.value),
                        placeholder: (0, $d916753b57975e04$export$25ce5a424b770e84).status.reasonOptional,
                        className: "h-control w-72 rounded border border-border bg-bg px-3 text-sm outline-none focus:border-primary"
                    }),
                    $96a2e77fcd195696$var$PIPELINE.map((status)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                            disabled: busy,
                            onClick: ()=>run(()=>bulkStatus({
                                        variables: {
                                            selector: selector,
                                            toStatus: status,
                                            reason: statusReason || null
                                        }
                                    })),
                            children: (0, $d4d460d3ffb6daab$export$3c3cfc169bd4703d)[status]
                        }, status)),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-xs text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).status.reasonRequiredBackward
                    })
                ]
            }),
            isAdmin && sending && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-xs text-text-muted",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.bulkSendHint
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d044b66b3f88fefb$export$59cc7642dbe0bf15), {
                open: sending,
                onOpenChange: setSending,
                selector: selector,
                recipientCount: selectedCount,
                sampleContact: sampleContact,
                onSent: ()=>{
                    setMessage((0, $d916753b57975e04$export$25ce5a424b770e84).messaging.bulkSendQueued);
                    onDone();
                }
            }),
            message && /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                className: "flex items-center gap-1 text-sm text-success",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $aNyTM.default), {
                        size: 13,
                        "aria-hidden": "true"
                    }),
                    message
                ]
            }),
            error && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-sm text-danger",
                children: error
            })
        ]
    });
}


/**
 * The workbench's filter panel.
 *
 * FACET COUNTS BESIDE EVERY OPTION, which is the whole reason this is not a
 * row of chips. The point of a filter panel over a search box is that you can
 * see what is there before you click: «مشترک (۱۲)» tells you whether the next
 * click is worth making, and an option showing (۰) tells you not to bother.
 *
 * The specialty list is FLAT with indentation rather than a collapsible tree.
 * Picking a parent already includes its children server-side, so a tree would
 * add a disclosure control that changes nothing about the answer.
 */ 
var $2M70Q = parcelRequire("2M70Q");


var $9ZCAD = parcelRequire("9ZCAD");
var $gcf4m = parcelRequire("gcf4m");
var $bi4P4 = parcelRequire("bi4P4");

var $3OyDL = parcelRequire("3OyDL");




/**
 * The search filter's URL round trip.
 *
 * WHY THE URL AT ALL: a filtered view is something people send each other.
 * «این لیست رو ببین» with a link that opens the same twelve contacts is worth
 * more than any amount of in-app state, and it also makes the browser's back
 * button do the obvious thing after a drill-down.
 *
 * ONE MODULE, because the round trip has to be exact in both directions and
 * there are four callers: the workbench reads it on mount, writes it on every
 * change, hands it to the CSV route, and hands it to campaign creation. Four
 * ad-hoc serializers is how the export ends up covering a different set than
 * the table it was launched from.
 *
 * The shape written to the URL is the GraphQL `ContactFilterInput` shape
 * (camelCase), not the CRM's snake_case `filter_json`. That is deliberate: what
 * the client holds is what it sends, and the BFF owns the conversion. A client
 * that spoke the domain service's dialect would be a client that knows about
 * the domain service.
 */ /** The empty filter — what "no filters applied" means, in one place. */ const $64b4b7ad47ed3264$export$afe19b60928021f6 = {
    term: '',
    kinds: [],
    // NOTE: `collaborationStatuses` and `subscriptionTypes` were REMOVED from the
    // contacts filter on request. Dropped from the model and not merely from the
    // panel, deliberately: leaving the keys here would let a bookmarked URL or a
    // saved view narrow the list by a filter no control can show or clear, which
    // is the one thing this panel's design refuses to do. The underlying fields
    // are untouched everywhere else — the profile, the status history, the bulk
    // action, the analytics funnel and the messaging rules all still use them.
    fieldOfWorkIds: [],
    specialtyIds: [],
    tagIds: [],
    tagMatch: 'ANY',
    productIds: [],
    // --- the CRM profile dimensions (migration 0016) ---
    lifecycleStageIds: [],
    salesStageIds: [],
    customerHealthIds: [],
    engagementStatusIds: [],
    cityIds: [],
    facilityTypeIds: [],
    // «ارزیابی» — the tags flagged isAssessment. A separate list from `tagIds`
    // because tags OR under `tagMatch` and an assessment has to AND with them.
    assessmentTagIds: [],
    genders: [],
    referrerContactId: '',
    // TRI-STATE: null = everyone, true = «مشتری ویژه», false = «عادی». A bool
    // could not say "everyone", which is the default and the usual answer.
    isGold: null,
    createdFrom: '',
    createdTo: '',
    lastInteractionFrom: '',
    lastInteractionTo: '',
    hasNoInteractionSinceDays: null,
    affiliatedOrgId: '',
    includeDeleted: false,
    sort: 'NAME',
    sortDesc: false
};
const $64b4b7ad47ed3264$var$LIST_KEYS = [
    'kinds',
    'fieldOfWorkIds',
    'specialtyIds',
    'tagIds',
    'productIds',
    'lifecycleStageIds',
    'salesStageIds',
    'customerHealthIds',
    'engagementStatusIds',
    'cityIds',
    'facilityTypeIds',
    'assessmentTagIds',
    'genders'
];
const $64b4b7ad47ed3264$var$TEXT_KEYS = [
    'term',
    'createdFrom',
    'createdTo',
    'lastInteractionFrom',
    'lastInteractionTo',
    'affiliatedOrgId',
    'referrerContactId'
];
function $64b4b7ad47ed3264$export$7866417077914431(filter) {
    const f = {
        ...$64b4b7ad47ed3264$export$afe19b60928021f6,
        ...filter ?? {}
    };
    return !f.term.trim() && $64b4b7ad47ed3264$var$LIST_KEYS.every((key)=>(f[key] ?? []).length === 0) && $64b4b7ad47ed3264$var$TEXT_KEYS.slice(1).every((key)=>!f[key]) && !f.hasNoInteractionSinceDays && // `== null` and not falsy: «عادی» is `false`, a real selection that a
    // truthiness test would read as "not filtering".
    f.isGold == null;
}
function $64b4b7ad47ed3264$export$5f4338951a8b8d7d(filter) {
    const f = {
        ...$64b4b7ad47ed3264$export$afe19b60928021f6,
        ...filter ?? {}
    };
    let count = 0;
    if (f.term.trim()) count += 1;
    for (const key of $64b4b7ad47ed3264$var$LIST_KEYS)if ((f[key] ?? []).length > 0) count += 1;
    for (const key of $64b4b7ad47ed3264$var$TEXT_KEYS.slice(1))if (f[key]) count += 1;
    if (f.hasNoInteractionSinceDays) count += 1;
    if (f.isGold != null) count += 1;
    if (f.includeDeleted) count += 1;
    return count;
}
function $64b4b7ad47ed3264$export$498a66644341482(filter, extra = {}) {
    const f = {
        ...$64b4b7ad47ed3264$export$afe19b60928021f6,
        ...filter ?? {}
    };
    const params = new URLSearchParams();
    if (f.term.trim()) params.set('q', f.term.trim());
    for (const key of $64b4b7ad47ed3264$var$LIST_KEYS){
        const values = (f[key] ?? []).filter(Boolean);
        if (values.length) params.set(key, values.join(','));
    }
    for (const key of $64b4b7ad47ed3264$var$TEXT_KEYS.slice(1))if (f[key]) params.set(key, f[key]);
    if (f.tagMatch === 'ALL') params.set('tagMatch', 'ALL');
    if (f.hasNoInteractionSinceDays) params.set('quietDays', String(f.hasNoInteractionSinceDays));
    if (f.isGold != null) params.set('gold', f.isGold ? '1' : '0');
    if (f.includeDeleted) params.set('deleted', '1');
    if (f.sort && f.sort !== 'NAME') params.set('sort', f.sort);
    if (f.sortDesc) params.set('desc', '1');
    for (const [key, value] of Object.entries(extra))if (value !== null && value !== undefined && value !== '' && value !== 1) params.set(key, String(value));
    return params;
}
function $64b4b7ad47ed3264$export$f378acf937b01c9f(params) {
    const get = (key)=>params.get(key) ?? '';
    const list = (key)=>get(key).split(',').map((v)=>v.trim()).filter(Boolean);
    const days = Number.parseInt(get('quietDays'), 10);
    return {
        ...$64b4b7ad47ed3264$export$afe19b60928021f6,
        term: get('q'),
        ...Object.fromEntries($64b4b7ad47ed3264$var$LIST_KEYS.map((key)=>[
                key,
                list(key)
            ])),
        ...Object.fromEntries($64b4b7ad47ed3264$var$TEXT_KEYS.slice(1).map((key)=>[
                key,
                get(key)
            ])),
        tagMatch: get('tagMatch') === 'ALL' ? 'ALL' : 'ANY',
        hasNoInteractionSinceDays: Number.isFinite(days) && days > 0 ? days : null,
        // Three states from one parameter: absent, '1' and '0'. Anything else is
        // treated as absent, so a mangled link opens unfiltered rather than
        // silently filtered to «عادی».
        isGold: get('gold') === '1' ? true : get('gold') === '0' ? false : null,
        includeDeleted: get('deleted') === '1',
        sort: [
            'NAME',
            'CREATED',
            'LAST_INTERACTION',
            'STATUS'
        ].includes(get('sort')) ? get('sort') : 'NAME',
        sortDesc: get('desc') === '1'
    };
}
function $64b4b7ad47ed3264$export$209fad8e84c0fe04(filter) {
    const f = {
        ...$64b4b7ad47ed3264$export$afe19b60928021f6,
        ...filter ?? {}
    };
    const input = {};
    if (f.term.trim()) input.term = f.term.trim();
    for (const key of $64b4b7ad47ed3264$var$LIST_KEYS){
        const values = (f[key] ?? []).filter(Boolean);
        if (values.length) input[key] = values;
    }
    for (const key of $64b4b7ad47ed3264$var$TEXT_KEYS.slice(1))if (f[key]) input[key] = f[key];
    if (f.tagMatch === 'ALL') input.tagMatch = 'ALL';
    if (f.hasNoInteractionSinceDays) input.hasNoInteractionSinceDays = f.hasNoInteractionSinceDays;
    if (f.isGold != null) input.isGold = f.isGold;
    if (f.includeDeleted) input.includeDeleted = true;
    if (f.sort && f.sort !== 'NAME') input.sort = f.sort;
    if (f.sortDesc) input.sortDesc = true;
    return input;
}
/**
 * A saved view's stored JSON -> a filter.
 *
 * The server stores the CRM's snake_case shape (it re-parses and re-serializes
 * on save), so opening a saved view means translating back. The key map is
 * written out rather than derived, because a mechanical camelCase conversion
 * would silently produce `hasNoInteractionSinceDays` from
 * `has_no_interaction_since_days` and nothing else — and then quietly do the
 * wrong thing for a key that does not follow the pattern.
 */ const $64b4b7ad47ed3264$var$FROM_STORED = {
    term: 'term',
    kinds: 'kinds',
    // `collaboration_statuses` and `subscription_types` are deliberately ABSENT:
    // a saved view stored before they were removed opens without them rather
    // than applying a filter the panel cannot display (see EMPTY_FILTER).
    field_of_work_ids: 'fieldOfWorkIds',
    specialty_ids: 'specialtyIds',
    tag_ids: 'tagIds',
    tag_match: 'tagMatch',
    product_ids: 'productIds',
    lifecycle_stage_ids: 'lifecycleStageIds',
    sales_stage_ids: 'salesStageIds',
    customer_health_ids: 'customerHealthIds',
    engagement_status_ids: 'engagementStatusIds',
    city_ids: 'cityIds',
    facility_type_ids: 'facilityTypeIds',
    assessment_tag_ids: 'assessmentTagIds',
    genders: 'genders',
    referrer_contact_id: 'referrerContactId',
    is_gold: 'isGold',
    created_from: 'createdFrom',
    created_to: 'createdTo',
    last_interaction_from: 'lastInteractionFrom',
    last_interaction_to: 'lastInteractionTo',
    has_no_interaction_since_days: 'hasNoInteractionSinceDays',
    affiliated_org_id: 'affiliatedOrgId',
    include_deleted: 'includeDeleted',
    sort: 'sort',
    sort_desc: 'sortDesc'
};
function $64b4b7ad47ed3264$export$acb063342f63a374(json) {
    let stored;
    try {
        stored = typeof json === 'string' ? JSON.parse(json) : json ?? {};
    } catch  {
        // A stored view whose JSON is unreadable opens EMPTY rather than throwing:
        // a broken bookmark should not take the screen down.
        return {
            ...$64b4b7ad47ed3264$export$afe19b60928021f6
        };
    }
    const filter = {
        ...$64b4b7ad47ed3264$export$afe19b60928021f6
    };
    for (const [storedKey, key] of Object.entries($64b4b7ad47ed3264$var$FROM_STORED))if (stored[storedKey] !== undefined) filter[key] = stored[storedKey];
    // Dates arrive as full ISO timestamps; the date inputs want YYYY-MM-DD.
    for (const key of [
        'createdFrom',
        'createdTo',
        'lastInteractionFrom',
        'lastInteractionTo'
    ])if (filter[key]) filter[key] = String(filter[key]).slice(0, 10);
    return filter;
}



const $247b1b332fd40693$var$KINDS = [
    'PERSON',
    'ORGANIZATION'
];
/**
 * OTHER is offered alongside مرد and زن.
 *
 * The request named two options; the model has had three since Step 1 and the
 * contact form has always offered all three. Leaving OTHER out would make
 * every contact recorded that way unreachable through this filter — a filter
 * that hides rows is worse than one option more than was asked for.
 */ const $247b1b332fd40693$var$GENDERS = [
    'MALE',
    'FEMALE',
    'OTHER'
];
/**
 * The six vocabularies this panel filters on that the contact form also uses.
 *
 * Title comes from `S.search`, options from `lookups[kind]` — so nothing here
 * names a value, and a deployment that renames «دمو انجام شده» renames the
 * filter option with it (CLAUDE.md §1).
 */ const $247b1b332fd40693$var$VOCABULARY_SECTIONS = [
    [
        'LIFECYCLE_STAGE',
        'lifecycleStageIds',
        'lifecycleStage'
    ],
    [
        'SALES_STAGE',
        'salesStageIds',
        'salesStage'
    ],
    [
        'CUSTOMER_HEALTH',
        'customerHealthIds',
        'customerHealth'
    ],
    [
        'ENGAGEMENT_STATUS',
        'engagementStatusIds',
        'engagementStatus'
    ],
    [
        'FACILITY_TYPE',
        'facilityTypeIds',
        'facilityType'
    ],
    [
        'CITY',
        'cityIds',
        'city'
    ]
];
/** Facet lookup: kind + key -> count, built once per render. */ function $247b1b332fd40693$var$facetIndex(facets) {
    const index = new Map();
    for (const facet of facets ?? [])index.set(`${facet.kind}:${facet.key}`, facet.count);
    return index;
}
function $247b1b332fd40693$var$Section({ title: title, children: children, defaultOpen: defaultOpen = true }) {
    const [open, setOpen] = (0, $3OyDL.useState)(defaultOpen);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("section", {
        className: "border-b border-border pb-3",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("button", {
                type: "button",
                onClick: ()=>setOpen((v)=>!v),
                "aria-expanded": open,
                className: "flex w-full items-center justify-between py-2 text-sm font-medium text-text",
                children: [
                    title,
                    open ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $gcf4m.default), {
                        size: 14,
                        "aria-hidden": "true"
                    }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9ZCAD.default), {
                        size: 14,
                        "aria-hidden": "true"
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: "flex flex-col gap-1 overflow-y-auto",
                style: {
                    maxHeight: (0, $370d2fd34ead4cb4$export$ea79a652c275fff6).filterSectionMax
                },
                children: children
            })
        ]
    });
}
/**
 * «معرف» — pick one contact and see everyone they introduced.
 *
 * A search box narrowing a `<select>`, which is the shape every other contact
 * picker in this app already has (the affiliation dialog, the referrer field
 * on the contact form, the activity dialog). A fourth way to choose a contact
 * would be a fourth thing to learn.
 *
 * ONE, not a list: «who did رضا bring in» is asked about one person at a time,
 * and the filter reads as a sentence that way.
 */ function $247b1b332fd40693$var$ReferrerFilter({ value: value, onChange: onChange }) {
    const [search, setSearch] = (0, $3OyDL.useState)('');
    const { data: data, loading: loading } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$9b2e8c059cb38823), {
        variables: {
            page: 1,
            pageSize: 25,
            search: search.trim() || null
        },
        errorPolicy: 'ignore'
    });
    const candidates = data?.contacts?.items ?? [];
    // The current selection stays listed even when the search has moved past it,
    // or narrowing the box would silently clear the filter.
    const chosen = candidates.find((c)=>c.id === value);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex flex-col gap-2 px-2 pb-1",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                type: "text",
                value: search,
                onChange: (event)=>setSearch(event.target.value),
                placeholder: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.searchContact,
                "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.searchContact,
                className: "h-control rounded border border-border bg-bg px-3 text-sm outline-none focus:border-primary"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("select", {
                value: value ?? '',
                "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).search.referrer,
                onChange: (event)=>onChange(event.target.value),
                className: "h-control rounded border border-border bg-bg px-3 text-sm outline-none focus:border-primary",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: "",
                        children: loading ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.loading : (0, $d916753b57975e04$export$25ce5a424b770e84).search.referrerAny
                    }),
                    value && !chosen && /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: value,
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    candidates.map((contact)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                            value: contact.id,
                            children: contact.displayName
                        }, contact.id))
                ]
            })
        ]
    });
}
function $247b1b332fd40693$var$CheckOption({ label: label, count: count, checked: checked, onChange: onChange, indent: indent = 0 }) {
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("label", {
        className: "flex cursor-pointer items-center gap-2 rounded px-2 py-1 text-sm hover:bg-surface-hover",
        style: {
            paddingInlineStart: `calc(${indent} * var(--mh-space-4))`
        },
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                type: "checkbox",
                className: "accent-primary",
                checked: checked,
                onChange: onChange
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                className: "min-w-0 flex-1 truncate",
                children: label
            }),
            count !== undefined && /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                className: "shrink-0 text-xs text-text-muted tabular-nums",
                children: [
                    "(",
                    (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(count),
                    ")"
                ]
            })
        ]
    });
}
function $247b1b332fd40693$export$5286927812faf543({ filter: filter, onChange: onChange, facets: facets, tags: tags = [], lookups: lookups = {}, searchRef: searchRef }) {
    const counts = $247b1b332fd40693$var$facetIndex(facets);
    const assessments = tags.filter((tag)=>tag.isAssessment);
    const set = (patch)=>onChange({
            ...filter,
            ...patch
        });
    const toggle = (key, value)=>{
        const current = filter[key] ?? [];
        set({
            [key]: current.includes(value) ? current.filter((v)=>v !== value) : [
                ...current,
                value
            ]
        });
    };
    const active = (0, $64b4b7ad47ed3264$export$5f4338951a8b8d7d)(filter);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("aside", {
        className: "flex w-filters shrink-0 flex-col gap-1 overflow-y-auto border-e border-border bg-surface p-4",
        "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).search.filters,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex items-center justify-between pb-2",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("h2", {
                        className: "text-sm font-bold",
                        children: [
                            (0, $d916753b57975e04$export$25ce5a424b770e84).search.filters,
                            active > 0 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                                className: "ms-2 bg-primary text-primary-contrast",
                                children: (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(active)
                            })
                        ]
                    }),
                    active > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "ghost",
                        onClick: ()=>onChange({
                                ...(0, $64b4b7ad47ed3264$export$afe19b60928021f6)
                            }),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $bi4P4.default), {
                                size: 13,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).search.clearFilters
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("label", {
                className: "flex flex-col gap-1 pb-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-sm text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).search.term
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                        ref: searchRef,
                        value: filter.term,
                        onChange: (event)=>set({
                                term: event.target.value
                            }),
                        placeholder: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.searchPlaceholder,
                        className: "h-control rounded border border-border bg-bg px-3 text-base outline-none focus:border-primary"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-xs text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).search.termHint
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)($247b1b332fd40693$var$Section, {
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).search.kind,
                defaultOpen: false,
                children: $247b1b332fd40693$var$KINDS.map((kind)=>/*#__PURE__*/ (0, $2M70Q.jsx)($247b1b332fd40693$var$CheckOption, {
                        label: (0, $d4d460d3ffb6daab$export$dab5d6c7a52ba3f8)[kind],
                        checked: filter.kinds.includes(kind),
                        onChange: ()=>toggle('kinds', kind)
                    }, kind))
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)($247b1b332fd40693$var$Section, {
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).search.tags,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                        className: "flex gap-2 px-2 pb-1 text-xs",
                        children: [
                            'ANY',
                            'ALL'
                        ].map((mode)=>/*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                                type: "button",
                                onClick: ()=>set({
                                        tagMatch: mode
                                    }),
                                "aria-pressed": filter.tagMatch === mode,
                                className: `rounded-full border px-3 py-1 ${filter.tagMatch === mode ? 'border-primary bg-primary text-primary-contrast' : 'border-border text-text-muted'}`,
                                children: mode === 'ANY' ? (0, $d916753b57975e04$export$25ce5a424b770e84).search.tagMatchAny : (0, $d916753b57975e04$export$25ce5a424b770e84).search.tagMatchAll
                            }, mode))
                    }),
                    tags.filter((tag)=>!tag.isAssessment).map((tag)=>/*#__PURE__*/ (0, $2M70Q.jsx)($247b1b332fd40693$var$CheckOption, {
                            label: tag.name,
                            count: counts.get(`TAG:${tag.id}`) ?? 0,
                            checked: filter.tagIds.includes(tag.id),
                            onChange: ()=>toggle('tagIds', tag.id)
                        }, tag.id))
                ]
            }),
            assessments.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsx)($247b1b332fd40693$var$Section, {
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).search.assessment,
                children: assessments.map((tag)=>/*#__PURE__*/ (0, $2M70Q.jsx)($247b1b332fd40693$var$CheckOption, {
                        label: tag.name,
                        count: counts.get(`TAG:${tag.id}`) ?? 0,
                        checked: filter.assessmentTagIds.includes(tag.id),
                        onChange: ()=>toggle('assessmentTagIds', tag.id)
                    }, tag.id))
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)($247b1b332fd40693$var$Section, {
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).search.fieldOfWork,
                defaultOpen: false,
                children: (lookups.FIELD_OF_WORK ?? []).map((item)=>/*#__PURE__*/ (0, $2M70Q.jsx)($247b1b332fd40693$var$CheckOption, {
                        label: item.labelFa,
                        count: counts.get(`FIELD_OF_WORK:${item.id}`) ?? 0,
                        checked: filter.fieldOfWorkIds.includes(item.id),
                        onChange: ()=>toggle('fieldOfWorkIds', item.id)
                    }, item.id))
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)($247b1b332fd40693$var$Section, {
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).search.specialty,
                defaultOpen: false,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                        className: "px-2 pb-1 text-xs text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).search.specialtyHint
                    }),
                    (lookups.SPECIALTY ?? []).map((item)=>/*#__PURE__*/ (0, $2M70Q.jsx)($247b1b332fd40693$var$CheckOption, {
                            label: item.labelFa,
                            count: counts.get(`SPECIALTY:${item.id}`) ?? 0,
                            checked: filter.specialtyIds.includes(item.id),
                            onChange: ()=>toggle('specialtyIds', item.id),
                            indent: item.parentId ? 1 : 0
                        }, item.id))
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)($247b1b332fd40693$var$Section, {
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).search.products,
                defaultOpen: false,
                children: (lookups.PRODUCT ?? []).map((item)=>/*#__PURE__*/ (0, $2M70Q.jsx)($247b1b332fd40693$var$CheckOption, {
                        label: item.labelFa,
                        checked: filter.productIds.includes(item.id),
                        onChange: ()=>toggle('productIds', item.id)
                    }, item.id))
            }),
            $247b1b332fd40693$var$VOCABULARY_SECTIONS.map(([kind, key, title])=>/*#__PURE__*/ (0, $2M70Q.jsx)($247b1b332fd40693$var$Section, {
                    title: (0, $d916753b57975e04$export$25ce5a424b770e84).search[title],
                    defaultOpen: false,
                    children: (lookups[kind] ?? []).map((item)=>/*#__PURE__*/ (0, $2M70Q.jsx)($247b1b332fd40693$var$CheckOption, {
                            label: item.labelFa,
                            checked: (filter[key] ?? []).includes(item.id),
                            onChange: ()=>toggle(key, item.id)
                        }, item.id))
                }, kind)),
            /*#__PURE__*/ (0, $2M70Q.jsx)($247b1b332fd40693$var$Section, {
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).search.gender,
                defaultOpen: false,
                children: $247b1b332fd40693$var$GENDERS.map((gender)=>/*#__PURE__*/ (0, $2M70Q.jsx)($247b1b332fd40693$var$CheckOption, {
                        label: (0, $d4d460d3ffb6daab$export$fc6fe25248839a29)[gender],
                        checked: filter.genders.includes(gender),
                        onChange: ()=>toggle('genders', gender)
                    }, gender))
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)($247b1b332fd40693$var$Section, {
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).search.gold,
                defaultOpen: false,
                children: [
                    [
                        null,
                        (0, $d916753b57975e04$export$25ce5a424b770e84).search.goldAny
                    ],
                    [
                        true,
                        (0, $d916753b57975e04$export$25ce5a424b770e84).search.goldOnly
                    ],
                    [
                        false,
                        (0, $d916753b57975e04$export$25ce5a424b770e84).search.goldRegular
                    ]
                ].map(([value, label])=>/*#__PURE__*/ (0, $2M70Q.jsxs)("label", {
                        className: "flex cursor-pointer items-center gap-2 rounded px-2 py-1 text-sm hover:bg-surface-hover",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                                type: "radio",
                                name: "gold",
                                className: "accent-primary",
                                checked: filter.isGold === value,
                                onChange: ()=>set({
                                        isGold: value
                                    })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                className: "min-w-0 flex-1 truncate",
                                children: label
                            })
                        ]
                    }, String(value)))
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)($247b1b332fd40693$var$Section, {
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).search.referrer,
                defaultOpen: false,
                children: /*#__PURE__*/ (0, $2M70Q.jsx)($247b1b332fd40693$var$ReferrerFilter, {
                    value: filter.referrerContactId,
                    onChange: (id)=>set({
                            referrerContactId: id
                        })
                })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)($247b1b332fd40693$var$Section, {
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).search.lastInteractionRange,
                defaultOpen: false,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)($247b1b332fd40693$var$DateRange, {
                        from: filter.lastInteractionFrom,
                        to: filter.lastInteractionTo,
                        onFrom: (v)=>set({
                                lastInteractionFrom: v
                            }),
                        onTo: (v)=>set({
                                lastInteractionTo: v
                            })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("label", {
                        className: "flex flex-col gap-1 px-2 pt-2 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                className: "text-text-muted",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).search.noInteractionDays
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                                type: "number",
                                min: "1",
                                value: filter.hasNoInteractionSinceDays ?? '',
                                onChange: (event)=>set({
                                        hasNoInteractionSinceDays: event.target.value ? Number(event.target.value) : null
                                    }),
                                className: "h-control rounded border border-border bg-bg px-3 tabular-nums outline-none focus:border-primary"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)($247b1b332fd40693$var$Section, {
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).search.createdRange,
                defaultOpen: false,
                children: /*#__PURE__*/ (0, $2M70Q.jsx)($247b1b332fd40693$var$DateRange, {
                    from: filter.createdFrom,
                    to: filter.createdTo,
                    onFrom: (v)=>set({
                            createdFrom: v
                        }),
                    onTo: (v)=>set({
                            createdTo: v
                        })
                })
            })
        ]
    });
}
/**
 * A date range.
 *
 * `<input type="date">` shows the BROWSER's calendar, which under a Persian
 * locale is Jalali and under an English one is Gregorian — so what the user
 * sees depends on their machine rather than on the app. That is a known gap
 * (ui.md): the honest fix is a Jalali date picker component, and building one
 * is not what Step 5 is for. The value stored is always ISO, so nothing
 * downstream is ambiguous.
 */ function $247b1b332fd40693$var$DateRange({ from: from, to: to, onFrom: onFrom, onTo: onTo }) {
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex gap-2 px-2",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("label", {
                className: "flex flex-1 flex-col gap-1 text-sm",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.from
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                        type: "date",
                        value: from ?? '',
                        onChange: (event)=>onFrom(event.target.value),
                        className: "h-control rounded border border-border bg-bg px-2 text-sm outline-none focus:border-primary"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("label", {
                className: "flex flex-1 flex-col gap-1 text-sm",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.to
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                        type: "date",
                        value: to ?? '',
                        onChange: (event)=>onTo(event.target.value),
                        className: "h-control rounded border border-border bg-bg px-2 text-sm outline-none focus:border-primary"
                    })
                ]
            })
        ]
    });
}


/**
 * Saved views: named filters, applied with one click.
 *
 * A view stores the QUESTION, not the answer — «مشتاق اشتراک بدون تعامل ۳۰
 * روز» has to mean "as of today", which a frozen member list could not. Opening
 * one therefore re-runs the search rather than restoring rows.
 */ 
var $2M70Q = parcelRequire("2M70Q");


/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $ad7589d548a21eed$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M17 3a2 2 0 0 1 2 2v15a1 1 0 0 1-1.496.868l-4.512-2.578a2 2 0 0 0-1.984 0l-4.512 2.578A1 1 0 0 1 5 20V5a2 2 0 0 1 2-2z",
            key: "oz39mx"
        }
    ]
];
const $ad7589d548a21eed$export$2e2bcd8739ae039 = (0, $djixo.default)("bookmark", $ad7589d548a21eed$export$3efd853dbb351e94);


var $fohPo = parcelRequire("fohPo");
var $kvlXp = parcelRequire("kvlXp");

var $3OyDL = parcelRequire("3OyDL");



function $c7b435074e94e4af$export$74fb2143f0b7f082({ views: views, filter: filter, isAdmin: isAdmin, onApply: onApply, onChanged: onChanged }) {
    const [saving, setSaving] = (0, $3OyDL.useState)(false);
    const [name, setName] = (0, $3OyDL.useState)('');
    const [share, setShare] = (0, $3OyDL.useState)(false);
    const [error, setError] = (0, $3OyDL.useState)(null);
    const [createView, { loading: loading }] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$f38236151411f663));
    const [deleteView] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$c9aa14f48ff4ab57));
    const save = async ()=>{
        setError(null);
        try {
            await createView({
                variables: {
                    name: name.trim(),
                    filter: (0, $64b4b7ad47ed3264$export$209fad8e84c0fe04)(filter),
                    isShared: share
                }
            });
            setName('');
            setShare(false);
            setSaving(false);
            onChanged();
        } catch (err) {
            setError(err.message);
        }
    };
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex flex-wrap items-center gap-2 border-b border-border bg-surface px-6 py-2",
        "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).search.savedViews,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ad7589d548a21eed$export$2e2bcd8739ae039), {
                size: 14,
                "aria-hidden": "true",
                className: "text-text-muted"
            }),
            views.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                className: "text-sm text-text-muted",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).search.savedViews
            }),
            views.map((view)=>/*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsxs)("button", {
                            type: "button",
                            onClick: ()=>onApply((0, $64b4b7ad47ed3264$export$acb063342f63a374)(view.filterJson)),
                            className: "flex h-control items-center gap-1 rounded-s border border-border bg-surface px-3 text-sm hover:bg-surface-hover",
                            children: [
                                view.isShared && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $kvlXp.default), {
                                    size: 11,
                                    "aria-hidden": "true",
                                    className: "text-text-muted"
                                }),
                                view.name
                            ]
                        }),
                        !view.isSystem && /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                            type: "button",
                            title: (0, $d916753b57975e04$export$25ce5a424b770e84).search.deleteView,
                            "aria-label": `${(0, $d916753b57975e04$export$25ce5a424b770e84).search.deleteView}: ${view.name}`,
                            onClick: async ()=>{
                                await deleteView({
                                    variables: {
                                        id: view.id
                                    }
                                });
                                onChanged();
                            },
                            className: "flex h-control items-center rounded-e border border-s-0 border-border bg-surface px-2 text-text-muted hover:text-danger",
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8750d1d3edd41705$export$2e2bcd8739ae039), {
                                size: 12,
                                "aria-hidden": "true"
                            })
                        })
                    ]
                }, view.id)),
            /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: "ms-auto flex items-center gap-2",
                children: saving ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                            value: name,
                            onChange: (event)=>setName(event.target.value),
                            placeholder: (0, $d916753b57975e04$export$25ce5a424b770e84).search.saveViewName,
                            autoFocus: true,
                            className: "h-control w-56 rounded border border-border bg-bg px-3 text-sm outline-none focus:border-primary"
                        }),
                        isAdmin && /*#__PURE__*/ (0, $2M70Q.jsxs)("label", {
                            className: "flex items-center gap-1 text-xs text-text-muted",
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                                    type: "checkbox",
                                    className: "accent-primary",
                                    checked: share,
                                    onChange: (event)=>setShare(event.target.checked)
                                }),
                                (0, $d916753b57975e04$export$25ce5a424b770e84).search.shareView
                            ]
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                            variant: "primary",
                            disabled: !name.trim() || loading,
                            onClick: save,
                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.save
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                            variant: "ghost",
                            onClick: ()=>setSaving(false),
                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.cancel
                        })
                    ]
                }) : /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                    variant: "ghost",
                    // Saving "no filters" would create a view that means «همه», which
                    // the contacts screen already is.
                    disabled: (0, $64b4b7ad47ed3264$export$7866417077914431)(filter),
                    onClick: ()=>setSaving(true),
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $fohPo.default), {
                            size: 13,
                            "aria-hidden": "true"
                        }),
                        (0, $d916753b57975e04$export$25ce5a424b770e84).search.saveView
                    ]
                })
            }),
            error && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "w-full text-sm text-danger",
                children: error
            })
        ]
    });
}





/**
 * Quick-add — "exhibition mode", and the most important interaction in the app.
 *
 * The scenario it is built for: a sales rep at a congress, phone in one hand,
 * a doctor in front of them, thirty seconds before the next conversation. What
 * they actually have is a surname, a number, and something worth remembering.
 *
 * Every design decision here follows from that:
 *
 *  - **Six fields, and only one is required.** Everything else is editable
 *    later on the profile; a form that demands a first name at a congress is a
 *    form that gets abandoned.
 *  - **The note becomes the first interaction.** «کجا آشنا شدید» is the single
 *    most valuable thing captured at a stand, and asking someone to open a
 *    second screen to record it means it never gets recorded.
 *  - **"Save and add another" keeps the dialog open** and returns focus to the
 *    surname. A queue of people at a stand is the normal case, not the
 *    exception, and closing the dialog between each one is pure friction.
 *  - **Channel checkboxes, not a channel picker.** One number is usually on
 *    WhatsApp *and* Eitaa; two taps beats a multi-select.
 *
 * Two round trips, not one: createContact then recordInteraction. A combined
 * mutation would put a "create a contact and maybe an interaction" special case
 * into the domain, and the second call is a few milliseconds on a form that
 * takes twenty seconds to fill.
 */ 
var $2M70Q = parcelRequire("2M70Q");


var $9ZCAD = parcelRequire("9ZCAD");
var $gcf4m = parcelRequire("gcf4m");
var $c7uHF = parcelRequire("c7uHF");

var $3OyDL = parcelRequire("3OyDL");





function $1a57dd2069dc4761$export$69d5b40e4f0879f3({ open: open, onOpenChange: onOpenChange, onCreated: onCreated }) {
    const { form: form, set: set, toggleChannel: toggleChannel, submit: submit, error: error, justAdded: justAdded, creating: creating, channels: channels, facilityTypes: facilityTypes, defaultType: defaultType, lastNameRef: lastNameRef } = (0, $e4a7b3005db96355$export$11a5163cdfa605d7)({
        open: open,
        onCreated: onCreated,
        onDone: ()=>onOpenChange(false)
    });
    // CLOSED by default, and that is the whole point. Exhibition mode is a
    // surname, a number and thirty seconds; everything behind this disclosure is
    // for somebody filling a profile in at a desk. A reduction may hide a field
    // behind a disclosure — it may not drop one (CLAUDE.md §12), which is why
    // the mobile sheet carries the same section rather than a shorter list.
    const [showCrm, setShowCrm] = (0, $3OyDL.useState)(false);
    const [messaging, setMessaging] = (0, $3OyDL.useState)(null);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: open,
        onOpenChange: onOpenChange,
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.title,
        hint: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.hint,
        onSubmit: ()=>submit({
                keepOpen: false
            }),
        submitLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.submit,
        busy: creating,
        footer: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
            type: "button",
            onClick: ()=>submit({
                    keepOpen: true
                }),
            disabled: creating,
            children: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.submitAndAnother
        }),
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: error
            }),
            justAdded && /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                role: "status",
                className: "flex flex-wrap items-center gap-3 rounded border border-success px-4 py-2 text-base text-success",
                children: [
                    (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.added(justAdded.displayName),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        type: "button",
                        variant: "ghost",
                        onClick: ()=>setMessaging(justAdded),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c7uHF.default), {
                                size: 13,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.sendMessage
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "grid grid-cols-2 gap-4",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                        ref: lastNameRef,
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.lastName,
                        value: form.lastName,
                        onChange: (e)=>set({
                                lastName: e.target.value
                            }),
                        autoFocus: true,
                        required: true
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.firstName,
                        value: form.firstName,
                        onChange: (e)=>set({
                                firstName: e.target.value
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.phone,
                value: form.phone,
                onChange: (e)=>set({
                        phone: e.target.value
                    }),
                dir: "ltr",
                inputMode: "tel",
                // Persian digits are accepted and converted on submit, so the rep can
                // type on whichever keyboard is already open.
                placeholder: "09121234567"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("fieldset", {
                className: "flex flex-wrap gap-4",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("legend", {
                        className: "mb-2 text-sm text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.channels
                    }),
                    channels.map((channel)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$94195a47b94ed396), {
                            label: channel.labelFa,
                            checked: form.channels.includes(channel.code),
                            onChange: ()=>toggleChannel(channel.code)
                        }, channel.id))
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d3b76cf2615e480d$export$f9cad722f60dcf76), {
                kind: "FIELD_OF_WORK",
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.fieldOfWork,
                value: form.fieldOfWorkId,
                onChange: (id)=>set({
                        fieldOfWorkId: id
                    })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d3b76cf2615e480d$export$f9cad722f60dcf76), {
                kind: "PRODUCT",
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.product,
                value: form.productId,
                onChange: (id)=>set({
                        productId: id
                    })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$f5c9f3c2c4054eec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.note,
                placeholder: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.notePlaceholder,
                hint: defaultType ? (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.noteBecomesInteraction : undefined,
                rows: 3,
                value: form.note,
                onChange: (e)=>set({
                        note: e.target.value
                    })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                type: "button",
                variant: "ghost",
                className: "self-start",
                "aria-expanded": showCrm,
                onClick: ()=>setShowCrm((v)=>!v),
                children: [
                    showCrm ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $gcf4m.default), {
                        size: 14,
                        "aria-hidden": "true"
                    }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9ZCAD.default), {
                        size: 14,
                        "aria-hidden": "true"
                    }),
                    (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.crmDetails
                ]
            }),
            showCrm && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                        className: "text-xs text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.crmDetailsHint
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d3b76cf2615e480d$export$6a9747c59f9c0f7e), {
                        values: form,
                        onChange: set,
                        facilityTypes: facilityTypes
                    })
                ]
            }),
            messaging && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $d044b66b3f88fefb$export$59cc7642dbe0bf15), {
                open: true,
                onOpenChange: (next)=>!next && setMessaging(null),
                contact: messaging
            })
        ]
    });
}











function $c05a4dc07b0f294f$export$c15beb6b679ef7ed() {
    const navigate = (0, $8B9Zg.useNavigate)();
    const searchRef = (0, $3OyDL.useRef)(null);
    const { isAdmin: isAdmin } = (0, $00d5d84dffcdf8d5$export$ad0a340bf97d63d5)();
    const [params, setParams] = (0, $8B9Zg.useSearchParams)();
    // The URL is the source of truth for the filter; `draft` is what the panel
    // edits between keystrokes. One debounce, on the way OUT to the URL, so
    // typing stays instant and the address bar does not thrash.
    const urlFilter = (0, $3OyDL.useMemo)(()=>(0, $64b4b7ad47ed3264$export$f378acf937b01c9f)(params), [
        params
    ]);
    const [draft, setDraft] = (0, $3OyDL.useState)(urlFilter);
    const [page, setPage] = (0, $3OyDL.useState)(Number(params.get('page') ?? 1));
    const [showFilters, setShowFilters] = (0, $3OyDL.useState)(true);
    const [quickAddOpen, setQuickAddOpen] = (0, $3OyDL.useState)(false);
    // The CONTACTS picked, not only their ids, because a selection outlives the
    // search that found them: pick one person, search for another, pick them
    // too. The objects are what let the send dialog preview against somebody
    // who is actually selected once they have scrolled out of the result set.
    const [selected, setSelected] = (0, $3OyDL.useState)([]);
    const [allMatching, setAllMatching] = (0, $3OyDL.useState)(false);
    // True while «all matching» is being turned into a real id list (below).
    const [materialising, setMaterialising] = (0, $3OyDL.useState)(false);
    // The row whose trash icon was clicked, and a refusal from deleting it.
    const [deleting, setDeleting] = (0, $3OyDL.useState)(null);
    const [deleteError, setDeleteError] = (0, $3OyDL.useState)(null);
    const selectedIds = (0, $3OyDL.useMemo)(()=>selected.map((c)=>c.id), [
        selected
    ]);
    (0, $3OyDL.useEffect)(()=>{
        const timer = setTimeout(()=>{
            const next = (0, $64b4b7ad47ed3264$export$498a66644341482)(draft, {
                page: 1
            });
            setParams(next, {
                replace: true
            });
            setPage(1);
        }, (0, $370d2fd34ead4cb4$export$e907fe684aa8ce6c));
        return ()=>clearTimeout(timer);
    // `draft` only. Reacting to `params` too would fight the effect that wrote
    // them and loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        draft
    ]);
    (0, $ed3cc4f847deec94$export$b0ebbe7904d8d94a)('/', ()=>searchRef.current?.focus(), {
        description: (0, $d916753b57975e04$export$25ce5a424b770e84).shortcuts.actions.searchContacts,
        group: (0, $d916753b57975e04$export$25ce5a424b770e84).shortcuts.groups.contacts
    });
    (0, $ed3cc4f847deec94$export$b0ebbe7904d8d94a)('n', ()=>setQuickAddOpen(true), {
        description: (0, $d916753b57975e04$export$25ce5a424b770e84).shortcuts.actions.quickAdd,
        group: (0, $d916753b57975e04$export$25ce5a424b770e84).shortcuts.groups.contacts
    });
    (0, $ed3cc4f847deec94$export$b0ebbe7904d8d94a)('f', ()=>setShowFilters((v)=>!v), {
        description: (0, $d916753b57975e04$export$25ce5a424b770e84).search.filters,
        group: (0, $d916753b57975e04$export$25ce5a424b770e84).shortcuts.groups.contacts
    });
    const filterInput = (0, $3OyDL.useMemo)(()=>(0, $64b4b7ad47ed3264$export$209fad8e84c0fe04)(urlFilter), [
        urlFilter
    ]);
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $047171b3f4119885$export$3b9cdff68986504e), {
        variables: {
            filter: filterInput,
            page: page,
            pageSize: (0, $370d2fd34ead4cb4$export$8ec3d08588d2eeda),
            withFacets: true
        }
    });
    const { data: tagData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$c064f18f2e294629), {
        variables: {
            includeInactive: false
        },
        errorPolicy: 'ignore'
    });
    // The vocabularies the filter panel offers, fetched with one explicit hook
    // EACH rather than a loop: `useQuery` inside a `.map()` works only while the
    // array is constant, and a rule that holds by accident is a rule that breaks
    // the first time somebody makes it configurable. `useVocabulary` is a
    // one-line wrapper, not a loop — the call sites stay explicit and countable.
    //
    // Nine queries, and Apollo dedupes each against the identical one the
    // contact form runs, so opening the panel beside a dialog is not eighteen.
    const useVocabulary = (kind)=>(0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$d2d584f4325fcf08), {
            variables: {
                kind: kind,
                includeInactive: false
            },
            errorPolicy: 'ignore'
        }).data?.lookups ?? [];
    const lookups = {
        FIELD_OF_WORK: useVocabulary('FIELD_OF_WORK'),
        SPECIALTY: useVocabulary('SPECIALTY'),
        PRODUCT: useVocabulary('PRODUCT'),
        // --- the CRM profile dimensions (migration 0016) ---
        LIFECYCLE_STAGE: useVocabulary('LIFECYCLE_STAGE'),
        SALES_STAGE: useVocabulary('SALES_STAGE'),
        CUSTOMER_HEALTH: useVocabulary('CUSTOMER_HEALTH'),
        ENGAGEMENT_STATUS: useVocabulary('ENGAGEMENT_STATUS'),
        CITY: useVocabulary('CITY'),
        FACILITY_TYPE: useVocabulary('FACILITY_TYPE')
    };
    const { data: viewData, refetch: refetchViews } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $047171b3f4119885$export$c8f13d3a0b86351b), {
        errorPolicy: 'ignore'
    });
    const contacts = data?.searchContacts?.items ?? [];
    const totalCount = data?.searchContacts?.totalCount ?? 0;
    const facets = data?.searchContacts?.facets ?? [];
    const pageCount = Math.max(1, Math.ceil(totalCount / (0, $370d2fd34ead4cb4$export$8ec3d08588d2eeda)));
    const bulkLimit = viewData?.bulkLimit ?? 5000;
    // A new filter drops «all matching» — that selection IS the old filter —
    // but keeps the rows ticked one by one. Clearing them here meant every
    // keystroke in the search box threw away what had been picked before it,
    // so nobody could select two people who did not appear in one search.
    const applyFilter = (0, $3OyDL.useCallback)((next)=>{
        setDraft(next);
        setAllMatching(false);
    }, []);
    const goToPage = (next)=>{
        setPage(next);
        setParams((0, $64b4b7ad47ed3264$export$498a66644341482)(urlFilter, {
            page: next
        }), {
            replace: true
        });
    };
    // UNTICKING ONE ROW UNDER «ALL MATCHING» NEEDS THE WHOLE LIST FIRST.
    // «انتخاب همهٔ ۱۱۰ مورد منطبق» sends the FILTER; the client holds only the
    // page it was clicked on. The first version flipped straight back to
    // explicit mode and toggled the one row — which, on page two, meant the
    // 109 others were never in `selected` at all: every row on the page went
    // blank except the one just clicked, and the count read «۱». Reported from
    // the running deployment on 2026-09-26.
    //
    // So the selection is MATERIALISED: the filter is re-run in pages of the
    // server's maximum, the ids become an explicit list, and the unticked
    // row is dropped from it. From then on it is an ordinary selection — the
    // filter can change and the 109 stay picked. Capped at the bulk limit,
    // which is also what the server would have refused past.
    const client = (0, $2b2c5bfb3bce7a5b$export$eb9a56e7a29e494)();
    const materialise = async (excluded)=>{
        setMaterialising(true);
        try {
            const skip = new Set(excluded);
            const collected = [];
            const cap = Math.min(totalCount, bulkLimit);
            for(let p = 1; collected.length < cap; p += 1){
                const { data: pageData } = await client.query({
                    query: (0, $047171b3f4119885$export$3b9cdff68986504e),
                    variables: {
                        filter: filterInput,
                        page: p,
                        pageSize: (0, $370d2fd34ead4cb4$export$cd99908c73c6130),
                        withFacets: false
                    },
                    fetchPolicy: 'network-only'
                });
                const items = pageData?.searchContacts?.items ?? [];
                if (items.length === 0) break;
                collected.push(...items);
            }
            setSelected(collected.filter((c)=>!skip.has(c.id)));
            setAllMatching(false);
        } catch  {
        // Keep «all matching» rather than silently shrink the selection to one
        // page: the bulk bar still says N, and N is still what a send reaches.
        } finally{
            setMaterialising(false);
        }
    };
    const toggleRow = (contact)=>{
        if (allMatching) {
            materialise([
                contact.id
            ]);
            return;
        }
        setSelected((current)=>current.some((c)=>c.id === contact.id) ? current.filter((c)=>c.id !== contact.id) : [
                ...current,
                contact
            ]);
    };
    // The header checkbox speaks for THIS PAGE only: it adds or removes the
    // rows on screen and leaves picks from other searches and pages alone.
    // Under «all matching» every page is selected, so it reads checked; unticking
    // it materialises the rest and drops this page.
    const pageSelected = allMatching || contacts.length > 0 && contacts.every((c)=>selectedIds.includes(c.id));
    const togglePage = (checked)=>{
        if (allMatching) {
            if (!checked) materialise(contacts.map((c)=>c.id));
            return;
        }
        const onPage = new Set(contacts.map((c)=>c.id));
        setSelected((current)=>{
            const rest = current.filter((c)=>!onPage.has(c.id));
            return checked ? [
                ...rest,
                ...contacts
            ] : rest;
        });
    };
    // The selector the bulk bar hands to the server. `allMatching` sends the
    // FILTER: the client never held those ids.
    const selector = allMatching ? {
        filter: filterInput
    } : {
        contactIds: selectedIds
    };
    const exportHref = (0, $3OyDL.useMemo)(()=>{
        const query = new URLSearchParams();
        query.set('filter', JSON.stringify(filterInput));
        // A download is a NAVIGATION, so it cannot carry an Authorization header
        // any more than EventSource can. Same trade as the pairing stream, same
        // note in todo.md: a short-lived token in a same-origin URL.
        const token = (0, $f0578ea5f18e5637$export$84773cc9bf7dbe87)();
        if (token) query.set('token', token);
        return `${0, $b5d41e4dbaeacaa2$export$4dc6837bb3c0882f}/exports/contacts?${query}`;
    }, [
        filterInput
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex h-screen",
        children: [
            showFilters && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $247b1b332fd40693$export$5286927812faf543), {
                filter: draft,
                onChange: applyFilter,
                facets: facets,
                tags: tagData?.tags ?? [],
                lookups: lookups,
                searchRef: searchRef
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex min-w-0 flex-1 flex-col",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("header", {
                        className: "flex h-toolbar shrink-0 items-center gap-3 border-b border-border bg-surface px-6",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                variant: "ghost",
                                onClick: ()=>setShowFilters((v)=>!v),
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $95214ae28e44529c$export$2e2bcd8739ae039), {
                                        size: 14,
                                        "aria-hidden": "true"
                                    }),
                                    showFilters ? (0, $d916753b57975e04$export$25ce5a424b770e84).search.hideFilters : (0, $d916753b57975e04$export$25ce5a424b770e84).search.showFilters
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("h1", {
                                className: "text-lg font-bold",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.title
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                className: "text-sm text-text-muted",
                                children: [
                                    (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(totalCount),
                                    " ",
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).search.results
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                variant: "primary",
                                onClick: ()=>setQuickAddOpen(true),
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                                        size: 14,
                                        "aria-hidden": "true"
                                    }),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).quickAdd.open
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                                className: "ms-auto flex items-center gap-2",
                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)("a", {
                                    href: exportHref,
                                    className: "inline-flex h-control items-center gap-2 rounded border border-border bg-surface px-4 text-base hover:bg-surface-hover",
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $fd6556f9b67f337f$export$2e2bcd8739ae039), {
                                            size: 14,
                                            "aria-hidden": "true"
                                        }),
                                        (0, $d916753b57975e04$export$25ce5a424b770e84).search.bulkExport
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c7b435074e94e4af$export$74fb2143f0b7f082), {
                        views: viewData?.savedViews ?? [],
                        filter: draft,
                        isAdmin: isAdmin,
                        onApply: applyFilter,
                        onChanged: refetchViews
                    }),
                    (selected.length > 0 || allMatching) && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $96a2e77fcd195696$export$c6b3b1c12d3baf2d), {
                        selector: selector,
                        selectedCount: allMatching ? totalCount : selected.length,
                        totalCount: totalCount,
                        allMatching: allMatching,
                        bulkLimit: bulkLimit,
                        isAdmin: isAdmin,
                        tags: tagData?.tags ?? [],
                        // A REAL contact to preview the message against: the first one
                        // picked, even if the current search no longer shows them. With
                        // «select all matching» the client holds no ids at all, and the
                        // first row on the page is somebody definitely in the set.
                        sampleContact: allMatching ? contacts[0] : selected[0],
                        onSelectAllMatching: ()=>setAllMatching(true),
                        onClear: ()=>{
                            setSelected([]);
                            setAllMatching(false);
                        },
                        onDone: ()=>{
                            setSelected([]);
                            setAllMatching(false);
                            refetch();
                        }
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "min-h-0 flex-1 overflow-auto p-6",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                                error: deleteError
                            }),
                            error && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$fddf379e22a74b00), {
                                title: "\u062E\u0637\u0627 \u062F\u0631 \u062F\u0631\u06CC\u0627\u0641\u062A \u0627\u0637\u0644\u0627\u0639\u0627\u062A",
                                hint: error.message,
                                className: "text-danger"
                            }),
                            loading && contacts.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                                className: "flex justify-center p-7",
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {})
                            }),
                            !loading && contacts.length === 0 && !error && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$fddf379e22a74b00), {
                                title: (0, $d916753b57975e04$export$25ce5a424b770e84).app.notFound,
                                hint: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.emptyHint
                            }),
                            contacts.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$54ec01a60f47d33d), {
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$c4c2bc57f2e82919), {
                                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                    className: "w-thumb",
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                                                        type: "checkbox",
                                                        className: "accent-primary",
                                                        "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).search.selectedCount.replace('{n}', ''),
                                                        checked: pageSelected,
                                                        disabled: materialising,
                                                        onChange: (event)=>togglePage(event.target.checked)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                    className: "w-thumb",
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                        className: "sr-only",
                                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.columnPhoto
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.columns.name
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.columns.specialty
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.columns.primaryPhone
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.columns.assessment
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.columns.referrer
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.columns.tags
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).search.interactions
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).search.lastInteraction
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                    className: "w-thumb",
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                        className: "sr-only",
                                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.deleteContact
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7005b8a93a167348), {
                                        children: contacts.map((contact)=>// THE WHOLE ROW navigates, and it is the only thing here
                                            // that does. Two cells used to carry their own handler, so
                                            // clicking the specialty, the status or the phone number did
                                            // nothing at all — a row that is clickable in two places out
                                            // of nine reads as broken rather than as restrained.
                                            //
                                            // The checkbox cell below already stopped propagation,
                                            // which is what this was always meant to be.
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                                interactive: true,
                                                onClick: ()=>navigate(`/contacts/${contact.id}`),
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                        onClick: (event)=>event.stopPropagation(),
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                                                            type: "checkbox",
                                                            className: "accent-primary",
                                                            "aria-label": contact.displayName,
                                                            checked: allMatching || selectedIds.includes(contact.id),
                                                            disabled: materialising,
                                                            onChange: ()=>toggleRow(contact)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f1ac2c7aaec4c80d$export$5f6775a0d87895ab), {
                                                            name: contact.displayName,
                                                            url: contact.photoUrl,
                                                            gender: contact.gender
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                        className: "font-medium",
                                                        children: [
                                                            contact.displayName,
                                                            contact.deletedAt && /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                                                className: "ms-2 text-xs text-danger",
                                                                children: [
                                                                    "(",
                                                                    (0, $d916753b57975e04$export$25ce5a424b770e84).app.delete,
                                                                    ")"
                                                                ]
                                                            }),
                                                            contact.messagingOptOut && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                                className: "ms-2 inline-flex items-center gap-1 text-xs text-warning",
                                                                title: (0, $d916753b57975e04$export$25ce5a424b770e84).search.optedOut,
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $7k3Wx.default), {
                                                                    size: 11,
                                                                    "aria-hidden": "true"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                        className: "text-text-muted",
                                                        children: contact.specialty?.labelFa ?? contact.fieldOfWork?.labelFa ?? (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                        dir: "ltr",
                                                        className: "text-start tabular-nums",
                                                        children: contact.primaryPhone ? (0, $d4d460d3ffb6daab$export$10c09b2cff9813eb)(contact.primaryPhone.number) : (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                                            className: "flex flex-wrap gap-1",
                                                            children: [
                                                                contact.tags.filter((tag)=>tag.isAssessment).map((tag)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$c21cd4bbffdb84a0), {
                                                                        name: tag.name,
                                                                        colorHex: tag.colorHex
                                                                    }, tag.id)),
                                                                !contact.tags.some((tag)=>tag.isAssessment) && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                                    className: "text-text-muted",
                                                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                        className: "text-text-muted",
                                                        children: contact.referrerName || (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                            className: "flex flex-wrap gap-1",
                                                            children: contact.tags.filter((tag)=>!tag.isAssessment).map((tag)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$c21cd4bbffdb84a0), {
                                                                    name: tag.name,
                                                                    colorHex: tag.colorHex
                                                                }, tag.id))
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                        className: "tabular-nums text-text-muted",
                                                        children: (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(contact.interactionCount ?? 0)
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                        className: "text-text-muted",
                                                        children: contact.lastInteractionAt ? (0, $d4d460d3ffb6daab$export$3ae94a2503e890a1)(contact.lastInteractionAt) : (0, $d916753b57975e04$export$25ce5a424b770e84).search.never
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                        onClick: (event)=>event.stopPropagation(),
                                                        children: !contact.deletedAt && /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>setDeleting(contact),
                                                            "aria-label": `${(0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.deleteContact} ${contact.displayName}`,
                                                            title: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.detail.deleteContact,
                                                            className: "text-text-muted hover:text-danger",
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8750d1d3edd41705$export$2e2bcd8739ae039), {
                                                                size: 14,
                                                                "aria-hidden": "true"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, contact.id))
                                    })
                                ]
                            })
                        ]
                    }),
                    pageCount > 1 && /*#__PURE__*/ (0, $2M70Q.jsxs)("footer", {
                        className: "flex h-control shrink-0 items-center justify-center gap-4 border-t border-border bg-surface text-sm",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                                type: "button",
                                disabled: page <= 1,
                                onClick: ()=>goToPage(page - 1),
                                className: "text-primary disabled:text-text-muted",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.previous
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                className: "text-text-muted",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.pageOf((0, $d4d460d3ffb6daab$export$104ee80c24270f18)(page), (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(pageCount))
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                                type: "button",
                                disabled: page >= pageCount,
                                onClick: ()=>goToPage(page + 1),
                                className: "text-primary disabled:text-text-muted",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.next
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $7f1b88b42a536c5f$export$5879ef5716dc8de0), {
                contact: deleting,
                open: deleting != null,
                onOpenChange: (next)=>{
                    if (!next) setDeleting(null);
                },
                onDeleted: ()=>{
                    // A deleted contact leaves the list, so it leaves the selection too;
                    // otherwise a bulk action would reach somebody no longer shown.
                    const goneId = deleting?.id;
                    setSelected((current)=>current.filter((c)=>c.id !== goneId));
                    refetch();
                },
                onError: setDeleteError
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1a57dd2069dc4761$export$69d5b40e4f0879f3), {
                open: quickAddOpen,
                onOpenChange: setQuickAddOpen,
                onCreated: ()=>refetch()
            })
        ]
    });
}



/**
 * Campaigns: a named message to a frozen list of people.
 *
 * CREATING ONE FROM A SAVED VIEW is the path this screen is built around,
 * because it is the one the brief's walkthrough describes: filter, save, send.
 * The recipients are resolved by the BFF through the CRM at CREATION and
 * stored — so what the counters count is a list somebody could have reviewed,
 * not "whoever matches when the send fires".
 *
 * PREVIEW BEFORE SEND, always. The preview renders through the same function
 * the send uses, so a contact with no first name shows its blank here rather
 * than in eight hundred WhatsApp messages.
 */ 
var $2M70Q = parcelRequire("2M70Q");

var $b8xcN = parcelRequire("b8xcN");







var $f4baf7f160de1c24$var$Ctx;
function $f4baf7f160de1c24$var$noop() {}
function $f4baf7f160de1c24$export$3e6dc71f325021bd() {
    if (!$f4baf7f160de1c24$var$Ctx) // we want the intialization to be lazy because `createContext` would error on import in a RSC
    $f4baf7f160de1c24$var$Ctx = $631d82cb14744748$exports.createContext(null);
    return $631d82cb14744748$exports.useCallback(/**
     * @returns true if the hook was called during render
     */ function() {
        var orig = console.error;
        try {
            console.error = $f4baf7f160de1c24$var$noop;
            /**
             * `useContext` can be called conditionally during render, so this is safe.
             * (Also, during render we would want to throw as a reaction to this anyways, so it
             * wouldn't even matter if we got the order of hooks mixed up...)
             *
             * They cannot however be called outside of Render, and that's what we're testing here.
             *
             * Different versions of React have different behaviour on an invalid hook call:
             *
             * React 16.8 - 17: throws an error
             * https://github.com/facebook/react/blob/2b93d686e359c7afa299e2ec5cf63160a32a1155/packages/react/src/ReactHooks.js#L18-L26
             *
             * React 18 & 19: `console.error` in development, then `resolveDispatcher` returns `null` and a member access on `null` throws.
             * https://github.com/facebook/react/blob/58e8304483ebfadd02a295339b5e9a989ac98c6e/packages/react/src/ReactHooks.js#L28-L35
             */ $631d82cb14744748$exports.useContext($f4baf7f160de1c24$var$Ctx);
            return true;
        } catch (e) {
            return false;
        } finally{
            console.error = orig;
        }
    }, []);
}


// The following methods, when called will execute the query, regardless of
// whether the useLazyQuery execute function was called before.
var $08c81aa164c88db1$var$EAGER_METHODS = [
    "refetch",
    "reobserve",
    "fetchMore",
    "updateQuery",
    "startPolling",
    "stopPolling",
    "subscribeToMore"
];
var $08c81aa164c88db1$var$REMOVED_EXECUTE_OPTIONS = [
    "initialFetchPolicy",
    "onCompleted",
    "onError",
    "defaultOptions",
    "partialRefetch",
    "canonizeResults"
];
var $08c81aa164c88db1$var$DEPRECATED_EXECUTE_OPTIONS = [
    "query",
    "ssr",
    "client",
    "fetchPolicy",
    "nextFetchPolicy",
    "refetchWritePolicy",
    "errorPolicy",
    "pollInterval",
    "notifyOnNetworkStatusChange",
    "returnPartialData",
    "skipPollAttempt"
];
function $08c81aa164c88db1$export$fd83eea6ecd2d8fa(query, options) {
    var _a;
    if (globalThis.__DEV__ !== false) {
        /* eslint-disable react-hooks/rules-of-hooks, react-compiler/react-compiler */ var warnOpts = options || {};
        (0, $5371af004b6fa366$export$d5e35053e4aec331)(warnOpts, "canonizeResults", "useLazyQuery");
        (0, $5371af004b6fa366$export$d5e35053e4aec331)(warnOpts, "variables", "useLazyQuery", "Pass all `variables` to the returned `execute` function instead.");
        (0, $5371af004b6fa366$export$d5e35053e4aec331)(warnOpts, "context", "useLazyQuery", "Pass `context` to the returned `execute` function instead.");
        (0, $5371af004b6fa366$export$d5e35053e4aec331)(warnOpts, "onCompleted", "useLazyQuery", "If your `onCompleted` callback sets local state, switch to use derived state using `data` returned from the hook instead. Use `useEffect` to perform side-effects as a result of updates to `data`.");
        (0, $5371af004b6fa366$export$d5e35053e4aec331)(warnOpts, "onError", "useLazyQuery", "If your `onError` callback sets local state, switch to use derived state using `data`, `error` or `errors` returned from the hook instead. Use `useEffect` if you need to perform side-effects as a result of updates to `data`, `error` or `errors`.");
        (0, $5371af004b6fa366$export$d5e35053e4aec331)(warnOpts, "defaultOptions", "useLazyQuery", "Pass the options directly to the hook instead.");
        (0, $5371af004b6fa366$export$d5e35053e4aec331)(warnOpts, "initialFetchPolicy", "useLazyQuery", "Use the `fetchPolicy` option instead.");
        (0, $5371af004b6fa366$export$d5e35053e4aec331)(warnOpts, "partialRefetch", "useLazyQuery");
    /* eslint-enable react-hooks/rules-of-hooks, react-compiler/react-compiler */ }
    var execOptionsRef = $631d82cb14744748$exports.useRef(void 0);
    var optionsRef = $631d82cb14744748$exports.useRef(void 0);
    var queryRef = $631d82cb14744748$exports.useRef(void 0);
    var merged = (0, $a76f045ea055af6d$export$235b7fc70b9fc359)(options, execOptionsRef.current || {});
    var document = (_a = merged === null || merged === void 0 ? void 0 : merged.query) !== null && _a !== void 0 ? _a : query;
    // Use refs to track options and the used query to ensure the `execute`
    // function remains referentially stable between renders.
    optionsRef.current = options;
    queryRef.current = document;
    var queryHookOptions = (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, merged), {
        skip: !execOptionsRef.current
    });
    var _b = (0, $549c36a2a3cf1189$export$5c23c59ff7f655a8)(document, queryHookOptions), obsQueryFields = _b.obsQueryFields, useQueryResult = _b.result, client = _b.client, resultData = _b.resultData, observable = _b.observable, onQueryExecuted = _b.onQueryExecuted;
    var initialFetchPolicy = observable.options.initialFetchPolicy || (0, $549c36a2a3cf1189$export$e700754533d2c94f)(queryHookOptions.defaultOptions, client.defaultOptions);
    var forceUpdateState = $631d82cb14744748$exports.useReducer(function(tick) {
        return tick + 1;
    }, 0)[1];
    // We use useMemo here to make sure the eager methods have a stable identity.
    var eagerMethods = $631d82cb14744748$exports.useMemo(function() {
        var eagerMethods = {};
        var _loop_1 = function(key) {
            var method = obsQueryFields[key];
            eagerMethods[key] = function() {
                if (globalThis.__DEV__ !== false) {
                    if (key === "reobserve") globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(79);
                }
                if (!execOptionsRef.current) {
                    execOptionsRef.current = Object.create(null);
                    // Only the first time populating execOptionsRef.current matters here.
                    forceUpdateState();
                }
                // @ts-expect-error this is just too generic to type
                return method.apply(this, arguments);
            };
        };
        for(var _i = 0, EAGER_METHODS_1 = $08c81aa164c88db1$var$EAGER_METHODS; _i < EAGER_METHODS_1.length; _i++){
            var key = EAGER_METHODS_1[_i];
            _loop_1(key);
        }
        return eagerMethods;
    }, [
        forceUpdateState,
        obsQueryFields
    ]);
    var called = !!execOptionsRef.current;
    var result = $631d82cb14744748$exports.useMemo(function() {
        return (0, $b8xcN.__assign)((0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, useQueryResult), eagerMethods), {
            called: called
        });
    }, [
        useQueryResult,
        eagerMethods,
        called
    ]);
    var calledDuringRender = (0, $f4baf7f160de1c24$export$3e6dc71f325021bd)();
    var warnRef = $631d82cb14744748$exports.useRef(new Set());
    var execute = $631d82cb14744748$exports.useCallback(function(executeOptions) {
        if (globalThis.__DEV__ !== false) {
            if (calledDuringRender()) globalThis.__DEV__ !== false && (0, $c21c2000775800f2$export$f5708dca728d7177).warn(80);
            for(var _i = 0, REMOVED_EXECUTE_OPTIONS_1 = $08c81aa164c88db1$var$REMOVED_EXECUTE_OPTIONS; _i < REMOVED_EXECUTE_OPTIONS_1.length; _i++){
                var name_1 = REMOVED_EXECUTE_OPTIONS_1[_i];
                if (!warnRef.current.has(name_1)) {
                    (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(executeOptions || {}, name_1, "useLazyQuery.execute");
                    warnRef.current.add(name_1);
                }
            }
            for(var _a = 0, DEPRECATED_EXECUTE_OPTIONS_1 = $08c81aa164c88db1$var$DEPRECATED_EXECUTE_OPTIONS; _a < DEPRECATED_EXECUTE_OPTIONS_1.length; _a++){
                var name_2 = DEPRECATED_EXECUTE_OPTIONS_1[_a];
                if (!warnRef.current.has(name_2)) {
                    (0, $14465ad01ccc354a$export$6d0d09df4c29a84a)(executeOptions || {}, name_2, "useLazyQuery.execute", "Please pass the option to the `useLazyQuery` hook instead.");
                    warnRef.current.add(name_2);
                }
            }
        }
        execOptionsRef.current = executeOptions ? (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, executeOptions), {
            fetchPolicy: executeOptions.fetchPolicy || initialFetchPolicy
        }) : {
            fetchPolicy: initialFetchPolicy
        };
        var options = (0, $a76f045ea055af6d$export$235b7fc70b9fc359)(optionsRef.current, (0, $b8xcN.__assign)({
            query: queryRef.current
        }, execOptionsRef.current));
        var promise = $08c81aa164c88db1$var$executeQuery(resultData, observable, client, document, (0, $b8xcN.__assign)((0, $b8xcN.__assign)({}, options), {
            skip: false
        }), onQueryExecuted).then(function(queryResult) {
            return Object.assign(queryResult, eagerMethods);
        });
        // Because the return value of `useLazyQuery` is usually floated, we need
        // to catch the promise to prevent unhandled rejections.
        promise.catch(function() {});
        return promise;
    }, [
        calledDuringRender,
        client,
        document,
        eagerMethods,
        initialFetchPolicy,
        observable,
        resultData,
        onQueryExecuted
    ]);
    var executeRef = $631d82cb14744748$exports.useRef(execute);
    (0, $a18155047725579a$export$700979bc83e7db82)(function() {
        executeRef.current = execute;
    });
    var stableExecute = $631d82cb14744748$exports.useCallback(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return executeRef.current.apply(executeRef, args);
    }, []);
    return [
        stableExecute,
        result
    ];
}
function $08c81aa164c88db1$var$executeQuery(resultData, observable, client, currentQuery, options, onQueryExecuted) {
    var query = options.query || currentQuery;
    var watchQueryOptions = (0, $549c36a2a3cf1189$export$63539d93836ebf9c)(client, query, options, false)(observable);
    var concast = observable.reobserveAsConcast((0, $549c36a2a3cf1189$export$2167b7db3cd527f2)(observable, client, options, watchQueryOptions));
    onQueryExecuted(watchQueryOptions);
    return new Promise(function(resolve) {
        var result;
        // Subscribe to the concast independently of the ObservableQuery in case
        // the component gets unmounted before the promise resolves. This prevents
        // the concast from terminating early and resolving with `undefined` when
        // there are no more subscribers for the concast.
        concast.subscribe({
            next: function(value) {
                result = value;
            },
            error: function() {
                resolve((0, $549c36a2a3cf1189$export$de3acc9431f1695e)(observable.getCurrentResult(), resultData.previousData, observable, client));
            },
            complete: function() {
                resolve((0, $549c36a2a3cf1189$export$de3acc9431f1695e)(observable["maskResult"](result), resultData.previousData, observable, client));
            }
        });
    });
}




var $5Quto = parcelRequire("5Quto");/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $b90671aae5dcc076$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
            key: "1nclc0"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const $b90671aae5dcc076$export$2e2bcd8739ae039 = (0, $djixo.default)("eye", $b90671aae5dcc076$export$3efd853dbb351e94);


var $hb5XY = parcelRequire("hb5XY");
var $6PxCH = parcelRequire("6PxCH");

var $3OyDL = parcelRequire("3OyDL");

var $8B9Zg = parcelRequire("8B9Zg");






const $e15b1163fa6b552a$var$STATE_LABELS = {
    DRAFT: (0, $d916753b57975e04$export$25ce5a424b770e84).app.inactive,
    SCHEDULED: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.schedule,
    RUNNING: (0, $d916753b57975e04$export$25ce5a424b770e84).app.loading,
    DONE: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.statusSent,
    CANCELLED: (0, $d916753b57975e04$export$25ce5a424b770e84).app.cancel
};
function $e15b1163fa6b552a$export$de2bbf1734ee03f0() {
    const [creating, setCreating] = (0, $3OyDL.useState)(false);
    const [previewOf, setPreviewOf] = (0, $3OyDL.useState)(null);
    const { data: data, loading: loading, refetch: refetch } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $047171b3f4119885$export$dc9303094dc8d17f), {
        variables: {
            page: 1,
            pageSize: (0, $370d2fd34ead4cb4$export$8ec3d08588d2eeda)
        }
    });
    const { data: viewData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $047171b3f4119885$export$c8f13d3a0b86351b), {
        errorPolicy: 'ignore'
    });
    const { data: templateData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$53468eed769bf661), {
        variables: {
            includeInactive: false
        },
        errorPolicy: 'ignore'
    });
    const [schedule, scheduleState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$431dc0c2ff5a4e9a), {
        onCompleted: ()=>refetch()
    });
    const [cancel, cancelState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$15728f4a132922ba), {
        onCompleted: ()=>refetch()
    });
    const campaigns = data?.campaigns?.items ?? [];
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex h-screen flex-col",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("header", {
                className: "flex h-toolbar shrink-0 items-center gap-4 border-b border-border bg-surface px-6",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h1", {
                        className: "text-lg font-bold",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.campaigns
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "primary",
                        onClick: ()=>setCreating(true),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                                size: 14,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.newCampaign
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8B9Zg.Link), {
                        to: "/messaging/outbox",
                        className: "ms-auto text-sm text-primary",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.outbox
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "min-h-0 flex-1 overflow-auto p-6",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                        error: scheduleState.error ?? cancelState.error
                    }),
                    loading && campaigns.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                        className: "flex justify-center p-7",
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {})
                    }),
                    !loading && campaigns.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$fddf379e22a74b00), {
                        title: (0, $d916753b57975e04$export$25ce5a424b770e84).app.notFound
                    }),
                    campaigns.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$54ec01a60f47d33d), {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$c4c2bc57f2e82919), {
                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.campaignName
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.recipients
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.status
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.counters
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.schedule
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7005b8a93a167348), {
                                children: campaigns.map((campaign)=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                className: "font-medium",
                                                children: campaign.name
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                className: "tabular-nums",
                                                children: (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(campaign.resolvedCount)
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                                                    className: "bg-surface-hover",
                                                    children: $e15b1163fa6b552a$var$STATE_LABELS[campaign.state] ?? campaign.state
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                className: "text-sm text-text-muted tabular-nums",
                                                children: [
                                                    (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.statusSent,
                                                    " ",
                                                    (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(campaign.sentCount),
                                                    " \xb7",
                                                    ' ',
                                                    (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.statusRead,
                                                    " ",
                                                    (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(campaign.readCount),
                                                    " \xb7",
                                                    ' ',
                                                    (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.statusSuppressed,
                                                    " ",
                                                    (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(campaign.suppressedCount)
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                className: "text-text-muted",
                                                children: campaign.scheduledAt ? (0, $d4d460d3ffb6daab$export$8b492ed8828f789c)(campaign.scheduledAt) : (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                                    className: "flex gap-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                                            variant: "ghost",
                                                            onClick: ()=>setPreviewOf(campaign),
                                                            children: [
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $b90671aae5dcc076$export$2e2bcd8739ae039), {
                                                                    size: 13,
                                                                    "aria-hidden": "true"
                                                                }),
                                                                (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.preview
                                                            ]
                                                        }),
                                                        [
                                                            'DRAFT',
                                                            'SCHEDULED'
                                                        ].includes(campaign.state) && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                                            variant: "ghost",
                                                            onClick: ()=>schedule({
                                                                    variables: {
                                                                        id: campaign.id
                                                                    }
                                                                }),
                                                            children: [
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $hb5XY.default), {
                                                                    size: 13,
                                                                    "aria-hidden": "true"
                                                                }),
                                                                (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.sendNow
                                                            ]
                                                        }),
                                                        campaign.state !== 'CANCELLED' && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                                            variant: "ghost",
                                                            onClick: ()=>cancel({
                                                                    variables: {
                                                                        id: campaign.id
                                                                    }
                                                                }),
                                                            children: [
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $5Quto.default), {
                                                                    size: 13,
                                                                    "aria-hidden": "true"
                                                                }),
                                                                (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.cancel
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, campaign.id))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)($e15b1163fa6b552a$var$CreateCampaignDialog, {
                open: creating,
                onOpenChange: setCreating,
                views: viewData?.savedViews ?? [],
                templates: templateData?.messageTemplates ?? [],
                onCreated: ()=>refetch()
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)($e15b1163fa6b552a$var$PreviewDialog, {
                campaign: previewOf,
                onClose: ()=>setPreviewOf(null)
            })
        ]
    });
}
function $e15b1163fa6b552a$var$CreateCampaignDialog({ open: open, onOpenChange: onOpenChange, views: views, templates: templates, onCreated: onCreated }) {
    const [name, setName] = (0, $3OyDL.useState)('');
    const [viewId, setViewId] = (0, $3OyDL.useState)('');
    const [templateId, setTemplateId] = (0, $3OyDL.useState)('');
    // WHICH NUMBER THIS CAMPAIGN SENDS FROM. Empty means the default, resolved
    // and FROZEN by the server at creation — a campaign built this morning must
    // not change identity because somebody re-pointed the default before it ran
    // tonight. The picker only appears once there is a choice to make.
    const [accountId, setAccountId] = (0, $3OyDL.useState)('');
    const { data: accountsData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $047171b3f4119885$export$f08c69326971bdb2), {
        skip: !open
    });
    const accounts = (accountsData?.whatsappAccounts ?? []).filter((a)=>a.isActive);
    const [create, { loading: loading, error: error }] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$5406bbed7d677353));
    const submit = async ()=>{
        const view = views.find((v)=>v.id === viewId);
        await create({
            variables: {
                name: name.trim(),
                templateId: templateId || null,
                // The filter is sent, and the BFF resolves it against the CRM once.
                // The client does not send ids it never held.
                filter: view ? (0, $64b4b7ad47ed3264$export$209fad8e84c0fe04)((0, $64b4b7ad47ed3264$export$acb063342f63a374)(view.filterJson)) : null,
                accountId: accountId || null
            }
        });
        setName('');
        setViewId('');
        setTemplateId('');
        setAccountId('');
        onOpenChange(false);
        onCreated();
    };
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: open,
        onOpenChange: onOpenChange,
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.newCampaign,
        submitLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).app.create,
        onSubmit: submit,
        busy: loading,
        canSubmit: Boolean(name.trim() && viewId && templateId),
        error: error,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.campaignName,
                value: name,
                onChange: (event)=>setName(event.target.value)
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.fromView,
                value: viewId,
                onChange: (event)=>setViewId(event.target.value),
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: "",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    views.map((view)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                            value: view.id,
                            children: view.name
                        }, view.id))
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.template,
                value: templateId,
                onChange: (event)=>setTemplateId(event.target.value),
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: "",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    templates.map((template)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                            value: template.id,
                            children: template.name
                        }, template.id))
                ]
            }),
            accounts.length > 1 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.sendsFrom,
                hint: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.defaultHint,
                value: accountId,
                onChange: (event)=>setAccountId(event.target.value),
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: "",
                        children: accounts.find((a)=>a.isDefault)?.label ?? (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.isDefault
                    }),
                    accounts.map((account)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                            value: account.accountId,
                            children: account.label
                        }, account.id))
                ]
            })
        ]
    });
}
function $e15b1163fa6b552a$var$PreviewDialog({ campaign: campaign, onClose: onClose }) {
    const [load, { data: data, loading: loading }] = (0, $08c81aa164c88db1$export$fd83eea6ecd2d8fa)((0, $047171b3f4119885$export$39821677e7ddca34));
    (0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).useEffect(()=>{
        if (campaign) load({
            variables: {
                id: campaign.id,
                sample: 5
            }
        });
    }, [
        campaign,
        load
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: Boolean(campaign),
        onOpenChange: (next)=>!next && onClose(),
        title: `${(0, $d916753b57975e04$export$25ce5a424b770e84).messaging.preview} \u{2014} ${campaign?.name ?? ''}`,
        submitLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).app.close,
        onSubmit: onClose,
        canSubmit: true,
        children: [
            loading && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: "flex flex-col gap-2",
                children: (data?.campaignPreview ?? []).map((entry, index)=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
                        className: "p-3",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                className: "text-sm font-medium",
                                children: entry.displayName
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                className: "whitespace-pre-wrap text-sm text-text-muted",
                                children: entry.renderedBody
                            })
                        ]
                    }, index))
            })
        ]
    });
}



/**
 * One issue: its story, its notes, and the two things that leave this screen —
 * a status change and a message to the contact.
 *
 * «حل شد» REQUIRES A RESULT, and the form makes that visible before the server
 * refuses it. The reports read that text; «حل شد» with no account of how is a
 * row that helps nobody six months later.
 *
 * `contactNotifiedAt` is displayed but never SET here. This service does not
 * send anything and cannot know: the messaging service reports the message
 * SENT, the feedback service hears it and stamps the field. What the button
 * does is queue a message.
 */ 
var $2M70Q = parcelRequire("2M70Q");



var $74E7N = parcelRequire("74E7N");
var $7k3Wx = parcelRequire("7k3Wx");
var $c7uHF = parcelRequire("c7uHF");

var $3OyDL = parcelRequire("3OyDL");

var $8B9Zg = parcelRequire("8B9Zg");
var $ZNHD9 = parcelRequire("ZNHD9");







function $79b6ccb465b64fb9$export$c24121eefa79457e() {
    const { id: id } = (0, $ZNHD9.useParams)();
    const navigate = (0, $8B9Zg.useNavigate)();
    const { me: me } = (0, $00d5d84dffcdf8d5$export$ad0a340bf97d63d5)();
    const [statusTarget, setStatusTarget] = (0, $3OyDL.useState)(null);
    const [notifying, setNotifying] = (0, $3OyDL.useState)(false);
    const [comment, setComment] = (0, $3OyDL.useState)('');
    const [customerVisible, setCustomerVisible] = (0, $3OyDL.useState)(false);
    const { data: data, loading: loading, refetch: refetch } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $047171b3f4119885$export$f4f44b136c1e517c), {
        variables: {
            id: id
        }
    });
    const [changeStatus, statusState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$eb275db119aada7d), {
        onCompleted: ()=>refetch()
    });
    const [assign, assignState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$e3e5ec492e10f340), {
        onCompleted: ()=>refetch()
    });
    const [addComment, commentState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$a0313c9e3952c70c), {
        onCompleted: ()=>{
            setComment('');
            refetch();
        }
    });
    (0, $ed3cc4f847deec94$export$b0ebbe7904d8d94a)('Escape', ()=>navigate('/issues'), {
        description: (0, $d916753b57975e04$export$25ce5a424b770e84).app.close,
        group: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.title
    });
    const issue = data?.issue;
    if (loading && !issue) return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {
        className: "m-7"
    });
    if (!issue) return null;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex h-screen flex-col",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("header", {
                className: "flex h-toolbar shrink-0 items-center gap-3 border-b border-border bg-surface px-6",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8B9Zg.Link), {
                        to: "/issues",
                        className: "text-text-muted",
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $74E7N.default), {
                            size: 16,
                            "aria-hidden": "true"
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h1", {
                        className: "truncate text-lg font-bold",
                        children: issue.title
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                        className: `bg-surface-hover ${(0, $8be8610b9776ae98$export$fce5400eb9b3fa56)[issue.status]}`,
                        children: (0, $8be8610b9776ae98$export$3b558bfbd454e1bc)[issue.status]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                        className: `bg-surface-hover ${(0, $8be8610b9776ae98$export$bd92a918e489f48a)[issue.priority]}`,
                        children: (0, $8be8610b9776ae98$export$e1e838806c3b27c5)[issue.priority]
                    }),
                    issue.orphaned && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                        className: "bg-surface-hover text-warning",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.orphaned
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "ms-auto flex items-center gap-2",
                        children: [
                            ((0, $8be8610b9776ae98$export$b2677d2be83a902c)[issue.status] ?? []).map((next)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                    onClick: ()=>setStatusTarget(next),
                                    children: (0, $8be8610b9776ae98$export$3b558bfbd454e1bc)[next]
                                }, next)),
                            issue.contact && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                variant: "primary",
                                onClick: ()=>setNotifying(true),
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c7uHF.default), {
                                        size: 13,
                                        "aria-hidden": "true"
                                    }),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).issues.notify
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "min-h-0 flex-1 overflow-auto p-6",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                        error: statusState.error ?? assignState.error ?? commentState.error
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "grid grid-cols-3 gap-6",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                className: "col-span-2 flex flex-col gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
                                        className: "flex flex-col gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                                className: "whitespace-pre-wrap text-base",
                                                children: issue.description || (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                                            }),
                                            issue.resolution && /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                                className: "rounded border border-success bg-surface-hover p-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                                        className: "text-sm font-medium text-success",
                                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.resolution
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                                        className: "whitespace-pre-wrap text-sm",
                                                        children: issue.resolution
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
                                        className: "flex flex-col gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                                                className: "text-md font-bold",
                                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.comments
                                            }),
                                            issue.comments.map((entry)=>/*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                                    className: "border-b border-border pb-2 last:border-b-0",
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                                                            className: "flex items-center gap-2 text-xs text-text-muted",
                                                            children: [
                                                                entry.authorName ?? entry.authorId,
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                                    children: "\xb7"
                                                                }),
                                                                (0, $d4d460d3ffb6daab$export$8b492ed8828f789c)(entry.createdAt),
                                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                                                                    className: entry.isCustomerVisible ? 'bg-surface-hover text-info' : 'bg-surface-hover text-text-muted',
                                                                    children: entry.isCustomerVisible ? (0, $d916753b57975e04$export$25ce5a424b770e84).issues.customerVisible : (0, $d916753b57975e04$export$25ce5a424b770e84).issues.internalNote
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                                            className: "whitespace-pre-wrap text-sm",
                                                            children: entry.body
                                                        })
                                                    ]
                                                }, entry.id)),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$f5c9f3c2c4054eec), {
                                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.addComment,
                                                rows: 3,
                                                value: comment,
                                                onChange: (event)=>setComment(event.target.value)
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                                className: "flex items-center gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsxs)("label", {
                                                        className: "flex items-center gap-2 text-sm text-text-muted",
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                                                                type: "checkbox",
                                                                className: "accent-primary",
                                                                checked: customerVisible,
                                                                onChange: (event)=>setCustomerVisible(event.target.checked)
                                                            }),
                                                            (0, $d916753b57975e04$export$25ce5a424b770e84).issues.customerVisible
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                                        variant: "primary",
                                                        disabled: !comment.trim() || commentState.loading,
                                                        onClick: ()=>addComment({
                                                                variables: {
                                                                    issueId: issue.id,
                                                                    body: comment.trim(),
                                                                    isCustomerVisible: customerVisible
                                                                }
                                                            }),
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $7k3Wx.default), {
                                                                size: 13,
                                                                "aria-hidden": "true"
                                                            }),
                                                            (0, $d916753b57975e04$export$25ce5a424b770e84).app.add
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                className: "flex flex-col gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
                                        className: "flex flex-col gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.title,
                                                children: issue.contact ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8B9Zg.Link), {
                                                    to: `/contacts/${issue.contact.id}`,
                                                    className: "text-primary",
                                                    children: issue.contact.displayName
                                                }) : (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.kind,
                                                children: (0, $8be8610b9776ae98$export$7b239963c3289a2)[issue.kind]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.type,
                                                children: issue.type?.labelFa
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.assignee,
                                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        issue.assigneeName ?? (issue.assigneeId || (0, $d916753b57975e04$export$25ce5a424b770e84).issues.unassigned),
                                                        issue.assigneeId !== me?.id && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                                            variant: "ghost",
                                                            onClick: ()=>assign({
                                                                    variables: {
                                                                        id: issue.id,
                                                                        assigneeId: me?.id
                                                                    }
                                                                }),
                                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.assignToMe
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.reportedAt,
                                                children: (0, $d4d460d3ffb6daab$export$8b492ed8828f789c)(issue.reportedAt)
                                            }),
                                            issue.contactNotifiedAt && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.notify,
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                    className: "text-success",
                                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.notified.replace('{date}', (0, $d4d460d3ffb6daab$export$8b492ed8828f789c)(issue.contactNotifiedAt))
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
                                        className: "flex flex-col gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                                                className: "text-md font-bold",
                                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.history
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$54ec01a60f47d33d), {
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7005b8a93a167348), {
                                                    children: issue.statusHistory.map((entry)=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                                    className: "text-sm",
                                                                    children: [
                                                                        entry.fromStatus ? `${(0, $8be8610b9776ae98$export$3b558bfbd454e1bc)[entry.fromStatus]} \u{2192} ` : '',
                                                                        (0, $8be8610b9776ae98$export$3b558bfbd454e1bc)[entry.toStatus],
                                                                        entry.reason && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                                            className: "block text-xs text-text-muted",
                                                                            children: entry.reason
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                                    className: "text-xs text-text-muted",
                                                                    children: [
                                                                        entry.changedByName ?? entry.changedBy,
                                                                        /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                                            className: "block",
                                                                            children: (0, $d4d460d3ffb6daab$export$8b492ed8828f789c)(entry.changedAt)
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }, entry.id))
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)($79b6ccb465b64fb9$var$StatusDialog, {
                target: statusTarget,
                currentStatus: issue.status,
                onClose: ()=>setStatusTarget(null),
                onSubmit: (variables)=>changeStatus({
                        variables: {
                            id: issue.id,
                            ...variables
                        }
                    }).then(()=>setStatusTarget(null))
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)($79b6ccb465b64fb9$var$NotifyDialog, {
                open: notifying,
                onOpenChange: setNotifying,
                issueId: issue.id,
                onSent: ()=>refetch()
            })
        ]
    });
}
function $79b6ccb465b64fb9$var$StatusDialog({ target: target, currentStatus: currentStatus, onClose: onClose, onSubmit: onSubmit }) {
    const [resolution, setResolution] = (0, $3OyDL.useState)('');
    const [reason, setReason] = (0, $3OyDL.useState)('');
    const needsResolution = target === 'RESOLVED';
    // Reopening from CLOSED is ADMIN-only AND needs a reason — enforced in the
    // feedback service; the form asks for it so the refusal never happens.
    const needsReason = currentStatus === 'CLOSED';
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: Boolean(target),
        onOpenChange: (next)=>!next && onClose(),
        title: target ? (0, $8be8610b9776ae98$export$3b558bfbd454e1bc)[target] : '',
        submitLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).app.confirm,
        canSubmit: (!needsResolution || resolution.trim().length > 0) && (!needsReason || reason.trim().length > 0),
        onSubmit: ()=>onSubmit({
                toStatus: target,
                resolution: resolution.trim() || null,
                reason: reason.trim() || null
            }),
        children: [
            needsResolution && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$f5c9f3c2c4054eec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.resolution,
                hint: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.resolutionRequired,
                value: resolution,
                onChange: (event)=>setResolution(event.target.value)
            }),
            needsReason && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$f5c9f3c2c4054eec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.reopenReason,
                value: reason,
                onChange: (event)=>setReason(event.target.value)
            })
        ]
    });
}
function $79b6ccb465b64fb9$var$NotifyDialog({ open: open, onOpenChange: onOpenChange, issueId: issueId, onSent: onSent }) {
    const [templateId, setTemplateId] = (0, $3OyDL.useState)('');
    const [result, setResult] = (0, $3OyDL.useState)(null);
    const { data: data } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$53468eed769bf661), {
        variables: {
            includeInactive: false
        },
        errorPolicy: 'ignore'
    });
    const [notify, { loading: loading, error: error }] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$cbfcf33edfce844c));
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: open,
        onOpenChange: onOpenChange,
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.notify,
        submitLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.send,
        busy: loading,
        error: error,
        canSubmit: Boolean(templateId),
        onSubmit: async ()=>{
            const sent = await notify({
                variables: {
                    issueId: issueId,
                    templateId: templateId
                }
            });
            setResult(sent.data?.notifyContactAboutIssue);
            onSent();
        },
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.template,
                value: templateId,
                onChange: (event)=>setTemplateId(event.target.value),
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: "",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    (data?.messageTemplates ?? []).map((template)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                            value: template.id,
                            children: template.name
                        }, template.id))
                ]
            }),
            result && /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                className: "text-sm text-success",
                children: [
                    (0, $d916753b57975e04$export$25ce5a424b770e84).issues.notifySent,
                    " \u2014 ",
                    result.renderedBody
                ]
            })
        ]
    });
}


/**
 * `/issues/reports` — «مشکلات پرتکرار».
 *
 * THREE NUMBERS, and each answers a different question:
 *
 *  - **count** — how many issues were REPORTED in the window. What people mean
 *    by "how many problems did we have".
 *  - **median time to resolve** — over issues RESOLVED in it. A median rather
 *    than a mean, because one issue that sat open over Nowruz would wreck an
 *    average and describe nobody's experience.
 *  - **reopen rate** — reopenings per resolution, counted from the append-only
 *    history rather than from current state. A high one means things are being
 *    closed before they are fixed, which no count would show.
 *
 * THE MONTH LABELS ARE JALALI AND THE CONVERSION HAPPENS HERE. The service
 * sends ISO bucket dates on purpose — a calendar is a locale decision and a
 * domain service does not make one (CLAUDE.md §12).
 */ 
var $2M70Q = parcelRequire("2M70Q");



var $74E7N = parcelRequire("74E7N");

var $3OyDL = parcelRequire("3OyDL");

var $8B9Zg = parcelRequire("8B9Zg");





const $4f72b7c2271a0dfd$var$GROUPS = [
    {
        value: 'TYPE',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.reportByType
    },
    {
        value: 'KIND',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.reportByKind
    },
    {
        value: 'PRIORITY',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.reportByPriority
    },
    {
        value: 'ASSIGNEE',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.reportByAssignee
    }
];
const $4f72b7c2271a0dfd$var$BUCKETS = [
    {
        value: 'NONE',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.reportNone
    },
    {
        value: 'MONTH',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.reportMonthly
    },
    {
        value: 'WEEK',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.reportWeekly
    }
];
/** A year back, which is what «مشکلات پرتکرار» is usually asked about. */ function $4f72b7c2271a0dfd$var$defaultRange() {
    const to = new Date();
    const from = new Date(to);
    from.setFullYear(from.getFullYear() - 1);
    return [
        from.toISOString(),
        to.toISOString()
    ];
}
function $4f72b7c2271a0dfd$export$75c890e685aee97e() {
    const [groupBy, setGroupBy] = (0, $3OyDL.useState)('TYPE');
    const [bucket, setBucket] = (0, $3OyDL.useState)('NONE');
    const [dateFrom, dateTo] = (0, $3OyDL.useMemo)($4f72b7c2271a0dfd$var$defaultRange, []);
    const { data: data, loading: loading, error: error } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $047171b3f4119885$export$12fa00367f992389), {
        variables: {
            dateFrom: dateFrom,
            dateTo: dateTo,
            groupBy: groupBy,
            bucket: bucket
        }
    });
    const buckets = data?.issueStats ?? [];
    /** The label a row reads under, once the enum and the calendar are applied. */ const labelFor = (row)=>{
        const base = groupBy === 'KIND' ? (0, $8be8610b9776ae98$export$7b239963c3289a2)[row.label] ?? row.label : groupBy === 'PRIORITY' ? (0, $8be8610b9776ae98$export$e1e838806c3b27c5)[row.label] ?? row.label : row.label || (0, $d916753b57975e04$export$25ce5a424b770e84).app.none;
        if (bucket === 'NONE' || !row.bucketStart) return base;
        return `${(0, $d4d460d3ffb6daab$export$d4a2b3f01177c29b)(row.bucketStart)} \xb7 ${base}`;
    };
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex h-screen flex-col",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("header", {
                className: "flex h-toolbar shrink-0 items-center gap-3 border-b border-border bg-surface px-6",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8B9Zg.Link), {
                        to: "/issues",
                        className: "text-text-muted",
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $74E7N.default), {
                            size: 16,
                            "aria-hidden": "true"
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h1", {
                        className: "text-lg font-bold",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.reports
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("select", {
                        value: groupBy,
                        onChange: (event)=>setGroupBy(event.target.value),
                        className: "h-control rounded border border-border bg-bg px-3 text-base",
                        "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).issues.reportByType,
                        children: $4f72b7c2271a0dfd$var$GROUPS.map((option)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                value: option.value,
                                children: option.label
                            }, option.value))
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("select", {
                        value: bucket,
                        onChange: (event)=>setBucket(event.target.value),
                        className: "h-control rounded border border-border bg-bg px-3 text-base",
                        "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).issues.reportBucket,
                        children: $4f72b7c2271a0dfd$var$BUCKETS.map((option)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                value: option.value,
                                children: option.label
                            }, option.value))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "min-h-0 flex-1 overflow-auto p-6",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                        error: error
                    }),
                    loading && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {}),
                    !loading && /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "flex flex-col gap-6",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
                                className: "flex flex-col gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                                        className: "text-md font-bold",
                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.reportCount
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$94aefc399ef206a9), {
                                        data: buckets.map((row)=>({
                                                key: row.key,
                                                label: labelFor(row),
                                                value: row.count
                                            })),
                                        valueLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.reportCount,
                                        formatValue: (value)=>(0, $d4d460d3ffb6daab$export$104ee80c24270f18)(value),
                                        emptyLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.noIssues
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
                                className: "flex flex-col gap-3",
                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$54ec01a60f47d33d), {
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$c4c2bc57f2e82919), {
                                            children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.reportBucket
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.reportCount
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.statusResolved
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.reportMedian
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.reportReopen
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7005b8a93a167348), {
                                            children: buckets.map((row)=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                            className: "font-medium",
                                                            children: labelFor(row)
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                            className: "tabular-nums",
                                                            children: (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(row.count)
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                            className: "tabular-nums",
                                                            children: (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(row.resolvedCount)
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                            className: "tabular-nums",
                                                            children: row.medianHoursToResolve === null ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.none : (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(Math.round(row.medianHoursToResolve))
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                            className: "tabular-nums",
                                                            children: row.resolvedCount > 0 ? `${(0, $d4d460d3ffb6daab$export$104ee80c24270f18)(Math.round(row.reopenedCount / row.resolvedCount * 100))}\u{66A}` : (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                                                        })
                                                    ]
                                                }, row.key))
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/**
 * The issues list.
 *
 * URGENT FIRST, then newest — the server orders it, because "what should I
 * look at" is a property of the data rather than of this screen. The orphan
 * badge stays VISIBLE: an issue whose contact was deleted is still work
 * somebody has to finish, and hiding it would leave work nobody can find.
 */ 
var $2M70Q = parcelRequire("2M70Q");


/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $5459f34577228c29$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 3v16a2 2 0 0 0 2 2h16",
            key: "c24i48"
        }
    ],
    [
        "path",
        {
            d: "M18 17V9",
            key: "2bz60n"
        }
    ],
    [
        "path",
        {
            d: "M13 17V5",
            key: "1frdt8"
        }
    ],
    [
        "path",
        {
            d: "M8 17v-3",
            key: "17ska0"
        }
    ]
];
const $5459f34577228c29$export$2e2bcd8739ae039 = (0, $djixo.default)("chart-column", $5459f34577228c29$export$3efd853dbb351e94);


var $6PxCH = parcelRequire("6PxCH");

var $3OyDL = parcelRequire("3OyDL");

var $8B9Zg = parcelRequire("8B9Zg");






const $45a90a4f1a61be33$var$OPEN_STATUSES = [
    'OPEN',
    'IN_PROGRESS',
    'WAITING_ON_CONTACT'
];
function $45a90a4f1a61be33$export$4e7f04199a7ef9d7() {
    const navigate = (0, $8B9Zg.useNavigate)();
    const [page, setPage] = (0, $3OyDL.useState)(1);
    const [statuses, setStatuses] = (0, $3OyDL.useState)($45a90a4f1a61be33$var$OPEN_STATUSES);
    const [search, setSearch] = (0, $3OyDL.useState)('');
    const [creating, setCreating] = (0, $3OyDL.useState)(false);
    const { data: data, loading: loading, refetch: refetch } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $047171b3f4119885$export$f1d9713146d025f5), {
        variables: {
            page: page,
            pageSize: (0, $370d2fd34ead4cb4$export$8ec3d08588d2eeda),
            statuses: statuses,
            search: search.trim() || null
        }
    });
    const issues = data?.issues?.items ?? [];
    const totalCount = data?.issues?.totalCount ?? 0;
    const pageCount = Math.max(1, Math.ceil(totalCount / (0, $370d2fd34ead4cb4$export$8ec3d08588d2eeda)));
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex h-screen flex-col",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("header", {
                className: "flex h-toolbar shrink-0 items-center gap-4 border-b border-border bg-surface px-6",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h1", {
                        className: "text-lg font-bold",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.title
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-sm text-text-muted",
                        children: (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(totalCount)
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "primary",
                        onClick: ()=>setCreating(true),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                                size: 14,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).issues.newIssue
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                        value: search,
                        onChange: (event)=>setSearch(event.target.value),
                        placeholder: (0, $d916753b57975e04$export$25ce5a424b770e84).app.search,
                        className: "h-control w-64 rounded border border-border bg-bg px-3 text-base outline-none focus:border-primary"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $8B9Zg.Link), {
                        to: "/issues/reports",
                        className: "ms-auto flex items-center gap-2 text-sm text-primary",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $5459f34577228c29$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).issues.reports
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: "flex shrink-0 flex-wrap items-center gap-2 border-b border-border bg-surface px-6 py-2",
                children: [
                    {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).app.all,
                        value: null
                    },
                    {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.statusOpen,
                        value: $45a90a4f1a61be33$var$OPEN_STATUSES
                    },
                    {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.statusResolved,
                        value: [
                            'RESOLVED'
                        ]
                    },
                    {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.statusClosed,
                        value: [
                            'CLOSED'
                        ]
                    }
                ].map((option)=>/*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            setStatuses(option.value);
                            setPage(1);
                        },
                        "aria-pressed": JSON.stringify(statuses) === JSON.stringify(option.value),
                        className: `rounded-full border px-3 py-1 text-sm ${JSON.stringify(statuses) === JSON.stringify(option.value) ? 'border-primary bg-primary text-primary-contrast' : 'border-border bg-surface text-text-muted hover:bg-surface-hover'}`,
                        children: option.label
                    }, option.label))
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "min-h-0 flex-1 overflow-auto p-6",
                children: [
                    loading && issues.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                        className: "flex justify-center p-7",
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {})
                    }),
                    !loading && issues.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$fddf379e22a74b00), {
                        title: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.noIssues
                    }),
                    issues.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$54ec01a60f47d33d), {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$c4c2bc57f2e82919), {
                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.priority
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.issueTitle
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.kind
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.type
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.title
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.assignee
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.status
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.reportedAt
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7005b8a93a167348), {
                                children: issues.map((issue)=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                        interactive: true,
                                        onClick: ()=>navigate(`/issues/${issue.id}`),
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                className: `font-medium ${(0, $8be8610b9776ae98$export$bd92a918e489f48a)[issue.priority]}`,
                                                children: (0, $8be8610b9776ae98$export$e1e838806c3b27c5)[issue.priority]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                className: "font-medium",
                                                children: issue.title
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                className: "text-text-muted",
                                                children: (0, $8be8610b9776ae98$export$7b239963c3289a2)[issue.kind]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                className: "text-text-muted",
                                                children: issue.type?.labelFa
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                children: [
                                                    issue.contact ? issue.contact.displayName : (0, $d916753b57975e04$export$25ce5a424b770e84).app.none,
                                                    issue.orphaned && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                                                        className: "ms-2 bg-surface-hover text-warning",
                                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).issues.orphaned
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                className: "text-text-muted",
                                                children: issue.assigneeName ?? (issue.assigneeId ? issue.assigneeId : (0, $d916753b57975e04$export$25ce5a424b770e84).issues.unassigned)
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                className: (0, $8be8610b9776ae98$export$fce5400eb9b3fa56)[issue.status],
                                                children: (0, $8be8610b9776ae98$export$3b558bfbd454e1bc)[issue.status]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                className: "text-text-muted",
                                                children: (0, $d4d460d3ffb6daab$export$3ae94a2503e890a1)(issue.reportedAt)
                                            })
                                        ]
                                    }, issue.id))
                            })
                        ]
                    })
                ]
            }),
            pageCount > 1 && /*#__PURE__*/ (0, $2M70Q.jsxs)("footer", {
                className: "flex h-control shrink-0 items-center justify-center gap-4 border-t border-border bg-surface text-sm",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                        type: "button",
                        disabled: page <= 1,
                        onClick: ()=>setPage((p)=>p - 1),
                        className: "text-primary disabled:text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.previous
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.pageOf((0, $d4d460d3ffb6daab$export$104ee80c24270f18)(page), (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(pageCount))
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                        type: "button",
                        disabled: page >= pageCount,
                        onClick: ()=>setPage((p)=>p + 1),
                        className: "text-primary disabled:text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.next
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4d7077ffa15cf8ad$export$2e00bb6c96d50ef3), {
                open: creating,
                onOpenChange: setCreating,
                onCreated: ()=>refetch()
            })
        ]
    });
}


/**
 * `/settings/automation` — rules, occasions, and the DRY RUN.
 *
 * THE DRY RUN IS THE POINT OF THIS SCREEN. An automation rule sends messages to
 * real doctors without anybody pressing anything, and the only honest way to
 * review one is to ask "who would get what, on this date?" and read the answer.
 * It writes nothing.
 *
 * Occasions are stored in JALALI month/day because that is what the date
 * MEANS: روز پزشک is 1 شهریور every year, and its Gregorian equivalent moves.
 */ 
var $2M70Q = parcelRequire("2M70Q");



var $hb5XY = parcelRequire("hb5XY");
var $6PxCH = parcelRequire("6PxCH");

var $3OyDL = parcelRequire("3OyDL");

/**
 * The settings-specific pieces: a page frame, the active/inactive badge, the
 * `is_system` lock, and the show-inactive toggle. They live here rather than in
 * the design system because they encode *MeshHub's* configuration rules —
 * "deactivate, never delete", "system rows are locked" — not generic visuals.
 *
 * The form primitives moved to `components/FormKit.web.jsx` in Step 3, when
 * contact editing started needing the same dialogs and fields. They are
 * re-exported here so the six settings screens import from one place, and so
 * there is exactly one definition of each.
 */ 
var $2M70Q = parcelRequire("2M70Q");

/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $cfefd3e8f3aca329$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "18",
            height: "11",
            x: "3",
            y: "11",
            rx: "2",
            ry: "2",
            key: "1w4ew1"
        }
    ],
    [
        "path",
        {
            d: "M7 11V7a5 5 0 0 1 10 0v4",
            key: "fwvmzm"
        }
    ]
];
const $cfefd3e8f3aca329$export$2e2bcd8739ae039 = (0, $djixo.default)("lock", $cfefd3e8f3aca329$export$3efd853dbb351e94);


parcelRequire("3OyDL");


function $287828886661deba$export$8f6dcfe950367406({ title: title, hint: hint, toolbar: toolbar, children: children }) {
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex h-screen flex-col",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("header", {
                className: "flex h-toolbar shrink-0 items-center gap-4 border-b border-border bg-surface px-6",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h1", {
                        className: "text-lg font-bold",
                        children: title
                    }),
                    hint && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-sm text-text-muted",
                        children: hint
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                        className: "ms-auto flex items-center gap-3",
                        children: toolbar
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: "min-h-0 flex-1 overflow-auto p-6",
                children: children
            })
        ]
    });
}
function $287828886661deba$export$cb8f259c2accb9d1({ isActive: isActive }) {
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
        className: isActive ? 'bg-surface-hover text-success' : 'bg-surface-hover text-text-muted',
        children: isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.active : (0, $d916753b57975e04$export$25ce5a424b770e84).app.inactive
    });
}
function $287828886661deba$export$1b6bbf917c8fdc0c({ isSystem: isSystem }) {
    if (!isSystem) return null;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
        className: "flex items-center gap-1 text-xs text-text-muted",
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.systemLocked,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $cfefd3e8f3aca329$export$2e2bcd8739ae039), {
                size: 12,
                "aria-hidden": "true"
            }),
            (0, $d916753b57975e04$export$25ce5a424b770e84).app.system
        ]
    });
}
function $287828886661deba$export$13da608e8f9e10fe({ checked: checked, onChange: onChange }) {
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("label", {
        className: "flex items-center gap-2 text-sm text-text-muted",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                type: "checkbox",
                checked: checked,
                onChange: (event)=>onChange(event.target.checked),
                className: "accent-primary"
            }),
            (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.showInactive
        ]
    });
}





const $ecf0f3812bdd66f0$var$TRIGGER_LABELS = {
    BIRTHDAY: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.triggerBirthday,
    OCCASION: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.triggerOccasion,
    STATUS_CHANGED: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.triggerStatusChanged,
    ISSUE_RESOLVED: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.triggerIssueResolved
};
function $ecf0f3812bdd66f0$export$bfdea316a467e3e5() {
    const { data: data, loading: loading, refetch: refetch } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $047171b3f4119885$export$7a07355bc01f6db9), {
        variables: {
            includeDisabled: true
        }
    });
    const { data: templateData } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$53468eed769bf661), {
        variables: {
            includeInactive: false
        },
        errorPolicy: 'ignore'
    });
    const [toggle, toggleState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$cd33e63553c99333), {
        onCompleted: ()=>refetch()
    });
    const [creatingRule, setCreatingRule] = (0, $3OyDL.useState)(false);
    const [creatingOccasion, setCreatingOccasion] = (0, $3OyDL.useState)(false);
    const rules = data?.automationRules ?? [];
    const occasions = data?.occasions ?? [];
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $287828886661deba$export$8f6dcfe950367406), {
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.title,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: toggleState.error
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
                className: "flex flex-col gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                                className: "text-md font-bold",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.rules
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                variant: "primary",
                                onClick: ()=>setCreatingRule(true),
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                                        size: 13,
                                        "aria-hidden": "true"
                                    }),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).automation.newRule
                                ]
                            })
                        ]
                    }),
                    loading && rules.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {}),
                    !loading && rules.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$fddf379e22a74b00), {
                        title: (0, $d916753b57975e04$export$25ce5a424b770e84).app.notFound
                    }),
                    rules.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$54ec01a60f47d33d), {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$c4c2bc57f2e82919), {
                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.ruleName
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.trigger
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.sendTime
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.enabled
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7005b8a93a167348), {
                                children: rules.map((rule)=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                className: "font-medium",
                                                children: rule.name
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                                                    className: "bg-surface-hover",
                                                    children: $ecf0f3812bdd66f0$var$TRIGGER_LABELS[rule.trigger] ?? rule.trigger
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                dir: "ltr",
                                                className: "text-start tabular-nums",
                                                children: rule.sendTimeLocal || (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)("label", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                                                            type: "checkbox",
                                                            className: "accent-primary",
                                                            checked: rule.enabled,
                                                            onChange: (event)=>toggle({
                                                                    variables: {
                                                                        id: rule.id,
                                                                        enabled: event.target.checked
                                                                    }
                                                                })
                                                        }),
                                                        rule.enabled ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.active : (0, $d916753b57975e04$export$25ce5a424b770e84).app.inactive
                                                    ]
                                                })
                                            })
                                        ]
                                    }, rule.id))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
                className: "flex flex-col gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                                className: "text-md font-bold",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.occasions
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                variant: "primary",
                                onClick: ()=>setCreatingOccasion(true),
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                                        size: 13,
                                        "aria-hidden": "true"
                                    }),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).automation.newOccasion
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$54ec01a60f47d33d), {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$c4c2bc57f2e82919), {
                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.occasionLabel
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.occasionCode
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.jalaliMonth
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.jalaliDay
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7005b8a93a167348), {
                                children: occasions.map((occasion)=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                className: "font-medium",
                                                children: occasion.labelFa
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                dir: "ltr",
                                                className: "text-start text-text-muted",
                                                children: occasion.code
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                children: (0, $d4d460d3ffb6daab$export$3d5cc8a1339f76b9)[occasion.jalaliMonth - 1]
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                className: "tabular-nums",
                                                children: (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(occasion.jalaliDay)
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $287828886661deba$export$1b6bbf917c8fdc0c), {
                                                    isSystem: occasion.isSystem
                                                })
                                            })
                                        ]
                                    }, occasion.id))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)($ecf0f3812bdd66f0$var$DryRunCard, {}),
            /*#__PURE__*/ (0, $2M70Q.jsx)($ecf0f3812bdd66f0$var$RuleDialog, {
                open: creatingRule,
                onOpenChange: setCreatingRule,
                templates: templateData?.messageTemplates ?? [],
                occasions: occasions,
                onCreated: refetch
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)($ecf0f3812bdd66f0$var$OccasionDialog, {
                open: creatingOccasion,
                onOpenChange: setCreatingOccasion,
                onCreated: refetch
            })
        ]
    });
}
function $ecf0f3812bdd66f0$var$DryRunCard() {
    const [date, setDate] = (0, $3OyDL.useState)('');
    const [run, { data: data, loading: loading, error: error }] = (0, $08c81aa164c88db1$export$fd83eea6ecd2d8fa)((0, $047171b3f4119885$export$3e464326d9b05f59), {
        fetchPolicy: 'network-only'
    });
    const entries = data?.automationDryRun ?? [];
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
        className: "flex flex-col gap-3",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                className: "text-md font-bold",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.dryRun
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-sm text-text-muted",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.dryRunHint
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex items-end gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("label", {
                        className: "flex flex-col gap-1 text-sm",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                className: "text-text-muted",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.dryRunDate
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                                type: "date",
                                value: date,
                                onChange: (event)=>setDate(event.target.value),
                                className: "h-control rounded border border-border bg-bg px-3 text-base outline-none focus:border-primary"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "primary",
                        onClick: ()=>run({
                                variables: {
                                    localDate: date || null
                                }
                            }),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $hb5XY.default), {
                                size: 13,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).automation.dryRun
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: error
            }),
            loading && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {}),
            !loading && data && entries.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$fddf379e22a74b00), {
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.dryRunEmpty
            }),
            entries.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$54ec01a60f47d33d), {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$c4c2bc57f2e82919), {
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.recipient
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.ruleName
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.body
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7005b8a93a167348), {
                        children: entries.map((entry)=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        className: "font-medium",
                                        children: entry.displayName
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        className: "text-text-muted",
                                        children: [
                                            entry.ruleName,
                                            " \xb7 ",
                                            entry.reason
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        className: "text-text-muted",
                                        children: entry.renderedBody
                                    })
                                ]
                            }, `${entry.ruleId}:${entry.contactId}`))
                    })
                ]
            })
        ]
    });
}
function $ecf0f3812bdd66f0$var$RuleDialog({ open: open, onOpenChange: onOpenChange, templates: templates, occasions: occasions, onCreated: onCreated }) {
    const [name, setName] = (0, $3OyDL.useState)('');
    const [trigger, setTrigger] = (0, $3OyDL.useState)('BIRTHDAY');
    const [templateId, setTemplateId] = (0, $3OyDL.useState)('');
    const [occasionCode, setOccasionCode] = (0, $3OyDL.useState)('');
    const [toStatus, setToStatus] = (0, $3OyDL.useState)('SUBSCRIBER');
    const [create, { loading: loading, error: error }] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$1d3239ed8df5698f));
    const config = ()=>{
        if (trigger === 'OCCASION') return JSON.stringify({
            occasion_code: occasionCode
        });
        if (trigger === 'STATUS_CHANGED') return JSON.stringify({
            to_status: toStatus
        });
        return '{}';
    };
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: open,
        onOpenChange: onOpenChange,
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.newRule,
        submitLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).app.create,
        busy: loading,
        error: error,
        canSubmit: Boolean(name.trim() && templateId),
        onSubmit: async ()=>{
            await create({
                variables: {
                    name: name.trim(),
                    trigger: trigger,
                    templateId: templateId,
                    triggerConfigJson: config()
                }
            });
            setName('');
            onOpenChange(false);
            onCreated();
        },
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.ruleName,
                value: name,
                onChange: (event)=>setName(event.target.value)
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.trigger,
                value: trigger,
                onChange: (event)=>setTrigger(event.target.value),
                children: Object.entries($ecf0f3812bdd66f0$var$TRIGGER_LABELS).map(([value, label])=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: value,
                        children: label
                    }, value))
            }),
            trigger === 'OCCASION' && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.occasions,
                value: occasionCode,
                onChange: (event)=>setOccasionCode(event.target.value),
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: "",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    occasions.map((occasion)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                            value: occasion.code,
                            children: occasion.labelFa
                        }, occasion.id))
                ]
            }),
            trigger === 'STATUS_CHANGED' && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.toStatus,
                value: toStatus,
                onChange: (event)=>setToStatus(event.target.value),
                children: [
                    'UNKNOWN',
                    'INTERESTED',
                    'CONSULTING',
                    'SUBSCRIBER'
                ].map((value)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: value,
                        children: value
                    }, value))
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).messaging.template,
                value: templateId,
                onChange: (event)=>setTemplateId(event.target.value),
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: "",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    }),
                    templates.map((template)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                            value: template.id,
                            children: template.name
                        }, template.id))
                ]
            })
        ]
    });
}
function $ecf0f3812bdd66f0$var$OccasionDialog({ open: open, onOpenChange: onOpenChange, onCreated: onCreated }) {
    const [code, setCode] = (0, $3OyDL.useState)('');
    const [labelFa, setLabelFa] = (0, $3OyDL.useState)('');
    const [month, setMonth] = (0, $3OyDL.useState)(1);
    const [day, setDay] = (0, $3OyDL.useState)(1);
    const [create, { loading: loading, error: error }] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$1e93a0f3b2de7317));
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: open,
        onOpenChange: onOpenChange,
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.newOccasion,
        submitLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).app.create,
        busy: loading,
        error: error,
        canSubmit: Boolean(code.trim() && labelFa.trim()),
        onSubmit: async ()=>{
            await create({
                variables: {
                    code: code.trim().toUpperCase(),
                    labelFa: labelFa.trim(),
                    jalaliMonth: Number(month),
                    jalaliDay: Number(day)
                }
            });
            setCode('');
            setLabelFa('');
            onOpenChange(false);
            onCreated();
        },
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.occasionCode,
                dir: "ltr",
                value: code,
                onChange: (event)=>setCode(event.target.value)
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.occasionLabel,
                value: labelFa,
                onChange: (event)=>setLabelFa(event.target.value)
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.jalaliMonth,
                value: month,
                onChange: (event)=>setMonth(event.target.value),
                children: (0, $d4d460d3ffb6daab$export$3d5cc8a1339f76b9).map((label, index)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: index + 1,
                        children: label
                    }, label))
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.jalaliDay,
                value: day,
                onChange: (event)=>setDay(event.target.value),
                children: Array.from({
                    length: 31
                }, (_, i)=>i + 1).map((value)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: value,
                        children: (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(value)
                    }, value))
            })
        ]
    });
}


/**
 * `/settings/whatsapp` — this deployment's numbers, the pairing flow, and the
 * ban notice.
 *
 * THE RISK NOTICE IS NOT DECORATION. MeshHub speaks WhatsApp's unofficial Web
 * protocol; a linked number can be rate-limited or banned. Somebody about to
 * link a real business number should read that on the screen where they do it,
 * not only in a document they may never open. With several numbers it matters
 * MORE, not less: the warm-up is per number, because WhatsApp has never heard
 * of the new one (docs/whatsapp-multi-account.md §7).
 *
 * THE QR ARRIVES OVER SSE, because it ROTATES: WhatsApp expires each code after
 * about twenty seconds. A unary "give me the QR" would show one that is
 * already dead. The countdown is part of the design — «چرا هیچ اتفاقی
 * نمی‌افتد» is the usual failure here, and a number ticking down answers it.
 *
 * TWO HALVES, NEVER FLATTENED. `label` and `isDefault` are MeshHub's
 * configuration; `linked` and `connected` are the gateway's live answer. A
 * configured-but-unpaired number is the normal state of one nobody has scanned
 * yet, and rendering it as connected would read as «ready to send» for a
 * number that cannot.
 *
 * IT DEGRADES TO ONE NUMBER. A deployment that has never named an account has
 * no rows, sends from the legacy number, and sees the single connection card
 * this screen has always shown — so upgrading changes nothing until somebody
 * chooses to.
 */ 
var $2M70Q = parcelRequire("2M70Q");



var $6tkl0 = parcelRequire("6tkl0");
var $ks4jt = parcelRequire("ks4jt");
var $2vK0R = parcelRequire("2vK0R");
var $6PxCH = parcelRequire("6PxCH");/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $e91ad3707c8273fb$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
            key: "r04s7s"
        }
    ]
];
const $e91ad3707c8273fb$export$2e2bcd8739ae039 = (0, $djixo.default)("star", $e91ad3707c8273fb$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $41dbd9baa470cf33$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71",
            key: "yqzxt4"
        }
    ],
    [
        "path",
        {
            d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71",
            key: "4qinb0"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "8",
            y1: "2",
            y2: "5",
            key: "1041cp"
        }
    ],
    [
        "line",
        {
            x1: "2",
            x2: "5",
            y1: "8",
            y2: "8",
            key: "14m1p5"
        }
    ],
    [
        "line",
        {
            x1: "16",
            x2: "16",
            y1: "19",
            y2: "22",
            key: "rzdirn"
        }
    ],
    [
        "line",
        {
            x1: "19",
            x2: "22",
            y1: "16",
            y2: "16",
            key: "ox905f"
        }
    ]
];
const $41dbd9baa470cf33$export$2e2bcd8739ae039 = (0, $djixo.default)("unlink", $41dbd9baa470cf33$export$3efd853dbb351e94);



var $3OyDL = parcelRequire("3OyDL");

/**
 * A scannable QR code, as inline SVG.
 *
 * WHY THIS EXISTS AT ALL. The pairing screen used to render the WhatsApp
 * payload as its raw TEXT and ask the operator to paste it into some other QR
 * renderer — recorded in ui.md as a gap since Step 5, because drawing one
 * needs an encoder and the brief said to ask before adding a dependency. It is
 * the first thing anybody does with the WhatsApp feature and the one screen
 * that has to work on the first try, so it is now drawn here.
 *
 * `qrcode-generator` does the encoding: Reed-Solomon, mask selection and
 * version choice are genuinely subtle, and a hand-rolled encoder whose failure
 * mode is «scans on my phone, not on yours» is the worst possible thing to
 * home-grow. It has ZERO transitive dependencies and returns a module matrix
 * rather than an image, so the drawing stays here and stays on design tokens.
 *
 * SVG rather than a canvas: it scales to any density without going soft, it
 * needs no ref or effect, and it renders identically in jsdom — so the test
 * can count modules instead of asserting a component was mounted.
 */ 
var $2M70Q = parcelRequire("2M70Q");
var $fab4f7c5f0db28e3$exports = {};
//---------------------------------------------------------------------
//
// QR Code Generator for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//  http://www.opensource.org/licenses/mit-license.php
//
// The word 'QR Code' is registered trademark of
// DENSO WAVE INCORPORATED
//  http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
var $fab4f7c5f0db28e3$var$qrcode = function() {
    //---------------------------------------------------------------------
    // qrcode
    //---------------------------------------------------------------------
    /**
   * qrcode
   * @param typeNumber 1 to 40
   * @param errorCorrectionLevel 'L','M','Q','H'
   */ var qrcode = function(typeNumber, errorCorrectionLevel) {
        var PAD0 = 0xEC;
        var PAD1 = 0x11;
        var _typeNumber = typeNumber;
        var _errorCorrectionLevel = QRErrorCorrectionLevel[errorCorrectionLevel];
        var _modules = null;
        var _moduleCount = 0;
        var _dataCache = null;
        var _dataList = [];
        var _this = {};
        var makeImpl = function(test, maskPattern) {
            _moduleCount = _typeNumber * 4 + 17;
            _modules = function(moduleCount) {
                var modules = new Array(moduleCount);
                for(var row = 0; row < moduleCount; row += 1){
                    modules[row] = new Array(moduleCount);
                    for(var col = 0; col < moduleCount; col += 1)modules[row][col] = null;
                }
                return modules;
            }(_moduleCount);
            setupPositionProbePattern(0, 0);
            setupPositionProbePattern(_moduleCount - 7, 0);
            setupPositionProbePattern(0, _moduleCount - 7);
            setupPositionAdjustPattern();
            setupTimingPattern();
            setupTypeInfo(test, maskPattern);
            if (_typeNumber >= 7) setupTypeNumber(test);
            if (_dataCache == null) _dataCache = createData(_typeNumber, _errorCorrectionLevel, _dataList);
            mapData(_dataCache, maskPattern);
        };
        var setupPositionProbePattern = function(row, col) {
            for(var r = -1; r <= 7; r += 1){
                if (row + r <= -1 || _moduleCount <= row + r) continue;
                for(var c = -1; c <= 7; c += 1){
                    if (col + c <= -1 || _moduleCount <= col + c) continue;
                    if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) _modules[row + r][col + c] = true;
                    else _modules[row + r][col + c] = false;
                }
            }
        };
        var getBestMaskPattern = function() {
            var minLostPoint = 0;
            var pattern = 0;
            for(var i = 0; i < 8; i += 1){
                makeImpl(true, i);
                var lostPoint = QRUtil.getLostPoint(_this);
                if (i == 0 || minLostPoint > lostPoint) {
                    minLostPoint = lostPoint;
                    pattern = i;
                }
            }
            return pattern;
        };
        var setupTimingPattern = function() {
            for(var r = 8; r < _moduleCount - 8; r += 1){
                if (_modules[r][6] != null) continue;
                _modules[r][6] = r % 2 == 0;
            }
            for(var c = 8; c < _moduleCount - 8; c += 1){
                if (_modules[6][c] != null) continue;
                _modules[6][c] = c % 2 == 0;
            }
        };
        var setupPositionAdjustPattern = function() {
            var pos = QRUtil.getPatternPosition(_typeNumber);
            for(var i = 0; i < pos.length; i += 1)for(var j = 0; j < pos.length; j += 1){
                var row = pos[i];
                var col = pos[j];
                if (_modules[row][col] != null) continue;
                for(var r = -2; r <= 2; r += 1){
                    for(var c = -2; c <= 2; c += 1)if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) _modules[row + r][col + c] = true;
                    else _modules[row + r][col + c] = false;
                }
            }
        };
        var setupTypeNumber = function(test) {
            var bits = QRUtil.getBCHTypeNumber(_typeNumber);
            for(var i = 0; i < 18; i += 1){
                var mod = !test && (bits >> i & 1) == 1;
                _modules[Math.floor(i / 3)][i % 3 + _moduleCount - 8 - 3] = mod;
            }
            for(var i = 0; i < 18; i += 1){
                var mod = !test && (bits >> i & 1) == 1;
                _modules[i % 3 + _moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
            }
        };
        var setupTypeInfo = function(test, maskPattern) {
            var data = _errorCorrectionLevel << 3 | maskPattern;
            var bits = QRUtil.getBCHTypeInfo(data);
            // vertical
            for(var i = 0; i < 15; i += 1){
                var mod = !test && (bits >> i & 1) == 1;
                if (i < 6) _modules[i][8] = mod;
                else if (i < 8) _modules[i + 1][8] = mod;
                else _modules[_moduleCount - 15 + i][8] = mod;
            }
            // horizontal
            for(var i = 0; i < 15; i += 1){
                var mod = !test && (bits >> i & 1) == 1;
                if (i < 8) _modules[8][_moduleCount - i - 1] = mod;
                else if (i < 9) _modules[8][15 - i - 1 + 1] = mod;
                else _modules[8][15 - i - 1] = mod;
            }
            // fixed module
            _modules[_moduleCount - 8][8] = !test;
        };
        var mapData = function(data, maskPattern) {
            var inc = -1;
            var row = _moduleCount - 1;
            var bitIndex = 7;
            var byteIndex = 0;
            var maskFunc = QRUtil.getMaskFunction(maskPattern);
            for(var col = _moduleCount - 1; col > 0; col -= 2){
                if (col == 6) col -= 1;
                while(true){
                    for(var c = 0; c < 2; c += 1)if (_modules[row][col - c] == null) {
                        var dark = false;
                        if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) == 1;
                        var mask = maskFunc(row, col - c);
                        if (mask) dark = !dark;
                        _modules[row][col - c] = dark;
                        bitIndex -= 1;
                        if (bitIndex == -1) {
                            byteIndex += 1;
                            bitIndex = 7;
                        }
                    }
                    row += inc;
                    if (row < 0 || _moduleCount <= row) {
                        row -= inc;
                        inc = -inc;
                        break;
                    }
                }
            }
        };
        var createBytes = function(buffer, rsBlocks) {
            var offset = 0;
            var maxDcCount = 0;
            var maxEcCount = 0;
            var dcdata = new Array(rsBlocks.length);
            var ecdata = new Array(rsBlocks.length);
            for(var r = 0; r < rsBlocks.length; r += 1){
                var dcCount = rsBlocks[r].dataCount;
                var ecCount = rsBlocks[r].totalCount - dcCount;
                maxDcCount = Math.max(maxDcCount, dcCount);
                maxEcCount = Math.max(maxEcCount, ecCount);
                dcdata[r] = new Array(dcCount);
                for(var i = 0; i < dcdata[r].length; i += 1)dcdata[r][i] = 0xff & buffer.getBuffer()[i + offset];
                offset += dcCount;
                var rsPoly = QRUtil.getErrorCorrectPolynomial(ecCount);
                var rawPoly = qrPolynomial(dcdata[r], rsPoly.getLength() - 1);
                var modPoly = rawPoly.mod(rsPoly);
                ecdata[r] = new Array(rsPoly.getLength() - 1);
                for(var i = 0; i < ecdata[r].length; i += 1){
                    var modIndex = i + modPoly.getLength() - ecdata[r].length;
                    ecdata[r][i] = modIndex >= 0 ? modPoly.getAt(modIndex) : 0;
                }
            }
            var totalCodeCount = 0;
            for(var i = 0; i < rsBlocks.length; i += 1)totalCodeCount += rsBlocks[i].totalCount;
            var data = new Array(totalCodeCount);
            var index = 0;
            for(var i = 0; i < maxDcCount; i += 1){
                for(var r = 0; r < rsBlocks.length; r += 1)if (i < dcdata[r].length) {
                    data[index] = dcdata[r][i];
                    index += 1;
                }
            }
            for(var i = 0; i < maxEcCount; i += 1){
                for(var r = 0; r < rsBlocks.length; r += 1)if (i < ecdata[r].length) {
                    data[index] = ecdata[r][i];
                    index += 1;
                }
            }
            return data;
        };
        var createData = function(typeNumber, errorCorrectionLevel, dataList) {
            var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, errorCorrectionLevel);
            var buffer = qrBitBuffer();
            for(var i = 0; i < dataList.length; i += 1){
                var data = dataList[i];
                buffer.put(data.getMode(), 4);
                buffer.put(data.getLength(), QRUtil.getLengthInBits(data.getMode(), typeNumber));
                data.write(buffer);
            }
            // calc num max data.
            var totalDataCount = 0;
            for(var i = 0; i < rsBlocks.length; i += 1)totalDataCount += rsBlocks[i].dataCount;
            if (buffer.getLengthInBits() > totalDataCount * 8) throw 'code length overflow. (' + buffer.getLengthInBits() + '>' + totalDataCount * 8 + ')';
            // end code
            if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) buffer.put(0, 4);
            // padding
            while(buffer.getLengthInBits() % 8 != 0)buffer.putBit(false);
            // padding
            while(true){
                if (buffer.getLengthInBits() >= totalDataCount * 8) break;
                buffer.put(PAD0, 8);
                if (buffer.getLengthInBits() >= totalDataCount * 8) break;
                buffer.put(PAD1, 8);
            }
            return createBytes(buffer, rsBlocks);
        };
        _this.addData = function(data, mode) {
            mode = mode || 'Byte';
            var newData = null;
            switch(mode){
                case 'Numeric':
                    newData = qrNumber(data);
                    break;
                case 'Alphanumeric':
                    newData = qrAlphaNum(data);
                    break;
                case 'Byte':
                    newData = qr8BitByte(data);
                    break;
                case 'Kanji':
                    newData = qrKanji(data);
                    break;
                default:
                    throw 'mode:' + mode;
            }
            _dataList.push(newData);
            _dataCache = null;
        };
        _this.isDark = function(row, col) {
            if (row < 0 || _moduleCount <= row || col < 0 || _moduleCount <= col) throw row + ',' + col;
            return _modules[row][col];
        };
        _this.getModuleCount = function() {
            return _moduleCount;
        };
        _this.make = function() {
            if (_typeNumber < 1) {
                var typeNumber = 1;
                for(; typeNumber < 40; typeNumber++){
                    var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, _errorCorrectionLevel);
                    var buffer = qrBitBuffer();
                    for(var i = 0; i < _dataList.length; i++){
                        var data = _dataList[i];
                        buffer.put(data.getMode(), 4);
                        buffer.put(data.getLength(), QRUtil.getLengthInBits(data.getMode(), typeNumber));
                        data.write(buffer);
                    }
                    var totalDataCount = 0;
                    for(var i = 0; i < rsBlocks.length; i++)totalDataCount += rsBlocks[i].dataCount;
                    if (buffer.getLengthInBits() <= totalDataCount * 8) break;
                }
                _typeNumber = typeNumber;
            }
            makeImpl(false, getBestMaskPattern());
        };
        _this.createTableTag = function(cellSize, margin) {
            cellSize = cellSize || 2;
            margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
            var qrHtml = '';
            qrHtml += '<table style="';
            qrHtml += ' border-width: 0px; border-style: none;';
            qrHtml += ' border-collapse: collapse;';
            qrHtml += ' padding: 0px; margin: ' + margin + 'px;';
            qrHtml += '">';
            qrHtml += '<tbody>';
            for(var r = 0; r < _this.getModuleCount(); r += 1){
                qrHtml += '<tr>';
                for(var c = 0; c < _this.getModuleCount(); c += 1){
                    qrHtml += '<td style="';
                    qrHtml += ' border-width: 0px; border-style: none;';
                    qrHtml += ' border-collapse: collapse;';
                    qrHtml += ' padding: 0px; margin: 0px;';
                    qrHtml += ' width: ' + cellSize + 'px;';
                    qrHtml += ' height: ' + cellSize + 'px;';
                    qrHtml += ' background-color: ';
                    qrHtml += _this.isDark(r, c) ? '#000000' : '#ffffff';
                    qrHtml += ';';
                    qrHtml += '"/>';
                }
                qrHtml += '</tr>';
            }
            qrHtml += '</tbody>';
            qrHtml += '</table>';
            return qrHtml;
        };
        _this.createSvgTag = function(cellSize, margin, alt, title) {
            var opts = {};
            if (typeof arguments[0] == 'object') {
                // Called by options.
                opts = arguments[0];
                // overwrite cellSize and margin.
                cellSize = opts.cellSize;
                margin = opts.margin;
                alt = opts.alt;
                title = opts.title;
            }
            cellSize = cellSize || 2;
            margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
            // Compose alt property surrogate
            alt = typeof alt === 'string' ? {
                text: alt
            } : alt || {};
            alt.text = alt.text || null;
            alt.id = alt.text ? alt.id || 'qrcode-description' : null;
            // Compose title property surrogate
            title = typeof title === 'string' ? {
                text: title
            } : title || {};
            title.text = title.text || null;
            title.id = title.text ? title.id || 'qrcode-title' : null;
            var size = _this.getModuleCount() * cellSize + margin * 2;
            var c, mc, r, mr, qrSvg = '', rect;
            rect = 'l' + cellSize + ',0 0,' + cellSize + ' -' + cellSize + ',0 0,-' + cellSize + 'z ';
            qrSvg += '<svg version="1.1" xmlns="http://www.w3.org/2000/svg"';
            qrSvg += !opts.scalable ? ' width="' + size + 'px" height="' + size + 'px"' : '';
            qrSvg += ' viewBox="0 0 ' + size + ' ' + size + '" ';
            qrSvg += ' preserveAspectRatio="xMinYMin meet"';
            qrSvg += title.text || alt.text ? ' role="img" aria-labelledby="' + escapeXml([
                title.id,
                alt.id
            ].join(' ').trim()) + '"' : '';
            qrSvg += '>';
            qrSvg += title.text ? '<title id="' + escapeXml(title.id) + '">' + escapeXml(title.text) + '</title>' : '';
            qrSvg += alt.text ? '<description id="' + escapeXml(alt.id) + '">' + escapeXml(alt.text) + '</description>' : '';
            qrSvg += '<rect width="100%" height="100%" fill="white" cx="0" cy="0"/>';
            qrSvg += '<path d="';
            for(r = 0; r < _this.getModuleCount(); r += 1){
                mr = r * cellSize + margin;
                for(c = 0; c < _this.getModuleCount(); c += 1)if (_this.isDark(r, c)) {
                    mc = c * cellSize + margin;
                    qrSvg += 'M' + mc + ',' + mr + rect;
                }
            }
            qrSvg += '" stroke="transparent" fill="black"/>';
            qrSvg += '</svg>';
            return qrSvg;
        };
        _this.createDataURL = function(cellSize, margin) {
            cellSize = cellSize || 2;
            margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
            var size = _this.getModuleCount() * cellSize + margin * 2;
            var min = margin;
            var max = size - margin;
            return createDataURL(size, size, function(x, y) {
                if (min <= x && x < max && min <= y && y < max) {
                    var c = Math.floor((x - min) / cellSize);
                    var r = Math.floor((y - min) / cellSize);
                    return _this.isDark(r, c) ? 0 : 1;
                } else return 1;
            });
        };
        _this.createImgTag = function(cellSize, margin, alt) {
            cellSize = cellSize || 2;
            margin = typeof margin == 'undefined' ? cellSize * 4 : margin;
            var size = _this.getModuleCount() * cellSize + margin * 2;
            var img = '';
            img += '<img';
            img += '\u0020src="';
            img += _this.createDataURL(cellSize, margin);
            img += '"';
            img += '\u0020width="';
            img += size;
            img += '"';
            img += '\u0020height="';
            img += size;
            img += '"';
            if (alt) {
                img += '\u0020alt="';
                img += escapeXml(alt);
                img += '"';
            }
            img += '/>';
            return img;
        };
        var escapeXml = function(s) {
            var escaped = '';
            for(var i = 0; i < s.length; i += 1){
                var c = s.charAt(i);
                switch(c){
                    case '<':
                        escaped += '&lt;';
                        break;
                    case '>':
                        escaped += '&gt;';
                        break;
                    case '&':
                        escaped += '&amp;';
                        break;
                    case '"':
                        escaped += '&quot;';
                        break;
                    default:
                        escaped += c;
                        break;
                }
            }
            return escaped;
        };
        var _createHalfASCII = function(margin) {
            var cellSize = 1;
            margin = typeof margin == 'undefined' ? cellSize * 2 : margin;
            var size = _this.getModuleCount() * cellSize + margin * 2;
            var min = margin;
            var max = size - margin;
            var y, x, r1, r2, p;
            var blocks = {
                "\u2588\u2588": "\u2588",
                "\u2588 ": "\u2580",
                " \u2588": "\u2584",
                '  ': ' '
            };
            var blocksLastLineNoMargin = {
                "\u2588\u2588": "\u2580",
                "\u2588 ": "\u2580",
                " \u2588": ' ',
                '  ': ' '
            };
            var ascii = '';
            for(y = 0; y < size; y += 2){
                r1 = Math.floor((y - min) / cellSize);
                r2 = Math.floor((y + 1 - min) / cellSize);
                for(x = 0; x < size; x += 1){
                    p = "\u2588";
                    if (min <= x && x < max && min <= y && y < max && _this.isDark(r1, Math.floor((x - min) / cellSize))) p = ' ';
                    if (min <= x && x < max && min <= y + 1 && y + 1 < max && _this.isDark(r2, Math.floor((x - min) / cellSize))) p += ' ';
                    else p += "\u2588";
                    // Output 2 characters per pixel, to create full square. 1 character per pixels gives only half width of square.
                    ascii += margin < 1 && y + 1 >= max ? blocksLastLineNoMargin[p] : blocks[p];
                }
                ascii += '\n';
            }
            if (size % 2 && margin > 0) return ascii.substring(0, ascii.length - size - 1) + Array(size + 1).join("\u2580");
            return ascii.substring(0, ascii.length - 1);
        };
        _this.createASCII = function(cellSize, margin) {
            cellSize = cellSize || 1;
            if (cellSize < 2) return _createHalfASCII(margin);
            cellSize -= 1;
            margin = typeof margin == 'undefined' ? cellSize * 2 : margin;
            var size = _this.getModuleCount() * cellSize + margin * 2;
            var min = margin;
            var max = size - margin;
            var y, x, r, p;
            var white = Array(cellSize + 1).join("\u2588\u2588");
            var black = Array(cellSize + 1).join('  ');
            var ascii = '';
            var line = '';
            for(y = 0; y < size; y += 1){
                r = Math.floor((y - min) / cellSize);
                line = '';
                for(x = 0; x < size; x += 1){
                    p = 1;
                    if (min <= x && x < max && min <= y && y < max && _this.isDark(r, Math.floor((x - min) / cellSize))) p = 0;
                    // Output 2 characters per pixel, to create full square. 1 character per pixels gives only half width of square.
                    line += p ? white : black;
                }
                for(r = 0; r < cellSize; r += 1)ascii += line + '\n';
            }
            return ascii.substring(0, ascii.length - 1);
        };
        _this.renderTo2dContext = function(context, cellSize) {
            cellSize = cellSize || 2;
            var length = _this.getModuleCount();
            for(var row = 0; row < length; row++)for(var col = 0; col < length; col++){
                context.fillStyle = _this.isDark(row, col) ? 'black' : 'white';
                context.fillRect(row * cellSize, col * cellSize, cellSize, cellSize);
            }
        };
        return _this;
    };
    //---------------------------------------------------------------------
    // qrcode.stringToBytes
    //---------------------------------------------------------------------
    qrcode.stringToBytesFuncs = {
        'default': function(s) {
            var bytes = [];
            for(var i = 0; i < s.length; i += 1){
                var c = s.charCodeAt(i);
                bytes.push(c & 0xff);
            }
            return bytes;
        }
    };
    qrcode.stringToBytes = qrcode.stringToBytesFuncs['default'];
    //---------------------------------------------------------------------
    // qrcode.createStringToBytes
    //---------------------------------------------------------------------
    /**
   * @param unicodeData base64 string of byte array.
   * [16bit Unicode],[16bit Bytes], ...
   * @param numChars
   */ qrcode.createStringToBytes = function(unicodeData, numChars) {
        // create conversion map.
        var unicodeMap = function() {
            var bin = base64DecodeInputStream(unicodeData);
            var read = function() {
                var b = bin.read();
                if (b == -1) throw 'eof';
                return b;
            };
            var count = 0;
            var unicodeMap = {};
            while(true){
                var b0 = bin.read();
                if (b0 == -1) break;
                var b1 = read();
                var b2 = read();
                var b3 = read();
                var k = String.fromCharCode(b0 << 8 | b1);
                var v = b2 << 8 | b3;
                unicodeMap[k] = v;
                count += 1;
            }
            if (count != numChars) throw count + ' != ' + numChars;
            return unicodeMap;
        }();
        var unknownChar = '?'.charCodeAt(0);
        return function(s) {
            var bytes = [];
            for(var i = 0; i < s.length; i += 1){
                var c = s.charCodeAt(i);
                if (c < 128) bytes.push(c);
                else {
                    var b = unicodeMap[s.charAt(i)];
                    if (typeof b == 'number') {
                        if ((b & 0xff) == b) // 1byte
                        bytes.push(b);
                        else {
                            // 2bytes
                            bytes.push(b >>> 8);
                            bytes.push(b & 0xff);
                        }
                    } else bytes.push(unknownChar);
                }
            }
            return bytes;
        };
    };
    //---------------------------------------------------------------------
    // QRMode
    //---------------------------------------------------------------------
    var QRMode = {
        MODE_NUMBER: 1,
        MODE_ALPHA_NUM: 2,
        MODE_8BIT_BYTE: 4,
        MODE_KANJI: 8
    };
    //---------------------------------------------------------------------
    // QRErrorCorrectionLevel
    //---------------------------------------------------------------------
    var QRErrorCorrectionLevel = {
        L: 1,
        M: 0,
        Q: 3,
        H: 2
    };
    //---------------------------------------------------------------------
    // QRMaskPattern
    //---------------------------------------------------------------------
    var QRMaskPattern = {
        PATTERN000: 0,
        PATTERN001: 1,
        PATTERN010: 2,
        PATTERN011: 3,
        PATTERN100: 4,
        PATTERN101: 5,
        PATTERN110: 6,
        PATTERN111: 7
    };
    //---------------------------------------------------------------------
    // QRUtil
    //---------------------------------------------------------------------
    var QRUtil = function() {
        var PATTERN_POSITION_TABLE = [
            [],
            [
                6,
                18
            ],
            [
                6,
                22
            ],
            [
                6,
                26
            ],
            [
                6,
                30
            ],
            [
                6,
                34
            ],
            [
                6,
                22,
                38
            ],
            [
                6,
                24,
                42
            ],
            [
                6,
                26,
                46
            ],
            [
                6,
                28,
                50
            ],
            [
                6,
                30,
                54
            ],
            [
                6,
                32,
                58
            ],
            [
                6,
                34,
                62
            ],
            [
                6,
                26,
                46,
                66
            ],
            [
                6,
                26,
                48,
                70
            ],
            [
                6,
                26,
                50,
                74
            ],
            [
                6,
                30,
                54,
                78
            ],
            [
                6,
                30,
                56,
                82
            ],
            [
                6,
                30,
                58,
                86
            ],
            [
                6,
                34,
                62,
                90
            ],
            [
                6,
                28,
                50,
                72,
                94
            ],
            [
                6,
                26,
                50,
                74,
                98
            ],
            [
                6,
                30,
                54,
                78,
                102
            ],
            [
                6,
                28,
                54,
                80,
                106
            ],
            [
                6,
                32,
                58,
                84,
                110
            ],
            [
                6,
                30,
                58,
                86,
                114
            ],
            [
                6,
                34,
                62,
                90,
                118
            ],
            [
                6,
                26,
                50,
                74,
                98,
                122
            ],
            [
                6,
                30,
                54,
                78,
                102,
                126
            ],
            [
                6,
                26,
                52,
                78,
                104,
                130
            ],
            [
                6,
                30,
                56,
                82,
                108,
                134
            ],
            [
                6,
                34,
                60,
                86,
                112,
                138
            ],
            [
                6,
                30,
                58,
                86,
                114,
                142
            ],
            [
                6,
                34,
                62,
                90,
                118,
                146
            ],
            [
                6,
                30,
                54,
                78,
                102,
                126,
                150
            ],
            [
                6,
                24,
                50,
                76,
                102,
                128,
                154
            ],
            [
                6,
                28,
                54,
                80,
                106,
                132,
                158
            ],
            [
                6,
                32,
                58,
                84,
                110,
                136,
                162
            ],
            [
                6,
                26,
                54,
                82,
                110,
                138,
                166
            ],
            [
                6,
                30,
                58,
                86,
                114,
                142,
                170
            ]
        ];
        var G15 = 1335;
        var G18 = 7973;
        var G15_MASK = 21522;
        var _this = {};
        var getBCHDigit = function(data) {
            var digit = 0;
            while(data != 0){
                digit += 1;
                data >>>= 1;
            }
            return digit;
        };
        _this.getBCHTypeInfo = function(data) {
            var d = data << 10;
            while(getBCHDigit(d) - getBCHDigit(G15) >= 0)d ^= G15 << getBCHDigit(d) - getBCHDigit(G15);
            return (data << 10 | d) ^ G15_MASK;
        };
        _this.getBCHTypeNumber = function(data) {
            var d = data << 12;
            while(getBCHDigit(d) - getBCHDigit(G18) >= 0)d ^= G18 << getBCHDigit(d) - getBCHDigit(G18);
            return data << 12 | d;
        };
        _this.getPatternPosition = function(typeNumber) {
            return PATTERN_POSITION_TABLE[typeNumber - 1];
        };
        _this.getMaskFunction = function(maskPattern) {
            switch(maskPattern){
                case QRMaskPattern.PATTERN000:
                    return function(i, j) {
                        return (i + j) % 2 == 0;
                    };
                case QRMaskPattern.PATTERN001:
                    return function(i, j) {
                        return i % 2 == 0;
                    };
                case QRMaskPattern.PATTERN010:
                    return function(i, j) {
                        return j % 3 == 0;
                    };
                case QRMaskPattern.PATTERN011:
                    return function(i, j) {
                        return (i + j) % 3 == 0;
                    };
                case QRMaskPattern.PATTERN100:
                    return function(i, j) {
                        return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;
                    };
                case QRMaskPattern.PATTERN101:
                    return function(i, j) {
                        return i * j % 2 + i * j % 3 == 0;
                    };
                case QRMaskPattern.PATTERN110:
                    return function(i, j) {
                        return (i * j % 2 + i * j % 3) % 2 == 0;
                    };
                case QRMaskPattern.PATTERN111:
                    return function(i, j) {
                        return (i * j % 3 + (i + j) % 2) % 2 == 0;
                    };
                default:
                    throw 'bad maskPattern:' + maskPattern;
            }
        };
        _this.getErrorCorrectPolynomial = function(errorCorrectLength) {
            var a = qrPolynomial([
                1
            ], 0);
            for(var i = 0; i < errorCorrectLength; i += 1)a = a.multiply(qrPolynomial([
                1,
                QRMath.gexp(i)
            ], 0));
            return a;
        };
        _this.getLengthInBits = function(mode, type) {
            if (1 <= type && type < 10) // 1 - 9
            switch(mode){
                case QRMode.MODE_NUMBER:
                    return 10;
                case QRMode.MODE_ALPHA_NUM:
                    return 9;
                case QRMode.MODE_8BIT_BYTE:
                    return 8;
                case QRMode.MODE_KANJI:
                    return 8;
                default:
                    throw 'mode:' + mode;
            }
            else if (type < 27) // 10 - 26
            switch(mode){
                case QRMode.MODE_NUMBER:
                    return 12;
                case QRMode.MODE_ALPHA_NUM:
                    return 11;
                case QRMode.MODE_8BIT_BYTE:
                    return 16;
                case QRMode.MODE_KANJI:
                    return 10;
                default:
                    throw 'mode:' + mode;
            }
            else if (type < 41) // 27 - 40
            switch(mode){
                case QRMode.MODE_NUMBER:
                    return 14;
                case QRMode.MODE_ALPHA_NUM:
                    return 13;
                case QRMode.MODE_8BIT_BYTE:
                    return 16;
                case QRMode.MODE_KANJI:
                    return 12;
                default:
                    throw 'mode:' + mode;
            }
            else throw 'type:' + type;
        };
        _this.getLostPoint = function(qrcode) {
            var moduleCount = qrcode.getModuleCount();
            var lostPoint = 0;
            // LEVEL1
            for(var row = 0; row < moduleCount; row += 1)for(var col = 0; col < moduleCount; col += 1){
                var sameCount = 0;
                var dark = qrcode.isDark(row, col);
                for(var r = -1; r <= 1; r += 1){
                    if (row + r < 0 || moduleCount <= row + r) continue;
                    for(var c = -1; c <= 1; c += 1){
                        if (col + c < 0 || moduleCount <= col + c) continue;
                        if (r == 0 && c == 0) continue;
                        if (dark == qrcode.isDark(row + r, col + c)) sameCount += 1;
                    }
                }
                if (sameCount > 5) lostPoint += 3 + sameCount - 5;
            }
            // LEVEL2
            for(var row = 0; row < moduleCount - 1; row += 1)for(var col = 0; col < moduleCount - 1; col += 1){
                var count = 0;
                if (qrcode.isDark(row, col)) count += 1;
                if (qrcode.isDark(row + 1, col)) count += 1;
                if (qrcode.isDark(row, col + 1)) count += 1;
                if (qrcode.isDark(row + 1, col + 1)) count += 1;
                if (count == 0 || count == 4) lostPoint += 3;
            }
            // LEVEL3
            for(var row = 0; row < moduleCount; row += 1){
                for(var col = 0; col < moduleCount - 6; col += 1)if (qrcode.isDark(row, col) && !qrcode.isDark(row, col + 1) && qrcode.isDark(row, col + 2) && qrcode.isDark(row, col + 3) && qrcode.isDark(row, col + 4) && !qrcode.isDark(row, col + 5) && qrcode.isDark(row, col + 6)) lostPoint += 40;
            }
            for(var col = 0; col < moduleCount; col += 1){
                for(var row = 0; row < moduleCount - 6; row += 1)if (qrcode.isDark(row, col) && !qrcode.isDark(row + 1, col) && qrcode.isDark(row + 2, col) && qrcode.isDark(row + 3, col) && qrcode.isDark(row + 4, col) && !qrcode.isDark(row + 5, col) && qrcode.isDark(row + 6, col)) lostPoint += 40;
            }
            // LEVEL4
            var darkCount = 0;
            for(var col = 0; col < moduleCount; col += 1){
                for(var row = 0; row < moduleCount; row += 1)if (qrcode.isDark(row, col)) darkCount += 1;
            }
            var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
            lostPoint += ratio * 10;
            return lostPoint;
        };
        return _this;
    }();
    //---------------------------------------------------------------------
    // QRMath
    //---------------------------------------------------------------------
    var QRMath = function() {
        var EXP_TABLE = new Array(256);
        var LOG_TABLE = new Array(256);
        // initialize tables
        for(var i = 0; i < 8; i += 1)EXP_TABLE[i] = 1 << i;
        for(var i = 8; i < 256; i += 1)EXP_TABLE[i] = EXP_TABLE[i - 4] ^ EXP_TABLE[i - 5] ^ EXP_TABLE[i - 6] ^ EXP_TABLE[i - 8];
        for(var i = 0; i < 255; i += 1)LOG_TABLE[EXP_TABLE[i]] = i;
        var _this = {};
        _this.glog = function(n) {
            if (n < 1) throw 'glog(' + n + ')';
            return LOG_TABLE[n];
        };
        _this.gexp = function(n) {
            while(n < 0)n += 255;
            while(n >= 256)n -= 255;
            return EXP_TABLE[n];
        };
        return _this;
    }();
    //---------------------------------------------------------------------
    // qrPolynomial
    //---------------------------------------------------------------------
    function qrPolynomial(num, shift) {
        if (typeof num.length == 'undefined') throw num.length + '/' + shift;
        var _num = function() {
            var offset = 0;
            while(offset < num.length && num[offset] == 0)offset += 1;
            var _num = new Array(num.length - offset + shift);
            for(var i = 0; i < num.length - offset; i += 1)_num[i] = num[i + offset];
            return _num;
        }();
        var _this = {};
        _this.getAt = function(index) {
            return _num[index];
        };
        _this.getLength = function() {
            return _num.length;
        };
        _this.multiply = function(e) {
            var num = new Array(_this.getLength() + e.getLength() - 1);
            for(var i = 0; i < _this.getLength(); i += 1)for(var j = 0; j < e.getLength(); j += 1)num[i + j] ^= QRMath.gexp(QRMath.glog(_this.getAt(i)) + QRMath.glog(e.getAt(j)));
            return qrPolynomial(num, 0);
        };
        _this.mod = function(e) {
            if (_this.getLength() - e.getLength() < 0) return _this;
            var ratio = QRMath.glog(_this.getAt(0)) - QRMath.glog(e.getAt(0));
            var num = new Array(_this.getLength());
            for(var i = 0; i < _this.getLength(); i += 1)num[i] = _this.getAt(i);
            for(var i = 0; i < e.getLength(); i += 1)num[i] ^= QRMath.gexp(QRMath.glog(e.getAt(i)) + ratio);
            // recursive call
            return qrPolynomial(num, 0).mod(e);
        };
        return _this;
    }
    //---------------------------------------------------------------------
    // QRRSBlock
    //---------------------------------------------------------------------
    var QRRSBlock = function() {
        var RS_BLOCK_TABLE = [
            // L
            // M
            // Q
            // H
            // 1
            [
                1,
                26,
                19
            ],
            [
                1,
                26,
                16
            ],
            [
                1,
                26,
                13
            ],
            [
                1,
                26,
                9
            ],
            // 2
            [
                1,
                44,
                34
            ],
            [
                1,
                44,
                28
            ],
            [
                1,
                44,
                22
            ],
            [
                1,
                44,
                16
            ],
            // 3
            [
                1,
                70,
                55
            ],
            [
                1,
                70,
                44
            ],
            [
                2,
                35,
                17
            ],
            [
                2,
                35,
                13
            ],
            // 4
            [
                1,
                100,
                80
            ],
            [
                2,
                50,
                32
            ],
            [
                2,
                50,
                24
            ],
            [
                4,
                25,
                9
            ],
            // 5
            [
                1,
                134,
                108
            ],
            [
                2,
                67,
                43
            ],
            [
                2,
                33,
                15,
                2,
                34,
                16
            ],
            [
                2,
                33,
                11,
                2,
                34,
                12
            ],
            // 6
            [
                2,
                86,
                68
            ],
            [
                4,
                43,
                27
            ],
            [
                4,
                43,
                19
            ],
            [
                4,
                43,
                15
            ],
            // 7
            [
                2,
                98,
                78
            ],
            [
                4,
                49,
                31
            ],
            [
                2,
                32,
                14,
                4,
                33,
                15
            ],
            [
                4,
                39,
                13,
                1,
                40,
                14
            ],
            // 8
            [
                2,
                121,
                97
            ],
            [
                2,
                60,
                38,
                2,
                61,
                39
            ],
            [
                4,
                40,
                18,
                2,
                41,
                19
            ],
            [
                4,
                40,
                14,
                2,
                41,
                15
            ],
            // 9
            [
                2,
                146,
                116
            ],
            [
                3,
                58,
                36,
                2,
                59,
                37
            ],
            [
                4,
                36,
                16,
                4,
                37,
                17
            ],
            [
                4,
                36,
                12,
                4,
                37,
                13
            ],
            // 10
            [
                2,
                86,
                68,
                2,
                87,
                69
            ],
            [
                4,
                69,
                43,
                1,
                70,
                44
            ],
            [
                6,
                43,
                19,
                2,
                44,
                20
            ],
            [
                6,
                43,
                15,
                2,
                44,
                16
            ],
            // 11
            [
                4,
                101,
                81
            ],
            [
                1,
                80,
                50,
                4,
                81,
                51
            ],
            [
                4,
                50,
                22,
                4,
                51,
                23
            ],
            [
                3,
                36,
                12,
                8,
                37,
                13
            ],
            // 12
            [
                2,
                116,
                92,
                2,
                117,
                93
            ],
            [
                6,
                58,
                36,
                2,
                59,
                37
            ],
            [
                4,
                46,
                20,
                6,
                47,
                21
            ],
            [
                7,
                42,
                14,
                4,
                43,
                15
            ],
            // 13
            [
                4,
                133,
                107
            ],
            [
                8,
                59,
                37,
                1,
                60,
                38
            ],
            [
                8,
                44,
                20,
                4,
                45,
                21
            ],
            [
                12,
                33,
                11,
                4,
                34,
                12
            ],
            // 14
            [
                3,
                145,
                115,
                1,
                146,
                116
            ],
            [
                4,
                64,
                40,
                5,
                65,
                41
            ],
            [
                11,
                36,
                16,
                5,
                37,
                17
            ],
            [
                11,
                36,
                12,
                5,
                37,
                13
            ],
            // 15
            [
                5,
                109,
                87,
                1,
                110,
                88
            ],
            [
                5,
                65,
                41,
                5,
                66,
                42
            ],
            [
                5,
                54,
                24,
                7,
                55,
                25
            ],
            [
                11,
                36,
                12,
                7,
                37,
                13
            ],
            // 16
            [
                5,
                122,
                98,
                1,
                123,
                99
            ],
            [
                7,
                73,
                45,
                3,
                74,
                46
            ],
            [
                15,
                43,
                19,
                2,
                44,
                20
            ],
            [
                3,
                45,
                15,
                13,
                46,
                16
            ],
            // 17
            [
                1,
                135,
                107,
                5,
                136,
                108
            ],
            [
                10,
                74,
                46,
                1,
                75,
                47
            ],
            [
                1,
                50,
                22,
                15,
                51,
                23
            ],
            [
                2,
                42,
                14,
                17,
                43,
                15
            ],
            // 18
            [
                5,
                150,
                120,
                1,
                151,
                121
            ],
            [
                9,
                69,
                43,
                4,
                70,
                44
            ],
            [
                17,
                50,
                22,
                1,
                51,
                23
            ],
            [
                2,
                42,
                14,
                19,
                43,
                15
            ],
            // 19
            [
                3,
                141,
                113,
                4,
                142,
                114
            ],
            [
                3,
                70,
                44,
                11,
                71,
                45
            ],
            [
                17,
                47,
                21,
                4,
                48,
                22
            ],
            [
                9,
                39,
                13,
                16,
                40,
                14
            ],
            // 20
            [
                3,
                135,
                107,
                5,
                136,
                108
            ],
            [
                3,
                67,
                41,
                13,
                68,
                42
            ],
            [
                15,
                54,
                24,
                5,
                55,
                25
            ],
            [
                15,
                43,
                15,
                10,
                44,
                16
            ],
            // 21
            [
                4,
                144,
                116,
                4,
                145,
                117
            ],
            [
                17,
                68,
                42
            ],
            [
                17,
                50,
                22,
                6,
                51,
                23
            ],
            [
                19,
                46,
                16,
                6,
                47,
                17
            ],
            // 22
            [
                2,
                139,
                111,
                7,
                140,
                112
            ],
            [
                17,
                74,
                46
            ],
            [
                7,
                54,
                24,
                16,
                55,
                25
            ],
            [
                34,
                37,
                13
            ],
            // 23
            [
                4,
                151,
                121,
                5,
                152,
                122
            ],
            [
                4,
                75,
                47,
                14,
                76,
                48
            ],
            [
                11,
                54,
                24,
                14,
                55,
                25
            ],
            [
                16,
                45,
                15,
                14,
                46,
                16
            ],
            // 24
            [
                6,
                147,
                117,
                4,
                148,
                118
            ],
            [
                6,
                73,
                45,
                14,
                74,
                46
            ],
            [
                11,
                54,
                24,
                16,
                55,
                25
            ],
            [
                30,
                46,
                16,
                2,
                47,
                17
            ],
            // 25
            [
                8,
                132,
                106,
                4,
                133,
                107
            ],
            [
                8,
                75,
                47,
                13,
                76,
                48
            ],
            [
                7,
                54,
                24,
                22,
                55,
                25
            ],
            [
                22,
                45,
                15,
                13,
                46,
                16
            ],
            // 26
            [
                10,
                142,
                114,
                2,
                143,
                115
            ],
            [
                19,
                74,
                46,
                4,
                75,
                47
            ],
            [
                28,
                50,
                22,
                6,
                51,
                23
            ],
            [
                33,
                46,
                16,
                4,
                47,
                17
            ],
            // 27
            [
                8,
                152,
                122,
                4,
                153,
                123
            ],
            [
                22,
                73,
                45,
                3,
                74,
                46
            ],
            [
                8,
                53,
                23,
                26,
                54,
                24
            ],
            [
                12,
                45,
                15,
                28,
                46,
                16
            ],
            // 28
            [
                3,
                147,
                117,
                10,
                148,
                118
            ],
            [
                3,
                73,
                45,
                23,
                74,
                46
            ],
            [
                4,
                54,
                24,
                31,
                55,
                25
            ],
            [
                11,
                45,
                15,
                31,
                46,
                16
            ],
            // 29
            [
                7,
                146,
                116,
                7,
                147,
                117
            ],
            [
                21,
                73,
                45,
                7,
                74,
                46
            ],
            [
                1,
                53,
                23,
                37,
                54,
                24
            ],
            [
                19,
                45,
                15,
                26,
                46,
                16
            ],
            // 30
            [
                5,
                145,
                115,
                10,
                146,
                116
            ],
            [
                19,
                75,
                47,
                10,
                76,
                48
            ],
            [
                15,
                54,
                24,
                25,
                55,
                25
            ],
            [
                23,
                45,
                15,
                25,
                46,
                16
            ],
            // 31
            [
                13,
                145,
                115,
                3,
                146,
                116
            ],
            [
                2,
                74,
                46,
                29,
                75,
                47
            ],
            [
                42,
                54,
                24,
                1,
                55,
                25
            ],
            [
                23,
                45,
                15,
                28,
                46,
                16
            ],
            // 32
            [
                17,
                145,
                115
            ],
            [
                10,
                74,
                46,
                23,
                75,
                47
            ],
            [
                10,
                54,
                24,
                35,
                55,
                25
            ],
            [
                19,
                45,
                15,
                35,
                46,
                16
            ],
            // 33
            [
                17,
                145,
                115,
                1,
                146,
                116
            ],
            [
                14,
                74,
                46,
                21,
                75,
                47
            ],
            [
                29,
                54,
                24,
                19,
                55,
                25
            ],
            [
                11,
                45,
                15,
                46,
                46,
                16
            ],
            // 34
            [
                13,
                145,
                115,
                6,
                146,
                116
            ],
            [
                14,
                74,
                46,
                23,
                75,
                47
            ],
            [
                44,
                54,
                24,
                7,
                55,
                25
            ],
            [
                59,
                46,
                16,
                1,
                47,
                17
            ],
            // 35
            [
                12,
                151,
                121,
                7,
                152,
                122
            ],
            [
                12,
                75,
                47,
                26,
                76,
                48
            ],
            [
                39,
                54,
                24,
                14,
                55,
                25
            ],
            [
                22,
                45,
                15,
                41,
                46,
                16
            ],
            // 36
            [
                6,
                151,
                121,
                14,
                152,
                122
            ],
            [
                6,
                75,
                47,
                34,
                76,
                48
            ],
            [
                46,
                54,
                24,
                10,
                55,
                25
            ],
            [
                2,
                45,
                15,
                64,
                46,
                16
            ],
            // 37
            [
                17,
                152,
                122,
                4,
                153,
                123
            ],
            [
                29,
                74,
                46,
                14,
                75,
                47
            ],
            [
                49,
                54,
                24,
                10,
                55,
                25
            ],
            [
                24,
                45,
                15,
                46,
                46,
                16
            ],
            // 38
            [
                4,
                152,
                122,
                18,
                153,
                123
            ],
            [
                13,
                74,
                46,
                32,
                75,
                47
            ],
            [
                48,
                54,
                24,
                14,
                55,
                25
            ],
            [
                42,
                45,
                15,
                32,
                46,
                16
            ],
            // 39
            [
                20,
                147,
                117,
                4,
                148,
                118
            ],
            [
                40,
                75,
                47,
                7,
                76,
                48
            ],
            [
                43,
                54,
                24,
                22,
                55,
                25
            ],
            [
                10,
                45,
                15,
                67,
                46,
                16
            ],
            // 40
            [
                19,
                148,
                118,
                6,
                149,
                119
            ],
            [
                18,
                75,
                47,
                31,
                76,
                48
            ],
            [
                34,
                54,
                24,
                34,
                55,
                25
            ],
            [
                20,
                45,
                15,
                61,
                46,
                16
            ]
        ];
        var qrRSBlock = function(totalCount, dataCount) {
            var _this = {};
            _this.totalCount = totalCount;
            _this.dataCount = dataCount;
            return _this;
        };
        var _this = {};
        var getRsBlockTable = function(typeNumber, errorCorrectionLevel) {
            switch(errorCorrectionLevel){
                case QRErrorCorrectionLevel.L:
                    return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
                case QRErrorCorrectionLevel.M:
                    return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
                case QRErrorCorrectionLevel.Q:
                    return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
                case QRErrorCorrectionLevel.H:
                    return RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
                default:
                    return undefined;
            }
        };
        _this.getRSBlocks = function(typeNumber, errorCorrectionLevel) {
            var rsBlock = getRsBlockTable(typeNumber, errorCorrectionLevel);
            if (typeof rsBlock == 'undefined') throw 'bad rs block @ typeNumber:' + typeNumber + '/errorCorrectionLevel:' + errorCorrectionLevel;
            var length = rsBlock.length / 3;
            var list = [];
            for(var i = 0; i < length; i += 1){
                var count = rsBlock[i * 3 + 0];
                var totalCount = rsBlock[i * 3 + 1];
                var dataCount = rsBlock[i * 3 + 2];
                for(var j = 0; j < count; j += 1)list.push(qrRSBlock(totalCount, dataCount));
            }
            return list;
        };
        return _this;
    }();
    //---------------------------------------------------------------------
    // qrBitBuffer
    //---------------------------------------------------------------------
    var qrBitBuffer = function() {
        var _buffer = [];
        var _length = 0;
        var _this = {};
        _this.getBuffer = function() {
            return _buffer;
        };
        _this.getAt = function(index) {
            var bufIndex = Math.floor(index / 8);
            return (_buffer[bufIndex] >>> 7 - index % 8 & 1) == 1;
        };
        _this.put = function(num, length) {
            for(var i = 0; i < length; i += 1)_this.putBit((num >>> length - i - 1 & 1) == 1);
        };
        _this.getLengthInBits = function() {
            return _length;
        };
        _this.putBit = function(bit) {
            var bufIndex = Math.floor(_length / 8);
            if (_buffer.length <= bufIndex) _buffer.push(0);
            if (bit) _buffer[bufIndex] |= 0x80 >>> _length % 8;
            _length += 1;
        };
        return _this;
    };
    //---------------------------------------------------------------------
    // qrNumber
    //---------------------------------------------------------------------
    var qrNumber = function(data) {
        var _mode = QRMode.MODE_NUMBER;
        var _data = data;
        var _this = {};
        _this.getMode = function() {
            return _mode;
        };
        _this.getLength = function(buffer) {
            return _data.length;
        };
        _this.write = function(buffer) {
            var data = _data;
            var i = 0;
            while(i + 2 < data.length){
                buffer.put(strToNum(data.substring(i, i + 3)), 10);
                i += 3;
            }
            if (i < data.length) {
                if (data.length - i == 1) buffer.put(strToNum(data.substring(i, i + 1)), 4);
                else if (data.length - i == 2) buffer.put(strToNum(data.substring(i, i + 2)), 7);
            }
        };
        var strToNum = function(s) {
            var num = 0;
            for(var i = 0; i < s.length; i += 1)num = num * 10 + chatToNum(s.charAt(i));
            return num;
        };
        var chatToNum = function(c) {
            if ('0' <= c && c <= '9') return c.charCodeAt(0) - '0'.charCodeAt(0);
            throw 'illegal char :' + c;
        };
        return _this;
    };
    //---------------------------------------------------------------------
    // qrAlphaNum
    //---------------------------------------------------------------------
    var qrAlphaNum = function(data) {
        var _mode = QRMode.MODE_ALPHA_NUM;
        var _data = data;
        var _this = {};
        _this.getMode = function() {
            return _mode;
        };
        _this.getLength = function(buffer) {
            return _data.length;
        };
        _this.write = function(buffer) {
            var s = _data;
            var i = 0;
            while(i + 1 < s.length){
                buffer.put(getCode(s.charAt(i)) * 45 + getCode(s.charAt(i + 1)), 11);
                i += 2;
            }
            if (i < s.length) buffer.put(getCode(s.charAt(i)), 6);
        };
        var getCode = function(c) {
            if ('0' <= c && c <= '9') return c.charCodeAt(0) - '0'.charCodeAt(0);
            else if ('A' <= c && c <= 'Z') return c.charCodeAt(0) - 'A'.charCodeAt(0) + 10;
            else switch(c){
                case ' ':
                    return 36;
                case '$':
                    return 37;
                case '%':
                    return 38;
                case '*':
                    return 39;
                case '+':
                    return 40;
                case '-':
                    return 41;
                case '.':
                    return 42;
                case '/':
                    return 43;
                case ':':
                    return 44;
                default:
                    throw 'illegal char :' + c;
            }
        };
        return _this;
    };
    //---------------------------------------------------------------------
    // qr8BitByte
    //---------------------------------------------------------------------
    var qr8BitByte = function(data) {
        var _mode = QRMode.MODE_8BIT_BYTE;
        var _data = data;
        var _bytes = qrcode.stringToBytes(data);
        var _this = {};
        _this.getMode = function() {
            return _mode;
        };
        _this.getLength = function(buffer) {
            return _bytes.length;
        };
        _this.write = function(buffer) {
            for(var i = 0; i < _bytes.length; i += 1)buffer.put(_bytes[i], 8);
        };
        return _this;
    };
    //---------------------------------------------------------------------
    // qrKanji
    //---------------------------------------------------------------------
    var qrKanji = function(data) {
        var _mode = QRMode.MODE_KANJI;
        var _data = data;
        var stringToBytes = qrcode.stringToBytesFuncs['SJIS'];
        if (!stringToBytes) throw 'sjis not supported.';
        !function(c, code) {
            // self test for sjis support.
            var test = stringToBytes(c);
            if (test.length != 2 || (test[0] << 8 | test[1]) != code) throw 'sjis not supported.';
        }('\u53cb', 0x9746);
        var _bytes = stringToBytes(data);
        var _this = {};
        _this.getMode = function() {
            return _mode;
        };
        _this.getLength = function(buffer) {
            return ~~(_bytes.length / 2);
        };
        _this.write = function(buffer) {
            var data = _bytes;
            var i = 0;
            while(i + 1 < data.length){
                var c = (0xff & data[i]) << 8 | 0xff & data[i + 1];
                if (0x8140 <= c && c <= 0x9FFC) c -= 0x8140;
                else if (0xE040 <= c && c <= 0xEBBF) c -= 0xC140;
                else throw 'illegal char at ' + (i + 1) + '/' + c;
                c = (c >>> 8 & 0xff) * 0xC0 + (c & 0xff);
                buffer.put(c, 13);
                i += 2;
            }
            if (i < data.length) throw 'illegal char at ' + (i + 1);
        };
        return _this;
    };
    //=====================================================================
    // GIF Support etc.
    //
    //---------------------------------------------------------------------
    // byteArrayOutputStream
    //---------------------------------------------------------------------
    var byteArrayOutputStream = function() {
        var _bytes = [];
        var _this = {};
        _this.writeByte = function(b) {
            _bytes.push(b & 0xff);
        };
        _this.writeShort = function(i) {
            _this.writeByte(i);
            _this.writeByte(i >>> 8);
        };
        _this.writeBytes = function(b, off, len) {
            off = off || 0;
            len = len || b.length;
            for(var i = 0; i < len; i += 1)_this.writeByte(b[i + off]);
        };
        _this.writeString = function(s) {
            for(var i = 0; i < s.length; i += 1)_this.writeByte(s.charCodeAt(i));
        };
        _this.toByteArray = function() {
            return _bytes;
        };
        _this.toString = function() {
            var s = '';
            s += '[';
            for(var i = 0; i < _bytes.length; i += 1){
                if (i > 0) s += ',';
                s += _bytes[i];
            }
            s += ']';
            return s;
        };
        return _this;
    };
    //---------------------------------------------------------------------
    // base64EncodeOutputStream
    //---------------------------------------------------------------------
    var base64EncodeOutputStream = function() {
        var _buffer = 0;
        var _buflen = 0;
        var _length = 0;
        var _base64 = '';
        var _this = {};
        var writeEncoded = function(b) {
            _base64 += String.fromCharCode(encode(b & 0x3f));
        };
        var encode = function(n) {
            if (n < 0) ;
            else if (n < 26) return 0x41 + n;
            else if (n < 52) return 0x61 + (n - 26);
            else if (n < 62) return 0x30 + (n - 52);
            else if (n == 62) return 0x2b;
            else if (n == 63) return 0x2f;
            throw 'n:' + n;
        };
        _this.writeByte = function(n) {
            _buffer = _buffer << 8 | n & 0xff;
            _buflen += 8;
            _length += 1;
            while(_buflen >= 6){
                writeEncoded(_buffer >>> _buflen - 6);
                _buflen -= 6;
            }
        };
        _this.flush = function() {
            if (_buflen > 0) {
                writeEncoded(_buffer << 6 - _buflen);
                _buffer = 0;
                _buflen = 0;
            }
            if (_length % 3 != 0) {
                // padding
                var padlen = 3 - _length % 3;
                for(var i = 0; i < padlen; i += 1)_base64 += '=';
            }
        };
        _this.toString = function() {
            return _base64;
        };
        return _this;
    };
    //---------------------------------------------------------------------
    // base64DecodeInputStream
    //---------------------------------------------------------------------
    var base64DecodeInputStream = function(str) {
        var _str = str;
        var _pos = 0;
        var _buffer = 0;
        var _buflen = 0;
        var _this = {};
        _this.read = function() {
            while(_buflen < 8){
                if (_pos >= _str.length) {
                    if (_buflen == 0) return -1;
                    throw 'unexpected end of file./' + _buflen;
                }
                var c = _str.charAt(_pos);
                _pos += 1;
                if (c == '=') {
                    _buflen = 0;
                    return -1;
                } else if (c.match(/^\s$/)) continue;
                _buffer = _buffer << 6 | decode(c.charCodeAt(0));
                _buflen += 6;
            }
            var n = _buffer >>> _buflen - 8 & 0xff;
            _buflen -= 8;
            return n;
        };
        var decode = function(c) {
            if (0x41 <= c && c <= 0x5a) return c - 0x41;
            else if (0x61 <= c && c <= 0x7a) return c - 0x61 + 26;
            else if (0x30 <= c && c <= 0x39) return c - 0x30 + 52;
            else if (c == 0x2b) return 62;
            else if (c == 0x2f) return 63;
            else throw 'c:' + c;
        };
        return _this;
    };
    //---------------------------------------------------------------------
    // gifImage (B/W)
    //---------------------------------------------------------------------
    var gifImage = function(width, height) {
        var _width = width;
        var _height = height;
        var _data = new Array(width * height);
        var _this = {};
        _this.setPixel = function(x, y, pixel) {
            _data[y * _width + x] = pixel;
        };
        _this.write = function(out) {
            //---------------------------------
            // GIF Signature
            out.writeString('GIF87a');
            //---------------------------------
            // Screen Descriptor
            out.writeShort(_width);
            out.writeShort(_height);
            out.writeByte(0x80); // 2bit
            out.writeByte(0);
            out.writeByte(0);
            //---------------------------------
            // Global Color Map
            // black
            out.writeByte(0x00);
            out.writeByte(0x00);
            out.writeByte(0x00);
            // white
            out.writeByte(0xff);
            out.writeByte(0xff);
            out.writeByte(0xff);
            //---------------------------------
            // Image Descriptor
            out.writeString(',');
            out.writeShort(0);
            out.writeShort(0);
            out.writeShort(_width);
            out.writeShort(_height);
            out.writeByte(0);
            //---------------------------------
            // Local Color Map
            //---------------------------------
            // Raster Data
            var lzwMinCodeSize = 2;
            var raster = getLZWRaster(lzwMinCodeSize);
            out.writeByte(lzwMinCodeSize);
            var offset = 0;
            while(raster.length - offset > 255){
                out.writeByte(255);
                out.writeBytes(raster, offset, 255);
                offset += 255;
            }
            out.writeByte(raster.length - offset);
            out.writeBytes(raster, offset, raster.length - offset);
            out.writeByte(0x00);
            //---------------------------------
            // GIF Terminator
            out.writeString(';');
        };
        var bitOutputStream = function(out) {
            var _out = out;
            var _bitLength = 0;
            var _bitBuffer = 0;
            var _this = {};
            _this.write = function(data, length) {
                if (data >>> length != 0) throw 'length over';
                while(_bitLength + length >= 8){
                    _out.writeByte(0xff & (data << _bitLength | _bitBuffer));
                    length -= 8 - _bitLength;
                    data >>>= 8 - _bitLength;
                    _bitBuffer = 0;
                    _bitLength = 0;
                }
                _bitBuffer = data << _bitLength | _bitBuffer;
                _bitLength = _bitLength + length;
            };
            _this.flush = function() {
                if (_bitLength > 0) _out.writeByte(_bitBuffer);
            };
            return _this;
        };
        var getLZWRaster = function(lzwMinCodeSize) {
            var clearCode = 1 << lzwMinCodeSize;
            var endCode = (1 << lzwMinCodeSize) + 1;
            var bitLength = lzwMinCodeSize + 1;
            // Setup LZWTable
            var table = lzwTable();
            for(var i = 0; i < clearCode; i += 1)table.add(String.fromCharCode(i));
            table.add(String.fromCharCode(clearCode));
            table.add(String.fromCharCode(endCode));
            var byteOut = byteArrayOutputStream();
            var bitOut = bitOutputStream(byteOut);
            // clear code
            bitOut.write(clearCode, bitLength);
            var dataIndex = 0;
            var s = String.fromCharCode(_data[dataIndex]);
            dataIndex += 1;
            while(dataIndex < _data.length){
                var c = String.fromCharCode(_data[dataIndex]);
                dataIndex += 1;
                if (table.contains(s + c)) s = s + c;
                else {
                    bitOut.write(table.indexOf(s), bitLength);
                    if (table.size() < 0xfff) {
                        if (table.size() == 1 << bitLength) bitLength += 1;
                        table.add(s + c);
                    }
                    s = c;
                }
            }
            bitOut.write(table.indexOf(s), bitLength);
            // end code
            bitOut.write(endCode, bitLength);
            bitOut.flush();
            return byteOut.toByteArray();
        };
        var lzwTable = function() {
            var _map = {};
            var _size = 0;
            var _this = {};
            _this.add = function(key) {
                if (_this.contains(key)) throw 'dup key:' + key;
                _map[key] = _size;
                _size += 1;
            };
            _this.size = function() {
                return _size;
            };
            _this.indexOf = function(key) {
                return _map[key];
            };
            _this.contains = function(key) {
                return typeof _map[key] != 'undefined';
            };
            return _this;
        };
        return _this;
    };
    var createDataURL = function(width, height, getPixel) {
        var gif = gifImage(width, height);
        for(var y = 0; y < height; y += 1)for(var x = 0; x < width; x += 1)gif.setPixel(x, y, getPixel(x, y));
        var b = byteArrayOutputStream();
        gif.write(b);
        var base64 = base64EncodeOutputStream();
        var bytes = b.toByteArray();
        for(var i = 0; i < bytes.length; i += 1)base64.writeByte(bytes[i]);
        base64.flush();
        return 'data:image/gif;base64,' + base64;
    };
    //---------------------------------------------------------------------
    // returns qrcode function.
    return qrcode;
}();
// multibyte support
!function() {
    $fab4f7c5f0db28e3$var$qrcode.stringToBytesFuncs['UTF-8'] = function(s) {
        // http://stackoverflow.com/questions/18729405/how-to-convert-utf8-string-to-byte-array
        function toUTF8Array(str) {
            var utf8 = [];
            for(var i = 0; i < str.length; i++){
                var charcode = str.charCodeAt(i);
                if (charcode < 0x80) utf8.push(charcode);
                else if (charcode < 0x800) utf8.push(0xc0 | charcode >> 6, 0x80 | charcode & 0x3f);
                else if (charcode < 0xd800 || charcode >= 0xe000) utf8.push(0xe0 | charcode >> 12, 0x80 | charcode >> 6 & 0x3f, 0x80 | charcode & 0x3f);
                else {
                    i++;
                    // UTF-16 encodes 0x10000-0x10FFFF by
                    // subtracting 0x10000 and splitting the
                    // 20 bits of 0x0-0xFFFFF into two halves
                    charcode = 0x10000 + ((charcode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
                    utf8.push(0xf0 | charcode >> 18, 0x80 | charcode >> 12 & 0x3f, 0x80 | charcode >> 6 & 0x3f, 0x80 | charcode & 0x3f);
                }
            }
            return utf8;
        }
        return toUTF8Array(s);
    };
}();
(function(factory) {
    if (typeof define === 'function' && define.amd) define([], factory);
    else $fab4f7c5f0db28e3$exports = factory();
})(function() {
    return $fab4f7c5f0db28e3$var$qrcode;
});



var $3OyDL = parcelRequire("3OyDL");
/** Error correction L, and that is a scanning decision rather than a lazy one.
 *  Higher levels add modules; at a fixed on-screen size more modules means
 *  SMALLER ones, which is the thing a phone camera actually struggles with.
 *  A pairing QR lives ~20 seconds on a clean screen — it is not a sticker on a
 *  van, and it does not need to survive being scratched. */ const $6d114691ee51c401$var$ERROR_CORRECTION = 'L';
/** The quiet zone, in modules. FOUR is what the QR spec requires and what
 *  decoders assume; a QR flush against a card border is a QR that intermittently
 *  fails to be found at all, which reads to the user as a broken feature. */ const $6d114691ee51c401$var$QUIET_ZONE = 4;
/**
 * Build one SVG path covering every dark module.
 *
 * ONE path, not one <rect> per module: a WhatsApp payload needs roughly 49–61
 * modules a side, so the rect version is up to ~1800 elements re-created every
 * time the code rotates — every twenty seconds, for as long as the operator
 * takes to scan.
 */ function $6d114691ee51c401$var$modulePath(qr, count) {
    const parts = [];
    for(let row = 0; row < count; row += 1){
        for(let column = 0; column < count; column += 1)if (qr.isDark(row, column)) // One unit square per module; the viewBox does the scaling.
        parts.push(`M${column + $6d114691ee51c401$var$QUIET_ZONE} ${row + $6d114691ee51c401$var$QUIET_ZONE}h1v1h-1z`);
    }
    return parts.join('');
}
function $6d114691ee51c401$export$e3b6b80dd4f481c3({ value: value, label: label }) {
    const drawn = (0, $3OyDL.useMemo)(()=>{
        if (!value) return null;
        try {
            // Type 0 = pick the smallest version that fits the payload. A pinned
            // version would refuse a longer-than-expected payload outright, and
            // WhatsApp does not promise the length of its reference string.
            const qr = (0, (/*@__PURE__*/$parcel$interopDefault($fab4f7c5f0db28e3$exports)))(0, $6d114691ee51c401$var$ERROR_CORRECTION);
            qr.addData(value);
            qr.make();
            const count = qr.getModuleCount();
            return {
                count: count,
                path: $6d114691ee51c401$var$modulePath(qr, count)
            };
        } catch  {
            // An unencodable payload must not take the screen down with it — the
            // caller still renders the text fallback underneath, which is a worse
            // experience and not a broken one.
            return null;
        }
    }, [
        value
    ]);
    if (!drawn) return null;
    const side = drawn.count + $6d114691ee51c401$var$QUIET_ZONE * 2;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("svg", {
        // A QR is never mirrored, so it opts out of the RTL document direction.
        dir: "ltr",
        className: "h-qr w-qr rounded border border-border bg-qr-quiet",
        viewBox: `0 0 ${side} ${side}`,
        role: "img",
        "aria-label": label,
        // Without this the browser antialiases module edges and a marginal scan
        // gets more marginal.
        shapeRendering: "crispEdges",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("rect", {
                width: side,
                height: side,
                className: "fill-qr-quiet"
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("path", {
                d: drawn.path,
                className: "fill-qr-module"
            })
        ]
    });
}









function $8b2aa657be98f217$var$bffBase() {
    return 0, $b5d41e4dbaeacaa2$export$4dc6837bb3c0882f;
}
function $8b2aa657be98f217$export$ff53179d2e9790e4() {
    // `isAdmin`, not `role` — the session exposes the boolean, and guarding on
    // `role !== 'ADMIN'` reads undefined and shows every admin the wrong panel
    // (CLAUDE.md §15).
    const { isAdmin: isAdmin } = (0, $00d5d84dffcdf8d5$export$ad0a340bf97d63d5)();
    const { data: data, loading: loading, refetch: refetch } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $047171b3f4119885$export$562f31d2c926639d), {
        // The pairing state changes outside this tab (somebody scans a code on a
        // phone), so the card polls rather than waiting for a refetch nobody will
        // trigger.
        pollInterval: 5000
    });
    const accountsQuery = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $047171b3f4119885$export$f08c69326971bdb2), {
        variables: {
            includeInactive: true
        },
        pollInterval: 5000
    });
    const refetchAll = (0, $3OyDL.useCallback)(()=>{
        refetch();
        accountsQuery.refetch();
    }, [
        refetch,
        accountsQuery
    ]);
    const [pairing, setPairing] = (0, $3OyDL.useState)(null);
    const [pairingAccount, setPairingAccount] = (0, $3OyDL.useState)(null);
    const sourceRef = (0, $3OyDL.useRef)(null);
    const stop = (0, $3OyDL.useCallback)(()=>{
        sourceRef.current?.close();
        sourceRef.current = null;
    }, []);
    // Closing the page must close the stream, or the gateway keeps a pairing
    // attempt alive against a session nobody is watching.
    (0, $3OyDL.useEffect)(()=>stop, [
        stop
    ]);
    const startPairing = (0, $3OyDL.useCallback)((accountId, phone)=>{
        stop();
        setPairingAccount(accountId ?? '');
        setPairing({
            kind: 'PENDING'
        });
        const params = new URLSearchParams();
        // EventSource cannot set an Authorization header; the BFF verifies this
        // through the identical code path (todo.md).
        const token = (0, $f0578ea5f18e5637$export$84773cc9bf7dbe87)();
        if (token) params.set('token', token);
        if (phone?.trim()) params.set('phone', phone.trim());
        // WHICH number is being paired. Absent means the default, which is what
        // a single-number deployment wants and has always got.
        if (accountId) params.set('account', accountId);
        const source = new EventSource(`${$8b2aa657be98f217$var$bffBase()}/integrations/whatsapp/pairing?${params}`);
        sourceRef.current = source;
        source.addEventListener('pairing', (event)=>{
            const update = JSON.parse(event.data);
            setPairing(update);
            if ([
                'SUCCESS',
                'TIMEOUT',
                'ERROR'
            ].includes(update.kind)) {
                stop();
                refetchAll();
            }
        });
        source.onerror = ()=>{
            setPairing({
                kind: 'ERROR',
                message: (0, $d916753b57975e04$export$25ce5a424b770e84).app.unknownError
            });
            stop();
        };
    }, [
        refetchAll,
        stop
    ]);
    const status = data?.whatsappStatus;
    const accounts = accountsQuery.data?.whatsappAccounts ?? [];
    const sandbox = status && status.provider !== 'hypermeow';
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $287828886661deba$export$8f6dcfe950367406), {
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.title,
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
                className: "flex flex-col gap-3 border-warning",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                        className: "flex items-center gap-2 font-bold text-warning",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6tkl0.default), {
                                size: 16,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.riskTitle
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                        className: "text-sm leading-relaxed text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.riskBody
                    })
                ]
            }),
            loading && !status && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {}),
            status && /*#__PURE__*/ (0, $2M70Q.jsx)($8b2aa657be98f217$var$ProviderCard, {
                status: status,
                sandbox: sandbox,
                accountCount: accounts.length
            }),
            status && accounts.length === 0 && // NOTHING CONFIGURED: the legacy single-connection card, unchanged.
            // This is the state every deployment is in before somebody names a
            // number, and it must keep working exactly as it did.
            /*#__PURE__*/ (0, $2M70Q.jsx)($8b2aa657be98f217$var$LegacyConnectionCard, {
                status: status,
                isAdmin: isAdmin,
                pairing: pairing,
                onPair: (phone)=>startPairing('', phone),
                onUnlinked: refetchAll
            }),
            accounts.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: "flex flex-col gap-3",
                children: accounts.map((account)=>/*#__PURE__*/ (0, $2M70Q.jsx)($8b2aa657be98f217$var$AccountCard, {
                        account: account,
                        accounts: accounts,
                        isAdmin: isAdmin,
                        pairing: pairingAccount === account.accountId ? pairing : null,
                        onPair: (phone)=>startPairing(account.accountId, phone),
                        onChanged: refetchAll
                    }, account.id))
            }),
            isAdmin && /*#__PURE__*/ (0, $2M70Q.jsx)($8b2aa657be98f217$var$AddAccountCard, {
                empty: accounts.length === 0,
                onCreated: refetchAll
            })
        ]
    });
}
/** Deployment-wide facts: which transport, and whether sending is switched off. */ function $8b2aa657be98f217$var$ProviderCard({ status: status, sandbox: sandbox, accountCount: accountCount }) {
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
        className: "flex flex-wrap items-center gap-3",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                className: "text-md font-bold",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.connection
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                className: sandbox ? 'bg-surface-hover text-warning' : 'bg-surface-hover text-success',
                children: status.provider
            }),
            status.sendDisabled && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                className: "bg-surface-hover text-danger",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.sendDisabled
            }),
            accountCount > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                className: "bg-surface-hover",
                children: [
                    (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.accounts,
                    " ",
                    (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(accountCount)
                ]
            })
        ]
    });
}
/** The screen as it was before multi-account, for a deployment with no rows. */ function $8b2aa657be98f217$var$LegacyConnectionCard({ status: status, isAdmin: isAdmin, pairing: pairing, onPair: onPair, onUnlinked: onUnlinked }) {
    const [unlink, unlinkState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$632d0db57ac2645), {
        onCompleted: onUnlinked
    });
    const [confirming, setConfirming] = (0, $3OyDL.useState)(false);
    const [phone, setPhone] = (0, $3OyDL.useState)('');
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
        className: "flex flex-col gap-4",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex flex-wrap items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                        className: "bg-surface-hover",
                        children: status.paired ? (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.paired : (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.notPaired
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                        className: status.connected ? 'bg-surface-hover text-success' : 'bg-surface-hover text-text-muted',
                        children: status.connected ? (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.connected : (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.disconnected
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)($8b2aa657be98f217$var$StatusFields, {
                status: status
            }),
            isAdmin && /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex flex-wrap items-end gap-3 border-t border-border pt-4",
                children: [
                    !status.paired && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                variant: "primary",
                                onClick: ()=>onPair(phone),
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ks4jt.default), {
                                        size: 14,
                                        "aria-hidden": "true"
                                    }),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.pair
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.phoneForCode,
                                hint: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.codeAlternative,
                                value: phone,
                                dir: "ltr",
                                onChange: (event)=>setPhone(event.target.value)
                            })
                        ]
                    }),
                    status.paired && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "danger",
                        onClick: ()=>setConfirming(true),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $41dbd9baa470cf33$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.unlink
                        ]
                    })
                ]
            }),
            pairing && /*#__PURE__*/ (0, $2M70Q.jsx)($8b2aa657be98f217$var$PairingPanel, {
                pairing: pairing
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: unlinkState.error
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2cc85109a937009e), {
                open: confirming,
                onOpenChange: setConfirming,
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.unlink,
                body: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.unlinkConfirm,
                confirmLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.unlink,
                destructive: true,
                onConfirm: async ()=>{
                    await unlink({
                        variables: {
                            accountId: ''
                        }
                    });
                    setConfirming(false);
                }
            })
        ]
    });
}
/** One named number. */ function $8b2aa657be98f217$var$AccountCard({ account: account, accounts: accounts, isAdmin: isAdmin, pairing: pairing, onPair: onPair, onChanged: onChanged }) {
    const [unlink, unlinkState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$632d0db57ac2645), {
        onCompleted: onChanged
    });
    const [setDefault, defaultState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$eec6816698e22cca), {
        onCompleted: onChanged
    });
    const [setActive, activeState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$31ebb277d01c34ae), {
        onCompleted: onChanged
    });
    const [confirming, setConfirming] = (0, $3OyDL.useState)(false);
    const [renaming, setRenaming] = (0, $3OyDL.useState)(false);
    const [phone, setPhone] = (0, $3OyDL.useState)('');
    // The server refuses this; saying so BEFORE the click is the difference
    // between a disabled button with a reason and an error nobody expected.
    const otherActive = accounts.some((a)=>a.id !== account.id && a.isActive);
    const blockedFromDeactivating = account.isDefault && otherActive;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
        className: "flex flex-col gap-4",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex flex-wrap items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                        className: "text-md font-bold",
                        children: account.label
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("code", {
                        dir: "ltr",
                        className: "text-xs text-text-muted",
                        children: account.accountId
                    }),
                    account.isDefault && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                        className: "bg-surface-hover text-success",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e91ad3707c8273fb$export$2e2bcd8739ae039), {
                                size: 12,
                                "aria-hidden": "true"
                            }),
                            " ",
                            (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.isDefault
                        ]
                    }),
                    !account.isActive && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                        className: "bg-surface-hover text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.inactive
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                        className: "bg-surface-hover",
                        children: account.linked ? (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.paired : (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.notLinkedYet
                    }),
                    account.linked && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                        className: account.connected ? 'bg-surface-hover text-success' : 'bg-surface-hover text-text-muted',
                        children: account.connected ? (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.connected : (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.disconnected
                    }),
                    account.sendDisabled && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                        className: "bg-surface-hover text-danger",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.sendDisabled
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)($8b2aa657be98f217$var$StatusFields, {
                status: account
            }),
            !account.linked && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-sm text-warning",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.perAccountWarmup
            }),
            isAdmin && /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex flex-wrap items-end gap-3 border-t border-border pt-4",
                children: [
                    !account.linked && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                variant: "primary",
                                onClick: ()=>onPair(phone),
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ks4jt.default), {
                                        size: 14,
                                        "aria-hidden": "true"
                                    }),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.pair
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                                label: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.phoneForCode,
                                hint: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.codeAlternative,
                                value: phone,
                                dir: "ltr",
                                onChange: (event)=>setPhone(event.target.value)
                            })
                        ]
                    }),
                    account.linked && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "danger",
                        onClick: ()=>setConfirming(true),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $41dbd9baa470cf33$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.unlink
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "ghost",
                        onClick: ()=>setRenaming(true),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2vK0R.default), {
                                size: 14,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.rename
                        ]
                    }),
                    !account.isDefault && account.isActive && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "ghost",
                        onClick: ()=>setDefault({
                                variables: {
                                    id: account.id
                                }
                            }),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e91ad3707c8273fb$export$2e2bcd8739ae039), {
                                size: 14,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.makeDefault
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "ghost",
                        disabled: blockedFromDeactivating,
                        title: blockedFromDeactivating ? (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.cannotDeactivateDefault : undefined,
                        onClick: ()=>setActive({
                                variables: {
                                    id: account.id,
                                    isActive: !account.isActive
                                }
                            }),
                        children: account.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.deactivate : (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.activate
                    })
                ]
            }),
            blockedFromDeactivating && isAdmin && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-xs text-text-muted",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.cannotDeactivateDefault
            }),
            pairing && /*#__PURE__*/ (0, $2M70Q.jsx)($8b2aa657be98f217$var$PairingPanel, {
                pairing: pairing
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: unlinkState.error || defaultState.error || activeState.error
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2cc85109a937009e), {
                open: confirming,
                onOpenChange: setConfirming,
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.unlink,
                body: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.unlinkConfirm,
                confirmLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.unlink,
                destructive: true,
                onConfirm: async ()=>{
                    await unlink({
                        variables: {
                            accountId: account.accountId
                        }
                    });
                    setConfirming(false);
                }
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)($8b2aa657be98f217$var$RenameDialog, {
                open: renaming,
                onOpenChange: setRenaming,
                account: account,
                onRenamed: onChanged
            })
        ]
    });
}
/** The gateway's live half, shared by both card shapes so they cannot drift. */ function $8b2aa657be98f217$var$StatusFields({ status: status }) {
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "grid grid-cols-3 gap-4",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.linkedNumber,
                children: /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                    dir: "ltr",
                    children: status.phoneE164 || (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.pushName,
                children: status.pushName || (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.queueDepth,
                children: (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(status.queueDepth)
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.sentLastHour,
                children: [
                    (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(status.sentLastHour),
                    " / ",
                    (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(status.maxPerHour)
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.lastError,
                children: /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                    className: "text-danger",
                    children: status.lastError || (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                })
            })
        ]
    });
}
function $8b2aa657be98f217$var$RenameDialog({ open: open, onOpenChange: onOpenChange, account: account, onRenamed: onRenamed }) {
    const [label, setLabel] = (0, $3OyDL.useState)(account.label);
    const [rename, state] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$3b41fa584fa4ca4), {
        onCompleted: ()=>{
            onRenamed();
            onOpenChange(false);
        }
    });
    (0, $3OyDL.useEffect)(()=>{
        if (open) setLabel(account.label);
    }, [
        open,
        account.label
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: open,
        onOpenChange: onOpenChange,
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.rename,
        submitLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).app.save,
        busy: state.loading,
        canSubmit: Boolean(label.trim()),
        error: state.error,
        onSubmit: ()=>rename({
                variables: {
                    id: account.id,
                    label: label.trim()
                }
            }),
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.accountLabel,
                hint: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.accountLabelHint,
                value: label,
                onChange: (event)=>setLabel(event.target.value)
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$a455218a85c89869), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.accountId,
                children: /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                    dir: "ltr",
                    className: "text-text-muted",
                    children: account.accountId
                })
            })
        ]
    });
}
function $8b2aa657be98f217$var$AddAccountCard({ empty: empty, onCreated: onCreated }) {
    const [open, setOpen] = (0, $3OyDL.useState)(false);
    const [accountId, setAccountId] = (0, $3OyDL.useState)('');
    const [label, setLabel] = (0, $3OyDL.useState)('');
    const [create, state] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$d8464ea945544c47), {
        onCompleted: ()=>{
            onCreated();
            setOpen(false);
            setAccountId('');
            setLabel('');
        }
    });
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
                className: "flex flex-wrap items-center gap-3",
                children: [
                    empty && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                        className: "text-sm text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.accountsEmpty
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "primary",
                        onClick: ()=>setOpen(true),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                                size: 14,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.addAccount
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
                open: open,
                onOpenChange: setOpen,
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.addAccount,
                hint: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.addAccountHint,
                submitLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).app.save,
                busy: state.loading,
                // ONE required field. The id is the machine's job.
                canSubmit: Boolean(label.trim()),
                error: state.error,
                onSubmit: ()=>create({
                        variables: {
                            label: label.trim(),
                            // Empty means «derive it from the label», which is the path
                            // essentially everybody takes.
                            accountId: accountId.trim() || null
                        }
                    }),
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.accountLabel,
                        hint: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.accountLabelHint,
                        value: label,
                        onChange: (event)=>setLabel(event.target.value)
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("details", {
                        className: "text-xs",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("summary", {
                                className: "cursor-pointer text-text-muted",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.accountIdToggle
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                                className: "mt-2",
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                                    label: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.accountId,
                                    hint: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.accountIdHint,
                                    value: accountId,
                                    dir: "ltr",
                                    placeholder: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.accountIdPlaceholder,
                                    onChange: (event)=>setAccountId(event.target.value)
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $8b2aa657be98f217$var$PairingPanel({ pairing: pairing }) {
    if (pairing.kind === 'PENDING') return /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
        className: "flex items-center gap-2 text-sm text-text-muted",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {}),
            " ",
            (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.pairing
        ]
    });
    if (pairing.kind === 'SUCCESS') return /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
        className: "text-sm text-success",
        children: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.pairSuccess
    });
    if (pairing.kind === 'TIMEOUT') return /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
        className: "text-sm text-warning",
        children: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.pairTimeout
    });
    if (pairing.kind === 'ERROR') return /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
        className: "text-sm text-danger",
        children: pairing.message
    });
    if (pairing.kind === 'PAIRING_CODE') return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-sm text-text-muted",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.scanHint
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                dir: "ltr",
                className: "text-xl font-bold tracking-widest",
                children: pairing.code
            })
        ]
    });
    // QR. Drawn as a scannable code since 2026-09-06; it used to be the payload
    // text and an instruction to paste it elsewhere (ui.md).
    //
    // THE TEXT SURVIVES, behind a disclosure. It is what a support call falls
    // back to when the screen will not scan — a glare, a scaled-down window, a
    // camera that cannot focus that close — and it costs nothing to keep. Closed
    // by default, because offering both as equals would suggest the operator has
    // a decision to make here.
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex flex-col gap-3",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-sm text-text-muted",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.scanHint
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6d114691ee51c401$export$e3b6b80dd4f481c3), {
                value: pairing.code,
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.qrLabel
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)($8b2aa657be98f217$var$CountDown, {
                seconds: pairing.expiresInSeconds
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("details", {
                className: "text-xs",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("summary", {
                        className: "cursor-pointer text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.qrPayloadToggle
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("code", {
                        dir: "ltr",
                        className: "mt-2 block max-h-32 overflow-auto break-all rounded border border-border bg-bg p-3 text-xs",
                        children: pairing.code
                    })
                ]
            })
        ]
    });
}
/** The countdown that answers «چرا هیچ اتفاقی نمی‌افتد». */ function $8b2aa657be98f217$var$CountDown({ seconds: seconds }) {
    const [left, setLeft] = (0, $3OyDL.useState)(seconds ?? 0);
    (0, $3OyDL.useEffect)(()=>{
        setLeft(seconds ?? 0);
        const timer = setInterval(()=>setLeft((v)=>v > 0 ? v - 1 : 0), 1000);
        return ()=>clearInterval(timer);
    }, [
        seconds
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
        className: "text-xs text-text-muted tabular-nums",
        children: [
            (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(left),
            "s"
        ]
    });
}


/**
 * `/settings/checklists` — checklist templates (ADMIN).
 *
 * Same shape as the other Step 2 settings screens, and the same rule: no
 * delete, only deactivation. A template that stops being offered leaves every
 * checklist already made from it working, because a checklist is a COPY — the
 * note on this page says so, because it is the thing an administrator will
 * most reasonably assume otherwise.
 */ 
var $2M70Q = parcelRequire("2M70Q");



var $6PxCH = parcelRequire("6PxCH");

var $3OyDL = parcelRequire("3OyDL");




const $4b42b481428550c6$var$emptyDraft = {
    title: '',
    description: '',
    items: ''
};
function $4b42b481428550c6$export$7440c21dce611c38() {
    const [editing, setEditing] = (0, $3OyDL.useState)(null);
    const [draft, setDraft] = (0, $3OyDL.useState)($4b42b481428550c6$var$emptyDraft);
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$68d6e722992ca7ca), {
        variables: {
            includeInactive: true
        }
    });
    const [createTemplate, createState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$7aa9473f85afc7a), {
        onCompleted: ()=>refetch()
    });
    const [updateTemplate, updateState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$1ad4459b0390dadd), {
        onCompleted: ()=>refetch()
    });
    const [setActive, activeState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$d31b8b684d42dab8), {
        onCompleted: ()=>refetch()
    });
    const templates = data?.checklistTemplates ?? [];
    function open(template) {
        setEditing(template ?? {
            id: null
        });
        setDraft(template ? {
            title: template.title,
            description: template.description ?? '',
            // One item per line: the fastest way to write six steps, and the
            // fastest way to read them back.
            items: template.items.map((item)=>item.title).join('\n')
        } : $4b42b481428550c6$var$emptyDraft);
    }
    async function save() {
        const items = draft.items.split('\n').map((line)=>line.trim()).filter(Boolean);
        const input = {
            title: draft.title,
            description: draft.description || null,
            items: items
        };
        if (editing?.id) await updateTemplate({
            variables: {
                id: editing.id,
                input: input
            }
        });
        else await createTemplate({
            variables: {
                input: input
            }
        });
        setEditing(null);
    }
    const itemCount = draft.items.split('\n').filter((line)=>line.trim()).length;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex flex-col gap-4 p-5",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("header", {
                className: "flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $74429f95599e26c6$export$2e2bcd8739ae039), {
                        size: 18,
                        className: "text-primary",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h1", {
                        className: "text-md font-bold",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).checklists.templates
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        type: "button",
                        variant: "primary",
                        className: "ms-auto",
                        onClick: ()=>open(null),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                                size: 15,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).checklists.newTemplate
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-sm text-text-muted",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).checklists.copyNote
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: error ?? createState.error ?? updateState.error ?? activeState.error
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$4b2346c6725d60cc), {
                loading: loading,
                empty: templates.length === 0,
                emptyTitle: (0, $d916753b57975e04$export$25ce5a424b770e84).checklists.empty
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
                className: "flex flex-col gap-2",
                children: templates.map((template)=>/*#__PURE__*/ (0, $2M70Q.jsxs)("li", {
                        className: [
                            'flex items-center gap-4 rounded border border-border bg-surface px-4 py-3',
                            template.isActive ? '' : 'opacity-60'
                        ].join(' '),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                className: "flex flex-1 flex-col",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                        className: "font-medium",
                                        children: template.title
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                        className: "text-xs text-text-muted",
                                        children: [
                                            (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(template.items.length),
                                            " ",
                                            (0, $d916753b57975e04$export$25ce5a424b770e84).checklists.items,
                                            template.description ? ` \xb7 ${template.description}` : ''
                                        ]
                                    })
                                ]
                            }),
                            template.isSystem && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                className: "rounded bg-surface-hover px-2 py-px text-xs text-text-muted",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.system
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                type: "button",
                                onClick: ()=>open(template),
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.edit
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                type: "button",
                                onClick: ()=>setActive({
                                        variables: {
                                            id: template.id,
                                            isActive: !template.isActive
                                        }
                                    }),
                                children: template.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.deactivate : (0, $d916753b57975e04$export$25ce5a424b770e84).app.activate
                            })
                        ]
                    }, template.id))
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
                open: Boolean(editing),
                onOpenChange: (open_)=>!open_ && setEditing(null),
                title: editing?.id ? (0, $d916753b57975e04$export$25ce5a424b770e84).checklists.editTemplate : (0, $d916753b57975e04$export$25ce5a424b770e84).checklists.newTemplate,
                submitLabel: editing?.id ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.save : (0, $d916753b57975e04$export$25ce5a424b770e84).app.create,
                busy: createState.loading || updateState.loading,
                onSubmit: save,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).checklists.templateTitle,
                        value: draft.title,
                        onChange: (event)=>setDraft((d)=>({
                                    ...d,
                                    title: event.target.value
                                })),
                        required: true
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).checklists.templateDescription,
                        value: draft.description,
                        onChange: (event)=>setDraft((d)=>({
                                    ...d,
                                    description: event.target.value
                                }))
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$f5c9f3c2c4054eec), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).checklists.items,
                        hint: itemCount === 0 ? (0, $d916753b57975e04$export$25ce5a424b770e84).checklists.itemsRequired : (0, $d916753b57975e04$export$25ce5a424b770e84).checklists.itemsHint,
                        error: itemCount === 0 ? (0, $d916753b57975e04$export$25ce5a424b770e84).checklists.itemsRequired : undefined,
                        rows: 8,
                        value: draft.items,
                        onChange: (event)=>setDraft((d)=>({
                                    ...d,
                                    items: event.target.value
                                }))
                    })
                ]
            })
        ]
    });
}



var $2M70Q = parcelRequire("2M70Q");



var $2vK0R = parcelRequire("2vK0R");
var $6PxCH = parcelRequire("6PxCH");
var $bi4P4 = parcelRequire("bi4P4");

var $3OyDL = parcelRequire("3OyDL");



const $56c3142c22569aa5$var$TYPES = [
    'TEXT',
    'NUMBER',
    'DATE',
    'BOOLEAN',
    'SELECT',
    'MULTISELECT'
];
const $56c3142c22569aa5$var$APPLIES_TO = [
    'BOTH',
    'PERSON',
    'ORGANIZATION'
];
const $56c3142c22569aa5$var$OPTION_TYPES = [
    'SELECT',
    'MULTISELECT'
];
function $56c3142c22569aa5$export$fbbbcbdee15d1996() {
    const [includeInactive, setIncludeInactive] = (0, $3OyDL.useState)(true);
    const [editing, setEditing] = (0, $3OyDL.useState)(null);
    const [confirming, setConfirming] = (0, $3OyDL.useState)(null);
    const variables = {
        includeInactive: includeInactive
    };
    const { data: data, loading: loading } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$3c145a0cae51e944), {
        variables: variables
    });
    const refetch = [
        {
            query: (0, $13be303c7211393a$export$3c145a0cae51e944),
            variables: variables
        }
    ];
    const [create, createState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$6588b0f00bceb444), {
        refetchQueries: refetch
    });
    const [update, updateState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$e970ae7328b2abf9), {
        refetchQueries: refetch
    });
    const [setActive, activeState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$5062eff1685daf61), {
        refetchQueries: refetch
    });
    const rows = data?.customFieldDefinitions ?? [];
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $287828886661deba$export$8f6dcfe950367406), {
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.sections.customFields,
        hint: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.customFields.deactivateHint,
        toolbar: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $287828886661deba$export$13da608e8f9e10fe), {
                    checked: includeInactive,
                    onChange: setIncludeInactive
                }),
                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                    variant: "primary",
                    onClick: ()=>setEditing('new'),
                    className: "gap-2",
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                            size: 15,
                            "aria-hidden": "true"
                        }),
                        (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.newItem
                    ]
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: createState.error || updateState.error || activeState.error
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$4b2346c6725d60cc), {
                loading: loading && rows.length === 0,
                empty: !loading && rows.length === 0
            }),
            rows.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$54ec01a60f47d33d), {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$c4c2bc57f2e82919), {
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.customFields.label
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.customFields.name
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.customFields.type
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.customFields.appliesTo
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.customFields.options
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.status
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.actions
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7005b8a93a167348), {
                        children: rows.map((field)=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                className: field.isActive ? '' : 'opacity-60',
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        className: "font-medium",
                                        children: field.labelFa
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        dir: "ltr",
                                        className: "text-start text-text-muted",
                                        children: field.name
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.customFields.types[field.type]
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.customFields.appliesToOptions[field.appliesTo]
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        className: "text-text-muted",
                                        children: field.options.length ? field.options.join("\u060C ") : (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $287828886661deba$export$cb8f259c2accb9d1), {
                                            isActive: field.isActive
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                            className: "flex items-center gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                                    variant: "ghost",
                                                    title: (0, $d916753b57975e04$export$25ce5a424b770e84).app.edit,
                                                    onClick: ()=>setEditing(field),
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2vK0R.default), {
                                                        size: 14,
                                                        "aria-hidden": "true"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                                    variant: "ghost",
                                                    onClick: ()=>setConfirming(field),
                                                    children: field.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.deactivate : (0, $d916753b57975e04$export$25ce5a424b770e84).app.activate
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }, field.id))
                    })
                ]
            }),
            editing && /*#__PURE__*/ (0, $2M70Q.jsx)($56c3142c22569aa5$var$CustomFieldDialog, {
                field: editing === 'new' ? null : editing,
                busy: createState.loading || updateState.loading,
                onClose: ()=>setEditing(null),
                onSubmit: async (input)=>{
                    if (editing === 'new') await create({
                        variables: {
                            input: input
                        }
                    });
                    else await update({
                        variables: {
                            id: editing.id,
                            input: input
                        }
                    });
                    setEditing(null);
                }
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2cc85109a937009e), {
                open: Boolean(confirming),
                onOpenChange: (open)=>!open && setConfirming(null),
                title: confirming?.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.deactivate : (0, $d916753b57975e04$export$25ce5a424b770e84).app.activate,
                message: confirming?.isActive ? `${(0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.confirmDeactivate(confirming?.labelFa ?? '')} ${(0, $d916753b57975e04$export$25ce5a424b770e84).settings.customFields.deactivateHint}` : (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.confirmActivate(confirming?.labelFa ?? ''),
                danger: confirming?.isActive,
                confirmLabel: confirming?.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.deactivate : (0, $d916753b57975e04$export$25ce5a424b770e84).app.activate,
                onConfirm: ()=>setActive({
                        variables: {
                            id: confirming.id,
                            isActive: !confirming.isActive
                        }
                    })
            })
        ]
    });
}
function $56c3142c22569aa5$var$CustomFieldDialog({ field: field, onClose: onClose, onSubmit: onSubmit, busy: busy }) {
    const isNew = !field;
    const [name, setName] = (0, $3OyDL.useState)(field?.name ?? '');
    const [labelFa, setLabelFa] = (0, $3OyDL.useState)(field?.labelFa ?? '');
    const [type, setType] = (0, $3OyDL.useState)(field?.type ?? 'TEXT');
    const [appliesTo, setAppliesTo] = (0, $3OyDL.useState)(field?.appliesTo ?? 'BOTH');
    const [options, setOptions] = (0, $3OyDL.useState)(field?.options ?? []);
    const [draftOption, setDraftOption] = (0, $3OyDL.useState)('');
    const needsOptions = $56c3142c22569aa5$var$OPTION_TYPES.includes(type);
    function addOption() {
        const value = draftOption.trim();
        if (!value || options.includes(value)) return;
        setOptions([
            ...options,
            value
        ]);
        setDraftOption('');
    }
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: true,
        onOpenChange: (open)=>!open && onClose(),
        title: isNew ? (0, $d916753b57975e04$export$25ce5a424b770e84).settings.customFields.createTitle : `${(0, $d916753b57975e04$export$25ce5a424b770e84).app.edit} \u{2014} ${field.labelFa}`,
        busy: busy,
        onSubmit: ()=>onSubmit(isNew ? {
                name: name.trim(),
                labelFa: labelFa,
                type: type,
                appliesTo: appliesTo,
                options: needsOptions ? options : []
            } : {
                labelFa: labelFa,
                appliesTo: appliesTo,
                options: needsOptions ? options : []
            }),
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.customFields.name,
                value: name,
                dir: "ltr",
                required: isNew,
                disabled: !isNew,
                hint: isNew ? (0, $d916753b57975e04$export$25ce5a424b770e84).settings.customFields.nameHint : (0, $d916753b57975e04$export$25ce5a424b770e84).settings.customFields.nameImmutable,
                onChange: (event)=>setName(event.target.value.toLowerCase())
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.customFields.label,
                value: labelFa,
                required: true,
                onChange: (event)=>setLabelFa(event.target.value)
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.customFields.type,
                value: type,
                disabled: !isNew,
                hint: isNew ? undefined : (0, $d916753b57975e04$export$25ce5a424b770e84).settings.customFields.nameImmutable,
                onChange: (event)=>setType(event.target.value),
                children: $56c3142c22569aa5$var$TYPES.map((t)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: t,
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.customFields.types[t]
                    }, t))
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.customFields.appliesTo,
                value: appliesTo,
                onChange: (event)=>setAppliesTo(event.target.value),
                children: $56c3142c22569aa5$var$APPLIES_TO.map((a)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: a,
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.customFields.appliesToOptions[a]
                    }, a))
            }),
            needsOptions && /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-sm text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.customFields.options
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
                        className: "flex flex-wrap gap-2",
                        children: options.map((option)=>/*#__PURE__*/ (0, $2M70Q.jsxs)("li", {
                                className: "flex items-center gap-2 rounded border border-border px-3 py-1 text-sm",
                                children: [
                                    option,
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                                        type: "button",
                                        "aria-label": `${(0, $d916753b57975e04$export$25ce5a424b770e84).app.close} ${option}`,
                                        className: "text-text-muted hover:text-danger",
                                        onClick: ()=>setOptions(options.filter((o)=>o !== option)),
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $bi4P4.default), {
                                            size: 12,
                                            "aria-hidden": "true"
                                        })
                                    })
                                ]
                            }, option))
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                                value: draftOption,
                                onChange: (event)=>setDraftOption(event.target.value),
                                onKeyDown: (event)=>{
                                    // Enter adds an option instead of submitting the whole form,
                                    // which is what someone typing a list expects.
                                    if (event.key === 'Enter') {
                                        event.preventDefault();
                                        addOption();
                                    }
                                },
                                placeholder: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.customFields.addOption,
                                className: "h-control flex-1 rounded border border-border bg-bg px-4 text-base outline-none focus:border-primary"
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                type: "button",
                                onClick: addOption,
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.customFields.addOption
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-xs text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.customFields.optionsHint
                    })
                ]
            })
        ]
    });
}


/**
 * `/settings/integrations` — the Google connection.
 *
 * SELF-SERVICE for every role, which is why this page sits under /settings but
 * is NOT ADMIN-gated: a Google connection is one person's own calendar, and an
 * admin connecting one on somebody's behalf would mean holding their
 * credentials. The scheduling service refuses any user id but the caller's, so
 * the boundary is real rather than a UI convention.
 *
 * When the deployment has no OAuth client, this page says so and explains what
 * an operator must do — the whole feature degrades to a notice rather than a
 * broken button.
 */ 
var $2M70Q = parcelRequire("2M70Q");



var $6tkl0 = parcelRequire("6tkl0");
var $ks4jt = parcelRequire("ks4jt");
var $jqtUP = parcelRequire("jqtUP");

var $3OyDL = parcelRequire("3OyDL");

var $8B9Zg = parcelRequire("8B9Zg");





function $5a0c03611e51adce$export$f6f0dceccdb6a70d(url) {
    if (!url) return '#';
    const token = (0, $f0578ea5f18e5637$export$84773cc9bf7dbe87)();
    if (!token) return url;
    const joiner = url.includes('?') ? '&' : '?';
    return `${url}${joiner}token=${encodeURIComponent(token)}`;
}
function $5a0c03611e51adce$export$bcc5fd5e78aa1400() {
    const [params, setParams] = (0, $8B9Zg.useSearchParams)();
    const [notice, setNotice] = (0, $3OyDL.useState)(null);
    const [confirmDisconnect, setConfirmDisconnect] = (0, $3OyDL.useState)(false);
    const [calendarId, setCalendarId] = (0, $3OyDL.useState)('');
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$c934b5b4ba3d37d1), {
        fetchPolicy: 'cache-and-network'
    });
    const [syncNow, syncState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$a55e62122bd685e));
    const [disconnect, disconnectState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$a57372ef6713ed79));
    const [setCalendar, calendarState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$8ef7c2a226fc63e3));
    const connection = data?.googleConnection;
    (0, $3OyDL.useEffect)(()=>{
        if (connection?.calendarId) setCalendarId(connection.calendarId);
    }, [
        connection?.calendarId
    ]);
    /**
   * The OAuth callback sends the browser back here with an outcome in the query
   * string. Read once and cleared, so a reload does not re-announce a
   * connection that happened ten minutes ago.
   */ (0, $3OyDL.useEffect)(()=>{
        const outcome = params.get('google');
        if (!outcome) return;
        const detail = params.get('detail');
        setNotice(outcome === 'connected' ? {
            kind: 'ok',
            text: (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.connected
        } : outcome === 'denied' ? {
            kind: 'warn',
            text: (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.denied
        } : {
            kind: 'error',
            text: `${(0, $d916753b57975e04$export$25ce5a424b770e84).integrations.error}: ${detail ?? ''}`
        });
        setParams({}, {
            replace: true
        });
        refetch();
    }, [
        params,
        setParams,
        refetch
    ]);
    if (loading && !connection) return /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
        className: "flex justify-center py-8",
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {})
    });
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex flex-col gap-5 p-5",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("header", {
                children: /*#__PURE__*/ (0, $2M70Q.jsx)("h1", {
                    className: "text-md font-bold",
                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.title
                })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: error ?? syncState.error ?? disconnectState.error ?? calendarState.error
            }),
            notice && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: [
                    'rounded border px-3 py-2 text-sm',
                    notice.kind === 'ok' ? 'border-success text-success' : notice.kind === 'warn' ? 'border-warning text-warning' : 'border-danger text-danger'
                ].join(' '),
                children: notice.text
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("section", {
                className: "flex flex-col gap-4 rounded border border-border bg-surface p-5",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                        className: "text-base font-medium",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.google
                    }),
                    !connection?.configured ? /* Not an error — a deployment fact. The page explains what an
             operator must do instead of showing a button that cannot work. */ /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "flex items-start gap-3 rounded border border-border bg-bg p-4",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6tkl0.default), {
                                size: 16,
                                className: "mt-px text-warning",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                className: "flex flex-col gap-1",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                        className: "text-sm font-medium",
                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.notConfigured
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                        className: "text-sm text-text-muted",
                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.notConfiguredHint
                                    })
                                ]
                            })
                        ]
                    }) : connection.connected ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("dl", {
                                className: "grid grid-cols-2 gap-3 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("dt", {
                                        className: "text-text-muted",
                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.connectedAs
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("dd", {
                                        dir: "ltr",
                                        className: "text-start",
                                        children: connection.googleEmail || (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("dt", {
                                        className: "text-text-muted",
                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.lastSync
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("dd", {
                                        children: connection.lastSyncAt ? (0, $d4d460d3ffb6daab$export$8b492ed8828f789c)(connection.lastSyncAt) : (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.never
                                    }),
                                    connection.lastError && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)("dt", {
                                                className: "text-text-muted",
                                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.lastError
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)("dd", {
                                                className: "text-danger",
                                                children: connection.lastError
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                className: "flex items-end gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.calendarTarget,
                                        value: calendarId,
                                        onChange: (event)=>setCalendarId(event.target.value),
                                        dir: "ltr"
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                        type: "button",
                                        disabled: !calendarId || calendarId === connection.calendarId,
                                        onClick: ()=>setCalendar({
                                                variables: {
                                                    calendarId: calendarId
                                                }
                                            }),
                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.save
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                className: "flex gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                        type: "button",
                                        variant: "primary",
                                        disabled: syncState.loading,
                                        onClick: async ()=>{
                                            const result = await syncNow();
                                            const outcome = result.data?.syncGoogleNow;
                                            if (outcome) setNotice({
                                                kind: outcome.errors?.length ? 'warn' : 'ok',
                                                text: outcome.skippedReason || (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.syncResult(outcome.pushed, outcome.pulled, outcome.imported)
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $jqtUP.default), {
                                                size: 14,
                                                "aria-hidden": "true"
                                            }),
                                            syncState.loading ? (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.syncing : (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.syncNow
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                        type: "button",
                                        onClick: ()=>setConfirmDisconnect(true),
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $41dbd9baa470cf33$export$2e2bcd8739ae039), {
                                                size: 14,
                                                "aria-hidden": "true"
                                            }),
                                            (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.disconnect
                                        ]
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "flex flex-col items-start gap-3",
                        children: [
                            connection.googleEmail && // The row remembers WHICH account was connected, so a revoked
                            // connection can say "reconnect this one" rather than starting
                            // from nothing.
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                                className: "text-sm text-text-muted",
                                children: [
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.connectedAs,
                                    ": ",
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                        dir: "ltr",
                                        children: connection.googleEmail
                                    })
                                ]
                            }),
                            connection.lastError && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                className: "text-sm text-danger",
                                children: connection.lastError
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("a", {
                                href: $5a0c03611e51adce$export$f6f0dceccdb6a70d(connection.connectUrl),
                                className: "flex h-control items-center gap-2 rounded bg-primary px-4 text-sm text-primary-contrast hover:bg-primary-hover",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ks4jt.default), {
                                        size: 14,
                                        "aria-hidden": "true"
                                    }),
                                    connection.googleEmail ? (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.reconnect : (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.connect
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("details", {
                        className: "text-sm",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("summary", {
                                className: "cursor-pointer text-text-muted",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.whatSyncs
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                className: "mt-2 leading-relaxed text-text-muted",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.whatSyncsBody
                            })
                        ]
                    })
                ]
            }),
            connection?.recent?.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)("section", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                        className: "text-sm font-medium",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.recentActivity
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("table", {
                        className: "w-full border-collapse text-sm",
                        children: /*#__PURE__*/ (0, $2M70Q.jsx)("tbody", {
                            children: connection.recent.map((entry, index)=>/*#__PURE__*/ (0, $2M70Q.jsxs)("tr", {
                                    className: "border-b border-border",
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)("td", {
                                            className: "px-4 py-2 align-middle text-text-muted",
                                            children: (0, $d4d460d3ffb6daab$export$8b492ed8828f789c)(entry.at)
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)("td", {
                                            className: "px-4 py-2 align-middle",
                                            dir: "ltr",
                                            children: entry.direction
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)("td", {
                                            className: "px-4 py-2 align-middle",
                                            dir: "ltr",
                                            children: entry.entity
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)("td", {
                                            className: `px-4 py-2 align-middle ${entry.outcome === 'error' ? 'text-danger' : entry.outcome === 'conflict' ? 'text-warning' : ''}`,
                                            dir: "ltr",
                                            children: entry.outcome
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)("td", {
                                            className: "px-4 py-2 align-middle text-text-muted",
                                            children: entry.error
                                        })
                                    ]
                                }, `${entry.at}-${index}`))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2cc85109a937009e), {
                open: confirmDisconnect,
                onOpenChange: setConfirmDisconnect,
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.disconnect,
                description: (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.disconnectConfirm,
                confirmLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.disconnect,
                destructive: true,
                onConfirm: async ()=>{
                    await disconnect();
                    setConfirmDisconnect(false);
                    refetch();
                }
            })
        ]
    });
}


/**
 * ورود مخاطبین از فایل اکسل — the congress spreadsheet import.
 *
 * TWO STEPS, AND THE FIRST ONE WRITES NOTHING. Choosing a file previews it;
 * only «تأیید و ثبت» commits. The preview is not a summary computed here — it
 * is the server's own plan, row by row, and the commit applies that same plan.
 * A client that computed its own preview would eventually disagree with the
 * server, and the client's is the one the user would have believed (the
 * `previewSend` rule, CLAUDE.md §12).
 *
 * The per-row table is the point of the screen. «۷۶ مخاطب اضافه شد» is not
 * enough to approve an irreversible-ish bulk write: the operator needs to see
 * WHICH row was refused and why, and which contact a duplicate attached to.
 */ 
var $2M70Q = parcelRequire("2M70Q");


var $6tkl0 = parcelRequire("6tkl0");
var $aNyTM = parcelRequire("aNyTM");/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $1f1f16c9a06c706c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
            key: "1oefj6"
        }
    ],
    [
        "path",
        {
            d: "M14 2v5a1 1 0 0 0 1 1h5",
            key: "wfsgrz"
        }
    ],
    [
        "path",
        {
            d: "M12 12v6",
            key: "3ahymv"
        }
    ],
    [
        "path",
        {
            d: "m15 15-3-3-3 3",
            key: "15xj92"
        }
    ]
];
const $1f1f16c9a06c706c$export$2e2bcd8739ae039 = (0, $djixo.default)("file-up", $1f1f16c9a06c706c$export$3efd853dbb351e94);



var $3OyDL = parcelRequire("3OyDL");


/**
 * The spreadsheet import — preview then commit.
 *
 * Not GraphQL, for the reason `files.js` and the CSV export are not: an upload
 * is a multipart body, which GraphQL cannot express.
 *
 * THE FILE IS SENT TWICE, once to preview and once to commit, and that is
 * deliberate. Parking it on the server between the two would need a session,
 * an expiry and a cleanup job for a file the browser is already holding — and
 * the commit re-runs the same planner anyway, so the second answer is the one
 * that counts.
 */ 

const $963accd20c2a73f8$var$BASE = (0, $b5d41e4dbaeacaa2$export$4dc6837bb3c0882f);
class $963accd20c2a73f8$export$adb28e3846b9f9f6 extends Error {
    constructor(message, code){
        super(message);
        this.name = 'ImportError';
        this.code = code ?? 'INTERNAL_SERVER_ERROR';
    }
}
async function $963accd20c2a73f8$export$85b28d1a11ab01d4(file, { mode: mode = 'preview', sheet: sheet, rows: rows, signal: signal } = {}) {
    const token = (0, $f0578ea5f18e5637$export$84773cc9bf7dbe87)();
    const form = new FormData();
    form.append('file', file);
    // Absent means every row. A commit carries the subset the operator ticked,
    // and the server RE-PLANS it — dropping one row can change another's
    // outcome, and only the planner knows that.
    if (rows) form.append('rows', rows.join(','));
    const params = new URLSearchParams({
        mode: mode
    });
    if (sheet) params.set('sheet', sheet);
    const response = await fetch(`${$963accd20c2a73f8$var$BASE}/imports/contacts?${params}`, {
        method: 'POST',
        // No content-type header: the browser sets it WITH the multipart boundary,
        // and setting it by hand produces a body the server cannot split.
        headers: token ? {
            authorization: `Bearer ${token}`
        } : {},
        body: form,
        signal: signal
    });
    const payload = await response.json().catch(()=>null);
    if (!response.ok) throw new $963accd20c2a73f8$export$adb28e3846b9f9f6(payload?.error?.message ?? `import failed (${response.status})`, payload?.error?.code);
    return payload;
}




const $7055ef928be9ba0d$var$OUTCOME_STYLE = {
    CREATED: 'text-success',
    MATCHED: 'text-text',
    SKIPPED: 'text-text-muted',
    INVALID: 'text-danger'
};
/**
 * Only a row that would WRITE something can be selected.
 *
 * INVALID has nothing to import and SKIPPED is already on file, so a checkbox
 * beside either would be a control that cannot change the outcome — the same
 * reason the send dialog hides the force toggle beside an OPT_OUT
 * (CLAUDE.md §12).
 */ function $7055ef928be9ba0d$var$isSelectable(row) {
    return row.outcome === 'CREATED' || row.outcome === 'MATCHED';
}
function $7055ef928be9ba0d$var$Stat({ label: label, value: value, tone: tone }) {
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex flex-col gap-1 rounded border border-border bg-surface px-4 py-3",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                className: "text-xs text-text-muted",
                children: label
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                className: `text-lg font-bold ${tone ?? ''}`,
                children: (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(value)
            })
        ]
    });
}
/**
 * Each of these shows the CELL as written, and underneath it what the import
 * read it as — but only when the two differ. «رجبی» under «آقای دکتر رجبی» is
 * worth a line; «تهران» under «تهران» is noise.
 */ function $7055ef928be9ba0d$var$NameCell({ row: row }) {
    const written = row.source?.name ?? '';
    const read = row.parsed?.lastName ?? '';
    const gender = row.parsed?.gender ? (0, $d916753b57975e04$export$25ce5a424b770e84).imports.genders[row.parsed.gender] : null;
    const same = written === read && !gender;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                children: written
            }),
            !same && /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                className: "text-xs text-text-muted",
                children: [
                    (0, $d916753b57975e04$export$25ce5a424b770e84).imports.readAs,
                    ": ",
                    read || "\u2014",
                    gender ? ` \xb7 ${gender}` : ''
                ]
            })
        ]
    });
}
function $7055ef928be9ba0d$var$DateCell({ row: row }) {
    const written = row.source?.date ?? '';
    const iso = row.parsed?.occurredAt;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                children: written
            }),
            iso ? // Converted back to Jalali rather than shown as ISO: it proves the
            // round trip AND is the calendar the operator reads.
            /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                className: "text-xs text-text-muted",
                children: [
                    (0, $d916753b57975e04$export$25ce5a424b770e84).imports.readAs,
                    ": ",
                    (0, $d4d460d3ffb6daab$export$aae69b02cbc5f8df)(iso)
                ]
            }) : written && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                className: "text-xs text-danger",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).imports.notRead
            })
        ]
    });
}
function $7055ef928be9ba0d$var$PhoneCell({ row: row }) {
    const written = row.source?.phone ?? '';
    const read = row.parsed?.phone ?? '';
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex flex-col",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                children: (0, $d4d460d3ffb6daab$export$e9cf274fc1035ec4)(written)
            }),
            read && read !== written && /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                className: "text-xs text-text-muted",
                children: [
                    (0, $d916753b57975e04$export$25ce5a424b770e84).imports.readAs,
                    ": ",
                    read
                ]
            })
        ]
    });
}
function $7055ef928be9ba0d$export$3f07954da1f48015() {
    const { isAdmin: isAdmin } = (0, $00d5d84dffcdf8d5$export$ad0a340bf97d63d5)();
    const inputRef = (0, $3OyDL.useRef)(null);
    const [file, setFile] = (0, $3OyDL.useState)(null);
    const [plan, setPlan] = (0, $3OyDL.useState)(null);
    const [committed, setCommitted] = (0, $3OyDL.useState)(false);
    const [busy, setBusy] = (0, $3OyDL.useState)(null); // 'preview' | 'commit'
    const [error, setError] = (0, $3OyDL.useState)(null);
    //: Row numbers the operator wants imported. Seeded from the preview with
    //: everything importable already ticked — the common case is "all of it",
    //: and making somebody tick 84 boxes to get there would be hostile.
    const [selected, setSelected] = (0, $3OyDL.useState)(()=>new Set());
    if (!isAdmin) return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $287828886661deba$export$8f6dcfe950367406), {
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).imports.title,
        children: /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
            className: "text-sm text-text-muted",
            children: (0, $d916753b57975e04$export$25ce5a424b770e84).imports.onlyAdmin
        })
    });
    async function run(mode, chosen = file) {
        if (!chosen) return;
        setBusy(mode);
        setError(null);
        try {
            const result = await (0, $963accd20c2a73f8$export$85b28d1a11ab01d4)(chosen, {
                mode: mode,
                rows: mode === 'commit' ? [
                    ...selected
                ] : undefined
            });
            setPlan(result);
            setCommitted(mode === 'commit');
            if (mode === 'preview') setSelected(new Set(result.rows.filter($7055ef928be9ba0d$var$isSelectable).map((r)=>r.rowNumber)));
        } catch (err) {
            setError(err.message);
            if (mode === 'preview') setPlan(null);
        } finally{
            setBusy(null);
        }
    }
    function choose(event) {
        const chosen = event.target.files?.[0];
        if (!chosen) return;
        setFile(chosen);
        setPlan(null);
        setCommitted(false);
        setSelected(new Set());
        run('preview', chosen);
    }
    function reset() {
        setFile(null);
        setPlan(null);
        setCommitted(false);
        setError(null);
        setSelected(new Set());
        if (inputRef.current) inputRef.current.value = '';
    }
    const selectableRows = (plan?.rows ?? []).filter($7055ef928be9ba0d$var$isSelectable);
    function toggleRow(rowNumber) {
        setSelected((current)=>{
            const next = new Set(current);
            if (next.has(rowNumber)) next.delete(rowNumber);
            else next.add(rowNumber);
            return next;
        });
    }
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $287828886661deba$export$8f6dcfe950367406), {
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).imports.title,
        toolbar: plan && !committed ? /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                    variant: "ghost",
                    onClick: reset,
                    disabled: busy !== null,
                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).imports.again
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                    onClick: ()=>run('commit'),
                    disabled: busy !== null || selected.size === 0,
                    children: busy === 'commit' ? (0, $d916753b57975e04$export$25ce5a424b770e84).imports.committing : (0, $d916753b57975e04$export$25ce5a424b770e84).imports.commit
                })
            ]
        }) : plan && committed ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
            variant: "ghost",
            onClick: reset,
            children: (0, $d916753b57975e04$export$25ce5a424b770e84).imports.again
        }) : null,
        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
            className: "flex flex-col gap-6",
            children: [
                !plan && /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                    className: "flex flex-col gap-3",
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                            className: "text-sm text-text-muted",
                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).imports.intro
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                            className: "text-xs text-text-muted",
                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).imports.columns
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                                    ref: inputRef,
                                    type: "file",
                                    accept: ".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                    onChange: choose,
                                    className: "hidden",
                                    id: "import-file"
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                    onClick: ()=>inputRef.current?.click(),
                                    disabled: busy !== null,
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $1f1f16c9a06c706c$export$2e2bcd8739ae039), {
                                            className: "size-4"
                                        }),
                                        busy === 'preview' ? (0, $d916753b57975e04$export$25ce5a424b770e84).imports.previewing : (0, $d916753b57975e04$export$25ce5a424b770e84).imports.choose
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                error && /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                    className: "flex items-start gap-2 rounded border border-danger bg-surface px-4 py-3 text-sm text-danger",
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6tkl0.default), {
                            className: "mt-0.5 size-4 shrink-0"
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                            children: error
                        })
                    ]
                }),
                plan && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                            className: `flex items-start gap-2 rounded border px-4 py-3 text-sm ${committed ? 'border-success bg-surface text-success' : 'border-border bg-surface text-text-muted'}`,
                            children: [
                                committed ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $aNyTM.default), {
                                    className: "mt-0.5 size-4 shrink-0"
                                }) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $5a1900bd77631f6a$export$2e2bcd8739ae039), {
                                    className: "mt-0.5 size-4 shrink-0"
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                    children: committed ? (0, $d916753b57975e04$export$25ce5a424b770e84).imports.done : (0, $d916753b57975e04$export$25ce5a424b770e84).imports.previewOnly
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                            className: "flex flex-wrap items-center gap-3 text-sm",
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                    className: "text-text-muted",
                                    children: [
                                        (0, $d916753b57975e04$export$25ce5a424b770e84).imports.file,
                                        ": ",
                                        /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                            className: "text-text",
                                            children: file?.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                    className: "text-text-muted",
                                    children: [
                                        (0, $d916753b57975e04$export$25ce5a424b770e84).imports.sheet,
                                        ": ",
                                        /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                            className: "text-text",
                                            children: plan.sheet
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                            className: "grid grid-cols-4 gap-3",
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)($7055ef928be9ba0d$var$Stat, {
                                    label: (0, $d916753b57975e04$export$25ce5a424b770e84).imports.created,
                                    value: plan.created,
                                    tone: "text-success"
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)($7055ef928be9ba0d$var$Stat, {
                                    label: (0, $d916753b57975e04$export$25ce5a424b770e84).imports.matched,
                                    value: plan.matched
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)($7055ef928be9ba0d$var$Stat, {
                                    label: (0, $d916753b57975e04$export$25ce5a424b770e84).imports.skipped,
                                    value: plan.skipped,
                                    tone: "text-text-muted"
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)($7055ef928be9ba0d$var$Stat, {
                                    label: (0, $d916753b57975e04$export$25ce5a424b770e84).imports.invalid,
                                    value: plan.invalid,
                                    tone: plan.invalid > 0 ? 'text-danger' : undefined
                                })
                            ]
                        }),
                        !committed && /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                            className: "flex flex-wrap items-center gap-x-4 gap-y-1 text-sm",
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                    className: selected.size === 0 ? 'text-danger' : 'text-text',
                                    children: selected.size === 0 ? (0, $d916753b57975e04$export$25ce5a424b770e84).imports.nothingSelected : (0, $d916753b57975e04$export$25ce5a424b770e84).imports.selectedOf.replace('{n}', (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(selected.size)).replace('{total}', (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(selectableRows.length))
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                    className: "text-xs text-text-muted",
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).imports.selectionNote
                                })
                            ]
                        }),
                        plan.newSources?.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                            className: "text-sm text-text-muted",
                            children: [
                                (0, $d916753b57975e04$export$25ce5a424b770e84).imports.newSources,
                                ": ",
                                /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                    className: "text-text",
                                    children: plan.newSources.join("\u060C ")
                                })
                            ]
                        }),
                        plan.newInteractionType && /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                            className: "text-sm text-text-muted",
                            children: [
                                (0, $d916753b57975e04$export$25ce5a424b770e84).imports.newInteractionType,
                                ":",
                                ' ',
                                /*#__PURE__*/ (0, $2M70Q.jsx)("b", {
                                    className: "text-text",
                                    children: plan.newInteractionType
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                                    className: "mb-2 text-sm font-bold",
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).imports.rowsTitle
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                                    className: "overflow-x-auto",
                                    children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$54ec01a60f47d33d), {
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$c4c2bc57f2e82919), {
                                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                            className: "w-thumb",
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                                                                type: "checkbox",
                                                                className: "accent-primary",
                                                                "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).imports.selectAll,
                                                                disabled: committed || selectableRows.length === 0,
                                                                checked: selectableRows.length > 0 && selected.size === selectableRows.length,
                                                                ref: (el)=>{
                                                                    // Indeterminate is a PROPERTY, not an attribute:
                                                                    // React cannot set it from JSX.
                                                                    if (el) el.indeterminate = selected.size > 0 && selected.size < selectableRows.length;
                                                                },
                                                                onChange: (event)=>setSelected(event.target.checked ? new Set(selectableRows.map((r)=>r.rowNumber)) : new Set())
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                            className: "w-14",
                                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).imports.row
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).imports.cols.name
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).imports.cols.congress
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).imports.cols.date
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).imports.cols.description
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).imports.cols.phone
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                                            className: "w-52",
                                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).imports.outcome
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7005b8a93a167348), {
                                                children: plan.rows.map((row)=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                                                                    type: "checkbox",
                                                                    className: "accent-primary",
                                                                    "aria-label": `${(0, $d916753b57975e04$export$25ce5a424b770e84).imports.selectRow} ${row.rowNumber}`,
                                                                    disabled: committed || !$7055ef928be9ba0d$var$isSelectable(row),
                                                                    title: $7055ef928be9ba0d$var$isSelectable(row) ? undefined : (0, $d916753b57975e04$export$25ce5a424b770e84).imports.notSelectable,
                                                                    checked: selected.has(row.rowNumber),
                                                                    onChange: ()=>toggleRow(row.rowNumber)
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                                className: "text-text-muted",
                                                                children: (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(row.rowNumber)
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)($7055ef928be9ba0d$var$NameCell, {
                                                                    row: row
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                                children: row.source?.congress
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)($7055ef928be9ba0d$var$DateCell, {
                                                                    row: row
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                                className: "max-w-md truncate",
                                                                title: row.source?.description,
                                                                children: row.source?.description
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                                className: "text-text-muted",
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)($7055ef928be9ba0d$var$PhoneCell, {
                                                                    row: row
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                                className: $7055ef928be9ba0d$var$OUTCOME_STYLE[row.outcome],
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                                                    className: "flex flex-col gap-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).imports.outcomes[row.outcome] ?? row.outcome
                                                                        }),
                                                                        row.detail && /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                                            className: "text-xs text-text-muted",
                                                                            children: row.detail
                                                                        }),
                                                                        row.warnings?.map((w)=>/*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                                                                className: "flex items-center gap-1 text-xs text-warning",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6tkl0.default), {
                                                                                        className: "size-3 shrink-0"
                                                                                    }),
                                                                                    w
                                                                                ]
                                                                            }, w))
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }, row.rowNumber))
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


/**
 * `/settings/activity-types` — the scheduling service's vocabulary.
 *
 * It had no screen until now, which is what made an unseeded deployment's
 * calendar unusable: «نوع فعالیت» is required, the list was empty, and nothing
 * in the app could add to it.
 */ 
var $2M70Q = parcelRequire("2M70Q");


var $3OyDL = parcelRequire("3OyDL");
/**
 * The settings screen for a vocabulary that is NOT the CRM's.
 *
 * `/settings/lookups` administers the five CRM lookup kinds through one screen
 * because they are one service's contract. The scheduling service's
 * `ACTIVITY_TYPE` and the feedback service's `ISSUE_TYPE` are the same contract
 * MIRRORED — separate deployables, separate databases, separate mutations
 * (CLAUDE.md §5a) — so they cannot be folded into that screen's `kind` picker,
 * and until now they had no screen at all. That is why a fresh deployment's
 * calendar offered an empty «نوع فعالیت» with nowhere to go.
 *
 * This is the shared frame. It knows the RULES that are common to every
 * vocabulary in MeshHub — deactivate, never delete; `code` immutable after
 * creation; `is_system` rows relabellable but not deactivatable — and nothing
 * about which vocabulary it is showing.
 */ 
var $2M70Q = parcelRequire("2M70Q");


var $2vK0R = parcelRequire("2vK0R");
var $6PxCH = parcelRequire("6PxCH");

var $3OyDL = parcelRequire("3OyDL");




function $9a8137e42aeb39a5$export$879fb0b25b7e9c05({ title: title, hint: hint, emptyHint: emptyHint, createTitle: createTitle, codePrefix: codePrefix, rows: rows = [], loading: loading = false, busy: busy = false, error: error, includeInactive: includeInactive, onIncludeInactiveChange: onIncludeInactiveChange, onCreate: onCreate, onUpdate: onUpdate, onSetActive: onSetActive }) {
    const [editing, setEditing] = (0, $3OyDL.useState)(null); // row | 'new' | null
    const [confirming, setConfirming] = (0, $3OyDL.useState)(null);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $287828886661deba$export$8f6dcfe950367406), {
        title: title,
        hint: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.noDelete,
        toolbar: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $287828886661deba$export$13da608e8f9e10fe), {
                    checked: includeInactive,
                    onChange: onIncludeInactiveChange
                }),
                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                    variant: "primary",
                    onClick: ()=>setEditing('new'),
                    className: "gap-2",
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                            size: 15,
                            "aria-hidden": "true"
                        }),
                        (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.newItem
                    ]
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "mb-4 text-sm text-text-muted",
                children: hint
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: error
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$4b2346c6725d60cc), {
                loading: loading && rows.length === 0,
                empty: !loading && rows.length === 0,
                emptyHint: emptyHint
            }),
            rows.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-sm text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.count((0, $d4d460d3ffb6daab$export$104ee80c24270f18)(rows.length))
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$54ec01a60f47d33d), {
                        className: "mt-4",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$c4c2bc57f2e82919), {
                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                    children: [
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.code
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.labelFa
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.labelEn
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.status
                                        }),
                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.actions
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7005b8a93a167348), {
                                children: rows.map((row)=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                        className: row.isActive ? '' : 'opacity-60',
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                dir: "ltr",
                                                className: "text-start font-medium",
                                                children: row.code
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                children: row.labelFa
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                dir: "ltr",
                                                className: "text-start text-text-muted",
                                                children: row.labelEn || (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $287828886661deba$export$cb8f259c2accb9d1), {
                                                            isActive: row.isActive
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $287828886661deba$export$1b6bbf917c8fdc0c), {
                                                            isSystem: row.isSystem
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                                    className: "flex items-center gap-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                                            variant: "ghost",
                                                            "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).app.edit,
                                                            title: (0, $d916753b57975e04$export$25ce5a424b770e84).app.edit,
                                                            onClick: ()=>setEditing(row),
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2vK0R.default), {
                                                                size: 14,
                                                                "aria-hidden": "true"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                                            variant: "ghost",
                                                            disabled: row.isSystem && row.isActive,
                                                            title: row.isSystem && row.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.systemLocked : '',
                                                            onClick: ()=>setConfirming(row),
                                                            children: row.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.deactivate : (0, $d916753b57975e04$export$25ce5a424b770e84).app.activate
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }, row.id))
                            })
                        ]
                    })
                ]
            }),
            editing && /*#__PURE__*/ (0, $2M70Q.jsx)($9a8137e42aeb39a5$var$VocabularyDialog, {
                row: editing === 'new' ? null : editing,
                title: createTitle,
                codePrefix: codePrefix,
                busy: busy,
                onClose: ()=>setEditing(null),
                onSubmit: async (values)=>{
                    if (editing === 'new') await onCreate(values);
                    else await onUpdate(editing, values);
                    setEditing(null);
                }
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2cc85109a937009e), {
                open: Boolean(confirming),
                onOpenChange: (open)=>!open && setConfirming(null),
                title: confirming?.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.deactivate : (0, $d916753b57975e04$export$25ce5a424b770e84).app.activate,
                message: confirming?.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.confirmDeactivate(confirming?.labelFa ?? '') : (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.confirmActivate(confirming?.labelFa ?? ''),
                danger: confirming?.isActive,
                confirmLabel: confirming?.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.deactivate : (0, $d916753b57975e04$export$25ce5a424b770e84).app.activate,
                onConfirm: ()=>onSetActive(confirming, !confirming.isActive)
            })
        ]
    });
}
/**
 * The LABEL comes first and the code follows it, which is the opposite of the
 * CRM's lookup dialog — and deliberate. `code` is machinery: immutable, never
 * shown to anyone outside this screen, and derivable from the label by the same
 * function the inline creator uses. An administrator who cares can still type
 * one; one who does not should not be blocked on inventing an identifier.
 */ function $9a8137e42aeb39a5$var$VocabularyDialog({ row: row, title: title, codePrefix: codePrefix, busy: busy, onClose: onClose, onSubmit: onSubmit }) {
    const isNew = !row;
    const [labelFa, setLabelFa] = (0, $3OyDL.useState)(row?.labelFa ?? '');
    const [labelEn, setLabelEn] = (0, $3OyDL.useState)(row?.labelEn ?? '');
    const [sortOrder, setSortOrder] = (0, $3OyDL.useState)(row?.sortOrder ?? 0);
    const [code, setCode] = (0, $3OyDL.useState)(row?.code ?? '');
    const [codeTouched, setCodeTouched] = (0, $3OyDL.useState)(false);
    const effectiveCode = isNew && !codeTouched ? (0, $07ca0f97a2bd5399$export$ee36c3544963506c)(labelFa, codePrefix) : code;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: true,
        onOpenChange: (open)=>!open && onClose(),
        title: isNew ? title : `${(0, $d916753b57975e04$export$25ce5a424b770e84).app.edit} \u{2014} ${row.labelFa}`,
        busy: busy,
        onSubmit: ()=>onSubmit(isNew ? {
                code: effectiveCode,
                labelFa: labelFa,
                labelEn: labelEn,
                sortOrder: Number(sortOrder)
            } : {
                labelFa: labelFa,
                labelEn: labelEn,
                sortOrder: Number(sortOrder)
            }),
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.labelFa,
                value: labelFa,
                required: true,
                autoFocus: true,
                onChange: (event)=>setLabelFa(event.target.value)
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.code,
                value: effectiveCode,
                dir: "ltr",
                required: isNew,
                disabled: !isNew,
                hint: isNew ? (0, $d916753b57975e04$export$25ce5a424b770e84).settings.lookups.codeHint : (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.codeImmutable,
                onChange: (event)=>{
                    setCodeTouched(true);
                    setCode(event.target.value.toUpperCase());
                }
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.labelEn,
                value: labelEn,
                dir: "ltr",
                onChange: (event)=>setLabelEn(event.target.value)
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.sortOrder,
                type: "number",
                value: sortOrder,
                onChange: (event)=>setSortOrder(event.target.value)
            }),
            row?.isSystem && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-xs text-text-muted",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.systemLocked
            })
        ]
    });
}




function $6e121a5c90ad241d$export$7a50dc096a992b78() {
    const [includeInactive, setIncludeInactive] = (0, $3OyDL.useState)(true);
    const variables = {
        includeInactive: includeInactive
    };
    const { data: data, loading: loading } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$76905cee0d96ad5e), {
        variables: variables
    });
    const refetchQueries = [
        {
            query: (0, $13be303c7211393a$export$76905cee0d96ad5e),
            variables: variables
        }
    ];
    const [create, createState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$39328c7d9faf3888), {
        refetchQueries: refetchQueries
    });
    const [update, updateState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$b8cf506a23320988), {
        refetchQueries: refetchQueries
    });
    const [setActive, activeState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$69b3d794de253f20), {
        refetchQueries: refetchQueries
    });
    const rows = (0, $3OyDL.useMemo)(()=>[
            ...data?.activityTypes ?? []
        ].sort((a, b)=>a.sortOrder - b.sortOrder), [
        data
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9a8137e42aeb39a5$export$879fb0b25b7e9c05), {
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.sections.activityTypes,
        hint: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.activityTypes.hint,
        emptyHint: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.activityTypes.empty,
        createTitle: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.activityTypes.createTitle,
        codePrefix: "ACTIVITY",
        rows: rows,
        loading: loading,
        busy: createState.loading || updateState.loading,
        error: createState.error || updateState.error || activeState.error,
        includeInactive: includeInactive,
        onIncludeInactiveChange: setIncludeInactive,
        onCreate: (input)=>create({
                variables: {
                    input: input
                }
            }),
        onUpdate: (row, input)=>update({
                variables: {
                    id: row.id,
                    input: input
                }
            }),
        onSetActive: (row, isActive)=>setActive({
                variables: {
                    id: row.id,
                    isActive: isActive
                }
            })
    });
}


/**
 * `/settings/issue-types` — the feedback service's vocabulary.
 *
 * The same gap as the activity types': `typeId` is required to open an issue,
 * the mutations existed at the BFF and the service, and no screen reached them.
 *
 * Its mutations take loose arguments rather than an input object, because the
 * feedback service mirrored the CRM's contract without mirroring its GraphQL
 * shape. The frame does not care; the mapping is here, once.
 */ 
var $2M70Q = parcelRequire("2M70Q");


var $3OyDL = parcelRequire("3OyDL");



function $08e23e29b3ee4844$export$bfb4b09b3d89b06a() {
    const [includeInactive, setIncludeInactive] = (0, $3OyDL.useState)(true);
    const variables = {
        includeInactive: includeInactive
    };
    const { data: data, loading: loading } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $047171b3f4119885$export$f08810cd3a46d5f8), {
        variables: variables
    });
    const refetchQueries = [
        {
            query: (0, $047171b3f4119885$export$f08810cd3a46d5f8),
            variables: variables
        }
    ];
    const [create, createState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$ee884be3a3453f7a), {
        refetchQueries: refetchQueries
    });
    const [update, updateState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$24d168255ea252f0), {
        refetchQueries: refetchQueries
    });
    const [setActive, activeState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $047171b3f4119885$export$ac53f097aef4b96c), {
        refetchQueries: refetchQueries
    });
    const rows = (0, $3OyDL.useMemo)(()=>data?.issueTypes ?? [], [
        data
    ]);
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9a8137e42aeb39a5$export$879fb0b25b7e9c05), {
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.sections.issueTypes,
        hint: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.issueTypes.hint,
        emptyHint: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.issueTypes.empty,
        createTitle: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.issueTypes.createTitle,
        codePrefix: "ISSUE",
        rows: rows,
        loading: loading,
        busy: createState.loading || updateState.loading,
        error: createState.error || updateState.error || activeState.error,
        includeInactive: includeInactive,
        onIncludeInactiveChange: setIncludeInactive,
        onCreate: ({ code: code, labelFa: labelFa, labelEn: labelEn, sortOrder: sortOrder })=>create({
                variables: {
                    code: code,
                    labelFa: labelFa,
                    labelEn: labelEn,
                    sortOrder: sortOrder
                }
            }),
        onUpdate: (row, { labelFa: labelFa, labelEn: labelEn, sortOrder: sortOrder })=>update({
                variables: {
                    id: row.id,
                    labelFa: labelFa,
                    labelEn: labelEn,
                    sortOrder: sortOrder
                }
            }),
        onSetActive: (row, isActive)=>setActive({
                variables: {
                    id: row.id,
                    isActive: isActive
                }
            })
    });
}



var $2M70Q = parcelRequire("2M70Q");



var $9ZCAD = parcelRequire("9ZCAD");
var $gcf4m = parcelRequire("gcf4m");
var $2vK0R = parcelRequire("2vK0R");
var $6PxCH = parcelRequire("6PxCH");

var $3OyDL = parcelRequire("3OyDL");




/** Specialties get their own hierarchy-aware screen. */ const $8199f2b2c04f9242$var$KINDS = [
    'FIELD_OF_WORK',
    'COMMUNICATION_CHANNEL',
    'PRODUCT',
    'INTERACTION_TYPE',
    'TEMPLATE_CATEGORY',
    // Where a contact came from. The CRM has accepted this kind since migration
    // 0015 and the search workbench facets on it, but it was missing from this
    // list — so the only way a new congress entered the vocabulary was the
    // spreadsheet importer inventing one, and nobody could relabel it.
    'ACQUISITION_SOURCE',
    // The CRM profile vocabularies (migration 0016). Listed here for exactly the
    // reason ACQUISITION_SOURCE eventually was: a vocabulary the admin surface
    // cannot reach is a feature that does not exist, and the tests cannot see it
    // (CLAUDE.md §15).
    'LIFECYCLE_STAGE',
    'SALES_STAGE',
    'CUSTOMER_HEALTH',
    'ENGAGEMENT_STATUS',
    'CITY',
    'FACILITY_TYPE'
];
/**
 * Kinds whose rows can require the free-text detail beside them.
 *
 * A per-kind list rather than a checkbox on every vocabulary, because the flag
 * only means something where a paired text field exists — offering it on
 * «محصول» would be a control with nothing behind it. The RULE it drives is
 * still generic: the domain reads `requiresDetail` off the row and knows
 * nothing about clinics.
 */ const $8199f2b2c04f9242$var$DETAIL_KINDS = new Set([
    'FACILITY_TYPE'
]);
function $8199f2b2c04f9242$export$6f73c9645709c239() {
    const [kind, setKind] = (0, $3OyDL.useState)($8199f2b2c04f9242$var$KINDS[0]);
    const [includeInactive, setIncludeInactive] = (0, $3OyDL.useState)(true);
    const [editing, setEditing] = (0, $3OyDL.useState)(null); // lookup | 'new' | null
    const [confirming, setConfirming] = (0, $3OyDL.useState)(null);
    const variables = {
        kind: kind,
        includeInactive: includeInactive
    };
    const { data: data, loading: loading } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$d2d584f4325fcf08), {
        variables: variables
    });
    const refetch = [
        {
            query: (0, $13be303c7211393a$export$d2d584f4325fcf08),
            variables: variables
        }
    ];
    const [createLookup, createState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$bceff013a27ec1ea), {
        refetchQueries: refetch
    });
    const [updateLookup, updateState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$48b05fe6fa904f4b), {
        refetchQueries: refetch
    });
    const [setActive, activeState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$c6cb79e861c7fb42), {
        refetchQueries: refetch
    });
    const [reorder, reorderState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$f444d57829178b1f), {
        refetchQueries: refetch
    });
    const rows = (0, $3OyDL.useMemo)(()=>[
            ...data?.lookups ?? []
        ].sort((a, b)=>a.sortOrder - b.sortOrder), [
        data
    ]);
    const mutationError = createState.error || updateState.error || activeState.error || reorderState.error;
    /** Buttons rather than drag-and-drop: keyboard-reachable and unambiguous. */ function move(index, delta) {
        const next = [
            ...rows
        ];
        const target = index + delta;
        if (target < 0 || target >= next.length) return;
        [next[index], next[target]] = [
            next[target],
            next[index]
        ];
        reorder({
            variables: {
                kind: kind,
                orderedIds: next.map((r)=>r.id)
            }
        });
    }
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $287828886661deba$export$8f6dcfe950367406), {
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.sections.lookups,
        hint: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.noDelete,
        toolbar: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $287828886661deba$export$13da608e8f9e10fe), {
                    checked: includeInactive,
                    onChange: setIncludeInactive
                }),
                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                    variant: "primary",
                    onClick: ()=>setEditing('new'),
                    className: "gap-2",
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                            size: 15,
                            "aria-hidden": "true"
                        }),
                        (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.newItem
                    ]
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "mb-5 flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.lookups.kindLabel,
                        value: kind,
                        onChange: (event)=>setKind(event.target.value),
                        children: $8199f2b2c04f9242$var$KINDS.map((k)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                value: k,
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.lookups.kinds[k]
                            }, k))
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "mt-5 text-sm text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.count((0, $d4d460d3ffb6daab$export$104ee80c24270f18)(rows.length))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: mutationError
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$4b2346c6725d60cc), {
                loading: loading && rows.length === 0,
                empty: !loading && rows.length === 0
            }),
            rows.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$54ec01a60f47d33d), {
                className: "mt-4",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$c4c2bc57f2e82919), {
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.code
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.labelFa
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.labelEn
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.sortOrder
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.status
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.actions
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7005b8a93a167348), {
                        children: rows.map((row, index)=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                className: row.isActive ? '' : 'opacity-60',
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        dir: "ltr",
                                        className: "text-start font-medium",
                                        children: row.code
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        children: row.labelFa
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        dir: "ltr",
                                        className: "text-start text-text-muted",
                                        children: row.labelEn || (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        className: "text-text-muted",
                                        children: (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(row.sortOrder)
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $287828886661deba$export$cb8f259c2accb9d1), {
                                                    isActive: row.isActive
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $287828886661deba$export$1b6bbf917c8fdc0c), {
                                                    isSystem: row.isSystem
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                            className: "flex items-center gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                                    variant: "ghost",
                                                    "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).app.edit,
                                                    title: (0, $d916753b57975e04$export$25ce5a424b770e84).app.edit,
                                                    onClick: ()=>setEditing(row),
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2vK0R.default), {
                                                        size: 14,
                                                        "aria-hidden": "true"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                                    variant: "ghost",
                                                    "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.moveUp,
                                                    title: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.moveUp,
                                                    disabled: index === 0,
                                                    onClick: ()=>move(index, -1),
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $gcf4m.default), {
                                                        size: 14,
                                                        "aria-hidden": "true"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                                    variant: "ghost",
                                                    "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.moveDown,
                                                    title: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.moveDown,
                                                    disabled: index === rows.length - 1,
                                                    onClick: ()=>move(index, 1),
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9ZCAD.default), {
                                                        size: 14,
                                                        "aria-hidden": "true"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                                    variant: "ghost",
                                                    disabled: row.isSystem && row.isActive,
                                                    title: row.isSystem && row.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.systemLocked : '',
                                                    onClick: ()=>setConfirming(row),
                                                    children: row.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.deactivate : (0, $d916753b57975e04$export$25ce5a424b770e84).app.activate
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }, row.id))
                    })
                ]
            }),
            editing && /*#__PURE__*/ (0, $2M70Q.jsx)($8199f2b2c04f9242$var$LookupDialog, {
                kind: kind,
                showRequiresDetail: $8199f2b2c04f9242$var$DETAIL_KINDS.has(kind),
                lookup: editing === 'new' ? null : editing,
                busy: createState.loading || updateState.loading,
                onClose: ()=>setEditing(null),
                onSubmit: async (values)=>{
                    if (editing === 'new') await createLookup({
                        variables: {
                            input: {
                                kind: kind,
                                ...values
                            }
                        }
                    });
                    else await updateLookup({
                        variables: {
                            input: {
                                id: editing.id,
                                ...values
                            }
                        }
                    });
                    setEditing(null);
                }
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2cc85109a937009e), {
                open: Boolean(confirming),
                onOpenChange: (open)=>!open && setConfirming(null),
                title: confirming?.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.deactivate : (0, $d916753b57975e04$export$25ce5a424b770e84).app.activate,
                message: confirming?.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.confirmDeactivate(confirming?.labelFa ?? '') : (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.confirmActivate(confirming?.labelFa ?? ''),
                danger: confirming?.isActive,
                confirmLabel: confirming?.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.deactivate : (0, $d916753b57975e04$export$25ce5a424b770e84).app.activate,
                onConfirm: ()=>setActive({
                        variables: {
                            id: confirming.id,
                            isActive: !confirming.isActive
                        }
                    })
            })
        ]
    });
}
function $8199f2b2c04f9242$var$LookupDialog({ kind: kind, lookup: lookup, onClose: onClose, onSubmit: onSubmit, busy: busy, showRequiresDetail: showRequiresDetail }) {
    const isNew = !lookup;
    const [code, setCode] = (0, $3OyDL.useState)(lookup?.code ?? '');
    const [labelFa, setLabelFa] = (0, $3OyDL.useState)(lookup?.labelFa ?? '');
    const [labelEn, setLabelEn] = (0, $3OyDL.useState)(lookup?.labelEn ?? '');
    const [sortOrder, setSortOrder] = (0, $3OyDL.useState)(lookup?.sortOrder ?? 0);
    const [requiresDetail, setRequiresDetail] = (0, $3OyDL.useState)(Boolean(lookup?.requiresDetail));
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: true,
        onOpenChange: (open)=>!open && onClose(),
        title: isNew ? (0, $d916753b57975e04$export$25ce5a424b770e84).settings.lookups.createTitle : `${(0, $d916753b57975e04$export$25ce5a424b770e84).app.edit} \u{2014} ${lookup.labelFa}`,
        busy: busy,
        onSubmit: ()=>onSubmit({
                ...isNew ? {
                    code: code.trim()
                } : {},
                labelFa: labelFa,
                labelEn: labelEn,
                sortOrder: Number(sortOrder),
                // Sent ONLY for a kind that pairs with a detail field. Absent leaves
                // the stored flag alone, which is what stops a relabel of any other
                // vocabulary from silently clearing it.
                ...showRequiresDetail ? {
                    requiresDetail: requiresDetail
                } : {}
            }),
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.code,
                value: code,
                dir: "ltr",
                required: isNew,
                disabled: !isNew,
                hint: isNew ? (0, $d916753b57975e04$export$25ce5a424b770e84).settings.lookups.codeHint : (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.codeImmutable,
                onChange: (event)=>setCode(event.target.value.toUpperCase())
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.labelFa,
                value: labelFa,
                required: true,
                onChange: (event)=>setLabelFa(event.target.value)
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.labelEn,
                value: labelEn,
                dir: "ltr",
                onChange: (event)=>setLabelEn(event.target.value)
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.sortOrder,
                type: "number",
                value: sortOrder,
                onChange: (event)=>setSortOrder(event.target.value)
            }),
            showRequiresDetail && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$94195a47b94ed396), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.lookups.requiresDetail,
                checked: requiresDetail,
                onChange: (event)=>setRequiresDetail(event.target.checked)
            }),
            showRequiresDetail && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-xs text-text-muted",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.lookups.requiresDetailHint
            }),
            lookup?.isSystem && /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-xs text-text-muted",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.systemLocked
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-xs text-text-muted",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.lookups.kinds[kind]
            })
        ]
    });
}



var $2M70Q = parcelRequire("2M70Q");

parcelRequire("3OyDL");

var $8B9Zg = parcelRequire("8B9Zg");
var $ZNHD9 = parcelRequire("ZNHD9");

var $2M70Q = parcelRequire("2M70Q");


var $brQlu = parcelRequire("brQlu");
parcelRequire("3OyDL");

var $8B9Zg = parcelRequire("8B9Zg");

function $23fa8f02dfee6b5f$export$19e402bf0a6cad34() {
    const navigate = (0, $8B9Zg.useNavigate)();
    return /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
        className: "flex h-screen items-center justify-center p-6",
        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
            className: "flex max-w-lg flex-col items-center gap-4 text-center",
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $brQlu.default), {
                    size: 32,
                    className: "text-warning",
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("h1", {
                    className: "text-lg font-bold",
                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).auth.forbiddenTitle
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                    className: "text-base text-text-muted",
                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).auth.forbiddenHint
                }),
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                    variant: "primary",
                    onClick: ()=>navigate('/'),
                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).auth.backToContacts
                })
            ]
        })
    });
}




/**
 * `adminOnly: false` means every authenticated user may open it.
 *
 * There is exactly one such section, and the exception is real rather than a
 * convenience: a Google connection is ONE PERSON'S OWN calendar. An admin
 * cannot connect one on somebody's behalf — that would mean holding their
 * credentials — so the page cannot be admin-gated without making the feature
 * unusable for the people it is for. The scheduling service enforces the same
 * thing from the other side by refusing any user id but the caller's.
 */ const $874a61e03b1c18c9$var$SECTIONS = [
    {
        to: 'lookups',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.sections.lookups,
        adminOnly: true
    },
    {
        to: 'specialties',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.sections.specialties,
        adminOnly: true
    },
    {
        to: 'tags',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.sections.tags,
        adminOnly: true
    },
    {
        to: 'custom-fields',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.sections.customFields,
        adminOnly: true
    },
    {
        to: 'templates',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.sections.templates,
        adminOnly: true
    },
    {
        to: 'activity-types',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.sections.activityTypes,
        adminOnly: true
    },
    {
        to: 'checklists',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).checklists.templates,
        adminOnly: true
    },
    {
        to: 'issue-types',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.sections.issueTypes,
        adminOnly: true
    },
    {
        to: 'integrations',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).integrations.title,
        adminOnly: false
    },
    {
        to: 'automation',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).automation.title,
        adminOnly: true
    },
    {
        to: 'whatsapp',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).whatsapp.title,
        adminOnly: true
    },
    {
        to: 'import',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.sections.import,
        adminOnly: true
    },
    {
        to: 'users',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.sections.users,
        adminOnly: true
    },
    // The ops panel. ADMIN, because it is a map of the deployment: which
    // service is down, how far behind the read models are, and who did what.
    {
        to: 'system',
        label: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.title,
        adminOnly: true
    }
];
const $874a61e03b1c18c9$var$SELF_SERVICE = $874a61e03b1c18c9$var$SECTIONS.filter((section)=>!section.adminOnly).map((s)=>s.to);
function $874a61e03b1c18c9$export$91d8b01f755b4863() {
    const { isAdmin: isAdmin, loading: loading } = (0, $00d5d84dffcdf8d5$export$ad0a340bf97d63d5)();
    const location = (0, $8B9Zg.useLocation)();
    if (loading) return /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
        className: "flex h-screen items-center justify-center",
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {})
    });
    // A USER may reach the self-service sections and nothing else. Matched on the
    // path segment rather than a prefix, so `/settings/integrations-secret` is
    // not accidentally allowed by a `startsWith`.
    const section = location.pathname.split('/').filter(Boolean)[1];
    if (!isAdmin && !$874a61e03b1c18c9$var$SELF_SERVICE.includes(section)) return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $23fa8f02dfee6b5f$export$19e402bf0a6cad34), {});
    const visible = $874a61e03b1c18c9$var$SECTIONS.filter((entry)=>isAdmin || !entry.adminOnly);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex h-screen",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("nav", {
                className: "flex w-sidebar shrink-0 flex-col gap-1 border-e border-border bg-surface p-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "px-4 py-2 text-sm text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.subtitle
                    }),
                    visible.map((entry)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $8B9Zg.NavLink), {
                            to: entry.to,
                            className: ({ isActive: isActive })=>[
                                    'flex h-control items-center rounded px-4 text-base transition-colors',
                                    isActive ? 'bg-primary text-primary-contrast' : 'text-text hover:bg-surface-hover'
                                ].join(' '),
                            children: entry.label
                        }, entry.to))
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: "min-w-0 flex-1 overflow-y-auto",
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ZNHD9.Outlet), {})
            })
        ]
    });
}



var $2M70Q = parcelRequire("2M70Q");


/**
 * @license lucide-react v1.37.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $djixo = parcelRequire("djixo");
const $ec0edae7f8a0214a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 4v7a4 4 0 0 1-4 4H4",
            key: "6o5b7l"
        }
    ],
    [
        "path",
        {
            d: "m9 10-5 5 5 5",
            key: "1kshq7"
        }
    ]
];
const $ec0edae7f8a0214a$export$2e2bcd8739ae039 = (0, $djixo.default)("corner-down-left", $ec0edae7f8a0214a$export$3efd853dbb351e94);


var $2vK0R = parcelRequire("2vK0R");
var $6PxCH = parcelRequire("6PxCH");

var $3OyDL = parcelRequire("3OyDL");



const $e17294cecbc6ad37$var$KIND = 'SPECIALTY';
/** Build parent → children, preserving sort order. */ function $e17294cecbc6ad37$var$buildTree(rows) {
    const byParent = new Map();
    for (const row of rows){
        const key = row.parentId ?? '__root__';
        if (!byParent.has(key)) byParent.set(key, []);
        byParent.get(key).push(row);
    }
    for (const list of byParent.values())list.sort((a, b)=>a.sortOrder - b.sortOrder);
    return byParent;
}
/** Descendants of `id`, so the "move to" picker cannot offer a cycle. */ function $e17294cecbc6ad37$var$descendantIds(byParent, id, acc = new Set()) {
    for (const child of byParent.get(id) ?? []){
        acc.add(child.id);
        $e17294cecbc6ad37$var$descendantIds(byParent, child.id, acc);
    }
    return acc;
}
function $e17294cecbc6ad37$export$85eaffe425ede927() {
    const [includeInactive, setIncludeInactive] = (0, $3OyDL.useState)(true);
    const [editing, setEditing] = (0, $3OyDL.useState)(null); // {mode:'new'|'edit'|'child', node}
    const [confirming, setConfirming] = (0, $3OyDL.useState)(null);
    const variables = {
        kind: $e17294cecbc6ad37$var$KIND,
        includeInactive: includeInactive
    };
    const { data: data, loading: loading } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$d2d584f4325fcf08), {
        variables: variables
    });
    const refetch = [
        {
            query: (0, $13be303c7211393a$export$d2d584f4325fcf08),
            variables: variables
        }
    ];
    const [createLookup, createState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$bceff013a27ec1ea), {
        refetchQueries: refetch
    });
    const [updateLookup, updateState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$48b05fe6fa904f4b), {
        refetchQueries: refetch
    });
    const [setActive, activeState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$c6cb79e861c7fb42), {
        refetchQueries: refetch
    });
    const rows = data?.lookups ?? [];
    const byParent = (0, $3OyDL.useMemo)(()=>$e17294cecbc6ad37$var$buildTree(rows), [
        rows
    ]);
    const roots = byParent.get('__root__') ?? [];
    const mutationError = createState.error || updateState.error || activeState.error;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $287828886661deba$export$8f6dcfe950367406), {
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.specialties.title,
        hint: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.noDelete,
        toolbar: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $287828886661deba$export$13da608e8f9e10fe), {
                    checked: includeInactive,
                    onChange: setIncludeInactive
                }),
                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                    variant: "primary",
                    onClick: ()=>setEditing({
                            mode: 'new',
                            node: null
                        }),
                    className: "gap-2",
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                            size: 15,
                            "aria-hidden": "true"
                        }),
                        (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.newItem
                    ]
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: mutationError
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$4b2346c6725d60cc), {
                loading: loading && rows.length === 0,
                empty: !loading && rows.length === 0
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
                className: "flex flex-col gap-1",
                children: roots.map((node)=>/*#__PURE__*/ (0, $2M70Q.jsx)($e17294cecbc6ad37$var$TreeNode, {
                        node: node,
                        byParent: byParent,
                        depth: 0,
                        onEdit: (n)=>setEditing({
                                mode: 'edit',
                                node: n
                            }),
                        onAddChild: (n)=>setEditing({
                                mode: 'child',
                                node: n
                            }),
                        onToggle: setConfirming
                    }, node.id))
            }),
            editing && /*#__PURE__*/ (0, $2M70Q.jsx)($e17294cecbc6ad37$var$SpecialtyDialog, {
                mode: editing.mode,
                node: editing.node,
                rows: rows,
                byParent: byParent,
                busy: createState.loading || updateState.loading,
                onClose: ()=>setEditing(null),
                onSubmit: async (values)=>{
                    if (editing.mode === 'edit') await updateLookup({
                        variables: {
                            input: {
                                id: editing.node.id,
                                ...values
                            }
                        }
                    });
                    else await createLookup({
                        variables: {
                            input: {
                                kind: $e17294cecbc6ad37$var$KIND,
                                ...values
                            }
                        }
                    });
                    setEditing(null);
                }
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2cc85109a937009e), {
                open: Boolean(confirming),
                onOpenChange: (open)=>!open && setConfirming(null),
                title: confirming?.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.deactivate : (0, $d916753b57975e04$export$25ce5a424b770e84).app.activate,
                message: confirming?.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.confirmDeactivate(confirming?.labelFa ?? '') : (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.confirmActivate(confirming?.labelFa ?? ''),
                danger: confirming?.isActive,
                confirmLabel: confirming?.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.deactivate : (0, $d916753b57975e04$export$25ce5a424b770e84).app.activate,
                onConfirm: ()=>setActive({
                        variables: {
                            id: confirming.id,
                            isActive: !confirming.isActive
                        }
                    })
            })
        ]
    });
}
function $e17294cecbc6ad37$var$TreeNode({ node: node, byParent: byParent, depth: depth, onEdit: onEdit, onAddChild: onAddChild, onToggle: onToggle }) {
    const children = byParent.get(node.id) ?? [];
    const hasActiveChildren = children.some((c)=>c.isActive);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: `flex items-center gap-3 rounded border border-border bg-surface px-4 py-2
                    ${node.isActive ? '' : 'opacity-60'}`,
                // Indentation is structural, not decorative: it encodes tree depth.
                // Uses a spacing token multiple, not a raw pixel value.
                style: {
                    marginInlineStart: `calc(var(--mh-space-6) * ${depth})`
                },
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "font-medium",
                        children: node.labelFa
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        dir: "ltr",
                        className: "text-xs text-text-muted",
                        children: node.code
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $287828886661deba$export$cb8f259c2accb9d1), {
                        isActive: node.isActive
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $287828886661deba$export$1b6bbf917c8fdc0c), {
                        isSystem: node.isSystem
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                        className: "ms-auto flex items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                variant: "ghost",
                                title: (0, $d916753b57975e04$export$25ce5a424b770e84).app.edit,
                                "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).app.edit,
                                onClick: ()=>onEdit(node),
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2vK0R.default), {
                                    size: 14,
                                    "aria-hidden": "true"
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                variant: "ghost",
                                title: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.specialties.addChild,
                                "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).settings.specialties.addChild,
                                onClick: ()=>onAddChild(node),
                                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                                    size: 14,
                                    "aria-hidden": "true"
                                })
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                variant: "ghost",
                                disabled: node.isSystem && node.isActive || node.isActive && hasActiveChildren,
                                title: node.isActive && hasActiveChildren ? (0, $d916753b57975e04$export$25ce5a424b770e84).settings.specialties.hasActiveChildren : node.isSystem && node.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.systemLocked : '',
                                onClick: ()=>onToggle(node),
                                children: node.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.deactivate : (0, $d916753b57975e04$export$25ce5a424b770e84).app.activate
                            })
                        ]
                    })
                ]
            }),
            children.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
                className: "mt-1 flex flex-col gap-1",
                children: children.map((child)=>/*#__PURE__*/ (0, $2M70Q.jsx)($e17294cecbc6ad37$var$TreeNode, {
                        node: child,
                        byParent: byParent,
                        depth: depth + 1,
                        onEdit: onEdit,
                        onAddChild: onAddChild,
                        onToggle: onToggle
                    }, child.id))
            })
        ]
    });
}
function $e17294cecbc6ad37$var$SpecialtyDialog({ mode: mode, node: node, rows: rows, byParent: byParent, onClose: onClose, onSubmit: onSubmit, busy: busy }) {
    const isEdit = mode === 'edit';
    const [code, setCode] = (0, $3OyDL.useState)(isEdit ? node.code : '');
    const [labelFa, setLabelFa] = (0, $3OyDL.useState)(isEdit ? node.labelFa : '');
    const [labelEn, setLabelEn] = (0, $3OyDL.useState)(isEdit ? node.labelEn ?? '' : '');
    const [parentId, setParentId] = (0, $3OyDL.useState)(mode === 'child' ? node.id : isEdit ? node.parentId ?? '' : '');
    /**
   * A node may not move under itself or any of its descendants. The server
   * rejects a cycle regardless; excluding them here means the admin never gets
   * to pick an option that is guaranteed to fail.
   */ const forbidden = (0, $3OyDL.useMemo)(()=>{
        if (!isEdit) return new Set();
        const set = $e17294cecbc6ad37$var$descendantIds(byParent, node.id);
        set.add(node.id);
        return set;
    }, [
        isEdit,
        node,
        byParent
    ]);
    const parentOptions = rows.filter((r)=>!forbidden.has(r.id));
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: true,
        onOpenChange: (open)=>!open && onClose(),
        title: isEdit ? `${(0, $d916753b57975e04$export$25ce5a424b770e84).app.edit} \u{2014} ${node.labelFa}` : mode === 'child' ? `${(0, $d916753b57975e04$export$25ce5a424b770e84).settings.specialties.addChild} \u{2014} ${node.labelFa}` : (0, $d916753b57975e04$export$25ce5a424b770e84).settings.lookups.createTitle,
        busy: busy,
        onSubmit: ()=>onSubmit(isEdit ? {
                labelFa: labelFa,
                labelEn: labelEn,
                setParent: true,
                parentId: parentId || null
            } : {
                code: code.trim(),
                labelFa: labelFa,
                labelEn: labelEn,
                parentId: parentId || null
            }),
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.code,
                value: code,
                dir: "ltr",
                required: !isEdit,
                disabled: isEdit,
                hint: isEdit ? (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.codeImmutable : (0, $d916753b57975e04$export$25ce5a424b770e84).settings.lookups.codeHint,
                onChange: (event)=>setCode(event.target.value.toUpperCase())
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.labelFa,
                value: labelFa,
                required: true,
                onChange: (event)=>setLabelFa(event.target.value)
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.labelEn,
                value: labelEn,
                dir: "ltr",
                onChange: (event)=>setLabelEn(event.target.value)
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.specialties.moveTo,
                value: parentId,
                onChange: (event)=>setParentId(event.target.value),
                hint: isEdit ? (0, $d916753b57975e04$export$25ce5a424b770e84).settings.specialties.cycleRejected : undefined,
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: "",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.specialties.rootLevel
                    }),
                    parentOptions.map((option)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                            value: option.id,
                            children: option.labelFa
                        }, option.id))
                ]
            }),
            isEdit && /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                className: "flex items-center gap-1 text-xs text-text-muted",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ec0edae7f8a0214a$export$2e2bcd8739ae039), {
                        size: 12,
                        "aria-hidden": "true"
                    }),
                    (0, $d916753b57975e04$export$25ce5a424b770e84).settings.specialties.makeRoot
                ]
            })
        ]
    });
}



var $2M70Q = parcelRequire("2M70Q");




var $2vK0R = parcelRequire("2vK0R");
var $6PxCH = parcelRequire("6PxCH");

var $3OyDL = parcelRequire("3OyDL");



function $ef64e51b4859829b$export$a74aa39d833b143a() {
    const [includeInactive, setIncludeInactive] = (0, $3OyDL.useState)(true);
    const [editing, setEditing] = (0, $3OyDL.useState)(null);
    const [confirming, setConfirming] = (0, $3OyDL.useState)(null);
    const variables = {
        includeInactive: includeInactive
    };
    const { data: data, loading: loading } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$c064f18f2e294629), {
        variables: variables
    });
    const refetch = [
        {
            query: (0, $13be303c7211393a$export$c064f18f2e294629),
            variables: variables
        }
    ];
    const [createTag, createState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$14db7933f8d84816), {
        refetchQueries: refetch
    });
    const [updateTag, updateState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$8090d300a1218c8), {
        refetchQueries: refetch
    });
    const [setActive, activeState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$c189a2effcb3cc82), {
        refetchQueries: refetch
    });
    const rows = data?.tags ?? [];
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $287828886661deba$export$8f6dcfe950367406), {
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.sections.tags,
        hint: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.noDelete,
        toolbar: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $287828886661deba$export$13da608e8f9e10fe), {
                    checked: includeInactive,
                    onChange: setIncludeInactive
                }),
                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                    variant: "primary",
                    onClick: ()=>setEditing('new'),
                    className: "gap-2",
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                            size: 15,
                            "aria-hidden": "true"
                        }),
                        (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.newItem
                    ]
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: createState.error || updateState.error || activeState.error
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$4b2346c6725d60cc), {
                loading: loading && rows.length === 0,
                empty: !loading && rows.length === 0
            }),
            rows.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$54ec01a60f47d33d), {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$c4c2bc57f2e82919), {
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.tags.name
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.tags.color
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.tags.preview
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.tags.isAssessment
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.status
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.actions
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7005b8a93a167348), {
                        children: rows.map((tag)=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                className: tag.isActive ? '' : 'opacity-60',
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        className: "font-medium",
                                        children: tag.name
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                    "aria-hidden": "true",
                                                    className: "inline-block h-4 w-4 rounded border border-border",
                                                    style: {
                                                        backgroundColor: tag.colorHex
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                    dir: "ltr",
                                                    className: "text-text-muted",
                                                    children: tag.colorHex
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$c21cd4bbffdb84a0), {
                                            name: tag.name,
                                            colorHex: tag.colorHex
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        className: "text-text-muted",
                                        children: tag.isAssessment ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.yes : (0, $d916753b57975e04$export$25ce5a424b770e84).app.no
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $287828886661deba$export$cb8f259c2accb9d1), {
                                            isActive: tag.isActive
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                            className: "flex items-center gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                                    variant: "ghost",
                                                    title: (0, $d916753b57975e04$export$25ce5a424b770e84).app.edit,
                                                    onClick: ()=>setEditing(tag),
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2vK0R.default), {
                                                        size: 14,
                                                        "aria-hidden": "true"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                                    variant: "ghost",
                                                    onClick: ()=>setConfirming(tag),
                                                    children: tag.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.deactivate : (0, $d916753b57975e04$export$25ce5a424b770e84).app.activate
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }, tag.id))
                    })
                ]
            }),
            editing && /*#__PURE__*/ (0, $2M70Q.jsx)($ef64e51b4859829b$var$TagDialog, {
                tag: editing === 'new' ? null : editing,
                busy: createState.loading || updateState.loading,
                onClose: ()=>setEditing(null),
                onSubmit: async ({ name: name, colorHex: colorHex, isAssessment: isAssessment })=>{
                    const variables = {
                        name: name,
                        colorHex: colorHex,
                        isAssessment: isAssessment
                    };
                    if (editing === 'new') await createTag({
                        variables: variables
                    });
                    else await updateTag({
                        variables: {
                            id: editing.id,
                            ...variables
                        }
                    });
                    setEditing(null);
                }
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2cc85109a937009e), {
                open: Boolean(confirming),
                onOpenChange: (open)=>!open && setConfirming(null),
                title: confirming?.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.deactivate : (0, $d916753b57975e04$export$25ce5a424b770e84).app.activate,
                message: confirming?.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.confirmDeactivate(confirming?.name ?? '') : (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.confirmActivate(confirming?.name ?? ''),
                danger: confirming?.isActive,
                confirmLabel: confirming?.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.deactivate : (0, $d916753b57975e04$export$25ce5a424b770e84).app.activate,
                onConfirm: ()=>setActive({
                        variables: {
                            id: confirming.id,
                            isActive: !confirming.isActive
                        }
                    })
            })
        ]
    });
}
function $ef64e51b4859829b$var$TagDialog({ tag: tag, onClose: onClose, onSubmit: onSubmit, busy: busy }) {
    const [name, setName] = (0, $3OyDL.useState)(tag?.name ?? '');
    const [colorHex, setColorHex] = (0, $3OyDL.useState)(tag?.colorHex ?? (0, $dd0263804d68f882$export$3a830fa5ba207950));
    const [isAssessment, setIsAssessment] = (0, $3OyDL.useState)(Boolean(tag?.isAssessment));
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: true,
        onOpenChange: (open)=>!open && onClose(),
        title: tag ? `${(0, $d916753b57975e04$export$25ce5a424b770e84).app.edit} \u{2014} ${tag.name}` : (0, $d916753b57975e04$export$25ce5a424b770e84).settings.tags.createTitle,
        busy: busy,
        onSubmit: ()=>onSubmit({
                name: name,
                colorHex: colorHex,
                isAssessment: isAssessment
            }),
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.tags.name,
                value: name,
                required: true,
                onChange: (event)=>setName(event.target.value)
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex items-end gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("label", {
                        className: "flex flex-col gap-1",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                className: "text-sm text-text-muted",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.tags.color
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("input", {
                                type: "color",
                                value: colorHex,
                                onChange: (event)=>setColorHex(event.target.value),
                                className: "h-control w-16 cursor-pointer rounded border border-border bg-bg",
                                "aria-label": (0, $d916753b57975e04$export$25ce5a424b770e84).settings.tags.color
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                        label: "",
                        value: colorHex,
                        dir: "ltr",
                        className: "flex-1",
                        onChange: (event)=>setColorHex(event.target.value)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("div", {
                className: "flex flex-wrap gap-2",
                children: (0, $dd0263804d68f882$export$19e2e41f5a1b2902).map((swatch)=>/*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                        type: "button",
                        "aria-label": swatch.name,
                        onClick: ()=>setColorHex(swatch.value),
                        className: `h-5 w-5 rounded-full border ${colorHex.toLowerCase() === swatch.value ? 'border-text' : 'border-border'}`,
                        style: {
                            backgroundColor: swatch.value
                        }
                    }, swatch.name))
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$94195a47b94ed396), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.tags.isAssessment,
                checked: isAssessment,
                onChange: (event)=>setIsAssessment(event.target.checked)
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                className: "text-xs text-text-muted",
                children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.tags.isAssessmentHint
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-sm text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.tags.preview
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$c21cd4bbffdb84a0), {
                        name: name || (0, $d916753b57975e04$export$25ce5a424b770e84).settings.tags.name,
                        colorHex: colorHex
                    })
                ]
            })
        ]
    });
}



var $2M70Q = parcelRequire("2M70Q");



var $3ci4H = parcelRequire("3ci4H");
var $2vK0R = parcelRequire("2vK0R");
var $6PxCH = parcelRequire("6PxCH");

var $3OyDL = parcelRequire("3OyDL");




/** Stand-in values for the preview pane. Substitution itself is the future
 *  messaging service's job; this only shows the shape of the result. */ const $63c2f041637be3f0$var$SAMPLE = {
    firstName: "\u0639\u0644\u06CC",
    lastName: "\u0627\u062D\u0645\u062F\u06CC",
    fullName: "\u0639\u0644\u06CC \u0627\u062D\u0645\u062F\u06CC"
};
function $63c2f041637be3f0$var$renderPreview(body) {
    return (body ?? '').replace(/\{\{\s*([^}]*?)\s*\}\}/g, (match, token)=>token in $63c2f041637be3f0$var$SAMPLE ? $63c2f041637be3f0$var$SAMPLE[token] : match);
}
function $63c2f041637be3f0$export$4fbd823db0af2313() {
    const [includeInactive, setIncludeInactive] = (0, $3OyDL.useState)(true);
    const [editing, setEditing] = (0, $3OyDL.useState)(null);
    const [confirming, setConfirming] = (0, $3OyDL.useState)(null);
    const variables = {
        includeInactive: includeInactive
    };
    const { data: data, loading: loading } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$53468eed769bf661), {
        variables: variables
    });
    const channels = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$d2d584f4325fcf08), {
        variables: {
            kind: 'COMMUNICATION_CHANNEL',
            includeInactive: false
        }
    });
    const categories = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$d2d584f4325fcf08), {
        variables: {
            kind: 'TEMPLATE_CATEGORY',
            includeInactive: false
        }
    });
    const refetch = [
        {
            query: (0, $13be303c7211393a$export$53468eed769bf661),
            variables: variables
        }
    ];
    const [create, createState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$dcee5dee04648c93), {
        refetchQueries: refetch
    });
    const [update, updateState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$ba33506117bc02e3), {
        refetchQueries: refetch
    });
    const [setActive, activeState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $13be303c7211393a$export$e44689c3b2734c03), {
        refetchQueries: refetch
    });
    const rows = data?.messageTemplates ?? [];
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $287828886661deba$export$8f6dcfe950367406), {
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.sections.templates,
        hint: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.templates.sendingElsewhere,
        toolbar: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $287828886661deba$export$13da608e8f9e10fe), {
                    checked: includeInactive,
                    onChange: setIncludeInactive
                }),
                /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                    variant: "primary",
                    onClick: ()=>setEditing('new'),
                    className: "gap-2",
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6PxCH.default), {
                            size: 15,
                            "aria-hidden": "true"
                        }),
                        (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.newItem
                    ]
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                error: createState.error || updateState.error || activeState.error
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$4b2346c6725d60cc), {
                loading: loading && rows.length === 0,
                empty: !loading && rows.length === 0
            }),
            rows.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$54ec01a60f47d33d), {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$c4c2bc57f2e82919), {
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.templates.name
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.templates.channel
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.templates.category
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.templates.body
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.status
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.actions
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7005b8a93a167348), {
                        children: rows.map((template)=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                className: template.isActive ? '' : 'opacity-60',
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        className: "font-medium",
                                        children: template.name
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        children: template.channel.labelFa
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        children: template.category.labelFa
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        className: "max-w-sm truncate text-text-muted",
                                        title: template.body,
                                        children: template.body
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $287828886661deba$export$cb8f259c2accb9d1), {
                                            isActive: template.isActive
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                                            className: "flex items-center gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                                    variant: "ghost",
                                                    title: (0, $d916753b57975e04$export$25ce5a424b770e84).app.edit,
                                                    onClick: ()=>setEditing(template),
                                                    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2vK0R.default), {
                                                        size: 14,
                                                        "aria-hidden": "true"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                                    variant: "ghost",
                                                    onClick: ()=>setConfirming(template),
                                                    children: template.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.deactivate : (0, $d916753b57975e04$export$25ce5a424b770e84).app.activate
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }, template.id))
                    })
                ]
            }),
            editing && /*#__PURE__*/ (0, $2M70Q.jsx)($63c2f041637be3f0$var$TemplateDialog, {
                template: editing === 'new' ? null : editing,
                channels: channels.data?.lookups ?? [],
                categories: categories.data?.lookups ?? [],
                busy: createState.loading || updateState.loading,
                onClose: ()=>setEditing(null),
                onSubmit: async (input)=>{
                    if (editing === 'new') await create({
                        variables: {
                            input: input
                        }
                    });
                    else await update({
                        variables: {
                            id: editing.id,
                            input: input
                        }
                    });
                    setEditing(null);
                }
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2cc85109a937009e), {
                open: Boolean(confirming),
                onOpenChange: (open)=>!open && setConfirming(null),
                title: confirming?.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.deactivate : (0, $d916753b57975e04$export$25ce5a424b770e84).app.activate,
                message: confirming?.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.confirmDeactivate(confirming?.name ?? '') : (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.confirmActivate(confirming?.name ?? ''),
                danger: confirming?.isActive,
                confirmLabel: confirming?.isActive ? (0, $d916753b57975e04$export$25ce5a424b770e84).app.deactivate : (0, $d916753b57975e04$export$25ce5a424b770e84).app.activate,
                onConfirm: ()=>setActive({
                        variables: {
                            id: confirming.id,
                            isActive: !confirming.isActive
                        }
                    })
            })
        ]
    });
}
function $63c2f041637be3f0$var$TemplateDialog({ template: template, channels: channels, categories: categories, onClose: onClose, onSubmit: onSubmit, busy: busy }) {
    const client = (0, $2b2c5bfb3bce7a5b$export$eb9a56e7a29e494)();
    const [name, setName] = (0, $3OyDL.useState)(template?.name ?? '');
    const [channelId, setChannelId] = (0, $3OyDL.useState)(template?.channel.id ?? channels[0]?.id ?? '');
    const [categoryId, setCategoryId] = (0, $3OyDL.useState)(template?.category.id ?? categories[0]?.id ?? '');
    const [body, setBody] = (0, $3OyDL.useState)(template?.body ?? '');
    const [validation, setValidation] = (0, $3OyDL.useState)(null);
    /**
   * Validation runs on the server so the whitelist has exactly one definition.
   * Debounced because it fires per keystroke.
   */ (0, $3OyDL.useEffect)(()=>{
        if (!body.trim()) {
            setValidation(null);
            return undefined;
        }
        const timer = setTimeout(async ()=>{
            try {
                const { data: data } = await client.query({
                    query: (0, $13be303c7211393a$export$6b3f4b0350c29d0e),
                    variables: {
                        body: body
                    },
                    fetchPolicy: 'network-only'
                });
                setValidation(data.validatePlaceholders);
            } catch  {
                setValidation(null); // a transient failure must not block typing
            }
        }, 350);
        return ()=>clearTimeout(timer);
    }, [
        body,
        client
    ]);
    const preview = (0, $3OyDL.useMemo)(()=>$63c2f041637be3f0$var$renderPreview(body), [
        body
    ]);
    const allowed = validation?.allowed ?? (0, $6837d294924011ed$export$ac64a8171c5e2d33);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$ed8869c34b2bb205), {
        open: true,
        onOpenChange: (open)=>!open && onClose(),
        title: template ? `${(0, $d916753b57975e04$export$25ce5a424b770e84).app.edit} \u{2014} ${template.name}` : (0, $d916753b57975e04$export$25ce5a424b770e84).settings.templates.createTitle,
        busy: busy,
        onSubmit: ()=>onSubmit({
                name: name,
                channelId: channelId,
                body: body,
                categoryId: categoryId
            }),
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2c73285ae9390cec), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.templates.name,
                value: name,
                required: true,
                onChange: (event)=>setName(event.target.value)
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.templates.channel,
                value: channelId,
                onChange: (event)=>setChannelId(event.target.value),
                children: channels.map((channel)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: channel.id,
                        children: channel.labelFa
                    }, channel.id))
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                label: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.templates.category,
                value: categoryId,
                onChange: (event)=>setCategoryId(event.target.value),
                children: categories.map((category)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                        value: category.id,
                        children: category.labelFa
                    }, category.id))
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("label", {
                className: "flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-sm text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.templates.body
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("textarea", {
                        value: body,
                        required: true,
                        rows: 4,
                        onChange: (event)=>setBody(event.target.value),
                        className: "rounded border border-border bg-bg p-4 text-base outline-none focus:border-primary"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "flex flex-wrap items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                        className: "text-xs text-text-muted",
                        children: [
                            (0, $d916753b57975e04$export$25ce5a424b770e84).settings.templates.allowedPlaceholders,
                            ":"
                        ]
                    }),
                    allowed.map((placeholder)=>/*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                            type: "button",
                            variant: "ghost",
                            className: "text-xs",
                            onClick: ()=>setBody(`${body}{{${placeholder}}}`),
                            children: /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                dir: "ltr",
                                children: `{{${placeholder}}}`
                            })
                        }, placeholder))
                ]
            }),
            validation && !validation.valid && /*#__PURE__*/ (0, $2M70Q.jsx)("ul", {
                className: "flex flex-col gap-1",
                role: "alert",
                children: validation.errors.map((error)=>/*#__PURE__*/ (0, $2M70Q.jsx)("li", {
                        className: "text-xs text-danger",
                        children: error.message
                    }, `${error.placeholder}-${error.position}`))
            }),
            validation?.valid && /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                className: "flex items-center gap-1 text-xs text-success",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3ci4H.default), {
                        size: 12,
                        "aria-hidden": "true"
                    }),
                    (0, $d916753b57975e04$export$25ce5a424b770e84).settings.templates.valid
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
                className: "bg-bg",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                        className: "text-xs text-text-muted",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.templates.preview
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                        className: "mt-2 whitespace-pre-wrap text-base",
                        children: preview || (0, $d916753b57975e04$export$25ce5a424b770e84).app.none
                    })
                ]
            })
        ]
    });
}



var $2M70Q = parcelRequire("2M70Q");



var $5gte0 = parcelRequire("5gte0");

var $3OyDL = parcelRequire("3OyDL");






const $507a10e41cdf5aca$var$KEYCLOAK_USERS_URL = (0, $b5d41e4dbaeacaa2$export$4d026e62d5555bff);
const $507a10e41cdf5aca$var$ROLE_LABELS = {
    ADMIN: (0, $d916753b57975e04$export$25ce5a424b770e84).auth.roleAdmin,
    USER: (0, $d916753b57975e04$export$25ce5a424b770e84).auth.roleUser
};
function $507a10e41cdf5aca$export$1e24b8a998c3412e() {
    const [page, setPage] = (0, $3OyDL.useState)(1);
    const { data: data, loading: loading } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $13be303c7211393a$export$bba36a65d26d4ad8), {
        variables: {
            page: page,
            pageSize: (0, $370d2fd34ead4cb4$export$8ec3d08588d2eeda)
        }
    });
    const users = data?.users?.items ?? [];
    const totalCount = data?.users?.totalCount ?? 0;
    const pageCount = Math.max(1, Math.ceil(totalCount / (0, $370d2fd34ead4cb4$export$8ec3d08588d2eeda)));
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $287828886661deba$export$8f6dcfe950367406), {
        title: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.sections.users,
        hint: (0, $d916753b57975e04$export$25ce5a424b770e84).contacts.count((0, $d4d460d3ffb6daab$export$104ee80c24270f18)(totalCount)),
        toolbar: /*#__PURE__*/ (0, $2M70Q.jsxs)("a", {
            href: $507a10e41cdf5aca$var$KEYCLOAK_USERS_URL,
            target: "_blank",
            rel: "noreferrer",
            className: "flex h-control items-center gap-2 rounded border border-border px-4 text-base text-primary hover:bg-surface-hover",
            children: [
                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $5gte0.default), {
                    size: 15,
                    "aria-hidden": "true"
                }),
                (0, $d916753b57975e04$export$25ce5a424b770e84).settings.users.openKeycloak
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                className: "mb-5 flex items-start gap-2 rounded border border-border bg-surface p-4 text-base text-text-muted",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $5a1900bd77631f6a$export$2e2bcd8739ae039), {
                        size: 16,
                        className: "mt-1 shrink-0",
                        "aria-hidden": "true"
                    }),
                    (0, $d916753b57975e04$export$25ce5a424b770e84).settings.users.readOnlyNotice
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$4b2346c6725d60cc), {
                loading: loading && users.length === 0,
                empty: !loading && users.length === 0
            }),
            users.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$54ec01a60f47d33d), {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$c4c2bc57f2e82919), {
                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                            children: [
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.users.displayName
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.users.role
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.common.status
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.users.firstSeen
                                }),
                                /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$2b39a3648955dd09), {
                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).settings.users.lastSeen
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7005b8a93a167348), {
                        children: users.map((user)=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$5582bd7183a5e873), {
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        className: "font-medium",
                                        children: user.displayName
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                                            className: user.role === 'ADMIN' ? 'bg-surface-hover text-primary' : 'bg-surface-hover text-text-muted',
                                            children: $507a10e41cdf5aca$var$ROLE_LABELS[user.role] ?? user.role
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $287828886661deba$export$cb8f259c2accb9d1), {
                                            isActive: user.isActive
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        className: "text-text-muted",
                                        children: (0, $d4d460d3ffb6daab$export$8b492ed8828f789c)(user.firstSeenAt)
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$9cf5b401f969f5e3), {
                                        className: "text-text-muted",
                                        title: (0, $d4d460d3ffb6daab$export$8b492ed8828f789c)(user.lastSeenAt),
                                        children: (0, $d4d460d3ffb6daab$export$8fbbfd65594f46a0)(user.lastSeenAt)
                                    })
                                ]
                            }, user.id))
                    })
                ]
            }),
            pageCount > 1 && /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                className: "mt-4 flex items-center justify-center gap-4 text-sm",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                        type: "button",
                        disabled: page <= 1,
                        onClick: ()=>setPage((p)=>p - 1),
                        className: "text-primary disabled:text-text-muted",
                        children: "\u0642\u0628\u0644\u06CC"
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                        className: "text-text-muted",
                        children: [
                            "\u0635\u0641\u062D\u0647 ",
                            (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(page),
                            " \u0627\u0632 ",
                            (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(pageCount)
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsx)("button", {
                        type: "button",
                        disabled: page >= pageCount,
                        onClick: ()=>setPage((p)=>p + 1),
                        className: "text-primary disabled:text-text-muted",
                        children: "\u0628\u0639\u062F\u06CC"
                    })
                ]
            })
        ]
    });
}


/**
 * The ops panel — is anything broken, and who did what.
 *
 * WHY ONE QUERY RATHER THAN SIX. An operator asking "is anything broken" wants
 * one answer, and six sequential queries is six chances for the page to
 * half-render. More importantly a service being DOWN must produce a ROW saying
 * so rather than a failed query, and that only works because the BFF owns the
 * fan-out and catches each probe itself.
 *
 * The rebuild button is the sharpest thing on this page. It truncates the
 * analytics read model, so it asks first, says plainly what will happen, and
 * reports a PARTIAL rebuild as partial rather than as a failure — three
 * services replaying and one failing is a real state somebody has to
 * understand.
 */ 
var $2M70Q = parcelRequire("2M70Q");



var $6tkl0 = parcelRequire("6tkl0");
var $3ci4H = parcelRequire("3ci4H");
var $jqtUP = parcelRequire("jqtUP");
var $gXlfn = parcelRequire("gXlfn");

var $3OyDL = parcelRequire("3OyDL");




function $67401b6f0e22b675$var$ServiceRow({ service: service }) {
    const Icon = service.healthy ? (0, $3ci4H.default) : (0, $gXlfn.default);
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("tr", {
        className: "border-t border-border",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsx)("td", {
                className: "p-2",
                children: /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                    className: `flex items-center gap-2 text-sm ${service.healthy ? 'text-success' : 'text-danger'}`,
                    children: [
                        /*#__PURE__*/ (0, $2M70Q.jsx)(Icon, {
                            size: 14,
                            "aria-hidden": "true"
                        }),
                        service.name
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("td", {
                className: "p-2 text-xs text-text-muted",
                dir: "ltr",
                children: service.address
            }),
            /*#__PURE__*/ (0, $2M70Q.jsxs)("td", {
                className: "p-2 text-xs tabular-nums text-text-muted",
                children: [
                    (0, $d4d460d3ffb6daab$export$e9cf274fc1035ec4)(service.latencyMs),
                    " ms"
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)("td", {
                className: "p-2 text-xs text-text-muted",
                children: service.detail
            })
        ]
    });
}
function $67401b6f0e22b675$var$LagBadge({ seconds: seconds }) {
    if (seconds === null || seconds === undefined) return null;
    const stale = seconds > 600;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
        className: stale ? 'bg-warning-subtle text-warning' : 'bg-surface-hover text-text-muted',
        children: [
            (0, $d4d460d3ffb6daab$export$e9cf274fc1035ec4)(Math.round(seconds)),
            "s"
        ]
    });
}
/**
 * How far behind one projection source is, in seconds.
 *
 * `lastEventAt` is when the producer emitted; `lastAppliedAt` is when this
 * service folded it in. The gap between them is the lag — and when nothing has
 * arrived at all there is no lag to report rather than a zero, because zero
 * reads as «up to date» for a source that may simply be dead.
 */ function $67401b6f0e22b675$var$lagSeconds(source) {
    if (!source?.lastEventAt || !source?.lastAppliedAt) return null;
    const gap = (new Date(source.lastAppliedAt).getTime() - new Date(source.lastEventAt).getTime()) / 1000;
    return gap > 0 ? Math.round(gap) : 0;
}
function $67401b6f0e22b675$export$c7917f1179fd1de1() {
    const [confirmRebuild, setConfirmRebuild] = (0, $3OyDL.useState)(false);
    const [rebuildResult, setRebuildResult] = (0, $3OyDL.useState)(null);
    const [auditActor, setAuditActor] = (0, $3OyDL.useState)('');
    const [auditService, setAuditService] = (0, $3OyDL.useState)('');
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $c0a10c62685d2613$export$1db3a9c2cdc0237b), {
        // Polled, like the reminder tray and for the same reason: this is not a
        // real-time surface, and a socket per open tab is worse than a query a
        // minute (todo.md).
        pollInterval: 30000,
        fetchPolicy: 'cache-and-network'
    });
    const audit = (0, $549c36a2a3cf1189$export$dd0a697e1782aedd)((0, $c0a10c62685d2613$export$7def131616ad6745), {
        variables: {
            page: 1,
            pageSize: 50,
            actorId: auditActor || null,
            services: auditService ? [
                auditService
            ] : null
        }
    });
    const [rebuild, rebuildState] = (0, $97378baea225b83b$export$609860bf8b0084c)((0, $c0a10c62685d2613$export$9988b6e5e67ad43e), {
        onCompleted: (d)=>{
            setRebuildResult(d.rebuildAnalytics);
            refetch();
        }
    });
    const health = data?.systemHealth;
    return /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
        className: "flex flex-col gap-4 p-4",
        children: [
            /*#__PURE__*/ (0, $2M70Q.jsxs)("header", {
                className: "flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsx)("h1", {
                        className: "flex-1 text-lg font-bold text-text",
                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.title
                    }),
                    health && /*#__PURE__*/ (0, $2M70Q.jsxs)("span", {
                        className: "text-xs text-text-muted",
                        children: [
                            (0, $d916753b57975e04$export$25ce5a424b770e84).ops.checkedAt,
                            ": ",
                            (0, $d4d460d3ffb6daab$export$8b492ed8828f789c)(health.checkedAt)
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                        variant: "ghost",
                        onClick: ()=>refetch(),
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $jqtUP.default), {
                                size: 14,
                                "aria-hidden": "true"
                            }),
                            (0, $d916753b57975e04$export$25ce5a424b770e84).dashboard.refresh
                        ]
                    })
                ]
            }),
            loading && !data && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {}),
            error && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$fddf379e22a74b00), {
                title: error.message
            }),
            health && /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2M70Q.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
                        className: "p-2",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                                className: "p-2 text-sm font-bold text-text",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.services
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("table", {
                                className: "w-full border-collapse",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("thead", {
                                        className: "text-xs text-text-muted",
                                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)("th", {
                                                    className: "p-2 text-start font-medium",
                                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.services
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)("th", {
                                                    className: "p-2 text-start font-medium",
                                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.address
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)("th", {
                                                    className: "p-2 text-start font-medium",
                                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.latency
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)("th", {
                                                    className: "p-2 text-start font-medium",
                                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.details
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("tbody", {
                                        children: health.services.map((s)=>/*#__PURE__*/ (0, $2M70Q.jsx)($67401b6f0e22b675$var$ServiceRow, {
                                                service: s
                                            }, s.name))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                        className: "grid grid-cols-1 gap-3 lg:grid-cols-2",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
                                className: "flex flex-col gap-2 p-4",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                                        className: "text-sm font-bold text-text",
                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.ingest
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)("table", {
                                        className: "w-full border-collapse text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)("thead", {
                                                className: "text-xs text-text-muted",
                                                children: /*#__PURE__*/ (0, $2M70Q.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)("th", {
                                                            className: "p-1 text-start font-medium",
                                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.exchange
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)("th", {
                                                            className: "p-1 text-start font-medium",
                                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.lag
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)("th", {
                                                            className: "p-1 text-start font-medium",
                                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.applied
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)("th", {
                                                            className: "p-1 text-start font-medium",
                                                            title: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.unknownHint,
                                                            children: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.unknown
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)("tbody", {
                                                children: (health.analytics?.exchanges ?? []).map((e)=>/*#__PURE__*/ (0, $2M70Q.jsxs)("tr", {
                                                        className: "border-t border-border",
                                                        children: [
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)("td", {
                                                                className: "p-1 text-xs",
                                                                dir: "ltr",
                                                                children: e.exchange
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)("td", {
                                                                className: "p-1",
                                                                children: /*#__PURE__*/ (0, $2M70Q.jsx)($67401b6f0e22b675$var$LagBadge, {
                                                                    seconds: e.lagSeconds
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)("td", {
                                                                className: "p-1 tabular-nums text-xs",
                                                                children: (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(e.appliedCount)
                                                            }),
                                                            /*#__PURE__*/ (0, $2M70Q.jsx)("td", {
                                                                className: `p-1 tabular-nums text-xs ${e.unknownCount > 0 ? 'text-warning' : 'text-text-muted'}`,
                                                                children: (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(e.unknownCount)
                                                            })
                                                        ]
                                                    }, e.exchange))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
                                className: "flex flex-col gap-2 p-4",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                                        className: "text-sm font-bold text-text",
                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.projections
                                    }),
                                    health.projections && /*#__PURE__*/ (0, $2M70Q.jsxs)("dl", {
                                        className: "grid grid-cols-2 gap-1 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)("dt", {
                                                className: "text-text-muted",
                                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.recipients
                                            }),
                                            /*#__PURE__*/ (0, $2M70Q.jsx)("dd", {
                                                className: "tabular-nums",
                                                children: (0, $d4d460d3ffb6daab$export$104ee80c24270f18)(health.projections.recipientCount)
                                            }),
                                            (health.projections.sources ?? []).map((source)=>/*#__PURE__*/ (0, $2M70Q.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)("dt", {
                                                            className: "text-text-muted",
                                                            children: source.source
                                                        }),
                                                        /*#__PURE__*/ (0, $2M70Q.jsx)("dd", {
                                                            children: /*#__PURE__*/ (0, $2M70Q.jsx)($67401b6f0e22b675$var$LagBadge, {
                                                                seconds: $67401b6f0e22b675$var$lagSeconds(source)
                                                            })
                                                        })
                                                    ]
                                                }, source.source))
                                        ]
                                    }),
                                    health.whatsapp && /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                                        className: "border-t border-border pt-2 text-sm",
                                        children: [
                                            (0, $d916753b57975e04$export$25ce5a424b770e84).ops.whatsapp,
                                            ":",
                                            ' ',
                                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                                                className: health.whatsapp.provider === 'fake' ? 'bg-warning-subtle text-warning' : 'bg-surface-hover text-text',
                                                children: health.whatsapp.provider === 'fake' ? (0, $d916753b57975e04$export$25ce5a424b770e84).ops.sandbox : (0, $d916753b57975e04$export$25ce5a424b770e84).ops.live
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
                        className: "flex flex-col gap-2 p-4",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                                className: "text-sm font-bold text-text",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.rebuild
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)("p", {
                                className: "text-xs text-text-muted",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.rebuildWarning
                            }),
                            health.analytics?.rebuildRunning && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$37acb3580601e69a), {
                                className: "w-fit bg-warning-subtle text-warning",
                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.rebuildRunning
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$353f5b6fc5456de1), {
                                variant: "secondary",
                                className: "w-fit",
                                disabled: rebuildState.loading,
                                onClick: ()=>setConfirmRebuild(true),
                                children: [
                                    rebuildState.loading ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {}) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $jqtUP.default), {
                                        size: 14,
                                        "aria-hidden": "true"
                                    }),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).ops.rebuild
                                ]
                            }),
                            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$10c788363424e94e), {
                                error: rebuildState.error
                            }),
                            rebuildState.error && /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                                className: "flex items-start gap-2 text-xs text-warning",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6tkl0.default), {
                                        size: 13,
                                        className: "mt-px shrink-0",
                                        "aria-hidden": "true"
                                    }),
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).ops.rebuildPartial
                                ]
                            }),
                            rebuildResult && /*#__PURE__*/ (0, $2M70Q.jsxs)("p", {
                                className: "text-xs text-success",
                                children: [
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).ops.rebuildDone,
                                    " \u2014 ",
                                    (0, $d916753b57975e04$export$25ce5a424b770e84).ops.replayed,
                                    ":",
                                    ' ',
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                        dir: "ltr",
                                        children: rebuildResult.replayedJson
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $2d41816c9c811df0$export$60332b2344f7fe41), {
                        className: "p-2",
                        children: [
                            /*#__PURE__*/ (0, $2M70Q.jsxs)("div", {
                                className: "flex flex-wrap items-center gap-2 p-2",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("h2", {
                                        className: "flex-1 text-sm font-bold text-text",
                                        children: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.audit
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsxs)((0, $03dbd597abd3b4b7$export$d55b50a564d0b931), {
                                        label: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.auditService,
                                        value: auditService,
                                        onChange: (e)=>setAuditService(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                                value: "",
                                                children: (0, $d916753b57975e04$export$25ce5a424b770e84).app.all
                                            }),
                                            [
                                                'crm',
                                                'scheduling',
                                                'messaging',
                                                'feedback'
                                            ].map((s)=>/*#__PURE__*/ (0, $2M70Q.jsx)("option", {
                                                    value: s,
                                                    children: s
                                                }, s))
                                        ]
                                    })
                                ]
                            }),
                            audit.loading && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$7f7cbe89f1eacd2), {}),
                            audit.data?.auditLog?.items?.length === 0 && /*#__PURE__*/ (0, $2M70Q.jsx)((0, $2d41816c9c811df0$export$fddf379e22a74b00), {
                                title: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.auditEmpty
                            }),
                            audit.data?.auditLog?.items?.length > 0 && /*#__PURE__*/ (0, $2M70Q.jsxs)("table", {
                                className: "w-full border-collapse text-xs",
                                children: [
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("thead", {
                                        className: "text-text-muted",
                                        children: /*#__PURE__*/ (0, $2M70Q.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $2M70Q.jsx)("th", {
                                                    className: "p-2 text-start font-medium",
                                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.auditWhen
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)("th", {
                                                    className: "p-2 text-start font-medium",
                                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.auditService
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)("th", {
                                                    className: "p-2 text-start font-medium",
                                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.auditActor
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)("th", {
                                                    className: "p-2 text-start font-medium",
                                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.auditAction
                                                }),
                                                /*#__PURE__*/ (0, $2M70Q.jsx)("th", {
                                                    className: "p-2 text-start font-medium",
                                                    children: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.auditEntity
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2M70Q.jsx)("tbody", {
                                        children: audit.data.auditLog.items.map((row)=>/*#__PURE__*/ (0, $2M70Q.jsxs)("tr", {
                                                className: "border-t border-border",
                                                children: [
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)("td", {
                                                        className: "whitespace-nowrap p-2 text-text-muted",
                                                        children: (0, $d4d460d3ffb6daab$export$8b492ed8828f789c)(row.occurredAt)
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)("td", {
                                                        className: "p-2",
                                                        dir: "ltr",
                                                        children: row.service
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)("td", {
                                                        className: "p-2",
                                                        children: row.actorName || /*#__PURE__*/ (0, $2M70Q.jsx)("span", {
                                                            className: "text-text-muted",
                                                            dir: "ltr",
                                                            children: row.actorId.slice(0, 8)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)("td", {
                                                        className: "p-2",
                                                        dir: "ltr",
                                                        children: row.action
                                                    }),
                                                    /*#__PURE__*/ (0, $2M70Q.jsx)("td", {
                                                        className: "p-2 text-text-muted",
                                                        dir: "ltr",
                                                        children: row.entityId ? row.entityId.slice(0, 8) : "\u2014"
                                                    })
                                                ]
                                            }, row.id))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2M70Q.jsx)((0, $03dbd597abd3b4b7$export$2cc85109a937009e), {
                open: confirmRebuild,
                onOpenChange: setConfirmRebuild,
                title: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.rebuild,
                message: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.rebuildWarning,
                confirmLabel: (0, $d916753b57975e04$export$25ce5a424b770e84).ops.rebuildConfirm,
                onConfirm: ()=>{
                    setRebuildResult(null);
                    rebuild({
                        variables: {
                            includeDimensions: true
                        }
                    });
                    setConfirmRebuild(false);
                }
            })
        ]
    });
}




/**
 * Desktop-First: `.web.jsx` is the canonical variant. A future `.mobile.jsx`
 * is a *reduction* of it, never a fork (CLAUDE.md §12).
 */ /**
 * The two routes that have a mobile variant.
 *
 * Chosen at RENDER rather than at route definition, so rotating a phone or
 * resizing a window switches without a reload — which is also how anybody
 * tests this.
 */ function $c93e3e3c0761263b$var$ContactsRoute() {
    return (0, $0f92c7a8ccedf081$export$2b96349243a56116)() ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f696f03a05e1f5bc$export$f0815673d0dbc6e9), {}) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $c05a4dc07b0f294f$export$c15beb6b679ef7ed), {});
}
/**
 * The landing page. A rep opening MeshHub on a phone at a congress wants the
 * lookup, not a dashboard they cannot read; on a desk they want the dashboard.
 */ function $c93e3e3c0761263b$var$HomeRoute() {
    return (0, $0f92c7a8ccedf081$export$2b96349243a56116)() ? /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f696f03a05e1f5bc$export$f0815673d0dbc6e9), {}) : /*#__PURE__*/ (0, $2M70Q.jsx)((0, $da893dccebb0c931$export$5786b26ef2cb7933), {});
}
const $c93e3e3c0761263b$var$routes = [
    {
        path: '/',
        element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $9c7153815b06adfe$export$2afed54d6b7d68d9), {}),
        children: [
            // The dashboard is the POST-LOGIN LANDING PAGE as of Step 6: the
            // first question anybody has on opening a CRM is how it is going,
            // and the contact list is one click away for the people whose job
            // is the list.
            {
                index: true,
                element: /*#__PURE__*/ (0, $2M70Q.jsx)($c93e3e3c0761263b$var$HomeRoute, {})
            },
            {
                path: 'dashboard',
                element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $da893dccebb0c931$export$5786b26ef2cb7933), {})
            },
            // THE ONLY TWO MOBILE REDUCTIONS (CLAUDE.md §12). On a narrow viewport
            // the contact list becomes a lookup-and-call screen and quick-add
            // becomes a full-screen sheet, because exhibitions happen on phones.
            // Every OTHER route renders the desktop layout unchanged — the calendar
            // and the dashboard are desk work that a phone would make worse, and a
            // half-built mobile version of them would be worse still.
            {
                path: 'contacts',
                element: /*#__PURE__*/ (0, $2M70Q.jsx)($c93e3e3c0761263b$var$ContactsRoute, {})
            },
            {
                path: 'contacts/:id',
                element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $aad89f91096fa167$export$835a716917aceefd), {})
            },
            {
                path: 'calendar',
                element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $930b20b193f67514$export$4084ba14934f75cb), {})
            },
            {
                path: 'followups',
                element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $bc3777a1cb64c617$export$6a510118c5e7961), {})
            },
            // Step 5. The outbox is the default messaging screen because it is the
            // one anyone opens after pressing send.
            {
                path: 'messaging',
                element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $acda559a4124e8af$export$2f71c932e14ae53c), {})
            },
            {
                path: 'messaging/outbox',
                element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $acda559a4124e8af$export$2f71c932e14ae53c), {})
            },
            {
                path: 'messaging/campaigns',
                element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e15b1163fa6b552a$export$de2bbf1734ee03f0), {})
            },
            {
                path: 'issues',
                element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $45a90a4f1a61be33$export$4e7f04199a7ef9d7), {})
            },
            // Before `issues/:id`, or "reports" would be read as an issue id.
            {
                path: 'issues/reports',
                element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4f72b7c2271a0dfd$export$75c890e685aee97e), {})
            },
            {
                path: 'issues/:id',
                element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $79b6ccb465b64fb9$export$c24121eefa79457e), {})
            },
            {
                path: 'settings',
                element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $874a61e03b1c18c9$export$91d8b01f755b4863), {}),
                children: [
                    {
                        index: true,
                        element: /*#__PURE__*/ (0, $2M70Q.jsx)($c93e3e3c0761263b$var$SettingsIndex, {})
                    },
                    {
                        path: 'lookups',
                        element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8199f2b2c04f9242$export$6f73c9645709c239), {})
                    },
                    {
                        path: 'specialties',
                        element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $e17294cecbc6ad37$export$85eaffe425ede927), {})
                    },
                    {
                        path: 'tags',
                        element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ef64e51b4859829b$export$a74aa39d833b143a), {})
                    },
                    {
                        path: 'custom-fields',
                        element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $56c3142c22569aa5$export$fbbbcbdee15d1996), {})
                    },
                    {
                        path: 'templates',
                        element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $63c2f041637be3f0$export$4fbd823db0af2313), {})
                    },
                    {
                        path: 'checklists',
                        element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4b42b481428550c6$export$7440c21dce611c38), {})
                    },
                    // The two vocabularies that live in OTHER services, and therefore
                    // cannot be folded into /settings/lookups' kind picker.
                    {
                        path: 'activity-types',
                        element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $6e121a5c90ad241d$export$7a50dc096a992b78), {})
                    },
                    {
                        path: 'issue-types',
                        element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $08e23e29b3ee4844$export$bfb4b09b3d89b06a), {})
                    },
                    // Self-service for EVERY role, unlike the rest of /settings: a Google
                    // connection is one person's own calendar. SettingsLayout knows.
                    {
                        path: 'integrations',
                        element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $5a0c03611e51adce$export$bcc5fd5e78aa1400), {})
                    },
                    {
                        path: 'automation',
                        element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ecf0f3812bdd66f0$export$bfdea316a467e3e5), {})
                    },
                    {
                        path: 'whatsapp',
                        element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8b2aa657be98f217$export$ff53179d2e9790e4), {})
                    },
                    {
                        path: 'import',
                        element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $7055ef928be9ba0d$export$3f07954da1f48015), {})
                    },
                    {
                        path: 'users',
                        element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $507a10e41cdf5aca$export$1e24b8a998c3412e), {})
                    },
                    {
                        path: 'system',
                        element: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $67401b6f0e22b675$export$c7917f1179fd1de1), {})
                    }
                ]
            }
        ]
    }
];
/**
 * `/settings` lands somewhere the caller may actually go.
 *
 * A fixed redirect to `lookups` would drop a USER on the forbidden screen for
 * clicking their own integrations link — the nav is role-aware, so the default
 * has to be too.
 */ function $c93e3e3c0761263b$var$SettingsIndex() {
    const { isAdmin: isAdmin, loading: loading } = (0, $00d5d84dffcdf8d5$export$ad0a340bf97d63d5)();
    if (loading) return null;
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ZNHD9.Navigate), {
        to: isAdmin ? 'lookups' : 'integrations',
        replace: true
    });
}
/**
 * While unauthenticated, every route resolves to the login screen — the router
 * is not even mounted, so no screen can fire a query without a token.
 */ function $c93e3e3c0761263b$var$Root() {
    const { status: status } = (0, $f0578ea5f18e5637$export$1d39dc5b47e56ff0)();
    /**
   * Built lazily, on the first authenticated render. `createBrowserRouter`
   * snapshots `window.location` when it is constructed, and the OIDC callback
   * rewrites the URL back to the requested path while still unauthenticated —
   * so a module-scope router would capture the callback URL and land everyone
   * on the home page instead of their deep link.
   */ const router = (0, $3OyDL.useMemo)(()=>status === 'authenticated' ? (0, $8B9Zg.createBrowserRouter)($c93e3e3c0761263b$var$routes) : null, [
        status
    ]);
    if (status !== 'authenticated' || !router) return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $3f3b4115b2551f01$export$52c4631a391eb5f8), {});
    return /*#__PURE__*/ (0, $2M70Q.jsx)((0, $4dd79595e79ceb2b$export$c16b04c8a9956446), {
        client: (0, $b5f638428a9d7094$export$d1325c0cda90af4f),
        children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $00d5d84dffcdf8d5$export$d053b53cdff1ea07), {
            children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $ed3cc4f847deec94$export$87dd7790e69558a9), {
                children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $8B9Zg.RouterProvider), {
                    router: router
                })
            })
        })
    });
}
(0, $lApLI.createRoot)(document.getElementById('root')).render(/*#__PURE__*/ (0, $2M70Q.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3OyDL))).StrictMode, {
    children: /*#__PURE__*/ (0, $2M70Q.jsx)((0, $f0578ea5f18e5637$export$87091915187a1a85), {
        children: /*#__PURE__*/ (0, $2M70Q.jsx)($c93e3e3c0761263b$var$Root, {})
    })
}));


//# sourceMappingURL=app.c71b941c.js.map
